// @ts-nocheck
/* eslint-disable */
/**
 * Legacy-Frontend (Lift-and-Shift aus public/index.html, Phase B-1).
 * Wird in Phase B-2 in frontend/src/features/* aufgesplittet.
 * Keine Type-Checks hier — bewusster Verzicht für die Migration.
 */
import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";

/* ─── Path-to-Hash-Sync ───
 * Die Legacy-App nutzt window.location.hash als Router. Im Deploy lieft Nginx
 * mit SPA-Fallback alle Pfade auf index.html aus, aber die App "sieht" sie
 * nicht. Bei Direktaufruf von z.B. https://…/buchhaltung/banken übersetzen
 * wir den Pfad einmalig in einen Hash, damit der vorhandene Hash-Router greift.
 * (Wird in Phase B-2 durch echtes React-Router-DOM ersetzt.) */
(function syncPathToHash() {
  if (typeof window === "undefined") return;
  const p = window.location.pathname || "/";
  if (p !== "/" && !window.location.hash) {
    const route = p.replace(/^\/+/, "");
    window.history.replaceState(null, "", "/#/" + route + window.location.search);
  }
})();

/* ─── Auth: Token-Injection via Fetch-Override ─── */
(function(){
  const _origFetch = window.fetch.bind(window);
  window.fetch = function(input, init){
    init = init || {};
    const url = typeof input === "string" ? input : (input && input.url) || "";
    // Nur eigene /api-Requests mit Token anreichern
    if (url && url.startsWith("/api/")) {
      const tok = localStorage.getItem("authToken");
      if (tok) {
        const hdrs = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined) || {});
        hdrs.set("X-Auth-Token", tok);
        init.headers = hdrs;
      }
    }
    return _origFetch(input, init);
  };
})();

/* ─── Buchhaltung: Jahr-Filter-Injection via Fetch-Override ───
 * window.__bhJahr wird vom App-Komponenten-State synchron gehalten.
 * Jeder Fetch auf /api/cashflow/buchhaltung/* (außer /jahre) bekommt
 * automatisch ?jahr=<currentYear> angehängt — falls nicht schon gesetzt. */
(function(){
  try { window.__bhJahr = parseInt(localStorage.getItem("bhJahr")) || null; } catch(e) { window.__bhJahr = null; }
  const _origFetch = window.fetch.bind(window);
  window.fetch = function(input, init){
    const urlStr = typeof input === "string" ? input : (input && input.url) || "";
    if (urlStr && urlStr.indexOf("/api/cashflow/buchhaltung/") !== -1
        && urlStr.indexOf("/buchhaltung/jahre") === -1
        && window.__bhJahr) {
      const j = String(window.__bhJahr);
      const hasJahr = /[?&]jahr=/.test(urlStr);
      if (!hasJahr) {
        const sep = urlStr.indexOf("?") !== -1 ? "&" : "?";
        const newUrl = urlStr + sep + "jahr=" + j;
        if (typeof input === "string") input = newUrl;
        else { try { input = new Request(newUrl, input); } catch(e){} }
      }
    }
    return _origFetch(input, init);
  };
})();

/* ─── Theme ─── */
const TH={
  dark:{"--bg":"#0a0c10","--s1":"#12151c","--s2":"#1a1e28","--s3":"#222733","--brd":"#242936","--t1":"#e8eaf0","--t2":"#8b90a0","--t3":"#565c6e","--acc":"#6366f1","--acc2":"rgba(99,102,241,.12)","--grn":"#34d399","--grn2":"rgba(52,211,153,.12)","--red":"#f87171","--red2":"rgba(248,113,113,.12)","--ylw":"#fbbf24","--ylw2":"rgba(251,191,36,.12)","--sbg":"#0d0f14","--shov":"#161a24","--sact":"rgba(99,102,241,.15)","--purple":"#a78bfa","--pink":"#f472b6"},
  light:{"--bg":"#f4f5f7","--s1":"#ffffff","--s2":"#f0f1f4","--s3":"#e6e8ec","--brd":"#e2e4ea","--t1":"#1a1c22","--t2":"#6b7080","--t3":"#9ba0b0","--acc":"#4f46e5","--acc2":"rgba(79,70,229,.08)","--grn":"#059669","--grn2":"rgba(5,150,105,.1)","--red":"#dc2626","--red2":"rgba(220,38,38,.08)","--ylw":"#d97706","--ylw2":"rgba(217,119,6,.1)","--sbg":"#ffffff","--shov":"#f4f5f7","--sact":"rgba(79,70,229,.08)","--purple":"#7c3aed","--pink":"#db2777"}
};

const fmt=v=>new Intl.NumberFormat("de-DE",{style:"currency",currency:"EUR"}).format(v);
const fmtN=v=>new Intl.NumberFormat("de-DE").format(v);
const fmtDate=d=>d?new Date(d).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"}):"–";
const fmtAge=d=>{if(!d)return"–";const days=Math.floor((Date.now()-new Date(d))/86400000);if(days<1)return"heute";if(days===1)return"gestern";if(days<30)return days+"d";if(days<365)return Math.floor(days/30)+"M";return Math.floor(days/365)+"J "+Math.floor((days%365)/30)+"M";};
const fmtDT=d=>d?new Date(d).toLocaleString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"}):"–";
const extractJahr=pnr=>{const m=(pnr||'').match(/-(\d{4})-/);return m?m[1]:null;};

/* ─── Marktplatz-Ampel Colors ─── */
const MP_AMPEL={
  zalando:   {color:"#ff6900",label:"ZA"},
  aboutyou:  {color:"#e91e63",label:"AY"},
  otto:      {color:"#ef4444",label:"OT"},
  amazon:    {color:"#f59e0b",label:"AM"},
  ebay:      {color:"#3b82f6",label:"eB"},
  kaufland:  {color:"#10b981",label:"KF"},
  breuninger:{color:"#8b5cf6",label:"Br"},
  galeria:   {color:"#06b6d4",label:"GK"},
  trendyol:  {color:"#f97316",label:"TY"},
  limango:   {color:"#ec4899",label:"LI"},
  secretsales:{color:"#dc2626",label:"SS"},
  vangraaf:  {color:"#7c3aed",label:"VG"},
  fashioncore:{color:"#0891b2",label:"FC"},
  nes:       {color:"#65a30d",label:"NE"},
  digitec:   {color:"#1d4ed8",label:"DG"},
  bolcom:    {color:"#0072ce",label:"BO"},
  miinto:    {color:"#be185d",label:"MI"},
  spartoo:   {color:"#b45309",label:"SP"},
  tiktok:    {color:"#000000",label:"TT"},
};
/* ─── Master Marktplatz-Liste ─── */
const MP_ALL=[
  {key:"zalando",   name:"Zalando"},
  {key:"aboutyou",  name:"About You"},
  {key:"otto",      name:"Otto"},
  {key:"amazon",    name:"Amazon"},
  {key:"ebay",      name:"eBay"},
  {key:"kaufland",  name:"Kaufland"},
  {key:"breuninger",name:"Breuninger"},
  {key:"galeria",   name:"Galeria Karstadt Kaufhof"},
  {key:"trendyol",  name:"Trendyol"},
  {key:"limango",   name:"Limango"},
  {key:"secretsales",name:"Secret Sales"},
  {key:"vangraaf",  name:"Van Graaf"},
  {key:"fashioncore",name:"fashioncore"},
  {key:"nes",       name:"NES"},
  {key:"digitec",   name:"Digitec Galaxus"},
  {key:"bolcom",    name:"bol.com B.V."},
  {key:"miinto",    name:"Miinto"},
  {key:"spartoo",   name:"Spartoo"},
  {key:"tiktok",    name:"TikTok Shop"},
];
const AmpelDots=({markets=[]})=><div style={{display:"flex",gap:3,flexWrap:"wrap",alignItems:"center"}}>
  {markets.length===0&&<span style={{color:"var(--t3)",fontSize:10}}>–</span>}
  {markets.map(m=>{const mp=MP_AMPEL[m];return mp?<span key={m} title={m} style={{display:"inline-flex",alignItems:"center",justifyContent:"center",width:16,height:16,borderRadius:"50%",background:mp.color+"22",border:`1px solid ${mp.color}`,fontSize:7,fontWeight:700,color:mp.color,lineHeight:1}}>{mp.label}</span>:null;})}
</div>;

/* ─── Filter Bar ─── */
const EMPTY_FILTERS={brand:"",gender:"",season:"",year:"",warengruppe:"",kategorie:"",color:""};
const FilterBar=({filters,onChange,options,loading})=>{
  const [open,setOpen]=useState(false);
  const active=Object.values(filters).filter(v=>v).length;
  return<div style={{marginBottom:14}}>
    <div style={{display:"flex",gap:8,alignItems:"center"}}>
      <button onClick={()=>setOpen(o=>!o)} style={{display:"flex",alignItems:"center",gap:6,padding:"6px 12px",borderRadius:7,border:"1px solid var(--brd)",background:active?"var(--acc2)":"var(--s2)",color:active?"var(--acc)":"var(--t2)",fontSize:12,fontWeight:active?600:400,cursor:"pointer",fontFamily:"inherit"}}>
        <span>Filter</span>
        {active>0&&<span style={{background:"var(--acc)",color:"#fff",borderRadius:10,padding:"0 6px",fontSize:10,fontWeight:700}}>{active}</span>}
        <span style={{fontSize:9,opacity:.5,transition:"transform .2s",transform:open?"rotate(180deg)":"none"}}>▼</span>
      </button>
      {active>0&&<Btn small onClick={()=>onChange({...EMPTY_FILTERS})}>× Zurücksetzen</Btn>}
    </div>
    {open&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(155px,1fr))",gap:8,marginTop:10,padding:"14px",background:"var(--s2)",borderRadius:8,border:"1px solid var(--brd)"}}>
      {[
        {k:"brand",l:"Marke",opts:options?.brands||[]},
        {k:"gender",l:"Geschlecht",opts:options?.genders||[]},
        {k:"season",l:"Saison",opts:options?.seasons||[]},
        {k:"year",l:"Kollektion (Jahr)",opts:options?.years||[]},
        {k:"warengruppe",l:"Warengruppe",opts:options?.warengruppen||[]},
        {k:"kategorie",l:"Kategorie",opts:options?.kategorien||[]},
        {k:"color",l:"Farbe",opts:options?.colors||[]},
      ].map(f=><div key={f.k}>
        <label style={{fontSize:9,color:"var(--t3)",display:"block",marginBottom:3,textTransform:"uppercase",letterSpacing:".5px",fontWeight:600}}>{f.l}</label>
        <select value={filters[f.k]||""} onChange={e=>onChange({...filters,[f.k]:e.target.value})} style={{width:"100%",padding:"6px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s1)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
          <option value="">Alle</option>
          {f.opts.map(o=><option key={o} value={o}>{o}</option>)}
        </select>
      </div>)}
    </div>}
  </div>;
};

/* ─── Base Components ─── */
const Badge=({value,s="%"})=>{const p=value>0;return<span style={{display:"inline-flex",alignItems:"center",gap:2,padding:"2px 7px",borderRadius:5,fontSize:11,fontWeight:600,background:p?"var(--grn2)":"var(--red2)",color:p?"var(--grn)":"var(--red)"}}>{p?"↑":"↓"}{Math.abs(value)}{s}</span>};
const Dot=({s})=><span style={{width:7,height:7,borderRadius:"50%",background:{connected:"var(--grn)",pending:"var(--ylw)",error:"var(--red)",inactive:"var(--t3)",aktiv:"var(--grn)",inaktiv:"var(--t3)"}[s]||"var(--t3)",display:"inline-block",flexShrink:0,boxShadow:`0 0 5px ${{connected:"var(--grn)",pending:"var(--ylw)",error:"var(--red)"}[s]||"transparent"}`}}/>;
const Card=({children,style,onClick,onMouseEnter,onMouseLeave})=><div onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} style={{background:"var(--s1)",borderRadius:12,padding:"18px 20px",border:"1px solid var(--brd)",...style}}>{children}</div>;
const KPI=({title,value,sub,trend,accent,icon})=><Card style={{position:"relative",overflow:"hidden"}}><div style={{position:"absolute",top:0,left:0,right:0,height:3,background:accent||"var(--acc)",borderRadius:"12px 12px 0 0"}}/><div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><span style={{fontSize:12,color:"var(--t2)",fontWeight:500}}>{title}</span><span style={{fontSize:16,opacity:.4}}>{icon}</span></div><div style={{fontSize:22,fontWeight:700,color:"var(--t1)",margin:"6px 0 4px",letterSpacing:"-.5px"}}>{value}</div><div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><span style={{fontSize:11,color:"var(--t3)"}}>{sub}</span>{trend!==undefined&&<Badge value={trend}/>}</div></Card>;
const Tabs=({tabs,active,onChange})=><div style={{display:"flex",gap:3,background:"var(--s2)",borderRadius:8,padding:3}}>{tabs.map(t=><button key={t.k} onClick={()=>onChange(t.k)} style={{padding:"7px 16px",borderRadius:6,border:"none",fontSize:12,fontWeight:500,cursor:"pointer",fontFamily:"inherit",background:active===t.k?"var(--acc)":"transparent",color:active===t.k?"#fff":"var(--t2)",transition:"all .2s"}}>{t.l}</button>)}</div>;
const Btn=({children,primary,small,onClick,style,disabled})=><button disabled={disabled} onClick={onClick} style={{padding:small?"4px 10px":"6px 14px",borderRadius:6,border:primary?"none":"1px solid var(--brd)",background:primary?"var(--acc)":disabled?"var(--s3)":"var(--s2)",color:primary?"#fff":disabled?"var(--t3)":"var(--t2)",fontSize:small?11:12,fontWeight:500,cursor:disabled?"not-allowed":"pointer",fontFamily:"inherit",opacity:disabled?.6:1,...style}}>{children}</button>;
const Tag=({children,color})=><span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:(color||"var(--acc2)"),color:color?color:"var(--acc)",display:"inline-block"}}>{children}</span>;

/* ─── Empty State ─── */
const EmptyState=({icon,title,sub})=><div style={{padding:"60px 40px",textAlign:"center",color:"var(--t3)"}}><div style={{fontSize:36,marginBottom:14,opacity:.4}}>{icon}</div><div style={{fontSize:15,fontWeight:600,color:"var(--t2)",marginBottom:6}}>{title}</div><div style={{fontSize:12}}>{sub}</div></div>;

/* ─── System Status ─── */
const SystemStatus=()=>{
  const [s,setS]=useState(null);
  useEffect(()=>{fetch("/api/status").then(r=>r.json()).then(setS).catch(e=>setS({mongodb:"error"}));},[]);
  if(!s)return null;
  const ok=s.mongodb==="connected";
  return<div style={{display:"flex",alignItems:"center",gap:6,padding:"5px 10px",borderRadius:6,background:ok?"var(--grn2)":"var(--red2)",fontSize:10,fontWeight:500,color:ok?"var(--grn)":"var(--red)"}}>
    <Dot s={ok?"connected":"error"}/>{ok?`${fmtN(s.products||0)}P · ${fmtN(s.articles||0)}V`:"DB Fehler"}
  </div>;
};

/* ─── Dashboard ─── */
const Dashboard=()=>{
  const [z,setZ]=useState("monat");
  const [data,setData]=useState(null);
  useEffect(()=>{fetch("/api/dashboard").then(r=>r.json()).then(setData).catch(()=>{});},[]);
  return <>
    <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
      <Tabs tabs={[{k:"heute",l:"Heute"},{k:"woche",l:"7 Tage"},{k:"monat",l:"30 Tage"}]} active={z} onChange={setZ}/>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:14,marginBottom:20}}>
      <KPI title="Kontostand" value={fmt(487320.45)} sub="4 Bankkonten" icon="◈" accent="var(--acc)"/>
      <KPI title="Produkte" value={data?fmtN(data.products):"…"} sub="In Datenbank" icon="◧" accent="var(--grn)"/>
      <KPI title="Varianten" value={data?fmtN(data.articles):"…"} sub="In Datenbank" icon="▤" accent="var(--grn)"/>
      <KPI title="Retourenquote" value="28,4%" sub="6.867 Retouren" trend={-1.2} icon="↩" accent="var(--red)"/>
      <KPI title="Kosten heute" value={fmt(8420)} sub="Fix: 4.200 · Var: 3.120" icon="▾" accent="var(--ylw)"/>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"1fr 300px",gap:14,marginBottom:20}}>
      <Card>
        <div style={{fontSize:13,fontWeight:600,marginBottom:16,color:"var(--t1)"}}>Marktplatz-Übersicht</div>
        {[{n:"Zalando",u:485,c:"#ff6900"},{n:"About You",u:242,c:"#e91e63"},{n:"Otto",u:181,c:"#ef4444"},{n:"Amazon",u:145,c:"#f59e0b"},{n:"eBay",u:72,c:"#3b82f6"},{n:"Kaufland",u:48,c:"#10b981"}].map(m=>
          <div key={m.n} style={{display:"flex",alignItems:"center",gap:12,padding:"8px 0",borderBottom:"1px solid var(--brd)"}}>
            <span style={{width:90,fontSize:12,fontWeight:500,color:"var(--t1)"}}>{m.n}</span>
            <div style={{flex:1,height:6,borderRadius:3,background:"var(--s2)",overflow:"hidden"}}><div style={{height:"100%",width:`${(m.u/485)*100}%`,background:m.c,borderRadius:3}}/></div>
            <span style={{fontSize:12,fontWeight:600,color:"var(--t1)",width:55,textAlign:"right"}}>{m.u}k €</span>
          </div>
        )}
      </Card>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <Card>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <span style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>Liquidität</span>
            <span style={{width:9,height:9,borderRadius:"50%",background:"var(--ylw)",boxShadow:"0 0 8px var(--ylw)"}}/>
          </div>
          {[["Bereinigt",fmt(398120),"var(--t1)"],["Geld unterwegs",fmt(134500),"var(--acc)"],["Prognose 7T",fmt(462100),"var(--t1)"]].map(([l,v,c])=>
            <div key={l} style={{display:"flex",justifyContent:"space-between",marginBottom:8}}><span style={{fontSize:11,color:"var(--t2)"}}>{l}</span><span style={{fontSize:12,fontWeight:600,color:c}}>{v}</span></div>
          )}
        </Card>
        <Card>
          <div style={{fontSize:13,fontWeight:600,marginBottom:10,color:"var(--t1)"}}>Top Marken</div>
          {data&&data.brands?data.brands.slice(0,6).map(b=>
            <div key={b._id} style={{display:"flex",justifyContent:"space-between",padding:"4px 0"}}>
              <span style={{fontSize:11,color:"var(--t2)"}}>{b._id||"Unbekannt"}</span>
              <span style={{fontSize:11,fontWeight:600,color:"var(--t1)"}}>{b.count}</span>
            </div>
          ):<span style={{fontSize:11,color:"var(--t3)"}}>Noch keine Daten importiert</span>}
        </Card>
      </div>
    </div>
  </>;
};

/* ─── Verkaufszahlen (Marktplatz-Kacheln aus Bestellungen) ─── */
const fmtEurV=(n)=>(n||0).toLocaleString("de-DE",{minimumFractionDigits:0,maximumFractionDigits:0})+" €";
// Datumsbereich-Presets
const toIso=(d)=>d.toISOString().slice(0,10);
const dateRangePresets=()=>{
  const now=new Date();
  const y=now.getUTCFullYear(), m=now.getUTCMonth();
  const first=(yy,mm)=>new Date(Date.UTC(yy,mm,1));
  const lastDay=(yy,mm)=>new Date(Date.UTC(yy,mm+1,0,23,59,59));
  return {
    heute:{from:toIso(new Date(Date.UTC(y,m,now.getUTCDate()))),to:toIso(new Date(Date.UTC(y,m,now.getUTCDate(),23,59,59)))},
    dieserMonat:{from:toIso(first(y,m)),to:toIso(lastDay(y,m))},
    letzterMonat:{from:toIso(first(m===0?y-1:y,(m+11)%12)),to:toIso(lastDay(m===0?y-1:y,(m+11)%12))},
    aktJahr:{from:`${y}-01-01`,to:`${y}-12-31`},
    vorJahr:{from:`${y-1}-01-01`,to:`${y-1}-12-31`},
  };
};
const DateRangeBar=({from,to,setFrom,setTo,onApply})=>{
  const presets=dateRangePresets();
  const years=[];
  for(let yy=new Date().getUTCFullYear();yy>=2020;yy--) years.push(yy);
  const activePreset=Object.entries(presets).find(([_,p])=>p.from===from&&p.to===to)?.[0];
  // Wichtig: onApply direkt mit den neuen Werten aufrufen, NICHT auf State-Commit warten
  const set=(p)=>{setFrom(p.from);setTo(p.to);(onApply||(()=>{}))(p.from,p.to);};
  const btnStyle=(a)=>({padding:"6px 10px",fontSize:11,background:a?"var(--acc)":"var(--s2)",color:a?"#fff":"var(--t2)",border:"1px solid var(--brd)",borderRadius:6,cursor:"pointer",fontFamily:"inherit"});
  return<div style={{display:"flex",gap:6,alignItems:"end",flexWrap:"wrap"}}>
    <button onClick={()=>set(presets.heute)} style={btnStyle(activePreset==="heute")}>Heute</button>
    <button onClick={()=>set(presets.dieserMonat)} style={btnStyle(activePreset==="dieserMonat")}>Dieser Monat</button>
    <button onClick={()=>set(presets.letzterMonat)} style={btnStyle(activePreset==="letzterMonat")}>Letzter Monat</button>
    <button onClick={()=>set(presets.aktJahr)} style={btnStyle(activePreset==="aktJahr")}>Aktuelles Jahr</button>
    <button onClick={()=>set(presets.vorJahr)} style={btnStyle(activePreset==="vorJahr")}>Vorjahr</button>
    <select value={from?.slice(0,4)||""} onChange={e=>{const yy=e.target.value;if(yy){const f=`${yy}-01-01`,t=`${yy}-12-31`;setFrom(f);setTo(t);(onApply||(()=>{}))(f,t);}}} style={{padding:"6px 10px",fontSize:11,background:"var(--s2)",color:"var(--t2)",border:"1px solid var(--brd)",borderRadius:6,cursor:"pointer",fontFamily:"inherit"}}>
      <option value="">Jahr …</option>
      {years.map(y=><option key={y} value={y}>{y}</option>)}
    </select>
    <div style={{borderLeft:"1px solid var(--brd)",paddingLeft:8,display:"flex",gap:6,alignItems:"end"}}>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Von</label><input type="date" value={from||""} onChange={e=>setFrom(e.target.value)} style={{padding:"5px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:11,fontFamily:"inherit"}}/></div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Bis</label><input type="date" value={to||""} onChange={e=>setTo(e.target.value)} style={{padding:"5px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:11,fontFamily:"inherit"}}/></div>
      <Btn onClick={()=>(onApply||(()=>{}))(from,to)}>Anwenden</Btn>
      <Btn onClick={()=>{setFrom("");setTo("");(onApply||(()=>{}))("","");}}>Reset</Btn>
    </div>
  </div>;
};
const matchMarketplace=(channel,mps)=>{
  if(!channel) return null;
  const norm=s=>(s||"").toLowerCase().replace(/[^a-z0-9]/g,"");
  const c=norm(channel);
  // manuelle Heuristiken
  const hints={bolcom:["bolcom","bol"],digitec:["galaxus","digitec"],vangraaf:["vangraaf","van graaf"],secretsales:["secretsales","dressforless"],nes:["netto","marktkauf","nes:"]};
  // zuerst expliziter key
  for(const mp of mps){
    if(c.includes(norm(mp.key))) return mp.key;
  }
  // dann Name
  for(const mp of mps){
    if(c.includes(norm(mp.name))) return mp.key;
  }
  // dann Hints
  for(const [k,arr] of Object.entries(hints)){
    if(arr.some(h=>c.includes(norm(h)))) return k;
  }
  return null;
};
const Verkaufszahlen=()=>{
  const _yNow=new Date().getUTCFullYear();
  const [kanaele,setKanaele]=useState([]);
  const [total,setTotal]=useState({});
  const [mps,setMps]=useState([]);
  const [loading,setLoading]=useState(true);
  const [from,setFrom]=useState(`${_yNow}-01-01`);
  const [to,setTo]=useState(`${_yNow}-12-31`);
  const [expanded,setExpanded]=useState(null);
  const [incStornos,setIncStornos]=useState(false);
  const [incRetouren,setIncRetouren]=useState(false);
  const [kanalSort,setKanalSort]=useState("umsatz"); // umsatz | alpha
  const [mpFilter,setMpFilter]=useState(""); // leer = alle
  const [ustMode,setUstMode]=useState("brutto"); // brutto (inkl. USt) | netto (exkl. 19% USt)
  const vatDiv = ustMode==="netto" ? 1.19 : 1;
  const load=(fOv,tOv)=>{
    setLoading(true);
    const f=fOv!==undefined?fOv:from, t=tOv!==undefined?tOv:to;
    const p=new URLSearchParams(); if(f)p.set("from",f); if(t)p.set("to",t);
    Promise.all([
      fetch("/api/bestellungen/kanaele?"+p).then(r=>r.json()),
      fetch("/api/marktplaetze").then(r=>r.json()).catch(()=>[]),
    ]).then(([k,m])=>{
      setKanaele(k.rows||[]); setTotal(k.total||{});
      setMps(Array.isArray(m)?m:(m.data||[]));
      setLoading(false);
    }).catch(()=>setLoading(false));
  };
  useEffect(()=>{load();},[]);
  // Pro Kanal: Umsatz nach incS/incR umrechnen (Netto default, mit Stornos/Retouren addieren wenn angehakt)
  const adjUmsatz=(k)=>(((k.umsatz||0) + (incRetouren?(k.retourEur||0):0) + (incStornos?(k.stornoEur||0):0)) / vatDiv);
  // Gruppierung Kanäle → Marktplatz
  const groups={};
  const unmapped=[];
  kanaele.forEach(k=>{
    const key=matchMarketplace(k.kanal,mps);
    const u=adjUmsatz(k);
    if(key){
      if(!groups[key]) groups[key]={key,umsatz:0,umsatzBrutto:0,retourEur:0,stornoEur:0,auftraege:0,positionen:0,menge:0,kanaele:[]};
      groups[key].umsatz+=u; groups[key].umsatzBrutto+=(k.umsatzBrutto||0);
      groups[key].retourEur+=(k.retourEur||0); groups[key].stornoEur+=(k.stornoEur||0);
      groups[key].auftraege+=k.auftraege;
      groups[key].positionen+=k.positionen; groups[key].menge+=k.menge;
      groups[key].kanaele.push({...k,_adjUmsatz:u});
    } else unmapped.push({...k,_adjUmsatz:u});
  });
  let groupList=Object.values(groups).map(g=>({...g,mp:mps.find(m=>m.key===g.key)||{key:g.key,name:g.key}}));
  if(kanalSort==="alpha") groupList.sort((a,b)=>(a.mp.name||"").localeCompare(b.mp.name||""));
  else groupList.sort((a,b)=>b.umsatz-a.umsatz);
  // Marktplatz-Tag-Filter: wenn gesetzt nur diese Gruppe zeigen
  const groupListFiltered = mpFilter ? groupList.filter(g=>g.key===mpFilter) : groupList;
  const unmappedFiltered = mpFilter ? [] : unmapped;
  const maxU=Math.max(1,...groupListFiltered.map(g=>g.umsatz),...unmappedFiltered.map(u=>u._adjUmsatz||0));
  // Gesamt-KPIs aus den aktuell sichtbaren Kanälen berechnen (respektieren Filter + incS/incR)
  const allVisibleKanaele=[...groupListFiltered.flatMap(g=>g.kanaele),...unmappedFiltered];
  const gesamtUmsatz=allVisibleKanaele.reduce((s,k)=>s+(k._adjUmsatz||0),0);
  const gesamtAuftraege=allVisibleKanaele.reduce((s,k)=>s+(k.auftraege||0),0);
  const gesamtPositionen=allVisibleKanaele.reduce((s,k)=>s+(k.positionen||0),0);
  const mpColors=["#4a9eff","#10b981","#f59e0b","#ef4444","#8b5cf6","#ec4899","#06b6d4","#84cc16","#f97316","#14b8a6"];
  return<div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"end",marginBottom:16,flexWrap:"wrap",gap:12}}>
      <div>
        <div style={{fontSize:16,fontWeight:700,color:"var(--t1)"}}>Verkaufszahlen nach Marktplatz</div>
        <div style={{fontSize:11,color:"var(--t3)",marginTop:4}}>Aggregation aus Bestellungen (Tradebyte-Export) · {kanaele.length} Kanäle → {groupList.length} Marktplätze{unmapped.length>0&&<> · {unmapped.length} nicht zugeordnet</>}</div>
      </div>
      <DateRangeBar from={from} to={to} setFrom={setFrom} setTo={setTo} onApply={load}/>
    </div>
    <div style={{display:"flex",gap:12,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
      <label style={{display:"flex",alignItems:"center",gap:6,fontSize:11,color:"var(--t2)",cursor:"pointer"}} title="Standard: Netto (abzgl. Stornos).">
        <input type="checkbox" checked={incStornos} onChange={e=>setIncStornos(e.target.checked)}/> Stornos einbeziehen
      </label>
      <label style={{display:"flex",alignItems:"center",gap:6,fontSize:11,color:"var(--t2)",cursor:"pointer"}} title="Standard: Netto (abzgl. Retouren).">
        <input type="checkbox" checked={incRetouren} onChange={e=>setIncRetouren(e.target.checked)}/> Retouren einbeziehen
      </label>
      <div style={{marginLeft:12,display:"flex",gap:4,alignItems:"center"}}>
        <span style={{fontSize:11,color:"var(--t3)"}}>Sort:</span>
        <button onClick={()=>setKanalSort("umsatz")} style={{padding:"4px 8px",fontSize:10,background:kanalSort==="umsatz"?"var(--acc)":"var(--s2)",color:kanalSort==="umsatz"?"#fff":"var(--t2)",border:"1px solid var(--brd)",borderRadius:4,cursor:"pointer",fontFamily:"inherit"}}>Umsatz</button>
        <button onClick={()=>setKanalSort("alpha")} style={{padding:"4px 8px",fontSize:10,background:kanalSort==="alpha"?"var(--acc)":"var(--s2)",color:kanalSort==="alpha"?"#fff":"var(--t2)",border:"1px solid var(--brd)",borderRadius:4,cursor:"pointer",fontFamily:"inherit"}}>A-Z</button>
      </div>
      <div style={{marginLeft:12,display:"flex",gap:4,alignItems:"center"}} title="Tradebyte-Positionen sind Brutto inkl. 19% USt. Netto = ÷1,19 (pauschal, analog Tradebyte-KPI 'Netto exkl. MwSt').">
        <span style={{fontSize:11,color:"var(--t3)"}}>USt:</span>
        <button onClick={()=>setUstMode("brutto")} style={{padding:"4px 8px",fontSize:10,background:ustMode==="brutto"?"var(--acc)":"var(--s2)",color:ustMode==="brutto"?"#fff":"var(--t2)",border:"1px solid var(--brd)",borderRadius:4,cursor:"pointer",fontFamily:"inherit"}}>Brutto inkl.</button>
        <button onClick={()=>setUstMode("netto")} style={{padding:"4px 8px",fontSize:10,background:ustMode==="netto"?"var(--acc)":"var(--s2)",color:ustMode==="netto"?"#fff":"var(--t2)",border:"1px solid var(--brd)",borderRadius:4,cursor:"pointer",fontFamily:"inherit"}}>Netto exkl.</button>
      </div>
    </div>
    <div style={{display:"flex",gap:6,marginBottom:12,flexWrap:"wrap",alignItems:"center"}}>
      <span style={{fontSize:11,color:"var(--t3)",marginRight:4}}>Marktplatz:</span>
      <button onClick={()=>setMpFilter("")} style={{padding:"4px 10px",fontSize:11,background:!mpFilter?"var(--acc)":"var(--s2)",color:!mpFilter?"#fff":"var(--t2)",border:"1px solid var(--brd)",borderRadius:12,cursor:"pointer",fontFamily:"inherit"}}>Alle ({groupList.length})</button>
      {groupList.map(g=><button key={g.key} onClick={()=>setMpFilter(mpFilter===g.key?"":g.key)} style={{padding:"4px 10px",fontSize:11,background:mpFilter===g.key?"var(--acc)":"var(--s2)",color:mpFilter===g.key?"#fff":"var(--t2)",border:"1px solid var(--brd)",borderRadius:12,cursor:"pointer",fontFamily:"inherit"}}>{g.mp.name} <span style={{opacity:.6,marginLeft:4}}>{g.kanaele.length}</span></button>)}
    </div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:20}}>
      <KPI title={`Gesamtumsatz ${ustMode==="netto"?"(exkl. USt)":"(inkl. USt)"}${(incStornos||incRetouren)?"":" · abz. Ret/Storno"}`} value={fmtEurV(gesamtUmsatz)} icon="€" accent="var(--green)"/>
      <KPI title="Aufträge" value={gesamtAuftraege.toLocaleString("de-DE")} icon="◐"/>
      <KPI title="Positionen" value={gesamtPositionen.toLocaleString("de-DE")} icon="▦"/>
      <KPI title="Ø Auftragswert" value={gesamtAuftraege?fmtEurV(gesamtUmsatz/gesamtAuftraege):"-"} icon="∑"/>
    </div>
    {loading?<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
     groupListFiltered.length===0?<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Keine Daten – zuerst Bestellungen importieren.</div>:
     <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:14}}>
       {groupListFiltered.map((g,i)=>{
         const color=mpColors[i%mpColors.length];
         const share=gesamtUmsatz?(g.umsatz/gesamtUmsatz*100):0;
         const isOpen=expanded===g.key;
         return<div key={g.key} style={{background:"var(--s1)",border:"1px solid var(--brd)",borderRadius:10,overflow:"hidden",transition:"all .2s"}}>
           <div onClick={()=>setExpanded(isOpen?null:g.key)} style={{padding:16,cursor:"pointer",borderLeft:`4px solid ${color}`}}>
             <div style={{display:"flex",justifyContent:"space-between",alignItems:"start",marginBottom:10}}>
               <div>
                 <div style={{fontSize:14,fontWeight:700,color:"var(--t1)"}}>{g.mp.name}</div>
                 <div style={{fontSize:10,color:"var(--t3)",marginTop:2,textTransform:"uppercase",letterSpacing:".5px"}}>{g.kanaele.length} {g.kanaele.length===1?"Kanal":"Kanäle"} · {share.toFixed(1)}%</div>
               </div>
               <div style={{fontSize:11,color:"var(--t3)"}}>{isOpen?"▾":"▸"}</div>
             </div>
             <div style={{fontSize:22,fontWeight:800,color:"var(--t1)",marginBottom:8}}>{fmtEurV(g.umsatz)}</div>
             <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6,fontSize:10,color:"var(--t2)"}}>
               <div><div style={{color:"var(--t3)",marginBottom:2}}>Aufträge</div><div style={{fontWeight:600,color:"var(--t1)"}}>{g.auftraege.toLocaleString("de-DE")}</div></div>
               <div><div style={{color:"var(--t3)",marginBottom:2}}>Positionen</div><div style={{fontWeight:600,color:"var(--t1)"}}>{g.positionen.toLocaleString("de-DE")}</div></div>
               <div><div style={{color:"var(--t3)",marginBottom:2}}>Stück</div><div style={{fontWeight:600,color:"var(--t1)"}}>{g.menge.toLocaleString("de-DE")}</div></div>
             </div>
             <div style={{marginTop:10,height:6,background:"var(--s2)",borderRadius:3,overflow:"hidden"}}>
               <div style={{height:"100%",width:(g.umsatz/maxU*100)+"%",background:color,transition:"width .4s"}}/>
             </div>
           </div>
           {isOpen&&<div style={{borderTop:"1px solid var(--brd)",background:"var(--s2)",padding:"8px 12px"}}>
             <div style={{fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>Kanäle</div>
             {[...g.kanaele].sort((a,b)=>kanalSort==="alpha"?(a.kanal||"").localeCompare(b.kanal||""):((b._adjUmsatz||0)-(a._adjUmsatz||0))).map((k,j)=><div key={j} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",fontSize:11,borderBottom:j<g.kanaele.length-1?"1px solid var(--brd)":"none"}}>
               <span style={{color:"var(--t2)"}}>{k.kanal}</span>
               <span style={{color:"var(--t1)",fontWeight:600}}>{fmtEurV(k._adjUmsatz||0)}</span>
             </div>)}
           </div>}
         </div>;
       })}
       {unmappedFiltered.length>0&&<div style={{background:"var(--s1)",border:"1px dashed var(--brd)",borderRadius:10,padding:16,borderLeft:"4px solid var(--t3)"}}>
         <div style={{fontSize:13,fontWeight:700,color:"var(--t2)"}}>Nicht zugeordnet</div>
         <div style={{fontSize:10,color:"var(--t3)",marginTop:2,marginBottom:10,textTransform:"uppercase",letterSpacing:".5px"}}>{unmappedFiltered.length} {unmappedFiltered.length===1?"Kanal":"Kanäle"}</div>
         <div style={{fontSize:20,fontWeight:700,color:"var(--t1)",marginBottom:10}}>{fmtEurV(unmappedFiltered.reduce((s,u)=>s+(u._adjUmsatz||0),0))}</div>
         {[...unmappedFiltered].sort((a,b)=>kanalSort==="alpha"?(a.kanal||"").localeCompare(b.kanal||""):((b._adjUmsatz||0)-(a._adjUmsatz||0))).slice(0,10).map((k,j)=><div key={j} style={{display:"flex",justifyContent:"space-between",padding:"3px 0",fontSize:10,color:"var(--t3)"}}>
           <span>{k.kanal}</span><span>{fmtEurV(k._adjUmsatz||0)}</span>
         </div>)}
         {unmappedFiltered.length>10&&<div style={{fontSize:10,color:"var(--t3)",marginTop:6}}>… +{unmappedFiltered.length-10} weitere</div>}
       </div>}
     </div>}
  </div>;
};

/* ─── Bestseller (Top-Artikel + Marken-Filter aus Bestellungen) ─── */
const Bestseller=()=>{
  const _yNow=new Date().getUTCFullYear();
  const [rows,setRows]=useState([]);
  const [total,setTotal]=useState(0);
  const [menge,setMenge]=useState(0);
  const [umsatz,setUmsatz]=useState(0);
  const [marken,setMarken]=useState([]);
  const [from,setFrom]=useState(`${_yNow}-01-01`);
  const [to,setTo]=useState(`${_yNow}-12-31`);
  const [brand,setBrand]=useState("");
  const [q,setQ]=useState("");
  const [skip,setSkip]=useState(0);
  const [loading,setLoading]=useState(false);
  const [mps,setMps]=useState([]);
  const [mpFilter,setMpFilter]=useState("");
  const [allKanaele,setAllKanaele]=useState([]); // für MP-Zuordnung aller existierenden Kanäle
  const [expanded,setExpanded]=useState(null);
  const [incStornos,setIncStornos]=useState(false);
  const [incRetouren,setIncRetouren]=useState(false);
  const [sortBy,setSortBy]=useState("menge");
  const [sortDir,setSortDir]=useState("desc");
  const limit=50;
  const toggleSort=(field)=>{
    if(sortBy===field) setSortDir(sortDir==="asc"?"desc":"asc");
    else { setSortBy(field); setSortDir("desc"); }
    setSkip(0);
  };
  const sortArrow=(field)=>sortBy!==field?"":(sortDir==="asc"?" ▲":" ▼");
  const load=(fOv,tOv)=>{
    setLoading(true);
    const f=fOv!==undefined?fOv:from, t=tOv!==undefined?tOv:to;
    const p=new URLSearchParams();
    if(f)p.set("from",f); if(t)p.set("to",t);
    if(brand)p.set("brand",brand); if(q)p.set("q",q);
    if(incStornos)p.set("includeStornos","true");
    if(incRetouren)p.set("includeRetouren","true");
    p.set("sortBy",sortBy); p.set("sortDir",sortDir);
    // Marktplatz-Filter → Kanalliste aus allen bekannten Kanälen ableiten
    if(mpFilter){
      const matched=allKanaele.filter(k=>matchMarketplace(k,mps)===mpFilter);
      if(matched.length) p.set("channels",matched.join(","));
      else p.set("channels","__none__"); // führt zu leerem Ergebnis
    }
    p.set("limit",limit); p.set("skip",skip);
    const mp=new URLSearchParams(); if(f)mp.set("from",f); if(t)mp.set("to",t);
    Promise.all([
      fetch("/api/bestellungen/bestseller?"+p).then(r=>r.json()),
      fetch("/api/bestellungen/marken?"+mp).then(r=>r.json()).catch(()=>({rows:[]})),
      fetch("/api/marktplaetze").then(r=>r.json()).catch(()=>[]),
      fetch("/api/bestellungen/kanaele?"+mp).then(r=>r.json()).catch(()=>({rows:[]})),
    ]).then(([b,m,mm,kk])=>{
      setRows(b.data||[]);setTotal(b.total||0);
      setMenge(b.mengeNetto!==undefined?b.mengeNetto:(b.menge||0));
      setUmsatz(b.umsatzEurNetto!==undefined?b.umsatzEurNetto:(b.umsatz||0));
      setMarken(m.rows||[]);
      setMps(Array.isArray(mm)?mm:(mm.data||[]));
      setAllKanaele((kk.rows||[]).map(r=>r.kanal));
      setLoading(false);
    }).catch(()=>setLoading(false));
  };
  useEffect(()=>{load();},[skip,brand,mpFilter,incStornos,incRetouren,sortBy,sortDir]);
  // Kanäle → Marktplätze gruppieren
  const groupKanaeleByMp=(kanaele)=>{
    const arr=Array.isArray(kanaele)?kanaele:[];
    // Neues Format: Objekte {kanal, menge, umsatz}; altes Format: nur Strings
    const items=arr.map(k=>typeof k==="string"?{kanal:k,menge:0,umsatz:0}:k);
    const g={}, u=[];
    items.forEach(it=>{
      const key=matchMarketplace(it.kanal,mps);
      if(key){
        if(!g[key]) g[key]={key,name:(mps.find(m=>m.key===key)||{}).name||key,menge:0,umsatz:0,kanaele:[]};
        g[key].menge+=it.menge||0; g[key].umsatz+=it.umsatz||0; g[key].kanaele.push(it);
      } else u.push(it);
    });
    return {groups:Object.values(g).sort((a,b)=>b.menge-a.menge),unmapped:u};
  };
  const search=(fOv,tOv)=>{setSkip(0);load(fOv,tOv);};
  const maxMenge=Math.max(1,...rows.map(r=>r.menge||0));
  return<div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"end",marginBottom:16,flexWrap:"wrap",gap:12}}>
      <div>
        <div style={{fontSize:16,fontWeight:700,color:"var(--t1)"}}>Bestseller</div>
        <div style={{fontSize:11,color:"var(--t3)",marginTop:4}}>Meistverkaufte Artikel aus Bestellungen · gruppiert nach Menge · Join mit Artikelstamm für Marke</div>
      </div>
      <DateRangeBar from={from} to={to} setFrom={setFrom} setTo={setTo} onApply={search}/>
    </div>
    <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap",alignItems:"end"}}>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Marke ({marken.length})</label>
        <input list="bestseller-marken-list" value={brand} onChange={e=>{setBrand(e.target.value);setSkip(0);}} placeholder="Suchen/Auswählen…" style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",minWidth:220}}/>
        <datalist id="bestseller-marken-list">
          {marken.map(m=><option key={m.marke} value={m.marke}>{m.marke||"(ohne)"} – {m.menge} Stk</option>)}
        </datalist>
      </div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Marktplatz</label>
        <select value={mpFilter} onChange={e=>{setMpFilter(e.target.value);setSkip(0);}} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",minWidth:180}}>
          <option value="">Alle Marktplätze</option>
          {mps.map(m=><option key={m.key} value={m.key}>{m.name}</option>)}
        </select>
      </div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Suche (Artikel-Nr / Produkt)</label>
        <input value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&search()} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",width:280}}/>
      </div>
      <Btn onClick={search}>Filtern</Btn>
      <Btn onClick={()=>{setQ("");setBrand("");setMpFilter("");setIncStornos(false);setIncRetouren(false);setSkip(0);setTimeout(load,0);}}>Reset</Btn>
      <label style={{display:"flex",alignItems:"center",gap:6,fontSize:11,color:"var(--t2)",cursor:"pointer",marginLeft:12}} title="Standard: Netto (abzgl. Stornos). Anhaken = Stornos mitzählen (Brutto).">
        <input type="checkbox" checked={incStornos} onChange={e=>{setIncStornos(e.target.checked);setSkip(0);}}/> Stornos einbeziehen
      </label>
      <label style={{display:"flex",alignItems:"center",gap:6,fontSize:11,color:"var(--t2)",cursor:"pointer"}} title="Standard: Netto (abzgl. Retouren). Anhaken = Retouren mitzählen (Brutto).">
        <input type="checkbox" checked={incRetouren} onChange={e=>{setIncRetouren(e.target.checked);setSkip(0);}}/> Retouren einbeziehen
      </label>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:16}}>
      <KPI title="Artikel im Ergebnis" value={total.toLocaleString("de-DE")} icon="🏆"/>
      <KPI title={(incStornos||incRetouren)?"Verkaufte Stück":"Verkaufte Stück (netto)"} value={menge.toLocaleString("de-DE")} icon="▦"/>
      <KPI title={(incStornos||incRetouren)?"Umsatz":"Umsatz (netto)"} value={fmtEurV(umsatz)} icon="€" accent="var(--green)"/>
    </div>
    <div style={{background:"var(--s1)",borderRadius:8,overflow:"hidden",border:"1px solid var(--brd)"}}>
      <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
        <thead style={{background:"var(--s2)"}}><tr style={{color:"var(--t3)",fontSize:11,textAlign:"left"}}>
          <th style={{padding:"8px 10px",width:50,textAlign:"center"}}>#</th>
          <th style={{padding:"8px 10px",width:160}}>Marke</th>
          <th style={{padding:"8px 10px"}}>Artikel</th>
          <th style={{padding:"8px 10px"}}>Variante</th>
          <th style={{padding:"8px 10px",textAlign:"right",width:90,cursor:"pointer",userSelect:"none"}} onClick={()=>toggleSort("menge")}>Stück{sortArrow("menge")}</th>
          <th style={{padding:"8px 10px",width:150}}></th>
          <th style={{padding:"8px 10px",textAlign:"right",width:120,cursor:"pointer",userSelect:"none"}} onClick={()=>toggleSort("umsatz")}>Umsatz{sortArrow("umsatz")}</th>
          <th style={{padding:"8px 10px",textAlign:"right",width:80,cursor:"pointer",userSelect:"none"}} onClick={()=>toggleSort("stornoQuote")} title="Stornoquote (% der Bruttomenge)">Storno%{sortArrow("stornoQuote")}</th>
          <th style={{padding:"8px 10px",textAlign:"right",width:80,cursor:"pointer",userSelect:"none"}} onClick={()=>toggleSort("retourQuote")} title="Retourenquote (% der Bruttomenge)">Retour%{sortArrow("retourQuote")}</th>
          <th style={{padding:"8px 10px",textAlign:"center",width:60}}>Kanäle</th>
        </tr></thead>
        <tbody>{loading?<tr><td colSpan={10} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</td></tr>:
          rows.length===0?<tr><td colSpan={10} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Artikel im Filter.</td></tr>:
          rows.map((r,i)=>{
            const rank=skip+i+1;
            const medal=rank===1?"🥇":rank===2?"🥈":rank===3?"🥉":null;
            const isOpen=expanded===i;
            const {groups:mpGroups,unmapped:mpUn}=groupKanaeleByMp(r.kanaele);
            const kanalCnt=(r.kanaele||[]).length;
            return<React.Fragment key={i}>
              <tr style={{borderTop:"1px solid var(--brd)",cursor:"pointer"}} onClick={()=>setExpanded(isOpen?null:i)}>
                <td style={{padding:"8px 10px",textAlign:"center",fontSize:14,fontWeight:700,color:"var(--t2)"}}>{medal||rank}</td>
                <td style={{padding:"8px 10px",color:"var(--t1)",fontWeight:600}}>{r.marke||<span style={{color:"var(--t3)",fontStyle:"italic",fontWeight:400}}>—</span>}</td>
                <td style={{padding:"8px 10px"}}>
                  <div style={{color:"var(--t1)"}}><span title={r.matched?"In Panda-Stammdaten gefunden":"Nicht in Panda-Stammdaten – bitte Re-Import"} style={{color:r.matched?"var(--green)":"var(--t3)",fontSize:9,marginRight:4,cursor:"help"}}>●</span>{r.productName||r.produktname}</div>
                  <div style={{fontSize:10,color:"var(--t3)",fontFamily:"monospace",marginTop:2}}>{r.artikelNr}</div>
                </td>
                <td style={{padding:"8px 10px",color:"var(--t2)",fontSize:11}}>{r.variante}</td>
                <td style={{padding:"8px 10px",textAlign:"right",fontSize:14,fontWeight:700,color:"var(--t1)"}} title={`Brutto: ${r.menge} · Storno: ${r.stornoMenge||0} · Retour: ${r.retourMenge||0}`}>{r.mengeNetto!==undefined?r.mengeNetto:r.menge}</td>
                <td style={{padding:"8px 10px"}}><div style={{height:8,background:"var(--s2)",borderRadius:4,overflow:"hidden"}}><div style={{height:"100%",width:((r.mengeNetto!==undefined?r.mengeNetto:r.menge)/maxMenge*100)+"%",background:"var(--acc)"}}/></div></td>
                <td style={{padding:"8px 10px",textAlign:"right",fontWeight:600}} title={`Brutto: ${fmtEurV(r.umsatzEur)} · Storno: ${fmtEurV(r.stornoEur||0)} · Retour: ${fmtEurV(r.retourEur||0)}`}>{fmtEurV(r.umsatzEurNetto!==undefined?r.umsatzEurNetto:r.umsatzEur)}</td>
                <td style={{padding:"8px 10px",textAlign:"right",color:(r.stornoQuote||0)>20?"var(--red)":"var(--t2)",fontWeight:(r.stornoQuote||0)>20?600:400}}>{(r.stornoQuote||0).toFixed(1)}%</td>
                <td style={{padding:"8px 10px",textAlign:"right",color:(r.retourQuote||0)>40?"var(--red)":"var(--t2)",fontWeight:(r.retourQuote||0)>40?600:400}}>{(r.retourQuote||0).toFixed(1)}%</td>
                <td style={{padding:"8px 10px",textAlign:"center",color:"var(--t2)",fontSize:11}}>{mpGroups.length}{mpUn.length>0&&<span style={{color:"var(--t3)"}}>+{mpUn.length}</span>} <span style={{color:"var(--t3)"}}>({kanalCnt})</span> {isOpen?"▾":"▸"}</td>
              </tr>
              {isOpen&&<tr style={{background:"var(--s2)"}}>
                <td/>
                <td colSpan={9} style={{padding:"10px 14px"}}>
                  <div style={{fontSize:10,color:"var(--t3)",marginBottom:6,textTransform:"uppercase",letterSpacing:0.5}}>Menge je Marktplatz</div>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:6}}>
                    {mpGroups.map(g=><div key={g.key} style={{background:"var(--s1)",border:"1px solid var(--brd)",borderRadius:6,padding:"8px 10px"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                        <span style={{color:"var(--t1)",fontWeight:600,fontSize:12}}>{g.name}</span>
                        <span style={{color:"var(--t1)",fontWeight:700,fontSize:13}}>{g.menge} Stk</span>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"var(--t3)"}}>
                        <span>{fmtEurV(g.umsatz)}</span>
                        <span>{g.kanaele.length} Kanal{g.kanaele.length!==1?"äle":""}</span>
                      </div>
                      <div style={{height:4,background:"var(--s2)",borderRadius:2,overflow:"hidden",marginTop:6}}><div style={{height:"100%",width:(g.menge/r.menge*100)+"%",background:"var(--acc)"}}/></div>
                    </div>)}
                    {mpUn.map((u,j)=><div key={"u"+j} style={{background:"var(--s1)",border:"1px dashed var(--brd)",borderRadius:6,padding:"8px 10px"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                        <span style={{color:"var(--t2)",fontSize:11,fontStyle:"italic"}}>{u.kanal}</span>
                        <span style={{color:"var(--t1)",fontWeight:700,fontSize:13}}>{u.menge} Stk</span>
                      </div>
                      <div style={{fontSize:10,color:"var(--t3)"}}>{fmtEurV(u.umsatz)} · nicht zugeordnet</div>
                    </div>)}
                  </div>
                </td>
              </tr>}
            </React.Fragment>;
          })}
        </tbody>
      </table>
    </div>
    <div style={{display:"flex",justifyContent:"space-between",marginTop:12,fontSize:11,color:"var(--t3)"}}>
      <div>{total>0&&<>{skip+1}–{Math.min(skip+limit,total)} von {total.toLocaleString("de-DE")}</>}</div>
      <div style={{display:"flex",gap:6}}>
        <Btn onClick={()=>setSkip(Math.max(0,skip-limit))} disabled={skip===0}>← Zurück</Btn>
        <Btn onClick={()=>setSkip(skip+limit)} disabled={skip+limit>=total}>Weiter →</Btn>
      </div>
    </div>
  </div>;
};

/* ─── Auswertungen ─── */
const Auswertungen=({sub})=>{
  const pages={
    "reports":<EmptyState icon="📊" title="Reports & Analysen" sub="Konfigurierbare Berichte – in Entwicklung"/>,
    "verkaufszahlen":<Verkaufszahlen/>,
    "bestseller":<Bestseller/>,
    "trends":<EmptyState icon="✦" title="Trends nach Zeitraum" sub="Saisonale Auswertungen – in Entwicklung"/>,
    "performance":<EmptyState icon="◎" title="Performance nach Kategorien" sub="Kategorie-Analyse – in Entwicklung"/>,
  };
  return pages[sub]||<EmptyState icon="📊" title="Auswertungen" sub="Wähle einen Bereich links"/>;
};

/* ─── Cashflow ─── */
const Cashflow=()=>{
  const [h,setH]=useState("6m");
  const [sc,setSc]=useState(0);
  const cf=[{m:"Apr",s:487},{m:"Mai",s:582},{m:"Jun",s:672},{m:"Jul",s:782},{m:"Aug",s:912},{m:"Sep",s:1012}];
  const mx=Math.max(...cf.map(c=>c.s));
  return <>
    <Tabs tabs={[{k:"1m",l:"1 Monat"},{k:"3m",l:"3 Monate"},{k:"6m",l:"6 Monate"},{k:"12m",l:"12 Monate"}]} active={h} onChange={setH}/>
    <div style={{marginTop:16,display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:20}}>
      <KPI title="Kontostand aktuell" value={fmt(487320)} sub="Alle Konten" icon="◈" accent="var(--acc)"/>
      <KPI title="Bereinigter Stand" value={fmt(398120)} sub="- Verbindlichkeiten" icon="◇" accent="var(--ylw)"/>
      <KPI title="Geld unterwegs" value={fmt(134500)} sub="Ausstehende Auszahlungen" icon="↗" accent="var(--grn)"/>
      <KPI title="Liquiditätsampel" value="Gelb" sub="7T: 462k | 14T: 432k" icon="●" accent="var(--ylw)"/>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"1fr 300px",gap:14}}>
      <Card>
        <div style={{fontSize:13,fontWeight:600,marginBottom:16,color:"var(--t1)"}}>Cashflow Forecast</div>
        <div style={{display:"flex",alignItems:"flex-end",gap:8,height:160,marginBottom:8}}>
          {cf.map((c,i)=>{const adj=c.s*(1+sc/100);return<div key={c.m} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
            <span style={{fontSize:9,color:"var(--t3)",fontFamily:"'JetBrains Mono',monospace"}}>{Math.round(adj)}k</span>
            <div style={{width:"100%",height:`${(adj/mx/(1+Math.abs(sc)/100))*100}%`,background:`linear-gradient(180deg,var(--acc),${sc>0?"var(--grn)":sc<0?"var(--red)":"var(--acc)"})`,borderRadius:"4px 4px 0 0",minHeight:8,opacity:.5+(.5*i/cf.length),transition:"all .3s"}}/>
          </div>;})}
        </div>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:10,color:"var(--t3)",marginBottom:16}}>{cf.map(c=><span key={c.m}>{c.m}</span>)}</div>
        <div style={{padding:"12px 0",borderTop:"1px solid var(--brd)"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
            <span style={{fontSize:12,color:"var(--t2)"}}>Szenario</span>
            <span style={{fontSize:13,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:sc>0?"var(--grn)":sc<0?"var(--red)":"var(--t1)"}}>{sc>0?"+":""}{sc}%</span>
          </div>
          <input type="range" min={-20} max={20} value={sc} onChange={e=>setSc(+e.target.value)} style={{width:"100%",accentColor:"var(--acc)"}}/>
        </div>
      </Card>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <Card>
          <div style={{fontSize:13,fontWeight:600,marginBottom:12,color:"var(--t1)"}}>Fälligkeiten (7 Tage)</div>
          {[{l:"Bestseller",v:-12500,d:"09.04."},{l:"Miete Lager",v:-4200,d:"10.04."},{l:"Zalando",v:45000,d:"11.04."},{l:"Gehälter",v:-28000,d:"14.04."},{l:"About You",v:22000,d:"14.04."}].map(f=>
            <div key={f.l} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid var(--brd)"}}>
              <div><div style={{fontSize:12,color:"var(--t1)"}}>{f.l}</div><div style={{fontSize:10,color:"var(--t3)"}}>{f.d}</div></div>
              <span style={{fontSize:12,fontWeight:600,fontFamily:"'JetBrains Mono',monospace",color:f.v>0?"var(--grn)":"var(--red)"}}>{f.v>0?"+":""}{fmt(f.v)}</span>
            </div>
          )}
        </Card>
        <Card>
          <div style={{fontSize:13,fontWeight:600,marginBottom:12,color:"var(--t1)"}}>Working Capital</div>
          {[["Kapitalbindung",fmt(285000)],["Ø EK→Auszahlung","47 Tage"],["Ø Zalando","21 Tage"],["Ø About You","18 Tage"]].map(([l,v])=>
            <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"4px 0"}}><span style={{fontSize:11,color:"var(--t2)"}}>{l}</span><span style={{fontSize:12,fontWeight:600,color:"var(--t1)"}}>{v}</span></div>
          )}
        </Card>
      </div>
    </div>
  </>;
};

/* ─── Panda Upload ─── */
const PandaUpload=()=>{
  const [status,setStatus]=useState(null);
  const [loading,setLoading]=useState(false);
  const fileRef=useRef(null);
  const triggerImport=()=>{
    setLoading(true);setStatus(null);
    fetch("/api/import",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({file:"/app/data/panda-export.csv",drop:true})})
      .then(r=>r.json()).then(d=>{setStatus({ok:true,msg:"Import gestartet! Dieser Vorgang dauert mehrere Minuten."});setLoading(false);})
      .catch(e=>{setStatus({ok:false,msg:"Fehler: "+e.message});setLoading(false);});
  };
  return <>
    <Card style={{marginBottom:14}}>
      <div style={{fontSize:14,fontWeight:600,color:"var(--t1)",marginBottom:4}}>Tradebyte Panda CSV Upload</div>
      <div style={{fontSize:12,color:"var(--t2)",marginBottom:20}}>Exportiere aus Tradebyte: <strong>Artikel → Gesamtexport → CSV</strong> und lege die Datei hier ab.</div>
      <div style={{border:"2px dashed var(--brd)",borderRadius:10,padding:"36px 24px",textAlign:"center",background:"var(--s2)",marginBottom:16}}>
        <div style={{fontSize:28,marginBottom:10,opacity:.4}}>📂</div>
        <div style={{fontSize:13,fontWeight:500,color:"var(--t1)",marginBottom:6}}>Panda Export CSV ablegen</div>
        <div style={{fontSize:11,color:"var(--t3)",marginBottom:16}}>Format: <code style={{background:"var(--s3)",padding:"1px 5px",borderRadius:3}}>panda-export.csv</code> · Semikolon-getrennt · UTF-8</div>
        <Btn primary onClick={triggerImport} disabled={loading}>{loading?"Wird importiert…":"Import starten"}</Btn>
      </div>
      {status&&<div style={{padding:"10px 14px",borderRadius:7,background:status.ok?"var(--grn2)":"var(--red2)",color:status.ok?"var(--grn)":"var(--red)",fontSize:12}}>{status.msg}</div>}
    </Card>
    <Card>
      <div style={{fontSize:13,fontWeight:600,color:"var(--t1)",marginBottom:12}}>Import-Hinweise</div>
      {[["Dateiformat","CSV, Semikolon-getrennt, UTF-8 oder latin1"],["Erwartete Felder","p_nr, p_brand, a_nr, a_ean, a_vk[zafd], etc."],["Erstelldatum","Wird aus dem Panda-Feld _pandaCreatedAt extrahiert, falls vorhanden"],["Duplikate","Vorhandene Artikel werden per upsert überschrieben"],["Dauer","ca. 5–15 Minuten für 160.000+ Varianten"]].map(([k,v])=>
        <div key={k} style={{display:"flex",gap:12,padding:"7px 0",borderBottom:"1px solid var(--brd)",fontSize:12}}>
          <span style={{color:"var(--t3)",width:120,flexShrink:0}}>{k}</span>
          <span style={{color:"var(--t1)"}}>{v}</span>
        </div>
      )}
    </Card>
  </>;
};

/* ─── Panda Ansicht (Tradebyte) ─── */
const PandaAnsicht=()=>{
  const [products,setProducts]=useState([]);
  const [search,setSearch]=useState("");
  const [page,setPage]=useState(1);
  const [total,setTotal]=useState(0);
  const [sort,setSort]=useState("newest");
  const [selectedPnr,setSelectedPnr]=useState(null);
  const [filters,setFilters]=useState({...EMPTY_FILTERS});
  const [filterOpts,setFilterOpts]=useState({});
  useEffect(()=>{fetch("/api/products/filters").then(r=>r.json()).then(setFilterOpts).catch(()=>{});},[]);
  useEffect(()=>{
    const p=new URLSearchParams({page,limit:25,search,sort,...Object.fromEntries(Object.entries(filters).filter(([,v])=>v))});
    fetch(`/api/products?${p}`).then(r=>r.json()).then(d=>{setProducts(d.items||[]);setTotal(d.total||0);}).catch(()=>{});
  },[page,search,sort,filters]);
  const setF=f=>{setFilters(f);setPage(1);};

  return <>
    {selectedPnr&&<ArtikelDetailModal pnr={selectedPnr} onClose={()=>setSelectedPnr(null)}/>}
    <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:12,flexWrap:"wrap"}}>
      <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}} placeholder="Suchen nach P-Nr, Marke, Name…" style={{flex:1,minWidth:200,padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
      <select value={sort} onChange={e=>setSort(e.target.value)} style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
        <option value="newest">Neueste zuerst</option><option value="oldest">Älteste zuerst</option>
        <option value="brand">Marke A–Z</option><option value="name">Name A–Z</option>
      </select>
      <span style={{fontSize:11,color:"var(--t3)"}}>{fmtN(total)} Produkte</span>
    </div>
    <FilterBar filters={filters} onChange={setF} options={filterOpts}/>
    <Card>
      <div style={{display:"grid",gridTemplateColumns:"130px 100px 1fr 65px 55px 45px 50px 110px 105px",padding:"0 0 8px",borderBottom:"1px solid var(--brd)",fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:8}}>
        <span>P-Nr</span><span>Marke</span><span>Name</span><span>Gender</span><span>Saison</span><span>GPSR</span><span>Jahr</span><span>Marktplätze</span><span>Import</span>
      </div>
      {products.length>0?products.map(p=><div key={p.p_nr||p._id}
        onClick={()=>setSelectedPnr(p.p_nr)}
        style={{display:"grid",gridTemplateColumns:"130px 100px 1fr 65px 55px 45px 50px 110px 105px",padding:"9px 0",borderBottom:"1px solid var(--brd)",fontSize:12,cursor:"pointer",gap:8,transition:"background .1s"}}
        onMouseEnter={e=>e.currentTarget.style.background="var(--s2)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
        <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--acc)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.p_nr}</span>
        <span style={{fontWeight:500,color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.base?.brand||"–"}</span>
        <span style={{color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.base?.name_proper||p.base?.name_keyword||"–"}</span>
        <span style={{color:"var(--t2)",fontSize:11}}>{p.tags?.gender||"–"}</span>
        <span style={{color:"var(--t2)",fontSize:11}}>{p.tags?.season||"–"}</span>
        <span>{p.hersteller?.name?<span style={{color:"var(--grn)",fontSize:11}}>✓</span>:<span style={{color:"var(--t3)",fontSize:11}}>–</span>}</span>
        <span style={{color:"var(--purple)",fontSize:11,fontWeight:600}}>{extractJahr(p.p_nr)||"–"}</span>
        <AmpelDots markets={p._activeMarkets||[]}/>
        <span style={{color:"var(--t3)",fontSize:10,fontFamily:"'JetBrains Mono',monospace"}}>{fmtDate(p._importedAt)}</span>
      </div>):<EmptyState icon="◧" title="Keine Artikel gefunden" sub="Starte einen Panda-Import oder ändere den Suchbegriff"/>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:12}}>
        <span style={{fontSize:11,color:"var(--t3)"}}>{fmtN(total)} Produkte · Seite {page} von {Math.max(1,Math.ceil(total/25))}</span>
        <div style={{display:"flex",gap:6}}>
          <Btn small onClick={()=>setPage(Math.max(1,page-1))} disabled={page<=1}>← Zurück</Btn>
          <Btn small onClick={()=>setPage(page+1)} disabled={page>=Math.ceil(total/25)}>Weiter →</Btn>
        </div>
      </div>
    </Card>
  </>;
};

/* ─── Manuelle ODS Upload ─── */
const ODSUpload=()=><Card>
  <div style={{fontSize:14,fontWeight:600,color:"var(--t1)",marginBottom:4}}>Manuelle ODS-Datei hochladen</div>
  <div style={{fontSize:12,color:"var(--t2)",marginBottom:20}}>Lade die Panda_neu.ods (Mitarbeiter-Ansicht) hoch um Pflichtfeld-Werte und Kategorie-Strukturen zu aktualisieren.</div>
  <div style={{border:"2px dashed var(--brd)",borderRadius:10,padding:"36px 24px",textAlign:"center",background:"var(--s2)"}}>
    <div style={{fontSize:28,marginBottom:10,opacity:.4}}>📋</div>
    <div style={{fontSize:13,fontWeight:500,color:"var(--t1)",marginBottom:6}}>Panda_neu.ods ablegen</div>
    <div style={{fontSize:11,color:"var(--t3)",marginBottom:16}}>Format: OpenDocument Spreadsheet · Sheet "♦ Panda ♦"</div>
    <Btn primary>ODS-Import starten</Btn>
  </div>
</Card>;

/* ─── Artikelansicht (Manuelle Verwaltung) ─── */
const ManuelleArtikelansicht=()=>{
  const [articles,setArticles]=useState([]);
  const [page,setPage]=useState(1);
  const [total,setTotal]=useState(0);
  const [selectedPnr,setSelectedPnr]=useState(null);
  useEffect(()=>{
    fetch(`/api/articles?page=${page}&limit=30`).then(r=>r.json()).then(d=>{setArticles(d.items||[]);setTotal(d.total||0);}).catch(()=>{});
  },[page]);
  return <>
    {selectedPnr&&<ArtikelDetailModal pnr={selectedPnr} onClose={()=>setSelectedPnr(null)}/>}
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
      <span style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>Varianten-Übersicht</span>
      <span style={{fontSize:11,color:"var(--t3)"}}>{fmtN(total)} Varianten gesamt · Klick auf Zeile öffnet Produkt-Detail</span>
    </div>
    <Card>
      <div style={{display:"grid",gridTemplateColumns:"130px 130px 130px 80px 70px 70px 70px 70px",padding:"0 0 8px",borderBottom:"1px solid var(--brd)",fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:8}}>
        <span>A-Nr</span><span>P-Nr</span><span>EAN</span><span>Farbe</span><span>Größe</span><span>Gewicht</span><span>Bestand</span><span>Land</span>
      </div>
      {articles.map(a=><div key={a.a_nr||a._id}
        onClick={()=>setSelectedPnr(a.p_nr)}
        style={{display:"grid",gridTemplateColumns:"130px 130px 130px 80px 70px 70px 70px 70px",padding:"8px 0",borderBottom:"1px solid var(--brd)",fontSize:11,gap:8,cursor:"pointer"}}
        onMouseEnter={e=>e.currentTarget.style.background="var(--s2)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
        <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--acc)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.a_nr}</span>
        <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t2)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.p_nr}</span>
        <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t3)"}}>{a.ean||"–"}</span>
        <span style={{color:"var(--t1)"}}>{a.components?.color||"–"}</span>
        <span style={{color:"var(--t1)"}}>{a.components?.size||"–"}</span>
        <span style={{color:"var(--t2)"}}>{a.logistics?.weight||"–"}</span>
        <span style={{color:"var(--t2)"}}>{a.stock?.standard||"0"}</span>
        <span style={{color:"var(--t2)"}}>{a.logistics?.org_country||"–"}</span>
      </div>)}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:12}}>
        <span style={{fontSize:11,color:"var(--t3)"}}>{fmtN(total)} Varianten · Seite {page}</span>
        <div style={{display:"flex",gap:6}}>
          <Btn small onClick={()=>setPage(Math.max(1,page-1))} disabled={page<=1}>← Zurück</Btn>
          <Btn small onClick={()=>setPage(page+1)} disabled={page>=Math.ceil(total/30)}>Weiter →</Btn>
        </div>
      </div>
    </Card>
  </>;
};

/* ─── JTL Artikelansicht ─── */
const JTLArtikelansicht=()=>{
  const [products,setProducts]=useState([]);
  const [search,setSearch]=useState("");
  const [page,setPage]=useState(1);
  const [total,setTotal]=useState(0);
  const [filters,setFilters]=useState({...EMPTY_FILTERS});
  const [filterOpts,setFilterOpts]=useState({});
  const [selectedPnr,setSelectedPnr]=useState(null);
  useEffect(()=>{fetch("/api/products/filters").then(r=>r.json()).then(setFilterOpts).catch(()=>{});},[]);
  useEffect(()=>{
    const p=new URLSearchParams({page,limit:25,search,...Object.fromEntries(Object.entries(filters).filter(([,v])=>v))});
    fetch(`/api/products?${p}`).then(r=>r.json()).then(d=>{setProducts(d.items||[]);setTotal(d.total||0);}).catch(()=>{});
  },[page,search,filters]);
  const setF=f=>{setFilters(f);setPage(1);};
  return <>
    {selectedPnr&&<ArtikelDetailModal pnr={selectedPnr} onClose={()=>setSelectedPnr(null)}/>}
    <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:12,flexWrap:"wrap"}}>
      <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}} placeholder="Suchen…" style={{flex:1,minWidth:160,padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
      <span style={{fontSize:11,color:"var(--t3)"}}>{fmtN(total)} Produkte</span>
    </div>
    <FilterBar filters={filters} onChange={setF} options={filterOpts}/>
    <Card>
      <div style={{display:"grid",gridTemplateColumns:"130px 100px 1fr 65px 55px 45px 50px 110px 105px",padding:"0 0 8px",borderBottom:"1px solid var(--brd)",fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:8}}>
        <span>P-Nr</span><span>Marke</span><span>Name</span><span>Gender</span><span>Saison</span><span>GPSR</span><span>Jahr</span><span>Marktplätze</span><span>Import</span>
      </div>
      {products.map(p=><div key={p.p_nr||p._id}
        onClick={()=>setSelectedPnr(p.p_nr)}
        style={{display:"grid",gridTemplateColumns:"130px 100px 1fr 65px 55px 45px 50px 110px 105px",padding:"9px 0",borderBottom:"1px solid var(--brd)",fontSize:11,cursor:"pointer",gap:8}}
        onMouseEnter={e=>e.currentTarget.style.background="var(--s2)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
        <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--acc)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.p_nr}</span>
        <span style={{fontWeight:500,color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.base?.brand||"–"}</span>
        <span style={{color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.base?.name_proper||p.base?.name_keyword||"–"}</span>
        <span style={{color:"var(--t2)",fontSize:10}}>{p.tags?.gender||"–"}</span>
        <span style={{color:"var(--t2)",fontSize:10}}>{p.tags?.season||"–"}</span>
        <span>{p.hersteller?.name?<span style={{color:"var(--grn)"}}>✓</span>:<span style={{color:"var(--red)"}}>✗</span>}</span>
        <span style={{color:"var(--purple)",fontSize:11,fontWeight:600}}>{extractJahr(p.p_nr)||"–"}</span>
        <AmpelDots markets={p._activeMarkets||[]}/>
        <span style={{color:"var(--t3)",fontSize:10,fontFamily:"'JetBrains Mono',monospace"}}>{fmtDate(p._importedAt)}</span>
      </div>)}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:12}}>
        <span style={{fontSize:11,color:"var(--t3)"}}>{fmtN(total)} Produkte · Seite {page}</span>
        <div style={{display:"flex",gap:6}}>
          <Btn small onClick={()=>setPage(Math.max(1,page-1))} disabled={page<=1}>← Zurück</Btn>
          <Btn small onClick={()=>setPage(page+1)} disabled={page>=Math.ceil(total/25)}>Weiter →</Btn>
        </div>
      </div>
    </Card>
  </>;
};

/* ─── Modal ─── */
const Modal=({open,onClose,title,children,width=520})=>{
  useEffect(()=>{
    if(!open)return;
    const esc=e=>{if(e.key==="Escape")onClose();};
    document.addEventListener("keydown",esc);
    return()=>document.removeEventListener("keydown",esc);
  },[open,onClose]);
  if(!open)return null;
  return<div style={{position:"fixed",inset:0,zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center"}}>
    <div onClick={onClose} style={{position:"absolute",inset:0,background:"rgba(0,0,0,.55)",backdropFilter:"blur(3px)"}}/>
    <div style={{position:"relative",width,maxWidth:"90vw",maxHeight:"85vh",background:"var(--s1)",borderRadius:14,border:"1px solid var(--brd)",display:"flex",flexDirection:"column",boxShadow:"0 24px 64px rgba(0,0,0,.4)"}}>
      <div style={{padding:"18px 20px 14px",borderBottom:"1px solid var(--brd)",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
        <div style={{fontSize:14,fontWeight:600,color:"var(--t1)"}}>{title}</div>
        <button onClick={onClose} style={{width:28,height:28,borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t2)",cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"inherit"}}>✕</button>
      </div>
      <div style={{padding:"16px 20px",overflow:"auto",flex:1}}>{children}</div>
    </div>
  </div>;
};

/* ─── Artikel Detail Modal ─── */
const ArtikelDetailModal=({pnr,onClose})=>{
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const [tab,setTab]=useState("daten");

  useEffect(()=>{
    setLoading(true);setData(null);
    fetch(`/api/products/${encodeURIComponent(pnr)}`)
      .then(r=>r.json()).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false));
  },[pnr]);

  const flatten=(obj,prefix="")=>{
    const out=[];
    for(const [k,v] of Object.entries(obj||{})){
      if(v===null||v===undefined||v==="")continue;
      if(k==="_id"||k==="__v")continue;
      const key=prefix?`${prefix}.${k}`:k;
      if(Array.isArray(v)){if(v.length>0)out.push([key,v.join(" · ")]);}
      else if(typeof v==="object"&&!(v instanceof Date)){out.push(...flatten(v,key));}
      else{out.push([key,String(v)]);}
    }
    return out;
  };

  const p=data?.product||{};
  const variants=data?.variants||[];
  const SECTIONS=["base","tags","hersteller","components","descriptions","cluster","active","prices_vk"];
  const sectionLabel={base:"Basis",tags:"Tags / Klassifikation",hersteller:"Hersteller (GPSR)",components:"Komponenten / Material",descriptions:"Beschreibungen",cluster:"Cluster / Kategorie",active:"Kanalaktivierung",prices_vk:"Preise VK"};

  const title=`${p.p_nr||"…"} · ${p.base?.brand||""} – ${p.base?.name_proper||p.base?.name_keyword||""}`;

  return<Modal open={true} onClose={onClose} title={title} width={820}>
    {loading?<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade Artikeldaten…</div>:
    !data?<div style={{padding:40,textAlign:"center",color:"var(--red)"}}>Fehler beim Laden</div>:<>
      <div style={{marginBottom:14,display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
        <Tabs tabs={[{k:"daten",l:"Produktdaten"},{k:"varianten",l:`Varianten (${variants.length})`},{k:"preise",l:"Preise"}]} active={tab} onChange={setTab}/>
        <div style={{fontSize:10,color:"var(--t3)",marginLeft:"auto"}}>
          Importiert: {fmtDT(p._importedAt)} · Erstellt: {fmtDT(p._pandaCreatedAt||p._importedAt)}
        </div>
      </div>

      {tab==="daten"&&<div>
        {SECTIONS.map(sec=>{
          const raw=p[sec];
          if(!raw)return null;
          const fields=flatten(typeof raw==="object"&&!Array.isArray(raw)?raw:{[sec]:raw},sec);
          if(!fields.length)return null;
          return<div key={sec} style={{marginBottom:14}}>
            <div style={{fontSize:9,fontWeight:700,color:"var(--t3)",textTransform:"uppercase",letterSpacing:"1.2px",marginBottom:6,padding:"4px 0",borderBottom:"2px solid var(--brd)"}}>{sectionLabel[sec]||sec}</div>
            {fields.map(([k,v])=><div key={k} style={{display:"flex",gap:8,padding:"4px 0",borderBottom:"1px solid rgba(255,255,255,.04)"}}>
              <code style={{color:"var(--t3)",width:190,flexShrink:0,fontSize:10,fontFamily:"'JetBrains Mono',monospace",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{k}</code>
              <span style={{color:"var(--t1)",fontSize:12,wordBreak:"break-word",flex:1,maxHeight:48,overflow:"hidden"}}>{v}</span>
            </div>)}
          </div>;
        })}
        {/* Meta */}
        <div style={{marginTop:8,padding:"8px 0",borderTop:"1px solid var(--brd)",display:"flex",gap:20,fontSize:10,color:"var(--t3)"}}>
          <span>_importedAt: {fmtDT(p._importedAt)}</span>
          <span>_pandaCreatedAt: {fmtDT(p._pandaCreatedAt)}</span>
        </div>
      </div>}

      {tab==="varianten"&&<div style={{overflowX:"auto"}}>
        <div style={{display:"grid",gridTemplateColumns:"150px 120px 90px 90px 70px 70px 70px 70px",padding:"0 0 6px",borderBottom:"1px solid var(--brd)",fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:8,minWidth:700}}>
          <span>A-Nr</span><span>EAN</span><span>Farbe</span><span>Größe</span><span>Bestand</span><span>ZFS</span><span>Gewicht</span><span>Land</span>
        </div>
        {variants.map(a=><div key={a.a_nr||a._id} style={{display:"grid",gridTemplateColumns:"150px 120px 90px 90px 70px 70px 70px 70px",padding:"7px 0",borderBottom:"1px solid var(--brd)",fontSize:11,gap:8,minWidth:700}}>
          <code style={{fontSize:10,color:"var(--acc)",fontFamily:"'JetBrains Mono',monospace",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.a_nr}</code>
          <code style={{fontSize:10,color:"var(--t3)",fontFamily:"'JetBrains Mono',monospace"}}>{a.ean||"–"}</code>
          <span style={{color:"var(--t1)"}}>{a.components?.color||"–"}</span>
          <span style={{color:"var(--t1)"}}>{a.components?.size||"–"}</span>
          <span style={{color:"var(--t2)"}}>{a.stock?.standard||"0"}</span>
          <span style={{color:"var(--t2)"}}>{a.stock?.zfs||"0"}</span>
          <span style={{color:"var(--t2)"}}>{a.logistics?.weight||"–"}</span>
          <span style={{color:"var(--t2)"}}>{a.logistics?.org_country||"–"}</span>
        </div>)}
        {!variants.length&&<EmptyState icon="◧" title="Keine Varianten" sub="Zu diesem Produkt wurden keine Varianten gefunden"/>}
      </div>}

      {tab==="preise"&&<div>
        {variants.filter(a=>a.prices_vk&&Object.values(a.prices_vk).some(v=>v&&parseFloat(v)>0)).slice(0,30).map(a=>{
          const entries=Object.entries(a.prices_vk||{}).filter(([,v])=>v&&parseFloat(v)>0);
          return<div key={a.a_nr} style={{marginBottom:12,paddingBottom:12,borderBottom:"1px solid var(--brd)"}}>
            <div style={{fontSize:11,fontWeight:600,color:"var(--t2)",marginBottom:6}}>{a.a_nr} · {a.components?.color||"–"} / {a.components?.size||"–"}</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              {entries.map(([ch,v])=><div key={ch} style={{padding:"4px 10px",borderRadius:6,background:"var(--s2)",border:"1px solid var(--brd)"}}>
                <div style={{fontSize:9,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>{ch}</div>
                <div style={{fontSize:13,fontWeight:600,color:"var(--t1)",fontFamily:"'JetBrains Mono',monospace"}}>{parseFloat(v).toFixed(2)} €</div>
              </div>)}
            </div>
          </div>;
        })}
        {variants.every(a=>!a.prices_vk||Object.values(a.prices_vk||{}).every(v=>!v||parseFloat(v)===0))&&
          <EmptyState icon="€" title="Keine Preisdaten" sub="Preise nicht im Export enthalten"/>}
      </div>}
    </>}
  </Modal>;
};

/* ─── Pflichtfelder Modal ─── */
const PflichtfelderModal=({doc,onClose,onUpdate})=>{
  const [newVal,setNewVal]=useState("");
  const [saving,setSaving]=useState(false);
  const [deleting,setDeleting]=useState(null);
  const [error,setError]=useState(null);

  const addValue=async()=>{
    const v=newVal.trim();
    if(!v)return;
    setSaving(true);setError(null);
    try{
      const r=await fetch(`/api/pflichtfelder/${doc._id}/values`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({value:v})});
      const updated=await r.json();
      if(!r.ok)throw new Error(updated.error||"Fehler");
      setNewVal("");
      onUpdate(updated);
    }catch(e){setError(e.message);}
    setSaving(false);
  };

  const removeValue=async(val)=>{
    setDeleting(val);setError(null);
    try{
      const r=await fetch(`/api/pflichtfelder/${doc._id}/values`,{method:"DELETE",headers:{"Content-Type":"application/json"},body:JSON.stringify({value:val})});
      const updated=await r.json();
      if(!r.ok)throw new Error(updated.error||"Fehler");
      onUpdate(updated);
    }catch(e){setError(e.message);}
    setDeleting(null);
  };

  return<Modal open={true} onClose={onClose} title={`${doc.marketplace} · ${doc.field}`} width={500}>
    <div style={{marginBottom:12}}>
      <div style={{fontSize:11,color:"var(--t3)",marginBottom:6,textTransform:"uppercase",letterSpacing:".5px",fontWeight:600}}>
        {doc.label} · {doc.values?.length||0} Werte · Quelle: {doc.source==="ods"?"ODS Import":"Manuell"}
      </div>
    </div>

    {/* Existing values */}
    <div style={{display:"flex",flexWrap:"wrap",gap:7,marginBottom:20,minHeight:40}}>
      {doc.values?.length>0?doc.values.map(v=><div key={v} style={{display:"inline-flex",alignItems:"center",gap:5,padding:"4px 10px",borderRadius:6,background:"var(--acc2)",border:"1px solid rgba(99,102,241,.2)",fontSize:12,fontWeight:500,color:"var(--acc)"}}>
        <span>{v}</span>
        <button onClick={()=>removeValue(v)} disabled={deleting===v} style={{background:"none",border:"none",color:"var(--acc)",cursor:"pointer",padding:"0 0 0 2px",fontSize:13,lineHeight:1,opacity:deleting===v?.4:1,fontFamily:"inherit"}}>×</button>
      </div>):<span style={{fontSize:12,color:"var(--t3)"}}>Noch keine Werte definiert</span>}
    </div>

    {/* Add new value */}
    <div style={{borderTop:"1px solid var(--brd)",paddingTop:16}}>
      <div style={{fontSize:12,fontWeight:600,color:"var(--t1)",marginBottom:8}}>Wert hinzufügen</div>
      <div style={{display:"flex",gap:8}}>
        <input
          value={newVal}
          onChange={e=>setNewVal(e.target.value)}
          onKeyDown={e=>e.key==="Enter"&&addValue()}
          placeholder="Neuer Wert…"
          style={{flex:1,padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}
          autoFocus
        />
        <Btn primary onClick={addValue} disabled={saving||!newVal.trim()}>{saving?"…":"+ Hinzufügen"}</Btn>
      </div>
      {error&&<div style={{marginTop:8,fontSize:11,color:"var(--red)"}}>{error}</div>}
    </div>
  </Modal>;
};

/* ─── Pflichtfelder ─── */
const MP_COLORS={
  Zalando:"#ff6900", "About You":"#e91e63", Otto:"#ef4444",
  Amazon:"#f59e0b", Kaufland:"#10b981", Breuninger:"#6366f1",
};

const Pflichtfelder=()=>{
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const [activeMP,setActiveMP]=useState(null);
  const [modal,setModal]=useState(null); // doc object

  useEffect(()=>{
    fetch("/api/pflichtfelder").then(r=>r.json()).then(d=>{
      setData(d);
      setActiveMP(Object.keys(d)[0]||null);
      setLoading(false);
    }).catch(()=>setLoading(false));
  },[]);

  const handleUpdate=(updated)=>{
    setData(prev=>{
      const mp=updated.marketplace;
      return{...prev,[mp]:prev[mp].map(f=>f._id===updated._id?updated:f)};
    });
    setModal(updated); // keep modal open with fresh data
  };

  if(loading)return<div style={{padding:40,textAlign:"center",color:"var(--t3)",fontSize:13}}>Lade Pflichtfelder…</div>;
  if(!data||Object.keys(data).length===0)return<EmptyState icon="!" title="Keine Pflichtfelder" sub="Seed-Daten werden beim nächsten Seitenaufruf angelegt"/>;

  const marketplaces=Object.keys(data);

  return<>
    {modal&&<PflichtfelderModal doc={modal} onClose={()=>setModal(null)} onUpdate={handleUpdate}/>}

    {/* Marktplatz-Tabs */}
    <div style={{display:"flex",gap:6,marginBottom:20,flexWrap:"wrap"}}>
      {marketplaces.map(mp=><button key={mp} onClick={()=>setActiveMP(mp)}
        style={{padding:"7px 16px",borderRadius:8,border:`1px solid ${activeMP===mp?(MP_COLORS[mp]||"var(--acc)"):"var(--brd)"}`,background:activeMP===mp?(MP_COLORS[mp]||"var(--acc)")+"20":"var(--s2)",color:activeMP===mp?(MP_COLORS[mp]||"var(--acc)"):"var(--t2)",fontSize:12,fontWeight:activeMP===mp?600:400,cursor:"pointer",fontFamily:"inherit",transition:"all .15s"}}>
        {mp}
        <span style={{marginLeft:6,fontSize:10,opacity:.7}}>{data[mp].length}</span>
      </button>)}
    </div>

    {/* Felder des aktiven Marktplatzes */}
    {activeMP&&<div style={{display:"flex",flexDirection:"column",gap:10}}>
      {data[activeMP].map(doc=><div key={doc._id}
        style={{background:"var(--s1)",border:"1px solid var(--brd)",borderRadius:10,padding:"14px 16px",cursor:"pointer",transition:"border-color .15s,box-shadow .15s"}}
        onClick={()=>setModal(doc)}
        onMouseEnter={e=>{e.currentTarget.style.borderColor=MP_COLORS[activeMP]||"var(--acc)";e.currentTarget.style.boxShadow=`0 0 0 2px ${(MP_COLORS[activeMP]||"var(--acc)")}20`;}}
        onMouseLeave={e=>{e.currentTarget.style.borderColor="var(--brd)";e.currentTarget.style.boxShadow="none";}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:doc.values?.length>0?10:0}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <code style={{fontSize:12,fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)",background:"var(--acc2)",padding:"3px 8px",borderRadius:5}}>{doc.field}</code>
            <span style={{fontSize:12,color:"var(--t2)"}}>{doc.label}</span>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            {doc.values?.length>0&&<span style={{fontSize:10,color:"var(--t3)"}}>{doc.values.length} Werte</span>}
            <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:doc.source==="ods"?"var(--grn2)":"var(--acc2)",color:doc.source==="ods"?"var(--grn)":"var(--acc)",fontWeight:600}}>{doc.source==="ods"?"ODS":"Manuell"}</span>
            <span style={{fontSize:11,color:"var(--t3)"}}>▸ öffnen</span>
          </div>
        </div>
        {doc.values?.length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:5}}>
          {doc.values.slice(0,8).map(v=><span key={v} style={{fontSize:11,padding:"2px 8px",borderRadius:4,background:"var(--s2)",color:"var(--t2)",border:"1px solid var(--brd)"}}>{v}</span>)}
          {doc.values.length>8&&<span style={{fontSize:11,padding:"2px 8px",borderRadius:4,background:"var(--s2)",color:"var(--t3)"}}>+{doc.values.length-8} weitere</span>}
        </div>}
      </div>)}
    </div>}
  </>;
};

/* ─── Attributfelder ─── */
const MP_ATTR_DEF={
  Zalando:[
    {k:"zalando_a_comp[color]",l:"Farbe",panda:"a_comp[color]",typ:"Freitext",desc:"Farbe der Variante für Zalando. Pflichtfeld. Zulässige Werte aus Pflichtfelder-Liste (z.B. schwarz, weiß, grau). Wird im Tradebyte-CSV als a_comp[color] übergeben."},
    {k:"zalando_a_comp[size]",l:"Größe",panda:"a_comp[size]",typ:"Freitext",desc:"Größe der Variante für Zalando. Pflichtfeld. Zulässige Werte: XS, S, M, L, XL, XXL sowie numerische Konfektionsgrößen."},
    {k:"zalando_p_tag[gender]",l:"Geschlecht",panda:"p_tag[gender]",typ:"Freitext",desc:"Geschlecht des Produkts für Zalando. Pflichtfeld. Zulässige Werte: Damen, Herren, Unisex, Mädchen, Jungen, Baby Mädchen, Baby Jungen."},
    {k:"zalando_p_tag[age_group]",l:"Altersgruppe",panda:"p_tag[age_group]",typ:"Freitext",desc:"Altersgruppe für Zalando. Pflichtfeld. Zulässige Werte: adult, kids, baby."},
    {k:"zalando_p_tag[season]",l:"Saison",panda:"p_tag[season]",typ:"Freitext",desc:"Saison für Zalando. Pflichtfeld. Zulässige Werte: HW, SS, NOS, YR."},
    {k:"zalando_p_tag[size_grid]",l:"Größenraster",panda:"p_tag[size_grid]",typ:"Freitext",desc:"Zalando Größenraster-Code. Pflichtfeld. Steuert welche Größentabelle auf Zalando angezeigt wird."},
    {k:"zalando_a_org_country",l:"Herkunftsland",panda:"a_org_country",typ:"Freitext",desc:"Ursprungsland der Variante für Zalando (ISO 3166-1 alpha-2). Pflichtfeld. Z.B. DE, CN, TR, BD."},
    {k:"zalando_a_intrastat",l:"TARIC-Code",panda:"a_intrastat",typ:"Freitext",desc:"Zolltarifnummer (TARIC) für Zalando. Pflichtfeld. 8-stellig, z.B. 61091000."},
    {k:"zalando_p_comp[material]",l:"Material",panda:"p_comp[material]",typ:"Freitext",desc:"Materialzusammensetzung für Zalando. Pflichtfeld. Format: 100% Baumwolle oder gemischte Angaben."},
  ],
  "About You":[
    {k:"aboutyou_p_tag[gender]",l:"Geschlecht",panda:"p_tag[gender]",typ:"Freitext",desc:"Geschlecht für About You. Pflichtfeld. Zulässige Werte: Damen, Herren, Unisex, Kinder."},
    {k:"aboutyou_p_tag[season]",l:"Saison",panda:"p_tag[season]",typ:"Freitext",desc:"Saison für About You. Pflichtfeld. Zulässige Werte: HW, SS, NOS."},
    {k:"aboutyou_a_comp[color]",l:"Farbe",panda:"a_comp[color]",typ:"Freitext",desc:"Farbe der Variante für About You. Pflichtfeld."},
    {k:"aboutyou_a_comp[size]",l:"Größe",panda:"a_comp[size]",typ:"Freitext",desc:"Größe der Variante für About You. Pflichtfeld."},
  ],
  Otto:[
    {k:"otto_p_tag[gender]",l:"Geschlecht",panda:"p_tag[gender]",typ:"Freitext",desc:"Geschlecht für Otto. Pflichtfeld. Zulässige Werte: Damen, Herren, Unisex, Mädchen, Jungen."},
    {k:"otto_p_tag[season]",l:"Saison",panda:"p_tag[season]",typ:"Freitext",desc:"Saison für Otto. Pflichtfeld. Zulässige Werte: HW, SS, NOS, YR."},
    {k:"otto_a_comp[color]",l:"Farbe",panda:"a_comp[color]",typ:"Freitext",desc:"Farbe der Variante für Otto. Pflichtfeld."},
    {k:"otto_a_comp[size]",l:"Größe",panda:"a_comp[size]",typ:"Freitext",desc:"Größe der Variante für Otto. Pflichtfeld."},
  ],
  Amazon:[
    {k:"amazon_p_tag[gender]",l:"Geschlecht",panda:"p_tag[gender]",typ:"Freitext",desc:"Geschlecht für Amazon SP-API. Pflichtfeld. Zulässige Werte: female, male, unisex, girls, boys."},
    {k:"amazon_a_comp[color]",l:"Farbe",panda:"a_comp[color]",typ:"Freitext",desc:"Farbe der Variante für Amazon. Pflichtfeld. Englische Bezeichnung."},
    {k:"amazon_a_intrastat",l:"TARIC-Code",panda:"a_intrastat",typ:"Freitext",desc:"Zolltarifnummer für Amazon. Pflichtfeld. 8-stellig."},
  ],
  Kaufland:[
    {k:"kaufland_p_tag[gender]",l:"Geschlecht",panda:"p_tag[gender]",typ:"Freitext",desc:"Geschlecht für Kaufland. Pflichtfeld. Zulässige Werte: Damen, Herren, Unisex, Kinder."},
    {k:"kaufland_a_comp[color]",l:"Farbe",panda:"a_comp[color]",typ:"Freitext",desc:"Farbe der Variante für Kaufland. Pflichtfeld."},
    {k:"kaufland_a_comp[size]",l:"Größe",panda:"a_comp[size]",typ:"Freitext",desc:"Größe der Variante für Kaufland. Pflichtfeld."},
  ],
};

const Attributfelder=()=>{
  const [activeMP,setActiveMP]=useState("Zalando");
  const [syncing,setSyncing]=useState({});
  const [syncResult,setSyncResult]=useState({});
  const [detail,setDetail]=useState(null);

  const simulateJTLSync=async(attr)=>{
    setSyncing(s=>({...s,[attr.k]:true}));
    setSyncResult(r=>({...r,[attr.k]:null}));
    try{
      const resp=await fetch("/api/jtl/attribute",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({name:attr.k,description:attr.desc||attr.l||""})});
      const d=await resp.json();
      if(resp.ok) setSyncResult(r=>({...r,[attr.k]:{ok:true,msg:d.message||"In JTL angelegt"}}));
      else setSyncResult(r=>({...r,[attr.k]:{ok:false,msg:d.error||"Fehler"}}));
    }catch(e){
      setSyncResult(r=>({...r,[attr.k]:{ok:false,msg:"Verbindungsfehler"}}));
    }
    setSyncing(s=>({...s,[attr.k]:false}));
  };

  const syncAll=async()=>{
    const attrs=MP_ATTR_DEF[activeMP]||[];
    for(const a of attrs){await simulateJTLSync(a);}
  };

  const attrs=MP_ATTR_DEF[activeMP]||[];
  const MP_COLORS_A={Zalando:"#ff6900","About You":"#e91e63",Otto:"#ef4444",Amazon:"#f59e0b",Kaufland:"#10b981"};

  return<>
    {detail&&<Modal open={true} onClose={()=>setDetail(null)} title={`${detail.k} · Beschreibung`} width={560}>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        <div><div style={{fontSize:10,color:"var(--t3)",marginBottom:4,textTransform:"uppercase",letterSpacing:".5px"}}>JTL-Attributname</div>
          <code style={{fontSize:13,fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)",background:"var(--acc2)",padding:"6px 12px",borderRadius:6,display:"block"}}>{detail.k}</code></div>
        <div><div style={{fontSize:10,color:"var(--t3)",marginBottom:4,textTransform:"uppercase",letterSpacing:".5px"}}>Panda-Feldname</div>
          <code style={{fontSize:12,fontFamily:"'JetBrains Mono',monospace",color:"var(--purple)",background:"var(--s2)",padding:"5px 10px",borderRadius:6,display:"block"}}>{detail.panda}</code></div>
        <div><div style={{fontSize:10,color:"var(--t3)",marginBottom:4,textTransform:"uppercase",letterSpacing:".5px"}}>Beschreibungstext (wird in JTL hinterlegt)</div>
          <div style={{background:"var(--s2)",borderRadius:8,padding:"12px 14px",fontSize:12,color:"var(--t1)",lineHeight:1.6}}>{detail.desc}</div></div>
      </div>
    </Modal>}

    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
        {Object.keys(MP_ATTR_DEF).map(mp=><button key={mp} onClick={()=>setActiveMP(mp)}
          style={{padding:"7px 14px",borderRadius:8,border:`1px solid ${activeMP===mp?(MP_COLORS_A[mp]||"var(--acc)"):"var(--brd)"}`,background:activeMP===mp?(MP_COLORS_A[mp]||"var(--acc)")+"20":"var(--s2)",color:activeMP===mp?(MP_COLORS_A[mp]||"var(--acc)"):"var(--t2)",fontSize:12,fontWeight:activeMP===mp?600:400,cursor:"pointer",fontFamily:"inherit"}}>
          {mp} <span style={{opacity:.6,fontSize:10}}>{MP_ATTR_DEF[mp].length}</span>
        </button>)}
      </div>
      <Btn onClick={syncAll}>↑ Alle in JTL anlegen</Btn>
    </div>

    <Card>
      <div style={{display:"grid",gridTemplateColumns:"220px 90px 160px 1fr 110px 80px",padding:"0 0 8px",borderBottom:"1px solid var(--brd)",fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:10}}>
        <span>JTL-Attributname</span><span>Typ</span><span>Panda-Feld</span><span>Label</span><span>JTL-Status</span><span></span>
      </div>
      {attrs.map(a=><div key={a.k} style={{display:"grid",gridTemplateColumns:"220px 90px 160px 1fr 110px 80px",padding:"10px 0",borderBottom:"1px solid var(--brd)",fontSize:12,alignItems:"center",gap:10}}>
        <code style={{fontSize:10,fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.k}</code>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"var(--s2)",color:"var(--t3)",fontWeight:600}}>{a.typ}</span>
        <code style={{fontSize:10,fontFamily:"'JetBrains Mono',monospace",color:"var(--purple)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.panda}</code>
        <span style={{color:"var(--t2)"}}>{a.l}</span>
        <span title={syncResult[a.k]?.msg||""}>{syncResult[a.k]?.ok
          ?<span style={{fontSize:10,color:"var(--grn)",fontWeight:600}}>✓ In JTL</span>
          :syncResult[a.k]?.ok===false
            ?<span style={{fontSize:10,color:"var(--red)"}} title={syncResult[a.k]?.msg}>✗ {syncResult[a.k]?.msg?.slice(0,22)||"Fehler"}</span>
            :<span style={{fontSize:10,color:"var(--t3)"}}>– ausstehend</span>
        }</span>
        <div style={{display:"flex",gap:5}}>
          <Btn small onClick={()=>setDetail(a)}>Info</Btn>
          <Btn small onClick={()=>simulateJTLSync(a)} disabled={syncing[a.k]}>{syncing[a.k]?"…":"↑ JTL"}</Btn>
        </div>
      </div>)}
    </Card>
    <div style={{marginTop:12,padding:"10px 14px",borderRadius:8,background:"var(--s2)",border:"1px solid var(--brd)",fontSize:11,color:"var(--t3)"}}>
      <strong style={{color:"var(--t2)"}}>Hinweis:</strong> Der "↑ JTL" Button legt das Attribut über die JTL-Wawi REST API v2 an (Bereich: Artikel, Datentyp: Freitext). Die Zugangsdaten zur JTL-API müssen unter <em>Verwaltung → Schnittstellen → JTL-Wawi ERP</em> hinterlegt sein.
    </div>
  </>;
};

/* ─── Merkmale ─── */
const Merkmale=()=><Card>
  <div style={{fontSize:14,fontWeight:600,color:"var(--t1)",marginBottom:4}}>Merkmale (JTL Filterwerte)</div>
  <div style={{fontSize:12,color:"var(--t2)",marginBottom:20}}>Aus Attributen und Eingaben werden Filterwerte definiert, die als JTL-Merkmale nutzbar sind.</div>
  <EmptyState icon="◈" title="Merkmale" sub="JTL-Merkmal-Konfiguration – in Entwicklung"/>
</Card>;

/* ─── Artikelbildverwaltung ─── */
const Artikelbilder=()=><Card>
  <div style={{fontSize:14,fontWeight:600,color:"var(--t1)",marginBottom:4}}>Artikelbildverwaltung</div>
  <div style={{fontSize:12,color:"var(--t2)",marginBottom:20}}>Bilder aus Panda-CDN / Tradebyte verwalten und Marktplatz-Zuordnungen pflegen.</div>
  <EmptyState icon="🖼" title="Artikelbilder" sub="Bildverwaltung – in Entwicklung"/>
</Card>;

/* ─── Benutzerverwaltung ─── */
const Benutzerverwaltung=({currentUser})=>{
  const [users,setUsers]=useState([]);
  const [rollen,setRollen]=useState([]);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({name:"",email:"",rolleName:"Viewer",status:"aktiv",password:""});
  const [saving,setSaving]=useState(false);
  const [err,setErr]=useState("");
  const isAdmin=currentUser?.rolleName==="Admin";

  const load=()=>{
    fetch("/api/benutzer").then(r=>r.json()).then(d=>setUsers(Array.isArray(d)?d:[])).catch(()=>{});
    fetch("/api/rollen").then(r=>r.json()).then(d=>setRollen(Array.isArray(d)?d:[])).catch(()=>{});
  };
  useEffect(()=>{load();},[]);

  const openAdd=()=>{setForm({name:"",email:"",rolleName:rollen[0]?.name||"Viewer",status:"aktiv",password:""});setErr("");setModal("add");};
  const openEdit=u=>{setForm({name:u.name,email:u.email,rolleName:u.rolleName||"",status:u.status,password:""});setErr("");setModal(u);};

  const save=async()=>{
    setSaving(true); setErr("");
    const url=modal==="add"?"/api/benutzer":`/api/benutzer/${modal._id}`;
    const method=modal==="add"?"POST":"PUT";
    // Leeres Passwort bei Edit → Feld weglassen
    const payload={...form}; if(!payload.password) delete payload.password;
    const r=await fetch(url,{method,headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
    if(!r.ok){const j=await r.json().catch(()=>({}));setErr(j.message||"Fehler beim Speichern");setSaving(false);return;}
    setSaving(false);setModal(null);load();
  };

  const del=async(u)=>{
    if(!isAdmin) return;
    if(u._id===currentUser?._id){alert("Der eigene Account kann nicht gelöscht werden.");return;}
    if(!window.confirm(`Benutzer "${u.name}" wirklich löschen? Das kann nicht rückgängig gemacht werden.`)) return;
    const r=await fetch(`/api/benutzer/${u._id}`,{method:"DELETE"});
    if(!r.ok){const j=await r.json().catch(()=>({}));alert(j.message||"Fehler beim Löschen");return;}
    load();
  };

  const resetTwofa=async(u)=>{
    if(!isAdmin) return;
    if(!window.confirm(`2FA von "${u.name}" wirklich zurücksetzen?\n\nAlle offenen Sessions werden beendet und der Nutzer muss beim nächsten Login einen neuen Authenticator einrichten. Dieser Vorgang wird im Audit-Log protokolliert.`)) return;
    const r=await fetch(`/api/auth/2fa/admin-reset/${u._id}`,{method:"POST"});
    if(!r.ok){const j=await r.json().catch(()=>({}));alert(j.message||"Fehler beim Zurücksetzen");return;}
    alert(`2FA für "${u.name}" wurde zurückgesetzt.`);
    load();
  };

  const rc={};rollen.forEach(r=>{rc[r.name]=r.farbe||"#6366f1";});

  return<>
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:20}}>
      <KPI title="Benutzer gesamt" value={users.length} sub={`${users.filter(u=>u.status==="aktiv").length} aktiv`} icon="◉" accent="var(--acc)"/>
      <KPI title="Mit 2FA" value={users.filter(u=>u.twofa).length} sub={`${users.length?Math.round(users.filter(u=>u.twofa).length/users.length*100):0}% gesichert`} icon="🔒" accent="var(--grn)"/>
      <KPI title="Rollen" value={rollen.length} sub="Definiert" icon="◈" accent="var(--ylw)"/>
      <KPI title="Inaktiv" value={users.filter(u=>u.status==="inaktiv").length} sub="Benutzer" icon="◇"/>
    </div>
    <Card>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <span style={{fontSize:14,fontWeight:600,color:"var(--t1)"}}>Benutzer</span>
        <Btn primary onClick={openAdd}>+ Benutzer anlegen</Btn>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"20px 130px 180px 110px 36px 120px 120px 70px 54px 70px 36px",padding:"0 0 8px",borderBottom:"1px solid var(--brd)",fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:6}}>
        <span/><span>Name</span><span>E-Mail</span><span>Rolle</span><span>2FA</span><span>Angelegt</span><span>Letzter Login</span><span>Status</span><span/><span/><span/>
      </div>
      {users.map(u=><div key={u._id} style={{display:"grid",gridTemplateColumns:"20px 130px 180px 110px 36px 120px 120px 70px 54px 70px 36px",padding:"9px 0",borderBottom:"1px solid var(--brd)",fontSize:12,alignItems:"center",gap:6}}>
        <Dot s={u.status}/>
        <span style={{fontWeight:600,color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{u.name}</span>
        <span style={{color:"var(--t2)",fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{u.email}</span>
        <span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:(rc[u.rolleName]||"#6366f1")+"22",color:(rc[u.rolleName]||"#6366f1"),overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",display:"inline-block",maxWidth:108}}>{u.rolleName||"–"}</span>
        <span style={{textAlign:"center"}}>{u.twofa?<span style={{color:"var(--grn)"}}>✓</span>:<span style={{color:"var(--t3)"}}>–</span>}</span>
        <span style={{color:"var(--t2)",fontSize:11}}>{fmtDate(u.createdAt)}</span>
        <span style={{color:"var(--t2)",fontSize:11}}>{u.lastLoginAt?fmtDT(u.lastLoginAt):"–"}</span>
        <span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:u.status==="aktiv"?"var(--grn2)":"var(--s3)",color:u.status==="aktiv"?"var(--grn)":"var(--t3)",display:"inline-block"}}>{u.status}</span>
        <Btn small onClick={()=>openEdit(u)}>Edit</Btn>
        {isAdmin&&u.twofaEnabledAt?<button onClick={()=>resetTwofa(u)} title="2FA zurücksetzen (z.B. bei Handy-Verlust)" style={{background:"transparent",border:"1px solid var(--brd)",color:"var(--ylw)",borderRadius:5,cursor:"pointer",padding:"3px 6px",fontSize:10,fontFamily:"inherit",fontWeight:600}}>2FA ↺</button>:<span/>}
        {isAdmin&&u._id!==currentUser?._id?<button onClick={()=>del(u)} title="Benutzer löschen" style={{background:"transparent",border:"1px solid var(--brd)",color:"var(--red)",borderRadius:5,cursor:"pointer",padding:"3px 6px",fontSize:12,fontFamily:"inherit"}}>✕</button>:<span/>}
      </div>)}
      {!users.length&&<EmptyState icon="◉" title="Keine Benutzer" sub="Werden beim ersten API-Aufruf angelegt"/>}
    </Card>

    {modal&&<Modal open={true} onClose={()=>setModal(null)} title={modal==="add"?"Benutzer anlegen":`${modal.name} bearbeiten`} width={460}>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        {[{l:"Name",k:"name"},{l:"E-Mail",k:"email"}].map(f=><div key={f.k}>
          <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>{f.l}</label>
          <input value={form[f.k]} onChange={e=>setForm({...form,[f.k]:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/>
        </div>)}
        <div>
          <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Rolle</label>
          <select value={form.rolleName} onChange={e=>setForm({...form,rolleName:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",cursor:"pointer"}}>
            {rollen.map(r=><option key={r._id} value={r.name}>{r.name} – {r.beschreibung}</option>)}
          </select>
        </div>
        <div>
          <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Status</label>
          <select value={form.status} onChange={e=>setForm({...form,status:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",cursor:"pointer"}}>
            <option value="aktiv">Aktiv</option><option value="inaktiv">Inaktiv</option>
          </select>
        </div>
        <div>
          <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Passwort {modal==="add"?<span style={{color:"var(--red)"}}>*</span>:<span style={{color:"var(--t3)",fontWeight:400}}>(leer lassen = unverändert)</span>}</label>
          <input type="password" value={form.password||""} onChange={e=>setForm({...form,password:e.target.value})} autoComplete="new-password"
            placeholder={modal==="add"?"min. 6 Zeichen":"••••••••"}
            style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/>
        </div>
        {err&&<div style={{padding:"8px 12px",borderRadius:6,background:"var(--red2)",color:"var(--red)",fontSize:11}}>{err}</div>}
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}>
          <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
          <Btn primary onClick={save} disabled={saving||!form.name.trim()||!form.email.trim()||(modal==="add"&&(!form.password||form.password.length<6))}>{saving?"Speichere…":"Speichern"}</Btn>
        </div>
      </div>
    </Modal>}
  </>;
};

/* ─── Schnittstellenverwaltung ─── */
const Schnittstellenverwaltung=()=>{
  const [ifaces,setIfaces]=useState([]);
  const [tab,setTab]=useState("api");
  const [editId,setEditId]=useState(null);
  const [editData,setEditData]=useState(null);
  const [form,setForm]=useState({});
  const [logs,setLogs]=useState([]);
  const [testing,setTesting]=useState(false);
  const [testResult,setTestResult]=useState(null);
  const [saving,setSaving]=useState(false);

  const load=()=>fetch("/api/schnittstellen").then(r=>r.json()).then(d=>setIfaces(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);

  const openEdit=async iface=>{
    setEditId(iface._id);setTestResult(null);setLogs([]);
    const full=await fetch(`/api/schnittstellen/${iface._id}`).then(r=>r.json()).catch(()=>iface);
    setEditData(full);
    const creds={};(full.felder||[]).forEach(f=>{creds[f.k]=full.credentials?.[f.k]||"";});
    setForm(creds);
    fetch(`/api/schnittstellen/${iface._id}/logs`).then(r=>r.json()).then(d=>setLogs(Array.isArray(d)?d:[])).catch(()=>{});
  };
  const closeEdit=()=>{setEditId(null);setEditData(null);setForm({});setLogs([]);setTestResult(null);};

  const save=async()=>{
    setSaving(true);
    await fetch(`/api/schnittstellen/${editId}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({credentials:form})}).catch(()=>{});
    setSaving(false);load();closeEdit();
  };

  const test=async()=>{
    setTesting(true);setTestResult(null);
    const res=await fetch(`/api/schnittstellen/${editId}/test`,{method:"POST"}).then(r=>r.json()).catch(e=>({success:false,message:e.message}));
    setTestResult(res);setTesting(false);
    fetch(`/api/schnittstellen/${editId}/logs`).then(r=>r.json()).then(d=>setLogs(Array.isArray(d)?d:[])).catch(()=>{});
    load();
  };

  const apis=ifaces.filter(i=>!i.key?.startsWith("ebics"));
  const banken=ifaces.filter(i=>i.key?.startsWith("ebics"));
  const displayed=tab==="api"?apis:banken;

  return<>
    <div style={{marginBottom:16}}><Tabs tabs={[{k:"api",l:`Schnittstellen (${apis.length})`},{k:"bank",l:`Banken / EBICS (${banken.length})`}]} active={tab} onChange={setTab}/></div>

    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(210px,1fr))",gap:14}}>
      {displayed.map(iface=><Card key={iface._id} style={{cursor:"pointer",position:"relative",overflow:"hidden",transition:"border-color .15s,box-shadow .15s"}}
        onClick={()=>openEdit(iface)}
        onMouseEnter={e=>{e.currentTarget.style.borderColor=iface.color||"var(--acc)";e.currentTarget.style.boxShadow=`0 0 0 2px ${(iface.color||"var(--acc)")}22`;}}
        onMouseLeave={e=>{e.currentTarget.style.borderColor="var(--brd)";e.currentTarget.style.boxShadow="none";}}>
        <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:iface.status==="connected"?"var(--grn)":iface.status==="error"?"var(--red)":iface.status==="pending"?"var(--ylw)":"var(--t3)",borderRadius:"12px 12px 0 0"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10,marginTop:4}}>
          <div style={{width:34,height:34,borderRadius:8,background:(iface.color||"#6366f1")+"22",display:"flex",alignItems:"center",justifyContent:"center",fontSize:17,color:iface.color||"var(--t1)"}}>{iface.icon}</div>
          <Dot s={iface.status||"inactive"}/>
        </div>
        <div style={{fontSize:13,fontWeight:600,color:"var(--t1)",marginBottom:2}}>{iface.name}</div>
        <div style={{fontSize:10,color:"var(--t3)",marginBottom:6}}>{iface.typ}</div>
        <div style={{fontSize:10,color:"var(--t3)",lineHeight:1.4}}>{iface.beschreibung}</div>
        {iface.lastTestedAt&&<div style={{marginTop:8,fontSize:10,color:"var(--t3)",borderTop:"1px solid var(--brd)",paddingTop:6}}>Test: {fmtDate(iface.lastTestedAt)}</div>}
      </Card>)}
      {!displayed.length&&<div style={{gridColumn:"1/-1"}}><EmptyState icon="⚙" title="Keine Schnittstellen" sub="Werden beim ersten Aufruf angelegt"/></div>}
    </div>

    {editId&&editData&&<Modal open={true} onClose={closeEdit} title={`${editData.name} · Konfiguration`} width={680}>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <div style={{background:"var(--s2)",borderRadius:10,padding:"14px 16px"}}>
          <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:12}}>Zugangsdaten · {editData.typ}</div>
          {(editData.felder||[]).map(f=><div key={f.k} style={{marginBottom:10}}>
            <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>{f.l}{f.secret&&<span style={{marginLeft:6,fontSize:9,color:"var(--t3)",background:"var(--s3)",padding:"1px 5px",borderRadius:3}}>secret</span>}</label>
            <input type={f.t==="password"?"password":"text"} value={form[f.k]||""} onChange={e=>setForm({...form,[f.k]:e.target.value})}
              placeholder={f.secret?"Leer lassen um bestehenden Wert zu behalten":f.l}
              style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s1)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
          </div>)}
        </div>

        {testResult&&<div style={{padding:"10px 14px",borderRadius:7,background:testResult.success?"var(--grn2)":"var(--red2)",color:testResult.success?"var(--grn)":"var(--red)",fontSize:12}}>
          {testResult.success?"✓ ":"✗ "}{testResult.message}
        </div>}

        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <Btn onClick={closeEdit}>Abbrechen</Btn>
          <Btn onClick={test} disabled={testing}>{testing?"Teste Verbindung…":"Verbindung testen"}</Btn>
          <Btn primary onClick={save} disabled={saving}>{saving?"Speichere…":"Speichern"}</Btn>
        </div>

        <div style={{borderTop:"1px solid var(--brd)",paddingTop:12}}>
          <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:8}}>Aktivitätslog · letzte 30 Tage</div>
          {logs.length>0?<div style={{maxHeight:180,overflow:"auto",display:"flex",flexDirection:"column",gap:3}}>
            {logs.map((l,i)=><div key={i} style={{display:"flex",gap:10,alignItems:"center",padding:"5px 8px",borderRadius:6,background:"var(--s2)"}}>
              <Dot s={l.erfolg?"connected":"error"}/>
              <span style={{fontSize:10,color:"var(--t3)",fontFamily:"'JetBrains Mono',monospace",flexShrink:0,width:110}}>{fmtDT(l.zeitpunkt)}</span>
              <span style={{fontSize:10,color:"var(--t3)",flexShrink:0,width:90}}>{l.typ}</span>
              <span style={{fontSize:11,color:l.erfolg?"var(--grn)":"var(--red)",flex:1}}>{l.nachricht}</span>
            </div>)}
          </div>:<div style={{fontSize:11,color:"var(--t3)",padding:"8px 0"}}>Keine Einträge in den letzten 30 Tagen</div>}
        </div>
      </div>
    </Modal>}
  </>;
};

/* ─── Marktplatzverwaltung ─── */
const Marktplatzverwaltung=()=>{
  const [mps,setMps]=useState([]);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({provision:0,fixkosten:0,abrechnungszyklus:"monatlich",notizen:""});
  const [saving,setSaving]=useState(false);
  const load=()=>fetch("/api/marktplaetze").then(r=>r.json()).then(d=>setMps(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);
  const openEdit=mp=>{setForm({provision:mp.provision||0,fixkosten:mp.fixkosten||0,abrechnungszyklus:mp.abrechnungszyklus||"monatlich",auszahlungsintervall:mp.auszahlungsintervall||"monatlich",auszahlungsversatz:mp.auszahlungsversatz||0,retourenquote:mp.retourenquote||0,retourenfrist:mp.retourenfrist||30,retourenkosten:mp.retourenkosten||0,ruecksendeetikett:mp.ruecksendeetikett||"kundenverantwortung",notizen:mp.notizen||""});setModal(mp);};
  const save=async()=>{setSaving(true);await fetch(`/api/marktplaetze/${modal._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)}).catch(()=>{});setSaving(false);setModal(null);load();};
  const total=mps.reduce((s,m)=>s+(m.aktiveArtikel||0),0);
  return<>
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:20}}>
      <KPI title="Marktplätze" value={mps.length} sub={`${mps.filter(m=>m.aktiveArtikel>0).length} mit aktiven Artikeln`} icon="◎" accent="var(--acc)"/>
      <KPI title="Aktive Artikel" value={fmtN(total)} sub="Gesamt über alle Kanäle" icon="◧" accent="var(--grn)"/>
      <KPI title="Ø Provision" value={mps.length?`${(mps.reduce((s,m)=>s+(m.provision||0),0)/mps.length).toFixed(1)} %`:"–"} sub="Durchschnitt" icon="%" accent="var(--ylw)"/>
      <KPI title="Fixkosten/Monat" value={fmt(mps.reduce((s,m)=>s+(m.fixkosten||0),0))} sub="Summe Grundgebühren" icon="€" accent="var(--red)"/>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:14}}>
      {mps.map(mp=><Card key={mp._id} style={{position:"relative",overflow:"hidden",cursor:"pointer"}}
        onClick={()=>openEdit(mp)}
        onMouseEnter={e=>{e.currentTarget.style.borderColor=mp.color;e.currentTarget.style.boxShadow=`0 0 0 2px ${mp.color}22`;}}
        onMouseLeave={e=>{e.currentTarget.style.borderColor="var(--brd)";e.currentTarget.style.boxShadow="none";}}>
        <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:mp.color,borderRadius:"12px 12px 0 0"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,marginTop:4}}>
          <div style={{fontSize:18,color:mp.color}}>{mp.icon}</div>
          <span style={{fontSize:10,fontWeight:700,color:mp.aktiveArtikel>0?"var(--grn)":"var(--t3)",background:mp.aktiveArtikel>0?"var(--grn2)":"var(--s2)",padding:"2px 8px",borderRadius:4}}>{fmtN(mp.aktiveArtikel||0)} aktiv</span>
        </div>
        <div style={{fontSize:13,fontWeight:700,color:"var(--t1)",marginBottom:6}}>{mp.name}</div>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"var(--t2)",marginBottom:2}}><span>Provision</span><span style={{fontWeight:600,color:"var(--t1)"}}>{mp.provision} %</span></div>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"var(--t2)"}}><span>Fixkosten</span><span style={{fontWeight:600,color:mp.fixkosten>0?"var(--red)":"var(--t3)"}}>{mp.fixkosten>0?fmt(mp.fixkosten):"–"}</span></div>
      </Card>)}
    </div>
    {modal&&<Modal open={true} onClose={()=>setModal(null)} title={`${modal.name} · Gebühren`} width={560}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
        {[{l:"Verkaufsprovision (%)",k:"provision",t:"number"},{l:"Monatliche Fixkosten (€)",k:"fixkosten",t:"number"}].map(f=><div key={f.k}>
          <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>{f.l}</label>
          <input type={f.t} value={form[f.k]} onChange={e=>setForm({...form,[f.k]:parseFloat(e.target.value)||0})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/>
        </div>)}
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Abrechnungszyklus</label>
          <select value={form.abrechnungszyklus} onChange={e=>setForm({...form,abrechnungszyklus:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",cursor:"pointer"}}>
            <option value="monatlich">Monatlich</option><option value="wöchentlich">Wöchentlich</option><option value="pro Verkauf">Pro Verkauf</option>
          </select></div>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Auszahlungsintervall</label>
          <select value={form.auszahlungsintervall||"monatlich"} onChange={e=>setForm({...form,auszahlungsintervall:e.target.value})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
            <option value="woechentlich">Wöchentlich</option>
            <option value="14-taegig">14-tägig</option>
            <option value="monatlich">Monatlich</option>
          </select>
        </div>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Auszahlungsversatz (Tage)</label>
          <input type="number" value={form.auszahlungsversatz||0} onChange={e=>setForm({...form,auszahlungsversatz:parseInt(e.target.value)||0})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
        </div>
        <div style={{gridColumn:"1/-1"}}><div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:10,paddingTop:8,borderTop:"1px solid var(--brd)"}}>Retouren</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Retourenquote (%)</label><input type="number" step="0.1" value={form.retourenquote||0} onChange={e=>setForm({...form,retourenquote:parseFloat(e.target.value)||0})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/></div>
            <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Retourenfrist (Tage)</label><input type="number" value={form.retourenfrist||30} onChange={e=>setForm({...form,retourenfrist:parseInt(e.target.value)||30})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/></div>
            <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Retourenkosten (€)</label><input type="number" step="0.01" value={form.retourenkosten||0} onChange={e=>setForm({...form,retourenkosten:parseFloat(e.target.value)||0})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/></div>
            <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Rücksendeetikett</label>
              <select value={form.ruecksendeetikett||"kundenverantwortung"} onChange={e=>setForm({...form,ruecksendeetikett:e.target.value})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
                <option value="kostenlos">Kostenlos</option>
                <option value="kostenpflichtig">Kostenpflichtig</option>
                <option value="kundenverantwortung">Kundenverantwortung</option>
              </select>
            </div>
          </div>
        </div>
        <div style={{gridColumn:"1/-1"}}><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Notizen</label>
          <textarea value={form.notizen} onChange={e=>setForm({...form,notizen:e.target.value})} rows={3} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",resize:"vertical"}}/></div>
        <div style={{gridColumn:"1/-1",display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}><Btn onClick={()=>setModal(null)}>Abbrechen</Btn><Btn primary onClick={save} disabled={saving}>{saving?"Speichere…":"Speichern"}</Btn></div>
      </div>
    </Modal>}
  </>;
};

/* ─── Lager: Views ─── */
const fmtLagerNum=(n)=>Number(n||0).toLocaleString("de-DE");

const LagerSummaryCards=({summary,lagerwertSummary})=>{
  const byBucket=summary?.byBucket||[];
  const map=Object.fromEntries(byBucket.map(b=>[b.bucket,b]));
  const card=(label,key,accent)=>{
    const d=map[key]||{menge:0,artikelCount:0};
    return<div style={{flex:1,background:"var(--b2)",border:"1px solid var(--br)",borderRadius:8,padding:16}}>
      <div style={{fontSize:11,color:"var(--t3)",textTransform:"uppercase",letterSpacing:.5}}>{label}</div>
      <div style={{fontSize:22,fontWeight:700,color:accent||"var(--t1)",marginTop:4}}>{fmtLagerNum(d.menge)} Stk</div>
      <div style={{fontSize:11,color:"var(--t3)"}}>{fmtLagerNum(d.artikelCount)} Artikel</div>
    </div>;
  };
  const zfs=summary?.zfs||{menge:0,artikelCount:0};
  const lw=lagerwertSummary||{};
  const fmtEur=(n)=>(n||0).toLocaleString("de-DE",{minimumFractionDigits:0,maximumFractionDigits:0})+" €";
  return<>
    <div style={{display:"flex",gap:12,marginBottom:12}}>
      {card("Ehrenfriedersdorf","ehrenfriedersdorf")}
      {card("Zalando (JTL-Sicht)","zalando","#ff6a00")}
      <div style={{flex:1,background:"var(--b2)",border:"1px solid var(--br)",borderRadius:8,padding:16}}>
        <div style={{fontSize:11,color:"var(--t3)",textTransform:"uppercase",letterSpacing:.5}}>Zalando ZFS (authoritativ)</div>
        <div style={{fontSize:22,fontWeight:700,color:"#ff6a00",marginTop:4}}>{fmtLagerNum(zfs.menge)} Stk</div>
        <div style={{fontSize:11,color:"var(--t3)"}}>{fmtLagerNum(zfs.artikelCount)} Artikel · aus xlsx</div>
      </div>
      {card("About You","aboutyou","#f65")}
    </div>
    <div style={{display:"flex",gap:12,marginBottom:16}}>
      <div style={{flex:2,background:"linear-gradient(135deg, var(--b2), var(--b3))",border:"1px solid var(--br)",borderRadius:8,padding:16}}>
        <div style={{fontSize:11,color:"var(--t3)",textTransform:"uppercase",letterSpacing:.5}}>Gesamt-Lagerwert (EK-Netto)</div>
        <div style={{fontSize:28,fontWeight:700,color:"#16a34a",marginTop:4}}>{fmtEur(lw.lagerwert)}</div>
        <div style={{fontSize:11,color:"var(--t3)"}}>
          {fmtLagerNum(lw.lagerwertArtikel||0)} / {fmtLagerNum(lw.artikel||0)} Artikel mit EK
        </div>
      </div>
      <div style={{flex:1,background:"var(--b2)",border:"1px solid var(--br)",borderRadius:8,padding:16,display:"flex",flexDirection:"column",justifyContent:"center"}}>
        <div style={{fontSize:11,color:"var(--t3)",textTransform:"uppercase",letterSpacing:.5}}>EK-Abdeckung</div>
        <div style={{fontSize:28,fontWeight:700,color:(lw.lagerwertAbdeckung||0)>=80?"#16a34a":(lw.lagerwertAbdeckung||0)>=50?"#f59e0b":"#ef4444",marginTop:4}}>
          {lw.lagerwertAbdeckung!=null?`${lw.lagerwertAbdeckung}%`:"–"}
        </div>
        <div style={{fontSize:11,color:"var(--t3)"}}>
          der Artikel haben einen hinterlegten EK
        </div>
        {lw.lagerwertAbdeckung!=null&&<div style={{marginTop:8,height:6,background:"var(--s2)",borderRadius:3,overflow:"hidden"}}>
          <div style={{width:`${Math.min(100,lw.lagerwertAbdeckung)}%`,height:"100%",background:(lw.lagerwertAbdeckung||0)>=80?"#16a34a":(lw.lagerwertAbdeckung||0)>=50?"#f59e0b":"#ef4444",transition:"width .3s"}}/>
        </div>}
      </div>
    </div>
  </>;
};

const LagerImportPanel=({onRefresh})=>{
  const [busy,setBusy]=useState(false);
  const [msg,setMsg]=useState("");
  const scan=async()=>{
    setBusy(true);setMsg("");
    try{
      const r=await fetch("/api/lagerbestand/import",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({scanBucket:true})});
      const d=await r.json();
      setMsg(d.ok?`${d.enqueued?.length||0} Job(s) eingereiht`:"Fehler: "+(d.message||""));
      setTimeout(()=>onRefresh&&onRefresh(),2000);
    }catch(e){setMsg("Fehler: "+e.message);}
    setBusy(false);
  };
  return<div style={{display:"flex",gap:8,alignItems:"center",marginBottom:12}}>
    <button onClick={scan} disabled={busy} style={{padding:"6px 12px",background:"var(--accent)",color:"#fff",border:0,borderRadius:4,cursor:busy?"wait":"pointer"}}>
      {busy?"Läuft …":"Bucket scannen & importieren"}
    </button>
    <span style={{fontSize:11,color:"var(--t3)"}}>{msg||"MinIO lager/ → Import-Queue · Webhook aktiv unter POST /api/lagerbestand/webhook"}</span>
  </div>;
};

/** Lesbarer Marken-Filter mit Panel statt nativem datalist (darkmode-tauglich). */
const MarkenFilterPanel=({marken,brand,onChange,width=220})=>{
  const [open,setOpen]=useState(false);
  const [suche,setSuche]=useState("");
  const filtered=(marken||[]).filter(m=>!suche||(m.marke||"").toLowerCase().includes(suche.toLowerCase()));
  return<div style={{position:"relative",width}}>
    <button onClick={()=>setOpen(v=>!v)}
      style={{width:"100%",padding:"6px 10px",background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:4,color:"var(--t1)",textAlign:"left",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",gap:6,fontFamily:"inherit",fontSize:12}}>
      <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{brand?brand:"Marke filtern …"}</span>
      <span style={{color:"var(--t3)"}}>{open?"▲":"▼"}</span>
    </button>
    {open&&<div style={{position:"absolute",top:"100%",left:0,marginTop:4,width:"min(640px, 80vw)",maxWidth:"80vw",background:"var(--s1)",border:"1px solid var(--brd)",borderRadius:6,padding:10,zIndex:30,boxShadow:"0 8px 24px rgba(0,0,0,.35)"}}>
      <div style={{display:"flex",gap:6,marginBottom:8}}>
        <input autoFocus value={suche} onChange={e=>setSuche(e.target.value)} placeholder="Marke suchen …"
          style={{flex:1,padding:"6px 10px",background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:4,color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
        <button onClick={()=>{onChange("");setSuche("");setOpen(false);}}
          style={{padding:"6px 10px",background:!brand?"var(--acc)":"var(--s2)",color:!brand?"#fff":"var(--t1)",border:"1px solid var(--brd)",borderRadius:4,cursor:"pointer",fontSize:12}}>Alle</button>
        <button onClick={()=>setOpen(false)}
          style={{padding:"6px 10px",background:"var(--s2)",color:"var(--t1)",border:"1px solid var(--brd)",borderRadius:4,cursor:"pointer",fontSize:12}}>×</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill, minmax(200px, 1fr))",gap:4,maxHeight:320,overflowY:"auto"}}>
        {filtered.map(m=>{const active=brand===m.marke;return<button key={m.marke||"_leer"} onClick={()=>{onChange(m.marke);setOpen(false);}}
          style={{padding:"6px 8px",background:active?"var(--acc)":"var(--s2)",color:active?"#fff":"var(--t1)",border:`1px solid ${active?"var(--acc)":"var(--brd)"}`,borderRadius:4,textAlign:"left",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,fontSize:12,fontFamily:"inherit"}}>
          <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.marke||"(ohne)"}</span>
          <span style={{fontSize:10,color:active?"#fff":"var(--t3)",whiteSpace:"nowrap"}}>{fmtLagerNum(m.menge)}</span>
        </button>;})}
        {!filtered.length&&<div style={{padding:12,color:"var(--t3)",fontSize:12}}>Keine Treffer.</div>}
      </div>
    </div>}
  </div>;
};

const LagerBestandsTabelle=({bucket,endpoint,markenSource})=>{
  const [data,setData]=useState({rows:[],total:0,summary:null});
  const [marken,setMarken]=useState([]);
  const [q,setQ]=useState("");
  const [brand,setBrand]=useState("");
  const [sort,setSort]=useState("bestand_desc");
  const [salesDays,setSalesDays]=useState(365);
  const [loading,setLoading]=useState(false);
  const load=(overrides)=>{
    const o=overrides||{};
    setLoading(true);
    const url=endpoint||`/api/lagerbestand/bucket/${bucket}`;
    const params=new URLSearchParams({
      q:o.q!==undefined?o.q:q,
      brand:o.brand!==undefined?o.brand:brand,
      sort:o.sort!==undefined?o.sort:sort,
      salesDays:String(o.salesDays!==undefined?o.salesDays:salesDays),
      limit:"200",
    });
    fetch(`${url}?${params}`)
      .then(r=>r.json()).then(d=>setData(d||{rows:[],total:0,summary:null}))
      .catch(()=>setData({rows:[],total:0,summary:null}))
      .finally(()=>setLoading(false));
  };
  useEffect(()=>{
    load();
    fetch(`/api/lagerbestand/marken/${markenSource}`).then(r=>r.json()).then(d=>setMarken(d.marken||[])).catch(()=>{});
  },[bucket,endpoint,markenSource]);
  useEffect(()=>{load();},[sort,brand,salesDays]);
  const isZfs=!bucket;
  const s=data.summary||{};
  return<div>
    <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
      <input value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&load({q:e.target.value})}
        placeholder="Suche Herst-ArtNr / EAN / Name …"
        style={{flex:"1 1 220px",padding:"6px 10px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}/>
      <MarkenFilterPanel marken={marken} brand={brand} onChange={setBrand} width={220}/>
      <select value={sort} onChange={e=>setSort(e.target.value)}
        style={{padding:"6px 10px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}>
        <option value="bestand_desc">Bestand ↓</option>
        <option value="bestand_asc">Bestand ↑</option>
        <option value="verkauft_desc">Verkäufe ↓</option>
        <option value="verkauft_asc">Verkäufe ↑</option>
        <option value="umsatz_desc">Umsatz ↓</option>
        <option value="marke_asc">Marke A-Z</option>
      </select>
      <select value={salesDays} onChange={e=>setSalesDays(parseInt(e.target.value))}
        style={{padding:"6px 10px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}>
        <option value="30">30 Tage</option>
        <option value="90">90 Tage</option>
        <option value="180">6 Monate</option>
        <option value="365">12 Monate</option>
        <option value="730">24 Monate</option>
      </select>
      <button onClick={()=>load()} style={{padding:"6px 12px",background:"var(--b3)",color:"var(--t1)",border:"1px solid var(--br)",borderRadius:4}}>Suchen</button>
      {(brand||q)&&<button onClick={()=>{setBrand("");setQ("");load({brand:"",q:""});}} style={{padding:"6px 10px",background:"var(--b3)",color:"var(--t3)",border:"1px solid var(--br)",borderRadius:4}}>Reset</button>}
    </div>
    {brand&&<div style={{display:"flex",gap:16,padding:"10px 14px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:6,marginBottom:10,fontSize:12,flexWrap:"wrap"}}>
      <div><span style={{color:"var(--t3)"}}>Marke:</span> <b>{brand}</b></div>
      <div><span style={{color:"var(--t3)"}}>Artikel:</span> <b>{fmtLagerNum(s.artikel||0)}</b></div>
      <div><span style={{color:"var(--t3)"}}>Gesamtbestand:</span> <b>{fmtLagerNum(s.bestand||0)} Stk</b></div>
      <div><span style={{color:"var(--t3)"}}>Verkäufe ({salesDays}d):</span> <b>{fmtLagerNum(s.verkauft||0)} Stk</b></div>
      <div><span style={{color:"var(--t3)"}}>Umsatz netto:</span> <b>{fmtLagerNum(Math.round(s.umsatz||0))} €</b></div>
    </div>}
    <div style={{fontSize:11,color:"var(--t3)",marginBottom:6,display:"flex",justifyContent:"space-between"}}>
      <span>{loading?"Lädt …":`${fmtLagerNum(data.total)} Artikel · Bestand ${fmtLagerNum(s.bestand||0)} Stk · Verkäufe ${fmtLagerNum(s.verkauft||0)} Stk (${salesDays} Tage)`}</span>
      <span>Zeige {data.rows.length} / {data.total}</span>
    </div>
    <div style={{maxHeight:600,overflow:"auto",border:"1px solid var(--br)",borderRadius:4}}>
      <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
        <thead style={{position:"sticky",top:0,background:"var(--b2)"}}>
          <tr>
            {(()=>{
              const ths=[
                {l:"Herst-ArtNr",align:"left",sk:null},
                {l:"EAN",align:"left",sk:null},
                {l:"Marke",align:"left",sk:"marke"},
                {l:"Produkt",align:"left",sk:null},
                {l:"Variante",align:"left",sk:null},
                {l:isZfs?"Menge":"Bestand",align:"right",sk:"bestand"},
                {l:`Verk. ${salesDays}d`,align:"right",sk:"verkauft"},
                {l:"Umsatz €",align:"right",sk:"umsatz"},
                {l:isZfs?"Lagerort":"Unterlager",align:"left",sk:null},
              ];
              const toggle=(sk)=>{
                if(!sk)return;
                const cur=sort.startsWith(sk+"_")?sort:sk+"_desc";
                const next=cur===sk+"_desc"?sk+"_asc":sk+"_desc";
                setSort(next);
              };
              return ths.map((th,idx)=>{
                const active=th.sk&&sort.startsWith(th.sk+"_");
                const arrow=active?(sort.endsWith("_asc")?" ↑":" ↓"):"";
                return<th key={idx} onClick={()=>toggle(th.sk)}
                  style={{textAlign:th.align,padding:"8px 10px",borderBottom:"1px solid var(--br)",cursor:th.sk?"pointer":"default",userSelect:"none",color:active?"#4aa":"var(--t1)"}}>
                  {th.l}{arrow}
                </th>;
              });
            })()}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((r,i)=><tr key={i} style={{borderBottom:"1px solid var(--br)"}}>
            <td style={{padding:"6px 10px",fontFamily:"monospace"}}>{r.herstArtNr||"—"}</td>
            <td style={{padding:"6px 10px",fontFamily:"monospace"}}>{r.ean||"—"}</td>
            <td style={{padding:"6px 10px"}}>{r.marke||"—"}</td>
            <td style={{padding:"6px 10px"}}>{r.produktname||r.name||"—"}</td>
            <td style={{padding:"6px 10px",color:"var(--t3)"}}>{r.variante||""}</td>
            <td style={{padding:"6px 10px",textAlign:"right",fontWeight:600}}>{fmtLagerNum(r.bucketSum||r.menge||0)}</td>
            <td style={{padding:"6px 10px",textAlign:"right",color:r.netto>0?"var(--t1)":"var(--t3)"}}>{fmtLagerNum(r.netto||0)}</td>
            <td style={{padding:"6px 10px",textAlign:"right",color:"var(--t2)"}}>{fmtLagerNum(Math.round(r.umsatz||0))}</td>
            {!isZfs&&<td style={{padding:"6px 10px",color:"var(--t3)",fontSize:11}}>
              {(r.bucketDetails||[]).map(b=>`${b.subLocation}: ${b.menge}`).join(" · ")}
            </td>}
            {isZfs&&<td style={{padding:"6px 10px",color:"var(--t3)",fontSize:11}}>
              {(r.locations||[]).filter(l=>l.menge>0).map(l=>`${l.name}${l.status==="non_offerable"?"⁺":""}: ${l.menge}`).join(" · ")||(r.subLocation||"—")}
            </td>}
          </tr>)}
          {!data.rows.length&&<tr><td colSpan="9" style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Keine Daten.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>;
};

const LagerGesamtTabelle=({onSummary})=>{
  const [data,setData]=useState({rows:[],total:0,summary:null});
  const [marken,setMarken]=useState([]);
  const [q,setQ]=useState("");
  const [brand,setBrand]=useState("");
  const [sort,setSort]=useState("bestand_desc");
  const [salesDays,setSalesDays]=useState(365);
  const [loading,setLoading]=useState(false);
  const load=(overrides)=>{
    const o=overrides||{};
    setLoading(true);
    const params=new URLSearchParams({
      q:o.q!==undefined?o.q:q, brand:o.brand!==undefined?o.brand:brand,
      sort:o.sort!==undefined?o.sort:sort,
      salesDays:String(o.salesDays!==undefined?o.salesDays:salesDays),
      limit:"200",
    });
    fetch(`/api/lagerbestand/all?${params}`)
      .then(r=>r.json()).then(d=>{
        const safe=d||{rows:[],total:0,summary:null};
        setData(safe);
        if(onSummary) onSummary(safe.summary||null);
      })
      .catch(()=>setData({rows:[],total:0,summary:null}))
      .finally(()=>setLoading(false));
  };
  useEffect(()=>{
    load();
    fetch("/api/lagerbestand/marken/all").then(r=>r.json()).then(d=>setMarken(d.marken||[])).catch(()=>{});
  },[]);
  useEffect(()=>{load();},[sort,brand,salesDays]);
  const s=data.summary||{};
  return<div>
    <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
      <input value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&load({q:e.target.value})}
        placeholder="Suche Herst-ArtNr / EAN / Name …"
        style={{flex:"1 1 240px",padding:"6px 10px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}/>
      <MarkenFilterPanel marken={marken} brand={brand} onChange={setBrand} width={240}/>
      <select value={sort} onChange={e=>setSort(e.target.value)}
        style={{padding:"6px 10px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}>
        <option value="bestand_desc">Bestand ↓</option>
        <option value="bestand_asc">Bestand ↑</option>
        <option value="verkauft_desc">Verkäufe ↓</option>
        <option value="verkauft_asc">Verkäufe ↑</option>
        <option value="umsatz_desc">Umsatz ↓</option>
        <option value="marke_asc">Marke A-Z</option>
      </select>
      <select value={salesDays} onChange={e=>setSalesDays(parseInt(e.target.value))}
        style={{padding:"6px 10px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}>
        <option value="30">30 Tage</option>
        <option value="90">90 Tage</option>
        <option value="180">6 Monate</option>
        <option value="365">12 Monate</option>
        <option value="730">24 Monate</option>
      </select>
      <button onClick={()=>load()} style={{padding:"6px 12px",background:"var(--b3)",color:"var(--t1)",border:"1px solid var(--br)",borderRadius:4}}>Suchen</button>
      {(brand||q)&&<button onClick={()=>{setBrand("");setQ("");load({brand:"",q:""});}} style={{padding:"6px 10px",background:"var(--b3)",color:"var(--t3)",border:"1px solid var(--br)",borderRadius:4}}>Reset</button>}
    </div>
    {brand&&<div style={{display:"flex",gap:16,padding:"10px 14px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:6,marginBottom:10,fontSize:12,flexWrap:"wrap"}}>
      <div><span style={{color:"var(--t3)"}}>Marke:</span> <b>{brand}</b></div>
      <div><span style={{color:"var(--t3)"}}>Artikel:</span> <b>{fmtLagerNum(s.artikel||0)}</b></div>
      <div><span style={{color:"var(--t3)"}}>Gesamt:</span> <b>{fmtLagerNum(s.bestand||0)} Stk</b></div>
      <div><span style={{color:"var(--t3)"}}>Ehrenfr:</span> <b>{fmtLagerNum(s.ehr||0)}</b></div>
      <div><span style={{color:"var(--t3)"}}>ZFS:</span> <b>{fmtLagerNum(s.zfs||0)}</b></div>
      <div><span style={{color:"var(--t3)"}}>AY:</span> <b>{fmtLagerNum(s.ay||0)}</b></div>
      <div><span style={{color:"var(--t3)"}}>Verkäufe ({salesDays}d):</span> <b>{fmtLagerNum(s.verkauft||0)} Stk</b></div>
      <div><span style={{color:"var(--t3)"}}>Umsatz:</span> <b>{fmtLagerNum(Math.round(s.umsatz||0))} €</b></div>
      <div><span style={{color:"var(--t3)"}}>Lagerwert:</span> <b style={{color:"#16a34a"}}>{fmtLagerNum(Math.round(s.lagerwert||0))} €</b></div>
    </div>}
    <div style={{fontSize:11,color:"var(--t3)",marginBottom:6,display:"flex",justifyContent:"space-between"}}>
      <span>{loading?"Lädt …":`${fmtLagerNum(data.total)} Artikel · Gesamt ${fmtLagerNum(s.bestand||0)} Stk (Ehr ${fmtLagerNum(s.ehr||0)} · ZFS ${fmtLagerNum(s.zfs||0)} · AY ${fmtLagerNum(s.ay||0)}) · Verk. ${fmtLagerNum(s.verkauft||0)} Stk · Lagerwert ${fmtLagerNum(Math.round(s.lagerwert||0))} €`}</span>
      <span>Zeige {data.rows.length} / {data.total}</span>
    </div>
    <div style={{maxHeight:650,overflow:"auto",border:"1px solid var(--br)",borderRadius:4}}>
      <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
        <thead style={{position:"sticky",top:0,background:"var(--b2)"}}>
          <tr>
            {(()=>{
              const ths=[
                {k:"marke",l:"Herst-ArtNr",align:"left",sortKey:null}, // herstArtNr not server-sortable → skip
                {k:"ean",l:"EAN",align:"left",sortKey:null},
                {k:"marke",l:"Marke",align:"left",sortKey:"marke"},
                {k:"produkt",l:"Produkt",align:"left",sortKey:null},
                {k:"variante",l:"Variante",align:"left",sortKey:null},
                {k:"ehr",l:"Ehrenfr",align:"right",sortKey:null},
                {k:"zfs",l:"ZFS",align:"right",sortKey:null},
                {k:"ay",l:"AY",align:"right",sortKey:null},
                {k:"bestand",l:"Gesamt",align:"right",sortKey:"bestand",highlight:true},
                {k:"ek",l:"EK €",align:"right",sortKey:"ek"},
                {k:"lagerwert",l:"Lagerwert €",align:"right",sortKey:"lagerwert",highlight:true},
                {k:"verkauft",l:`Verk. ${salesDays}d`,align:"right",sortKey:"verkauft"},
                {k:"umsatz",l:"Umsatz €",align:"right",sortKey:"umsatz"},
              ];
              const toggle=(sk)=>{
                if(!sk)return;
                const cur=sort.startsWith(sk+"_")?sort:sk+"_desc";
                const next=cur===sk+"_desc"?sk+"_asc":sk+"_desc";
                setSort(next);
              };
              return ths.map((th,idx)=>{
                const active=th.sortKey&&sort.startsWith(th.sortKey+"_");
                const arrow=active?(sort.endsWith("_asc")?" ↑":" ↓"):"";
                return<th key={idx} onClick={()=>toggle(th.sortKey)}
                  style={{textAlign:th.align,padding:"8px 10px",borderBottom:"1px solid var(--br)",background:th.highlight?"var(--b3)":undefined,cursor:th.sortKey?"pointer":"default",userSelect:"none",color:active?"var(--accent, #4aa)":"var(--t1)"}}>
                  {th.l}{arrow}
                </th>;
              });
            })()}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((r,i)=><tr key={i} style={{borderBottom:"1px solid var(--br)"}}>
            <td style={{padding:"6px 10px",fontFamily:"monospace"}}>{r.herstArtNr||"—"}</td>
            <td style={{padding:"6px 10px",fontFamily:"monospace"}}>{r.ean||"—"}</td>
            <td style={{padding:"6px 10px"}}>{r.marke||"—"}</td>
            <td style={{padding:"6px 10px"}}>{r.produktname||"—"}</td>
            <td style={{padding:"6px 10px",color:"var(--t3)"}}>{r.variante||""}</td>
            <td style={{padding:"6px 10px",textAlign:"right",color:r.ehr>0?"var(--t1)":"var(--t3)"}}>{fmtLagerNum(r.ehr||0)}</td>
            <td style={{padding:"6px 10px",textAlign:"right",color:r.zfs>0?"#ff6a00":"var(--t3)"}}>{fmtLagerNum(r.zfs||0)}</td>
            <td style={{padding:"6px 10px",textAlign:"right",color:r.ay>0?"#f65":"var(--t3)"}}>{fmtLagerNum(r.ay||0)}</td>
            <td style={{padding:"6px 10px",textAlign:"right",fontWeight:700,background:"var(--b2)"}}>{fmtLagerNum(r.gesamt||0)}</td>
            <td style={{padding:"6px 10px",textAlign:"right",color:r.ek>0?"var(--t1)":"var(--t3)"}}>{r.ek>0?(r.ek.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})):"—"}</td>
            <td style={{padding:"6px 10px",textAlign:"right",fontWeight:600,color:r.lagerwert>0?"#16a34a":"var(--t3)",background:"var(--b2)"}}>{r.lagerwert>0?(Math.round(r.lagerwert).toLocaleString("de-DE")):"—"}</td>
            <td style={{padding:"6px 10px",textAlign:"right",color:r.netto>0?"var(--t1)":"var(--t3)"}}>{fmtLagerNum(r.netto||0)}</td>
            <td style={{padding:"6px 10px",textAlign:"right",color:"var(--t2)"}}>{fmtLagerNum(Math.round(r.umsatz||0))}</td>
          </tr>)}
          {!data.rows.length&&<tr><td colSpan="13" style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Keine Daten.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>;
};

const LagerBestand=()=>{
  const [summary,setSummary]=useState(null);
  const [lagerwertSummary,setLagerwertSummary]=useState(null);
  const load=()=>fetch("/api/lagerbestand/summary").then(r=>r.json()).then(setSummary).catch(()=>setSummary(null));
  useEffect(()=>{load();},[]);
  return<div style={{padding:20}}>
    <h2 style={{marginTop:0}}>Bestand · Gesamtübersicht</h2>
    <LagerImportPanel onRefresh={load}/>
    <LagerSummaryCards summary={summary} lagerwertSummary={lagerwertSummary}/>
    <div style={{fontSize:11,color:"var(--t3)",marginBottom:12}}>
      Letzte Importe: {(summary?.lastImports||[]).slice(0,3).map((i,idx)=>
        <span key={idx} style={{marginRight:12}}>
          {new Date(i.startedAt).toLocaleString("de-DE")} · {i.kind} · {i.zeilen||0} Zeilen · {i.status}
        </span>)}
    </div>
    <LagerGesamtTabelle onSummary={setLagerwertSummary}/>
  </div>;
};
const LagerEhrenfriedersdorf=()=><div style={{padding:20}}>
  <h2 style={{marginTop:0}}>Ehrenfriedersdorf · Eigenlager</h2>
  <LagerBestandsTabelle bucket="ehrenfriedersdorf" markenSource="ehrenfriedersdorf"/>
</div>;
const LagerZalando=()=><div style={{padding:20}}>
  <h2 style={{marginTop:0}}>Zalando ZFS</h2>
  <div style={{fontSize:11,color:"var(--t3)",marginBottom:10}}>Quelle: Zalando-XLSX (authoritativ). Unterlager = physische ZFS-Location · „⁺" = non_offerable.</div>
  <LagerBestandsTabelle endpoint="/api/lagerbestand/zfs" markenSource="zfs"/>
</div>;
const LagerAboutYou=()=><div style={{padding:20}}>
  <h2 style={{marginTop:0}}>About You Lager (FbAY)</h2>
  <LagerBestandsTabelle bucket="aboutyou" markenSource="aboutyou"/>
</div>;
const DEFAULT_AMPEL={renner:90,mittel:365};
const ampelOf=(reichweite,verkProTag,thresholds)=>{
  const th=thresholds||DEFAULT_AMPEL;
  // verkProTag=0 → Penner (rot), egal wie viel Bestand
  if(!verkProTag||verkProTag<=0)return{key:"penner",color:"#e64545",label:"Penner"};
  if(reichweite<=th.renner)return{key:"renner",color:"#16a34a",label:"Renner"};
  if(reichweite<=th.mittel)return{key:"mittel",color:"#eab308",label:"Mitteldreher"};
  return{key:"penner",color:"#e64545",label:"Penner"};
};

const LagerAuswertung=()=>{
  const [data,setData]=useState({rows:[],total:0,summary:null});
  const [marken,setMarken]=useState([]);
  const [q,setQ]=useState("");
  const [brand,setBrand]=useState("");
  const [ampelFilter,setAmpelFilter]=useState("alle");
  const [sort,setSort]=useState("reichweite_asc");
  const [salesDays,setSalesDays]=useState(365);
  const [minBestand,setMinBestand]=useState(1);
  const [saisonal,setSaisonal]=useState(true);
  const [loading,setLoading]=useState(false);
  const [markenOffen,setMarkenOffen]=useState(false);
  const [markenSuche,setMarkenSuche]=useState("");
  const [thresholds,setThresholds]=useState(DEFAULT_AMPEL);
  const load=()=>{
    setLoading(true);
    const params=new URLSearchParams({q,brand,salesDays:String(salesDays),sort:"bestand_desc",limit:"50000"});
    fetch(`/api/lagerbestand/all?${params}`)
      .then(r=>r.json()).then(d=>setData(d||{rows:[],total:0,summary:null}))
      .catch(()=>setData({rows:[],total:0,summary:null}))
      .finally(()=>setLoading(false));
  };
  useEffect(()=>{
    load();
    fetch("/api/lagerbestand/marken/all").then(r=>r.json()).then(d=>setMarken(d.marken||[])).catch(()=>{});
    fetch("/api/lagerbestand/config/ampel").then(r=>r.json()).then(d=>d&&d.config&&setThresholds(d.config)).catch(()=>{});
  },[]);
  useEffect(()=>{load();},[brand,salesDays]);
  // Client-side: Reichweite + Ampel + Filter + Sort
  const rows=useMemo(()=>{
    const enriched=(data.rows||[]).map(r=>{
      const bestand=r.gesamt||0;
      const verkauftLinear=r.netto||0;
      const verkProTagLinear=verkauftLinear/salesDays;
      // Saisonal aus Backend; Fallback linear
      const verkProTag=saisonal&&r.hatSaisonprofil?(r.avgProTagAktuell||0):verkProTagLinear;
      const reichweite=saisonal&&r.hatSaisonprofil
        ?(r.reichweiteSaisonal||(bestand>0?99999:0))
        :(verkProTagLinear>0?bestand/verkProTagLinear:(bestand>0?99999:0));
      const ampel=ampelOf(reichweite,verkProTag||verkProTagLinear,thresholds);
      return{...r,bestand,verkProTag,verkProTagLinear,reichweite,ampel};
    }).filter(r=>(r.bestand||0)>=minBestand);
    const filtered=ampelFilter==="alle"?enriched:enriched.filter(r=>r.ampel.key===ampelFilter);
    const sign=sort.endsWith("_asc")?1:-1;
    const key=sort.replace(/_(asc|desc)$/,"");
    const getF=r=>{
      switch(key){
        case"reichweite":return r.reichweite;
        case"verkauft":return r.netto||0;
        case"verkProTag":return r.verkProTag;
        case"bestand":return r.bestand;
        case"umsatz":return r.umsatz||0;
        case"marke":return(r.marke||"").toLowerCase();
        case"herstArtNr":return(r.herstArtNr||"").toLowerCase();
        case"produktname":return(r.produktname||"").toLowerCase();
      }
      return 0;
    };
    filtered.sort((a,b)=>{const va=getF(a),vb=getF(b);if(typeof va==="string")return sign*va.localeCompare(vb);return sign*(va-vb);});
    return filtered;
  },[data.rows,salesDays,ampelFilter,sort,minBestand,saisonal,thresholds]);
  // Counts pro Ampelkategorie
  const counts=useMemo(()=>{
    const c={renner:0,mittel:0,penner:0,alle:0};
    const s={renner:0,mittel:0,penner:0,alle:0};
    for(const r of data.rows||[]){
      if((r.gesamt||0)<minBestand)continue;
      const lin=(r.netto||0)/salesDays;
      const verkProTag=saisonal&&r.hatSaisonprofil?(r.avgProTagAktuell||0):lin;
      const reichweite=saisonal&&r.hatSaisonprofil
        ?(r.reichweiteSaisonal||99999)
        :(lin>0?(r.gesamt||0)/lin:99999);
      const a=ampelOf(reichweite,verkProTag||lin,thresholds);
      c[a.key]++;c.alle++;
      s[a.key]+=r.gesamt||0;s.alle+=r.gesamt||0;
    }
    return{c,s};
  },[data.rows,salesDays,minBestand,saisonal,thresholds]);
  return<div style={{padding:20}}>
    <h2 style={{marginTop:0}}>Lagerauswertung · Reichweite & Renner/Penner</h2>
    <div style={{fontSize:11,color:"var(--t3)",marginBottom:12}}>
      {saisonal
        ?"Saisonale Reichweite: Vorwärts-Projektion Tag-für-Tag mit dem durchschnittlichen Kalendermonats-Muster der letzten 24 Monate. Ø/Tag = Erwartung im aktuellen Monat."
        :`Lineare Reichweite: Bestand ÷ (Netto-Verkäufe ÷ ${salesDays} Tage).`}
      {" "}Ampel: 🟢 Renner ≤ {thresholds.renner} Tage · 🟡 Mittel {thresholds.renner+1}–{thresholds.mittel} · 🔴 Penner &gt; {thresholds.mittel} oder 0.
    </div>
    <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
      <input value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&load()}
        placeholder="Suche …" style={{flex:"1 1 200px",padding:"6px 10px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}/>
      <button onClick={()=>setMarkenOffen(v=>!v)}
        style={{width:220,padding:"6px 10px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)",textAlign:"left",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span>{brand?brand:"Marke …"}</span>
        <span style={{color:"var(--t3)"}}>{markenOffen?"▲":"▼"}</span>
      </button>
      <select value={salesDays} onChange={e=>setSalesDays(parseInt(e.target.value))}
        style={{padding:"6px 10px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}>
        <option value="90">Ø aus 90 Tagen</option>
        <option value="180">Ø aus 180 Tagen</option>
        <option value="365">Ø aus 365 Tagen</option>
        <option value="730">Ø aus 730 Tagen</option>
      </select>
      <select value={sort} onChange={e=>setSort(e.target.value)}
        style={{padding:"6px 10px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}>
        <option value="reichweite_asc">Reichweite ↑ (knapp)</option>
        <option value="reichweite_desc">Reichweite ↓ (viel)</option>
        <option value="verkProTag_desc">Ø Verk./Tag ↓</option>
        <option value="verkauft_desc">Verkäufe ↓</option>
        <option value="bestand_desc">Bestand ↓</option>
        <option value="umsatz_desc">Umsatz ↓</option>
        <option value="marke_asc">Marke A-Z</option>
      </select>
      <label style={{display:"flex",alignItems:"center",gap:4,fontSize:11,color:"var(--t3)"}}>
        Bestand ≥ <input type="number" value={minBestand} onChange={e=>setMinBestand(parseInt(e.target.value)||0)} style={{width:60,padding:"4px 6px",background:"var(--b2)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}/>
      </label>
      <button onClick={load} style={{padding:"6px 12px",background:"var(--b3)",color:"var(--t1)",border:"1px solid var(--br)",borderRadius:4}}>Laden</button>
    </div>
    {markenOffen && <div style={{marginBottom:12,padding:12,background:"var(--b2)",border:"1px solid var(--br)",borderRadius:6}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
        <input value={markenSuche} onChange={e=>setMarkenSuche(e.target.value)} placeholder="Marke suchen …"
          style={{flex:1,padding:"6px 10px",background:"var(--b1)",border:"1px solid var(--br)",borderRadius:4,color:"var(--t1)"}}/>
        <button onClick={()=>{setBrand("");setMarkenSuche("");setMarkenOffen(false);}}
          style={{padding:"6px 10px",background:!brand?"var(--accent)":"var(--b3)",color:!brand?"#fff":"var(--t1)",border:"1px solid var(--br)",borderRadius:4,cursor:"pointer"}}>Alle Marken</button>
        <button onClick={()=>setMarkenOffen(false)} style={{padding:"6px 10px",background:"var(--b3)",color:"var(--t1)",border:"1px solid var(--br)",borderRadius:4,cursor:"pointer"}}>Schließen</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill, minmax(220px, 1fr))",gap:6,maxHeight:360,overflowY:"auto"}}>
        {marken
          .filter(m=>!markenSuche||(m.marke||"").toLowerCase().includes(markenSuche.toLowerCase()))
          .map(m=>{
            const active=brand===m.marke;
            return<button key={m.marke||"_leer"} onClick={()=>{setBrand(m.marke);setMarkenOffen(false);}}
              style={{padding:"8px 10px",background:active?"var(--accent)":"var(--b1)",color:active?"#fff":"var(--t1)",border:`1px solid ${active?"var(--accent)":"var(--br)"}`,borderRadius:4,textAlign:"left",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
              <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{m.marke||"(ohne)"}</span>
              <span style={{fontSize:11,color:active?"#fff":"var(--t3)",whiteSpace:"nowrap"}}>{fmtLagerNum(m.menge)} Stk</span>
            </button>;
          })}
      </div>
    </div>}
    <div style={{display:"flex",gap:8,marginBottom:12}}>
      {[
        {k:"alle",l:"Alle",color:"var(--t2)"},
        {k:"renner",l:"🟢 Renner",color:"#16a34a"},
        {k:"mittel",l:"🟡 Mitteldreher",color:"#eab308"},
        {k:"penner",l:"🔴 Penner",color:"#e64545"},
      ].map(t=>{
        const active=ampelFilter===t.k;
        return<button key={t.k} onClick={()=>setAmpelFilter(t.k)}
          style={{flex:1,padding:"12px",background:active?t.color:"var(--b2)",color:active?"#fff":"var(--t1)",border:`2px solid ${active?t.color:"var(--br)"}`,borderRadius:6,cursor:"pointer",textAlign:"left"}}>
          <div style={{fontSize:11,textTransform:"uppercase",letterSpacing:.5,opacity:.8}}>{t.l}</div>
          <div style={{fontSize:20,fontWeight:700,marginTop:2}}>{fmtLagerNum(counts.c[t.k]||0)}</div>
          <div style={{fontSize:11,opacity:.85}}>{fmtLagerNum(counts.s[t.k]||0)} Stk</div>
        </button>;
      })}
    </div>
    <div style={{fontSize:11,color:"var(--t3)",marginBottom:6}}>
      {loading?"Lädt …":`${fmtLagerNum(rows.length)} von ${fmtLagerNum(counts.c.alle)} Artikeln`}
    </div>
    <div style={{maxHeight:650,overflow:"auto",border:"1px solid var(--br)",borderRadius:4}}>
      <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
        <thead style={{position:"sticky",top:0,background:"var(--b2)"}}>
          <tr>
            <th style={{width:12,padding:"8px 4px",borderBottom:"1px solid var(--br)"}}></th>
            {(()=>{
              const ths=[
                {l:"Herst-ArtNr",align:"left",sk:"herstArtNr"},
                {l:"Marke",align:"left",sk:"marke"},
                {l:"Produkt",align:"left",sk:"produktname"},
                {l:"Bestand",align:"right",sk:"bestand"},
                {l:`Verk. ${salesDays}d`,align:"right",sk:"verkauft"},
                {l:"Ø/Tag",align:"right",sk:"verkProTag"},
                {l:"Reichweite",align:"right",sk:"reichweite"},
                {l:"Umsatz €",align:"right",sk:"umsatz"},
                {l:"Verteilung",align:"left",sk:null},
              ];
              const toggle=(sk)=>{
                if(!sk)return;
                const cur=sort.startsWith(sk+"_")?sort:sk+"_desc";
                const next=cur===sk+"_desc"?sk+"_asc":sk+"_desc";
                setSort(next);
              };
              return ths.map((th,idx)=>{
                const active=th.sk&&sort.startsWith(th.sk+"_");
                const arrow=active?(sort.endsWith("_asc")?" ↑":" ↓"):"";
                return<th key={idx} onClick={()=>toggle(th.sk)}
                  style={{textAlign:th.align,padding:"8px 10px",borderBottom:"1px solid var(--br)",cursor:th.sk?"pointer":"default",userSelect:"none",color:active?"#4aa":"var(--t1)"}}>
                  {th.l}{arrow}
                </th>;
              });
            })()}
          </tr>
        </thead>
        <tbody>
          {rows.slice(0,500).map((r,i)=><tr key={i} style={{borderBottom:"1px solid var(--br)"}}>
            <td style={{padding:"6px 4px"}}><div style={{width:8,height:24,borderRadius:2,background:r.ampel.color}}/></td>
            <td style={{padding:"6px 10px",fontFamily:"monospace"}}>{r.herstArtNr||"—"}</td>
            <td style={{padding:"6px 10px"}}>{r.marke||"—"}</td>
            <td style={{padding:"6px 10px"}}>{r.produktname||"—"} <span style={{color:"var(--t3)"}}>{r.variante||""}</span></td>
            <td style={{padding:"6px 10px",textAlign:"right",fontWeight:600}}>{fmtLagerNum(r.bestand)}</td>
            <td style={{padding:"6px 10px",textAlign:"right"}}>{fmtLagerNum(r.netto||0)}</td>
            <td style={{padding:"6px 10px",textAlign:"right"}}>{r.verkProTag>=1?r.verkProTag.toFixed(1):r.verkProTag.toFixed(2)}</td>
            <td style={{padding:"6px 10px",textAlign:"right",color:r.ampel.color,fontWeight:600}}>
              {r.reichweite>=99999?"∞":r.reichweite>=365?`${(r.reichweite/30).toFixed(0)} Mon`:`${Math.round(r.reichweite)} Tage`}
            </td>
            <td style={{padding:"6px 10px",textAlign:"right",color:"var(--t2)"}}>{fmtLagerNum(Math.round(r.umsatz||0))}</td>
            <td style={{padding:"6px 10px",color:"var(--t3)",fontSize:11}}>
              {r.ehr>0&&<span>Ehr {r.ehr}</span>}{r.zfs>0&&<span style={{marginLeft:8,color:"#ff6a00"}}>ZFS {r.zfs}</span>}{r.ay>0&&<span style={{marginLeft:8,color:"#f65"}}>AY {r.ay}</span>}
            </td>
          </tr>)}
          {!rows.length&&<tr><td colSpan="10" style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Keine Daten für diese Filter.</td></tr>}
        </tbody>
      </table>
    </div>
    {rows.length>500&&<div style={{fontSize:11,color:"var(--t3)",marginTop:6,textAlign:"center"}}>Zeige die ersten 500 Treffer – bitte enger filtern für vollständige Liste.</div>}
  </div>;
};

/* ─── Lagerverwaltung (Konfiguration) ─── */
const AmpelKonfigCard=()=>{
  const [cfg,setCfg]=useState({renner:90,mittel:365});
  const [form,setForm]=useState({renner:90,mittel:365});
  const [saving,setSaving]=useState(false);
  const [msg,setMsg]=useState("");
  const load=()=>fetch("/api/lagerbestand/config/ampel").then(r=>r.json()).then(d=>{if(d&&d.config){setCfg(d.config);setForm(d.config);}}).catch(()=>{});
  useEffect(()=>{load();},[]);
  const save=async()=>{
    if(form.renner<1||form.mittel<=form.renner){setMsg("Mittel muss größer als Renner sein.");return;}
    setSaving(true);setMsg("");
    const r=await fetch("/api/lagerbestand/config/ampel",{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({renner:form.renner,mittel:form.mittel})}).then(x=>x.json()).catch(()=>null);
    setSaving(false);
    if(r&&r.ok){setCfg(r.config);setForm(r.config);setMsg("Gespeichert · Cache wird neu berechnet.");setTimeout(()=>setMsg(""),4000);}
    else setMsg("Fehler beim Speichern.");
  };
  const dirty=form.renner!==cfg.renner||form.mittel!==cfg.mittel;
  const iS={width:90,padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"};
  return<Card style={{marginBottom:16}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12,gap:16,flexWrap:"wrap"}}>
      <div>
        <div style={{fontSize:14,fontWeight:700,color:"var(--t1)",marginBottom:4}}>Ampel-Schwellen für die Lagerauswertung</div>
        <div style={{fontSize:11,color:"var(--t3)"}}>Reichweite (Tage) entscheidet, ob ein Artikel als Renner, Mitteldreher oder Penner läuft. Nach dem Speichern wird der Auswertungs-Cache neu berechnet.</div>
      </div>
    </div>
    <div style={{display:"flex",gap:20,flexWrap:"wrap",alignItems:"flex-end"}}>
      <div>
        <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>🟢 Renner: Reichweite ≤</label>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <input type="number" min={1} value={form.renner} onChange={e=>setForm(f=>({...f,renner:parseInt(e.target.value)||0}))} style={iS}/>
          <span style={{fontSize:12,color:"var(--t3)"}}>Tage</span>
        </div>
      </div>
      <div>
        <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>🟡 Mitteldreher: Reichweite ≤</label>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <input type="number" min={form.renner+1} value={form.mittel} onChange={e=>setForm(f=>({...f,mittel:parseInt(e.target.value)||0}))} style={iS}/>
          <span style={{fontSize:12,color:"var(--t3)"}}>Tage</span>
        </div>
      </div>
      <div>
        <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>🔴 Penner</label>
        <div style={{fontSize:13,color:"var(--t1)",padding:"8px 0"}}>&gt; {form.mittel} Tage oder 0 Verkäufe</div>
      </div>
      <div style={{flex:1}}/>
      <Btn primary onClick={save} disabled={saving||!dirty}>{saving?"Speichere…":"Speichern"}</Btn>
    </div>
    {msg&&<div style={{marginTop:10,fontSize:12,color:msg.startsWith("Gespeichert")?"var(--grn)":"var(--red, #e64545)"}}>{msg}</div>}
  </Card>;
};

const Lagerverwaltung=()=>{
  const [lager,setLager]=useState([]);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({name:"",adresse:"",notizen:"",aktiv:true});
  const [saving,setSaving]=useState(false);
  const load=()=>fetch("/api/lager").then(r=>r.json()).then(d=>setLager(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);
  const openEdit=l=>{setForm({name:l.name,adresse:l.adresse||"",notizen:l.notizen||"",aktiv:l.aktiv!==false});setModal(l);};
  const save=async()=>{setSaving(true);await fetch(`/api/lager/${modal._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)}).catch(()=>{});setSaving(false);setModal(null);load();};
  const C={Eigenlager:"var(--grn)",Fremdlager:"var(--acc)"};
  return<>
    <AmpelKonfigCard/>
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:16}}>
      {lager.map(l=><Card key={l._id} style={{position:"relative",overflow:"hidden",cursor:"pointer"}}
        onClick={()=>openEdit(l)} onMouseEnter={e=>e.currentTarget.style.borderColor=C[l.typ]||"var(--acc)"} onMouseLeave={e=>e.currentTarget.style.borderColor="var(--brd)"}>
        <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:C[l.typ]||"var(--acc)",borderRadius:"12px 12px 0 0"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginTop:4,marginBottom:8}}>
          <span style={{fontSize:10,fontWeight:600,padding:"2px 8px",borderRadius:4,background:(C[l.typ]||"var(--acc)")+"20",color:C[l.typ]||"var(--acc)"}}>{l.typ}</span>
          <Dot s={l.aktiv?"aktiv":"inaktiv"}/>
        </div>
        <div style={{fontSize:14,fontWeight:700,color:"var(--t1)",marginBottom:4}}>{l.name}</div>
        <div style={{fontSize:11,color:"var(--t2)",marginBottom:6}}>{l.adresse}</div>
        {l.partner&&<div style={{fontSize:11,color:"var(--t3)"}}>Partner: {l.partner}</div>}
        <div style={{marginTop:12,padding:"10px 0 0",borderTop:"1px solid var(--brd)",fontSize:11,color:"var(--t3)"}}>Bestände nach JTL-Anbindung</div>
      </Card>)}
    </div>
    <div style={{padding:"10px 14px",borderRadius:8,background:"var(--s2)",border:"1px solid var(--brd)",fontSize:11,color:"var(--t3)"}}>Artikelmengen und Lagerwerte werden nach Anbindung von JTL-Wawi und den Marktplatz-APIs automatisch befüllt.</div>
    {modal&&<Modal open={true} onClose={()=>setModal(null)} title={`${modal.name} bearbeiten`} width={440}>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        {[{l:"Name",k:"name"},{l:"Adresse",k:"adresse"}].map(f=><div key={f.k}><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>{f.l}</label><input value={form[f.k]} onChange={e=>setForm({...form,[f.k]:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/></div>)}
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Notizen</label><textarea value={form.notizen} onChange={e=>setForm({...form,notizen:e.target.value})} rows={2} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",resize:"vertical"}}/></div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}><Btn onClick={()=>setModal(null)}>Abbrechen</Btn><Btn primary onClick={save} disabled={saving}>{saving?"Speichere…":"Speichern"}</Btn></div>
      </div>
    </Modal>}
  </>;
};

/* ─── Lieferantenverwaltung ─── */
const EMPTY_LIEF={
  firma:"",firmenzusatz:"",anrede:"Herr",titel:"",vorname:"",nachname:"",
  strasse:"",plz:"",ort:"",land:"DE",sprache:"de",
  telefon:"",fax:"",email:"",www:"",ustIdNr:"",
  bestellwaehrung:"EUR",kreditorennr:"",lieferantennr:"",
  rechnungsdruck:false,steuerschluessel:"0",aktiv:true,
  bankverbindungen:[],
  konditionen:{zahlungsziel:30,mindestbestellwert:0,skonto:0,skontoziel:0},
  rabattstaffel:[],ansprechpartner:[],brands:[],notizen:"",
};
const BrandPicker=({selected,onSave,onClose})=>{
  const [brands,setBrands]=useState([]);
  const [search,setSearch]=useState("");
  const [sel,setSel]=useState(selected||[]);
  useEffect(()=>{fetch("/api/products/filters").then(r=>r.json()).then(d=>setBrands(d.brands||[])).catch(()=>{});},[]);
  const filtered=brands.filter(b=>!search||b.toLowerCase().includes(search.toLowerCase()));
  const iS={width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};
  return<Modal open={true} onClose={onClose} title="Brands auswählen" width={460}>
    <div style={{marginBottom:10}}><input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Brand suchen…" style={iS}/></div>
    <div style={{maxHeight:300,overflowY:"auto",border:"1px solid var(--brd)",borderRadius:7,background:"var(--s2)",padding:6,display:"flex",flexDirection:"column",gap:1}}>
      {filtered.map(b=><label key={b} style={{display:"flex",alignItems:"center",gap:8,padding:"5px 8px",borderRadius:5,cursor:"pointer",background:sel.includes(b)?"var(--acc2)":"transparent",userSelect:"none"}}>
        <input type="checkbox" checked={sel.includes(b)} onChange={()=>setSel(s=>s.includes(b)?s.filter(x=>x!==b):[...s,b])} style={{accentColor:"var(--acc)"}}/>
        <span style={{fontSize:12,color:"var(--t1)"}}>{b}</span>
      </label>)}
      {!filtered.length&&<div style={{padding:16,color:"var(--t3)",fontSize:12,textAlign:"center"}}>Keine Treffer</div>}
    </div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:12,paddingTop:12,borderTop:"1px solid var(--brd)"}}>
      <span style={{fontSize:11,color:"var(--t3)"}}>{sel.length} ausgewählt</span>
      <div style={{display:"flex",gap:8}}><Btn onClick={onClose}>Abbrechen</Btn><Btn primary onClick={()=>onSave(sel)}>Übernehmen</Btn></div>
    </div>
  </Modal>;
};
const Lieferantenverwaltung=()=>{
  const [lieferanten,setLieferanten]=useState([]);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({...EMPTY_LIEF});
  const [activeTab,setActiveTab]=useState("allgemein");
  const [saving,setSaving]=useState(false);
  const [deleting,setDeleting]=useState(null);
  const [showBrandPicker,setShowBrandPicker]=useState(false);
  const load=()=>fetch("/api/lieferanten").then(r=>r.json()).then(d=>setLieferanten(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);
  const iS={width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};
  const sS={...iS,cursor:"pointer"};
  const sf=(k,v)=>setForm(f=>({...f,[k]:v}));
  const sfk=(k,sk,v)=>setForm(f=>({...f,[k]:{...f[k],[sk]:v}}));
  const openAdd=()=>{setForm({...EMPTY_LIEF});setActiveTab("allgemein");setModal("add");};
  const openEdit=l=>{
    setForm({
      firma:l.firma||l.name||"",firmenzusatz:l.firmenzusatz||"",anrede:l.anrede||"Herr",titel:l.titel||"",
      vorname:l.vorname||"",nachname:l.nachname||"",strasse:l.strasse||"",plz:l.plz||"",ort:l.ort||"",
      land:l.land||"DE",sprache:l.sprache||"de",telefon:l.telefon||"",fax:l.fax||"",email:l.email||"",
      www:l.www||"",ustIdNr:l.ustIdNr||"",bestellwaehrung:l.bestellwaehrung||"EUR",
      kreditorennr:l.kreditorennr||"",lieferantennr:l.lieferantennr||"",
      rechnungsdruck:l.rechnungsdruck||false,steuerschluessel:l.steuerschluessel||"0",aktiv:l.aktiv!==false,
      bankverbindungen:l.bankverbindungen||[],
      konditionen:l.konditionen||{zahlungsziel:30,mindestbestellwert:0,skonto:0,skontoziel:0},
      rabattstaffel:l.rabattstaffel||[],ansprechpartner:l.ansprechpartner||[],
      brands:l.brands||[],notizen:l.notizen||"",
    });
    setActiveTab("allgemein");setModal(l);
  };
  const save=async()=>{
    setSaving(true);
    const body={...form,name:form.firma};
    const url=modal==="add"?"/api/lieferanten":`/api/lieferanten/${modal._id}`;
    await fetch(url,{method:modal==="add"?"POST":"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)}).catch(()=>{});
    setSaving(false);setModal(null);load();
  };
  const del=async id=>{if(!confirm("Lieferant wirklich löschen?"))return;setDeleting(id);await fetch(`/api/lieferanten/${id}`,{method:"DELETE"}).catch(()=>{});setDeleting(null);load();};
  const addBk=()=>sf("bankverbindungen",[...form.bankverbindungen,{bank:"",bic:"",iban:"",kontoinhaber:""}]);
  const updBk=(i,k,v)=>sf("bankverbindungen",form.bankverbindungen.map((b,j)=>j===i?{...b,[k]:v}:b));
  const remBk=i=>sf("bankverbindungen",form.bankverbindungen.filter((_,j)=>j!==i));
  const addRs=()=>sf("rabattstaffel",[...form.rabattstaffel,{von:0,bis:0,prozent:0}]);
  const updRs=(i,k,v)=>sf("rabattstaffel",form.rabattstaffel.map((r,j)=>j===i?{...r,[k]:v}:r));
  const remRs=i=>sf("rabattstaffel",form.rabattstaffel.filter((_,j)=>j!==i));
  const addAp=()=>sf("ansprechpartner",[...form.ansprechpartner,{anrede:"Herr",vorname:"",nachname:"",telefon:"",email:"",abteilung:""}]);
  const updAp=(i,k,v)=>sf("ansprechpartner",form.ansprechpartner.map((a,j)=>j===i?{...a,[k]:v}:a));
  const remAp=i=>sf("ansprechpartner",form.ansprechpartner.filter((_,j)=>j!==i));
  const renderTab=()=>{
    if(activeTab==="allgemein") return(
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <div style={{gridColumn:"1/-1"}}><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Firma *</label><input value={form.firma} onChange={e=>sf("firma",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Firmenzusatz</label><input value={form.firmenzusatz} onChange={e=>sf("firmenzusatz",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Lieferantennr.</label><input value={form.lieferantennr} onChange={e=>sf("lieferantennr",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Anrede</label><select value={form.anrede} onChange={e=>sf("anrede",e.target.value)} style={sS}>{["Herr","Frau","Divers","Firma"].map(a=><option key={a} value={a}>{a}</option>)}</select></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Titel</label><input value={form.titel} onChange={e=>sf("titel",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Vorname</label><input value={form.vorname} onChange={e=>sf("vorname",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Nachname</label><input value={form.nachname} onChange={e=>sf("nachname",e.target.value)} style={iS}/></div>
        </div>
        <div style={{borderTop:"1px solid var(--brd)",paddingTop:8,display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <div style={{gridColumn:"1/-1"}}><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Straße + Hausnr.</label><input value={form.strasse} onChange={e=>sf("strasse",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>PLZ</label><input value={form.plz} onChange={e=>sf("plz",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Ort</label><input value={form.ort} onChange={e=>sf("ort",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Land</label><select value={form.land} onChange={e=>sf("land",e.target.value)} style={sS}>{[["DE","Deutschland"],["AT","Österreich"],["CH","Schweiz"],["IT","Italien"],["FR","Frankreich"],["ES","Spanien"],["NL","Niederlande"],["PL","Polen"],["TR","Türkei"],["CN","China"],["US","USA"]].map(([v,l])=><option key={v} value={v}>{l}</option>)}</select></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Sprache</label><select value={form.sprache} onChange={e=>sf("sprache",e.target.value)} style={sS}>{[["de","Deutsch"],["en","Englisch"],["it","Italienisch"],["fr","Französisch"],["tr","Türkisch"]].map(([v,l])=><option key={v} value={v}>{l}</option>)}</select></div>
        </div>
        <div style={{borderTop:"1px solid var(--brd)",paddingTop:8,display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Telefon</label><input value={form.telefon} onChange={e=>sf("telefon",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Fax</label><input value={form.fax} onChange={e=>sf("fax",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>E-Mail</label><input value={form.email} onChange={e=>sf("email",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Website</label><input value={form.www} onChange={e=>sf("www",e.target.value)} style={iS}/></div>
        </div>
        <div style={{borderTop:"1px solid var(--brd)",paddingTop:8,display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>USt-IdNr.</label><input value={form.ustIdNr} onChange={e=>sf("ustIdNr",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Kreditorennr.</label><input value={form.kreditorennr} onChange={e=>sf("kreditorennr",e.target.value)} style={iS}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Bestellwährung</label><select value={form.bestellwaehrung} onChange={e=>sf("bestellwaehrung",e.target.value)} style={sS}>{["EUR","USD","GBP","CHF","PLN","TRY","CNY"].map(c=><option key={c} value={c}>{c}</option>)}</select></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Steuerschlüssel</label><select value={form.steuerschluessel} onChange={e=>sf("steuerschluessel",e.target.value)} style={sS}><option value="0">0 – Standard (19%)</option><option value="1">1 – Ermäßigt (7%)</option><option value="2">2 – Keine Steuer</option></select></div>
          <div style={{display:"flex",alignItems:"center",gap:8,paddingTop:4}}>
            <input type="checkbox" id="rdruck" checked={form.rechnungsdruck} onChange={e=>sf("rechnungsdruck",e.target.checked)} style={{accentColor:"var(--acc)"}}/>
            <label htmlFor="rdruck" style={{fontSize:12,color:"var(--t1)",cursor:"pointer"}}>Rechnungsdruck</label>
          </div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Status</label><select value={form.aktiv?"aktiv":"inaktiv"} onChange={e=>sf("aktiv",e.target.value==="aktiv")} style={sS}><option value="aktiv">Aktiv</option><option value="inaktiv">Inaktiv</option></select></div>
        </div>
        <div style={{borderTop:"1px solid var(--brd)",paddingTop:8}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
            <label style={{fontSize:11,color:"var(--t2)"}}>Brands</label>
            <Btn small onClick={()=>setShowBrandPicker(true)}>Auswählen…</Btn>
          </div>
          <div style={{display:"flex",flexWrap:"wrap",gap:4,minHeight:34,padding:"6px 8px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)"}}>
            {form.brands.length===0&&<span style={{fontSize:11,color:"var(--t3)"}}>Noch keine Brands zugewiesen</span>}
            {form.brands.map(b=><span key={b} onClick={()=>sf("brands",form.brands.filter(x=>x!==b))} style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:"var(--acc2)",color:"var(--acc)",fontWeight:600,cursor:"pointer"}}>{b} ×</span>)}
          </div>
        </div>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>Notizen</label><textarea value={form.notizen} onChange={e=>sf("notizen",e.target.value)} rows={2} style={{...iS,resize:"vertical"}}/></div>
      </div>
    );
    if(activeTab==="bankverbindungen") return(
      <div>
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:10}}><Btn small onClick={addBk}>+ Bankverbindung</Btn></div>
        {form.bankverbindungen.length===0&&<EmptyState icon="◇" title="Keine Bankverbindungen" sub="Füge Bankverbindungen für diesen Lieferanten hinzu"/>}
        {form.bankverbindungen.map((b,i)=>(
          <div key={i} style={{marginBottom:10,padding:12,borderRadius:8,border:"1px solid var(--brd)",background:"var(--s2)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
              <span style={{fontSize:12,fontWeight:600,color:"var(--t2)"}}>Bank {i+1}</span>
              <Btn small onClick={()=>remBk(i)} style={{color:"var(--red)"}}>✕</Btn>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
              {[["Kontoinhaber","kontoinhaber"],["Bank / Institut","bank"],["IBAN","iban"],["BIC / SWIFT","bic"]].map(([l,k])=>(
                <div key={k}><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>{l}</label><input value={b[k]||""} onChange={e=>updBk(i,k,e.target.value)} style={iS}/></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
    if(activeTab==="konditionen") return(
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          {[["Zahlungsziel (Tage)","zahlungsziel"],["Skonto (%)","skonto"],["Skontofrist (Tage)","skontoziel"],["Mindestbestellwert (€)","mindestbestellwert"]].map(([l,k])=>(
            <div key={k}><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3}}>{l}</label><input type="number" value={form.konditionen[k]||0} onChange={e=>sfk("konditionen",k,parseFloat(e.target.value)||0)} style={iS}/></div>
          ))}
        </div>
        <div style={{borderTop:"1px solid var(--brd)",paddingTop:12}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
            <div style={{fontSize:12,fontWeight:600,color:"var(--t1)"}}>Rabattstaffel</div>
            <Btn small onClick={addRs}>+ Staffel</Btn>
          </div>
          {form.rabattstaffel.length===0&&<EmptyState icon="◈" title="Keine Rabattstaffel" sub="Definiere mengen- oder wertbasierte Rabatte"/>}
          {form.rabattstaffel.length>0&&(
            <div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 32px",gap:6,marginBottom:6,fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px"}}>
                <span>Von (Stk/€)</span><span>Bis (Stk/€)</span><span>Rabatt %</span><span/>
              </div>
              {form.rabattstaffel.map((r,i)=>(
                <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 32px",gap:6,marginBottom:6}}>
                  <input type="number" value={r.von||0} onChange={e=>updRs(i,"von",parseFloat(e.target.value)||0)} style={iS}/>
                  <input type="number" value={r.bis||0} onChange={e=>updRs(i,"bis",parseFloat(e.target.value)||0)} style={iS}/>
                  <input type="number" value={r.prozent||0} onChange={e=>updRs(i,"prozent",parseFloat(e.target.value)||0)} style={iS}/>
                  <button onClick={()=>remRs(i)} style={{background:"var(--red2)",border:"none",borderRadius:6,color:"var(--red)",cursor:"pointer",fontSize:14,fontWeight:700}}>✕</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
    if(activeTab==="ansprechpartner") return(
      <div>
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:10}}><Btn small onClick={addAp}>+ Ansprechpartner</Btn></div>
        {form.ansprechpartner.length===0&&<EmptyState icon="◎" title="Keine Ansprechpartner" sub="Füge Ansprechpartner für diesen Lieferanten hinzu"/>}
        {form.ansprechpartner.map((a,i)=>(
          <div key={i} style={{marginBottom:10,padding:12,borderRadius:8,border:"1px solid var(--brd)",background:"var(--s2)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
              <span style={{fontSize:12,fontWeight:600,color:"var(--t2)"}}>{a.vorname||a.nachname?`${a.vorname} ${a.nachname}`.trim():`Ansprechpartner ${i+1}`}</span>
              <Btn small onClick={()=>remAp(i)} style={{color:"var(--red)"}}>✕</Btn>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
              <div><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Anrede</label><select value={a.anrede||"Herr"} onChange={e=>updAp(i,"anrede",e.target.value)} style={sS}>{["Herr","Frau","Divers"].map(x=><option key={x} value={x}>{x}</option>)}</select></div>
              {[["Vorname","vorname"],["Nachname","nachname"],["Telefon","telefon"],["E-Mail","email"],["Abteilung","abteilung"]].map(([l,k])=>(
                <div key={k}><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>{l}</label><input value={a[k]||""} onChange={e=>updAp(i,k,e.target.value)} style={iS}/></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
    return<EmptyState icon="◇" title="Keine Nachrichten" sub="Nachrichten aus JTL-Wawi werden hier angezeigt"/>;
  };
  return<>
    <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}><Btn primary onClick={openAdd}>+ Lieferant anlegen</Btn></div>
    <Card>
      <div style={{display:"grid",gridTemplateColumns:"1fr 130px 150px 100px 90px 64px",padding:"0 0 8px",borderBottom:"1px solid var(--brd)",fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:8}}>
        <span>Firma / Brands</span><span>Ort / Land</span><span>E-Mail</span><span>Kreditorennr.</span><span>Status</span><span/>
      </div>
      {lieferanten.map(l=><div key={l._id} style={{display:"grid",gridTemplateColumns:"1fr 130px 150px 100px 90px 64px",padding:"10px 0",borderBottom:"1px solid var(--brd)",fontSize:12,alignItems:"center",gap:8}}>
        <div>
          <div style={{fontWeight:600,color:"var(--t1)",marginBottom:3}}>{l.firma||l.name||"–"}</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:3}}>
            {(l.brands||[]).slice(0,5).map(b=><span key={b} style={{fontSize:9,padding:"1px 6px",borderRadius:3,background:"var(--acc2)",color:"var(--acc)",fontWeight:600}}>{b}</span>)}
            {(l.brands||[]).length>5&&<span style={{fontSize:9,color:"var(--t3)"}}>+{(l.brands||[]).length-5}</span>}
          </div>
        </div>
        <span style={{color:"var(--t2)",fontSize:11}}>{[l.ort,l.land].filter(Boolean).join(", ")||"–"}</span>
        <span style={{color:"var(--t2)",fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{l.email||"–"}</span>
        <span style={{color:"var(--t3)",fontSize:11,fontFamily:"'JetBrains Mono',monospace"}}>{l.kreditorennr||"–"}</span>
        <span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:l.aktiv!==false?"var(--grn2)":"var(--s3)",color:l.aktiv!==false?"var(--grn)":"var(--t3)",display:"inline-block"}}>{l.aktiv!==false?"aktiv":"inaktiv"}</span>
        <div style={{display:"flex",gap:4}}><Btn small onClick={()=>openEdit(l)}>Edit</Btn><Btn small onClick={()=>del(l._id)} disabled={deleting===l._id} style={{color:"var(--red)"}}>{deleting===l._id?"…":"✕"}</Btn></div>
      </div>)}
      {!lieferanten.length&&<EmptyState icon="◉" title="Noch keine Lieferanten" sub="Lieferanten anlegen um Einkaufspreise und Brands zu verwalten"/>}
    </Card>
    {modal&&<Modal open={true} onClose={()=>setModal(null)} title={modal==="add"?"Lieferant anlegen":`${form.firma||"Lieferant"} bearbeiten`} width={800}>
      <div style={{marginBottom:14}}>
        <Tabs tabs={[{k:"allgemein",l:"Allgemeine Daten"},{k:"bankverbindungen",l:"Bankverbindungen"},{k:"konditionen",l:"Konditionen"},{k:"ansprechpartner",l:"Ansprechpartner"},{k:"nachrichten",l:"Nachrichten"}]} active={activeTab} onChange={setActiveTab}/>
      </div>
      <div style={{minHeight:280,maxHeight:"58vh",overflowY:"auto",paddingRight:4}}>
        {renderTab()}
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:12,marginTop:12,borderTop:"1px solid var(--brd)"}}>
        <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
        <Btn primary onClick={save} disabled={saving||!form.firma.trim()}>{saving?"Speichere…":"Speichern"}</Btn>
      </div>
    </Modal>}
    {showBrandPicker&&<BrandPicker selected={form.brands} onSave={b=>{sf("brands",b);setShowBrandPicker(false);}} onClose={()=>setShowBrandPicker(false)}/>}
  </>;
};

/* ─── Kontostände ─── */
const ZEITRAUM_OPTS=[
  {k:"heute",l:"Heute"},{k:"gestern",l:"Gestern"},
  {k:"1m",l:"1 Monat"},{k:"3m",l:"3 Monate"},{k:"6m",l:"6 Monate"},{k:"12m",l:"12 Monate"},
  {k:"ytd",l:"Dieses Jahr"},{k:"lj",l:"Letztes Jahr"},{k:"jahr",l:"Jahr ▾"},{k:"custom",l:"Zeitraum wählen"},
];
const VERFUEGBARE_JAHRE=Array.from({length:new Date().getFullYear()-2021},(_,i)=>new Date().getFullYear()-i);
const zeitraumDates=z=>{
  const now=new Date();const bis=new Date(now.toISOString().slice(0,10));
  if(z==="heute"){return{von:new Date(bis),bis:new Date(bis)};}
  if(z==="gestern"){const g=new Date(bis);g.setDate(g.getDate()-1);return{von:new Date(g),bis:new Date(g)};}
  if(z==="1m"){const v=new Date(bis);v.setMonth(v.getMonth()-1);return{von:v,bis};}
  if(z==="3m"){const v=new Date(bis);v.setMonth(v.getMonth()-3);return{von:v,bis};}
  if(z==="6m"){const v=new Date(bis);v.setMonth(v.getMonth()-6);return{von:v,bis};}
  if(z==="12m"){const v=new Date(bis);v.setFullYear(v.getFullYear()-1);return{von:v,bis};}
  if(z==="ytd"){return{von:new Date(now.getFullYear(),0,1),bis};}
  if(z==="lj"){const y=now.getFullYear()-1;return{von:new Date(y,0,1),bis:new Date(y,11,31)};}
  return{von:new Date(bis.getFullYear(),0,1),bis};
};
const fmtIso=d=>d instanceof Date?d.toISOString().slice(0,10):d;
const SaldoBar=({saldo,farbe})=>{
  const neg=saldo<0;
  return<div style={{display:"flex",alignItems:"center",gap:8}}>
    <span style={{fontSize:18,fontWeight:700,color:neg?"var(--red)":saldo>0?"var(--grn)":"var(--t1)",letterSpacing:"-.5px",fontFamily:"'JetBrains Mono',monospace"}}>{fmt(saldo)}</span>
    {neg&&<span style={{fontSize:10,color:"var(--red)",padding:"1px 6px",borderRadius:4,background:"var(--red2)",fontWeight:600}}>NEGATIV</span>}
  </div>;
};
const MiniVerlauf=({data,farbe})=>{
  if(!data||data.length<2) return<div style={{height:40,display:"flex",alignItems:"center",justifyContent:"center",color:"var(--t3)",fontSize:10}}>Keine Daten</div>;
  const vals=data.map(d=>d.saldo);
  const min=Math.min(...vals),max=Math.max(...vals);
  const range=max-min||1;
  const W=180,H=40;
  const pts=data.map((d,i)=>`${i/(data.length-1)*W},${H-(d.saldo-min)/range*H}`).join(' ');
  return<svg width={W} height={H} style={{overflow:"visible"}}>
    <polyline points={pts} fill="none" stroke={farbe||"var(--acc)"} strokeWidth={2} strokeLinejoin="round"/>
    <polyline points={`0,${H} ${pts} ${W},${H}`} fill={`${farbe||"#6366f1"}22`} stroke="none"/>
  </svg>;
};
const Kontostände=()=>{
  const [zeitraum,setZeitraum]=useState("ytd");
  const [vonStr,setVonStr]=useState(()=>new Date(new Date().getFullYear(),0,1).toISOString().slice(0,10));
  const [bisStr,setBisStr]=useState(()=>new Date().toISOString().slice(0,10));
  const [jahr,setJahr]=useState(String(new Date().getFullYear()));
  const [konten,setKonten]=useState([]);
  const [uebersicht,setUebersicht]=useState([]);
  const [verlauf,setVerlauf]=useState({});
  const [loading,setLoading]=useState(true);
  const [detail,setDetail]=useState(null);
  const [bewegungen,setBewegungen]=useState([]);
  const [bLoading,setBLoading]=useState(false);
  const [bPage,setBPage]=useState(1);
  const [bTotal,setBTotal]=useState(0);
  const [bSearch,setBSearch]=useState("");
  const [bFilter,setBFilter]=useState({umbuchung:""});
  const [vergleich,setVergleich]=useState(false);
  const [vergleichKeys,setVergleichKeys]=useState([]);

  const getVonBis=()=>{
    if(zeitraum==="custom") return{von:vonStr,bis:bisStr};
    if(zeitraum==="jahr") return{von:`${jahr}-01-01`,bis:`${jahr}-12-31`};
    const d=zeitraumDates(zeitraum);
    return{von:fmtIso(d.von),bis:fmtIso(d.bis)};
  };

  const load=async()=>{
    setLoading(true);
    const {von,bis}=getVonBis();
    try{
      const [k,u,v]=await Promise.all([
        fetch("/api/cashflow/konten").then(r=>r.json()),
        fetch(`/api/cashflow/uebersicht?von=${von}&bis=${bis}`).then(r=>r.json()),
        fetch(`/api/cashflow/verlauf?von=${von}&bis=${bis}&interval=month`).then(r=>r.json()),
      ]);
      setKonten(Array.isArray(k)?k:[]);
      setUebersicht(Array.isArray(u)?u:[]);
      setVerlauf(v||{});
    }catch(e){}
    setLoading(false);
  };

  const loadBewegungen=async(kontoKey,page=1,search="",filter={})=>{
    setBLoading(true);
    const {von,bis}=getVonBis();
    let url=`/api/cashflow/bewegungen?konto=${kontoKey}&von=${von}&bis=${bis}&page=${page}&limit=100`;
    if(search) url+=`&search=${encodeURIComponent(search)}`;
    if(filter.umbuchung) url+=`&umbuchung=${filter.umbuchung}`;
    try{
      const d=await fetch(url).then(r=>r.json());
      setBewegungen(d.docs||[]);setBTotal(d.total||0);setBPage(page);
    }catch(e){}
    setBLoading(false);
  };

  useEffect(()=>{load();},[zeitraum,vonStr,bisStr,jahr]);
  useEffect(()=>{if(detail){setBSearch("");setBFilter({umbuchung:""});loadBewegungen(detail.key,1);}else{setBewegungen([]);}},[detail,zeitraum,vonStr,bisStr,jahr]);

  const iS={width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};
  const sS={...iS,cursor:"pointer"};

  const totalSaldo=(uebersicht||[]).reduce((s,k)=>s+(k.saldo||0),0);
  const gesamtEinnahmen=(uebersicht||[]).reduce((s,k)=>s+(k.einnahmen||0),0);
  const gesamtAusgaben=(uebersicht||[]).reduce((s,k)=>s+(k.ausgaben||0),0);

  if(detail) return<>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:18}}>
      <button onClick={()=>setDetail(null)} style={{padding:"5px 12px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t2)",fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>← Zurück</button>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <div style={{width:12,height:12,borderRadius:"50%",background:detail.farbe}}/>
        <span style={{fontSize:15,fontWeight:700,color:"var(--t1)"}}>{detail.name}</span>
        <span style={{fontSize:11,color:"var(--t3)",fontFamily:"'JetBrains Mono',monospace"}}>{detail.kontonr}</span>
      </div>
      <div style={{marginLeft:"auto"}}><SaldoBar saldo={detail.saldo||0} farbe={detail.farbe}/></div>
    </div>
    <Card style={{marginBottom:12}}>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
        <input value={bSearch} onChange={e=>{setBSearch(e.target.value);loadBewegungen(detail.key,1,e.target.value,bFilter);}} placeholder="Suche Empfänger / Verwendungszweck…" style={{...iS,maxWidth:300}}/>
        <select value={bFilter.umbuchung} onChange={e=>{const f={...bFilter,umbuchung:e.target.value};setBFilter(f);loadBewegungen(detail.key,1,bSearch,f);}} style={{...sS,maxWidth:160}}>
          <option value="">Alle Buchungen</option>
          <option value="false">Ohne Umbuchungen</option>
          <option value="true">Nur Umbuchungen</option>
        </select>
        <span style={{fontSize:11,color:"var(--t3)",marginLeft:"auto"}}>{bTotal} Buchungen</span>
      </div>
    </Card>
    <Card style={{padding:0,overflow:"hidden"}}>
      <div style={{display:"grid",gridTemplateColumns:"90px 80px 1fr 160px 90px 80px",padding:"8px 16px",borderBottom:"1px solid var(--brd)",fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:8}}>
        <span>Datum</span><span>Valuta</span><span>Empfänger / Verwendungszweck</span><span>Kategorie</span><span style={{textAlign:"right"}}>Betrag</span><span>Typ</span>
      </div>
      {bLoading&&<div style={{padding:24,textAlign:"center",color:"var(--t3)",fontSize:12}}>Lade…</div>}
      {!bLoading&&bewegungen.length===0&&<EmptyState icon="◇" title="Keine Buchungen" sub="Für diesen Zeitraum und Filter keine Ergebnisse"/>}
      {!bLoading&&bewegungen.map((b,i)=><div key={i} style={{display:"grid",gridTemplateColumns:"90px 80px 1fr 160px 90px 80px",padding:"8px 16px",borderBottom:"1px solid var(--brd)",fontSize:11,alignItems:"center",gap:8,background:b.umbuchung?"var(--ylw2)":b.betrag>0?"var(--grn2)":"transparent"}}>
        <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t2)"}}>{fmtDate(b.datum)}</span>
        <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t3)"}}>{fmtDate(b.valuta)}</span>
        <div style={{minWidth:0}}>
          <div style={{fontWeight:500,color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{b.empfaenger||"–"}</div>
          <div style={{fontSize:9,color:"var(--t3)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",marginTop:1}}>{b.verwendungszweck||""}</div>
        </div>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {b.umbuchung&&<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"var(--ylw2)",color:"var(--ylw)",fontWeight:600}}>UMBUCHUNG</span>}
          {b.marktplatz&&<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"var(--acc2)",color:"var(--acc)",fontWeight:600}}>{b.marktplatz}</span>}
          {b.kategorie&&b.kategorie!=="sonstiges"&&!b.marktplatz&&<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"var(--s3)",color:"var(--t2)",fontWeight:600}}>{b.kategorie}</span>}
        </div>
        <span style={{textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontWeight:600,color:b.betrag>0?"var(--grn)":b.betrag<0?"var(--red)":"var(--t2)"}}>{fmt(b.betrag)}</span>
        <span style={{fontSize:9,color:"var(--t3)"}}>{b.dateiname?.slice(0,14)||""}</span>
      </div>)}
      {bTotal>100&&<div style={{padding:"10px 16px",display:"flex",gap:8,justifyContent:"center",borderTop:"1px solid var(--brd)"}}>
        {bPage>1&&<Btn small onClick={()=>loadBewegungen(detail.key,bPage-1,bSearch,bFilter)}>← Zurück</Btn>}
        <span style={{fontSize:11,color:"var(--t3)",padding:"4px 0"}}>{bPage} / {Math.ceil(bTotal/100)}</span>
        {bPage*100<bTotal&&<Btn small onClick={()=>loadBewegungen(detail.key,bPage+1,bSearch,bFilter)}>Weiter →</Btn>}
      </div>}
    </Card>
  </>;

  return<>
    <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center",marginBottom:18}}>
      <div style={{display:"flex",gap:4,background:"var(--s2)",borderRadius:8,padding:3}}>
        {ZEITRAUM_OPTS.map(o=><button key={o.k} onClick={()=>setZeitraum(o.k)} style={{padding:"5px 12px",borderRadius:5,border:"none",fontSize:11,fontWeight:500,cursor:"pointer",fontFamily:"inherit",background:zeitraum===o.k?"var(--acc)":"transparent",color:zeitraum===o.k?"#fff":"var(--t2)",transition:"all .15s"}}>{o.l}</button>)}
      </div>
      {zeitraum==="jahr"&&<select value={jahr} onChange={e=>{setJahr(e.target.value);}} style={{...iS,maxWidth:90,cursor:"pointer"}}>
        {VERFUEGBARE_JAHRE.map(y=><option key={y} value={y}>{y}</option>)}
      </select>}
      {zeitraum==="custom"&&<>
        <input type="date" value={vonStr} onChange={e=>setVonStr(e.target.value)} style={{...iS,maxWidth:145}}/>
        <span style={{color:"var(--t3)",fontSize:11}}>bis</span>
        <input type="date" value={bisStr} onChange={e=>setBisStr(e.target.value)} style={{...iS,maxWidth:145}}/>
      </>}
      <div style={{marginLeft:"auto",display:"flex",gap:8,alignItems:"center"}}>
        <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:12,color:vergleich?"var(--acc)":"var(--t2)"}}>
          <input type="checkbox" checked={vergleich} onChange={e=>setVergleich(e.target.checked)} style={{accentColor:"var(--acc)"}}/>
          Vergleichen
        </label>
      </div>
    </div>

    {loading&&<div style={{padding:40,textAlign:"center",color:"var(--t3)",fontSize:12}}>Lade Kontostände…</div>}
    {!loading&&<>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:14,marginBottom:22}}>
        {uebersicht.map(k=><Card key={k.key}
          onClick={()=>setDetail(k)}
          style={{cursor:"pointer",position:"relative",overflow:"hidden",transition:"border-color .15s"}}
          onMouseEnter={e=>e.currentTarget.style.borderColor=k.farbe}
          onMouseLeave={e=>e.currentTarget.style.borderColor="var(--brd)"}>
          <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:k.farbe,borderRadius:"12px 12px 0 0"}}/>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:4,marginBottom:8}}>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:"var(--t1)"}}>{k.name}</div>
              <div style={{fontSize:10,color:"var(--t3)",fontFamily:"'JetBrains Mono',monospace"}}>{k.kontonr}</div>
            </div>
            {vergleich&&<input type="checkbox" checked={vergleichKeys.includes(k.key)} onChange={e=>{e.stopPropagation();setVergleichKeys(prev=>e.target.checked?[...prev,k.key]:prev.filter(x=>x!==k.key));}} style={{accentColor:k.farbe,width:16,height:16}} onClick={e=>e.stopPropagation()}/>}
          </div>
          <SaldoBar saldo={k.saldo||0} farbe={k.farbe}/>
          <div style={{marginTop:10,paddingTop:10,borderTop:"1px solid var(--brd)",display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,fontSize:10}}>
            <div><div style={{color:"var(--t3)"}}>Einnahmen</div><div style={{color:"var(--grn)",fontWeight:600,fontFamily:"'JetBrains Mono',monospace"}}>{fmt(k.einnahmen)}</div></div>
            <div><div style={{color:"var(--t3)"}}>Ausgaben</div><div style={{color:"var(--red)",fontWeight:600,fontFamily:"'JetBrains Mono',monospace"}}>{fmt(Math.abs(k.ausgaben))}</div></div>
            <div><div style={{color:"var(--t3)"}}>Buchungen</div><div style={{color:"var(--t1)",fontWeight:600}}>{k.buchungen}</div></div>
          </div>
          {verlauf[k.key]&&verlauf[k.key].length>1&&<div style={{marginTop:10,paddingTop:8,borderTop:"1px solid var(--brd)"}}>
            <MiniVerlauf data={verlauf[k.key]} farbe={k.farbe}/>
          </div>}
        </Card>)}

        <Card style={{position:"relative",overflow:"hidden",borderStyle:"dashed"}}>
          <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:"var(--acc)",borderRadius:"12px 12px 0 0"}}/>
          <div style={{marginTop:4,marginBottom:8}}>
            <div style={{fontSize:13,fontWeight:700,color:"var(--t1)"}}>Gesamt</div>
            <div style={{fontSize:10,color:"var(--t3)"}}>Alle Konten</div>
          </div>
          <SaldoBar saldo={totalSaldo} farbe="var(--acc)"/>
          <div style={{marginTop:10,paddingTop:10,borderTop:"1px solid var(--brd)",display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,fontSize:10}}>
            <div><div style={{color:"var(--t3)"}}>Einnahmen ges.</div><div style={{color:"var(--grn)",fontWeight:600,fontFamily:"'JetBrains Mono',monospace"}}>{fmt(gesamtEinnahmen)}</div></div>
            <div><div style={{color:"var(--t3)"}}>Ausgaben ges.</div><div style={{color:"var(--red)",fontWeight:600,fontFamily:"'JetBrains Mono',monospace"}}>{fmt(Math.abs(gesamtAusgaben))}</div></div>
          </div>
        </Card>
      </div>

      {vergleich&&vergleichKeys.length>=2&&<Card style={{marginBottom:18}}>
        <div style={{fontSize:12,fontWeight:600,color:"var(--t1)",marginBottom:12}}>Vergleich: {vergleichKeys.map(k=>uebersicht.find(u=>u.key===k)?.name||k).join(" vs. ")}</div>
        <div style={{display:"grid",gridTemplateColumns:`repeat(${vergleichKeys.length},1fr)`,gap:16}}>
          {vergleichKeys.map(k=>{const u=uebersicht.find(x=>x.key===k);if(!u)return null;return<div key={k}>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:8}}>
              <div style={{width:10,height:10,borderRadius:"50%",background:u.farbe}}/>
              <span style={{fontSize:12,fontWeight:600,color:"var(--t1)"}}>{u.name}</span>
            </div>
            <div style={{fontSize:18,fontWeight:700,color:u.saldo<0?"var(--red)":"var(--grn)",fontFamily:"'JetBrains Mono',monospace"}}>{fmt(u.saldo)}</div>
            <div style={{marginTop:8,fontSize:10,color:"var(--t3)"}}>Ø Saldo-Diff zu Periode: <strong style={{color:"var(--t1)"}}>{fmt((u.saldo||0)-(u.saldoVon||0))}</strong></div>
            {verlauf[k]&&<div style={{marginTop:8}}><MiniVerlauf data={verlauf[k]} farbe={u.farbe}/></div>}
          </div>;})}
        </div>
      </Card>}

      {uebersicht.length===0&&<EmptyState icon="◇" title="Keine Kontodaten" subtitle="Importiere Kontoauszüge mit: node bank-import.js --dir ./daten"/>}
    </>}
  </>;
};

/* ─── Lieferantenauswertung ─── */
const Lieferantenauswertung=()=>{
  const [zeitraum,setZeitraum]=useState("ytd");
  const [vonStr,setVonStr]=useState(()=>new Date(new Date().getFullYear(),0,1).toISOString().slice(0,10));
  const [bisStr,setBisStr]=useState(()=>new Date().toISOString().slice(0,10));
  const [jahr,setJahr]=useState(String(new Date().getFullYear()));
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(false);
  const [drilldown,setDrilldown]=useState(null);
  const [bewegungen,setBewegungen]=useState([]);
  const [matching,setMatching]=useState(false);
  const [matchResult,setMatchResult]=useState(null);
  const iS={padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  const getVonBis=()=>{
    if(zeitraum==="custom") return{von:vonStr,bis:bisStr};
    if(zeitraum==="jahr") return{von:`${jahr}-01-01`,bis:`${jahr}-12-31`};
    const d=zeitraumDates(zeitraum);
    return{von:fmtIso(d.von),bis:fmtIso(d.bis)};
  };

  const runMatch=async()=>{
    setMatching(true);setMatchResult(null);
    try{
      const r=await fetch("/api/cashflow/lieferant-match",{method:"POST"}).then(d=>d.json());
      setMatchResult(r);
      load();
    }catch(e){setMatchResult({error:String(e)});}
    setMatching(false);
  };

  const load=async()=>{
    setLoading(true);
    const {von,bis}=getVonBis();
    try{
      const d=await fetch(`/api/cashflow/lieferantenauswertung?von=${von}&bis=${bis}`).then(r=>r.json());
      setData(d);
    }catch(e){}
    setLoading(false);
  };

  const loadDrilldown=async(lieferantId)=>{
    const {von,bis}=getVonBis();
    try{
      const d=await fetch(`/api/cashflow/bewegungen?von=${von}&bis=${bis}&limit=500`).then(r=>r.json());
      setBewegungen((d.docs||[]).filter(b=>b.lieferantId===lieferantId));
    }catch(e){}
  };

  useEffect(()=>{load();},[zeitraum,vonStr,bisStr,jahr]);

  return<>
    <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center",marginBottom:18}}>
      <div style={{display:"flex",gap:4,background:"var(--s2)",borderRadius:8,padding:3}}>
        {ZEITRAUM_OPTS.map(o=><button key={o.k} onClick={()=>setZeitraum(o.k)} style={{padding:"5px 12px",borderRadius:5,border:"none",fontSize:11,fontWeight:500,cursor:"pointer",fontFamily:"inherit",background:zeitraum===o.k?"var(--acc)":"transparent",color:zeitraum===o.k?"#fff":"var(--t2)",transition:"all .15s"}}>{o.l}</button>)}
      </div>
      {zeitraum==="jahr"&&<select value={jahr} onChange={e=>{setJahr(e.target.value);}} style={{...iS,maxWidth:90,cursor:"pointer"}}>
        {VERFUEGBARE_JAHRE.map(y=><option key={y} value={y}>{y}</option>)}
      </select>}
      {zeitraum==="custom"&&<>
        <input type="date" value={vonStr} onChange={e=>setVonStr(e.target.value)} style={{...iS,maxWidth:145}}/>
        <span style={{color:"var(--t3)",fontSize:11}}>bis</span>
        <input type="date" value={bisStr} onChange={e=>setBisStr(e.target.value)} style={{...iS,maxWidth:145}}/>
      </>}
      <div style={{marginLeft:"auto",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
        {matchResult&&!matchResult.error&&<span style={{fontSize:11,color:"var(--grn)",fontWeight:600}}>✓ {matchResult.matched} Buchungen zugeordnet</span>}
        {matchResult?.error&&<span style={{fontSize:11,color:"var(--red)"}}>{matchResult.error}</span>}
        <button onClick={runMatch} disabled={matching} style={{padding:"6px 14px",borderRadius:6,border:"1px solid var(--acc)",background:"transparent",color:"var(--acc)",fontSize:11,fontWeight:600,cursor:matching?"not-allowed":"pointer",fontFamily:"inherit",opacity:matching?.6:1}}>
          {matching?"…":"⟳ Lieferanten zuordnen"}
        </button>
        {data&&<>
          <span style={{fontSize:11,color:"var(--t3)"}}>Gesamtausgaben</span>
          <span style={{fontSize:18,fontWeight:700,color:"var(--red)",fontFamily:"'JetBrains Mono',monospace"}}>{fmt(data.totalAusgaben)}</span>
        </>}
      </div>
    </div>

    {data&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
      <Card>
        <div style={{fontSize:12,fontWeight:700,color:"var(--t1)",marginBottom:12}}>Lieferanten ({(data.lieferanten||[]).length})</div>
        {(data.lieferanten||[]).length===0&&<EmptyState icon="◉" title="Keine Lieferantenzahlungen" sub="Buchungen werden automatisch zugeordnet wenn Lieferanten in der Lieferantenverwaltung gepflegt sind"/>}
        {(data.lieferanten||[]).map((l,i)=><div key={i}
          onClick={()=>{setDrilldown(drilldown===l.lieferantId?null:l.lieferantId);loadDrilldown(l.lieferantId);}}
          style={{display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid var(--brd)",cursor:"pointer",background:drilldown===l.lieferantId?"var(--acc2)":"transparent",margin:"0 -8px",padding:"9px 8px",borderRadius:drilldown===l.lieferantId?6:0}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontWeight:600,color:"var(--t1)",fontSize:12,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{l.name}</div>
            <div style={{fontSize:10,color:"var(--t3)"}}>{l.anzahl} Buchungen</div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{fontFamily:"'JetBrains Mono',monospace",fontWeight:700,color:"var(--red)",fontSize:13}}>{fmt(l.gesamt)}</div>
            <div style={{fontSize:10,color:"var(--t3)"}}>{l.anteil.toFixed(1)} %</div>
          </div>
          <div style={{width:60,height:6,borderRadius:3,background:"var(--s3)",overflow:"hidden"}}>
            <div style={{width:`${Math.min(100,l.anteil)}%`,height:"100%",background:"var(--red)",borderRadius:3}}/>
          </div>
        </div>)}
      </Card>

      <Card>
        <div style={{fontSize:12,fontWeight:700,color:"var(--t1)",marginBottom:12}}>Sonstige Ausgaben (Top 50)</div>
        {(data.sonstige||[]).map((s,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"7px 0",borderBottom:"1px solid var(--brd)",fontSize:11}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s.empfaenger||"–"}</div>
            {s.kategorie&&s.kategorie!=="sonstiges"&&<span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:"var(--acc2)",color:"var(--acc)",fontWeight:600}}>{s.marktplatz||s.kategorie}</span>}
          </div>
          <span style={{fontSize:10,color:"var(--t3)"}}>{s.anzahl}×</span>
          <span style={{fontFamily:"'JetBrains Mono',monospace",fontWeight:600,color:"var(--red)",whiteSpace:"nowrap"}}>{fmt(s.gesamt)}</span>
        </div>)}
        {(data.sonstige||[]).length===0&&<EmptyState icon="◈" title="Keine sonstigen Ausgaben" sub="Alle Ausgaben wurden Lieferanten zugeordnet"/>}
      </Card>
    </div>}

    {drilldown&&bewegungen.length>0&&<Card style={{marginTop:16}}>
      <div style={{fontSize:12,fontWeight:700,color:"var(--t1)",marginBottom:10}}>Buchungsdetail – {(data?.lieferanten||[]).find(l=>l.lieferantId===drilldown)?.name}</div>
      <div style={{display:"grid",gridTemplateColumns:"90px 1fr 120px 90px",gap:8,fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",paddingBottom:6,borderBottom:"1px solid var(--brd)"}}>
        <span>Datum</span><span>Verwendungszweck</span><span>Konto</span><span style={{textAlign:"right"}}>Betrag</span>
      </div>
      {bewegungen.map((b,i)=><div key={i} style={{display:"grid",gridTemplateColumns:"90px 1fr 120px 90px",gap:8,padding:"6px 0",borderBottom:"1px solid var(--brd)",fontSize:11,alignItems:"center"}}>
        <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t3)"}}>{fmtDate(b.datum)}</span>
        <span style={{color:"var(--t2)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{b.verwendungszweck||b.empfaenger||"–"}</span>
        <span style={{fontSize:10,color:"var(--t3)"}}>{b.kontoKey}</span>
        <span style={{textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontWeight:600,color:"var(--red)"}}>{fmt(b.betrag)}</span>
      </div>)}
    </Card>}
  </>;
};

/* ─── Artikeleinkaufspreise ─── */
const ArtikelEinkaufspreise=()=>{
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(false);
  const [importing,setImporting]=useState(false);
  const [importResult,setImportResult]=useState(null);
  const [page,setPage]=useState(1);
  const [saison,setSaison]=useState("");
  const [ohnePreis,setOhnePreis]=useState(false);
  const [search,setSearch]=useState("");
  const [searchInput,setSearchInput]=useState("");
  const iS={padding:"7px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  const load=async(p=page)=>{
    setLoading(true);
    try{
      const params=new URLSearchParams({page:p,limit:50});
      if(saison) params.set("saison",saison);
      if(ohnePreis) params.set("ohnePreis","true");
      if(search) params.set("search",search);
      const d=await fetch("/api/einkauf/artikeleinkaufspreise?"+params).then(r=>r.json());
      setData(d);
    }catch(e){}
    setLoading(false);
  };

  const doImport=async()=>{
    setImporting(true);setImportResult(null);
    try{
      const r=await fetch("/api/einkauf/preise-import",{method:"POST"}).then(d=>d.json());
      setImportResult(r);
      load(1);
    }catch(e){setImportResult({error:String(e)});}
    setImporting(false);
  };

  useEffect(()=>{load(1);setPage(1);},[saison,ohnePreis,search]);

  const cleanVal=v=>typeof v==="string"?v.replace(/^"|"$/g,"").trim():v;

  const saisonLabel=s=>{
    const raw=cleanVal(s);
    if(!raw||raw==="YRB") return "Saisonlos (YRB)";
    return raw;
  };

  const fmtHek=v=>v!=null?v.toFixed(2)+" €":"–";

  const pages=data?Math.ceil(data.total/50):1;

  return<>
    <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center",marginBottom:16}}>
      {/* Saison-Filter */}
      <select value={saison} onChange={e=>setSaison(e.target.value)} style={{...iS,maxWidth:180}}>
        <option value="">Alle Saisonen</option>
        {(data?.saisons||[]).map(s=><option key={s} value={s}>{saisonLabel(s)}</option>)}
      </select>

      {/* Ohne Preis Toggle */}
      <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:12,color:ohnePreis?"var(--red)":"var(--t2)",padding:"7px 12px",borderRadius:7,border:"1px solid",borderColor:ohnePreis?"var(--red)":"var(--brd)",background:ohnePreis?"var(--red2)":"transparent",userSelect:"none"}}>
        <input type="checkbox" checked={ohnePreis} onChange={e=>setOhnePreis(e.target.checked)} style={{accentColor:"var(--red)"}}/>
        Ohne Einkaufspreis
      </label>

      {/* Suche */}
      <input value={searchInput} onChange={e=>setSearchInput(e.target.value)}
        onKeyDown={e=>{if(e.key==="Enter"){setSearch(searchInput);setPage(1);}}}
        placeholder="Brand oder Artikelname …" style={{...iS,width:220}}/>
      <button onClick={()=>{setSearch(searchInput);setPage(1);}} style={{padding:"7px 14px",borderRadius:7,border:"none",background:"var(--acc)",color:"#fff",fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>Suchen</button>
      {search&&<button onClick={()=>{setSearch("");setSearchInput("");}} style={{padding:"7px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"transparent",color:"var(--t2)",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>✕</button>}

      {/* Preise importieren */}
      <div style={{marginLeft:"auto",display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
        {importResult&&!importResult.error&&<span style={{fontSize:11,color:"var(--grn)",fontWeight:600}}>✓ {importResult.imported.toLocaleString("de")} Preise aus {importResult.files} Dateien</span>}
        {importResult?.error&&<span style={{fontSize:11,color:"var(--red)"}}>{importResult.error}</span>}
        <button onClick={doImport} disabled={importing} title="Liest alle ready4import CSVs aus MinIO und verknüpft EANs mit Produkten" style={{padding:"7px 16px",borderRadius:7,border:"1px solid var(--acc)",background:"transparent",color:"var(--acc)",fontSize:12,fontWeight:600,cursor:importing?"not-allowed":"pointer",fontFamily:"inherit",opacity:importing?.6:1}}>
          {importing?"Importiere …":"⟳ Preise aus MinIO laden"}
        </button>
      </div>
    </div>

    {/* Statistik-Zeile */}
    {data&&<div style={{display:"flex",gap:20,marginBottom:14,padding:"10px 14px",background:"var(--s2)",borderRadius:8,fontSize:12}}>
      <span style={{color:"var(--t3)"}}>Produkte gesamt: <b style={{color:"var(--t1)"}}>{data.total.toLocaleString("de")}</b></span>
      <span style={{color:"var(--t3)"}}>Seite <b style={{color:"var(--t1)"}}>{page}</b> / {pages}</span>
    </div>}

    {/* Tabelle */}
    <Card style={{padding:0,overflow:"hidden"}}>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{background:"var(--s2)",borderBottom:"2px solid var(--brd)"}}>
              {["Brand / Artikel","Saison","Varianten","Lieferanten","HEK min","HEK max","UVP"].map(h=>(
                <th key={h} style={{padding:"10px 12px",textAlign:"left",fontWeight:700,color:"var(--t2)",fontSize:10,textTransform:"uppercase",letterSpacing:".5px",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading&&<tr><td colSpan={7} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade …</td></tr>}
            {!loading&&data&&(data.docs||[]).length===0&&<tr><td colSpan={7} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Artikel gefunden</td></tr>}
            {!loading&&(data?.docs||[]).map((p,i)=>(
              <tr key={p.p_nr||i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--s1)"}}>
                <td style={{padding:"9px 12px",maxWidth:280}}>
                  <div style={{fontWeight:600,color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{cleanVal(p.brand)||"–"}</div>
                  <div style={{fontSize:10,color:"var(--t3)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{cleanVal(p.name)||p.p_nr}</div>
                </td>
                <td style={{padding:"9px 12px",whiteSpace:"nowrap"}}>
                  <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"var(--s3)",color:"var(--t2)",fontWeight:500}}>{saisonLabel(p.saison)}</span>
                </td>
                <td style={{padding:"9px 12px",textAlign:"center",color:"var(--t2)",fontWeight:500}}>{p.variantenCount}</td>
                <td style={{padding:"9px 12px"}}>
                  {p.lieferantenCount===0
                    ?<span style={{fontSize:10,color:"var(--t3)"}}>–</span>
                    :<div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                      {(p.lieferantenList||[]).slice(0,3).map((l,j)=>(
                        <span key={j} style={{fontSize:9,padding:"1px 6px",borderRadius:3,background:"var(--acc2)",color:"var(--acc)",fontWeight:600,whiteSpace:"nowrap"}}>{l}</span>
                      ))}
                      {(p.lieferantenList||[]).length>3&&<span style={{fontSize:9,color:"var(--t3)"}}>+{p.lieferantenList.length-3}</span>}
                    </div>
                  }
                </td>
                <td style={{padding:"9px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontWeight:600,color:p.hekMin!=null?"var(--grn)":"var(--t3)",whiteSpace:"nowrap"}}>{fmtHek(p.hekMin)}</td>
                <td style={{padding:"9px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontWeight:500,color:p.hekMax!=null?"var(--t1)":"var(--t3)",whiteSpace:"nowrap"}}>{fmtHek(p.hekMax)}</td>
                <td style={{padding:"9px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"var(--t2)",whiteSpace:"nowrap"}}>{fmtHek(p.uvpMax)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>

    {/* Pagination */}
    {data&&pages>1&&<div style={{display:"flex",gap:4,justifyContent:"center",marginTop:14,flexWrap:"wrap"}}>
      <button onClick={()=>{setPage(1);load(1);}} disabled={page===1} style={{padding:"5px 10px",borderRadius:5,border:"1px solid var(--brd)",background:"transparent",color:"var(--t2)",cursor:"pointer",fontFamily:"inherit",fontSize:11}}>«</button>
      <button onClick={()=>{const p=Math.max(1,page-1);setPage(p);load(p);}} disabled={page===1} style={{padding:"5px 10px",borderRadius:5,border:"1px solid var(--brd)",background:"transparent",color:"var(--t2)",cursor:"pointer",fontFamily:"inherit",fontSize:11}}>‹</button>
      {Array.from({length:Math.min(7,pages)},(_,i)=>{
        let pg;
        if(pages<=7) pg=i+1;
        else if(page<=4) pg=i+1;
        else if(page>=pages-3) pg=pages-6+i;
        else pg=page-3+i;
        return<button key={pg} onClick={()=>{setPage(pg);load(pg);}} style={{padding:"5px 10px",borderRadius:5,border:"1px solid",borderColor:pg===page?"var(--acc)":"var(--brd)",background:pg===page?"var(--acc)":"transparent",color:pg===page?"#fff":"var(--t2)",cursor:"pointer",fontFamily:"inherit",fontSize:11,fontWeight:pg===page?700:400}}>{pg}</button>;
      })}
      <button onClick={()=>{const p=Math.min(pages,page+1);setPage(p);load(p);}} disabled={page===pages} style={{padding:"5px 10px",borderRadius:5,border:"1px solid var(--brd)",background:"transparent",color:"var(--t2)",cursor:"pointer",fontFamily:"inherit",fontSize:11}}>›</button>
      <button onClick={()=>{setPage(pages);load(pages);}} disabled={page===pages} style={{padding:"5px 10px",borderRadius:5,border:"1px solid var(--brd)",background:"transparent",color:"var(--t2)",cursor:"pointer",fontFamily:"inherit",fontSize:11}}>»</button>
    </div>}
  </>;
};

/* ─── Versanddienstleister ─── */
const Versanddienstleister=()=>{
  const [dienste,setDienste]=useState([]);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({});
  const [saving,setSaving]=useState(false);
  const [vTab,setVTab]=useState("grund");
  const load=()=>fetch("/api/versand").then(r=>r.json()).then(d=>setDienste(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);
  const openEdit=d=>{
    setForm({
      kundennummer:d.kundennummer||"",
      vertragsnummer:d.vertragsnummer||"",
      kontakt:d.kontakt||"",
      email:d.email||"",
      aktiv:d.aktiv!==false,
      notizen:d.notizen||"",
      absender:d.absender||{name:"",strasse:"",plz:"",ort:""},
      aktuell_gueltigAb:d.aktuell_gueltigAb||"",
      volumenProPaketLiter:d.volumenProPaketLiter||null,
      versandkostentabelle:Array.isArray(d.versandkostentabelle)?d.versandkostentabelle.map(x=>({...x})):[],
      services:Array.isArray(d.services)?d.services.map(x=>({...x})):[],
      zuschlaege:Array.isArray(d.zuschlaege)?d.zuschlaege.map(x=>({...x})):[],
      abrechnungsnummern:Array.isArray(d.abrechnungsnummern)?d.abrechnungsnummern.map(x=>({...x})):[],
      retoure:Array.isArray(d.retoure)?d.retoure.map(x=>({...x})):[],
      preisaenderung:d.preisaenderung||{gueltigAb:"",dokument:""},
      international:d.international?{
        gueltigAb:d.international.gueltigAb||"",
        zonen:Array.isArray(d.international.zonen)?d.international.zonen.map(x=>({...x})):[],
        laenderSpezifisch:Array.isArray(d.international.laenderSpezifisch)?d.international.laenderSpezifisch.map(x=>({...x})):[],
        laenderZonen:Array.isArray(d.international.laenderZonen)?d.international.laenderZonen.map(x=>({...x})):[],
        hinweise:Array.isArray(d.international.hinweise)?[...d.international.hinweise]:[],
      }:{gueltigAb:"",zonen:[],laenderSpezifisch:[],laenderZonen:[],hinweise:[]},
    });
    setVTab("grund");
    setModal(d);
  };
  const save=async()=>{
    setSaving(true);
    await fetch(`/api/versand/${modal._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)}).catch(()=>{});
    setSaving(false);setModal(null);load();
  };
  // List-Helper (generic add/remove/update)
  const updList=(key,i,patch)=>setForm(f=>({...f,[key]:f[key].map((x,idx)=>idx===i?{...x,...patch}:x)}));
  const addList=(key,tpl)=>setForm(f=>({...f,[key]:[...(f[key]||[]),tpl]}));
  const delList=(key,i)=>setForm(f=>({...f,[key]:f[key].filter((_,idx)=>idx!==i)}));
  // Nested (z. B. international.zonen)
  const updIntl=(key,i,patch)=>setForm(f=>({...f,international:{...(f.international||{}),[key]:(f.international?.[key]||[]).map((x,idx)=>idx===i?{...x,...patch}:x)}}));
  const addIntl=(key,tpl)=>setForm(f=>({...f,international:{...(f.international||{}),[key]:[...(f.international?.[key]||[]),tpl]}}));
  const delIntl=(key,i)=>setForm(f=>({...f,international:{...(f.international||{}),[key]:(f.international?.[key]||[]).filter((_,idx)=>idx!==i)}}));

  const inputStyle={padding:"6px 8px",borderRadius:5,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:11,fontFamily:"inherit",width:"100%",boxSizing:"border-box"};
  const numStyle={...inputStyle,textAlign:"right"};
  const labelStyle={fontSize:11,color:"var(--t2)",display:"block",marginBottom:4};
  const delBtn=(onClick)=><button onClick={onClick} style={{padding:"3px 8px",fontSize:11,background:"transparent",color:"var(--red)",border:"1px solid var(--red)",borderRadius:4,cursor:"pointer"}}>✕</button>;

  return<>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:14}}>
      {dienste.map(d=><Card key={d._id} style={{cursor:"pointer",position:"relative",overflow:"hidden"}}
        onClick={()=>openEdit(d)} onMouseEnter={e=>e.currentTarget.style.borderColor="var(--acc)"} onMouseLeave={e=>e.currentTarget.style.borderColor="var(--brd)"}>
        <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:d.aktiv!==false?"var(--grn)":"var(--t3)",borderRadius:"12px 12px 0 0"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:4,marginBottom:10}}>
          <div style={{fontSize:15,fontWeight:700,color:"var(--t1)"}}>{d.name}</div><Dot s={d.aktiv!==false?"aktiv":"inaktiv"}/>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:4,fontSize:11,color:"var(--t2)"}}>
          {d.kundennummer&&<span>Kundennummer: <strong style={{color:"var(--t1)"}}>{d.kundennummer}</strong></span>}
          {d.vertragsnummer&&<span>Vertragsnummer: <strong style={{color:"var(--t1)"}}>{d.vertragsnummer}</strong></span>}
          {(d.abrechnungsnummern||[]).length>0&&<span>Abrechnungsnr.: <strong style={{color:"var(--t1)"}}>{d.abrechnungsnummern.length}</strong></span>}
          {!d.kundennummer&&!d.vertragsnummer&&<span style={{color:"var(--t3)"}}>Noch keine Zugangsdaten hinterlegt</span>}
        </div>
        {(d.versandkostentabelle||[]).length>0&&<div style={{marginTop:10,paddingTop:10,borderTop:"1px solid var(--brd)"}}>
          <div style={{fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>Staffelpreise</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:4}}>{d.versandkostentabelle.map((t,i)=><span key={i} style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"var(--s2)",color:"var(--t1)",border:"1px solid var(--brd)"}}>bis {t.bis_kg}kg → {t.preis?.toFixed(2)}€{t.preisNeu?` (→ ${t.preisNeu.toFixed(2)})`:""}</span>)}</div>
        </div>}
        {(d.services||[]).length>0&&<div style={{marginTop:8,fontSize:10,color:"var(--t3)"}}>+ {d.services.length} Services · {(d.zuschlaege||[]).length} Zuschläge</div>}
      </Card>)}
    </div>
    {modal&&<Modal open={true} onClose={()=>setModal(null)} title={`${modal.name} · Konfiguration`} width={820}>
      <div style={{display:"flex",flexDirection:"column",gap:12,maxHeight:"70vh",overflow:"auto"}}>
        <div style={{display:"flex",gap:4,borderBottom:"1px solid var(--brd)",marginBottom:6}}>
          {[
            {k:"grund",l:"Grunddaten"},
            {k:"staffeln",l:`Staffelpreise (${(form.versandkostentabelle||[]).length})`},
            {k:"services",l:`Services (${(form.services||[]).length})`},
            {k:"zuschlaege",l:`Zuschläge (${(form.zuschlaege||[]).length})`},
            {k:"retoure",l:`Retoure (${(form.retoure||[]).length})`},
            {k:"abrnr",l:`Abrechnungsnr. (${(form.abrechnungsnummern||[]).length})`},
            {k:"intl",l:`International (${(form.international?.zonen||[]).length + (form.international?.laenderSpezifisch||[]).length})`},
          ].map(t=><button key={t.k} onClick={()=>setVTab(t.k)} style={{padding:"8px 14px",fontSize:11,background:"transparent",color:vTab===t.k?"var(--acc)":"var(--t2)",border:"none",borderBottom:vTab===t.k?"2px solid var(--acc)":"2px solid transparent",cursor:"pointer",fontFamily:"inherit",fontWeight:vTab===t.k?600:400}}>{t.l}</button>)}
        </div>

        {vTab==="grund"&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          {[{l:"Kundennummer (Auftraggeber)",k:"kundennummer"},{l:"Vertragsnummer",k:"vertragsnummer"},{l:"Ansprechpartner",k:"kontakt"},{l:"E-Mail",k:"email"},{l:"Gültig ab (aktueller Preis)",k:"aktuell_gueltigAb"},{l:"Ø Volumen pro Paket (Liter)",k:"volumenProPaketLiter",num:true}].map(f=><div key={f.k}><label style={labelStyle}>{f.l}</label><input type={f.num?"number":"text"} step={f.num?"0.1":undefined} value={form[f.k]||""} onChange={e=>setForm({...form,[f.k]:f.num?(e.target.value===""?null:parseFloat(e.target.value)):e.target.value})} style={inputStyle}/></div>)}
          <div><label style={labelStyle}>Status</label><select value={form.aktiv?"aktiv":"inaktiv"} onChange={e=>setForm({...form,aktiv:e.target.value==="aktiv"})} style={{...inputStyle,cursor:"pointer"}}><option value="aktiv">Aktiv</option><option value="inaktiv">Inaktiv</option></select></div>
          <div style={{gridColumn:"1/-1",marginTop:8,paddingTop:8,borderTop:"1px solid var(--brd)"}}>
            <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:8}}>Absender</div>
            <div style={{display:"grid",gridTemplateColumns:"2fr 2fr 1fr 2fr",gap:8}}>
              {[{l:"Name",k:"name"},{l:"Straße",k:"strasse"},{l:"PLZ",k:"plz"},{l:"Ort",k:"ort"}].map(f=><div key={f.k}><label style={labelStyle}>{f.l}</label><input value={form.absender?.[f.k]||""} onChange={e=>setForm({...form,absender:{...(form.absender||{}),[f.k]:e.target.value}})} style={inputStyle}/></div>)}
            </div>
          </div>
          <div style={{gridColumn:"1/-1",marginTop:8,paddingTop:8,borderTop:"1px solid var(--brd)"}}>
            <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:8}}>Angekündigte Preisänderung</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:8}}>
              <div><label style={labelStyle}>Gültig ab</label><input value={form.preisaenderung?.gueltigAb||""} onChange={e=>setForm({...form,preisaenderung:{...(form.preisaenderung||{}),gueltigAb:e.target.value}})} placeholder="YYYY-MM-DD" style={inputStyle}/></div>
              <div><label style={labelStyle}>Dokument / Quelle</label><input value={form.preisaenderung?.dokument||""} onChange={e=>setForm({...form,preisaenderung:{...(form.preisaenderung||{}),dokument:e.target.value}})} style={inputStyle}/></div>
            </div>
          </div>
          <div style={{gridColumn:"1/-1"}}><label style={labelStyle}>Notizen</label><textarea value={form.notizen||""} onChange={e=>setForm({...form,notizen:e.target.value})} rows={3} style={{...inputStyle,resize:"vertical"}}/></div>
        </div>}

        {vTab==="staffeln"&&<div>
          <table style={{width:"100%",fontSize:11,borderCollapse:"collapse"}}>
            <thead><tr style={{color:"var(--t3)",borderBottom:"1px solid var(--brd)"}}>
              <th style={{textAlign:"left",padding:6,width:120}}>bis kg</th>
              <th style={{textAlign:"right",padding:6,width:120}}>Preis aktuell (€)</th>
              <th style={{textAlign:"right",padding:6,width:120}}>Preis neu (€)</th>
              <th style={{padding:6,width:50}}></th>
            </tr></thead>
            <tbody>{(form.versandkostentabelle||[]).map((t,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)"}}>
              <td style={{padding:4}}><input type="number" step="0.1" value={t.bis_kg??""} onChange={e=>updList("versandkostentabelle",i,{bis_kg:parseFloat(e.target.value)||0})} style={numStyle}/></td>
              <td style={{padding:4}}><input type="number" step="0.01" value={t.preis??""} onChange={e=>updList("versandkostentabelle",i,{preis:parseFloat(e.target.value)||0})} style={numStyle}/></td>
              <td style={{padding:4}}><input type="number" step="0.01" value={t.preisNeu??""} onChange={e=>updList("versandkostentabelle",i,{preisNeu:e.target.value===""?null:parseFloat(e.target.value)})} style={numStyle}/></td>
              <td style={{padding:4,textAlign:"center"}}>{delBtn(()=>delList("versandkostentabelle",i))}</td>
            </tr>)}</tbody>
          </table>
          <Btn onClick={()=>addList("versandkostentabelle",{bis_kg:0,preis:0,preisNeu:null})} style={{marginTop:8}}>+ Staffel</Btn>
        </div>}

        {(vTab==="services"||vTab==="zuschlaege")&&(()=>{
          const key=vTab==="services"?"services":"zuschlaege";
          const label=vTab==="services"?"Service":"Zuschlag";
          return <div>
            <table style={{width:"100%",fontSize:11,borderCollapse:"collapse"}}>
              <thead><tr style={{color:"var(--t3)",borderBottom:"1px solid var(--brd)"}}>
                <th style={{textAlign:"left",padding:6}}>Bezeichnung</th>
                <th style={{textAlign:"right",padding:6,width:120}}>Preis (€)</th>
                <th style={{textAlign:"left",padding:6,width:240}}>Hinweis</th>
                <th style={{padding:6,width:50}}></th>
              </tr></thead>
              <tbody>{(form[key]||[]).map((t,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)"}}>
                <td style={{padding:4}}><input value={t.name||""} onChange={e=>updList(key,i,{name:e.target.value})} style={inputStyle}/></td>
                <td style={{padding:4}}><input type="number" step="0.01" value={t.preis??""} onChange={e=>updList(key,i,{preis:e.target.value===""?null:parseFloat(e.target.value)})} style={numStyle}/></td>
                <td style={{padding:4}}><input value={t.hinweis||""} onChange={e=>updList(key,i,{hinweis:e.target.value})} placeholder="optional" style={inputStyle}/></td>
                <td style={{padding:4,textAlign:"center"}}>{delBtn(()=>delList(key,i))}</td>
              </tr>)}</tbody>
            </table>
            <Btn onClick={()=>addList(key,{name:"",preis:0,hinweis:""})} style={{marginTop:8}}>+ {label}</Btn>
          </div>;
        })()}

        {vTab==="retoure"&&<div>
          <table style={{width:"100%",fontSize:11,borderCollapse:"collapse"}}>
            <thead><tr style={{color:"var(--t3)",borderBottom:"1px solid var(--brd)"}}>
              <th style={{textAlign:"left",padding:6}}>Bezeichnung</th>
              <th style={{textAlign:"right",padding:6,width:120}}>Preis aktuell (€)</th>
              <th style={{textAlign:"right",padding:6,width:120}}>Preis neu (€)</th>
              <th style={{padding:6,width:50}}></th>
            </tr></thead>
            <tbody>{(form.retoure||[]).map((t,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)"}}>
              <td style={{padding:4}}><input value={t.name||""} onChange={e=>updList("retoure",i,{name:e.target.value})} style={inputStyle}/></td>
              <td style={{padding:4}}><input type="number" step="0.01" value={t.preis??""} onChange={e=>updList("retoure",i,{preis:parseFloat(e.target.value)||0})} style={numStyle}/></td>
              <td style={{padding:4}}><input type="number" step="0.01" value={t.preisNeu??""} onChange={e=>updList("retoure",i,{preisNeu:e.target.value===""?null:parseFloat(e.target.value)})} style={numStyle}/></td>
              <td style={{padding:4,textAlign:"center"}}>{delBtn(()=>delList("retoure",i))}</td>
            </tr>)}</tbody>
          </table>
          <Btn onClick={()=>addList("retoure",{name:"",preis:0,preisNeu:null})} style={{marginTop:8}}>+ Retoure-Posten</Btn>
        </div>}

        {vTab==="abrnr"&&<div>
          <table style={{width:"100%",fontSize:11,borderCollapse:"collapse"}}>
            <thead><tr style={{color:"var(--t3)",borderBottom:"1px solid var(--brd)"}}>
              <th style={{textAlign:"left",padding:6,width:180}}>Abrechnungsnummer</th>
              <th style={{textAlign:"left",padding:6,width:140}}>Gültig ab</th>
              <th style={{textAlign:"left",padding:6}}>Produkt</th>
              <th style={{padding:6,width:50}}></th>
            </tr></thead>
            <tbody>{(form.abrechnungsnummern||[]).map((t,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)"}}>
              <td style={{padding:4}}><input value={t.nr||""} onChange={e=>updList("abrechnungsnummern",i,{nr:e.target.value})} style={inputStyle}/></td>
              <td style={{padding:4}}><input value={t.gueltigAb||""} onChange={e=>updList("abrechnungsnummern",i,{gueltigAb:e.target.value})} placeholder="YYYY-MM-DD" style={inputStyle}/></td>
              <td style={{padding:4}}><input value={t.produkt||""} onChange={e=>updList("abrechnungsnummern",i,{produkt:e.target.value})} style={inputStyle}/></td>
              <td style={{padding:4,textAlign:"center"}}>{delBtn(()=>delList("abrechnungsnummern",i))}</td>
            </tr>)}</tbody>
          </table>
          <Btn onClick={()=>addList("abrechnungsnummern",{nr:"",gueltigAb:"",produkt:""})} style={{marginTop:8}}>+ Abrechnungsnummer</Btn>
        </div>}

        {vTab==="intl"&&<div style={{display:"flex",flexDirection:"column",gap:16}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr",gap:8}}>
            <div><label style={labelStyle}>International gültig ab</label>
              <input value={form.international?.gueltigAb||""} onChange={e=>setForm({...form,international:{...(form.international||{}),gueltigAb:e.target.value}})} placeholder="YYYY-MM-DD" style={inputStyle}/></div>
          </div>

          <div>
            <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>Zonentarife (Basispreis + Kilopreis je Zone)</div>
            <table style={{width:"100%",fontSize:11,borderCollapse:"collapse"}}>
              <thead><tr style={{color:"var(--t3)",borderBottom:"1px solid var(--brd)"}}>
                <th style={{textAlign:"left",padding:6,width:110}}>Zone</th>
                <th style={{textAlign:"left",padding:6}}>Produkt</th>
                <th style={{textAlign:"right",padding:6,width:110}}>Basispreis (€)</th>
                <th style={{textAlign:"right",padding:6,width:110}}>Kilopreis (€)</th>
                <th style={{textAlign:"left",padding:6,width:200}}>Hinweis</th>
                <th style={{padding:6,width:40}}></th>
              </tr></thead>
              <tbody>{(form.international?.zonen||[]).map((t,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)"}}>
                <td style={{padding:4}}><input value={t.zone||""} onChange={e=>updIntl("zonen",i,{zone:e.target.value})} style={inputStyle}/></td>
                <td style={{padding:4}}><input value={t.produkt||""} onChange={e=>updIntl("zonen",i,{produkt:e.target.value})} style={inputStyle}/></td>
                <td style={{padding:4}}><input type="number" step="0.01" value={t.basispreis??""} onChange={e=>updIntl("zonen",i,{basispreis:parseFloat(e.target.value)||0})} style={numStyle}/></td>
                <td style={{padding:4}}><input type="number" step="0.01" value={t.kilopreis??""} onChange={e=>updIntl("zonen",i,{kilopreis:parseFloat(e.target.value)||0})} style={numStyle}/></td>
                <td style={{padding:4}}><input value={t.hinweis||""} onChange={e=>updIntl("zonen",i,{hinweis:e.target.value})} placeholder="optional" style={inputStyle}/></td>
                <td style={{padding:4,textAlign:"center"}}>{delBtn(()=>delIntl("zonen",i))}</td>
              </tr>)}</tbody>
            </table>
            <Btn onClick={()=>addIntl("zonen",{zone:"",produkt:"DHL Paket International Premium",basispreis:0,kilopreis:0})} style={{marginTop:6}}>+ Zonentarif</Btn>
          </div>

          <div>
            <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>Länderindividuelle Basispreise</div>
            <table style={{width:"100%",fontSize:11,borderCollapse:"collapse"}}>
              <thead><tr style={{color:"var(--t3)",borderBottom:"1px solid var(--brd)"}}>
                <th style={{textAlign:"left",padding:6}}>Land</th>
                <th style={{textAlign:"left",padding:6,width:110}}>Zone</th>
                <th style={{textAlign:"right",padding:6,width:110}}>Basispreis (€)</th>
                <th style={{textAlign:"right",padding:6,width:110}}>Kilopreis (€)</th>
                <th style={{padding:6,width:40}}></th>
              </tr></thead>
              <tbody>{(form.international?.laenderSpezifisch||[]).map((t,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)"}}>
                <td style={{padding:4}}><input value={t.land||""} onChange={e=>updIntl("laenderSpezifisch",i,{land:e.target.value})} style={inputStyle}/></td>
                <td style={{padding:4}}><input value={t.zone||""} onChange={e=>updIntl("laenderSpezifisch",i,{zone:e.target.value})} style={inputStyle}/></td>
                <td style={{padding:4}}><input type="number" step="0.01" value={t.basispreis??""} onChange={e=>updIntl("laenderSpezifisch",i,{basispreis:parseFloat(e.target.value)||0})} style={numStyle}/></td>
                <td style={{padding:4}}><input type="number" step="0.01" value={t.kilopreis??""} onChange={e=>updIntl("laenderSpezifisch",i,{kilopreis:parseFloat(e.target.value)||0})} style={numStyle}/></td>
                <td style={{padding:4,textAlign:"center"}}>{delBtn(()=>delIntl("laenderSpezifisch",i))}</td>
              </tr>)}</tbody>
            </table>
            <Btn onClick={()=>addIntl("laenderSpezifisch",{land:"",zone:"",basispreis:0,kilopreis:0})} style={{marginTop:6}}>+ Länderpreis</Btn>
          </div>

          <div>
            <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>Länder → Zone ({(form.international?.laenderZonen||[]).length})</div>
            <div style={{maxHeight:240,overflow:"auto",border:"1px solid var(--brd)",borderRadius:6}}>
              <table style={{width:"100%",fontSize:11,borderCollapse:"collapse"}}>
                <thead style={{position:"sticky",top:0,background:"var(--s2)"}}><tr style={{color:"var(--t3)"}}>
                  <th style={{textAlign:"left",padding:6}}>Land</th>
                  <th style={{textAlign:"left",padding:6,width:140}}>Zone</th>
                  <th style={{padding:6,width:40}}></th>
                </tr></thead>
                <tbody>{(form.international?.laenderZonen||[]).map((t,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)"}}>
                  <td style={{padding:4}}><input value={t.land||""} onChange={e=>updIntl("laenderZonen",i,{land:e.target.value})} style={inputStyle}/></td>
                  <td style={{padding:4}}><input value={t.zone||""} onChange={e=>updIntl("laenderZonen",i,{zone:e.target.value})} style={inputStyle}/></td>
                  <td style={{padding:4,textAlign:"center"}}>{delBtn(()=>delIntl("laenderZonen",i))}</td>
                </tr>)}</tbody>
              </table>
            </div>
            <Btn onClick={()=>addIntl("laenderZonen",{land:"",zone:""})} style={{marginTop:6}}>+ Land</Btn>
          </div>

          {(form.international?.hinweise||[]).length>0&&<div style={{fontSize:10,color:"var(--t3)",lineHeight:1.5,padding:8,background:"var(--s2)",borderRadius:6}}>
            {form.international.hinweise.map((h,i)=><div key={i}>• {h}</div>)}
          </div>}
        </div>}

        <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:12,borderTop:"1px solid var(--brd)",marginTop:8}}>
          <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
          <Btn primary onClick={save} disabled={saving}>{saving?"Speichere…":"Speichern"}</Btn>
        </div>
      </div>
    </Modal>}
  </>;
};

/* ─── Kategoriemapping ─── */
const KATEGORIE_JTL_SEED=[
  {id:"damen",label:"Damen",children:[{id:"damen_oberteile",label:"Oberteile",children:[{id:"damen_tshirts",label:"T-Shirts & Tops"},{id:"damen_blusen",label:"Blusen & Tuniken"},{id:"damen_pullover",label:"Pullover & Sweatshirts"},{id:"damen_jacken",label:"Jacken & Mäntel"}]},{id:"damen_hosen",label:"Hosen & Röcke",children:[{id:"damen_jeans",label:"Jeans"},{id:"damen_stoffhosen",label:"Stoffhosen"},{id:"damen_roecke",label:"Röcke"}]},{id:"damen_kleider",label:"Kleider & Jumpsuits"},{id:"damen_waesche",label:"Unterwäsche & Nachtwäsche"}]},
  {id:"herren",label:"Herren",children:[{id:"herren_oberteile",label:"Oberteile",children:[{id:"herren_tshirts",label:"T-Shirts & Poloshirts"},{id:"herren_hemden",label:"Hemden"},{id:"herren_pullover",label:"Pullover & Hoodies"}]},{id:"herren_hosen",label:"Hosen",children:[{id:"herren_jeans",label:"Jeans"},{id:"herren_chinos",label:"Chinos & Stoffhosen"}]},{id:"herren_waesche",label:"Unterwäsche"}]},
  {id:"kinder",label:"Kinder",children:[{id:"kinder_baby",label:"Baby (0–24 Mon.)"},{id:"kinder_klein",label:"Kleinkinder (2–5 J.)"},{id:"kinder_gross",label:"Kinder (6–14 J.)"}]},
  {id:"accessoires",label:"Accessoires",children:[{id:"acc_taschen",label:"Taschen"},{id:"acc_guertel",label:"Gürtel"}]},
];
const MP_KAT_SEED={Zalando:["Damen > Bekleidung > Tops","Damen > Bekleidung > Hosen","Damen > Bekleidung > Kleider","Damen > Bekleidung > Unterwäsche","Herren > Bekleidung > Shirts","Herren > Bekleidung > Hosen","Kinder > Mädchen > Bekleidung","Kinder > Jungen > Bekleidung"],"About You":["Damen/Bekleidung/Oberteile","Damen/Bekleidung/Hosen","Damen/Bekleidung/Kleider","Herren/Bekleidung/Shirts","Herren/Bekleidung/Hosen","Kinder/Bekleidung"],Otto:["Damen-Mode > Shirts & Tops","Damen-Mode > Hosen","Herren-Mode > T-Shirts","Herren-Mode > Hosen","Kindermode"],Amazon:["Clothing > Women > Tops","Clothing > Women > Pants","Clothing > Men > T-Shirts","Clothing > Men > Pants","Clothing > Kids"]};

const KatNode=({node,depth=0,sel,onSel})=>{
  const [open,setOpen]=useState(depth<1);const leaf=!node.children?.length;const isSel=sel===node.id;
  return<div><div onClick={()=>{if(!leaf)setOpen(o=>!o);onSel(node.id);}}
    style={{display:"flex",alignItems:"center",gap:6,padding:"5px 8px",borderRadius:6,cursor:"pointer",marginLeft:depth*14,background:isSel?"var(--acc2)":"transparent",color:isSel?"var(--acc)":"var(--t1)",fontSize:12,fontWeight:isSel?600:400,transition:"background .1s"}}
    onMouseEnter={e=>{if(!isSel)e.currentTarget.style.background="var(--shov)";}} onMouseLeave={e=>{if(!isSel)e.currentTarget.style.background="transparent";}}>
    {!leaf&&<span style={{fontSize:9,opacity:.5,transform:open?"rotate(90deg)":"none",display:"inline-block",transition:"transform .15s"}}>▶</span>}
    {leaf&&<span style={{width:9}}/>}
    <span>{node.label}</span>
  </div>{open&&!leaf&&node.children.map(c=><KatNode key={c.id} node={c} depth={depth+1} sel={sel} onSel={onSel}/>)}</div>;
};

const Kategoriemapping=()=>{
  const [selJTL,setSelJTL]=useState(null);
  const [activeMP,setActiveMP]=useState("Zalando");
  const [mappings,setMappings]=useState({});
  const [saving,setSaving]=useState(false);
  useEffect(()=>{fetch("/api/kategoriemapping").then(r=>r.json()).then(d=>setMappings(d||{})).catch(()=>{});},[]);
  const toggle=(jtlId,kat)=>setMappings(m=>{
    const k=`${jtlId}|||${activeMP}`;const cur=m[k]||[];
    const next={...m,[k]:cur.includes(kat)?cur.filter(c=>c!==kat):[...cur,kat]};
    setSaving(true);
    fetch("/api/kategoriemapping",{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(next)})
      .then(()=>setSaving(false)).catch(()=>setSaving(false));
    return next;
  });
  const selMaps=selJTL?(mappings[`${selJTL}|||${activeMP}`]||[]):[];
  return<div style={{display:"grid",gridTemplateColumns:"230px 1fr 260px",gap:14,height:"calc(100vh - 145px)"}}>
    <Card style={{overflow:"auto",padding:"14px 10px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,padding:"0 8px"}}>
        <div style={{fontSize:9,fontWeight:700,color:"var(--t3)",textTransform:"uppercase",letterSpacing:"1px"}}>JTL-Kategorien</div>
        {saving&&<span style={{fontSize:9,color:"var(--ylw)"}}>● Speichern…</span>}
        {!saving&&Object.values(mappings).some(v=>v.length)&&<span style={{fontSize:9,color:"var(--grn)"}}>✓ Gespeichert</span>}
      </div>
      {KATEGORIE_JTL_SEED.map(n=><KatNode key={n.id} node={n} sel={selJTL} onSel={setSelJTL}/>)}
    </Card>
    <Card style={{overflow:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>{selJTL||"JTL-Kategorie wählen"}</div>
        <div style={{display:"flex",gap:4}}>{Object.keys(MP_KAT_SEED).map(mp=><button key={mp} onClick={()=>setActiveMP(mp)} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:activeMP===mp?"var(--acc)":"var(--s2)",color:activeMP===mp?"#fff":"var(--t2)",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>{mp}</button>)}</div>
      </div>
      {selJTL?<>{(MP_KAT_SEED[activeMP]||[]).map(kat=>{const mapped=selMaps.includes(kat);return<div key={kat} onClick={()=>toggle(selJTL,kat)} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",borderRadius:7,marginBottom:4,cursor:"pointer",background:mapped?"var(--grn2)":"var(--s2)",border:`1px solid ${mapped?"var(--grn)":"var(--brd)"}`,transition:"all .15s"}}>
        <span style={{fontSize:14,color:mapped?"var(--grn)":"var(--t3)"}}>{mapped?"✓":"○"}</span>
        <span style={{fontSize:12,color:mapped?"var(--grn)":"var(--t1)",fontWeight:mapped?600:400}}>{kat}</span>
      </div>})}</>:<EmptyState icon="◈" title="Keine Kategorie gewählt" sub="Wähle eine JTL-Kategorie links"/>}
    </Card>
    <Card style={{overflow:"auto",padding:"14px 12px"}}>
      <div style={{fontSize:9,fontWeight:700,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:10}}>Zuordnungen · {activeMP}</div>
      {Object.entries(mappings).filter(([k,v])=>k.endsWith(`|||${activeMP}`)&&v.length).map(([k,vals])=><div key={k} style={{marginBottom:10}}><div style={{fontSize:11,fontWeight:600,color:"var(--acc)",marginBottom:4}}>{k.split("|||")[0]}</div>{vals.map(v=><div key={v} style={{fontSize:10,color:"var(--t2)",padding:"2px 0",borderBottom:"1px solid var(--brd)"}}>→ {v}</div>)}</div>)}
      {!Object.entries(mappings).some(([k,v])=>k.endsWith(`|||${activeMP}`)&&v.length)&&<EmptyState icon="◈" title="Keine Zuordnungen" sub="Noch keine Kategorien verknüpft"/>}
    </Card>
  </div>;
};

/* ─── Rollenverwaltung ─── */
const PERM_ITEMS=[
  {k:"dashboard",l:"Dashboard",g:"Allgemein"},
  {k:"auswertungen",l:"Auswertungen",g:"Allgemein"},
  {k:"cashflow",l:"Cashflow",g:"Allgemein"},
  {k:"artikel.panda_upload",l:"Panda Upload",g:"Artikeldaten"},
  {k:"artikel.panda_ansicht",l:"Panda Ansicht",g:"Artikeldaten"},
  {k:"artikel.ods_upload",l:"ODS Upload",g:"Artikeldaten"},
  {k:"artikel.artikel_ansicht",l:"Artikelansicht Manuell",g:"Artikeldaten"},
  {k:"artikel.jtl_ansicht",l:"Artikelansicht JTL",g:"Artikeldaten"},
  {k:"artikel.pflichtfelder",l:"Pflichtfelder",g:"Artikeldaten"},
  {k:"artikel.attributfelder",l:"Attributfelder",g:"Artikeldaten"},
  {k:"artikel.merkmale",l:"Merkmale",g:"Artikeldaten"},
  {k:"artikel.bilder",l:"Artikelbilder",g:"Artikeldaten"},
  {k:"verwaltung.benutzer",l:"Benutzerverwaltung",g:"Verwaltung"},
  {k:"verwaltung.rollen",l:"Rollenverwaltung",g:"Verwaltung"},
  {k:"verwaltung.schnittstellen",l:"Schnittstellen",g:"Verwaltung"},
];

const Rollenverwaltung=()=>{
  const [rollen,setRollen]=useState([]);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({name:"",farbe:"#6366f1",beschreibung:"",rechte:{}});
  const [saving,setSaving]=useState(false);
  const [deleting,setDeleting]=useState(null);

  const load=()=>fetch("/api/rollen").then(r=>r.json()).then(d=>setRollen(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);

  const openAdd=()=>{setForm({name:"",farbe:"#6366f1",beschreibung:"",rechte:{}});setModal("add");};
  const openEdit=r=>{setForm({name:r.name,farbe:r.farbe||"#6366f1",beschreibung:r.beschreibung||"",rechte:{...(r.rechte||{})}});setModal(r);};

  const setPerm=(k,v)=>setForm(f=>({...f,rechte:{...f.rechte,[k]:v||undefined}}));

  const save=async()=>{
    setSaving(true);
    const body={...form,rechte:Object.fromEntries(Object.entries(form.rechte).filter(([,v])=>v))};
    const url=modal==="add"?"/api/rollen":`/api/rollen/${modal._id}`;
    const method=modal==="add"?"POST":"PUT";
    await fetch(url,{method,headers:{"Content-Type":"application/json"},body:JSON.stringify(body)}).catch(()=>{});
    setSaving(false);setModal(null);load();
  };

  const del=async id=>{
    if(!confirm("Rolle wirklich löschen?"))return;
    setDeleting(id);
    await fetch(`/api/rollen/${id}`,{method:"DELETE"}).catch(()=>{});
    setDeleting(null);load();
  };

  // Group PERM_ITEMS by section
  const groups=[...new Set(PERM_ITEMS.map(p=>p.g))];

  return<>
    <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
      <Btn primary onClick={openAdd}>+ Rolle anlegen</Btn>
    </div>

    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(310px,1fr))",gap:14,marginBottom:20}}>
      {rollen.map(r=><Card key={r._id} style={{position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:r.farbe||"var(--acc)",borderRadius:"12px 12px 0 0"}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8,marginTop:4}}>
          <div>
            <div style={{fontSize:13,fontWeight:700,color:"var(--t1)",marginBottom:2}}>{r.name}</div>
            <div style={{fontSize:11,color:"var(--t2)"}}>{r.beschreibung}</div>
          </div>
          <div style={{display:"flex",gap:5,flexShrink:0}}>
            <Btn small onClick={()=>openEdit(r)}>Edit</Btn>
            <Btn small onClick={()=>del(r._id)} disabled={deleting===r._id} style={{color:"var(--red)"}}>{deleting===r._id?"…":"✕"}</Btn>
          </div>
        </div>
        <div style={{marginTop:10,display:"flex",flexWrap:"wrap",gap:4}}>
          {Object.entries(r.rechte||{}).map(([k,v])=><span key={k} style={{display:"inline-flex",alignItems:"center",gap:3,padding:"2px 7px",borderRadius:4,fontSize:9,fontWeight:600,background:v==="rw"?"var(--grn2)":"var(--acc2)",color:v==="rw"?"var(--grn)":"var(--acc)"}}>
            {k.split(".").pop().replace(/_/g," ")} <span style={{opacity:.6}}>{v}</span>
          </span>)}
          {!Object.keys(r.rechte||{}).length&&<span style={{fontSize:10,color:"var(--t3)"}}>Keine Berechtigungen</span>}
        </div>
      </Card>)}
      {!rollen.length&&<div style={{gridColumn:"1/-1"}}><EmptyState icon="◈" title="Keine Rollen" sub="Werden beim ersten API-Aufruf angelegt"/></div>}
    </div>

    {modal&&<Modal open={true} onClose={()=>setModal(null)} title={modal==="add"?"Rolle anlegen":`${modal.name} bearbeiten`} width={640}>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 160px",gap:12}}>
          <div>
            <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Rollenname</label>
            <input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/>
          </div>
          <div>
            <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Farbe</label>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <input type="color" value={form.farbe} onChange={e=>setForm({...form,farbe:e.target.value})} style={{width:38,height:36,borderRadius:6,border:"1px solid var(--brd)",padding:2,cursor:"pointer",background:"none",flexShrink:0}}/>
              <input value={form.farbe} onChange={e=>setForm({...form,farbe:e.target.value})} style={{flex:1,minWidth:0,padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"'JetBrains Mono',monospace"}}/>
            </div>
          </div>
        </div>
        <div>
          <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Beschreibung</label>
          <input value={form.beschreibung} onChange={e=>setForm({...form,beschreibung:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/>
        </div>

        <div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 58px 58px 58px",gap:4,marginBottom:6,paddingBottom:6,borderBottom:"1px solid var(--brd)"}}>
            <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>Berechtigung</div>
            <div style={{fontSize:9,fontWeight:600,color:"var(--t3)",textAlign:"center"}}>–</div>
            <div style={{fontSize:9,fontWeight:600,color:"var(--acc)",textAlign:"center"}}>Lesen</div>
            <div style={{fontSize:9,fontWeight:600,color:"var(--grn)",textAlign:"center"}}>Lesen+Schreiben</div>
          </div>
          <div style={{maxHeight:300,overflow:"auto",display:"flex",flexDirection:"column",gap:1}}>
            {groups.map(g=><React.Fragment key={g}>
              <div style={{fontSize:9,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:"1px",padding:"8px 0 4px"}}>{g}</div>
              {PERM_ITEMS.filter(p=>p.g===g).map(item=>{
                const cur=form.rechte[item.k]||"";
                return<div key={item.k} style={{display:"grid",gridTemplateColumns:"1fr 58px 58px 58px",alignItems:"center",gap:4,padding:"3px 0",borderBottom:"1px solid rgba(255,255,255,.03)"}}>
                  <span style={{fontSize:12,color:"var(--t1)"}}>{item.l}</span>
                  {["","r","rw"].map(v=><div key={v} onClick={()=>setPerm(item.k,v)}
                    style={{display:"flex",alignItems:"center",justifyContent:"center",height:26,borderRadius:5,cursor:"pointer",
                      background:cur===v?(v==="rw"?"var(--grn2)":v==="r"?"var(--acc2)":"var(--s3)"):"var(--s2)",
                      border:`1px solid ${cur===v?(v==="rw"?"var(--grn)":v==="r"?"var(--acc)":"var(--brd)"):"var(--brd)"}`,transition:"all .1s"}}>
                    <span style={{fontSize:10,fontWeight:600,color:cur===v?(v==="rw"?"var(--grn)":v==="r"?"var(--acc)":"var(--t2)"):"var(--t3)"}}>{v||"–"}</span>
                  </div>)}
                </div>;
              })}
            </React.Fragment>)}
          </div>
        </div>

        <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}>
          <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
          <Btn primary onClick={save} disabled={saving||!form.name.trim()}>{saving?"Speichere…":"Speichern"}</Btn>
        </div>
      </div>
    </Modal>}
  </>;
};

/* ─── Preiskalkulator ─── */
const MP_LIST_KALK=MP_ALL.map(m=>m.name);
const Preiskalkulator=()=>{
  const [activeMP,setActiveMP]=useState("Zalando");
  const [rules,setRules]=useState({});
  const [saving,setSaving]=useState(false);
  const [preview,setPreview]=useState({});
  const PREV_PRICE=49.99;

  useEffect(()=>{
    fetch("/api/preisregeln").then(r=>r.json()).then(d=>{
      const m={};
      (Array.isArray(d)?d:[]).forEach(r=>{m[r.marktplatz]=r;});
      setRules(m);
    }).catch(()=>{});
  },[]);

  const getRule=mp=>rules[mp]||{basis:"uvp",aufschlagTyp:"prozent",aufschlag:0,rundung:".99",minMarge:0};
  const setRule=(mp,k,v)=>setRules(r=>({...r,[mp]:{...getRule(mp),[k]:v}}));

  const calcPreview=(rule)=>{
    const base=PREV_PRICE;
    let price=base;
    if(rule.aufschlagTyp==="prozent") price=base*(1+(parseFloat(rule.aufschlag)||0)/100);
    else price=base+(parseFloat(rule.aufschlag)||0);
    // Rounding
    const r=rule.rundung||".99";
    if(r===".99"||r===".49"||r===".95"||r===".00"){
      const cents=parseFloat(r.replace(",","."));
      price=Math.floor(price)+cents;
      if(price<base) price+=1;
    }
    return price;
  };

  const save=async(mp)=>{
    setSaving(mp);
    await fetch(`/api/preisregeln/${encodeURIComponent(mp)}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(getRule(mp))}).catch(()=>{});
    setSaving(false);
  };

  const rule=getRule(activeMP);
  const prevPrice=calcPreview(rule);

  return<div style={{display:"grid",gridTemplateColumns:"200px 1fr",gap:14,height:"calc(100vh - 145px)"}}>
    <Card style={{padding:"10px 8px",overflow:"auto"}}>
      <div style={{fontSize:9,fontWeight:700,color:"var(--t3)",textTransform:"uppercase",letterSpacing:"1px",marginBottom:10,padding:"0 8px"}}>Marktplätze</div>
      {MP_LIST_KALK.map(mp=>{const r=getRule(mp);const hasRule=r.aufschlag>0||r.rundung!==".99";return<div key={mp} onClick={()=>setActiveMP(mp)}
        style={{padding:"8px 10px",borderRadius:7,cursor:"pointer",marginBottom:2,background:activeMP===mp?"var(--acc2)":"transparent",border:`1px solid ${activeMP===mp?"var(--acc)":"transparent"}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}
        onMouseEnter={e=>{if(activeMP!==mp)e.currentTarget.style.background="var(--shov)";}} onMouseLeave={e=>{if(activeMP!==mp)e.currentTarget.style.background="transparent";}}>
        <span style={{fontSize:12,color:activeMP===mp?"var(--acc)":"var(--t1)",fontWeight:activeMP===mp?600:400}}>{mp}</span>
        {hasRule&&<span style={{width:6,height:6,borderRadius:"50%",background:"var(--grn)",display:"inline-block"}}/>}
      </div>;})}
    </Card>
    <div style={{display:"flex",flexDirection:"column",gap:14,overflow:"auto"}}>
      <Card>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontSize:14,fontWeight:700,color:"var(--t1)"}}>{activeMP} · Preisregel</div>
          <Btn primary onClick={()=>save(activeMP)} disabled={saving===activeMP}>{saving===activeMP?"Speichere…":"Speichern"}</Btn>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          <div>
            <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:6}}>Basis-Preis</label>
            <select value={rule.basis} onChange={e=>setRule(activeMP,"basis",e.target.value)} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
              <option value="uvp">UVP (Unverbindl. Verkaufspreis)</option>
              <option value="ek">EK (Einkaufspreis)</option>
              <option value="custom">Eigener Basispreis</option>
            </select>
          </div>
          <div>
            <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:6}}>Aufschlag</label>
            <div style={{display:"flex",gap:6}}>
              <select value={rule.aufschlagTyp} onChange={e=>setRule(activeMP,"aufschlagTyp",e.target.value)} style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
                <option value="prozent">%</option>
                <option value="euro">€</option>
              </select>
              <input type="number" step="0.1" value={rule.aufschlag||0} onChange={e=>setRule(activeMP,"aufschlag",parseFloat(e.target.value)||0)} style={{flex:1,padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
            </div>
          </div>
          <div>
            <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:6}}>Preisglättung (Endung)</label>
            <select value={rule.rundung||".99"} onChange={e=>setRule(activeMP,"rundung",e.target.value)} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
              <option value=".99">,99 (z.B. 29,99 €)</option>
              <option value=".49">,49 (z.B. 29,49 €)</option>
              <option value=".95">,95 (z.B. 29,95 €)</option>
              <option value=".00">,00 (glatter Preis)</option>
            </select>
          </div>
          <div>
            <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:6}}>Mindestmarge (EK × Faktor)</label>
            <input type="number" step="0.01" value={rule.minMarge||0} onChange={e=>setRule(activeMP,"minMarge",parseFloat(e.target.value)||0)} placeholder="z.B. 1.2 = EK+20%" style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
          </div>
        </div>
      </Card>
      <Card style={{background:"var(--acc2)",border:"1px solid var(--acc)"}}>
        <div style={{fontSize:11,color:"var(--acc)",fontWeight:600,marginBottom:10}}>Vorschau · Beispielrechnung (UVP {PREV_PRICE.toFixed(2)} €)</div>
        <div style={{display:"flex",gap:20,alignItems:"center"}}>
          <div style={{textAlign:"center"}}><div style={{fontSize:10,color:"var(--t3)",marginBottom:3}}>Basis</div><div style={{fontSize:16,fontWeight:700,color:"var(--t1)"}}>{PREV_PRICE.toFixed(2)} €</div></div>
          <div style={{fontSize:18,color:"var(--t3)"}}>→</div>
          <div style={{textAlign:"center"}}><div style={{fontSize:10,color:"var(--t3)",marginBottom:3}}>nach Regel</div><div style={{fontSize:16,fontWeight:700,color:"var(--acc)"}}>{(PREV_PRICE*(1+(parseFloat(rule.aufschlag)||0)/100)).toFixed(2)} €</div></div>
          <div style={{fontSize:18,color:"var(--t3)"}}>→</div>
          <div style={{textAlign:"center"}}><div style={{fontSize:10,color:"var(--t3)",marginBottom:3}}>Endpreis</div><div style={{fontSize:22,fontWeight:800,color:"var(--grn)"}}>{prevPrice.toFixed(2)} €</div></div>
        </div>
      </Card>
    </div>
  </div>;
};

/* ─── Angebote ─── */
const MP_LIST_ANG=MP_ALL.map(m=>m.name);
const Angebote=()=>{
  const [angebote,setAngebote]=useState([]);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({marktplatz:"Zalando",reduktionTyp:"prozent",reduktion:0,startdatum:"",enddatum:"",dauerhaft:false,notizen:""});
  const [saving,setSaving]=useState(false);
  const load=()=>fetch("/api/angebote").then(r=>r.json()).then(d=>setAngebote(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);
  const now=new Date();
  const getStatus=a=>{
    if(!a.startdatum) return"geplant";
    const s=new Date(a.startdatum);
    const e=a.enddatum?new Date(a.enddatum):null;
    if(s>now) return"geplant";
    if(e&&e<now) return"abgelaufen";
    return"aktiv";
  };
  const STATUS_COLOR={aktiv:"var(--grn)",geplant:"var(--ylw)",abgelaufen:"var(--t3)"};
  const openAdd=()=>{const today=new Date().toISOString().split("T")[0];setForm({marktplatz:"Zalando",reduktionTyp:"prozent",reduktion:0,startdatum:today,enddatum:"",dauerhaft:false,notizen:""});setModal("add");};
  const openEdit=a=>{setForm({marktplatz:a.marktplatz,reduktionTyp:a.reduktionTyp||"prozent",reduktion:a.reduktion||0,startdatum:a.startdatum||"",enddatum:a.enddatum||"",dauerhaft:a.dauerhaft||false,notizen:a.notizen||""});setModal(a);};
  const save=async()=>{
    setSaving(true);
    const url=modal==="add"?"/api/angebote":`/api/angebote/${modal._id}`;
    await fetch(url,{method:modal==="add"?"POST":"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)}).catch(()=>{});
    setSaving(false);setModal(null);load();
  };
  const del=async id=>{if(!confirm("Angebot löschen?"))return;await fetch(`/api/angebote/${id}`,{method:"DELETE"}).catch(()=>{});load();};
  return<>
    <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}><Btn primary onClick={openAdd}>+ Angebot anlegen</Btn></div>
    <Card>
      <div style={{display:"grid",gridTemplateColumns:"140px 1fr 90px 110px 110px 90px 64px",padding:"0 0 8px",borderBottom:"1px solid var(--brd)",fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:8}}>
        <span>Marktplatz</span><span>Notiz</span><span>Reduktion</span><span>Start</span><span>Ende</span><span>Status</span><span/>
      </div>
      {angebote.length===0&&<EmptyState icon="◇" title="Keine Angebote" sub="Lege zeitlich begrenzte oder dauerhafte Preisreduzierungen an"/>}
      {angebote.map(a=>{const st=getStatus(a);return<div key={a._id} style={{display:"grid",gridTemplateColumns:"140px 1fr 90px 110px 110px 90px 64px",padding:"10px 0",borderBottom:"1px solid var(--brd)",fontSize:12,alignItems:"center",gap:8}}>
        <span style={{fontWeight:600,color:"var(--t1)"}}>{a.marktplatz}</span>
        <span style={{color:"var(--t2)",fontSize:11}}>{a.notizen||"–"}</span>
        <span style={{color:"var(--red)",fontWeight:600}}>−{a.reduktion}{a.reduktionTyp==="prozent"?"%":"€"}</span>
        <span style={{color:"var(--t2)",fontSize:11}}>{a.startdatum?fmtDate(a.startdatum):"–"}</span>
        <span style={{color:"var(--t2)",fontSize:11}}>{a.dauerhaft?"∞ dauerhaft":a.enddatum?fmtDate(a.enddatum):"–"}</span>
        <span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:STATUS_COLOR[st]+"22",color:STATUS_COLOR[st]}}>{st}</span>
        <div style={{display:"flex",gap:4}}><Btn small onClick={()=>openEdit(a)}>Edit</Btn><Btn small onClick={()=>del(a._id)} style={{color:"var(--red)"}}>✕</Btn></div>
      </div>;})}
    </Card>
    {modal&&<Modal open={true} onClose={()=>setModal(null)} title={modal==="add"?"Angebot anlegen":"Angebot bearbeiten"} width={520}>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Marktplatz</label>
          <select value={form.marktplatz} onChange={e=>setForm({...form,marktplatz:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
            {MP_LIST_ANG.map(m=><option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Reduktion</label>
          <div style={{display:"flex",gap:8}}>
            <select value={form.reduktionTyp} onChange={e=>setForm({...form,reduktionTyp:e.target.value})} style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
              <option value="prozent">%</option><option value="euro">€</option>
            </select>
            <input type="number" step="0.1" min="0" value={form.reduktion} onChange={e=>setForm({...form,reduktion:parseFloat(e.target.value)||0})} style={{flex:1,padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Startdatum</label><input type="date" value={form.startdatum} onChange={e=>setForm({...form,startdatum:e.target.value})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Enddatum</label><input type="date" value={form.enddatum} onChange={e=>setForm({...form,enddatum:e.target.value})} disabled={form.dauerhaft} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:form.dauerhaft?"var(--s3)":"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",opacity:form.dauerhaft?.4:1}}/></div>
        </div>
        <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",fontSize:12,color:"var(--t1)"}}>
          <input type="checkbox" checked={form.dauerhaft} onChange={e=>setForm({...form,dauerhaft:e.target.checked,enddatum:""})} style={{width:14,height:14,accentColor:"var(--acc)"}}/>
          Dauerhaft (bleibt bis manuelle Änderung)
        </label>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Notiz</label><textarea value={form.notizen} onChange={e=>setForm({...form,notizen:e.target.value})} rows={2} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",resize:"vertical"}}/></div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}><Btn onClick={()=>setModal(null)}>Abbrechen</Btn><Btn primary onClick={save} disabled={saving}>{saving?"Speichere…":"Speichern"}</Btn></div>
      </div>
    </Modal>}
  </>;
};

/* ─── Preislisten ─── */
const Preislisten=()=>{
  const [liste,setListe]=useState([]);
  const [lieferanten,setLieferanten]=useState([]);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({lieferantId:"",dateiname:"",format:"csv",status:"neu",notizen:""});
  const [saving,setSaving]=useState(false);
  const load=()=>{
    fetch("/api/preislisten").then(r=>r.json()).then(d=>setListe(Array.isArray(d)?d:[])).catch(()=>{});
    fetch("/api/lieferanten").then(r=>r.json()).then(d=>setLieferanten(Array.isArray(d)?d:[])).catch(()=>{});
  };
  useEffect(()=>{load();},[]);
  const getLiefName=id=>{const l=lieferanten.find(x=>String(x._id)===String(id));return l?l.name:"–";};
  const openAdd=()=>{setForm({lieferantId:"",dateiname:"",format:"csv",status:"neu",notizen:""});setModal("add");};
  const save=async()=>{
    setSaving(true);
    const url=modal==="add"?"/api/preislisten":`/api/preislisten/${modal._id}`;
    await fetch(url,{method:modal==="add"?"POST":"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)}).catch(()=>{});
    setSaving(false);setModal(null);load();
  };
  const del=async id=>{if(!confirm("Preisliste löschen?"))return;await fetch(`/api/preislisten/${id}`,{method:"DELETE"}).catch(()=>{});load();};
  const STATUS_COLOR={neu:"var(--acc)",interpretiert:"var(--ylw)",zugeordnet:"var(--grn)",abgelehnt:"var(--red)"};
  return<>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
      <div style={{fontSize:11,color:"var(--t3)"}}>{liste.length} Preislisten</div>
      <Btn primary onClick={openAdd}>+ Preisliste erfassen</Btn>
    </div>
    <div style={{marginBottom:16,padding:"12px 16px",borderRadius:8,background:"var(--ylw2)",border:"1px solid var(--ylw)",fontSize:11,color:"var(--ylw)"}}>
      <strong>Hinweis:</strong> CSV/Excel-Parsing und OCR für PDFs werden nach Datei-Upload automatisch gestartet. Spalten-Mapping erfolgt im nächsten Schritt.
    </div>
    <Card>
      <div style={{display:"grid",gridTemplateColumns:"1fr 160px 70px 100px 105px 64px",padding:"0 0 8px",borderBottom:"1px solid var(--brd)",fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:8}}>
        <span>Dateiname</span><span>Lieferant</span><span>Format</span><span>Status</span><span>Hochgeladen</span><span/>
      </div>
      {liste.length===0&&<EmptyState icon="◧" title="Keine Preislisten" sub="Lade CSV, Excel oder PDF Preislisten deiner Lieferanten hoch"/>}
      {liste.map(l=><div key={l._id} style={{display:"grid",gridTemplateColumns:"1fr 160px 70px 100px 105px 64px",padding:"10px 0",borderBottom:"1px solid var(--brd)",fontSize:12,alignItems:"center",gap:8}}>
        <span style={{fontWeight:500,color:"var(--t1)"}}>{l.dateiname||"–"}</span>
        <span style={{color:"var(--t2)",fontSize:11}}>{getLiefName(l.lieferantId)}</span>
        <span style={{fontSize:10,padding:"2px 7px",borderRadius:4,background:"var(--s2)",color:"var(--t3)",fontWeight:600,textTransform:"uppercase"}}>{l.format||"–"}</span>
        <span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:(STATUS_COLOR[l.status]||"var(--acc)")+"22",color:STATUS_COLOR[l.status]||"var(--acc)"}}>{l.status||"neu"}</span>
        <span style={{color:"var(--t3)",fontSize:10}}>{fmtDate(l.createdAt)}</span>
        <div style={{display:"flex",gap:4}}><Btn small onClick={()=>{setForm({lieferantId:l.lieferantId||"",dateiname:l.dateiname||"",format:l.format||"csv",status:l.status||"neu",notizen:l.notizen||""});setModal(l);}}>Edit</Btn><Btn small onClick={()=>del(l._id)} style={{color:"var(--red)"}}>✕</Btn></div>
      </div>)}
    </Card>
    {modal&&<Modal open={true} onClose={()=>setModal(null)} title={modal==="add"?"Preisliste erfassen":"Preisliste bearbeiten"} width={520}>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Lieferant</label>
          <select value={form.lieferantId} onChange={e=>setForm({...form,lieferantId:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
            <option value="">– wählen –</option>
            {lieferanten.map(l=><option key={l._id} value={l._id}>{l.name}</option>)}
          </select>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:8}}>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Dateiname</label><input value={form.dateiname} onChange={e=>setForm({...form,dateiname:e.target.value})} placeholder="preisliste_ss26.csv" style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Format</label>
            <select value={form.format} onChange={e=>setForm({...form,format:e.target.value})} style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
              <option value="csv">CSV</option><option value="excel">Excel</option><option value="pdf">PDF</option>
            </select>
          </div>
        </div>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Status</label>
          <select value={form.status} onChange={e=>setForm({...form,status:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
            <option value="neu">Neu</option><option value="interpretiert">Interpretiert</option><option value="zugeordnet">Zugeordnet</option><option value="abgelehnt">Abgelehnt</option>
          </select>
        </div>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Notizen</label><textarea value={form.notizen} onChange={e=>setForm({...form,notizen:e.target.value})} rows={2} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",resize:"vertical"}}/></div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}><Btn onClick={()=>setModal(null)}>Abbrechen</Btn><Btn primary onClick={save} disabled={saving}>{saving?"Speichere…":"Speichern"}</Btn></div>
      </div>
    </Modal>}
  </>;
};

/* ─── Preorder ─── */
const SAISONS=["SS25","HW25","SS26","HW26","SS27","HW27"];
const Preorder=()=>{
  const [orders,setOrders]=useState([]);
  const [lieferanten,setLieferanten]=useState([]);
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({saison:"SS26",lieferantId:"",lieferdatum:"",status:"offen",betrag:0,notizen:""});
  const [saving,setSaving]=useState(false);
  const load=()=>{
    fetch("/api/preorder").then(r=>r.json()).then(d=>setOrders(Array.isArray(d)?d:[])).catch(()=>{});
    fetch("/api/lieferanten").then(r=>r.json()).then(d=>setLieferanten(Array.isArray(d)?d:[])).catch(()=>{});
  };
  useEffect(()=>{load();},[]);
  const getLiefName=id=>{const l=lieferanten.find(x=>String(x._id)===String(id));return l?l.name:"–";};
  const openAdd=()=>{setForm({saison:"SS26",lieferantId:"",lieferdatum:"",status:"offen",betrag:0,notizen:""});setModal("add");};
  const openEdit=o=>{setForm({saison:o.saison||"SS26",lieferantId:o.lieferantId||"",lieferdatum:o.lieferdatum||"",status:o.status||"offen",betrag:o.betrag||0,notizen:o.notizen||""});setModal(o);};
  const save=async()=>{
    setSaving(true);
    const url=modal==="add"?"/api/preorder":`/api/preorder/${modal._id}`;
    await fetch(url,{method:modal==="add"?"POST":"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)}).catch(()=>{});
    setSaving(false);setModal(null);load();
  };
  const del=async id=>{if(!confirm("Preorder löschen?"))return;await fetch(`/api/preorder/${id}`,{method:"DELETE"}).catch(()=>{});load();};
  const STATUS_COLORS={offen:"var(--ylw)",bestaetigt:"var(--acc)",teilgeliefert:"var(--purple)",geliefert:"var(--grn)",bezahlt:"var(--grn)",abweichung:"var(--red)"};
  return<>
    <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}><Btn primary onClick={openAdd}>+ Preorder anlegen</Btn></div>
    <Card>
      <div style={{display:"grid",gridTemplateColumns:"80px 1fr 100px 100px 90px 100px 64px",padding:"0 0 8px",borderBottom:"1px solid var(--brd)",fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",gap:8}}>
        <span>Saison</span><span>Lieferant</span><span>Lieferdatum</span><span>Betrag</span><span>Status</span><span>Angelegt</span><span/>
      </div>
      {orders.length===0&&<EmptyState icon="◇" title="Keine Preorders" sub="Lege saisonale Vorbestellungen bei deinen Lieferanten an"/>}
      {orders.map(o=><div key={o._id} style={{display:"grid",gridTemplateColumns:"80px 1fr 100px 100px 90px 100px 64px",padding:"10px 0",borderBottom:"1px solid var(--brd)",fontSize:12,alignItems:"center",gap:8}}>
        <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:11,fontWeight:700,color:"var(--purple)"}}>{o.saison}</span>
        <span style={{fontWeight:500,color:"var(--t1)"}}>{getLiefName(o.lieferantId)}</span>
        <span style={{color:"var(--t2)",fontSize:11}}>{o.lieferdatum?fmtDate(o.lieferdatum):"–"}</span>
        <span style={{color:"var(--t1)",fontWeight:600}}>{o.betrag>0?fmt(o.betrag):"–"}</span>
        <span style={{padding:"2px 7px",borderRadius:4,fontSize:10,fontWeight:600,background:(STATUS_COLORS[o.status]||"var(--t3)")+"22",color:STATUS_COLORS[o.status]||"var(--t3)"}}>{o.status||"offen"}</span>
        <span style={{color:"var(--t3)",fontSize:10}}>{fmtDate(o.createdAt)}</span>
        <div style={{display:"flex",gap:4}}><Btn small onClick={()=>openEdit(o)}>Edit</Btn><Btn small onClick={()=>del(o._id)} style={{color:"var(--red)"}}>✕</Btn></div>
      </div>)}
    </Card>
    {modal&&<Modal open={true} onClose={()=>setModal(null)} title={modal==="add"?"Preorder anlegen":"Preorder bearbeiten"} width={520}>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Saison</label>
            <select value={form.saison} onChange={e=>setForm({...form,saison:e.target.value})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
              {SAISONS.map(s=><option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Status</label>
            <select value={form.status} onChange={e=>setForm({...form,status:e.target.value})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
              {["offen","bestaetigt","teilgeliefert","geliefert","bezahlt","abweichung"].map(s=><option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Lieferant</label>
          <select value={form.lieferantId} onChange={e=>setForm({...form,lieferantId:e.target.value})} style={{width:"100%",padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
            <option value="">– wählen –</option>
            {lieferanten.map(l=><option key={l._id} value={l._id}>{l.name}</option>)}
          </select>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Lieferdatum (geplant)</label><input type="date" value={form.lieferdatum} onChange={e=>setForm({...form,lieferdatum:e.target.value})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/></div>
          <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Gesamtbetrag (€)</label><input type="number" step="0.01" value={form.betrag} onChange={e=>setForm({...form,betrag:parseFloat(e.target.value)||0})} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/></div>
        </div>
        <div><label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Notizen</label><textarea value={form.notizen} onChange={e=>setForm({...form,notizen:e.target.value})} rows={2} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",resize:"vertical"}}/></div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}><Btn onClick={()=>setModal(null)}>Abbrechen</Btn><Btn primary onClick={save} disabled={saving}>{saving?"Speichere…":"Speichern"}</Btn></div>
      </div>
    </Modal>}
  </>;
};

/* ─── CrmModal ─── */
const CrmModal=({children,onClose,title,wide})=><div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,backdropFilter:"blur(2px)"}}>
  <div style={{background:"var(--s1)",borderRadius:14,padding:"22px 24px",width:wide?"700px":"480px",maxWidth:"95vw",maxHeight:"90vh",overflowY:"auto",border:"1px solid var(--brd)",boxShadow:"0 20px 60px rgba(0,0,0,.5)"}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
      <span style={{fontSize:15,fontWeight:700,color:"var(--t1)"}}>{title}</span>
      <button onClick={onClose} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:"var(--t3)",padding:"0 4px"}}>×</button>
    </div>
    {children}
  </div>
</div>;

const Inp=({label,value,onChange,type="text",placeholder="",required,small})=><div style={{marginBottom:small?0:12}}>
  {label&&<label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3,fontWeight:500}}>{label}{required&&<span style={{color:"var(--red)"}}> *</span>}</label>}
  <input type={type} value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
    style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/>
</div>;

const Sel=({label,value,onChange,opts=[]})=><div style={{marginBottom:12}}>
  {label&&<label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3,fontWeight:500}}>{label}</label>}
  <select value={value||""} onChange={e=>onChange(e.target.value)}
    style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",cursor:"pointer"}}>
    {opts.map(o=>typeof o==="string"?<option key={o} value={o}>{o}</option>:<option key={o.v} value={o.v}>{o.l}</option>)}
  </select>
</div>;

/* ─── CRM Helpers ─── */
const FIRMA_STATUS=[{v:"lead",l:"Lead"},{v:"kunde",l:"Kunde"},{v:"inaktiv",l:"Inaktiv"},{v:"prospect",l:"Prospect"}];
const FIRMA_STATUS_COLOR={lead:"var(--acc)",kunde:"var(--grn)",inaktiv:"var(--t3)",prospect:"var(--ylw)"};
const LEAD_PRIO=[{v:"niedrig",l:"Niedrig"},{v:"mittel",l:"Mittel"},{v:"hoch",l:"Hoch"}];
const LEAD_PRIO_COLOR={niedrig:"var(--t3)",mittel:"var(--ylw)",hoch:"var(--red)"};
const AKTIVITAET_TYPEN=[{v:"notiz",l:"📝 Notiz"},{v:"telefon",l:"📞 Telefon"},{v:"email",l:"✉ E-Mail"},{v:"meeting",l:"🤝 Meeting"},{v:"aufgabe",l:"✓ Aufgabe"}];
const BRANCHEN=["Einzelhandel","Großhandel","Online-Handel","Boutique","Sport & Outdoor","Department Store","Outlet","Mode & Lifestyle","Sonstiges"];

/* ─── CRM Dashboard ─── */
const CrmDashboard=()=>{
  const [d,setD]=useState(null);
  const [aufgaben,setAufgaben]=useState([]);
  const load=()=>{
    fetch("/api/crm/dashboard").then(r=>r.json()).then(setD).catch(()=>{});
    fetch("/api/crm/aufgaben?status=offen").then(r=>r.json()).then(d=>setAufgaben(Array.isArray(d)?d.slice(0,8):[]) ).catch(()=>{});
  };
  useEffect(()=>{load();},[]);
  const today=new Date(); today.setHours(0,0,0,0);
  const tomorrow=new Date(today.getTime()+86400000);
  const farbeFaellig=a=>{if(!a.faellig)return"var(--t3)";const d=new Date(a.faellig);return d<today?"var(--red)":d<tomorrow?"var(--ylw)":"var(--t2)";};
  if(!d)return<div style={{padding:40,textAlign:"center",color:"var(--t3)",fontSize:13}}>Lade CRM…</div>;
  return<>
    <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:14,marginBottom:20}}>
      <KPI title="Firmen gesamt" value={d.firmen} sub={`${d.kunden} Kunden`} icon="🏢" accent="var(--acc)"/>
      <KPI title="Offene Leads" value={d.offeneLeads} sub={`${d.neueLeads} diese Woche neu`} icon="◉" accent="var(--ylw)"/>
      <KPI title="Aufgaben offen" value={d.offeneAufgaben} sub={`${d.faelligHeute} heute fällig`} icon="✓" accent={d.faelligHeute>0?"var(--red)":"var(--grn)"}/>
      <KPI title="Pipelines" value={d.pipelines} sub="Aktive Vertriebsprozesse" icon="◇" accent="var(--purple)"/>
      <KPI title="Conversion" value={d.firmen>0?`${Math.round((d.kunden/d.firmen)*100)}%`:"–"} sub="Lead → Kunde" icon="↗" accent="var(--grn)"/>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
      <Card>
        <div style={{fontSize:13,fontWeight:600,marginBottom:14,color:"var(--t1)"}}>Pipeline-Verteilung</div>
        {Object.entries(d.phasenMap||{}).length===0&&<span style={{fontSize:12,color:"var(--t3)"}}>Noch keine Leads angelegt</span>}
        {Object.entries(d.phasenMap||{}).map(([phase,count])=>{
          const total=Object.values(d.phasenMap).reduce((a,b)=>a+b,0);
          return<div key={phase} style={{marginBottom:8}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
              <span style={{fontSize:12,color:"var(--t2)"}}>{phase}</span>
              <span style={{fontSize:12,fontWeight:600,color:"var(--t1)"}}>{count}</span>
            </div>
            <div style={{height:5,borderRadius:3,background:"var(--s2)"}}><div style={{height:"100%",width:`${(count/total)*100}%`,background:"var(--acc)",borderRadius:3}}/></div>
          </div>;
        })}
      </Card>
      <Card>
        <div style={{fontSize:13,fontWeight:600,marginBottom:14,color:"var(--t1)"}}>Fällige Aufgaben</div>
        {aufgaben.length===0&&<span style={{fontSize:12,color:"var(--t3)"}}>Keine offenen Aufgaben</span>}
        {aufgaben.map(a=><div key={a._id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 0",borderBottom:"1px solid var(--brd)"}}>
          <div>
            <div style={{fontSize:12,color:"var(--t1)",fontWeight:500}}>{a.titel}</div>
            <div style={{fontSize:10,color:"var(--t3)"}}>{a.firmaName||a.leadTitel||""}</div>
          </div>
          <span style={{fontSize:10,fontWeight:600,color:farbeFaellig(a)}}>{a.faellig?fmtDate(a.faellig):"–"}</span>
        </div>)}
      </Card>
    </div>
  </>;
};

/* ─── CRM Firmen ─── */
const CrmFirmen=()=>{
  const [items,setItems]=useState([]);
  const [total,setTotal]=useState(0);
  const [search,setSearch]=useState("");
  const [status,setStatus]=useState("");
  const [page,setPage]=useState(1);
  const [modal,setModal]=useState(null);
  const [detail,setDetail]=useState(null);
  const LIMIT=25;
  const emptyForm={name:"",branche:"",adresse:"",plz:"",ort:"",land:"DE",website:"",telefon:"",email:"",ansprechpartner:"",notizen:"",status:"lead",kundennummer:""};
  const [form,setForm]=useState({...emptyForm});
  const [saving,setSaving]=useState(false);
  const sf=(k,v)=>setForm(f=>({...f,[k]:v}));
  const load=()=>{
    const p=new URLSearchParams({search,status,page,limit:LIMIT});
    fetch(`/api/crm/firmen?${p}`).then(r=>r.json()).then(d=>{setItems(d.items||[]);setTotal(d.total||0);}).catch(()=>{});
  };
  useEffect(()=>{load();},[search,status,page]);
  const openAdd=()=>{setForm({...emptyForm});setModal("add");};
  const openEdit=f=>{setForm({...emptyForm,...f});setModal(f);};
  const save=async()=>{
    setSaving(true);
    if(modal==="add") await fetch("/api/crm/firmen",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    else await fetch(`/api/crm/firmen/${modal._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    setSaving(false);setModal(null);load();
  };
  const del=async id=>{if(!confirm("Firma löschen?"))return;await fetch(`/api/crm/firmen/${id}`,{method:"DELETE"});load();};
  const sC={background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",cursor:"pointer"};
  return<>
    <div style={{display:"flex",gap:10,marginBottom:14,alignItems:"center"}}>
      <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}} placeholder="Firma suchen…" style={{flex:1,padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/>
      <select value={status} onChange={e=>{setStatus(e.target.value);setPage(1);}} style={sC}>
        <option value="">Alle Status</option>
        {FIRMA_STATUS.map(s=><option key={s.v} value={s.v}>{s.l}</option>)}
      </select>
      <Btn primary onClick={openAdd}>+ Firma</Btn>
    </div>
    <Card style={{padding:0,overflow:"hidden"}}>
      <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 100px 90px",padding:"8px 16px",borderBottom:"1px solid var(--brd)",background:"var(--s2)"}}>
        {["Firmenname","Branche","Ort","Status","Letzte Aktivität",""].map(h=><span key={h} style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>{h}</span>)}
      </div>
      {items.length===0&&<EmptyState icon="🏢" title="Keine Firmen gefunden" sub="Lege die erste Firma an"/>}
      {items.map(f=><div key={f._id} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 100px 90px",padding:"11px 16px",borderBottom:"1px solid var(--brd)",alignItems:"center",cursor:"pointer"}}
        onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}
        onClick={()=>setDetail(f)}>
        <div>
          <div style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>{f.name}</div>
          {f.website&&<div style={{fontSize:10,color:"var(--t3)"}}>{f.website}</div>}
        </div>
        <span style={{fontSize:12,color:"var(--t2)"}}>{f.branche||"–"}</span>
        <span style={{fontSize:12,color:"var(--t2)"}}>{f.ort||"–"}</span>
        <span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:(FIRMA_STATUS_COLOR[f.status]||"var(--t3)")+"22",color:FIRMA_STATUS_COLOR[f.status]||"var(--t3)",display:"inline-block",width:"fit-content"}}>{FIRMA_STATUS.find(s=>s.v===f.status)?.l||f.status}</span>
        <span style={{fontSize:11,color:"var(--t3)"}}>{f.updatedAt?fmtAge(f.updatedAt):"–"}</span>
        <div style={{display:"flex",gap:4}} onClick={e=>e.stopPropagation()}>
          <Btn small onClick={()=>openEdit(f)}>Edit</Btn>
          <Btn small onClick={()=>del(f._id)} style={{color:"var(--red)"}}>✕</Btn>
        </div>
      </div>)}
    </Card>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:12,fontSize:12,color:"var(--t3)"}}>
      <span>{total} Firmen</span>
      <div style={{display:"flex",gap:6}}>
        <Btn small onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page<=1}>‹</Btn>
        <span style={{padding:"4px 8px"}}>{page}/{Math.max(1,Math.ceil(total/LIMIT))}</span>
        <Btn small onClick={()=>setPage(p=>p+1)} disabled={page>=Math.ceil(total/LIMIT)}>›</Btn>
      </div>
    </div>

    {modal&&<CrmModal title={modal==="add"?"Neue Firma":"Firma bearbeiten"} onClose={()=>setModal(null)}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px"}}>
        <div style={{gridColumn:"1/-1"}}><Inp label="Firmenname" value={form.name} onChange={v=>sf("name",v)} required/></div>
        <Sel label="Branche" value={form.branche} onChange={v=>sf("branche",v)} opts={["",...BRANCHEN]}/>
        <Sel label="Status" value={form.status} onChange={v=>sf("status",v)} opts={FIRMA_STATUS}/>
        <Inp label="Adresse" value={form.adresse} onChange={v=>sf("adresse",v)}/>
        <Inp label="PLZ" value={form.plz} onChange={v=>sf("plz",v)}/>
        <Inp label="Ort" value={form.ort} onChange={v=>sf("ort",v)}/>
        <Inp label="Land" value={form.land} onChange={v=>sf("land",v)}/>
        <Inp label="Website" value={form.website} onChange={v=>sf("website",v)}/>
        <Inp label="Telefon" value={form.telefon} onChange={v=>sf("telefon",v)}/>
        <Inp label="E-Mail" value={form.email} onChange={v=>sf("email",v)} type="email"/>
        <Inp label="Kundennummer" value={form.kundennummer} onChange={v=>sf("kundennummer",v)}/>
        <div style={{gridColumn:"1/-1"}}>
          <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3,fontWeight:500}}>Notizen</label>
          <textarea value={form.notizen||""} onChange={e=>sf("notizen",e.target.value)} rows={3} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",resize:"vertical"}}/>
        </div>
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)",marginTop:4}}>
        <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
        <Btn primary onClick={save} disabled={saving||!form.name}>{saving?"Speichere…":"Speichern"}</Btn>
      </div>
    </CrmModal>}

    {detail&&<CrmModal title={detail.name} onClose={()=>setDetail(null)} wide>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
        <div>
          <div style={{fontSize:11,color:"var(--t3)",fontWeight:600,marginBottom:8,textTransform:"uppercase",letterSpacing:".5px"}}>Stammdaten</div>
          {[["Branche",detail.branche],["Adresse",[detail.adresse,detail.plz,detail.ort].filter(Boolean).join(", ")],["Land",detail.land],["Website",detail.website],["Telefon",detail.telefon],["E-Mail",detail.email],["Status",FIRMA_STATUS.find(s=>s.v===detail.status)?.l||detail.status]].map(([k,v])=>v?<div key={k} style={{display:"flex",gap:8,padding:"5px 0",borderBottom:"1px solid var(--brd)",fontSize:12}}><span style={{color:"var(--t3)",width:90,flexShrink:0}}>{k}</span><span style={{color:"var(--t1)"}}>{v}</span></div>:null)}
        </div>
        <div>
          <div style={{fontSize:11,color:"var(--t3)",fontWeight:600,marginBottom:8,textTransform:"uppercase",letterSpacing:".5px"}}>Notizen</div>
          <div style={{fontSize:12,color:"var(--t2)",lineHeight:1.6}}>{detail.notizen||"Keine Notizen"}</div>
        </div>
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:12,borderTop:"1px solid var(--brd)",marginTop:12}}>
        <Btn onClick={()=>{setDetail(null);openEdit(detail);}}>Bearbeiten</Btn>
        <Btn onClick={()=>setDetail(null)}>Schließen</Btn>
      </div>
    </CrmModal>}
  </>;
};

/* ─── CRM Kontakte ─── */
const CrmKontakte=()=>{
  const [items,setItems]=useState([]);
  const [firmen,setFirmen]=useState([]);
  const [search,setSearch]=useState("");
  const [modal,setModal]=useState(null);
  const [saving,setSaving]=useState(false);
  const emptyForm={vorname:"",nachname:"",email:"",telefon:"",mobil:"",rolle:"",firmaId:"",notizen:""};
  const [form,setForm]=useState({...emptyForm});
  const sf=(k,v)=>setForm(f=>({...f,[k]:v}));
  const load=()=>{
    fetch(`/api/crm/kontakte?search=${encodeURIComponent(search)}`).then(r=>r.json()).then(d=>setItems(Array.isArray(d)?d:[])).catch(()=>{});
  };
  useEffect(()=>{
    fetch("/api/crm/firmen?limit=200").then(r=>r.json()).then(d=>setFirmen(d.items||[])).catch(()=>{});
  },[]);
  useEffect(()=>{load();},[search]);
  const openAdd=()=>{setForm({...emptyForm});setModal("add");};
  const openEdit=k=>{setForm({...emptyForm,...k});setModal(k);};
  const save=async()=>{
    setSaving(true);
    if(modal==="add") await fetch("/api/crm/kontakte",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    else await fetch(`/api/crm/kontakte/${modal._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    setSaving(false);setModal(null);load();
  };
  const del=async id=>{if(!confirm("Kontakt löschen?"))return;await fetch(`/api/crm/kontakte/${id}`,{method:"DELETE"});load();};
  const firmaName=id=>(firmen.find(f=>String(f._id)===id)||{}).name||"–";
  return<>
    <div style={{display:"flex",gap:10,marginBottom:14,alignItems:"center"}}>
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Kontakt suchen…" style={{flex:1,padding:"8px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/>
      <Btn primary onClick={openAdd}>+ Kontakt</Btn>
    </div>
    <Card style={{padding:0,overflow:"hidden"}}>
      <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 80px",padding:"8px 16px",borderBottom:"1px solid var(--brd)",background:"var(--s2)"}}>
        {["Name","Firma","Rolle","E-Mail",""].map(h=><span key={h} style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>{h}</span>)}
      </div>
      {items.length===0&&<EmptyState icon="👤" title="Keine Kontakte" sub="Füge den ersten Ansprechpartner hinzu"/>}
      {items.map(k=><div key={k._id} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 80px",padding:"10px 16px",borderBottom:"1px solid var(--brd)",alignItems:"center"}}
        onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
        <div>
          <div style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>{k.vorname} {k.nachname}</div>
          {k.telefon&&<div style={{fontSize:10,color:"var(--t3)"}}>{k.telefon}</div>}
        </div>
        <span style={{fontSize:12,color:"var(--t2)"}}>{k.firmaId?firmaName(k.firmaId):"–"}</span>
        <span style={{fontSize:12,color:"var(--t2)"}}>{k.rolle||"–"}</span>
        <span style={{fontSize:12,color:"var(--t2)"}}>{k.email||"–"}</span>
        <div style={{display:"flex",gap:4}}>
          <Btn small onClick={()=>openEdit(k)}>Edit</Btn>
          <Btn small onClick={()=>del(k._id)} style={{color:"var(--red)"}}>✕</Btn>
        </div>
      </div>)}
    </Card>
    {modal&&<CrmModal title={modal==="add"?"Neuer Kontakt":"Kontakt bearbeiten"} onClose={()=>setModal(null)}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px"}}>
        <Inp label="Vorname" value={form.vorname} onChange={v=>sf("vorname",v)}/>
        <Inp label="Nachname" value={form.nachname} onChange={v=>sf("nachname",v)} required/>
        <Inp label="E-Mail" value={form.email} onChange={v=>sf("email",v)} type="email"/>
        <Inp label="Telefon" value={form.telefon} onChange={v=>sf("telefon",v)}/>
        <Inp label="Mobil" value={form.mobil} onChange={v=>sf("mobil",v)}/>
        <Inp label="Rolle / Funktion" value={form.rolle} onChange={v=>sf("rolle",v)}/>
        <div style={{gridColumn:"1/-1"}}>
          <Sel label="Firma" value={form.firmaId} onChange={v=>sf("firmaId",v)} opts={[{v:"",l:"– Keine Firma –"},...firmen.map(f=>({v:String(f._id),l:f.name}))]}/>
        </div>
        <div style={{gridColumn:"1/-1"}}>
          <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3,fontWeight:500}}>Notizen</label>
          <textarea value={form.notizen||""} onChange={e=>sf("notizen",e.target.value)} rows={2} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",resize:"vertical"}}/>
        </div>
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)",marginTop:4}}>
        <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
        <Btn primary onClick={save} disabled={saving||!form.nachname}>{saving?"Speichere…":"Speichern"}</Btn>
      </div>
    </CrmModal>}
  </>;
};

/* ─── CRM Pipelines ─── */
const CrmPipelines=()=>{
  const [items,setItems]=useState([]);
  const [modal,setModal]=useState(null);
  const [saving,setSaving]=useState(false);
  const [form,setForm]=useState({name:"",phasen:["Lead neu","Kontaktiert","Angebot erstellt","Gewonnen","Verloren"]});
  const sf=(k,v)=>setForm(f=>({...f,[k]:v}));
  const load=()=>fetch("/api/crm/pipelines").then(r=>r.json()).then(d=>setItems(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);
  const openAdd=()=>{setForm({name:"",phasen:["Lead neu","Kontaktiert","Angebot erstellt","Gewonnen","Verloren"]});setModal("add");};
  const openEdit=p=>{setForm({name:p.name,phasen:[...p.phasen]});setModal(p);};
  const save=async()=>{
    setSaving(true);
    if(modal==="add") await fetch("/api/crm/pipelines",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    else await fetch(`/api/crm/pipelines/${modal._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    setSaving(false);setModal(null);load();
  };
  const del=async id=>{if(!confirm("Pipeline löschen?"))return;await fetch(`/api/crm/pipelines/${id}`,{method:"DELETE"});load();};
  const addPhase=()=>setForm(f=>({...f,phasen:[...f.phasen,""]}));
  const setPhase=(i,v)=>setForm(f=>({...f,phasen:f.phasen.map((p,pi)=>pi===i?v:p)}));
  const removePhase=i=>setForm(f=>({...f,phasen:f.phasen.filter((_,pi)=>pi!==i)}));
  return<>
    <div style={{display:"flex",justifyContent:"flex-end",marginBottom:14}}>
      <Btn primary onClick={openAdd}>+ Pipeline</Btn>
    </div>
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {items.length===0&&<EmptyState icon="◇" title="Keine Pipelines" sub="Lege eine Vertriebspipeline an"/>}
      {items.map(p=><Card key={p._id}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <span style={{fontSize:15,fontWeight:700,color:"var(--t1)"}}>{p.name}</span>
          <div style={{display:"flex",gap:6}}>
            <Btn small onClick={()=>openEdit(p)}>Edit</Btn>
            <Btn small onClick={()=>del(p._id)} style={{color:"var(--red)"}}>✕</Btn>
          </div>
        </div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {(p.phasen||[]).map((phase,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:4}}>
            <span style={{padding:"4px 10px",borderRadius:6,fontSize:11,fontWeight:500,background:"var(--s2)",color:"var(--t2)",border:"1px solid var(--brd)"}}>{phase}</span>
            {i<p.phasen.length-1&&<span style={{color:"var(--t3)",fontSize:10}}>›</span>}
          </div>)}
        </div>
      </Card>)}
    </div>
    {modal&&<CrmModal title={modal==="add"?"Neue Pipeline":"Pipeline bearbeiten"} onClose={()=>setModal(null)}>
      <Inp label="Pipeline-Name" value={form.name} onChange={v=>sf("name",v)} required/>
      <div style={{marginBottom:12}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <label style={{fontSize:11,color:"var(--t2)",fontWeight:500}}>Phasen</label>
          <Btn small onClick={addPhase}>+ Phase</Btn>
        </div>
        {form.phasen.map((ph,i)=><div key={i} style={{display:"flex",gap:6,marginBottom:6,alignItems:"center"}}>
          <span style={{fontSize:11,color:"var(--t3)",width:16,flexShrink:0}}>{i+1}.</span>
          <input value={ph} onChange={e=>setPhase(i,e.target.value)} style={{flex:1,padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
          <button onClick={()=>removePhase(i)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--red)",fontSize:14,padding:"0 4px"}}>×</button>
        </div>)}
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}>
        <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
        <Btn primary onClick={save} disabled={saving||!form.name}>{saving?"Speichere…":"Speichern"}</Btn>
      </div>
    </CrmModal>}
  </>;
};

/* ─── CRM Leads ─── */
const CrmLeads=()=>{
  const [items,setItems]=useState([]);
  const [total,setTotal]=useState(0);
  const [pipelines,setPipelines]=useState([]);
  const [firmen,setFirmen]=useState([]);
  const [filterPipeline,setFilterPipeline]=useState("");
  const [filterPhase,setFilterPhase]=useState("");
  const [search,setSearch]=useState("");
  const [page,setPage]=useState(1);
  const [modal,setModal]=useState(null);
  const [detail,setDetail]=useState(null);
  const [history,setHistory]=useState([]);
  const [saving,setSaving]=useState(false);
  const LIMIT=30;
  const emptyForm={titel:"",firmaId:"",firmaName:"",pipelineId:"",phase:"",verantwortlicher:"",quelle:"",prioritaet:"mittel",faellig:"",umsatzchance:0,notizen:""};
  const [form,setForm]=useState({...emptyForm});
  const sf=(k,v)=>setForm(f=>({...f,[k]:v}));
  const load=()=>{
    const p=new URLSearchParams({pipelineId:filterPipeline,phase:filterPhase,search,page,limit:LIMIT});
    fetch(`/api/crm/leads?${p}`).then(r=>r.json()).then(d=>{setItems(d.items||[]);setTotal(d.total||0);}).catch(()=>{});
  };
  useEffect(()=>{
    fetch("/api/crm/pipelines").then(r=>r.json()).then(d=>setPipelines(Array.isArray(d)?d:[])).catch(()=>{});
    fetch("/api/crm/firmen?limit=200").then(r=>r.json()).then(d=>setFirmen(d.items||[])).catch(()=>{});
  },[]);
  useEffect(()=>{load();},[filterPipeline,filterPhase,search,page]);
  const activePipeline=pipelines.find(p=>String(p._id)===filterPipeline)||pipelines[0];
  const phasen=activePipeline?.phasen||[];
  const openAdd=()=>{setForm({...emptyForm,pipelineId:activePipeline?String(activePipeline._id):"",phase:phasen[0]||""});setModal("add");};
  const openEdit=l=>{setForm({...emptyForm,...l,pipelineId:l.pipelineId||"",phase:l.phase||""});setModal(l);};
  const openDetail=async l=>{setDetail(l);setHistory([]);const h=await fetch(`/api/crm/leads/${l._id}/history`).then(r=>r.json()).catch(()=>[]);setHistory(h);};
  const save=async()=>{
    setSaving(true);
    const firmaObj=firmen.find(f=>String(f._id)===form.firmaId);
    const payload={...form,firmaName:firmaObj?.name||form.firmaName};
    if(modal==="add") await fetch("/api/crm/leads",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
    else await fetch(`/api/crm/leads/${modal._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
    setSaving(false);setModal(null);load();
  };
  const del=async id=>{if(!confirm("Lead löschen?"))return;await fetch(`/api/crm/leads/${id}`,{method:"DELETE"});load();};
  const sC={background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",padding:"7px 10px",borderRadius:7,border:"1px solid var(--brd)",cursor:"pointer"};
  const today=new Date(); today.setHours(23,59,59,0);
  const prioColor=p=>LEAD_PRIO_COLOR[p]||"var(--t3)";
  const phaseColor=p=>{const g=["Gewonnen"];const r=["Verloren"];return g.includes(p)?"var(--grn)":r.includes(p)?"var(--red)":"var(--acc)"};
  return<>
    <div style={{display:"flex",gap:8,marginBottom:14,alignItems:"center",flexWrap:"wrap"}}>
      <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}} placeholder="Lead suchen…" style={{flex:1,minWidth:160,padding:"7px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
      <select value={filterPipeline} onChange={e=>{setFilterPipeline(e.target.value);setFilterPhase("");setPage(1);}} style={sC}>
        <option value="">Alle Pipelines</option>
        {pipelines.map(p=><option key={p._id} value={String(p._id)}>{p.name}</option>)}
      </select>
      <select value={filterPhase} onChange={e=>{setFilterPhase(e.target.value);setPage(1);}} style={sC}>
        <option value="">Alle Phasen</option>
        {phasen.map(p=><option key={p} value={p}>{p}</option>)}
      </select>
      <Btn primary onClick={openAdd}>+ Lead</Btn>
    </div>
    <Card style={{padding:0,overflow:"hidden"}}>
      <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 80px 90px",padding:"8px 16px",borderBottom:"1px solid var(--brd)",background:"var(--s2)"}}>
        {["Lead / Firma","Phase","Priorität","Fällig","Pipeline",""].map(h=><span key={h} style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>{h}</span>)}
      </div>
      {items.length===0&&<EmptyState icon="◉" title="Keine Leads" sub="Lege den ersten Lead an"/>}
      {items.map(l=>{
        const ueberfaellig=l.faellig&&new Date(l.faellig)<today&&l.phase!=="Gewonnen"&&l.phase!=="Verloren";
        const pl=pipelines.find(p=>String(p._id)===l.pipelineId);
        return<div key={l._id} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr 80px 90px",padding:"10px 16px",borderBottom:"1px solid var(--brd)",alignItems:"center",cursor:"pointer",background:ueberfaellig?"rgba(248,113,113,.04)":"transparent"}}
          onMouseEnter={e=>e.currentTarget.style.background=ueberfaellig?"rgba(248,113,113,.08)":"var(--shov)"} onMouseLeave={e=>e.currentTarget.style.background=ueberfaellig?"rgba(248,113,113,.04)":"transparent"}
          onClick={()=>openDetail(l)}>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>{l.titel||l.firmaName||"–"}</div>
            <div style={{fontSize:10,color:"var(--t3)"}}>{l.firmaName||""}</div>
          </div>
          <span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:phaseColor(l.phase)+"22",color:phaseColor(l.phase),display:"inline-block"}}>{l.phase||"–"}</span>
          <span style={{fontSize:12,fontWeight:600,color:prioColor(l.prioritaet)}}>{l.prioritaet||"–"}</span>
          <span style={{fontSize:11,color:ueberfaellig?"var(--red)":"var(--t2)",fontWeight:ueberfaellig?600:400}}>{l.faellig?fmtDate(l.faellig):"–"}</span>
          <span style={{fontSize:11,color:"var(--t3)"}}>{pl?.name||"–"}</span>
          <div style={{display:"flex",gap:4}} onClick={e=>e.stopPropagation()}>
            <Btn small onClick={()=>openEdit(l)}>Edit</Btn>
            <Btn small onClick={()=>del(l._id)} style={{color:"var(--red)"}}>✕</Btn>
          </div>
        </div>;
      })}
    </Card>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:12,fontSize:12,color:"var(--t3)"}}>
      <span>{total} Leads</span>
      <div style={{display:"flex",gap:6}}>
        <Btn small onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page<=1}>‹</Btn>
        <span style={{padding:"4px 8px"}}>{page}/{Math.max(1,Math.ceil(total/LIMIT))}</span>
        <Btn small onClick={()=>setPage(p=>p+1)} disabled={page>=Math.ceil(total/LIMIT)}>›</Btn>
      </div>
    </div>

    {modal&&<CrmModal title={modal==="add"?"Neuer Lead":"Lead bearbeiten"} onClose={()=>setModal(null)} wide>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
        <div style={{gridColumn:"1/-1"}}><Inp label="Lead-Titel / Thema" value={form.titel} onChange={v=>sf("titel",v)}/></div>
        <Sel label="Firma" value={form.firmaId} onChange={v=>sf("firmaId",v)} opts={[{v:"",l:"– Firma wählen –"},...firmen.map(f=>({v:String(f._id),l:f.name}))]}/>
        <Sel label="Pipeline" value={form.pipelineId} onChange={v=>{sf("pipelineId",v);const pl=pipelines.find(p=>String(p._id)===v);sf("phase",pl?.phasen?.[0]||"");}} opts={[{v:"",l:"– Pipeline wählen –"},...pipelines.map(p=>({v:String(p._id),l:p.name}))]}/>
        <Sel label="Phase" value={form.phase} onChange={v=>sf("phase",v)} opts={(pipelines.find(p=>String(p._id)===form.pipelineId)?.phasen||phasen).map(p=>({v:p,l:p}))}/>
        <Sel label="Priorität" value={form.prioritaet} onChange={v=>sf("prioritaet",v)} opts={LEAD_PRIO}/>
        <Inp label="Fälligkeitsdatum" value={form.faellig} onChange={v=>sf("faellig",v)} type="date"/>
        <Inp label="Verantwortlich" value={form.verantwortlicher} onChange={v=>sf("verantwortlicher",v)}/>
        <Inp label="Quelle" value={form.quelle} onChange={v=>sf("quelle",v)}/>
        <Inp label="Umsatzchance (€)" value={form.umsatzchance} onChange={v=>sf("umsatzchance",v)} type="number"/>
        <div style={{gridColumn:"1/-1"}}>
          <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3,fontWeight:500}}>Notizen</label>
          <textarea value={form.notizen||""} onChange={e=>sf("notizen",e.target.value)} rows={3} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",resize:"vertical"}}/>
        </div>
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)",marginTop:4}}>
        <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
        <Btn primary onClick={save} disabled={saving}>{saving?"Speichere…":"Speichern"}</Btn>
      </div>
    </CrmModal>}

    {detail&&<CrmModal title={detail.titel||detail.firmaName||"Lead"} onClose={()=>setDetail(null)} wide>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
        <div>
          {[["Firma",detail.firmaName],["Phase",detail.phase],["Priorität",detail.prioritaet],["Fällig",detail.faellig?fmtDate(detail.faellig):"–"],["Verantwortlich",detail.verantwortlicher],["Quelle",detail.quelle],["Umsatzchance",detail.umsatzchance?fmt(detail.umsatzchance):"–"]].map(([k,v])=>v?<div key={k} style={{display:"flex",gap:8,padding:"5px 0",borderBottom:"1px solid var(--brd)",fontSize:12}}><span style={{color:"var(--t3)",width:110,flexShrink:0}}>{k}</span><span style={{color:"var(--t1)"}}>{v}</span></div>:null)}
        </div>
        <div>
          <div style={{fontSize:11,color:"var(--t3)",fontWeight:600,marginBottom:8,textTransform:"uppercase",letterSpacing:".5px"}}>Verlauf</div>
          {history.length===0&&<span style={{fontSize:12,color:"var(--t3)"}}>Kein Verlauf</span>}
          {history.map((h,i)=><div key={i} style={{fontSize:11,padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>
            <span style={{color:"var(--t3)"}}>{fmtDate(h.datum)}</span> · {h.vonPhase?`${h.vonPhase} → `:""}
            <span style={{color:"var(--acc)",fontWeight:600}}>{h.zuPhase}</span>
            {h.notiz&&<span style={{color:"var(--t3)"}}> · {h.notiz}</span>}
          </div>)}
        </div>
      </div>
      {detail.notizen&&<div style={{padding:"10px 14px",borderRadius:8,background:"var(--s2)",fontSize:12,color:"var(--t2)",marginBottom:12}}>{detail.notizen}</div>}
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}>
        <Btn onClick={()=>{setDetail(null);openEdit(detail);}}>Bearbeiten</Btn>
        <Btn onClick={()=>setDetail(null)}>Schließen</Btn>
      </div>
    </CrmModal>}
  </>;
};

/* ─── CRM Aufgaben ─── */
const CrmAufgaben=()=>{
  const [items,setItems]=useState([]);
  const [filter,setFilter]=useState("offen");
  const [modal,setModal]=useState(null);
  const [saving,setSaving]=useState(false);
  const emptyForm={titel:"",beschreibung:"",faellig:"",prioritaet:"mittel",firmaName:"",leadTitel:"",typ:"aufgabe"};
  const [form,setForm]=useState({...emptyForm});
  const sf=(k,v)=>setForm(f=>({...f,[k]:v}));
  const load=()=>fetch(`/api/crm/aufgaben?${filter?"status="+filter:""}`).then(r=>r.json()).then(d=>setItems(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[filter]);
  const save=async()=>{
    setSaving(true);
    if(modal==="add") await fetch("/api/crm/aufgaben",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    else await fetch(`/api/crm/aufgaben/${modal._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    setSaving(false);setModal(null);load();
  };
  const erledigen=async id=>{await fetch(`/api/crm/aufgaben/${id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({status:"erledigt",erledigtAm:new Date()})});load();};
  const del=async id=>{if(!confirm("Aufgabe löschen?"))return;await fetch(`/api/crm/aufgaben/${id}`,{method:"DELETE"});load();};
  const today=new Date(); today.setHours(23,59,59,0);
  const farbeF=a=>{if(a.status==="erledigt")return"var(--grn)";if(!a.faellig)return"var(--t3)";return new Date(a.faellig)<today?"var(--red)":"var(--t2)";};
  return<>
    <div style={{display:"flex",gap:8,marginBottom:14,alignItems:"center"}}>
      <Tabs tabs={[{k:"offen",l:"Offen"},{k:"erledigt",l:"Erledigt"},{k:"",l:"Alle"}]} active={filter} onChange={setFilter}/>
      <div style={{flex:1}}/>
      <Btn primary onClick={()=>{setForm({...emptyForm});setModal("add");}}>+ Aufgabe</Btn>
    </div>
    <div style={{display:"flex",flexDirection:"column",gap:6}}>
      {items.length===0&&<EmptyState icon="✓" title="Keine Aufgaben" sub={filter==="offen"?"Alle Aufgaben erledigt!":"Keine Aufgaben gefunden"}/>}
      {items.map(a=><div key={a._id} style={{display:"flex",gap:12,padding:"12px 16px",background:"var(--s1)",borderRadius:10,border:"1px solid var(--brd)",alignItems:"flex-start"}}
        onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"} onMouseLeave={e=>e.currentTarget.style.background="var(--s1)"}>
        {a.status!=="erledigt"&&<button onClick={()=>erledigen(a._id)} title="Als erledigt markieren" style={{width:20,height:20,borderRadius:"50%",border:"2px solid var(--brd)",background:"transparent",cursor:"pointer",flexShrink:0,marginTop:1}}/>}
        {a.status==="erledigt"&&<div style={{width:20,height:20,borderRadius:"50%",background:"var(--grn)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:"#fff",flexShrink:0,marginTop:1}}>✓</div>}
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:13,fontWeight:600,color:a.status==="erledigt"?"var(--t3)":"var(--t1)",textDecoration:a.status==="erledigt"?"line-through":"none"}}>{a.titel}</div>
          {(a.firmaName||a.leadTitel)&&<div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>{a.firmaName||a.leadTitel}</div>}
          {a.beschreibung&&<div style={{fontSize:11,color:"var(--t2)",marginTop:4}}>{a.beschreibung}</div>}
        </div>
        <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4,flexShrink:0}}>
          <span style={{fontSize:11,fontWeight:600,color:farbeF(a)}}>{a.faellig?fmtDate(a.faellig):"kein Datum"}</span>
          <span style={{fontSize:10,padding:"1px 6px",borderRadius:4,background:LEAD_PRIO_COLOR[a.prioritaet]+"22",color:LEAD_PRIO_COLOR[a.prioritaet]}}>{a.prioritaet}</span>
        </div>
        <div style={{display:"flex",gap:4,flexShrink:0}}>
          <Btn small onClick={()=>{setForm({...emptyForm,...a});setModal(a);}}>Edit</Btn>
          <Btn small onClick={()=>del(a._id)} style={{color:"var(--red)"}}>✕</Btn>
        </div>
      </div>)}
    </div>
    {modal&&<CrmModal title={modal==="add"?"Neue Aufgabe":"Aufgabe bearbeiten"} onClose={()=>setModal(null)}>
      <Inp label="Titel" value={form.titel} onChange={v=>sf("titel",v)} required/>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px"}}>
        <Inp label="Fälligkeitsdatum" value={form.faellig} onChange={v=>sf("faellig",v)} type="date"/>
        <Sel label="Priorität" value={form.prioritaet} onChange={v=>sf("prioritaet",v)} opts={LEAD_PRIO}/>
        <Inp label="Firma / Kontext" value={form.firmaName} onChange={v=>sf("firmaName",v)}/>
        <Inp label="Lead / Thema" value={form.leadTitel} onChange={v=>sf("leadTitel",v)}/>
      </div>
      <div style={{marginBottom:12}}>
        <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3,fontWeight:500}}>Beschreibung</label>
        <textarea value={form.beschreibung||""} onChange={e=>sf("beschreibung",e.target.value)} rows={3} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",resize:"vertical"}}/>
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}>
        <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
        <Btn primary onClick={save} disabled={saving||!form.titel}>{saving?"Speichere…":"Speichern"}</Btn>
      </div>
    </CrmModal>}
  </>;
};

/* ─── CRM Sammlung (Lead-Import Staging) ─── */
const SAMMLUNG_STATUS=[
  {v:"neu",l:"Neu",c:"var(--t3)"},
  {v:"in_bearbeitung",l:"In Bearbeitung",c:"var(--ylw)"},
  {v:"bereit",l:"Bereit",c:"var(--grn)"},
  {v:"importiert",l:"→ Lead",c:"var(--acc)"},
];
const LEER_KONTAKT=()=>({vorname:"",nachname:"",email:"",telefon:"",mobil:"",rolle:"",_id:Date.now()+Math.random()});

// Parses a pasted text block into structured company objects (with kontakte array)
function parseImportText(text) {
  const isUrl=s=>/^(www\.|https?:\/\/)/.test(s)||(/\.[a-z]{2,4}$/.test(s)&&!/\s/.test(s));
  const isEmail=s=>/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(s);
  const isPhone=s=>/^[\d\s\+\-\/\(\)]{7,}$/.test(s);
  const isPlz=s=>/^\d{5}(\s|$)/.test(s);
  const isDesc=s=>s.length>40; // long text → Beschreibung
  const lines = text.split('\n').map(l=>l.trim()).filter(l=>l.length>2);
  return lines.map(line => {
    const parts = line.split(/;|\t/).map(p=>p.trim());
    const obj = { name:'', website:'', email:'', telefon:'', ort:'', plz:'', land:'', branche:'', kategorie:'', beschreibung:'', kontakte:[] };

    // ── Positioniertes Format: Name;Branche;Kategorie;URL;Email;Tel;?;Ort;?;Beschreibung ──
    // Erkennungsmerkmal: ≥4 Felder, Feld[0] ist kein URL/Email/Telefon
    if (parts.length >= 4 && !isUrl(parts[0]) && !isEmail(parts[0]) && !isPhone(parts[0])) {
      obj.name = parts[0];
      // Feld 1: Branche (wenn Text, kein URL/Email/Telefon)
      if (parts[1] && !isUrl(parts[1]) && !isEmail(parts[1]) && !isPhone(parts[1])) obj.branche = parts[1];
      // Feld 2: Kategorie (wenn Text)
      if (parts[2] && !isUrl(parts[2]) && !isEmail(parts[2]) && !isPhone(parts[2])) obj.kategorie = parts[2];
      // Felder 3+: pattern-basiert + Positions-Fallback
      for (let i=3; i<parts.length; i++) {
        const p=parts[i]; if(!p) continue;
        if (isEmail(p)) { obj.email=p; continue; }
        if (isUrl(p)) { obj.website=p; continue; }
        if (isPhone(p)) { obj.telefon=p; continue; }
        if (isPlz(p)) { const m=p.match(/^(\d{5})\s+(.+)/); if(m){obj.plz=m[1];obj.ort=m[2];}else obj.ort=p; continue; }
        if (isDesc(p) && !obj.beschreibung) { obj.beschreibung=p; continue; }
        // Kurzer Text ohne PLZ → Ort (wenn noch kein Ort)
        if (!obj.ort && p.length<60) { obj.ort=p; continue; }
        // Weiterer langer Text → an Beschreibung anhängen
        if (p.length>10) obj.beschreibung=(obj.beschreibung?obj.beschreibung+' ':'')+p;
      }
      return obj;
    }

    // ── Pattern-basiertes Format (einfachere Listen) ──
    const nameCandidate = [];
    for (const part of parts) {
      if (!part) continue;
      if (isEmail(part)) { obj.email=part; continue; }
      if (isUrl(part)) { obj.website=part; continue; }
      if (isPhone(part)) { obj.telefon=part; continue; }
      if (isPlz(part)) { const m=part.match(/^(\d{5})\s+(.+)/);if(m){obj.plz=m[1];obj.ort=m[2];}continue; }
      nameCandidate.push(part);
    }
    if (nameCandidate[0]) obj.name = nameCandidate[0];
    if (nameCandidate[1] && /[A-ZÄÖÜ]/.test(nameCandidate[1])) {
      const k=LEER_KONTAKT(); const p=nameCandidate[1].split(/\s+/);
      k.nachname=p.pop()||""; k.vorname=p.join(" ");
      obj.kontakte=[k];
    }
    if (!obj.name && parts[0]) obj.name=parts[0];
    return obj;
  }).filter(o=>o.name);
}

/* ── KontaktZeile: eine editierbare Kontaktzeile ── */
const KontaktZeile=({k,onChange,onDelete,iS})=><div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr 1fr 28px",gap:4,marginBottom:4,alignItems:"center"}}>
  <input value={k.vorname||""} onChange={e=>onChange({...k,vorname:e.target.value})} placeholder="Vorname" style={iS}/>
  <input value={k.nachname||""} onChange={e=>onChange({...k,nachname:e.target.value})} placeholder="Nachname *" style={{...iS,borderColor:k.nachname?"var(--brd)":"var(--ylw)"}}/>
  <input value={k.rolle||""} onChange={e=>onChange({...k,rolle:e.target.value})} placeholder="Rolle/Funktion" style={iS}/>
  <input value={k.email||""} onChange={e=>onChange({...k,email:e.target.value})} placeholder="E-Mail" style={iS}/>
  <input value={k.telefon||""} onChange={e=>onChange({...k,telefon:e.target.value})} placeholder="Telefon" style={iS}/>
  <button onClick={onDelete} style={{background:"none",border:"none",cursor:"pointer",color:"var(--red)",fontSize:14,padding:"0 4px",lineHeight:1}}>×</button>
</div>;

const RechercheModal=({result,eintrag,onClose,onApply})=>{
  const fields=[
    {k:"land",l:"Land",v:result.land},
    {k:"plz",l:"PLZ",v:result.plz},
    {k:"ort",l:"Ort",v:result.ort},
    {k:"adresse",l:"Adresse",v:result.adresse},
    {k:"website",l:"Website",v:result.website},
    {k:"telefon",l:"Telefon",v:result.telefon},
    {k:"email",l:"E-Mail",v:result.email},
    {k:"beschreibung",l:"Beschreibung",v:result.beschreibung},
  ].filter(f=>f.v&&f.v.trim());
  const hasKontakte=result.kontakte&&result.kontakte.length>0;
  const [sel,setSel]=React.useState(()=>{
    const s={kontakte:hasKontakte};
    fields.forEach(f=>{s[f.k]=true;});
    return s;
  });
  const toggle=k=>setSel(s=>({...s,[k]:!s[k]}));
  const iS={padding:"6px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",width:"100%"};
  return<CrmModal title={`Recherche: ${eintrag.name}`} onClose={onClose} wide>
    <div style={{fontSize:12,color:"var(--t2)",marginBottom:12}}>
      Gefundene Daten — Häkchen setzen was übernommen werden soll:
    </div>
    {result.hinweise&&<div style={{marginBottom:12,padding:"8px 12px",borderRadius:7,background:"var(--acc2)",border:"1px solid var(--acc)",fontSize:12,color:"var(--t2)"}}>
      <span style={{fontWeight:600,color:"var(--acc)"}}>Hinweis: </span>{result.hinweise}
    </div>}
    {fields.length===0&&!hasKontakte&&<div style={{color:"var(--t3)",fontSize:12,padding:"12px 0"}}>Keine neuen Daten gefunden.</div>}
    {fields.length>0&&<div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:14}}>
      {fields.map(f=><label key={f.k} style={{display:"flex",alignItems:"flex-start",gap:8,cursor:"pointer",padding:"6px 10px",borderRadius:7,background:sel[f.k]?"var(--acc2)":"var(--s2)",border:"1px solid "+(sel[f.k]?"var(--acc)":"var(--brd)")}}>
        <input type="checkbox" checked={!!sel[f.k]} onChange={()=>toggle(f.k)} style={{marginTop:2,cursor:"pointer"}}/>
        <div style={{flex:1}}>
          <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".3px",marginBottom:2}}>{f.l}</div>
          <div style={{fontSize:12,color:"var(--t1)",wordBreak:"break-word"}}>{f.v}</div>
          {eintrag[f.k]&&eintrag[f.k]!==f.v&&<div style={{fontSize:10,color:"var(--ylw)",marginTop:2}}>Aktuell: {eintrag[f.k]}</div>}
        </div>
      </label>)}
    </div>}
    {hasKontakte&&<div style={{marginBottom:14}}>
      <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",marginBottom:8}}>
        <input type="checkbox" checked={!!sel.kontakte} onChange={()=>toggle("kontakte")} style={{cursor:"pointer"}}/>
        <span style={{fontSize:11,fontWeight:600,color:"var(--t2)"}}>Ansprechpartner übernehmen ({result.kontakte.length})</span>
      </label>
      {result.kontakte.map((k,i)=><div key={i} style={{display:"flex",gap:10,padding:"8px 12px",borderRadius:7,background:"var(--s2)",border:"1px solid var(--brd)",fontSize:12,marginBottom:4,flexWrap:"wrap"}}>
        <span style={{fontWeight:600,color:"var(--t1)",minWidth:120}}>{[k.vorname,k.nachname].filter(Boolean).join(" ")||"–"}</span>
        {k.rolle&&<span style={{color:"var(--t3)"}}>{k.rolle}</span>}
        {k.email&&<span style={{color:"var(--t2)"}}>{k.email}</span>}
        {k.telefon&&<span style={{color:"var(--t3)"}}>{k.telefon}</span>}
        {k.quelle&&<span style={{fontSize:10,padding:"1px 6px",borderRadius:4,background:"var(--acc2)",color:"var(--acc)"}}>{k.quelle}</span>}
      </div>)}
    </div>}
    {result.quellen&&result.quellen.length>0&&<div style={{marginBottom:12,fontSize:10,color:"var(--t3)"}}>
      Quellen: {result.quellen.join(", ")}
    </div>}
    <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}>
      <Btn onClick={onClose}>Abbrechen</Btn>
      <Btn primary onClick={()=>onApply(eintrag,{...sel,result})}>Auswahl übernehmen</Btn>
    </div>
  </CrmModal>;
};

const CrmSammlung=()=>{
  const [tab,setTab]=useState("import");
  const [items,setItems]=useState([]);
  const [total,setTotal]=useState(0);
  const [filterStatus,setFilterStatus]=useState("");
  const [search,setSearch]=useState("");
  const [pasteText,setPasteText]=useState("");
  const [parsed,setParsed]=useState([]); // editable preview rows
  const [importing,setImporting]=useState(false);
  const [importResult,setImportResult]=useState(null);
  const [dupeNames,setDupeNames]=useState(new Set());
  const [metaBranchen,setMetaBranchen]=useState([]);
  const [metaKategorien,setMetaKategorien]=useState([]);
  const [selected,setSelected]=useState(new Set());
  const [expanded,setExpanded]=useState(new Set()); // expanded sammlung rows
  const [editId,setEditId]=useState(null);
  const [editForm,setEditForm]=useState({});
  const [savingEdit,setSavingEdit]=useState(false);
  const [pipelines,setPipelines]=useState([]);
  const [zuLeadModal,setZuLeadModal]=useState(null);
  const [zuLeadForm,setZuLeadForm]=useState({pipelineId:"",phase:"",verantwortlicher:"",prioritaet:"mittel"});
  const [zuLeadSaving,setZuLeadSaving]=useState(false);
  const [rechercheId,setRechercheId]=useState(null);
  const [rechercheResult,setRechercheResult]=useState(null);
  const [exportModal,setExportModal]=useState(false);
  const iS={padding:"6px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",width:"100%"};
  const sC={...iS,cursor:"pointer",width:"auto"};

  const load=()=>{
    const p=new URLSearchParams({status:filterStatus,search,limit:500});
    fetch(`/api/crm/sammlung?${p}`).then(r=>r.json()).then(d=>{setItems(d.items||[]);setTotal(d.total||0);}).catch(()=>{});
  };
  useEffect(()=>{
    load();
    fetch("/api/crm/pipelines").then(r=>r.json()).then(d=>setPipelines(Array.isArray(d)?d:[])).catch(()=>{});
    fetch("/api/crm/sammlung/meta").then(r=>r.json()).then(d=>{setMetaBranchen(d.branchen||[]);setMetaKategorien(d.kategorien||[]);}).catch(()=>{});
  },[]);
  useEffect(()=>{load();},[filterStatus,search]);
  useEffect(()=>{
    if(!pasteText.trim()){setParsed([]);setDupeNames(new Set());return;}
    const rows=parseImportText(pasteText).map(o=>({...o,_key:Math.random()}));
    setParsed(rows);
    // Detect within-batch duplicates
    const batchNames=rows.map(r=>r.name.trim().toLowerCase());
    const batchDupes=new Set(batchNames.filter((n,i)=>batchNames.indexOf(n)!==i));
    // Check against backend
    const namen=rows.map(r=>r.name).filter(Boolean);
    if(namen.length){
      fetch('/api/crm/sammlung/check-duplicates',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({namen})})
        .then(r=>r.json()).then(d=>{
          const s=new Set([...(d.duplikate||[]).map(n=>n.trim().toLowerCase()),...batchDupes]);
          setDupeNames(s);
        }).catch(()=>setDupeNames(batchDupes));
    } else { setDupeNames(batchDupes); }
  },[pasteText]);

  // ── parsed row helpers ──
  const updateParsed=(i,upd)=>setParsed(ps=>ps.map((p,pi)=>pi===i?{...p,...upd}:p));
  const removeParsed=i=>setParsed(ps=>ps.filter((_,pi)=>pi!==i));
  const addKontaktParsed=i=>setParsed(ps=>ps.map((p,pi)=>pi===i?{...p,kontakte:[...(p.kontakte||[]),LEER_KONTAKT()]}:p));
  const updateKontaktParsed=(pi,ki,upd)=>setParsed(ps=>ps.map((p,pii)=>pii!==pi?p:{...p,kontakte:p.kontakte.map((k,kii)=>kii===ki?{...k,...upd}:k)}));
  const removeKontaktParsed=(pi,ki)=>setParsed(ps=>ps.map((p,pii)=>pii!==pi?p:{...p,kontakte:p.kontakte.filter((_,kii)=>kii!==ki)}));

  const doImport=async()=>{
    if(!parsed.length)return;
    setImporting(true);setImportResult(null);
    const r=await fetch("/api/crm/sammlung/import",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({zeilen:parsed})}).then(d=>d.json()).catch(e=>({error:String(e)}));
    setImportResult(r);setImporting(false);
    if(!r.error){setPasteText("");setParsed([]);setTab("sammlung");load();}
  };

  // ── sammlung edit helpers ──
  const saveEdit=async()=>{
    setSavingEdit(true);
    await fetch(`/api/crm/sammlung/${editId}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(editForm)}).catch(()=>{});
    setSavingEdit(false);setEditId(null);load();
  };
  const startEdit=e=>{setEditId(String(e._id));setEditForm({...e,kontakte:e.kontakte?e.kontakte.map(k=>({...k,_id:k._id||Math.random()})):[]});setExpanded(ex=>{const n=new Set(ex);n.add(String(e._id));return n;});};
  const addKontaktEdit=()=>setEditForm(f=>({...f,kontakte:[...(f.kontakte||[]),LEER_KONTAKT()]}));
  const updateKontaktEdit=(ki,upd)=>setEditForm(f=>({...f,kontakte:f.kontakte.map((k,i)=>i===ki?{...k,...upd}:k)}));
  const removeKontaktEdit=ki=>setEditForm(f=>({...f,kontakte:f.kontakte.filter((_,i)=>i!==ki)}));

  const del=async id=>{if(!confirm("Eintrag löschen?"))return;await fetch(`/api/crm/sammlung/${id}`,{method:"DELETE"});load();};
  const doRecherche=async eintrag=>{
    setRechercheId(String(eintrag._id));setRechercheResult(null);
    const r=await fetch(`/api/crm/sammlung/${eintrag._id}/recherche`,{method:"POST",headers:{"Content-Type":"application/json"}}).then(d=>d.json()).catch(e=>({error:String(e)}));
    setRechercheId(null);
    if(r.error){alert("Recherche-Fehler: "+r.error);return;}
    setRechercheResult({eintrag,result:r.result});
  };
  const applyRecherche=async(eintrag,selected)=>{
    const upd={...eintrag};
    if(selected.land&&selected.result.land) upd.land=selected.result.land;
    if(selected.plz&&selected.result.plz) upd.plz=selected.result.plz;
    if(selected.ort&&selected.result.ort) upd.ort=selected.result.ort;
    if(selected.adresse&&selected.result.adresse) upd.adresse=selected.result.adresse;
    if(selected.website&&selected.result.website) upd.website=selected.result.website;
    if(selected.telefon&&selected.result.telefon) upd.telefon=selected.result.telefon;
    if(selected.email&&selected.result.email) upd.email=selected.result.email;
    if(selected.beschreibung&&selected.result.beschreibung) upd.beschreibung=selected.result.beschreibung;
    if(selected.kontakte&&selected.result.kontakte?.length){
      const existing=upd.kontakte||[];
      const neu=selected.result.kontakte.filter(k=>k.nachname).map(k=>({...LEER_KONTAKT(),...k}));
      upd.kontakte=[...existing,...neu];
    }
    await fetch(`/api/crm/sammlung/${eintrag._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(upd)});
    setRechercheResult(null);load();
  };
  const bulkDelete=async()=>{
    if(!selected.size||!confirm(`${selected.size} Einträge löschen?`))return;
    await fetch("/api/crm/sammlung/bulk-delete",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({ids:[...selected]})});
    setSelected(new Set());load();
  };
  const toggleExpand=id=>setExpanded(s=>{const n=new Set(s);n.has(id)?n.delete(id):n.add(id);return n;});
  const toggleSelect=id=>setSelected(s=>{const n=new Set(s);n.has(id)?n.delete(id):n.add(id);return n;});
  const toggleAll=()=>setSelected(s=>s.size===items.length?new Set():new Set(items.map(i=>String(i._id))));

  const openZuLead=eintrag=>{
    const defPl=pipelines[0];
    setZuLeadForm({pipelineId:defPl?String(defPl._id):"",phase:defPl?.phasen?.[0]||"Lead neu",verantwortlicher:"",prioritaet:"mittel"});
    setZuLeadModal(eintrag);
  };
  const doZuLead=async()=>{
    setZuLeadSaving(true);
    const r=await fetch(`/api/crm/sammlung/${zuLeadModal._id}/zu-lead`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(zuLeadForm)}).then(d=>d.json()).catch(e=>({error:String(e)}));
    setZuLeadSaving(false);
    if(!r.error){setZuLeadModal(null);load();}else alert("Fehler: "+r.error);
  };

  const toExportLine=e=>{
    const f=v=>v||"";
    const lines=[];
    lines.push([f(e.name),f(e.branche),f(e.kategorie),f(e.website),f(e.email),f(e.telefon),"",f(e.ort)&&(e.plz?e.plz+" ":"")+f(e.ort),"",f(e.beschreibung)].join("; "));
    (e.kontakte||[]).forEach(k=>{
      if(!k.nachname&&!k.vorname) return;
      lines.push(["→ "+[k.vorname,k.nachname].filter(Boolean).join(" "),k.rolle||"",k.email||"",k.telefon||""].join("; "));
    });
    return lines.join("\n");
  };
  const exportText=(exportItems)=>exportItems.map(toExportLine).join("\n\n");
  const statusBadge=s=>{const st=SAMMLUNG_STATUS.find(x=>x.v===s)||SAMMLUNG_STATUS[0];return<span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:st.c+"22",color:st.c,whiteSpace:"nowrap"}}>{st.l}</span>;};
  const vollstaendig=e=>!!(e.name&&(e.email||e.telefon||(e.kontakte||[]).some(k=>k.email||k.telefon)));
  const activePl=pipelines.find(p=>String(p._id)===zuLeadForm.pipelineId);
  const lbl=(txt,warn)=><label style={{fontSize:9,fontWeight:600,color:warn?"var(--ylw)":"var(--t3)",display:"block",marginBottom:2,textTransform:"uppercase",letterSpacing:".3px"}}>{txt}</label>;

  return<>
    <div style={{display:"flex",gap:10,marginBottom:16,alignItems:"center"}}>
      <Tabs tabs={[{k:"import",l:"Import"},{k:"sammlung",l:`Sammlung (${total})`}]} active={tab} onChange={setTab}/>
      <div style={{flex:1}}/>
      {tab==="sammlung"&&<Btn onClick={async()=>{
        const p=new URLSearchParams({status:filterStatus,search,page:1,limit:9999});
        const d=await fetch(`/api/crm/sammlung?${p}`).then(r=>r.json()).catch(()=>({items:[]}));
        setExportModal(d.items||[]);
      }}>↓ Export</Btn>}
      {tab==="sammlung"&&selected.size>0&&<Btn onClick={bulkDelete} style={{color:"var(--red)"}}>✕ {selected.size} löschen</Btn>}
    </div>

    {/* ══ IMPORT TAB ══ */}
    {tab==="import"&&<div style={{display:"grid",gridTemplateColumns:"340px 1fr",gap:16,alignItems:"start"}}>

      {/* Paste-Bereich */}
      <Card>
        <div style={{fontSize:13,fontWeight:600,color:"var(--t1)",marginBottom:6}}>Liste einfügen</div>
        <div style={{fontSize:11,color:"var(--t3)",marginBottom:8,lineHeight:1.7}}>
          Eine Firma pro Zeile, Felder mit <code style={{background:"var(--s2)",padding:"0 4px",borderRadius:3}}>;</code> trennen:<br/>
          <span style={{color:"var(--t2)"}}>Firma; Website; E-Mail; Telefon; Ort</span><br/>
          E-Mails, URLs & Telefonnummern werden automatisch erkannt.
        </div>
        <details style={{marginBottom:10}}>
          <summary style={{fontSize:11,color:"var(--acc)",cursor:"pointer",fontWeight:600,userSelect:"none"}}>✦ Beispiel: perfekter Datensatz</summary>
          <div style={{marginTop:8,padding:"10px 12px",borderRadius:7,background:"var(--s2)",border:"1px solid var(--brd)",fontSize:11,lineHeight:1.9,fontFamily:"'JetBrains Mono',monospace",color:"var(--t2)"}}>
            <div><span style={{color:"var(--t3)"}}>// Firma (wird automatisch erkannt):</span></div>
            <div style={{color:"var(--grn)",fontWeight:600}}>Mode GmbH & Co. KG; www.mode-gmbh.de; info@mode-gmbh.de; +49 211 12345678; 40213 Düsseldorf</div>
            <div style={{marginTop:6,color:"var(--t3)"}}>// Was danach manuell ergänzt wird:</div>
            <div>Branche → <span style={{color:"var(--t1)"}}>Großhandel</span></div>
            <div>Kategorie → <span style={{color:"var(--t1)"}}>Neukunde</span></div>
            <div>Beschreibung → <span style={{color:"var(--t1)"}}>Modehändler mit 12 Filialen, Fokus Damen-Oberbekleidung Gr. 36–46</span></div>
            <div>Ansprechpartner → <span style={{color:"var(--t1)"}}>Maria Müller · Einkauf · maria@mode-gmbh.de · +49 211 12345679</span></div>
          </div>
        </details>
        <textarea value={pasteText} onChange={e=>setPasteText(e.target.value)}
          placeholder={"Fashion GmbH\nTrend AG; www.trend.de; info@trend.de\nMode KG; Frankfurt; +49 69 12345\nLuxus Store; Max Müller; max@luxus.de"}
          rows={10} style={{width:"100%",padding:"10px 12px",borderRadius:8,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"'JetBrains Mono',monospace",resize:"vertical",lineHeight:1.8}}/>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:10}}>
          <span style={{fontSize:11,color:"var(--t3)"}}>{parsed.length>0?`${parsed.length} erkannt`:""}</span>
          <Btn primary onClick={doImport} disabled={importing||!parsed.length}>{importing?"Importiere…":`${parsed.length} importieren`}</Btn>
        </div>
        {importResult&&<div style={{marginTop:8,padding:"8px 12px",borderRadius:7,background:importResult.error?"var(--red2)":"var(--grn2)",color:importResult.error?"var(--red)":"var(--grn)",fontSize:12}}>
          {importResult.error||`✓ ${importResult.inserted} neu · ${importResult.merged||0} zusammengeführt`}
        </div>}
      </Card>

      {/* Editierbare Vorschau */}
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
          <span style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>Vorschau & Vervollständigung ({parsed.length})</span>
          {parsed.length>0&&<span style={{fontSize:11,color:"var(--t3)"}}>Felder direkt hier bearbeiten vor dem Import</span>}
        </div>
        {parsed.length===0&&<Card><div style={{color:"var(--t3)",fontSize:12,padding:"20px 0",textAlign:"center"}}>Text links einfügen…</div></Card>}
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {parsed.map((p,pi)=><Card key={p._key||pi} style={{padding:"12px 16px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:13,fontWeight:700,color:"var(--t1)"}}>{p.name||<span style={{color:"var(--red)"}}>Name fehlt!</span>}</span>
                {dupeNames.has((p.name||"").trim().toLowerCase())&&<span title="Mögliche Dublette – Name bereits vorhanden" style={{fontSize:10,fontWeight:600,padding:"1px 7px",borderRadius:4,background:"var(--ylw2,#fef08a22)",color:"var(--ylw)",border:"1px solid var(--ylw)",cursor:"default"}}>⚠ Dublette</span>}
              </div>
              <button onClick={()=>removeParsed(pi)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--red)",fontSize:16,padding:"0 2px",lineHeight:1}}>×</button>
            </div>
            {/* Firmendaten */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:6,marginBottom:6}}>
              <div>{lbl("Firma *",!p.name)}<input value={p.name||""} onChange={e=>updateParsed(pi,{name:e.target.value})} style={{...iS,borderColor:p.name?"var(--brd)":"var(--red)"}}/></div>
              <div>{lbl("Branche")}<input list={`bl-${pi}`} value={p.branche||""} onChange={e=>updateParsed(pi,{branche:e.target.value})} placeholder="z.B. Großhandel" style={iS}/><datalist id={`bl-${pi}`}>{metaBranchen.map(b=><option key={b} value={b}/>)}</datalist></div>
              <div>{lbl("Kategorie")}<input list={`kl-${pi}`} value={p.kategorie||""} onChange={e=>updateParsed(pi,{kategorie:e.target.value})} placeholder="z.B. Neukunde" style={iS}/><datalist id={`kl-${pi}`}>{metaKategorien.map(c=><option key={c} value={c}/>)}</datalist></div>
              <div>{lbl("Website")}<input value={p.website||""} onChange={e=>updateParsed(pi,{website:e.target.value})} style={iS}/></div>
              <div>{lbl("E-Mail Firma")}<input value={p.email||""} onChange={e=>updateParsed(pi,{email:e.target.value})} style={iS}/></div>
              <div>{lbl("Telefon Firma")}<input value={p.telefon||""} onChange={e=>updateParsed(pi,{telefon:e.target.value})} style={iS}/></div>
              <div>{lbl("PLZ")}<input value={p.plz||""} onChange={e=>updateParsed(pi,{plz:e.target.value})} style={iS}/></div>
              <div>{lbl("Ort")}<input value={p.ort||""} onChange={e=>updateParsed(pi,{ort:e.target.value})} style={iS}/></div>
              <div>{lbl("Land")}<input value={p.land||""} onChange={e=>updateParsed(pi,{land:e.target.value})} placeholder="DE" style={iS}/></div>
              <div>{lbl("Notizen")}<input value={p.notizen||""} onChange={e=>updateParsed(pi,{notizen:e.target.value})} style={iS}/></div>
            </div>
            <div style={{marginBottom:10}}>
              {lbl("Beschreibung")}
              <textarea value={p.beschreibung||""} onChange={e=>updateParsed(pi,{beschreibung:e.target.value})} rows={2} placeholder="Kurze Beschreibung des Unternehmens…" style={{...iS,resize:"vertical",lineHeight:1.5}}/>
            </div>
            {/* Ansprechpartner */}
            <div style={{borderTop:"1px solid var(--brd)",paddingTop:8}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                <span style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>Ansprechpartner ({(p.kontakte||[]).length})</span>
                <button onClick={()=>addKontaktParsed(pi)} style={{fontSize:11,padding:"2px 8px",borderRadius:5,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--acc)",cursor:"pointer",fontFamily:"inherit"}}>+ Kontakt</button>
              </div>
              {(p.kontakte||[]).length===0&&<div style={{fontSize:11,color:"var(--t3)",fontStyle:"italic",marginBottom:4}}>Noch kein Ansprechpartner – optional hinzufügen</div>}
              {/* Header */}
              {(p.kontakte||[]).length>0&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr 1fr 28px",gap:4,marginBottom:4}}>
                {["Vorname","Nachname *","Rolle","E-Mail","Telefon",""].map(h=><span key={h} style={{fontSize:9,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".3px"}}>{h}</span>)}
              </div>}
              {(p.kontakte||[]).map((k,ki)=><KontaktZeile key={k._id||ki} k={k} iS={iS}
                onChange={upd=>updateKontaktParsed(pi,ki,upd)}
                onDelete={()=>removeKontaktParsed(pi,ki)}/>)}
            </div>
          </Card>)}
        </div>
      </div>
    </div>}

    {/* ══ SAMMLUNG TAB ══ */}
    {tab==="sammlung"&&<>
      <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"center"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Firma suchen…" style={{flex:1,padding:"7px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
        <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={{...iS,width:"auto",cursor:"pointer"}}>
          <option value="">Alle Status</option>
          {SAMMLUNG_STATUS.map(s=><option key={s.v} value={s.v}>{s.l}</option>)}
        </select>
        <Btn primary onClick={()=>setTab("import")}>+ Import</Btn>
      </div>

      <Card style={{padding:0,overflow:"hidden"}}>
        {/* Header */}
        <div style={{display:"grid",gridTemplateColumns:"28px 20px 2fr 1fr 1fr 110px 110px",padding:"8px 14px",borderBottom:"1px solid var(--brd)",background:"var(--s2)",gap:8,alignItems:"center"}}>
          <input type="checkbox" checked={selected.size===items.length&&items.length>0} onChange={toggleAll} style={{cursor:"pointer"}}/>
          <span/>
          {["Firma","Kontakte","E-Mail / Web","Status",""].map(h=><span key={h} style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>{h}</span>)}
        </div>

        {items.length===0&&<EmptyState icon="📋" title="Sammlung leer" sub='Firmen über "Import" hinzufügen'/>}

        {items.map(e=>{
          const id=String(e._id);
          const isExp=expanded.has(id);
          const isEdit=editId===id;
          const ok=vollstaendig(e);
          const kontakte=e.kontakte||[];
          return<div key={id} style={{borderBottom:"1px solid var(--brd)"}}>
            {/* ─ Zeile ─ */}
            <div style={{display:"grid",gridTemplateColumns:"28px 20px 2fr 1fr 1fr 110px 110px",padding:"10px 14px",gap:8,alignItems:"center",background:selected.has(id)?"var(--acc2)":"transparent",cursor:"pointer"}}
              onClick={()=>toggleExpand(id)}
              onMouseEnter={el=>el.currentTarget.style.background=selected.has(id)?"var(--acc2)":"var(--shov)"}
              onMouseLeave={el=>el.currentTarget.style.background=selected.has(id)?"var(--acc2)":"transparent"}>
              <input type="checkbox" checked={selected.has(id)} onChange={()=>toggleSelect(id)} onClick={ev=>ev.stopPropagation()} style={{cursor:"pointer"}}/>
              <span style={{fontSize:10,color:"var(--t3)",transition:"transform .15s",display:"inline-block",transform:isExp?"rotate(90deg)":"none"}}>▶</span>
              <div>
                <div style={{fontSize:13,fontWeight:600,color:"var(--t1)",display:"flex",alignItems:"center",gap:6}}>
                  {e.name}
                  {!ok&&<span title="Kontaktdaten unvollständig" style={{fontSize:9,color:"var(--ylw)"}}>⚠</span>}
                </div>
                {e.branche&&<div style={{fontSize:10,color:"var(--t3)"}}>{e.branche}</div>}
                {(e.plz||e.ort)&&<div style={{fontSize:10,color:"var(--t3)"}}>{[e.plz,e.ort].filter(Boolean).join(" ")}</div>}
              </div>
              <div style={{fontSize:11,color:"var(--t2)"}}>
                {kontakte.length>0
                  ?kontakte.map((k,i)=><div key={i} style={{display:"flex",gap:4,alignItems:"center",marginBottom:1}}>
                      <span style={{width:5,height:5,borderRadius:"50%",background:"var(--acc)",display:"inline-block",flexShrink:0}}/>
                      <span style={{fontSize:11}}>{[k.vorname,k.nachname].filter(Boolean).join(" ")||"–"}</span>
                      {k.rolle&&<span style={{fontSize:9,color:"var(--t3)"}}>· {k.rolle}</span>}
                    </div>)
                  :<span style={{color:"var(--t3)",fontSize:11}}>Kein Kontakt</span>}
              </div>
              <div style={{fontSize:11,color:"var(--t2)",overflow:"hidden"}}>
                {e.email&&<div>{e.email}</div>}
                {e.website&&<div><a href={e.website.startsWith("http")?e.website:"https://"+e.website} target="_blank" rel="noopener noreferrer" style={{color:"var(--acc)",fontSize:10,textDecoration:"none"}} onMouseEnter={el=>el.currentTarget.style.textDecoration="underline"} onMouseLeave={el=>el.currentTarget.style.textDecoration="none"}>{e.website}</a></div>}
                {!e.email&&!e.website&&<span style={{color:"var(--t3)"}}>–</span>}
              </div>
              {statusBadge(e.status)}
              <div style={{display:"flex",gap:4}} onClick={ev=>ev.stopPropagation()}>
                {e.status!=="importiert"&&<>
                  <Btn small onClick={()=>isEdit?saveEdit():startEdit(e)}>{isEdit?"Speichern":"Edit"}</Btn>
                  <button onClick={()=>doRecherche(e)} disabled={rechercheId===id} title="KI-Recherche: Kontakte, Land, Details" style={{padding:"3px 8px",borderRadius:5,border:"1px solid var(--acc)",background:"transparent",color:"var(--acc)",fontSize:10,fontWeight:600,cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap",opacity:rechercheId===id?0.5:1}}>{rechercheId===id?"⏳…":"🔍"}</button>
                  {ok&&<button onClick={()=>openZuLead(e)} style={{padding:"3px 8px",borderRadius:5,border:"none",background:"var(--grn)",color:"#fff",fontSize:10,fontWeight:600,cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>→ Lead</button>}
                </>}
                {e.status==="importiert"&&<span style={{fontSize:10,color:"var(--acc)",fontWeight:600}}>✓ Lead</span>}
                <Btn small onClick={()=>del(e._id)} style={{color:"var(--red)"}}>✕</Btn>
              </div>
            </div>

            {/* ─ Ausgeklappt: View oder Edit ─ */}
            {isExp&&!isEdit&&<div style={{padding:"12px 16px 14px 60px",background:"var(--s2)",borderTop:"1px solid var(--brd)"}}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"4px 16px",marginBottom:8,fontSize:12}}>
                {[["Branche",e.branche],["Kategorie",e.kategorie],["Land",e.land],["E-Mail",e.email],["Telefon",e.telefon],["Ort",[e.plz,e.ort].filter(Boolean).join(" ")],["Notizen",e.notizen]].filter(([,v])=>v).map(([k,v])=><div key={k}><span style={{color:"var(--t3)",fontSize:10}}>{k}: </span><span style={{color:"var(--t1)"}}>{v}</span></div>)}
                {e.website&&<div><span style={{color:"var(--t3)",fontSize:10}}>Website: </span><a href={e.website.startsWith("http")?e.website:"https://"+e.website} target="_blank" rel="noopener noreferrer" style={{color:"var(--acc)",fontSize:12,textDecoration:"none"}} onMouseEnter={el=>el.currentTarget.style.textDecoration="underline"} onMouseLeave={el=>el.currentTarget.style.textDecoration="none"}>{e.website}</a></div>}
              </div>
              {e.beschreibung&&<div style={{marginBottom:12,fontSize:12,padding:"8px 12px",borderRadius:7,background:"var(--s1)",border:"1px solid var(--brd)"}}>
                <span style={{color:"var(--t3)",fontSize:10}}>Beschreibung: </span><span style={{color:"var(--t2)"}}>{e.beschreibung}</span>
              </div>}
              {kontakte.length>0&&<>
                <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:6}}>Ansprechpartner</div>
                <div style={{display:"flex",flexDirection:"column",gap:4}}>
                  {kontakte.map((k,i)=><div key={i} style={{display:"flex",gap:12,padding:"6px 10px",borderRadius:7,background:"var(--s1)",fontSize:12,border:"1px solid var(--brd)"}}>
                    <span style={{fontWeight:600,color:"var(--t1)",minWidth:120}}>{[k.vorname,k.nachname].filter(Boolean).join(" ")||"–"}</span>
                    {k.rolle&&<span style={{color:"var(--t3)"}}>{k.rolle}</span>}
                    {k.email&&<span style={{color:"var(--t2)"}}>{k.email}</span>}
                    {k.telefon&&<span style={{color:"var(--t3)"}}>{k.telefon}</span>}
                  </div>)}
                </div>
              </>}
            </div>}

            {/* ─ Edit-Formular ─ */}
            {isExp&&isEdit&&<div style={{padding:"14px 16px 16px 60px",background:"var(--acc2)",borderTop:"1px solid var(--brd)"}}>
              {/* Firmendaten */}
              <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:8}}>Firmendaten</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:6,marginBottom:6}}>
                <div>{lbl("Name *",!editForm.name)}<input value={editForm.name||""} onChange={e=>setEditForm(f=>({...f,name:e.target.value}))} style={{...iS,borderColor:editForm.name?"var(--brd)":"var(--red)"}}/></div>
                <div>{lbl("Branche")}<input list="edit-bl" value={editForm.branche||""} onChange={e=>setEditForm(f=>({...f,branche:e.target.value}))} placeholder="z.B. Großhandel" style={iS}/><datalist id="edit-bl">{metaBranchen.map(b=><option key={b} value={b}/>)}</datalist></div>
                <div>{lbl("Kategorie")}<input list="edit-kl" value={editForm.kategorie||""} onChange={e=>setEditForm(f=>({...f,kategorie:e.target.value}))} placeholder="z.B. Neukunde" style={iS}/><datalist id="edit-kl">{metaKategorien.map(c=><option key={c} value={c}/>)}</datalist></div>
                <div>{lbl("Website")}<input value={editForm.website||""} onChange={e=>setEditForm(f=>({...f,website:e.target.value}))} style={iS}/></div>
                <div>{lbl("E-Mail Firma",!editForm.email&&!(editForm.kontakte||[]).some(k=>k.email))}<input value={editForm.email||""} onChange={e=>setEditForm(f=>({...f,email:e.target.value}))} style={iS}/></div>
                <div>{lbl("Telefon")}<input value={editForm.telefon||""} onChange={e=>setEditForm(f=>({...f,telefon:e.target.value}))} style={iS}/></div>
                <div>{lbl("PLZ")}<input value={editForm.plz||""} onChange={e=>setEditForm(f=>({...f,plz:e.target.value}))} style={iS}/></div>
                <div>{lbl("Ort")}<input value={editForm.ort||""} onChange={e=>setEditForm(f=>({...f,ort:e.target.value}))} style={iS}/></div>
                <div>{lbl("Land")}<input value={editForm.land||""} onChange={e=>setEditForm(f=>({...f,land:e.target.value}))} placeholder="DE" style={iS}/></div>
                <div>{lbl("Status")}<select value={editForm.status||"neu"} onChange={e=>setEditForm(f=>({...f,status:e.target.value}))} style={{...iS,cursor:"pointer"}}>
                  {SAMMLUNG_STATUS.filter(s=>s.v!=="importiert").map(s=><option key={s.v} value={s.v}>{s.l}</option>)}
                </select></div>
                <div>{lbl("Notizen")}<input value={editForm.notizen||""} onChange={e=>setEditForm(f=>({...f,notizen:e.target.value}))} style={iS}/></div>
              </div>
              <div style={{marginBottom:14}}>
                {lbl("Beschreibung")}
                <textarea value={editForm.beschreibung||""} onChange={e=>setEditForm(f=>({...f,beschreibung:e.target.value}))} rows={2} placeholder="Kurze Beschreibung des Unternehmens…" style={{...iS,resize:"vertical",lineHeight:1.5}}/>
              </div>
              {/* Ansprechpartner */}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                <span style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>Ansprechpartner ({(editForm.kontakte||[]).length})</span>
                <button onClick={addKontaktEdit} style={{fontSize:11,padding:"2px 10px",borderRadius:5,border:"1px solid var(--brd)",background:"var(--s1)",color:"var(--acc)",cursor:"pointer",fontFamily:"inherit"}}>+ Kontakt</button>
              </div>
              {(editForm.kontakte||[]).length>0&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr 1fr 28px",gap:4,marginBottom:4}}>
                {["Vorname","Nachname *","Rolle","E-Mail","Telefon",""].map(h=><span key={h} style={{fontSize:9,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".3px"}}>{h}</span>)}
              </div>}
              {(editForm.kontakte||[]).map((k,ki)=><KontaktZeile key={k._id||ki} k={k} iS={iS}
                onChange={upd=>updateKontaktEdit(ki,upd)} onDelete={()=>removeKontaktEdit(ki)}/>)}
              <div style={{display:"flex",gap:6,marginTop:12,justifyContent:"flex-end"}}>
                <Btn small onClick={()=>{setEditId(null);}}>Abbrechen</Btn>
                <Btn small primary onClick={saveEdit} disabled={savingEdit||!editForm.name}>{savingEdit?"…":"Speichern"}</Btn>
                {vollstaendig(editForm)&&<button onClick={async()=>{await saveEdit();openZuLead(editForm);}} style={{padding:"3px 10px",borderRadius:5,border:"none",background:"var(--grn)",color:"#fff",fontSize:11,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>Speichern & → Lead</button>}
              </div>
            </div>}
          </div>;
        })}
      </Card>

      <div style={{marginTop:12,fontSize:12,color:"var(--t3)"}}>
        {total} Einträge · {items.filter(e=>e.status==="neu").length} neu · {items.filter(e=>e.status==="bereit").length} bereit
      </div>
    </>}

    {/* Zu Lead Modal */}
    {/* ── Export-Modal ── */}
    {exportModal&&(()=>{
      const allExport=Array.isArray(exportModal)?exportModal:items;
      const src=selected.size>0?allExport.filter(i=>selected.has(String(i._id))):allExport;
      const txt=exportText(src);
      return<CrmModal title={`Export – ${src.length} Einträge`} onClose={()=>setExportModal(false)} wide>
        <div style={{fontSize:11,color:"var(--t3)",marginBottom:8}}>
          {selected.size>0?`${src.length} ausgewählte Einträge`:`Alle ${src.length} Einträge der aktuellen Seite`} · Format: Name; Branche; Kategorie; URL; Email; Tel; ; Ort; ; Beschreibung
        </div>
        <textarea readOnly value={txt} rows={18}
          style={{width:"100%",padding:"10px 12px",borderRadius:8,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:11,fontFamily:"'JetBrains Mono',monospace",resize:"vertical",lineHeight:1.7}}
          onClick={e=>e.target.select()}/>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:10,borderTop:"1px solid var(--brd)",paddingTop:10}}>
          <Btn onClick={()=>setExportModal(false)}>Schließen</Btn>
          <Btn primary onClick={()=>{navigator.clipboard.writeText(txt).then(()=>alert("Kopiert!")).catch(()=>alert("Bitte manuell kopieren (Strg+A, Strg+C)"));}}>Kopieren</Btn>
        </div>
      </CrmModal>;
    })()}

    {/* ── Recherche-Ergebnis-Modal ── */}
    {rechercheResult&&<RechercheModal result={rechercheResult.result} eintrag={rechercheResult.eintrag} onClose={()=>setRechercheResult(null)} onApply={applyRecherche}/>}

    {zuLeadModal&&<CrmModal title={`"${zuLeadModal.name}" als Lead übernehmen`} onClose={()=>setZuLeadModal(null)}>
      <div style={{fontSize:12,color:"var(--t2)",marginBottom:14,padding:"8px 12px",borderRadius:7,background:"var(--s2)"}}>
        Erstellt automatisch: <strong style={{color:"var(--t1)"}}>Firma</strong> + <strong style={{color:"var(--t1)"}}>Lead</strong>
        {(zuLeadModal.kontakte||[]).length>0&&<> + <strong style={{color:"var(--t1)"}}>{zuLeadModal.kontakte.length} Kontakt{zuLeadModal.kontakte.length>1?"e":""}</strong></>}
      </div>
      <Sel label="Pipeline" value={zuLeadForm.pipelineId} onChange={v=>{const pl=pipelines.find(p=>String(p._id)===v);setZuLeadForm(f=>({...f,pipelineId:v,phase:pl?.phasen?.[0]||""}));}} opts={[{v:"",l:"– Pipeline wählen –"},...pipelines.map(p=>({v:String(p._id),l:p.name}))]}/>
      <Sel label="Startphase" value={zuLeadForm.phase} onChange={v=>setZuLeadForm(f=>({...f,phase:v}))} opts={(activePl?.phasen||[]).map(p=>({v:p,l:p}))}/>
      <Inp label="Verantwortlich" value={zuLeadForm.verantwortlicher} onChange={v=>setZuLeadForm(f=>({...f,verantwortlicher:v}))}/>
      <Sel label="Priorität" value={zuLeadForm.prioritaet} onChange={v=>setZuLeadForm(f=>({...f,prioritaet:v}))} opts={LEAD_PRIO}/>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:8,borderTop:"1px solid var(--brd)"}}>
        <Btn onClick={()=>setZuLeadModal(null)}>Abbrechen</Btn>
        <Btn primary onClick={doZuLead} disabled={zuLeadSaving||!zuLeadForm.pipelineId}>{zuLeadSaving?"Wird erstellt…":"Als Lead übernehmen"}</Btn>
      </div>
    </CrmModal>}
  </>;
};

/* ─── Email Konten Verwaltung ─── */
/* ─── Email Regelengine ─── */
const REGEL_FELDER=[{v:"von",l:"Von"},{v:"betreff",l:"Betreff"},{v:"inhalt",l:"Inhalt"},{v:"konto",l:"Konto"},{v:"hat_anhang",l:"Hat Anhang"}];
const REGEL_OPS=[{v:"enthält",l:"enthält"},{v:"enthält_nicht",l:"enthält nicht"},{v:"ist",l:"ist"},{v:"beginnt_mit",l:"beginnt mit"},{v:"endet_mit",l:"endet mit"}];
const AKTION_TYPEN=[{v:"label",l:"Label setzen"},{v:"zuweisen",l:"Zuweisen an"},{v:"verschieben",l:"Status setzen"},{v:"weiterleiten",l:"Weiterleiten an"},{v:"auto_antwort",l:"Auto-Antwort"},{v:"spam",l:"Als Spam markieren"},{v:"prioritaet",l:"Priorität setzen"}];
const iS0={padding:"5px 8px",borderRadius:5,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:11,fontFamily:"inherit"};

const RegelModal=({regel,onClose,onSaved})=>{
  const empty={name:"",aktiv:true,prioritaet:10,bedingungen:[{feld:"betreff",operator:"enthält",wert:""}],bedingungVerknuepfung:"UND",aktionen:[{typ:"label",wert:""}]};
  const [form,setForm]=useState(regel&&regel!=="add"?{...empty,...regel}:{...empty});
  const [saving,setSaving]=useState(false);
  const sf=(k,v)=>setForm(f=>({...f,[k]:v}));

  const addBed=()=>setForm(f=>({...f,bedingungen:[...f.bedingungen,{feld:"betreff",operator:"enthält",wert:""}]}));
  const delBed=i=>setForm(f=>({...f,bedingungen:f.bedingungen.filter((_,j)=>j!==i)}));
  const updBed=(i,k,v)=>setForm(f=>({...f,bedingungen:f.bedingungen.map((b,j)=>j===i?{...b,[k]:v}:b)}));
  const addAkt=()=>setForm(f=>({...f,aktionen:[...f.aktionen,{typ:"label",wert:""}]}));
  const delAkt=i=>setForm(f=>({...f,aktionen:f.aktionen.filter((_,j)=>j!==i)}));
  const updAkt=(i,k,v)=>setForm(f=>({...f,aktionen:f.aktionen.map((a,j)=>j===i?{...a,[k]:v}:a)}));

  const save=async()=>{
    setSaving(true);
    if(regel&&regel!=="add") await fetch("/api/email/regeln/"+regel._id,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    else await fetch("/api/email/regeln",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    setSaving(false);onSaved();
  };
  return<CrmModal title={regel&&regel!=="add"?"Regel bearbeiten":"Neue Regel"} onClose={onClose} wide>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px"}}>
      <Inp label="Name" value={form.name} onChange={v=>sf("name",v)} required/>
      <Inp label="Priorität" value={form.prioritaet} onChange={v=>sf("prioritaet",parseInt(v)||1)} type="number"/>
    </div>
    <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"var(--t2)",cursor:"pointer",marginTop:6}}>
      <input type="checkbox" checked={!!form.aktiv} onChange={e=>sf("aktiv",e.target.checked)}/> Aktiv
    </label>
    <div style={{marginTop:12}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
        <div style={{fontSize:11,fontWeight:600,color:"var(--t2)"}}>Bedingungen</div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <label style={{fontSize:11,color:"var(--t2)",display:"flex",gap:4,alignItems:"center"}}>Verknüpfung:
            {["UND","ODER"].map(o=><label key={o} style={{display:"flex",gap:3,alignItems:"center",cursor:"pointer",marginLeft:6,fontSize:11,color:"var(--t1)"}}>
              <input type="radio" name="vknpfg" value={o} checked={form.bedingungVerknuepfung===o} onChange={()=>sf("bedingungVerknuepfung",o)}/> {o}
            </label>)}
          </label>
          <Btn small onClick={addBed}>+ Bedingung</Btn>
        </div>
      </div>
      {form.bedingungen.map((b,i)=><div key={i} style={{display:"flex",gap:6,alignItems:"center",marginBottom:4}}>
        <select value={b.feld} onChange={e=>updBed(i,"feld",e.target.value)} style={iS0}>{REGEL_FELDER.map(f=><option key={f.v} value={f.v}>{f.l}</option>)}</select>
        <select value={b.operator} onChange={e=>updBed(i,"operator",e.target.value)} style={iS0}>{REGEL_OPS.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}</select>
        <input value={b.wert} onChange={e=>updBed(i,"wert",e.target.value)} style={{...iS0,flex:1}} placeholder="Wert"/>
        <Btn small onClick={()=>delBed(i)} style={{color:"var(--red)"}}>×</Btn>
      </div>)}
    </div>
    <div style={{marginTop:12}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
        <div style={{fontSize:11,fontWeight:600,color:"var(--t2)"}}>Aktionen</div>
        <Btn small onClick={addAkt}>+ Aktion</Btn>
      </div>
      {form.aktionen.map((a,i)=><div key={i} style={{display:"flex",gap:6,alignItems:"center",marginBottom:4}}>
        <select value={a.typ} onChange={e=>updAkt(i,"typ",e.target.value)} style={iS0}>{AKTION_TYPEN.map(t=><option key={t.v} value={t.v}>{t.l}</option>)}</select>
        {a.typ!=="spam"&&<input value={a.wert} onChange={e=>updAkt(i,"wert",e.target.value)} style={{...iS0,flex:1}} placeholder="Wert"/>}
        <Btn small onClick={()=>delAkt(i)} style={{color:"var(--red)"}}>×</Btn>
      </div>)}
    </div>
    <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:12,borderTop:"1px solid var(--brd)",marginTop:8}}>
      <Btn onClick={onClose}>Abbrechen</Btn>
      <Btn primary onClick={save} disabled={saving||!form.name}>{saving?"Speichere…":"Speichern"}</Btn>
    </div>
  </CrmModal>;
};

const EmailRegeln=()=>{
  const [regeln,setRegeln]=useState([]);
  const [modal,setModal]=useState(null);
  const load=()=>fetch("/api/email/regeln").then(r=>r.json()).then(d=>setRegeln(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);
  const del=async id=>{if(!confirm("Regel löschen?"))return;await fetch("/api/email/regeln/"+id,{method:"DELETE"});load();};
  const toggle=async regel=>{await fetch("/api/email/regeln/"+regel._id,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({aktiv:!regel.aktiv})});load();};
  const prio=async(id,delta)=>{const r=regeln.find(x=>x._id===id);if(!r)return;await fetch("/api/email/regeln/"+id,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({prioritaet:(r.prioritaet||0)+delta})});load();};
  return<>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
      <div style={{fontSize:13,color:"var(--t2)"}}>Automatische Regeln für eingehende E-Mails</div>
      <Btn primary onClick={()=>setModal("add")}>+ Regel</Btn>
    </div>
    {regeln.length===0&&<EmptyState icon="⚙" title="Keine Regeln" sub="Erstelle die erste Verarbeitungsregel"/>}
    {regeln.map(r=><Card key={r._id} style={{padding:"12px 16px",marginBottom:8}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
            <span style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>{r.name}</span>
            <span style={{fontSize:10,padding:"2px 6px",borderRadius:8,background:r.aktiv?"#d1fae5":"var(--s2)",color:r.aktiv?"#065f46":"var(--t3)"}}>{r.aktiv?"Aktiv":"Inaktiv"}</span>
            <span style={{fontSize:10,color:"var(--t3)"}}>Prio {r.prioritaet||0}</span>
          </div>
          <div style={{fontSize:11,color:"var(--t3)"}}>
            {(r.bedingungen||[]).map((b,i)=><span key={i} style={{marginRight:6}}>{b.feld} {b.operator} "{b.wert}"</span>)}
            {(r.bedingungen||[]).length>0&&<span style={{color:"var(--t2)",marginRight:8}}>[{r.bedingungVerknuepfung||"UND"}]</span>}
            →{(r.aktionen||[]).map((a,i)=><span key={i} style={{marginLeft:6,color:"var(--acc)"}}>{a.typ}{a.wert?" ("+a.wert+")":""}</span>)}
          </div>
        </div>
        <div style={{display:"flex",gap:4,alignItems:"center",flexShrink:0,marginLeft:12}}>
          <Btn small onClick={()=>prio(r._id,-1)}>↑</Btn>
          <Btn small onClick={()=>prio(r._id,1)}>↓</Btn>
          <Btn small onClick={()=>toggle(r)}>{r.aktiv?"Aus":"An"}</Btn>
          <Btn small onClick={()=>setModal(r)}>Edit</Btn>
          <Btn small onClick={()=>del(r._id)} style={{color:"var(--red)"}}>✕</Btn>
        </div>
      </div>
    </Card>)}
    {modal&&<RegelModal regel={modal} onClose={()=>setModal(null)} onSaved={()=>{setModal(null);load();}}/>}
  </>;
};

/* ─── Email Spamfilter ─── */
const EmailSpam=()=>{
  const [liste,setListe]=useState([]);
  const [newEmail,setNewEmail]=useState("");
  const [newDomain,setNewDomain]=useState("");
  useEffect(()=>{fetch("/api/email/spam-liste").then(r=>r.json()).then(d=>setListe(Array.isArray(d)?d:[])).catch(()=>{});},[]);
  const load=()=>fetch("/api/email/spam-liste").then(r=>r.json()).then(d=>setListe(Array.isArray(d)?d:[])).catch(()=>{});
  const addEntry=async(typ,val)=>{
    if(!val.trim())return;
    const body=typ==="email"?{email:val.trim()}:{domain:val.trim()};
    await fetch("/api/email/spam-liste",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)}).catch(()=>{});
    if(typ==="email")setNewEmail(""); else setNewDomain("");
    load();
  };
  const del=async id=>{await fetch("/api/email/spam-liste/"+id,{method:"DELETE"}).catch(()=>{});load();};
  const emails=liste.filter(l=>l.email);
  const domains=liste.filter(l=>l.domain&&!l.email);
  const tbl=(items,typ)=><>
    <div style={{display:"flex",gap:8,marginBottom:8}}>
      <input value={typ==="email"?newEmail:newDomain} onChange={e=>typ==="email"?setNewEmail(e.target.value):setNewDomain(e.target.value)}
        placeholder={typ==="email"?"spam@example.com":"example.com"}
        style={{flex:1,padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}
        onKeyDown={e=>{if(e.key==="Enter")addEntry(typ,typ==="email"?newEmail:newDomain);}}/>
      <Btn small primary onClick={()=>addEntry(typ,typ==="email"?newEmail:newDomain)}>+ Hinzufügen</Btn>
    </div>
    {items.length===0&&<div style={{fontSize:12,color:"var(--t3)",padding:"8px 0"}}>Keine Einträge</div>}
    {items.length>0&&<table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
      <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)"}}><th style={{textAlign:"left",padding:"4px 8px",fontWeight:500}}>{typ==="email"?"E-Mail-Adresse":"Domain"}</th><th style={{textAlign:"left",padding:"4px 8px",fontWeight:500}}>Hinzugefügt</th><th></th></tr></thead>
      <tbody>{items.map(i=><tr key={i._id} style={{borderBottom:"1px solid var(--brd)"}}>
        <td style={{padding:"6px 8px",color:"var(--t1)"}}>{i.email||i.domain}</td>
        <td style={{padding:"6px 8px",color:"var(--t3)"}}>{i.createdAt?new Date(i.createdAt).toLocaleDateString("de-DE"):""}</td>
        <td style={{padding:"6px 8px",textAlign:"right"}}><Btn small onClick={()=>del(i._id)} style={{color:"var(--red)"}}>✕</Btn></td>
      </tr>)}</tbody>
    </table>}
  </>;
  return<>
    <div style={{padding:"8px 12px",borderRadius:7,background:"var(--s2)",border:"1px solid var(--brd)",fontSize:12,color:"var(--t2)",marginBottom:16}}>
      Diese Absender werden beim IMAP-Sync automatisch als Spam markiert.
    </div>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24}}>
      <div><div style={{fontSize:12,fontWeight:600,color:"var(--t1)",marginBottom:10}}>E-Mail-Adressen Blacklist</div>{tbl(emails,"email")}</div>
      <div><div style={{fontSize:12,fontWeight:600,color:"var(--t1)",marginBottom:10}}>Domain Blacklist</div>{tbl(domains,"domain")}</div>
    </div>
  </>;
};

/* ─── Dokumente: Ablage ─── */
const FILE_ICONS={"pdf":"📄","jpg":"🖼","jpeg":"🖼","png":"🖼","gif":"🖼","webp":"🖼","xlsx":"📊","xls":"📊","csv":"📊","docx":"📎","doc":"📎"};
const fileIcon=name=>{const ext=(name||"").split(".").pop().toLowerCase();return FILE_ICONS[ext]||"📎";};
const fmtSize=b=>{if(!b)return"—";if(b<1024)return b+"B";if(b<1048576)return(b/1024).toFixed(1)+"KB";return(b/1048576).toFixed(1)+"MB";};

const WURZEL_ORDNER=["firmen","vorgaenge","allgemein","buchhaltung"];

const DokumenteAblage=()=>{
  const [pfad,setPfad]=useState("");
  const [items,setItems]=useState([]);
  const [uploading,setUploading]=useState(false);
  const [progress,setProgress]=useState(null);
  const [neuerOrdner,setNeuerOrdner]=useState(false);
  const [ordnerName,setOrdnerName]=useState("");
  const fileRef=React.useRef();

  const loadOrdner=p=>{
    setPfad(p||"");
    fetch("/api/dokumente/ordner?pfad="+encodeURIComponent(p||"")).then(r=>r.json()).then(d=>setItems(Array.isArray(d)?d:[])).catch(()=>{});
  };
  useEffect(()=>{loadOrdner("");},[]);

  const handleUpload=async e=>{
    const files=Array.from(e.target.files||[]);
    if(!files.length)return;
    setUploading(true);
    for(let i=0;i<files.length;i++){
      setProgress(`${i+1}/${files.length}: ${files[i].name}`);
      const fd=new FormData();fd.append("file",files[i]);fd.append("pfad",pfad||"allgemein");
      await fetch("/api/dokumente/upload",{method:"POST",body:fd}).catch(()=>{});
    }
    setUploading(false);setProgress(null);if(fileRef.current)fileRef.current.value="";
    loadOrdner(pfad);
  };

  const handleDownload=async key=>{
    const r=await fetch("/api/dokumente/download?key="+encodeURIComponent(key)).then(r=>r.json()).catch(()=>{});
    if(r?.url)window.open(r.url,"_blank");
  };
  const handleTeilen=async key=>{
    const r=await fetch("/api/dokumente/teilen?key="+encodeURIComponent(key),{method:"POST"}).then(r=>r.json()).catch(()=>{});
    if(r?.url){navigator.clipboard.writeText(r.url).catch(()=>{});alert("Link kopiert (gültig 7 Tage)");}
  };
  const handleDelete=async key=>{
    if(!confirm("Datei löschen?"))return;
    await fetch("/api/dokumente?key="+encodeURIComponent(key),{method:"DELETE"}).catch(()=>{});
    loadOrdner(pfad);
  };
  const handleOrdnerErstellen=async()=>{
    if(!ordnerName.trim())return;
    const np=(pfad?pfad+"/":"")+ordnerName.trim();
    await fetch("/api/dokumente/ordner",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({pfad:np})}).catch(()=>{});
    setNeuerOrdner(false);setOrdnerName("");loadOrdner(pfad);
  };

  const isDir=obj=>obj.prefix!==undefined||obj.name?.endsWith("/");
  const dirs=items.filter(isDir);
  const files=items.filter(o=>!isDir(o));

  return<div style={{display:"flex",gap:16,height:"calc(100vh - 160px)"}}>
    {/* Ordnerbaum links */}
    <div style={{width:220,flexShrink:0,borderRight:"1px solid var(--brd)",paddingRight:12}}>
      <div style={{fontSize:11,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Ordner</div>
      <div style={{cursor:"pointer",padding:"5px 8px",borderRadius:6,fontSize:12,color:pfad===""?"var(--acc)":"var(--t2)",background:pfad===""?"var(--sact)":"transparent",fontWeight:pfad===""?600:400}} onClick={()=>loadOrdner("")}>/ Wurzel</div>
      {WURZEL_ORDNER.map(o=><div key={o} style={{cursor:"pointer",padding:"5px 8px",borderRadius:6,fontSize:12,color:pfad===o?"var(--acc)":"var(--t2)",background:pfad===o?"var(--sact)":"transparent",fontWeight:pfad===o?600:400}} onClick={()=>loadOrdner(o)}>{o.charAt(0).toUpperCase()+o.slice(1)}</div>)}
      {dirs.map(d=><div key={d.prefix||d.name} style={{cursor:"pointer",padding:"5px 8px",borderRadius:6,fontSize:11,color:"var(--t2)",paddingLeft:16}} onClick={()=>loadOrdner(d.prefix||d.name)}>📁 {(d.prefix||d.name).replace(/\/$/, "").split("/").pop()}</div>)}
      <div style={{marginTop:8,borderTop:"1px solid var(--brd)",paddingTop:8}}>
        {neuerOrdner?<><input value={ordnerName} onChange={e=>setOrdnerName(e.target.value)} placeholder="Ordnername" style={{width:"100%",padding:"4px 8px",borderRadius:5,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:11,fontFamily:"inherit",marginBottom:4}} onKeyDown={e=>{if(e.key==="Enter")handleOrdnerErstellen();}}/><div style={{display:"flex",gap:4}}><Btn small primary onClick={handleOrdnerErstellen}>OK</Btn><Btn small onClick={()=>setNeuerOrdner(false)}>✕</Btn></div></>:<Btn small onClick={()=>setNeuerOrdner(true)}>+ Ordner</Btn>}
      </div>
    </div>
    {/* Dateiliste rechts */}
    <div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0}}>
      {/* Upload-Zone */}
      <div style={{border:"2px dashed var(--brd)",borderRadius:8,padding:"12px 16px",marginBottom:12,display:"flex",alignItems:"center",gap:12,background:"var(--s2)"}}>
        <input ref={fileRef} type="file" multiple onChange={handleUpload} style={{display:"none"}} id="dok-upload"/>
        <label htmlFor="dok-upload" style={{cursor:"pointer"}}><Btn small disabled={uploading}>{uploading?"Uploading…":"📤 Dateien hochladen"}</Btn></label>
        {progress&&<span style={{fontSize:11,color:"var(--t2)"}}>{progress}</span>}
        <span style={{fontSize:11,color:"var(--t3)",marginLeft:"auto"}}>Pfad: /{pfad||"(Wurzel)"}</span>
      </div>
      {/* Tabelle */}
      <div style={{flex:1,overflowY:"auto"}}>
        {files.length===0&&dirs.length===0&&<EmptyState icon="📁" title="Leer" sub="Noch keine Dateien in diesem Ordner"/>}
        {files.length>0&&<table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)"}}>
            <th style={{textAlign:"left",padding:"5px 8px",fontWeight:500}}>Datei</th>
            <th style={{textAlign:"right",padding:"5px 8px",fontWeight:500}}>Größe</th>
            <th style={{textAlign:"left",padding:"5px 8px",fontWeight:500}}>Datum</th>
            <th style={{padding:"5px 8px"}}></th>
          </tr></thead>
          <tbody>{files.map(f=><tr key={f.name} style={{borderBottom:"1px solid var(--brd)"}}>
            <td style={{padding:"7px 8px",color:"var(--t1)"}}>{fileIcon(f.name)} {f.name.split("/").pop()}</td>
            <td style={{padding:"7px 8px",color:"var(--t2)",textAlign:"right"}}>{fmtSize(f.size)}</td>
            <td style={{padding:"7px 8px",color:"var(--t3)"}}>{f.lastModified?new Date(f.lastModified).toLocaleDateString("de-DE"):""}</td>
            <td style={{padding:"7px 8px"}}><div style={{display:"flex",gap:4,justifyContent:"flex-end"}}>
              <Btn small onClick={()=>handleDownload(f.name)}>⬇</Btn>
              <Btn small onClick={()=>handleTeilen(f.name)}>🔗</Btn>
              <Btn small onClick={()=>handleDelete(f.name)} style={{color:"var(--red)"}}>✕</Btn>
            </div></td>
          </tr>)}</tbody>
        </table>}
      </div>
    </div>
  </div>;
};

/* ─── Dokumente: Geteilt ─── */
const DokumenteGeteilt=()=>{
  const [items,setItems]=useState([]);
  useEffect(()=>{fetch("/api/dokumente/geteilt").then(r=>r.json()).then(d=>setItems(Array.isArray(d)?d:[])).catch(()=>{});},[]);
  const copyLink=url=>{navigator.clipboard.writeText(url).catch(()=>{});alert("Link kopiert");};
  return<>
    <div style={{fontSize:13,color:"var(--t2)",marginBottom:12}}>Geteilte Links (gültig 7 Tage, gespeichert in DB)</div>
    {items.length===0&&<EmptyState icon="🔗" title="Keine geteilten Dateien" sub="Dateien über Ablage → 🔗 teilen"/>}
    {items.length>0&&<table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
      <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)"}}>
        <th style={{textAlign:"left",padding:"5px 8px",fontWeight:500}}>Datei</th>
        <th style={{textAlign:"left",padding:"5px 8px",fontWeight:500}}>Ablauf</th>
        <th style={{padding:"5px 8px"}}></th>
      </tr></thead>
      <tbody>{items.map(i=><tr key={i._id} style={{borderBottom:"1px solid var(--brd)"}}>
        <td style={{padding:"7px 8px",color:"var(--t1)"}}>{fileIcon(i.key)} {i.key.split("/").pop()}</td>
        <td style={{padding:"7px 8px",color:new Date(i.ablauf)<new Date()?"var(--red)":"var(--t2)"}}>{new Date(i.ablauf).toLocaleDateString("de-DE")}</td>
        <td style={{padding:"7px 8px"}}><Btn small onClick={()=>copyLink(i.url)}>🔗 Link kopieren</Btn></td>
      </tr>)}</tbody>
    </table>}
  </>;
};

/* ─── TeamChat ─── */
const TeamChat=()=>{
  return<div style={{display:"flex",flexDirection:"column",height:"calc(100vh - 120px)"}}>
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10,padding:"8px 14px",background:"var(--s2)",borderRadius:8,border:"1px solid var(--brd)"}}>
      <span style={{fontSize:12,color:"var(--t2)"}}>RocketChat muss einmalig eingerichtet werden → <a href="http://localhost:3100" target="_blank" style={{color:"var(--acc)"}}>http://localhost:3100</a></span>
      <Btn small onClick={()=>window.open("http://localhost:3100")}>RocketChat öffnen ↗</Btn>
    </div>
    <iframe src="http://localhost:3100" style={{flex:1,border:"none",borderRadius:8,background:"var(--s2)"}} title="Team-Chat"/>
  </div>;
};

const EmailKontenVerwaltung=()=>{
  const [items,setItems]=useState([]);
  const [modal,setModal]=useState(null);
  const [saving,setSaving]=useState(false);
  const emptyForm={name:"",email:"",typ:"persoenlich",kontotyp:"allgemein",zugriffRollen:[],verarbeitung:{crmMatch:false,dokumentenAblage:false,teamInbox:false,orderfiles:false},signatur:"",smtp:{host:"",port:587,user:"",password:"",secure:false},imap:{host:"",port:993,user:"",password:"",secure:true},aktiv:true};
  const [form,setForm]=useState({...emptyForm});
  const [testing,setTesting]=useState(false);
  const [testRes,setTestRes]=useState(null);
  const sf=(k,v)=>setForm(f=>({...f,[k]:v}));
  const sfSub=(sub,k,v)=>setForm(f=>({...f,[sub]:{...f[sub],[k]:v}}));
  const test=async()=>{
    setTesting(true);setTestRes(null);
    try{
      const r=await fetch("/api/email/konten/test",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({_id:form._id,smtp:form.smtp,imap:form.imap})});
      const d=await r.json();setTestRes(d);
    }catch(e){setTestRes({imap:{ok:false,msg:String(e)},smtp:{ok:false,msg:String(e)}});}
    setTesting(false);
  };
  const load=()=>fetch("/api/email/konten").then(r=>r.json()).then(d=>setItems(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);
  const openAdd=()=>{setForm({...emptyForm,smtp:{...emptyForm.smtp},imap:{...emptyForm.imap}});setModal("add");};
  const openEdit=k=>{setForm({...emptyForm,...k,smtp:{...emptyForm.smtp,...k.smtp},imap:{...emptyForm.imap,...k.imap}});setModal(k);};
  const save=async()=>{
    setSaving(true);
    if(modal==="add") await fetch("/api/email/konten",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    else await fetch(`/api/email/konten/${modal._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    setSaving(false);setModal(null);load();
  };
  const del=async id=>{if(!confirm("Konto löschen?"))return;await fetch(`/api/email/konten/${id}`,{method:"DELETE"});load();};
  const iS={background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",padding:"7px 10px",borderRadius:6,border:"1px solid var(--brd)"};
  return<>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
      <div style={{fontSize:13,color:"var(--t2)"}}>E-Mail-Konten für IMAP/SMTP-Anbindung</div>
      <Btn primary onClick={openAdd}>+ Konto</Btn>
    </div>
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {items.length===0&&<EmptyState icon="✉" title="Keine E-Mail-Konten" sub="Verbinde das erste Postfach"/>}
      {items.map(k=><Card key={k._id} style={{padding:"14px 18px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <div style={{width:36,height:36,borderRadius:8,background:"var(--acc2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>✉</div>
            <div>
              <div style={{fontSize:14,fontWeight:600,color:"var(--t1)"}}>{k.name}</div>
              <div style={{fontSize:11,color:"var(--t3)"}}>{k.email} · {k.typ==="gruppe"?"Gruppenpostfach":"Persönlich"}</div>
            </div>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <Dot s={k.aktiv?"aktiv":"inaktiv"}/>
            <Btn small onClick={()=>openEdit(k)}>Edit</Btn>
            <Btn small onClick={()=>del(k._id)} style={{color:"var(--red)"}}>✕</Btn>
          </div>
        </div>
        {k.smtp&&<div style={{marginTop:10,padding:"8px 12px",borderRadius:7,background:"var(--s2)",fontSize:11,color:"var(--t3)",display:"flex",gap:20}}>
          <span>SMTP: {k.smtp.host}:{k.smtp.port}</span>
          <span>IMAP: {k.imap?.host}:{k.imap?.port}</span>
        </div>}
      </Card>)}
    </div>
    {modal&&<CrmModal title={modal==="add"?"Neues E-Mail-Konto":"Konto bearbeiten"} onClose={()=>setModal(null)} wide>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
        <Inp label="Name / Bezeichnung" value={form.name} onChange={v=>sf("name",v)} required/>
        <Inp label="E-Mail-Adresse" value={form.email} onChange={v=>sf("email",v)} type="email" required/>
        <Sel label="Typ" value={form.typ} onChange={v=>sf("typ",v)} opts={[{v:"persoenlich",l:"Persönlich"},{v:"gruppe",l:"Gruppenpostfach (geteilt)"}]}/>
        <Sel label="Konto-Typ" value={form.kontotyp||"allgemein"} onChange={v=>sf("kontotyp",v)} opts={[{v:"kundensupport",l:"Kundensupport"},{v:"buchhaltung",l:"Buchhaltung"},{v:"einkauf",l:"Einkauf"},{v:"allgemein",l:"Allgemein"}]}/>
      </div>
      <div style={{marginTop:8}}>
        <Inp label='Zugriff für Rollen (kommagetrennt, leer = alle)' value={(form.zugriffRollen||[]).join(",")} onChange={v=>sf("zugriffRollen",v?v.split(",").map(s=>s.trim()).filter(Boolean):[])} placeholder="admin,buchhaltung — leer = alle"/>
      </div>
      <div style={{marginTop:8,padding:"10px 12px",border:"1px solid var(--brd)",borderRadius:7}}>
        <div style={{fontSize:11,fontWeight:600,color:"var(--t2)",marginBottom:8}}>Verarbeitung</div>
        <div style={{display:"flex",gap:16}}>
          {[["crmMatch","CRM-Match"],["dokumentenAblage","Dokumentenablage"],["teamInbox","Team-Inbox"],["orderfiles","Orderfiles"]].map(([k,l])=>(
            <label key={k} style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"var(--t2)",cursor:"pointer"}}>
              <input type="checkbox" checked={!!(form.verarbeitung||{})[k]} onChange={e=>sf("verarbeitung",{...(form.verarbeitung||{}), [k]:e.target.checked})}/> {l}
            </label>
          ))}
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginTop:8}}>
        <div style={{padding:"14px",border:"1px solid var(--brd)",borderRadius:8}}>
          <div style={{fontSize:12,fontWeight:600,color:"var(--t2)",marginBottom:10}}>SMTP (Ausgang)</div>
          <Inp label="Host" value={form.smtp.host} onChange={v=>sfSub("smtp","host",v)}/>
          <Inp label="Port" value={form.smtp.port} onChange={v=>sfSub("smtp","port",parseInt(v)||587)} type="number"/>
          <Inp label="Benutzer" value={form.smtp.user} onChange={v=>sfSub("smtp","user",v)}/>
          <Inp label="Passwort" value={form.smtp.password} onChange={v=>sfSub("smtp","password",v)} type="password"/>
          <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"var(--t2)",cursor:"pointer"}}>
            <input type="checkbox" checked={!!form.smtp.secure} onChange={e=>sfSub("smtp","secure",e.target.checked)}/> SSL/TLS
          </label>
        </div>
        <div style={{padding:"14px",border:"1px solid var(--brd)",borderRadius:8}}>
          <div style={{fontSize:12,fontWeight:600,color:"var(--t2)",marginBottom:10}}>IMAP (Eingang)</div>
          <Inp label="Host" value={form.imap.host} onChange={v=>sfSub("imap","host",v)}/>
          <Inp label="Port" value={form.imap.port} onChange={v=>sfSub("imap","port",parseInt(v)||993)} type="number"/>
          <Inp label="Benutzer" value={form.imap.user} onChange={v=>sfSub("imap","user",v)}/>
          <Inp label="Passwort" value={form.imap.password} onChange={v=>sfSub("imap","password",v)} type="password"/>
          <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"var(--t2)",cursor:"pointer"}}>
            <input type="checkbox" checked={!!form.imap.secure} onChange={e=>sfSub("imap","secure",e.target.checked)}/> SSL/TLS
          </label>
        </div>
      </div>
      <div style={{marginTop:12}}>
        <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3,fontWeight:500}}>Signatur</label>
        <textarea value={form.signatur||""} onChange={e=>sf("signatur",e.target.value)} rows={3} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",resize:"vertical"}}/>
      </div>
      {testRes&&<div style={{marginTop:10,padding:"10px 12px",borderRadius:7,background:"var(--s2)",border:"1px solid var(--brd)",fontSize:12,display:"flex",flexDirection:"column",gap:4}}>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <span style={{color:testRes.imap?.ok?"var(--green)":"var(--red)",fontWeight:600}}>{testRes.imap?.ok?"✓":"✕"} IMAP:</span>
          <span style={{color:"var(--t2)"}}>{testRes.imap?.msg||"—"}</span>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <span style={{color:testRes.smtp?.ok?"var(--green)":"var(--red)",fontWeight:600}}>{testRes.smtp?.ok?"✓":"✕"} SMTP:</span>
          <span style={{color:"var(--t2)"}}>{testRes.smtp?.msg||"—"}</span>
        </div>
      </div>}
      <div style={{display:"flex",gap:8,justifyContent:"space-between",alignItems:"center",paddingTop:12,borderTop:"1px solid var(--brd)",marginTop:8}}>
        <Btn onClick={test} disabled={testing||!form.imap?.host}>{testing?"Teste…":"Verbindung testen"}</Btn>
        <div style={{display:"flex",gap:8}}>
          <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
          <Btn primary onClick={save} disabled={saving||!form.name||!form.email}>{saving?"Speichere…":"Speichern"}</Btn>
        </div>
      </div>
    </CrmModal>}
  </>;
};

/* ─── Email Template Designer ─── */
const BLOCK_TYPES=[
  {type:"text",label:"📝 Text",icon:"T"},
  {type:"heading",label:"📌 Überschrift",icon:"H"},
  {type:"button",label:"🔗 Button",icon:"B"},
  {type:"divider",label:"— Trennlinie",icon:"—"},
  {type:"image",label:"🖼 Bild",icon:"I"},
  {type:"spacer",label:"⬜ Abstand",icon:"◻"},
  {type:"variable",label:"{{}} Variable",icon:"{}"},
];
const VARS=["{{firma}}","{{ansprechpartner}}","{{vorname}}","{{nachname}}","{{email}}","{{datum}}","{{produkt}}","{{angebot}}","{{benutzer}}"];

const BlockPreview=({block,dark})=>{
  const s={fontFamily:"'DM Sans',sans-serif",lineHeight:1.6};
  if(block.type==="heading") return<div style={{...s,fontSize:block.size||18,fontWeight:700,color:block.color||"#1a1c22",margin:"8px 0"}}>{block.content||"Überschrift"}</div>;
  if(block.type==="text") return<div style={{...s,fontSize:14,color:block.color||"#4b5563",margin:"6px 0",whiteSpace:"pre-wrap"}}>{block.content||"Textinhalt…"}</div>;
  if(block.type==="button") return<div style={{textAlign:block.align||"center",margin:"12px 0"}}><span style={{display:"inline-block",padding:"10px 24px",borderRadius:6,background:block.bgColor||"#4f46e5",color:block.textColor||"#ffffff",fontSize:14,fontWeight:600,textDecoration:"none"}}>{block.label||"Button"}</span></div>;
  if(block.type==="divider") return<hr style={{border:"none",borderTop:`1px solid ${block.color||"#e5e7eb"}`,margin:"12px 0"}}/>;
  if(block.type==="image") return<div style={{textAlign:block.align||"center",margin:"10px 0"}}>{block.src?<img src={block.src} alt={block.alt||""} style={{maxWidth:"100%",borderRadius:block.rounded?8:0}}/>:<div style={{height:80,borderRadius:8,background:"#f3f4f6",display:"flex",alignItems:"center",justifyContent:"center",color:"#9ca3af",fontSize:12}}>Bild-URL eingeben</div>}</div>;
  if(block.type==="spacer") return<div style={{height:block.height||20}}/>;
  if(block.type==="variable") return<span style={{background:"#ede9fe",color:"#5b21b6",padding:"2px 6px",borderRadius:4,fontSize:12,fontFamily:"monospace"}}>{block.variable||"{{variable}}"}</span>;
  return null;
};

const BlockEditor=({block,onChange,onDelete,onUp,onDown})=>{
  const [open,setOpen]=useState(true);
  const sf=(k,v)=>onChange({...block,[k]:v});
  const iS={width:"100%",padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};
  return<div style={{border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden",marginBottom:6}}>
    <div style={{display:"flex",alignItems:"center",gap:8,padding:"8px 12px",background:"var(--s2)",cursor:"pointer"}} onClick={()=>setOpen(o=>!o)}>
      <span style={{fontSize:11,color:"var(--t3)",fontWeight:600}}>{BLOCK_TYPES.find(b=>b.type===block.type)?.label||block.type}</span>
      <div style={{flex:1}}/>
      <button onClick={e=>{e.stopPropagation();onUp();}} style={{background:"none",border:"none",cursor:"pointer",color:"var(--t3)",fontSize:12,padding:"0 4px"}}>↑</button>
      <button onClick={e=>{e.stopPropagation();onDown();}} style={{background:"none",border:"none",cursor:"pointer",color:"var(--t3)",fontSize:12,padding:"0 4px"}}>↓</button>
      <button onClick={e=>{e.stopPropagation();onDelete();}} style={{background:"none",border:"none",cursor:"pointer",color:"var(--red)",fontSize:14,padding:"0 4px"}}>×</button>
      <span style={{fontSize:9,color:"var(--t3)"}}>{open?"▲":"▼"}</span>
    </div>
    {open&&<div style={{padding:"12px"}}>
      {(block.type==="text"||block.type==="heading")&&<>
        <label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Inhalt</label>
        <textarea value={block.content||""} onChange={e=>sf("content",e.target.value)} rows={block.type==="heading"?1:4} style={{...iS,resize:"vertical",marginBottom:8}}/>
        {block.type==="heading"&&<div style={{display:"flex",gap:8}}>
          <div style={{flex:1}}><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Größe (px)</label><input type="number" value={block.size||18} onChange={e=>sf("size",parseInt(e.target.value))} style={{...iS}}/></div>
          <div style={{flex:1}}><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Farbe</label><input type="color" value={block.color||"#1a1c22"} onChange={e=>sf("color",e.target.value)} style={{width:"100%",height:32,borderRadius:6,border:"1px solid var(--brd)",cursor:"pointer",padding:2}}/></div>
        </div>}
        {block.type==="text"&&<div style={{display:"flex",gap:6,flexWrap:"wrap",marginTop:8}}>
          <label style={{fontSize:10,color:"var(--t3)",display:"flex",alignItems:"center",width:"100%",marginBottom:4}}>Variable einfügen:</label>
          {VARS.map(v=><button key={v} onClick={()=>sf("content",(block.content||"")+v)} style={{padding:"2px 8px",borderRadius:4,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--acc)",fontSize:10,cursor:"pointer",fontFamily:"monospace"}}>{v}</button>)}
        </div>}
      </>}
      {block.type==="button"&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
        <div style={{gridColumn:"1/-1"}}><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Button-Text</label><input value={block.label||""} onChange={e=>sf("label",e.target.value)} style={iS}/></div>
        <div><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Link (URL)</label><input value={block.href||""} onChange={e=>sf("href",e.target.value)} style={iS}/></div>
        <div><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Ausrichtung</label><select value={block.align||"center"} onChange={e=>sf("align",e.target.value)} style={iS}><option value="left">Links</option><option value="center">Mitte</option><option value="right">Rechts</option></select></div>
        <div><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Hintergrundfarbe</label><input type="color" value={block.bgColor||"#4f46e5"} onChange={e=>sf("bgColor",e.target.value)} style={{width:"100%",height:32,borderRadius:6,border:"1px solid var(--brd)",cursor:"pointer",padding:2}}/></div>
        <div><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Textfarbe</label><input type="color" value={block.textColor||"#ffffff"} onChange={e=>sf("textColor",e.target.value)} style={{width:"100%",height:32,borderRadius:6,border:"1px solid var(--brd)",cursor:"pointer",padding:2}}/></div>
      </div>}
      {block.type==="image"&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
        <div style={{gridColumn:"1/-1"}}><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Bild-URL</label><input value={block.src||""} onChange={e=>sf("src",e.target.value)} placeholder="https://…" style={iS}/></div>
        <div><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Alt-Text</label><input value={block.alt||""} onChange={e=>sf("alt",e.target.value)} style={iS}/></div>
        <div><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Ausrichtung</label><select value={block.align||"center"} onChange={e=>sf("align",e.target.value)} style={iS}><option value="left">Links</option><option value="center">Mitte</option><option value="right">Rechts</option></select></div>
        <label style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"var(--t2)",cursor:"pointer",gridColumn:"1/-1"}}><input type="checkbox" checked={!!block.rounded} onChange={e=>sf("rounded",e.target.checked)}/> Abgerundete Ecken</label>
      </div>}
      {block.type==="spacer"&&<div><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Höhe (px)</label><input type="number" value={block.height||20} onChange={e=>sf("height",parseInt(e.target.value))} style={{...iS,width:100}}/></div>}
      {block.type==="divider"&&<div><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Farbe</label><input type="color" value={block.color||"#e5e7eb"} onChange={e=>sf("color",e.target.value)} style={{width:80,height:32,borderRadius:6,border:"1px solid var(--brd)",cursor:"pointer",padding:2}}/></div>}
      {block.type==="variable"&&<div><label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:3}}>Variable</label><select value={block.variable||""} onChange={e=>sf("variable",e.target.value)} style={{...iS,width:"auto"}}><option value="">– wählen –</option>{VARS.map(v=><option key={v} value={v}>{v}</option>)}</select></div>}
    </div>}
  </div>;
};

const EmailVorlagenDesigner=()=>{
  const [vorlagen,setVorlagen]=useState([]);
  const [active,setActive]=useState(null);
  const [saving,setSaving]=useState(false);
  const [betreff,setBetreff]=useState("");
  const [name,setName]=useState("");
  const [kategorie,setKategorie]=useState("Erstkontakt");
  const [blocks,setBlocks]=useState([]);
  const [previewMode,setPreviewMode]=useState(false);
  const KATEGORIEN=["Erstkontakt","Follow-up","Angebot","Rückmeldung","Allgemein"];
  const load=()=>fetch("/api/email/vorlagen").then(r=>r.json()).then(d=>{setVorlagen(Array.isArray(d)?d:[]);}).catch(()=>{});
  useEffect(()=>{load();},[]);
  const newVorlage=()=>{setActive(null);setName("Neue Vorlage");setBetreff("Betreff");setKategorie("Erstkontakt");setBlocks([{type:"heading",content:"Hallo {{ansprechpartner}}",size:20,color:"#1a1c22"},{type:"text",content:"",color:"#4b5563"},{type:"divider",color:"#e5e7eb"},{type:"text",content:"Mit freundlichen Grüßen\n{{benutzer}}",color:"#6b7280"}]);};
  const loadVorlage=v=>{setActive(v);setName(v.name);setBetreff(v.betreff||"");setKategorie(v.kategorie||"Allgemein");setBlocks(v.blocks||[]);setPreviewMode(false);};
  const save=async()=>{
    setSaving(true);
    const payload={name,betreff,kategorie,blocks};
    if(active) await fetch(`/api/email/vorlagen/${active._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
    else await fetch("/api/email/vorlagen",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)});
    setSaving(false);await load();
  };
  const del=async id=>{if(!confirm("Vorlage löschen?"))return;await fetch(`/api/email/vorlagen/${id}`,{method:"DELETE"});setActive(null);setBlocks([]);load();};
  const addBlock=type=>setBlocks(bs=>[...bs,{type,id:Date.now()}]);
  const updateBlock=(i,b)=>setBlocks(bs=>bs.map((x,xi)=>xi===i?b:x));
  const delBlock=i=>setBlocks(bs=>bs.filter((_,xi)=>xi!==i));
  const moveUp=i=>{if(i===0)return;setBlocks(bs=>{const n=[...bs];[n[i-1],n[i]]=[n[i],n[i-1]];return n;});};
  const moveDown=i=>{setBlocks(bs=>{if(i>=bs.length-1)return bs;const n=[...bs];[n[i],n[i+1]]=[n[i+1],n[i]];return n;});};
  return<div style={{display:"grid",gridTemplateColumns:"220px 1fr 1fr",gap:14,height:"calc(100vh - 120px)"}}>
    {/* Vorlagen-Liste */}
    <div style={{display:"flex",flexDirection:"column",gap:8,overflow:"auto"}}>
      <Btn primary onClick={newVorlage} style={{width:"100%"}}>+ Neue Vorlage</Btn>
      {KATEGORIEN.map(kat=>{
        const kVorlagen=vorlagen.filter(v=>v.kategorie===kat);
        if(kVorlagen.length===0)return null;
        return<div key={kat}>
          <div style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px",padding:"6px 4px 3px"}}>{kat}</div>
          {kVorlagen.map(v=><button key={v._id} onClick={()=>loadVorlage(v)}
            style={{display:"block",width:"100%",textAlign:"left",padding:"8px 10px",borderRadius:7,border:"1px solid",borderColor:active&&String(active._id)===String(v._id)?"var(--acc)":"var(--brd)",background:active&&String(active._id)===String(v._id)?"var(--acc2)":"var(--s1)",color:"var(--t1)",fontSize:12,cursor:"pointer",fontFamily:"inherit",marginBottom:3}}>
            {v.name}
          </button>)}
        </div>;
      })}
    </div>

    {/* Editor */}
    <div style={{display:"flex",flexDirection:"column",gap:10,overflow:"auto"}}>
      {blocks.length===0&&!active&&!name&&<EmptyState icon="✉" title="Vorlage wählen oder neu erstellen" sub="Links eine Vorlage öffnen oder + Neue Vorlage"/>}
      {(blocks.length>0||name)&&<>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <input value={name} onChange={e=>setName(e.target.value)} placeholder="Vorlagenname" style={{flex:1,padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",fontWeight:600}}/>
          <select value={kategorie} onChange={e=>setKategorie(e.target.value)} style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
            {KATEGORIEN.map(k=><option key={k} value={k}>{k}</option>)}
          </select>
        </div>
        <input value={betreff} onChange={e=>setBetreff(e.target.value)} placeholder="Betreff-Zeile" style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          {BLOCK_TYPES.map(b=><button key={b.type} onClick={()=>addBlock(b.type)} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t2)",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>{b.label}</button>)}
        </div>
        <div style={{flex:1,overflow:"auto"}}>
          {blocks.map((b,i)=><BlockEditor key={b.id||i} block={b} onChange={nb=>updateBlock(i,nb)} onDelete={()=>delBlock(i)} onUp={()=>moveUp(i)} onDown={()=>moveDown(i)}/>)}
        </div>
        <div style={{display:"flex",gap:8,paddingTop:8,borderTop:"1px solid var(--brd)"}}>
          <Btn onClick={()=>setPreviewMode(p=>!p)}>{previewMode?"Editor":"Vorschau"}</Btn>
          {active&&<Btn onClick={()=>del(active._id)} style={{color:"var(--red)"}}>Löschen</Btn>}
          <div style={{flex:1}}/>
          <Btn primary onClick={save} disabled={saving}>{saving?"Speichere…":"Speichern"}</Btn>
        </div>
      </>}
    </div>

    {/* Preview */}
    <div style={{overflow:"auto",border:"1px solid var(--brd)",borderRadius:10}}>
      <div style={{padding:"10px 16px",borderBottom:"1px solid var(--brd)",background:"var(--s2)",fontSize:11,color:"var(--t3)",fontWeight:600,display:"flex",gap:8,alignItems:"center"}}>
        <span>VORSCHAU</span>
        {betreff&&<span style={{color:"var(--t2)"}}>· {betreff}</span>}
      </div>
      <div style={{padding:"24px",background:"#ffffff",minHeight:200}}>
        {blocks.map((b,i)=><BlockPreview key={i} block={b}/>)}
      </div>
    </div>
  </div>;
};

/* ─── Zalando: shared helpers ─── */
const ZAL_STATUS_COLOR={initial:"var(--t3)",approved:"var(--ylw)",fulfilled:"var(--grn)",cancelled:"var(--red)",returned:"var(--purple)"};
const ZAL_STATUS_LABEL={initial:"Neu",approved:"Genehmigt",fulfilled:"Versendet",cancelled:"Storniert",returned:"Retourniert"};
const fmtZalDate=d=>{if(!d)return"–";try{return new Date(d).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});}catch{return d;}};
const fmtZalMoney=(amt,cur="EUR")=>{if(!amt&&amt!==0)return"–";return(+amt/100).toLocaleString("de-DE",{style:"currency",currency:cur});};

/* ─── ZalandoDashboard ─── */
const ZalandoDashboard=()=>{
  const [status,setStatus]=useState(null);
  const [loading,setLoading]=useState(true);
  const [syncing,setSyncing]=useState(false);

  const load=()=>{
    setLoading(true);
    fetch("/api/zalando/status").then(r=>r.json()).then(d=>{setStatus(d);setLoading(false);}).catch(()=>setLoading(false));
  };
  useEffect(()=>{load();},[]);

  const sync=async type=>{
    setSyncing(type);
    try{
      if(type==="orders")await fetch("/api/zalando/orders/sync").then(r=>r.json());
      if(type==="returns")await fetch("/api/zalando/returns/sync").then(r=>r.json());
      if(type==="zfs")await fetch("/api/zalando/zfs/quantities").then(r=>r.json());
      if(type==="channels")await fetch("/api/zalando/sales-channels").then(r=>r.json());
      load();
    }catch(e){alert("Fehler: "+e.message);}
    setSyncing(false);
  };

  if(loading)return<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>;

  const connected=status?.connected;
  const syncMeta=(status?.syncMeta||[]).reduce((a,m)=>{a[m.type]=m;return a;},{});

  return<div style={{padding:24,maxWidth:900}}>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:24}}>
      <div style={{fontSize:22,fontWeight:700,color:"var(--t1)"}}>Zalando zDirect</div>
      <div style={{padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:600,background:connected?"#16a34a22":"#dc262622",color:connected?"var(--grn)":"var(--red)"}}>
        {connected?"● Verbunden":"● Nicht verbunden"}
      </div>
      {connected&&status?.sandbox&&<div style={{padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:600,background:"#f59e0b22",color:"var(--ylw)"}}>SANDBOX</div>}
    </div>

    {!connected&&<div style={{background:"#dc262611",border:"1px solid #dc262633",borderRadius:8,padding:16,marginBottom:24,color:"var(--t2)",fontSize:13}}>
      Keine Verbindung. Bitte unter <strong>Verwaltung → Schnittstellen → Zalando zDirect</strong> Client ID, Client Secret und BPID eintragen.
      {status?.message&&<div style={{marginTop:6,color:"var(--red)",fontSize:12}}>{status.message}</div>}
    </div>}

    {connected&&<div style={{background:"var(--s2)",borderRadius:8,border:"1px solid var(--brd)",padding:16,marginBottom:24,fontSize:12,color:"var(--t2)"}}>
      <strong>BPID:</strong> {status.bpid||"–"} &nbsp;|&nbsp;
      <strong>Client Groups:</strong> {status.me?.groups?.join(", ")||"–"} &nbsp;|&nbsp;
      <strong>Scopes:</strong> {status.me?.scopes?.length||0} aktiv
    </div>}

    {/* Sync-Karten */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:16,marginBottom:24}}>
      {[
        {type:"orders",label:"Bestellungen",icon:"🛒",meta:syncMeta.orders},
        {type:"returns",label:"Retouren",icon:"↩",meta:syncMeta.returns},
        {type:"zfs",label:"ZFS-Lager",icon:"🏭",meta:syncMeta.zfs_quantities},
        {type:"channels",label:"Sales Channels",icon:"🌍",meta:syncMeta.sales_channels},
      ].map(({type,label,icon,meta})=>
        <div key={type} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:16}}>
          <div style={{fontSize:22,marginBottom:6}}>{icon}</div>
          <div style={{fontWeight:600,fontSize:13,color:"var(--t1)",marginBottom:4}}>{label}</div>
          <div style={{fontSize:11,color:"var(--t3)",marginBottom:10}}>
            {meta?.lastSync?`Letzter Sync: ${fmtZalDate(meta.lastSync)}`:"Noch nie synchronisiert"}
            {meta?.count!==undefined&&` (${meta.count} Einträge)`}
          </div>
          <button onClick={()=>sync(type)} disabled={!connected||syncing===type}
            style={{padding:"5px 12px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--acc)",color:"#fff",fontSize:11,fontWeight:600,cursor:connected&&syncing!==type?"pointer":"not-allowed",opacity:!connected||syncing===type?0.5:1}}>
            {syncing===type?"⏳ Sync…":"↻ Sync"}
          </button>
        </div>
      )}
    </div>

    {/* Schnell-Links */}
    <div style={{fontSize:12,color:"var(--t3)"}}>
      Zalando Developer Portal: <a href="https://developers.merchants.zalando.com" target="_blank" style={{color:"var(--acc)"}}>developers.merchants.zalando.com</a> &nbsp;|&nbsp;
      Kontakt: <a href="mailto:integration@zalando.de" style={{color:"var(--acc)"}}>integration@zalando.de</a>
    </div>
  </div>;
};

/* ─── ZalandoBestellungen ─── */
const ZalandoBestellungen=()=>{
  const [orders,setOrders]=useState([]);
  const [total,setTotal]=useState(0);
  const [page,setPage]=useState(1);
  const [search,setSearch]=useState("");
  const [status,setStatus]=useState("");
  const [loading,setLoading]=useState(false);
  const [syncing,setSyncing]=useState(false);
  const [detail,setDetail]=useState(null);

  const iS={padding:"6px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  const load=()=>{
    setLoading(true);
    const p=new URLSearchParams({page,limit:50});
    if(search)p.set("search",search);
    if(status)p.set("status",status);
    fetch(`/api/zalando/orders?${p}`).then(r=>r.json()).then(d=>{
      setOrders(d.orders||[]);setTotal(d.total||0);setLoading(false);
    }).catch(()=>setLoading(false));
  };

  useEffect(()=>{load();},[page,status]);

  const syncNow=async()=>{
    setSyncing(true);
    const params=new URLSearchParams({limit:100});
    if(status)params.set("status",status);
    await fetch(`/api/zalando/orders/sync?${params}`).then(r=>r.json()).catch(()=>{});
    setSyncing(false);load();
  };

  const openDetail=async(order)=>{
    setDetail({order,items:null,loading:true});
    const items=await fetch(`/api/zalando/orders/${order.id}/items`).then(r=>r.json()).catch(()=>[]);
    setDetail({order,items,loading:false});
  };

  const statusFilter=[{v:"",l:"Alle Status"},{v:"initial",l:"Neu"},{v:"approved",l:"Genehmigt"},{v:"fulfilled",l:"Versendet"},{v:"cancelled",l:"Storniert"}];

  return<div style={{padding:20,maxWidth:1100}}>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16,flexWrap:"wrap"}}>
      <div style={{fontWeight:700,fontSize:16,color:"var(--t1)"}}>Zalando Bestellungen</div>
      <div style={{flex:1}}/>
      <input value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==="Enter"&&load()} placeholder="Suche Bestellnr…" style={{...iS,width:180}}/>
      <select value={status} onChange={e=>{setStatus(e.target.value);setPage(1);}} style={iS}>
        {statusFilter.map(s=><option key={s.v} value={s.v}>{s.l}</option>)}
      </select>
      <button onClick={syncNow} disabled={syncing} style={{padding:"6px 14px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--acc)",color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>
        {syncing?"⏳ Sync…":"↻ Von Zalando laden"}
      </button>
    </div>

    {loading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:<>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)",textAlign:"left"}}>
            <th style={{padding:"6px 8px"}}>Bestellnr.</th>
            <th style={{padding:"6px 8px"}}>Status</th>
            <th style={{padding:"6px 8px"}}>Erstellt</th>
            <th style={{padding:"6px 8px"}}>Aktualisiert</th>
            <th style={{padding:"6px 8px"}}>Channel</th>
            <th style={{padding:"6px 8px"}}>Typ</th>
            <th style={{padding:"6px 8px"}}></th>
          </tr></thead>
          <tbody>
            {orders.length===0&&<tr><td colSpan={7} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Bestellungen. Klick "↻ Von Zalando laden" um zu synchronisieren.</td></tr>}
            {orders.map(o=>{
              const a=o.attributes||{};
              const st=a.order_status||"unknown";
              return<tr key={o.id} style={{borderBottom:"1px solid var(--brd)",cursor:"pointer"}}
                onClick={()=>openDetail(o)}
                onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"}
                onMouseLeave={e=>e.currentTarget.style.background=""}>
                <td style={{padding:"7px 8px",fontWeight:600,color:"var(--acc)"}}>{a.order_number||o.id}</td>
                <td style={{padding:"7px 8px"}}>
                  <span style={{padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600,background:(ZAL_STATUS_COLOR[st]||"var(--t3)")+"22",color:ZAL_STATUS_COLOR[st]||"var(--t3)"}}>
                    {ZAL_STATUS_LABEL[st]||st}
                  </span>
                </td>
                <td style={{padding:"7px 8px",color:"var(--t2)"}}>{fmtZalDate(a.created)}</td>
                <td style={{padding:"7px 8px",color:"var(--t2)"}}>{fmtZalDate(a.last_modified)}</td>
                <td style={{padding:"7px 8px",color:"var(--t2)",fontSize:11}}>{a.sales_channel_id||"–"}</td>
                <td style={{padding:"7px 8px",color:"var(--t2)",fontSize:11}}>{a.order_type||"–"}</td>
                <td style={{padding:"7px 8px",textAlign:"right"}}><span style={{color:"var(--acc)",fontSize:11}}>Details →</span></td>
              </tr>;
            })}
          </tbody>
        </table>
      </div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:12,fontSize:12,color:"var(--t3)"}}>
        <span>{total} Bestellungen gesamt</span>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page<=1} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",cursor:"pointer",fontSize:11}}>‹ Zurück</button>
          <span>Seite {page}</span>
          <button onClick={()=>setPage(p=>p+1)} disabled={orders.length<50} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",cursor:"pointer",fontSize:11}}>Weiter ›</button>
        </div>
      </div>
    </>}

    {/* Detail-Modal */}
    {detail&&<div style={{position:"fixed",inset:0,background:"#0009",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={e=>{if(e.target===e.currentTarget)setDetail(null);}}>
      <div style={{background:"var(--bg)",borderRadius:10,border:"1px solid var(--brd)",width:640,maxHeight:"80vh",overflow:"auto",padding:24}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontWeight:700,fontSize:15,color:"var(--t1)"}}>Bestellung {detail.order.attributes?.order_number||detail.order.id}</div>
          <button onClick={()=>setDetail(null)} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:"var(--t3)"}}>✕</button>
        </div>
        {detail.loading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade Positionen…</div>:<>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:16,fontSize:12}}>
            {[
              ["Status",ZAL_STATUS_LABEL[detail.order.attributes?.order_status]||detail.order.attributes?.order_status||"–"],
              ["Erstellt",fmtZalDate(detail.order.attributes?.created)],
              ["Sales Channel",detail.order.attributes?.sales_channel_id||"–"],
              ["Typ",detail.order.attributes?.order_type||"–"],
              ["Zalando ID",detail.order.id],
            ].map(([l,v])=>
              <div key={l} style={{background:"var(--s2)",borderRadius:6,padding:8}}>
                <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",marginBottom:2}}>{l}</div>
                <div style={{color:"var(--t1)",wordBreak:"break-all"}}>{v}</div>
              </div>
            )}
          </div>
          {detail.items?.length>0&&<>
            <div style={{fontWeight:600,fontSize:12,color:"var(--t2)",marginBottom:8}}>Positionen ({detail.items.length})</div>
            {detail.items.map((item,i)=>{
              const a=item.attributes||{};
              return<div key={i} style={{background:"var(--s2)",borderRadius:6,padding:10,marginBottom:6,fontSize:12}}>
                <div style={{fontWeight:600,color:"var(--t1)"}}>{a.ean||a.simple_sku||item.id}</div>
                <div style={{color:"var(--t2)",marginTop:2}}>Menge: {a.quantity||1} | Preis: {fmtZalMoney(a.price?.amount,a.price?.currency)} | Status: {a.item_status||"–"}</div>
              </div>;
            })}
          </>}
          {detail.items?.length===0&&<div style={{fontSize:12,color:"var(--t3)",padding:12,textAlign:"center"}}>Keine Positionen abrufbar (API-Berechtigung erforderlich)</div>}
        </>}
      </div>
    </div>}
  </div>;
};

/* ─── ZalandoZFSLager ─── */
const ZalandoZFSLager=()=>{
  const [items,setItems]=useState([]);
  const [total,setTotal]=useState(0);
  const [search,setSearch]=useState("");
  const [loading,setLoading]=useState(false);
  const [syncing,setSyncing]=useState(false);
  const [page,setPage]=useState(1);

  const iS={padding:"6px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  const load=()=>{
    setLoading(true);
    const p=new URLSearchParams({page,limit:100});
    if(search)p.set("search",search);
    fetch(`/api/zalando/zfs/quantities/local?${p}`).then(r=>r.json()).then(d=>{
      setItems(d.items||[]);setTotal(d.total||0);setLoading(false);
    }).catch(()=>setLoading(false));
  };

  useEffect(()=>{load();},[page]);

  const syncNow=async()=>{
    setSyncing(true);
    await fetch("/api/zalando/zfs/quantities").then(r=>r.json()).catch(()=>{});
    setSyncing(false);load();
  };

  const totalOfferable=items.reduce((s,i)=>{const q=i.attributes?.quantities_by_state?.offerable||0;return s+q;},0);
  const totalNonOfferable=items.reduce((s,i)=>{const q=i.attributes?.quantities_by_state?.non_offerable||0;return s+q;},0);

  return<div style={{padding:20,maxWidth:1100}}>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16,flexWrap:"wrap"}}>
      <div style={{fontWeight:700,fontSize:16,color:"var(--t1)"}}>Zalando ZFS-Lager</div>
      <div style={{flex:1}}/>
      <input value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){setPage(1);load();}}} placeholder="EAN suchen…" style={{...iS,width:180}}/>
      <button onClick={syncNow} disabled={syncing} style={{padding:"6px 14px",borderRadius:6,border:"none",background:"var(--acc)",color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>
        {syncing?"⏳ Sync…":"↻ ZFS-Bestände laden"}
      </button>
    </div>

    {/* KPI-Zeile */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:12,marginBottom:20}}>
      {[
        {l:"Artikel gesamt",v:total},
        {l:"Verkaufbar",v:totalOfferable,c:"var(--grn)"},
        {l:"Nicht verkaufbar",v:totalNonOfferable,c:"var(--ylw)"},
      ].map(({l,v,c})=>
        <div key={l} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:14}}>
          <div style={{fontSize:11,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",marginBottom:4}}>{l}</div>
          <div style={{fontSize:22,fontWeight:700,color:c||"var(--t1)"}}>{v.toLocaleString("de-DE")}</div>
        </div>
      )}
    </div>

    {loading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
    items.length===0?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine ZFS-Bestände. Klick "↻ ZFS-Bestände laden" um zu synchronisieren.</div>:
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
        <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)",textAlign:"left"}}>
          <th style={{padding:"6px 8px"}}>EAN</th>
          <th style={{padding:"6px 8px",textAlign:"right"}}>Gesamt</th>
          <th style={{padding:"6px 8px",textAlign:"right"}}>Verkaufbar</th>
          <th style={{padding:"6px 8px",textAlign:"right"}}>Nicht verkaufbar</th>
          <th style={{padding:"6px 8px"}}>Letzter Sync</th>
        </tr></thead>
        <tbody>
          {items.map(item=>{
            const a=item.attributes||{};
            const total=a.total_quantity||0;
            const offerable=a.quantities_by_state?.offerable||0;
            const nonOfferable=a.quantities_by_state?.non_offerable||0;
            return<tr key={item.ean||item._id} style={{borderBottom:"1px solid var(--brd)"}}
              onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"}
              onMouseLeave={e=>e.currentTarget.style.background=""}>
              <td style={{padding:"7px 8px",fontFamily:"monospace",fontWeight:600,color:"var(--t1)"}}>{item.ean||item.id}</td>
              <td style={{padding:"7px 8px",textAlign:"right",fontWeight:600}}>{total}</td>
              <td style={{padding:"7px 8px",textAlign:"right",color:"var(--grn)",fontWeight:600}}>{offerable}</td>
              <td style={{padding:"7px 8px",textAlign:"right",color:nonOfferable>0?"var(--ylw)":"var(--t3)"}}>{nonOfferable}</td>
              <td style={{padding:"7px 8px",color:"var(--t3)",fontSize:11}}>{fmtZalDate(item.syncedAt)}</td>
            </tr>;
          })}
        </tbody>
      </table>
    </div>}
    {total>100&&<div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:10,fontSize:12}}>
      <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page<=1} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",cursor:"pointer"}}>‹</button>
      <span style={{color:"var(--t3)"}}>Seite {page} · {total} gesamt</span>
      <button onClick={()=>setPage(p=>p+1)} disabled={items.length<100} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",cursor:"pointer"}}>›</button>
    </div>}
  </div>;
};

/* ─── Bestellungen ─── */
const fmtEurBest=(n)=>(n||0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})+" €";
const fmtDateBest=(d)=>d?new Date(d).toLocaleDateString("de-DE"):"-";

const BestellungenHeader=({title,children})=>{
  const [status,setStatus]=useState(null);
  const [importing,setImporting]=useState(false);
  const [msg,setMsg]=useState("");
  useEffect(()=>{fetch("/api/bestellungen/status").then(r=>r.json()).then(setStatus).catch(()=>{});},[importing]);
  const doImport=async()=>{
    setImporting(true);setMsg("Importiere …");
    try{
      const r=await fetch("/api/bestellungen/import",{method:"POST"}).then(r=>r.json());
      const files=r.files||[];
      if(!files.length) setMsg("Keine neuen Dateien in bestellungen/eingang");
      else setMsg(files.map(f=>f.error?`⚠ ${f.file}: ${f.error}`:`✓ ${f.file}: ${f.inserted} neu, ${f.updated} aktualisiert`).join(" · "));
    }catch(e){setMsg("Fehler: "+e.message);}
    setImporting(false);
  };
  return<div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,gap:12,flexWrap:"wrap"}}>
    <div>
      <div style={{fontSize:16,fontWeight:700,color:"var(--t1)"}}>{title}</div>
      {status&&<div style={{fontSize:11,color:"var(--t3)",marginTop:4}}>
        {status.positionen?.toLocaleString("de-DE")} Positionen · {status.auftraege?.toLocaleString("de-DE")} Aufträge
        {status.lastImport&&<> · zuletzt {new Date(status.lastImport).toLocaleString("de-DE")}</>}
      </div>}
    </div>
    <div style={{display:"flex",gap:8,alignItems:"center"}}>
      {msg&&<span style={{fontSize:11,color:"var(--t2)"}}>{msg}</span>}
      {children}
      <Btn onClick={doImport} disabled={importing} style={{background:"var(--acc)",color:"#fff"}}>{importing?"⏳ Importiere":"↻ Import (MinIO)"}</Btn>
    </div>
  </div>;
};

const BestellungenAuftraege=()=>{
  const _yNow=new Date().getUTCFullYear();
  const [rows,setRows]=useState([]);
  const [total,setTotal]=useState(0);
  const [umsatz,setUmsatz]=useState(0);
  const [nettoUmsatz,setNettoUmsatz]=useState(0);
  const [stornoSum,setStornoSum]=useState(0);
  const [retourSum,setRetourSum]=useState(0);
  const [positionen,setPositionen]=useState(0);
  const [q,setQ]=useState("");
  const [kanal,setKanal]=useState("");
  const [from,setFrom]=useState(`${_yNow}-01-01`);
  const [to,setTo]=useState(`${_yNow}-12-31`);
  const [status,setStatus]=useState("alle");
  const [skip,setSkip]=useState(0);
  const [loading,setLoading]=useState(false);
  const [sel,setSel]=useState(null);
  const limit=200;
  const load=(fOv,tOv)=>{
    setLoading(true);
    const f=fOv!==undefined?fOv:from, t=tOv!==undefined?tOv:to;
    const p=new URLSearchParams();
    if(q)p.set("q",q); if(kanal)p.set("kanal",kanal); if(f)p.set("from",f); if(t)p.set("to",t);
    if(status&&status!=="alle") p.set("status",status);
    p.set("limit",limit); p.set("skip",skip);
    fetch("/api/bestellungen/auftraege?"+p).then(r=>r.json()).then(d=>{
      setRows(d.data||[]);setTotal(d.total||0);setUmsatz(d.umsatz||0);
      setNettoUmsatz(d.nettoUmsatzEur||0);
      setStornoSum(d.stornoVkEur||0); setRetourSum(d.retourVkEur||0);
      setPositionen(d.positionen||0);setLoading(false);
    }).catch(()=>setLoading(false));
  };
  useEffect(()=>{load();},[skip,status]);
  const search=(fOv,tOv)=>{setSkip(0);load(fOv,tOv);};
  return<div>
    <BestellungenHeader title="Aufträge"/>
    <div style={{marginBottom:12}}><DateRangeBar from={from} to={to} setFrom={setFrom} setTo={setTo} onApply={search}/></div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12,marginBottom:12}}>
      <KPI title="Aufträge (Filter)" value={total.toLocaleString("de-DE")} icon="◐"/>
      <KPI title="Positionen" value={positionen.toLocaleString("de-DE")} icon="▦"/>
      <KPI title="Brutto-Umsatz" value={fmtEurBest(umsatz)} icon="€"/>
      <KPI title="Storno / Retour" value={fmtEurBest(stornoSum+retourSum)} icon="↩" accent="var(--red)"/>
      <KPI title="Netto-Umsatz" value={fmtEurBest(nettoUmsatz)} icon="€" accent="var(--green)"/>
    </div>
    <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"end"}}>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Suche (Auftrag-ID/Nr)</label><input value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&search()} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}/></div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Kanal</label><input value={kanal} onChange={e=>setKanal(e.target.value)} placeholder="z. B. Zalando.de ZFS" style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",width:180}}/></div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Status</label>
        <select value={status} onChange={e=>{setStatus(e.target.value);setSkip(0);}} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"}}>
          <option value="alle">Alle</option>
          <option value="valide">Nur valide (keine Retoure/Storno)</option>
          <option value="retourniert">Mit Retoure</option>
          <option value="storniert">Mit Storno</option>
        </select>
      </div>
      <Btn onClick={search}>Filtern</Btn>
      <Btn onClick={()=>{setQ("");setKanal("");setStatus("alle");setSkip(0);setTimeout(load,0);}}>Reset</Btn>
    </div>
    <div style={{background:"var(--s1)",borderRadius:8,overflow:"hidden",border:"1px solid var(--brd)"}}>
      <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
        <thead style={{background:"var(--s2)"}}><tr style={{color:"var(--t3)",fontSize:11,textAlign:"left"}}>
          <th style={{padding:"8px 10px"}}>Datum</th>
          <th style={{padding:"8px 10px"}}>Kanal</th>
          <th style={{padding:"8px 10px"}}>Auftrag-ID</th>
          <th style={{padding:"8px 10px"}}>Auftrag-Nr</th>
          <th style={{padding:"8px 10px",textAlign:"center",width:70}}>Status</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Positionen</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Menge</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Brutto €</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Storno/Retour</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Netto €</th>
        </tr></thead>
        <tbody>{loading?<tr><td colSpan={10} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</td></tr>:
          rows.length===0?<tr><td colSpan={10} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Aufträge. Import starten oder Filter anpassen.</td></tr>:
          rows.map(r=>{
            const hasStorno=(r.stornoMenge||0)>0; const hasRetour=(r.retourMenge||0)>0;
            const abz=(r.stornoVkEur||0)+(r.retourVkEur||0);
            return<tr key={r.auftragId} onClick={()=>setSel(r.auftragId)} style={{borderTop:"1px solid var(--brd)",cursor:"pointer"}} onMouseEnter={e=>e.currentTarget.style.background="var(--s2)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
            <td style={{padding:"8px 10px",color:"var(--t2)"}}>{fmtDateBest(r.erstelldatum)}</td>
            <td style={{padding:"8px 10px",color:"var(--t1)"}}>{r.kanal}</td>
            <td style={{padding:"8px 10px",fontFamily:"monospace",color:"var(--t1)"}}>{r.auftragId}</td>
            <td style={{padding:"8px 10px",fontFamily:"monospace",color:"var(--t2)"}}>{r.auftragNr}</td>
            <td style={{padding:"8px 10px",textAlign:"center",fontSize:10}}>
              {hasStorno&&<span title="Storno enthalten" style={{display:"inline-block",padding:"2px 6px",borderRadius:10,background:"var(--red)",color:"#fff",marginRight:3}}>S</span>}
              {hasRetour&&<span title="Retoure enthalten" style={{display:"inline-block",padding:"2px 6px",borderRadius:10,background:"#f39c12",color:"#fff",marginRight:3}}>R</span>}
              {!hasStorno&&!hasRetour&&<span title="Valide" style={{color:"var(--green)",fontSize:14}}>●</span>}
            </td>
            <td style={{padding:"8px 10px",textAlign:"right",color:"var(--t2)"}}>{r.positionen}</td>
            <td style={{padding:"8px 10px",textAlign:"right",color:"var(--t2)"}}>{r.mengeGesamt}</td>
            <td style={{padding:"8px 10px",textAlign:"right",color:"var(--t2)"}}>{fmtEurBest(r.umsatzEur)}</td>
            <td style={{padding:"8px 10px",textAlign:"right",color:abz>0?"var(--red)":"var(--t3)"}}>{abz>0?"-"+fmtEurBest(abz):"-"}</td>
            <td style={{padding:"8px 10px",textAlign:"right",fontWeight:600,color:"var(--t1)"}}>{fmtEurBest(r.nettoUmsatzEur!==undefined?r.nettoUmsatzEur:r.umsatzEur)}</td>
          </tr>;})}
        </tbody>
      </table>
    </div>
    <div style={{display:"flex",justifyContent:"space-between",marginTop:12,fontSize:11,color:"var(--t3)"}}>
      <div>{total>0&&<>{skip+1}–{Math.min(skip+limit,total)} von {total.toLocaleString("de-DE")}</>}</div>
      <div style={{display:"flex",gap:6}}>
        <Btn onClick={()=>setSkip(Math.max(0,skip-limit))} disabled={skip===0}>← Zurück</Btn>
        <Btn onClick={()=>setSkip(skip+limit)} disabled={skip+limit>=total}>Weiter →</Btn>
      </div>
    </div>
    {sel&&<AuftragDetailModal id={sel} onClose={()=>setSel(null)}/>}
  </div>;
};

const AuftragDetailModal=({id,onClose})=>{
  const [data,setData]=useState(null);
  useEffect(()=>{fetch(`/api/bestellungen/auftraege/${encodeURIComponent(id)}`).then(r=>r.json()).then(setData);},[id]);
  return<Modal open={true} onClose={onClose} title={`Auftrag ${id}`} width={900}>
    {!data?<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
     data.notFound?<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Auftrag nicht gefunden.</div>:
     <div style={{display:"flex",flexDirection:"column",gap:12,maxHeight:"70vh",overflow:"auto"}}>
       <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12}}>
         <div><div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase"}}>Kanal</div><div style={{fontSize:13,color:"var(--t1)",fontWeight:600}}>{data.kanal}</div></div>
         <div><div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase"}}>Auftrag-Nr</div><div style={{fontSize:13,fontFamily:"monospace"}}>{data.auftragNr}</div></div>
         <div><div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase"}}>Datum</div><div style={{fontSize:13}}>{fmtDateBest(data.erstelldatum)}</div></div>
         <div><div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase"}}>Status</div>
           <div style={{fontSize:12,fontWeight:600,color:data.status==="valide"?"var(--green)":data.status==="komplett_storniert"?"var(--red)":data.status==="komplett_retourniert"?"#f39c12":"var(--t2)"}}>{data.status}</div></div>
         <div><div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase"}}>Netto</div><div style={{fontSize:14,fontWeight:700,color:"var(--green)"}}>{fmtEurBest(data.nettoEur!==undefined?data.nettoEur:data.umsatzEur)}</div><div style={{fontSize:10,color:"var(--t3)"}}>Brutto {fmtEurBest(data.umsatzEur)}</div></div>
       </div>
       {(data.retouren?.length>0||data.stornos?.length>0)&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
         {data.retouren?.length>0&&<div style={{border:"1px solid var(--brd)",borderRadius:6,padding:10,background:"var(--s2)"}}>
           <div style={{fontSize:11,fontWeight:600,color:"#f39c12",marginBottom:6}}>↩ Retouren ({data.retouren.length})</div>
           {data.retouren.map((r,i)=><div key={i} style={{fontSize:11,display:"flex",justifyContent:"space-between",padding:"3px 0",borderTop:i>0?"1px dotted var(--brd)":"none"}}>
             <span style={{color:"var(--t2)"}}>{r.artikelNr} · {r.retourenmenge}× · {r.retourengrund||"-"}</span>
             <span style={{color:"var(--t1)",fontWeight:600}}>-{fmtEurBest(r.retourenVkEur||0)}</span>
           </div>)}
         </div>}
         {data.stornos?.length>0&&<div style={{border:"1px solid var(--brd)",borderRadius:6,padding:10,background:"var(--s2)"}}>
           <div style={{fontSize:11,fontWeight:600,color:"var(--red)",marginBottom:6}}>✕ Stornos ({data.stornos.length})</div>
           {data.stornos.map((s,i)=><div key={i} style={{fontSize:11,display:"flex",justifyContent:"space-between",padding:"3px 0",borderTop:i>0?"1px dotted var(--brd)":"none"}}>
             <span style={{color:"var(--t2)"}}>{s.artikelNr} · {s.stornomenge}× · {s.stornogrund||"-"}</span>
             <span style={{color:"var(--t1)",fontWeight:600}}>-{fmtEurBest(s.stornoVkEur||0)}</span>
           </div>)}
         </div>}
       </div>}
       <table style={{width:"100%",fontSize:11,borderCollapse:"collapse"}}>
         <thead style={{background:"var(--s2)"}}><tr style={{color:"var(--t3)",textAlign:"left"}}>
           <th style={{padding:6}}>Artikel-Nr</th>
           <th style={{padding:6}}>p_nr</th>
           <th style={{padding:6}}>Produkt</th>
           <th style={{padding:6}}>Variante</th>
           <th style={{padding:6,textAlign:"right"}}>Menge</th>
           <th style={{padding:6,textAlign:"right"}}>VK</th>
           <th style={{padding:6,textAlign:"right"}}>Summe €</th>
         </tr></thead>
         <tbody>{data.positionen.map((p,i)=>{
           const linked=data.verknuepfung?.articles?.includes(p.artikelNr)||data.verknuepfung?.products?.includes(p.pnr);
           return<tr key={i} style={{borderBottom:"1px solid var(--brd)"}}>
             <td style={{padding:6,fontFamily:"monospace"}}><span style={{color:linked?"var(--green)":"var(--t3)"}}>{linked?"●":"○"}</span> {p.artikelNr}</td>
             <td style={{padding:6,fontFamily:"monospace",color:"var(--t2)"}}>{p.pnr||"-"}</td>
             <td style={{padding:6,color:"var(--t1)"}}>{p.produktname}</td>
             <td style={{padding:6,color:"var(--t2)"}}>{p.variante}</td>
             <td style={{padding:6,textAlign:"right"}}>{p.menge}</td>
             <td style={{padding:6,textAlign:"right",color:"var(--t2)"}}>{fmtEurBest(p.positionVk)}</td>
             <td style={{padding:6,textAlign:"right",fontWeight:600}}>{fmtEurBest(p.positionVkEur)}</td>
           </tr>;
         })}</tbody>
       </table>
       <div style={{fontSize:10,color:"var(--t3)"}}>● = verknüpft mit Artikeldatenbank, ○ = nicht verknüpft</div>
     </div>}
  </Modal>;
};

const BestellungenArtikel=()=>{
  const _yNow=new Date().getUTCFullYear();
  const [rows,setRows]=useState([]);
  const [total,setTotal]=useState(0);
  const [menge,setMenge]=useState(0);
  const [umsatz,setUmsatz]=useState(0);
  const [q,setQ]=useState("");
  const [from,setFrom]=useState(`${_yNow}-01-01`);
  const [to,setTo]=useState(`${_yNow}-12-31`);
  const [groupBy,setGroupBy]=useState("artikel");
  const [skip,setSkip]=useState(0);
  const [loading,setLoading]=useState(false);
  const [incStornos,setIncStornos]=useState(false);
  const [incRetouren,setIncRetouren]=useState(false);
  const [sortBy,setSortBy]=useState("umsatz");
  const [sortDir,setSortDir]=useState("desc");
  const [brand,setBrand]=useState("");
  const [marken,setMarken]=useState([]);
  const limit=100;
  const toggleSort=(f)=>{ if(sortBy===f) setSortDir(sortDir==="asc"?"desc":"asc"); else { setSortBy(f); setSortDir("desc"); } setSkip(0); };
  const sortArrow=(f)=>sortBy!==f?"":(sortDir==="asc"?" ▲":" ▼");
  const load=(fOv,tOv)=>{
    setLoading(true);
    const f=fOv!==undefined?fOv:from, t=tOv!==undefined?tOv:to;
    const p=new URLSearchParams();
    if(q)p.set("q",q); if(f)p.set("from",f); if(t)p.set("to",t);
    if(brand)p.set("brand",brand);
    if(incStornos)p.set("includeStornos","true");
    if(incRetouren)p.set("includeRetouren","true");
    p.set("sortBy",sortBy); p.set("sortDir",sortDir);
    p.set("groupBy",groupBy); p.set("limit",limit); p.set("skip",skip);
    const mp=new URLSearchParams(); if(f)mp.set("from",f); if(t)mp.set("to",t);
    Promise.all([
      fetch("/api/bestellungen/artikel?"+p).then(r=>r.json()),
      fetch("/api/bestellungen/marken?"+mp).then(r=>r.json()).catch(()=>({rows:[]})),
    ]).then(([d,m])=>{
      setRows(d.data||[]);setTotal(d.total||0);
      setMenge(d.mengeNetto!==undefined?d.mengeNetto:(d.menge||0));
      setUmsatz(d.umsatzEurNetto!==undefined?d.umsatzEurNetto:(d.umsatz||0));
      setMarken(m.rows||[]);
      setLoading(false);
    }).catch(()=>setLoading(false));
  };
  useEffect(()=>{load();},[skip,groupBy,incStornos,incRetouren,sortBy,sortDir,brand]);
  const search=(fOv,tOv)=>{setSkip(0);load(fOv,tOv);};
  return<div>
    <BestellungenHeader title="Verkaufte Artikel">
      <Tabs tabs={[{k:"artikel",l:"Je Artikel (a_nr)"},{k:"produkt",l:"Je Produkt (p_nr)"}]} active={groupBy} onChange={v=>{setGroupBy(v);setSkip(0);}}/>
    </BestellungenHeader>
    <div style={{marginBottom:12}}><DateRangeBar from={from} to={to} setFrom={setFrom} setTo={setTo} onApply={search}/></div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:12}}>
      <KPI title={groupBy==="produkt"?"Einzigartige Produkte":"Einzigartige Artikel"} value={total.toLocaleString("de-DE")} icon="▦"/>
      <KPI title={(incStornos||incRetouren)?"Verkaufte Stück":"Verkaufte Stück (netto)"} value={menge.toLocaleString("de-DE")} icon="◈"/>
      <KPI title={(incStornos||incRetouren)?"Umsatz":"Umsatz (netto)"} value={fmtEurBest(umsatz)} icon="€" accent="var(--green)"/>
    </div>
    <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"end"}}>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Marke ({marken.length})</label>
        <input list="artikel-marken-list" value={brand} onChange={e=>{setBrand(e.target.value);setSkip(0);}} placeholder="Suchen/Auswählen…" style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",minWidth:220}}/>
        <datalist id="artikel-marken-list">
          {marken.map(m=><option key={m.marke} value={m.marke}>{m.marke||"(ohne)"} – {m.menge} Stk</option>)}
        </datalist>
      </div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Suche (Artikel-Nr, p_nr, Produkt)</label><input value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&search()} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",width:280}}/></div>
      <Btn onClick={search}>Filtern</Btn>
      <Btn onClick={()=>{setQ("");setBrand("");setIncStornos(false);setIncRetouren(false);setSkip(0);setTimeout(load,0);}}>Reset</Btn>
      <label style={{display:"flex",alignItems:"center",gap:6,fontSize:11,color:"var(--t2)",cursor:"pointer",marginLeft:12}} title="Standard: Netto (abzgl. Stornos).">
        <input type="checkbox" checked={incStornos} onChange={e=>{setIncStornos(e.target.checked);setSkip(0);}}/> Stornos einbeziehen
      </label>
      <label style={{display:"flex",alignItems:"center",gap:6,fontSize:11,color:"var(--t2)",cursor:"pointer"}} title="Standard: Netto (abzgl. Retouren).">
        <input type="checkbox" checked={incRetouren} onChange={e=>{setIncRetouren(e.target.checked);setSkip(0);}}/> Retouren einbeziehen
      </label>
    </div>
    <div style={{background:"var(--s1)",borderRadius:8,overflow:"hidden",border:"1px solid var(--brd)"}}>
      <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
        <thead style={{background:"var(--s2)"}}><tr style={{color:"var(--t3)",fontSize:11,textAlign:"left"}}>
          <th style={{padding:"8px 10px",width:30}}></th>
          <th style={{padding:"8px 10px",width:140}}>Marke</th>
          <th style={{padding:"8px 10px"}}>{groupBy==="produkt"?"p_nr":"Artikel-Nr"}</th>
          <th style={{padding:"8px 10px"}}>{groupBy==="produkt"?"Herst-ArtNr":"p_nr (aus Herst-ArtNr)"}</th>
          <th style={{padding:"8px 10px"}}>Produktname</th>
          <th style={{padding:"8px 10px"}}>Variante</th>
          <th style={{padding:"8px 10px",textAlign:"right",cursor:"pointer",userSelect:"none"}} onClick={()=>toggleSort("menge")}>Stück{sortArrow("menge")}</th>
          <th style={{padding:"8px 10px",textAlign:"right",cursor:"pointer",userSelect:"none"}} onClick={()=>toggleSort("umsatz")}>Umsatz{sortArrow("umsatz")}</th>
          <th style={{padding:"8px 10px",textAlign:"right",cursor:"pointer",userSelect:"none"}} onClick={()=>toggleSort("stornoQuote")} title="Stornoquote">Storno%{sortArrow("stornoQuote")}</th>
          <th style={{padding:"8px 10px",textAlign:"right",cursor:"pointer",userSelect:"none"}} onClick={()=>toggleSort("retourQuote")} title="Retourenquote">Retour%{sortArrow("retourQuote")}</th>
          <th style={{padding:"8px 10px",textAlign:"center"}}>Kanäle</th>
        </tr></thead>
        <tbody>{loading?<tr><td colSpan={11} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</td></tr>:
          rows.length===0?<tr><td colSpan={11} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Artikel. Import starten.</td></tr>:
          rows.map((r,i)=>{
            const nr=groupBy==="produkt"?(r.pnr||r.herstArtNr):r.artikelNr;
            const linked=groupBy==="produkt"?!!r.produkt:!!r.artikel;
            const linkedName=groupBy==="produkt"?r.produkt?.name:r.artikel?.name;
            const mengeShow=r.mengeNetto!==undefined?r.mengeNetto:r.menge;
            const umsatzShow=r.umsatzEurNetto!==undefined?r.umsatzEurNetto:r.umsatzEur;
            return<tr key={i} style={{borderTop:"1px solid var(--brd)"}}>
              <td style={{padding:"8px 10px",textAlign:"center",color:linked?"var(--green)":"var(--t3)",fontSize:14}} title={linked?"Verknüpft mit Artikelstamm":"Kein Match in Artikelstamm"}>{linked?"●":"○"}</td>
              <td style={{padding:"8px 10px",color:"var(--t1)",fontWeight:600}}>{r.marke||<span style={{color:"var(--t3)",fontStyle:"italic",fontWeight:400}}>—</span>}</td>
              <td style={{padding:"8px 10px",fontFamily:"monospace",color:"var(--t1)"}}>{nr||"-"}{linkedName&&<div style={{fontSize:10,color:"var(--t3)",fontFamily:"inherit"}}>{linkedName}</div>}</td>
              <td style={{padding:"8px 10px",fontFamily:"monospace",color:"var(--t2)"}}>{r.herstArtNr||"-"}</td>
              <td style={{padding:"8px 10px",color:"var(--t1)"}}>{r.produktname}</td>
              <td style={{padding:"8px 10px",color:"var(--t2)"}}>{r.variante}</td>
              <td style={{padding:"8px 10px",textAlign:"right",fontWeight:600}} title={`Brutto: ${r.menge} · Storno: ${r.stornoMenge||0} · Retour: ${r.retourMenge||0}`}>{mengeShow}</td>
              <td style={{padding:"8px 10px",textAlign:"right",fontWeight:600,color:"var(--t1)"}} title={`Brutto: ${fmtEurBest(r.umsatzEur)}`}>{fmtEurBest(umsatzShow)}</td>
              <td style={{padding:"8px 10px",textAlign:"right",color:(r.stornoQuote||0)>20?"var(--red)":"var(--t2)",fontWeight:(r.stornoQuote||0)>20?600:400}}>{(r.stornoQuote||0).toFixed(1)}%</td>
              <td style={{padding:"8px 10px",textAlign:"right",color:(r.retourQuote||0)>40?"var(--red)":"var(--t2)",fontWeight:(r.retourQuote||0)>40?600:400}}>{(r.retourQuote||0).toFixed(1)}%</td>
              <td style={{padding:"8px 10px",textAlign:"center",fontSize:11,color:"var(--t2)"}} title={(r.kanaele||[]).join(", ")}>{(r.kanaele||[]).length}</td>
            </tr>;
          })}
        </tbody>
      </table>
    </div>
    <div style={{display:"flex",justifyContent:"space-between",marginTop:12,fontSize:11,color:"var(--t3)"}}>
      <div>{total>0&&<>{skip+1}–{Math.min(skip+limit,total)} von {total.toLocaleString("de-DE")}</>}</div>
      <div style={{display:"flex",gap:6}}>
        <Btn onClick={()=>setSkip(Math.max(0,skip-limit))} disabled={skip===0}>← Zurück</Btn>
        <Btn onClick={()=>setSkip(skip+limit)} disabled={skip+limit>=total}>Weiter →</Btn>
      </div>
    </div>
  </div>;
};

const BestellungenRetouren=()=>{
  const _yNow=new Date().getUTCFullYear();
  const [rows,setRows]=useState([]);
  const [total,setTotal]=useState(0);
  const [menge,setMenge]=useState(0);
  const [vk,setVk]=useState(0);
  const [q,setQ]=useState("");
  const [kanal,setKanal]=useState("");
  const [grund,setGrund]=useState("");
  const [from,setFrom]=useState(`${_yNow}-01-01`);
  const [to,setTo]=useState(`${_yNow}-12-31`);
  const [skip,setSkip]=useState(0);
  const [loading,setLoading]=useState(false);
  const limit=200;
  const load=(fOv,tOv)=>{
    setLoading(true);
    const f=fOv!==undefined?fOv:from, t=tOv!==undefined?tOv:to;
    const p=new URLSearchParams();
    if(q)p.set("q",q); if(kanal)p.set("kanal",kanal); if(grund)p.set("grund",grund);
    if(f)p.set("from",f); if(t)p.set("to",t);
    p.set("limit",limit); p.set("skip",skip);
    fetch("/api/bestellungen/retouren?"+p).then(r=>r.json()).then(d=>{
      setRows(d.data||[]);setTotal(d.total||0);setMenge(d.menge||0);setVk(d.vkEur||0);setLoading(false);
    }).catch(()=>setLoading(false));
  };
  useEffect(()=>{load();},[skip]);
  const search=(fOv,tOv)=>{setSkip(0);load(fOv,tOv);};
  return<div>
    <BestellungenHeader title="Retouren"/>
    <div style={{marginBottom:12}}><DateRangeBar from={from} to={to} setFrom={setFrom} setTo={setTo} onApply={search}/></div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:12}}>
      <KPI title="Retouren (Filter)" value={total.toLocaleString("de-DE")} icon="↩"/>
      <KPI title="Menge" value={menge.toLocaleString("de-DE")} icon="▦"/>
      <KPI title="Rücksendewert" value={fmtEurBest(vk)} icon="€" accent="var(--red)"/>
      <KPI title="Ø pro Retoure" value={total?fmtEurBest(vk/total):"-"} icon="∑"/>
    </div>
    <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"end"}}>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Suche</label><input value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&search()} placeholder="Auftrag / Artikel / Produkt" style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,width:240}}/></div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Kanal</label><input value={kanal} onChange={e=>setKanal(e.target.value)} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,width:160}}/></div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Grund</label><input value={grund} onChange={e=>setGrund(e.target.value)} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,width:180}}/></div>
      <Btn onClick={search}>Filtern</Btn>
      <Btn onClick={()=>{setQ("");setKanal("");setGrund("");setSkip(0);setTimeout(load,0);}}>Reset</Btn>
    </div>
    <div style={{background:"var(--s1)",borderRadius:8,overflow:"hidden",border:"1px solid var(--brd)"}}>
      <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
        <thead style={{background:"var(--s2)"}}><tr style={{color:"var(--t3)",fontSize:11,textAlign:"left"}}>
          <th style={{padding:"8px 10px"}}>Datum</th>
          <th style={{padding:"8px 10px"}}>Kanal</th>
          <th style={{padding:"8px 10px"}}>Auftrag-Nr</th>
          <th style={{padding:"8px 10px"}}>Artikel-Nr</th>
          <th style={{padding:"8px 10px"}}>Produkt</th>
          <th style={{padding:"8px 10px"}}>Variante</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Menge</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Betrag €</th>
          <th style={{padding:"8px 10px"}}>Grund</th>
          <th style={{padding:"8px 10px"}}>Retour-Code</th>
        </tr></thead>
        <tbody>{loading?<tr><td colSpan={10} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</td></tr>:
          rows.length===0?<tr><td colSpan={10} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Retouren.</td></tr>:
          rows.map((r,i)=><tr key={i} style={{borderTop:"1px solid var(--brd)"}}>
            <td style={{padding:"8px 10px",color:"var(--t2)"}}>{fmtDateBest(r.erstelldatum)}</td>
            <td style={{padding:"8px 10px",color:"var(--t1)"}}>{r.kanal}</td>
            <td style={{padding:"8px 10px",fontFamily:"monospace",color:"var(--t2)"}}>{r.auftragNr}</td>
            <td style={{padding:"8px 10px",fontFamily:"monospace",color:"var(--t1)"}}>{r.artikelNr}</td>
            <td style={{padding:"8px 10px",color:"var(--t1)"}}>{r.produktname}</td>
            <td style={{padding:"8px 10px",color:"var(--t2)"}}>{r.variante}</td>
            <td style={{padding:"8px 10px",textAlign:"right",fontWeight:600}}>{r.retourenmenge}</td>
            <td style={{padding:"8px 10px",textAlign:"right",fontWeight:600,color:"var(--red)"}}>{fmtEurBest(r.retourenVkEur)}</td>
            <td style={{padding:"8px 10px",color:"var(--t2)",fontSize:11}}>{r.retourengrund||"-"}</td>
            <td style={{padding:"8px 10px",fontFamily:"monospace",color:"var(--t3)",fontSize:11}}>{r.retourenCode||"-"}</td>
          </tr>)}
        </tbody>
      </table>
    </div>
    <div style={{display:"flex",justifyContent:"space-between",marginTop:12,fontSize:11,color:"var(--t3)"}}>
      <div>{total>0&&<>{skip+1}–{Math.min(skip+limit,total)} von {total.toLocaleString("de-DE")}</>}</div>
      <div style={{display:"flex",gap:6}}>
        <Btn onClick={()=>setSkip(Math.max(0,skip-limit))} disabled={skip===0}>← Zurück</Btn>
        <Btn onClick={()=>setSkip(skip+limit)} disabled={skip+limit>=total}>Weiter →</Btn>
      </div>
    </div>
  </div>;
};

const BestellungenStornos=()=>{
  const _yNow=new Date().getUTCFullYear();
  const [rows,setRows]=useState([]);
  const [total,setTotal]=useState(0);
  const [menge,setMenge]=useState(0);
  const [vk,setVk]=useState(0);
  const [q,setQ]=useState("");
  const [kanal,setKanal]=useState("");
  const [grund,setGrund]=useState("");
  const [from,setFrom]=useState(`${_yNow}-01-01`);
  const [to,setTo]=useState(`${_yNow}-12-31`);
  const [skip,setSkip]=useState(0);
  const [loading,setLoading]=useState(false);
  const limit=200;
  const load=(fOv,tOv)=>{
    setLoading(true);
    const f=fOv!==undefined?fOv:from, t=tOv!==undefined?tOv:to;
    const p=new URLSearchParams();
    if(q)p.set("q",q); if(kanal)p.set("kanal",kanal); if(grund)p.set("grund",grund);
    if(f)p.set("from",f); if(t)p.set("to",t);
    p.set("limit",limit); p.set("skip",skip);
    fetch("/api/bestellungen/stornos?"+p).then(r=>r.json()).then(d=>{
      setRows(d.data||[]);setTotal(d.total||0);setMenge(d.menge||0);setVk(d.vkEur||0);setLoading(false);
    }).catch(()=>setLoading(false));
  };
  useEffect(()=>{load();},[skip]);
  const search=(fOv,tOv)=>{setSkip(0);load(fOv,tOv);};
  return<div>
    <BestellungenHeader title="Stornos"/>
    <div style={{marginBottom:12}}><DateRangeBar from={from} to={to} setFrom={setFrom} setTo={setTo} onApply={search}/></div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:12}}>
      <KPI title="Stornos (Filter)" value={total.toLocaleString("de-DE")} icon="✕"/>
      <KPI title="Menge" value={menge.toLocaleString("de-DE")} icon="▦"/>
      <KPI title="Storno-Wert" value={fmtEurBest(vk)} icon="€" accent="var(--red)"/>
      <KPI title="Ø pro Storno" value={total?fmtEurBest(vk/total):"-"} icon="∑"/>
    </div>
    <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap",alignItems:"end"}}>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Suche</label><input value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&search()} placeholder="Auftrag / Artikel / Produkt" style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,width:240}}/></div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Kanal</label><input value={kanal} onChange={e=>setKanal(e.target.value)} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,width:160}}/></div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Grund</label><input value={grund} onChange={e=>setGrund(e.target.value)} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,width:180}}/></div>
      <Btn onClick={search}>Filtern</Btn>
      <Btn onClick={()=>{setQ("");setKanal("");setGrund("");setSkip(0);setTimeout(load,0);}}>Reset</Btn>
    </div>
    <div style={{background:"var(--s1)",borderRadius:8,overflow:"hidden",border:"1px solid var(--brd)"}}>
      <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
        <thead style={{background:"var(--s2)"}}><tr style={{color:"var(--t3)",fontSize:11,textAlign:"left"}}>
          <th style={{padding:"8px 10px"}}>Datum</th>
          <th style={{padding:"8px 10px"}}>Kanal</th>
          <th style={{padding:"8px 10px"}}>Auftrag-Nr</th>
          <th style={{padding:"8px 10px"}}>Artikel-Nr</th>
          <th style={{padding:"8px 10px"}}>Produkt</th>
          <th style={{padding:"8px 10px"}}>Variante</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Menge</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Betrag €</th>
          <th style={{padding:"8px 10px"}}>Grund</th>
        </tr></thead>
        <tbody>{loading?<tr><td colSpan={9} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</td></tr>:
          rows.length===0?<tr><td colSpan={9} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Stornos.</td></tr>:
          rows.map((r,i)=><tr key={i} style={{borderTop:"1px solid var(--brd)"}}>
            <td style={{padding:"8px 10px",color:"var(--t2)"}}>{fmtDateBest(r.erstelldatum)}</td>
            <td style={{padding:"8px 10px",color:"var(--t1)"}}>{r.kanal}</td>
            <td style={{padding:"8px 10px",fontFamily:"monospace",color:"var(--t2)"}}>{r.auftragNr}</td>
            <td style={{padding:"8px 10px",fontFamily:"monospace",color:"var(--t1)"}}>{r.artikelNr}</td>
            <td style={{padding:"8px 10px",color:"var(--t1)"}}>{r.produktname}</td>
            <td style={{padding:"8px 10px",color:"var(--t2)"}}>{r.variante}</td>
            <td style={{padding:"8px 10px",textAlign:"right",fontWeight:600}}>{r.stornomenge}</td>
            <td style={{padding:"8px 10px",textAlign:"right",fontWeight:600,color:"var(--red)"}}>{fmtEurBest(r.stornoVkEur)}</td>
            <td style={{padding:"8px 10px",color:"var(--t2)",fontSize:11}}>{r.stornogrund||"-"}</td>
          </tr>)}
        </tbody>
      </table>
    </div>
    <div style={{display:"flex",justifyContent:"space-between",marginTop:12,fontSize:11,color:"var(--t3)"}}>
      <div>{total>0&&<>{skip+1}–{Math.min(skip+limit,total)} von {total.toLocaleString("de-DE")}</>}</div>
      <div style={{display:"flex",gap:6}}>
        <Btn onClick={()=>setSkip(Math.max(0,skip-limit))} disabled={skip===0}>← Zurück</Btn>
        <Btn onClick={()=>setSkip(skip+limit)} disabled={skip+limit>=total}>Weiter →</Btn>
      </div>
    </div>
  </div>;
};

const BestellungenKanaele=()=>{
  const [data,setData]=useState({rows:[],total:{}});
  const [from,setFrom]=useState("");
  const [to,setTo]=useState("");
  const [loading,setLoading]=useState(false);
  const load=()=>{
    setLoading(true);
    const p=new URLSearchParams();
    if(from)p.set("from",from); if(to)p.set("to",to);
    fetch("/api/bestellungen/kanaele?"+p).then(r=>r.json()).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false));
  };
  useEffect(load,[]);
  const maxU=Math.max(1,...(data.rows||[]).map(r=>r.umsatz||0));
  return<div>
    <BestellungenHeader title="Kanäle"/>
    <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"end"}}>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Von</label><input type="date" value={from} onChange={e=>setFrom(e.target.value)} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12}}/></div>
      <div><label style={{fontSize:10,color:"var(--t3)",display:"block"}}>Bis</label><input type="date" value={to} onChange={e=>setTo(e.target.value)} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12}}/></div>
      <Btn onClick={load}>Filtern</Btn>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:12}}>
      <KPI title="Kanäle" value={(data.rows||[]).length} icon="◎"/>
      <KPI title="Aufträge" value={(data.total?.auftraege||0).toLocaleString("de-DE")} icon="◐"/>
      <KPI title="Positionen" value={(data.total?.positionen||0).toLocaleString("de-DE")} icon="▦"/>
      <KPI title="Umsatz" value={fmtEurBest(data.total?.umsatz)} icon="€" accent="var(--green)"/>
    </div>
    <div style={{background:"var(--s1)",borderRadius:8,overflow:"hidden",border:"1px solid var(--brd)"}}>
      <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
        <thead style={{background:"var(--s2)"}}><tr style={{color:"var(--t3)",fontSize:11,textAlign:"left"}}>
          <th style={{padding:"8px 10px"}}>Kanal</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Aufträge</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Positionen</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Stück</th>
          <th style={{padding:"8px 10px",textAlign:"right"}}>Umsatz</th>
          <th style={{padding:"8px 10px",width:200}}>Anteil</th>
        </tr></thead>
        <tbody>{loading?<tr><td colSpan={6} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</td></tr>:
          (data.rows||[]).map((r,i)=><tr key={i} style={{borderTop:"1px solid var(--brd)"}}>
            <td style={{padding:"8px 10px",color:"var(--t1)",fontWeight:500}}>{r.kanal}</td>
            <td style={{padding:"8px 10px",textAlign:"right",color:"var(--t2)"}}>{r.auftraege.toLocaleString("de-DE")}</td>
            <td style={{padding:"8px 10px",textAlign:"right",color:"var(--t2)"}}>{r.positionen.toLocaleString("de-DE")}</td>
            <td style={{padding:"8px 10px",textAlign:"right",color:"var(--t2)"}}>{r.menge.toLocaleString("de-DE")}</td>
            <td style={{padding:"8px 10px",textAlign:"right",fontWeight:600}}>{fmtEurBest(r.umsatz)}</td>
            <td style={{padding:"8px 10px"}}><div style={{height:8,background:"var(--s2)",borderRadius:4,overflow:"hidden"}}><div style={{height:"100%",width:(r.umsatz/maxU*100)+"%",background:"var(--acc)"}}/></div></td>
          </tr>)}
        </tbody>
      </table>
    </div>
  </div>;
};

/* ─── ZalandoRetouren ─── */
const ZalandoRetouren=()=>{
  const [returns,setReturns]=useState([]);
  const [total,setTotal]=useState(0);
  const [loading,setLoading]=useState(false);
  const [syncing,setSyncing]=useState(false);
  const [page,setPage]=useState(1);
  const [tab,setTab]=useState("announced");

  const load=()=>{
    setLoading(true);
    fetch(`/api/zalando/returns?page=${page}&limit=50`).then(r=>r.json()).then(d=>{
      setReturns(d.returns||[]);setTotal(d.total||0);setLoading(false);
    }).catch(()=>setLoading(false));
  };

  useEffect(()=>{if(tab==="announced")load();},[page,tab]);

  const syncNow=async()=>{
    setSyncing(true);
    await fetch("/api/zalando/returns/sync").then(r=>r.json()).catch(()=>{});
    setSyncing(false);load();
  };

  return<div style={{padding:20,maxWidth:1100}}>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
      <div style={{fontWeight:700,fontSize:16,color:"var(--t1)"}}>Zalando Retouren</div>
      <div style={{flex:1}}/>
      <button onClick={syncNow} disabled={syncing} style={{padding:"6px 14px",borderRadius:6,border:"none",background:"var(--acc)",color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>
        {syncing?"⏳ Sync…":"↻ Retouren laden"}
      </button>
    </div>

    <Tabs tabs={[{k:"announced",l:"Angekündigte Retouren"},{k:"zfs",l:"ZFS-Retouren"}]} active={tab} onChange={setTab}/>

    {tab==="announced"&&<>
      {loading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
      returns.length===0?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine angekündigten Retouren. Klick "↻ Retouren laden" um zu synchronisieren.</div>:
      <div style={{overflowX:"auto",marginTop:16}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)",textAlign:"left"}}>
            <th style={{padding:"6px 8px"}}>Retouren-ID</th>
            <th style={{padding:"6px 8px"}}>Bestellung</th>
            <th style={{padding:"6px 8px"}}>Status</th>
            <th style={{padding:"6px 8px"}}>Erstellt</th>
            <th style={{padding:"6px 8px"}}>Sync</th>
          </tr></thead>
          <tbody>
            {returns.map(r=>{
              const a=r.attributes||{};
              return<tr key={r.id} style={{borderBottom:"1px solid var(--brd)"}}
                onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"}
                onMouseLeave={e=>e.currentTarget.style.background=""}>
                <td style={{padding:"7px 8px",fontFamily:"monospace",fontSize:11,color:"var(--t2)"}}>{r.id}</td>
                <td style={{padding:"7px 8px",color:"var(--acc)"}}>{a.order_number||a.order_id||"–"}</td>
                <td style={{padding:"7px 8px"}}>
                  <span style={{padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600,background:"var(--purple)22",color:"var(--purple)"}}>
                    {a.return_status||a.status||"angekündigt"}
                  </span>
                </td>
                <td style={{padding:"7px 8px",color:"var(--t2)"}}>{fmtZalDate(a.created_at||a.created)}</td>
                <td style={{padding:"7px 8px",color:"var(--t3)",fontSize:11}}>{fmtZalDate(r.syncedAt)}</td>
              </tr>;
            })}
          </tbody>
        </table>
      </div>}
      {total>0&&<div style={{fontSize:12,color:"var(--t3)",marginTop:8,textAlign:"right"}}>{total} Retouren gesamt</div>}
    </>}

    {tab==="zfs"&&<ZalandoZFSRetouren/>}
  </div>;
};

/* ─── ZalandoZFSRetouren (Sub-Tab) ─── */
const ZalandoZFSRetouren=()=>{
  const [items,setItems]=useState([]);
  const [loading,setLoading]=useState(false);
  const [since,setSince]=useState(new Date(Date.now()-30*86400000).toISOString().split("T")[0]);

  const load=()=>{
    setLoading(true);
    fetch(`/api/zalando/zfs/returns?since=${since}`).then(r=>r.json()).then(d=>{
      setItems(Array.isArray(d)?d:[]);setLoading(false);
    }).catch(()=>setLoading(false));
  };
  useEffect(()=>{load();},[]);

  const iS={padding:"6px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  return<div style={{marginTop:16}}>
    <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:12}}>
      <span style={{fontSize:12,color:"var(--t2)"}}>Seit:</span>
      <input type="date" value={since} onChange={e=>setSince(e.target.value)} style={iS}/>
      <button onClick={load} style={{padding:"6px 12px",borderRadius:6,border:"none",background:"var(--acc)",color:"#fff",fontSize:12,cursor:"pointer"}}>Laden</button>
    </div>
    {loading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
    items.length===0?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine ZFS-Retouren im gewählten Zeitraum.</div>:
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
        <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)",textAlign:"left"}}>
          <th style={{padding:"6px 8px"}}>EAN</th>
          <th style={{padding:"6px 8px"}}>Qualität</th>
          <th style={{padding:"6px 8px"}}>Retourniert am</th>
          <th style={{padding:"6px 8px"}}>Destination</th>
        </tr></thead>
        <tbody>
          {items.map((item,i)=>{
            const a=item.attributes||{};
            const qual=a.quality_category||"–";
            const qualColor={A:"var(--grn)",B:"var(--ylw)",C:"#f97316",D:"var(--red)"}[qual]||"var(--t3)";
            return<tr key={i} style={{borderBottom:"1px solid var(--brd)"}}
              onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"}
              onMouseLeave={e=>e.currentTarget.style.background=""}>
              <td style={{padding:"7px 8px",fontFamily:"monospace",fontWeight:600}}>{a.ean||a.simple_sku||"–"}</td>
              <td style={{padding:"7px 8px"}}>
                <span style={{padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:700,background:qualColor+"22",color:qualColor}}>
                  Klasse {qual}
                </span>
              </td>
              <td style={{padding:"7px 8px",color:"var(--t2)"}}>{fmtZalDate(a.shipped_timestamp||a.returned_at)}</td>
              <td style={{padding:"7px 8px",color:"var(--t2)",fontSize:11}}>{a.destination||"–"}</td>
            </tr>;
          })}
        </tbody>
      </table>
    </div>}
  </div>;
};

/* ─── ZalandoSalesChannels ─── */
const ZalandoSalesChannels=()=>{
  const [channels,setChannels]=useState([]);
  const [loading,setLoading]=useState(false);
  const [syncing,setSyncing]=useState(false);

  const load=()=>{
    setLoading(true);
    // load from local DB via status endpoint
    fetch("/api/zalando/status").then(r=>r.json()).then(d=>{setLoading(false);}).catch(()=>setLoading(false));
  };

  const syncNow=async()=>{
    setSyncing(true);
    const data=await fetch("/api/zalando/sales-channels").then(r=>r.json()).catch(()=>[]);
    setChannels(Array.isArray(data)?data:[]);
    setSyncing(false);
  };

  return<div style={{padding:20,maxWidth:800}}>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
      <div style={{fontWeight:700,fontSize:16,color:"var(--t1)"}}>Sales Channels</div>
      <div style={{flex:1}}/>
      <button onClick={syncNow} disabled={syncing} style={{padding:"6px 14px",borderRadius:6,border:"none",background:"var(--acc)",color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>
        {syncing?"⏳ Lade…":"↻ Channels laden"}
      </button>
    </div>
    {channels.length===0&&<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>
      Klick "↻ Channels laden" um Sales Channels von Zalando abzurufen.<br/>
      <span style={{fontSize:11,marginTop:8,display:"block"}}>Hinweis: Verbindung muss unter Verwaltung → Schnittstellen konfiguriert sein.</span>
    </div>}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:12}}>
      {channels.map(ch=>{
        const a=ch.attributes||{};
        return<div key={ch.id} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:16}}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <div style={{fontSize:20}}>{a.country_code==="DE"?"🇩🇪":a.country_code==="AT"?"🇦🇹":a.country_code==="CH"?"🇨🇭":a.country_code==="FR"?"🇫🇷":a.country_code==="PL"?"🇵🇱":a.country_code==="NL"?"🇳🇱":"🌍"}</div>
            <div>
              <div style={{fontWeight:600,fontSize:13,color:"var(--t1)"}}>{a.country_name||a.country_code||ch.id}</div>
              <div style={{fontSize:10,color:"var(--t3)"}}>{a.country_code}</div>
            </div>
          </div>
          <div style={{fontSize:10,fontFamily:"monospace",color:"var(--t3)",wordBreak:"break-all",marginBottom:6}}>{ch.id}</div>
          <div style={{padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600,background:a.live?"var(--grn)22":"var(--t3)22",color:a.live?"var(--grn)":"var(--t3)",display:"inline-block"}}>
            {a.live?"● Live":"○ Inaktiv"}
          </div>
        </div>;
      })}
    </div>
  </div>;
};

/* ─── About You: shared helpers ─── */
const AY_STATUS_COLOR={draft:"var(--t3)",pending_approval:"var(--ylw)",rejected:"var(--red)",pending_active:"#f97316",active:"var(--grn)",inactive:"var(--t3)",problem:"var(--red)",open:"var(--ylw)",shipped:"var(--grn)",cancelled:"var(--red)",returned:"var(--purple)",mixed:"#f97316"};
const AY_STATUS_LABEL={draft:"Entwurf",pending_approval:"Prüfung",rejected:"Abgelehnt",pending_active:"Aktivierung",active:"Aktiv",inactive:"Inaktiv",problem:"Problem",open:"Offen",shipped:"Versendet",cancelled:"Storniert",returned:"Retourniert",mixed:"Gemischt"};
const fmtAYMoney=v=>v!=null?(v/100).toLocaleString("de-DE",{style:"currency",currency:"EUR"}):"–";
const fmtAYDate=d=>{if(!d)return"–";try{return new Date(d).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"});}catch{return d;}};

/* ─── AYDashboard ─── */
const AYDashboard=()=>{
  const [status,setStatus]=useState(null);
  const [loading,setLoading]=useState(true);
  const [syncing,setSyncing]=useState(false);

  const load=()=>{setLoading(true);fetch("/api/aboutyou/status").then(r=>r.json()).then(d=>{setStatus(d);setLoading(false);}).catch(()=>setLoading(false));};
  useEffect(()=>{load();},[]);

  const sync=async type=>{
    setSyncing(type);
    try{
      if(type==="orders")await fetch("/api/aboutyou/orders/sync").then(r=>r.json());
      if(type==="products")await fetch("/api/aboutyou/products/sync").then(r=>r.json());
    }catch(e){alert("Fehler: "+e.message);}
    setSyncing(false);load();
  };

  if(loading)return<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>;
  const connected=status?.connected;
  const sm=(status?.syncMeta||[]).reduce((a,m)=>{a[m.type]=m;return a;},{});

  return<div style={{padding:24,maxWidth:900}}>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:24}}>
      <div style={{fontSize:22,fontWeight:700,color:"var(--t1)"}}>About You Partner API</div>
      <div style={{padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:600,background:connected?"#16a34a22":"#dc262622",color:connected?"var(--grn)":"var(--red)"}}>
        {connected?"● Verbunden":"● Nicht verbunden"}
      </div>
    </div>

    {!connected&&<div style={{background:"#dc262611",border:"1px solid #dc262633",borderRadius:8,padding:16,marginBottom:24,color:"var(--t2)",fontSize:13}}>
      Keine Verbindung. Bitte unter <strong>Verwaltung → Schnittstellen → About You</strong> den API-Key eintragen.
      {status?.message&&<div style={{marginTop:6,color:"var(--red)",fontSize:12}}>{status.message}</div>}
    </div>}

    {connected&&<div style={{background:"var(--s2)",borderRadius:8,border:"1px solid var(--brd)",padding:16,marginBottom:24,fontSize:12,color:"var(--t2)"}}>
      <strong>Verbunden</strong> · {status.countriesCount} Länder/Märkte verfügbar &nbsp;|&nbsp;
      <strong>Webhook-URL:</strong> <code style={{fontSize:11}}>http://[server]:3000/api/aboutyou/webhook-receiver</code>
    </div>}

    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:16,marginBottom:24}}>
      {[
        {type:"orders",label:"Bestellungen",icon:"🛒",meta:sm.orders},
        {type:"products",label:"Produkte",icon:"👕",meta:sm.products},
      ].map(({type,label,icon,meta})=>
        <div key={type} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:16}}>
          <div style={{fontSize:22,marginBottom:6}}>{icon}</div>
          <div style={{fontWeight:600,fontSize:13,color:"var(--t1)",marginBottom:4}}>{label}</div>
          <div style={{fontSize:11,color:"var(--t3)",marginBottom:10}}>
            {meta?.lastSync?`Letzter Sync: ${fmtAYDate(meta.lastSync)}`:"Noch nie synchronisiert"}
            {meta?.total!==undefined&&` (${meta.total} gesamt)`}
          </div>
          <button onClick={()=>sync(type)} disabled={!connected||syncing===type}
            style={{padding:"5px 12px",borderRadius:6,border:"none",background:"var(--acc)",color:"#fff",fontSize:11,fontWeight:600,cursor:connected&&syncing!==type?"pointer":"not-allowed",opacity:!connected||syncing===type?0.5:1}}>
            {syncing===type?"⏳ Sync…":"↻ Sync"}
          </button>
        </div>
      )}
      <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:16}}>
        <div style={{fontSize:22,marginBottom:6}}>🔔</div>
        <div style={{fontWeight:600,fontSize:13,color:"var(--t1)",marginBottom:4}}>Webhooks</div>
        <div style={{fontSize:11,color:"var(--t3)",marginBottom:10}}>Echtzeit-Events von About You</div>
        <button onClick={()=>window.location.hash="aboutyou/webhooks"} style={{padding:"5px 12px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:11,cursor:"pointer"}}>
          Verwalten →
        </button>
      </div>
    </div>
    <div style={{fontSize:12,color:"var(--t3)"}}>
      Doku: <a href="https://docs.partner.aboutyou.com/api/getting-started" target="_blank" style={{color:"var(--acc)"}}>docs.partner.aboutyou.com</a> &nbsp;|&nbsp;
      OpenAPI: <a href="https://partner.aboutyou.com/api/v1/openapi.json" target="_blank" style={{color:"var(--acc)"}}>openapi.json</a>
    </div>
  </div>;
};

/* ─── AYBestellungen ─── */
const AYBestellungen=()=>{
  const [orders,setOrders]=useState([]);
  const [total,setTotal]=useState(0);
  const [page,setPage]=useState(1);
  const [search,setSearch]=useState("");
  const [status,setStatus]=useState("");
  const [loading,setLoading]=useState(false);
  const [syncing,setSyncing]=useState(false);
  const [detail,setDetail]=useState(null);
  const iS={padding:"6px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  const load=()=>{
    setLoading(true);
    const p=new URLSearchParams({page,limit:50});
    if(search)p.set("search",search);
    if(status)p.set("status",status);
    fetch(`/api/aboutyou/orders?${p}`).then(r=>r.json()).then(d=>{setOrders(d.orders||[]);setTotal(d.total||0);setLoading(false);}).catch(()=>setLoading(false));
  };
  useEffect(()=>{load();},[page,status]);

  const syncNow=async()=>{
    setSyncing(true);
    const p=new URLSearchParams({limit:100});
    if(status)p.set("status",status);
    await fetch(`/api/aboutyou/orders/sync?${p}`).then(r=>r.json()).catch(()=>{});
    setSyncing(false);load();
  };

  const statusOpts=[{v:"",l:"Alle"},{v:"open",l:"Offen"},{v:"shipped",l:"Versendet"},{v:"cancelled",l:"Storniert"},{v:"returned",l:"Retourniert"},{v:"mixed",l:"Gemischt"}];

  return<div style={{padding:20,maxWidth:1100}}>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16,flexWrap:"wrap"}}>
      <div style={{fontWeight:700,fontSize:16,color:"var(--t1)"}}>About You Bestellungen</div>
      <div style={{flex:1}}/>
      <input value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==="Enter"&&load()} placeholder="Bestellnr. / Kunde…" style={{...iS,width:180}}/>
      <select value={status} onChange={e=>{setStatus(e.target.value);setPage(1);}} style={iS}>
        {statusOpts.map(s=><option key={s.v} value={s.v}>{s.l}</option>)}
      </select>
      <button onClick={syncNow} disabled={syncing} style={{padding:"6px 14px",borderRadius:6,border:"none",background:"#e91e63",color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>
        {syncing?"⏳ Sync…":"↻ Von About You laden"}
      </button>
    </div>

    {loading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:<>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)",textAlign:"left"}}>
            <th style={{padding:"6px 8px"}}>Bestellnr.</th>
            <th style={{padding:"6px 8px"}}>Status</th>
            <th style={{padding:"6px 8px"}}>Erstellt</th>
            <th style={{padding:"6px 8px"}}>Betrag</th>
            <th style={{padding:"6px 8px"}}>Positionen</th>
            <th style={{padding:"6px 8px"}}>Kunde</th>
            <th style={{padding:"6px 8px"}}></th>
          </tr></thead>
          <tbody>
            {orders.length===0&&<tr><td colSpan={7} style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Bestellungen. Klick "↻ Von About You laden" um zu synchronisieren.</td></tr>}
            {orders.map(o=>{
              const st=o.status||"unknown";
              return<tr key={o.order_number} style={{borderBottom:"1px solid var(--brd)",cursor:"pointer"}}
                onClick={()=>setDetail(o)}
                onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"}
                onMouseLeave={e=>e.currentTarget.style.background=""}>
                <td style={{padding:"7px 8px",fontWeight:600,color:"#e91e63"}}>{o.order_number}</td>
                <td style={{padding:"7px 8px"}}>
                  <span style={{padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600,background:(AY_STATUS_COLOR[st]||"var(--t3)")+"22",color:AY_STATUS_COLOR[st]||"var(--t3)"}}>
                    {AY_STATUS_LABEL[st]||st}
                  </span>
                </td>
                <td style={{padding:"7px 8px",color:"var(--t2)"}}>{fmtAYDate(o.created_at)}</td>
                <td style={{padding:"7px 8px",fontWeight:600}}>{fmtAYMoney(o.cost_with_tax)}</td>
                <td style={{padding:"7px 8px",color:"var(--t2)"}}>{o.order_items?.length||0} Pos.</td>
                <td style={{padding:"7px 8px",color:"var(--t2)",fontSize:11}}>{o.billing_recipient_first_name} {o.billing_recipient_last_name}</td>
                <td style={{padding:"7px 8px",textAlign:"right"}}><span style={{color:"#e91e63",fontSize:11}}>Details →</span></td>
              </tr>;
            })}
          </tbody>
        </table>
      </div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:12,fontSize:12,color:"var(--t3)"}}>
        <span>{total} Bestellungen gesamt</span>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page<=1} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",cursor:"pointer",fontSize:11}}>‹</button>
          <span>Seite {page}</span>
          <button onClick={()=>setPage(p=>p+1)} disabled={orders.length<50} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",cursor:"pointer",fontSize:11}}>›</button>
        </div>
      </div>
    </>}

    {detail&&<div style={{position:"fixed",inset:0,background:"#0009",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={e=>{if(e.target===e.currentTarget)setDetail(null);}}>
      <div style={{background:"var(--bg)",borderRadius:10,border:"1px solid var(--brd)",width:660,maxHeight:"80vh",overflow:"auto",padding:24}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontWeight:700,fontSize:15,color:"var(--t1)"}}>Bestellung {detail.order_number}</div>
          <button onClick={()=>setDetail(null)} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:"var(--t3)"}}>✕</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:16,fontSize:12}}>
          {[
            ["Status",AY_STATUS_LABEL[detail.status]||detail.status],
            ["Erstellt",fmtAYDate(detail.created_at)],
            ["Betrag (brutto)",fmtAYMoney(detail.cost_with_tax)],
            ["Betrag (netto)",fmtAYMoney(detail.cost_without_tax)],
            ["Carrier",detail.carrier_key||"–"],
            ["Fulfillment",detail.fulfillment_type||"–"],
            ["Rechnungsempfänger",`${detail.billing_recipient_first_name||""} ${detail.billing_recipient_last_name||""}`],
            ["Lieferadresse",detail.shipping_city?`${detail.shipping_zip_code} ${detail.shipping_city}, ${detail.shipping_country_code}`:"= Rechnungsadresse"],
          ].map(([l,v])=>
            <div key={l} style={{background:"var(--s2)",borderRadius:6,padding:8}}>
              <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",marginBottom:2}}>{l}</div>
              <div style={{color:"var(--t1)"}}>{v}</div>
            </div>
          )}
        </div>
        {detail.order_items?.length>0&&<>
          <div style={{fontWeight:600,fontSize:12,color:"var(--t2)",marginBottom:8}}>Positionen ({detail.order_items.length})</div>
          {detail.order_items.map((item,i)=>
            <div key={i} style={{background:"var(--s2)",borderRadius:6,padding:10,marginBottom:6,fontSize:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{fontWeight:600,color:"var(--t1)"}}>{item.sku}</div>
                <div style={{color:"var(--t2)",marginTop:2,fontSize:11}}>
                  Status: <span style={{color:AY_STATUS_COLOR[item.status]||"var(--t3)"}}>{AY_STATUS_LABEL[item.status]||item.status}</span>
                  {item.shipment_tracking_key&&<> · Tracking: {item.shipment_tracking_key}</>}
                </div>
              </div>
              <div style={{fontWeight:600,fontSize:13}}>{fmtAYMoney(item.price_with_tax)}</div>
            </div>
          )}
        </>}
      </div>
    </div>}
  </div>;
};

/* ─── AYProdukte ─── */
const AYProdukte=()=>{
  const [products,setProducts]=useState([]);
  const [total,setTotal]=useState(0);
  const [page,setPage]=useState(1);
  const [search,setSearch]=useState("");
  const [status,setStatus]=useState("");
  const [loading,setLoading]=useState(false);
  const [syncing,setSyncing]=useState(false);
  const iS={padding:"6px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  const load=()=>{
    setLoading(true);
    const p=new URLSearchParams({page,limit:50});
    if(search)p.set("search",search);
    if(status)p.set("status",status);
    fetch(`/api/aboutyou/products?${p}`).then(r=>r.json()).then(d=>{setProducts(d.products||[]);setTotal(d.total||0);setLoading(false);}).catch(()=>setLoading(false));
  };
  useEffect(()=>{load();},[page,status]);

  const syncNow=async()=>{
    setSyncing(true);
    const p=new URLSearchParams({limit:100});
    if(status)p.set("status",status);
    await fetch(`/api/aboutyou/products/sync?${p}`).then(r=>r.json()).catch(()=>{});
    setSyncing(false);load();
  };

  const statusOpts=[{v:"",l:"Alle"},{v:"active",l:"Aktiv"},{v:"draft",l:"Entwurf"},{v:"pending_approval",l:"In Prüfung"},{v:"rejected",l:"Abgelehnt"},{v:"inactive",l:"Inaktiv"},{v:"problem",l:"Problem"}];

  const activeCount=products.filter(p=>p.status==="active").length;
  const problemCount=products.filter(p=>p.status==="problem"||p.status==="rejected").length;

  return<div style={{padding:20,maxWidth:1100}}>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16,flexWrap:"wrap"}}>
      <div style={{fontWeight:700,fontSize:16,color:"var(--t1)"}}>About You Produkte</div>
      <div style={{flex:1}}/>
      <input value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==="Enter"&&(setPage(1),load())} placeholder="SKU / Name…" style={{...iS,width:180}}/>
      <select value={status} onChange={e=>{setStatus(e.target.value);setPage(1);}} style={iS}>
        {statusOpts.map(s=><option key={s.v} value={s.v}>{s.l}</option>)}
      </select>
      <button onClick={syncNow} disabled={syncing} style={{padding:"6px 14px",borderRadius:6,border:"none",background:"#e91e63",color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>
        {syncing?"⏳ Sync…":"↻ Von About You laden"}
      </button>
    </div>

    {products.length>0&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10,marginBottom:16}}>
      {[{l:"Gesamt (Seite)",v:products.length},{l:"Aktiv",v:activeCount,c:"var(--grn)"},{l:"Probleme",v:problemCount,c:"var(--red)"},{l:"Gesamt DB",v:total}].map(({l,v,c})=>
        <div key={l} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:12}}>
          <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",marginBottom:2}}>{l}</div>
          <div style={{fontSize:20,fontWeight:700,color:c||"var(--t1)"}}>{v}</div>
        </div>
      )}
    </div>}

    {loading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
    products.length===0?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Produkte. Klick "↻ Von About You laden".</div>:
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
        <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)",textAlign:"left"}}>
          <th style={{padding:"6px 8px"}}>SKU</th>
          <th style={{padding:"6px 8px"}}>Style Key</th>
          <th style={{padding:"6px 8px"}}>Name</th>
          <th style={{padding:"6px 8px"}}>Status</th>
          <th style={{padding:"6px 8px",textAlign:"right"}}>Bestand</th>
          <th style={{padding:"6px 8px",textAlign:"right"}}>AY-Lager</th>
          <th style={{padding:"6px 8px"}}>Länder</th>
        </tr></thead>
        <tbody>
          {products.map(p=>{
            const st=p.status||"unknown";
            return<tr key={p.sku} style={{borderBottom:"1px solid var(--brd)"}}
              onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"}
              onMouseLeave={e=>e.currentTarget.style.background=""}>
              <td style={{padding:"7px 8px",fontFamily:"monospace",fontWeight:600,color:"var(--t1)"}}>{p.sku}</td>
              <td style={{padding:"7px 8px",color:"var(--t2)",fontSize:11}}>{p.style_key||"–"}</td>
              <td style={{padding:"7px 8px",color:"var(--t2)"}}>{p.name||"–"}</td>
              <td style={{padding:"7px 8px"}}>
                <span style={{padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600,background:(AY_STATUS_COLOR[st]||"var(--t3)")+"22",color:AY_STATUS_COLOR[st]||"var(--t3)"}}>
                  {AY_STATUS_LABEL[st]||st}
                </span>
              </td>
              <td style={{padding:"7px 8px",textAlign:"right",fontWeight:600}}>{p.quantity??"–"}</td>
              <td style={{padding:"7px 8px",textAlign:"right",color:"var(--t2)"}}>{p.quantity_fbm??"–"}</td>
              <td style={{padding:"7px 8px",color:"var(--t2)",fontSize:11}}>{(p.countries||[]).join(", ")||"–"}</td>
            </tr>;
          })}
        </tbody>
      </table>
    </div>}
    <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:10,fontSize:12}}>
      <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={page<=1} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",cursor:"pointer"}}>‹</button>
      <span style={{color:"var(--t3)"}}>Seite {page} · {total} gesamt</span>
      <button onClick={()=>setPage(p=>p+1)} disabled={products.length<50} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",cursor:"pointer"}}>›</button>
    </div>
  </div>;
};

/* ─── AYWebhooks ─── */
const AYWebhooks=()=>{
  const [subs,setSubs]=useState([]);
  const [events,setEvents]=useState([]);
  const [loading,setLoading]=useState(false);
  const [modal,setModal]=useState(false);
  const [form,setForm]=useState({url:"",description:"",events:[]});
  const [saving,setSaving]=useState(false);
  const [recentEvents,setRecentEvents]=useState([]);

  const iS={padding:"6px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",width:"100%"};
  const AY_EVENTS=["order.created","order.updated","order_items.shipped","order_items.cancelled","order_items.returned","stock.updated","product_master.status_updated"];

  const load=async()=>{
    setLoading(true);
    const [s,r]=await Promise.all([
      fetch("/api/aboutyou/webhooks").then(r=>r.json()).catch(()=>[]),
      fetch("/api/aboutyou/orders?limit=5").then(r=>r.json()).catch(()=>({orders:[]})),
    ]);
    setSubs(Array.isArray(s)?s:[]);
    setLoading(false);
  };
  useEffect(()=>{load();},[]);

  const save=async()=>{
    if(!form.url||!form.events.length)return alert("URL und mind. 1 Event erforderlich");
    setSaving(true);
    await fetch("/api/aboutyou/webhooks",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)}).then(r=>r.json()).catch(()=>{});
    setSaving(false);setModal(false);load();
  };

  const del=async id=>{
    if(!confirm("Webhook-Subscription löschen?"))return;
    await fetch(`/api/aboutyou/webhooks/${id}`,{method:"DELETE"}).catch(()=>{});
    load();
  };

  const toggleEvent=ev=>setForm(f=>({...f,events:f.events.includes(ev)?f.events.filter(e=>e!==ev):[...f.events,ev]}));

  return<div style={{padding:20,maxWidth:900}}>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
      <div style={{fontWeight:700,fontSize:16,color:"var(--t1)"}}>About You Webhooks</div>
      <div style={{flex:1}}/>
      <button onClick={()=>setModal(true)} style={{padding:"6px 14px",borderRadius:6,border:"none",background:"#e91e63",color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer"}}>+ Subscription</button>
    </div>

    <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:14,marginBottom:20,fontSize:12,color:"var(--t2)"}}>
      <strong>Webhook-Receiver URL:</strong>
      <code style={{marginLeft:8,background:"var(--bg)",padding:"2px 8px",borderRadius:4,fontSize:11}}>
        http://[dein-server]:3000/api/aboutyou/webhook-receiver
      </code>
      <div style={{marginTop:6,fontSize:11,color:"var(--t3)"}}>Diese URL bei About You als Webhook-Ziel eintragen. AY sendet Events stündlich mit Retry für 48h.</div>
    </div>

    {loading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
    subs.length===0?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Webhook-Subscriptions. Klick "+ Subscription" um eine anzulegen.</div>:
    <div style={{display:"grid",gap:10}}>
      {subs.map(s=>
        <div key={s.id} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:16,display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:16}}>
          <div style={{flex:1}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
              <span style={{padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600,background:s.enabled?"var(--grn)22":"var(--t3)22",color:s.enabled?"var(--grn)":"var(--t3)"}}>
                {s.enabled?"● Aktiv":"○ Inaktiv"}
              </span>
              <span style={{fontSize:12,color:"var(--t2)",fontWeight:600}}>{s.url}</span>
            </div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:4}}>
              {(s.events||[]).map(ev=><span key={ev} style={{padding:"1px 6px",borderRadius:4,fontSize:10,background:"#e91e6322",color:"#e91e63",border:"1px solid #e91e6333"}}>{ev}</span>)}
            </div>
            {s.description&&<div style={{fontSize:11,color:"var(--t3)"}}>{s.description}</div>}
          </div>
          <button onClick={()=>del(s.id)} style={{padding:"4px 10px",borderRadius:6,border:"1px solid var(--red)",background:"none",color:"var(--red)",fontSize:11,cursor:"pointer",flexShrink:0}}>✕ Löschen</button>
        </div>
      )}
    </div>}

    {modal&&<div style={{position:"fixed",inset:0,background:"#0009",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={e=>{if(e.target===e.currentTarget)setModal(false);}}>
      <div style={{background:"var(--bg)",borderRadius:10,border:"1px solid var(--brd)",width:520,padding:24}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontWeight:700,fontSize:15}}>Neue Webhook-Subscription</div>
          <button onClick={()=>setModal(false)} style={{background:"none",border:"none",fontSize:18,cursor:"pointer",color:"var(--t3)"}}>✕</button>
        </div>
        <div style={{display:"grid",gap:12}}>
          <div><div style={{fontSize:11,color:"var(--t3)",fontWeight:600,marginBottom:4}}>WEBHOOK URL</div>
            <input value={form.url} onChange={e=>setForm(f=>({...f,url:e.target.value}))} placeholder="https://..." style={iS}/>
          </div>
          <div><div style={{fontSize:11,color:"var(--t3)",fontWeight:600,marginBottom:4}}>BESCHREIBUNG (optional)</div>
            <input value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} style={iS}/>
          </div>
          <div><div style={{fontSize:11,color:"var(--t3)",fontWeight:600,marginBottom:8}}>EVENTS</div>
            <div style={{display:"grid",gap:6}}>
              {AY_EVENTS.map(ev=><label key={ev} style={{display:"flex",alignItems:"center",gap:8,fontSize:12,cursor:"pointer"}}>
                <input type="checkbox" checked={form.events.includes(ev)} onChange={()=>toggleEvent(ev)} style={{cursor:"pointer"}}/>
                <span style={{color:form.events.includes(ev)?"#e91e63":"var(--t2)"}}>{ev}</span>
              </label>)}
            </div>
          </div>
          <button onClick={save} disabled={saving} style={{padding:"8px",borderRadius:6,border:"none",background:"#e91e63",color:"#fff",fontSize:13,fontWeight:600,cursor:"pointer",marginTop:4}}>
            {saving?"⏳ Speichere…":"Subscription anlegen"}
          </button>
        </div>
      </div>
    </div>}
  </div>;
};

/* ─── Shops: Helper ─── */
const SHOP_STATUS_COLOR={aktiv:"var(--grn)",inaktiv:"var(--t3)",wartung:"var(--ylw)"};
const SHOP_STATUS_LABEL={aktiv:"Aktiv",inaktiv:"Inaktiv",wartung:"Wartung"};
const CONNECTOR_TYPES=[{v:"medusa",l:"Medusa"},{v:"shopware",l:"Shopware"},{v:"custom",l:"Custom"}];
const SPRACHEN=[{v:"de",l:"Deutsch"},{v:"en",l:"English"},{v:"fr",l:"Français"},{v:"es",l:"Español"}];
const WAEHRUNGEN=[{v:"EUR",l:"EUR €"},{v:"CHF",l:"CHF ₣"},{v:"GBP",l:"GBP £"}];
const ZEITZONEN=["Europe/Berlin","Europe/Zurich","Europe/London","America/New_York","Asia/Tokyo"];
const COUPON_TYPEN=[{v:"prozent",l:"Prozent (%)"},{v:"fest",l:"Fester Betrag (€)"},{v:"versandkostenfrei",l:"Versandkostenfrei"}];
const genCode=()=>{const c="ABCDEFGHJKLMNPQRSTUVWXYZ23456789";let s="";for(let i=0;i<8;i++)s+=c[Math.floor(Math.random()*c.length)];return s;};

/* ─── ShopFormModal ─── */
const ShopFormModal=({shop,onClose,onSaved})=>{
  const emptyForm={name:"",beschreibung:"",status:"aktiv",domain:"",sprache:"de",waehrung:"EUR",zeitzone:"Europe/Berlin",logo:"",
    connector:{typ:"medusa",endpoint:"",apiKey:""},
    zahlungsanbieter:{stripe:{aktiv:false,publicKey:"",secretKey:"",webhookSecret:"",modus:"test"},paypal:{aktiv:false,clientId:"",clientSecret:"",modus:"sandbox"}},
    versand:{kostenlosAb:0,zonen:[]},
    steuern:{standard:19,reduziert:7,land:"DE"},
    scx:{channelId:"",apiKey:"",sellerId:"",endpoint:"",aktiv:false},
  };
  const [form,setForm]=useState(shop?{...emptyForm,...shop}:{...emptyForm});
  const [tab,setTab]=useState("basis");
  const [saving,setSaving]=useState(false);
  const sf=(path,val)=>setForm(f=>{
    const keys=path.split(".");
    if(keys.length===1)return{...f,[keys[0]]:val};
    if(keys.length===2)return{...f,[keys[0]]:{...f[keys[0]],[keys[1]]:val}};
    if(keys.length===3)return{...f,[keys[0]]:{...f[keys[0]],[keys[1]]:{...f[keys[0]][keys[1]],[keys[2]]:val}}};
    return f;
  });
  const addZone=()=>sf("versand.zonen",[...(form.versand.zonen||[]),{name:"",laender:"",preis:0}]);
  const updZone=(i,k,v)=>sf("versand.zonen",(form.versand.zonen||[]).map((z,idx)=>idx===i?{...z,[k]:v}:z));
  const delZone=i=>sf("versand.zonen",(form.versand.zonen||[]).filter((_,idx)=>idx!==i));
  const save=async()=>{
    setSaving(true);
    const method=shop?"PUT":"POST";
    const url=shop?`/api/shops/${shop._id}`:"/api/shops";
    await fetch(url,{method,headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    setSaving(false);onSaved();onClose();
  };
  const iS={padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",width:"100%"};
  const lS={fontSize:11,color:"var(--t2)",display:"block",marginBottom:3,fontWeight:500};
  const fG={display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px"};
  return<CrmModal title={shop?"Shop bearbeiten":"Neuer Shop"} onClose={onClose} wide>
    <div style={{marginBottom:14}}>
      <Tabs tabs={[{k:"basis",l:"Basisdaten"},{k:"connector",l:"Connector"},{k:"zahlung",l:"Zahlungsanbieter"},{k:"versand",l:"Versand & Steuern"},{k:"scx",l:"JTL SCX"}]} active={tab} onChange={setTab}/>
    </div>
    {tab==="basis"&&<div style={fG}>
      <div style={{gridColumn:"1/-1"}}><Inp label="Shop-Name" value={form.name} onChange={v=>sf("name",v)} required/></div>
      <div style={{gridColumn:"1/-1"}}><Inp label="Beschreibung" value={form.beschreibung} onChange={v=>sf("beschreibung",v)}/></div>
      <Inp label="Domain" value={form.domain} onChange={v=>sf("domain",v)} placeholder="https://www.meinshop.de" required/>
      <Inp label="Logo-URL" value={form.logo} onChange={v=>sf("logo",v)} placeholder="https://..."/>
      <Sel label="Sprache" value={form.sprache} onChange={v=>sf("sprache",v)} opts={SPRACHEN}/>
      <Sel label="Währung" value={form.waehrung} onChange={v=>sf("waehrung",v)} opts={WAEHRUNGEN}/>
      <div style={{marginBottom:12}}><label style={lS}>Zeitzone</label><select value={form.zeitzone||""} onChange={e=>sf("zeitzone",e.target.value)} style={iS}>{ZEITZONEN.map(z=><option key={z} value={z}>{z}</option>)}</select></div>
      <div style={{marginBottom:12}}><label style={lS}>Status</label><select value={form.status||"aktiv"} onChange={e=>sf("status",e.target.value)} style={iS}><option value="aktiv">Aktiv</option><option value="inaktiv">Inaktiv</option><option value="wartung">Wartung</option></select></div>
    </div>}
    {tab==="connector"&&<div style={fG}>
      <div style={{gridColumn:"1/-1"}}><Sel label="Connector-Typ" value={form.connector?.typ} onChange={v=>sf("connector.typ",v)} opts={CONNECTOR_TYPES}/></div>
      <div style={{gridColumn:"1/-1"}}><Inp label="API-Endpoint" value={form.connector?.endpoint} onChange={v=>sf("connector.endpoint",v)} placeholder="https://api.meinshop.de"/></div>
      <div style={{gridColumn:"1/-1"}}><Inp label="API-Key" value={form.connector?.apiKey} onChange={v=>sf("connector.apiKey",v)} type="password" placeholder="••••••••"/></div>
    </div>}
    {tab==="zahlung"&&<div>
      <div style={{background:"var(--s2)",borderRadius:8,padding:"12px 14px",marginBottom:12}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <span style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>Stripe</span>
          <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:12,color:"var(--t2)"}}>
            <input type="checkbox" checked={!!form.zahlungsanbieter?.stripe?.aktiv} onChange={e=>sf("zahlungsanbieter.stripe.aktiv",e.target.checked)}/> Aktiviert
          </label>
        </div>
        {form.zahlungsanbieter?.stripe?.aktiv&&<div style={fG}>
          <Inp label="Public Key" value={form.zahlungsanbieter.stripe.publicKey} onChange={v=>sf("zahlungsanbieter.stripe.publicKey",v)} placeholder="pk_..."/>
          <Inp label="Secret Key" value={form.zahlungsanbieter.stripe.secretKey} onChange={v=>sf("zahlungsanbieter.stripe.secretKey",v)} type="password" placeholder="sk_..."/>
          <Inp label="Webhook Secret" value={form.zahlungsanbieter.stripe.webhookSecret} onChange={v=>sf("zahlungsanbieter.stripe.webhookSecret",v)} type="password" placeholder="whsec_..."/>
          <div style={{marginBottom:12}}><label style={lS}>Modus</label><select value={form.zahlungsanbieter.stripe.modus||"test"} onChange={e=>sf("zahlungsanbieter.stripe.modus",e.target.value)} style={iS}><option value="test">Test</option><option value="live">Live</option></select></div>
        </div>}
      </div>
      <div style={{background:"var(--s2)",borderRadius:8,padding:"12px 14px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <span style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>PayPal</span>
          <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:12,color:"var(--t2)"}}>
            <input type="checkbox" checked={!!form.zahlungsanbieter?.paypal?.aktiv} onChange={e=>sf("zahlungsanbieter.paypal.aktiv",e.target.checked)}/> Aktiviert
          </label>
        </div>
        {form.zahlungsanbieter?.paypal?.aktiv&&<div style={fG}>
          <Inp label="Client ID" value={form.zahlungsanbieter.paypal.clientId} onChange={v=>sf("zahlungsanbieter.paypal.clientId",v)} placeholder="AYxx..."/>
          <Inp label="Client Secret" value={form.zahlungsanbieter.paypal.clientSecret} onChange={v=>sf("zahlungsanbieter.paypal.clientSecret",v)} type="password" placeholder="••••••••"/>
          <div style={{marginBottom:12}}><label style={lS}>Modus</label><select value={form.zahlungsanbieter.paypal.modus||"sandbox"} onChange={e=>sf("zahlungsanbieter.paypal.modus",e.target.value)} style={iS}><option value="sandbox">Sandbox</option><option value="live">Live</option></select></div>
        </div>}
      </div>
    </div>}
    {tab==="versand"&&<div>
      <div style={fG}>
        <Inp label="Kostenloser Versand ab (€)" value={form.versand?.kostenlosAb} onChange={v=>sf("versand.kostenlosAb",Number(v))} type="number"/>
        <div/>
        <Inp label="Steuersatz Standard (%)" value={form.steuern?.standard} onChange={v=>sf("steuern.standard",Number(v))} type="number"/>
        <Inp label="Steuersatz Reduziert (%)" value={form.steuern?.reduziert} onChange={v=>sf("steuern.reduziert",Number(v))} type="number"/>
        <div style={{gridColumn:"1/-1"}}><Inp label="Steuerland" value={form.steuern?.land} onChange={v=>sf("steuern.land",v)} placeholder="DE"/></div>
      </div>
      <div style={{marginTop:8}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <span style={{fontSize:12,fontWeight:600,color:"var(--t2)",textTransform:"uppercase",letterSpacing:".5px"}}>Versandzonen</span>
          <Btn small onClick={addZone}>+ Zone</Btn>
        </div>
        {(form.versand?.zonen||[]).map((z,i)=><div key={i} style={{display:"grid",gridTemplateColumns:"1fr 1fr 80px 28px",gap:6,marginBottom:6,alignItems:"end"}}>
          <div><label style={lS}>Name</label><input value={z.name||""} onChange={e=>updZone(i,"name",e.target.value)} style={iS} placeholder="Europa"/></div>
          <div><label style={lS}>Länder</label><input value={z.laender||""} onChange={e=>updZone(i,"laender",e.target.value)} style={iS} placeholder="DE,AT,CH"/></div>
          <div><label style={lS}>Preis €</label><input type="number" value={z.preis||0} onChange={e=>updZone(i,"preis",Number(e.target.value))} style={iS}/></div>
          <Btn small onClick={()=>delZone(i)} style={{color:"var(--red)"}}>✕</Btn>
        </div>)}
        {!(form.versand?.zonen||[]).length&&<div style={{fontSize:12,color:"var(--t3)",padding:"8px 0"}}>Keine Zonen definiert</div>}
      </div>
    </div>}
    {tab==="scx"&&<div style={fG}>
      <div style={{gridColumn:"1/-1",display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
        <span style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>JTL SCX Konfiguration</span>
        <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer",fontSize:12,color:"var(--t2)"}}>
          <input type="checkbox" checked={!!form.scx?.aktiv} onChange={e=>sf("scx.aktiv",e.target.checked)}/> Aktiviert
        </label>
      </div>
      <Inp label="Channel ID" value={form.scx?.channelId} onChange={v=>sf("scx.channelId",v)} placeholder="ch_..."/>
      <Inp label="Seller ID" value={form.scx?.sellerId} onChange={v=>sf("scx.sellerId",v)} placeholder="sel_..."/>
      <div style={{gridColumn:"1/-1"}}><Inp label="API-Key" value={form.scx?.apiKey} onChange={v=>sf("scx.apiKey",v)} type="password" placeholder="••••••••"/></div>
      <div style={{gridColumn:"1/-1"}}><Inp label="Endpoint-URL" value={form.scx?.endpoint} onChange={v=>sf("scx.endpoint",v)} placeholder="https://scx.jtl-software.com/api/v1"/></div>
    </div>}
    <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:10,borderTop:"1px solid var(--brd)",marginTop:8}}>
      <Btn onClick={onClose}>Abbrechen</Btn>
      <Btn primary onClick={save} disabled={saving||!form.name||!form.domain}>{saving?"Speichere…":"Speichern"}</Btn>
    </div>
  </CrmModal>;
};

/* ─── ShopsUebersicht ─── */
const ShopsUebersicht=()=>{
  const [shops,setShops]=useState([]);
  const [modal,setModal]=useState(null);
  const load=()=>fetch("/api/shops").then(r=>r.json()).then(d=>setShops(Array.isArray(d)?d:[])).catch(()=>{});
  useEffect(()=>{load();},[]);
  const del=async id=>{if(!confirm("Shop wirklich löschen?"))return;await fetch(`/api/shops/${id}`,{method:"DELETE"});load();};
  return<>
    <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
      <Btn primary onClick={()=>setModal("add")}>+ Shop anlegen</Btn>
    </div>
    {shops.length===0&&<EmptyState icon="◈" title="Keine Shops konfiguriert" sub="Lege deinen ersten Shop an"/>}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(320px,1fr))",gap:14}}>
      {shops.map(s=><Card key={s._id} style={{padding:0,overflow:"hidden"}}>
        <div style={{padding:"14px 16px",borderBottom:"1px solid var(--brd)",display:"flex",alignItems:"center",gap:10}}>
          {s.logo?<img src={s.logo} alt="" style={{width:32,height:32,borderRadius:6,objectFit:"contain",background:"var(--s2)"}}/>:<div style={{width:32,height:32,borderRadius:6,background:"var(--s2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,color:"var(--t3)"}}>◈</div>}
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:14,fontWeight:700,color:"var(--t1)",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{s.name}</div>
            <div style={{fontSize:11,color:"var(--t3)",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{s.domain||"–"}</div>
          </div>
          <span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:700,background:(SHOP_STATUS_COLOR[s.status]||"var(--t3)")+"22",color:SHOP_STATUS_COLOR[s.status]||"var(--t3)"}}>{SHOP_STATUS_LABEL[s.status]||s.status}</span>
        </div>
        <div style={{padding:"10px 16px",display:"flex",gap:16}}>
          <div style={{flex:1}}>
            <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",marginBottom:3}}>Connector</div>
            <div style={{fontSize:12,color:"var(--t2)"}}>{CONNECTOR_TYPES.find(c=>c.v===s.connector?.typ)?.l||"–"}</div>
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",marginBottom:3}}>Währung</div>
            <div style={{fontSize:12,color:"var(--t2)"}}>{s.waehrung||"–"}</div>
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",marginBottom:3}}>SCX</div>
            <div style={{display:"flex",alignItems:"center",gap:4}}><Dot s={s.scx?.aktiv?"connected":"inactive"}/><span style={{fontSize:12,color:"var(--t2)"}}>{s.scx?.aktiv?"Aktiv":"Inaktiv"}</span></div>
          </div>
        </div>
        <div style={{padding:"8px 16px",borderTop:"1px solid var(--brd)",display:"flex",gap:6,justifyContent:"flex-end"}}>
          <Btn small onClick={()=>setModal(s)}>Bearbeiten</Btn>
          <Btn small onClick={()=>del(s._id)} style={{color:"var(--red)"}}>Löschen</Btn>
        </div>
      </Card>)}
    </div>
    {modal&&<ShopFormModal shop={modal==="add"?null:modal} onClose={()=>setModal(null)} onSaved={load}/>}
  </>;
};

/* ─── ShopKategorien ─── */
const ShopKategorien=()=>{
  const [shops,setShops]=useState([]);
  const [shopId,setShopId]=useState("");
  const [kats,setKats]=useState([]);
  const [editId,setEditId]=useState(null);
  const [editForm,setEditForm]=useState({});
  const [addParent,setAddParent]=useState(null);
  const [addForm,setAddForm]=useState({name:"",slug:"",jtlKategorieId:"",aktiv:true});
  const [showAddTop,setShowAddTop]=useState(false);
  const iS={padding:"6px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};
  useEffect(()=>{fetch("/api/shops").then(r=>r.json()).then(d=>{const s=Array.isArray(d)?d:[];setShops(s);if(s.length)setShopId(s[0]._id);}).catch(()=>{});},[]);
  const loadKats=()=>{if(!shopId)return;fetch(`/api/shops/${shopId}/kategorien`).then(r=>r.json()).then(d=>setKats(Array.isArray(d)?d:[])).catch(()=>{});};
  useEffect(()=>{loadKats();},[shopId]);
  const slugify=n=>n.toLowerCase().replace(/\s+/g,"-").replace(/[^a-z0-9-]/g,"");
  const saveAdd=async(parentId)=>{
    const doc={...addForm,slug:addForm.slug||slugify(addForm.name),sortierung:0,aktiv:true};
    if(parentId)doc.parentId=parentId;
    await fetch(`/api/shops/${shopId}/kategorien`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(doc)});
    setAddForm({name:"",slug:"",jtlKategorieId:"",aktiv:true});setShowAddTop(false);setAddParent(null);loadKats();
  };
  const saveEdit=async()=>{
    await fetch(`/api/shops/kategorien/${editId}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(editForm)});
    setEditId(null);loadKats();
  };
  const del=async id=>{if(!confirm("Kategorie löschen?"))return;await fetch(`/api/shops/kategorien/${id}`,{method:"DELETE"});loadKats();};
  const roots=kats.filter(k=>!k.parentId);
  const children=pid=>kats.filter(k=>k.parentId&&k.parentId.toString()===pid.toString());
  const AddForm=({parentId})=><div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto auto",gap:6,alignItems:"end",padding:"6px 0"}}>
    <input value={addForm.name} onChange={e=>setAddForm(f=>({...f,name:e.target.value}))} placeholder="Name" style={iS}/>
    <input value={addForm.slug} onChange={e=>setAddForm(f=>({...f,slug:e.target.value}))} placeholder="slug (auto)" style={iS}/>
    <input value={addForm.jtlKategorieId||""} onChange={e=>setAddForm(f=>({...f,jtlKategorieId:e.target.value}))} placeholder="JTL Kategorie-ID" style={iS}/>
    <Btn small primary onClick={()=>saveAdd(parentId)} disabled={!addForm.name}>Speichern</Btn>
    <Btn small onClick={()=>{setShowAddTop(false);setAddParent(null);}}>✕</Btn>
  </div>;
  const KatRow=({k,depth})=>{
    const isEdit=editId===k._id;
    return<>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 60px auto",gap:6,alignItems:"center",padding:"7px 0",paddingLeft:depth*20,borderBottom:"1px solid var(--brd)"}}>
        {isEdit?<>
          <input value={editForm.name||""} onChange={e=>setEditForm(f=>({...f,name:e.target.value}))} style={iS}/>
          <input value={editForm.slug||""} onChange={e=>setEditForm(f=>({...f,slug:e.target.value}))} style={iS}/>
          <input value={editForm.jtlKategorieId||""} onChange={e=>setEditForm(f=>({...f,jtlKategorieId:e.target.value}))} placeholder="JTL ID" style={iS}/>
          <label style={{display:"flex",alignItems:"center",gap:4,fontSize:11,color:"var(--t2)",cursor:"pointer"}}>
            <input type="checkbox" checked={!!editForm.aktiv} onChange={e=>setEditForm(f=>({...f,aktiv:e.target.checked}))}/>Aktiv
          </label>
          <div style={{display:"flex",gap:4}}>
            <Btn small primary onClick={saveEdit}>✓</Btn>
            <Btn small onClick={()=>setEditId(null)}>✕</Btn>
          </div>
        </>:<>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:12,fontWeight:depth===0?600:400,color:"var(--t1)"}}>{k.name}</span>
            {!k.aktiv&&<span style={{fontSize:9,color:"var(--t3)",background:"var(--s2)",padding:"1px 4px",borderRadius:3}}>inaktiv</span>}
          </div>
          <span style={{fontSize:11,color:"var(--t3)"}}>{k.slug||"–"}</span>
          <div style={{display:"flex",alignItems:"center",gap:4}}>
            <Dot s={k.jtlKategorieId?"connected":"inactive"}/>
            <span style={{fontSize:11,color:k.jtlKategorieId?"var(--grn)":"var(--t3)"}}>{k.jtlKategorieId||"kein JTL-Match"}</span>
          </div>
          <span/>
          <div style={{display:"flex",gap:4}}>
            <Btn small onClick={()=>{setAddParent(k._id);setAddForm({name:"",slug:"",jtlKategorieId:"",aktiv:true});}}>+ Sub</Btn>
            <Btn small onClick={()=>{setEditId(k._id);setEditForm({...k});}}>Edit</Btn>
            <Btn small onClick={()=>del(k._id)} style={{color:"var(--red)"}}>✕</Btn>
          </div>
        </>}
      </div>
      {addParent&&addParent.toString()===k._id.toString()&&<div style={{paddingLeft:(depth+1)*20}}><AddForm parentId={k._id}/></div>}
      {children(k._id).map(c=><KatRow key={c._id} k={c} depth={depth+1}/>)}
    </>;
  };
  return<>
    <div style={{display:"flex",gap:10,marginBottom:16,alignItems:"center"}}>
      <select value={shopId} onChange={e=>setShopId(e.target.value)} style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}>
        {shops.map(s=><option key={s._id} value={s._id}>{s.name}</option>)}
      </select>
      <Btn primary onClick={()=>{setShowAddTop(true);setAddParent(null);setAddForm({name:"",slug:"",jtlKategorieId:"",aktiv:true});}}>+ Hauptkategorie</Btn>
    </div>
    {!shopId&&<EmptyState icon="◈" title="Kein Shop ausgewählt" sub="Bitte zuerst einen Shop anlegen"/>}
    {shopId&&<Card style={{padding:"0 14px"}}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 60px auto",gap:6,padding:"8px 0",borderBottom:"1px solid var(--brd)"}}>
        {["Name","Slug","JTL-ID","","Aktionen"].map(h=><span key={h} style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>{h}</span>)}
      </div>
      {showAddTop&&<AddForm parentId={null}/>}
      {roots.length===0&&!showAddTop&&<EmptyState icon="◈" title="Keine Kategorien" sub="Klicke + Hauptkategorie"/>}
      {roots.map(k=><KatRow key={k._id} k={k} depth={0}/>)}
    </Card>}
  </>;
};

/* ─── ShopCoupons ─── */
const ShopCoupons=()=>{
  const [shops,setShops]=useState([]);
  const [shopId,setShopId]=useState("");
  const [coupons,setCoupons]=useState([]);
  const [modal,setModal]=useState(null);
  const emptyForm={code:"",typ:"prozent",wert:10,mindestbestellwert:0,gueltigBis:"",maxNutzungen:0,aktiv:true};
  const [form,setForm]=useState({...emptyForm});
  const [saving,setSaving]=useState(false);
  const sf=(k,v)=>setForm(f=>({...f,[k]:v}));
  useEffect(()=>{fetch("/api/shops").then(r=>r.json()).then(d=>{const s=Array.isArray(d)?d:[];setShops(s);if(s.length)setShopId(s[0]._id);}).catch(()=>{});},[]);
  const loadCoupons=()=>{if(!shopId)return;fetch(`/api/shops/${shopId}/coupons`).then(r=>r.json()).then(d=>setCoupons(Array.isArray(d)?d:[])).catch(()=>{});};
  useEffect(()=>{loadCoupons();},[shopId]);
  const save=async()=>{
    setSaving(true);
    if(modal==="add") await fetch(`/api/shops/${shopId}/coupons`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    else await fetch(`/api/shops/coupons/${modal._id}`,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    setSaving(false);setModal(null);loadCoupons();
  };
  const del=async id=>{if(!confirm("Coupon löschen?"))return;await fetch(`/api/shops/coupons/${id}`,{method:"DELETE"});loadCoupons();};
  const openAdd=()=>{setForm({...emptyForm,code:genCode()});setModal("add");};
  const openEdit=c=>{setForm({...emptyForm,...c,gueltigBis:c.gueltigBis?c.gueltigBis.substring(0,10):""});setModal(c);};
  const couponStatus=c=>{
    if(!c.aktiv)return{l:"Inaktiv",col:"var(--t3)"};
    if(c.gueltigBis&&new Date(c.gueltigBis)<new Date())return{l:"Abgelaufen",col:"var(--red)"};
    if(c.maxNutzungen&&c.nutzungen>=c.maxNutzungen)return{l:"Limitiert",col:"var(--ylw)"};
    return{l:"Aktiv",col:"var(--grn)"};
  };
  const fmtWert=c=>c.typ==="prozent"?`${c.wert}%`:c.typ==="fest"?`${c.wert} €`:"Versandkostenfrei";
  const iS={padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit",width:"100%"};
  return<>
    <div style={{display:"flex",gap:10,marginBottom:16,alignItems:"center"}}>
      <select value={shopId} onChange={e=>setShopId(e.target.value)} style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}>
        {shops.map(s=><option key={s._id} value={s._id}>{s.name}</option>)}
      </select>
      <div style={{marginLeft:"auto"}}><Btn primary onClick={openAdd}>+ Coupon</Btn></div>
    </div>
    {!shopId&&<EmptyState icon="◈" title="Kein Shop ausgewählt" sub="Bitte zuerst einen Shop anlegen"/>}
    {shopId&&<Card style={{padding:0,overflow:"hidden"}}>
      <div style={{display:"grid",gridTemplateColumns:"140px 100px 80px 120px 100px 80px 80px 80px",padding:"8px 14px",borderBottom:"1px solid var(--brd)",background:"var(--s2)"}}>
        {["Code","Typ","Wert","Mindestbestellung","Gültig bis","Nutzungen","Status",""].map(h=><span key={h} style={{fontSize:10,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>{h}</span>)}
      </div>
      {coupons.length===0&&<EmptyState icon="◈" title="Keine Coupons" sub="Erstelle den ersten Coupon"/>}
      {coupons.map(c=>{const st=couponStatus(c);return<div key={c._id} style={{display:"grid",gridTemplateColumns:"140px 100px 80px 120px 100px 80px 80px 80px",padding:"10px 14px",borderBottom:"1px solid var(--brd)",alignItems:"center"}}
        onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
        <span style={{fontSize:13,fontWeight:700,color:"var(--acc)",fontFamily:"monospace"}}>{c.code}</span>
        <span style={{fontSize:11,color:"var(--t2)"}}>{COUPON_TYPEN.find(t=>t.v===c.typ)?.l||c.typ}</span>
        <span style={{fontSize:12,fontWeight:600,color:"var(--t1)"}}>{fmtWert(c)}</span>
        <span style={{fontSize:11,color:"var(--t2)"}}>{c.mindestbestellwert?`ab ${c.mindestbestellwert} €`:"–"}</span>
        <span style={{fontSize:11,color:"var(--t2)"}}>{c.gueltigBis?new Date(c.gueltigBis).toLocaleDateString("de-DE"):"–"}</span>
        <span style={{fontSize:11,color:"var(--t2)"}}>{c.nutzungen||0}{c.maxNutzungen?` / ${c.maxNutzungen}`:""}</span>
        <span style={{padding:"2px 7px",borderRadius:4,fontSize:10,fontWeight:700,background:st.col+"22",color:st.col}}>{st.l}</span>
        <div style={{display:"flex",gap:4}}>
          <Btn small onClick={()=>openEdit(c)}>Edit</Btn>
          <Btn small onClick={()=>del(c._id)} style={{color:"var(--red)"}}>✕</Btn>
        </div>
      </div>;})}
    </Card>}
    {modal&&<CrmModal title={modal==="add"?"Neuer Coupon":"Coupon bearbeiten"} onClose={()=>setModal(null)}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 12px"}}>
        <div style={{gridColumn:"1/-1",display:"flex",gap:8,alignItems:"flex-end"}}>
          <div style={{flex:1}}>
            <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:3,fontWeight:500}}>Code <span style={{color:"var(--red)"}}>*</span></label>
            <input value={form.code||""} onChange={e=>sf("code",e.target.value.toUpperCase())} style={{...iS,fontFamily:"monospace",fontWeight:700,letterSpacing:"2px"}} placeholder="SOMMER20"/>
          </div>
          <Btn onClick={()=>sf("code",genCode())}>Generieren</Btn>
        </div>
        <Sel label="Typ" value={form.typ} onChange={v=>sf("typ",v)} opts={COUPON_TYPEN}/>
        {form.typ!=="versandkostenfrei"&&<Inp label={form.typ==="prozent"?"Wert (%)":"Wert (€)"} value={form.wert} onChange={v=>sf("wert",Number(v))} type="number"/>}
        <Inp label="Mindestbestellwert (€)" value={form.mindestbestellwert} onChange={v=>sf("mindestbestellwert",Number(v))} type="number"/>
        <Inp label="Max. Nutzungen (0=unbegrenzt)" value={form.maxNutzungen} onChange={v=>sf("maxNutzungen",Number(v))} type="number"/>
        <Inp label="Gültig bis" value={form.gueltigBis} onChange={v=>sf("gueltigBis",v)} type="date"/>
        <div style={{gridColumn:"1/-1",display:"flex",alignItems:"center",gap:8,padding:"4px 0"}}>
          <input type="checkbox" id="cpn-aktiv" checked={!!form.aktiv} onChange={e=>sf("aktiv",e.target.checked)}/>
          <label htmlFor="cpn-aktiv" style={{fontSize:13,color:"var(--t2)",cursor:"pointer"}}>Coupon aktiv</label>
        </div>
      </div>
      <div style={{display:"flex",gap:8,justifyContent:"flex-end",paddingTop:10,borderTop:"1px solid var(--brd)",marginTop:4}}>
        <Btn onClick={()=>setModal(null)}>Abbrechen</Btn>
        <Btn primary onClick={save} disabled={saving||!form.code}>{saving?"Speichere…":"Speichern"}</Btn>
      </div>
    </CrmModal>}
  </>;
};

/* ─── ShopBestellungen ─── */
const ShopBestellungen=()=>{
  const [shops,setShops]=useState([]);
  const [shopId,setShopId]=useState("");
  const [vonDatum,setVonDatum]=useState("");
  const [bisDatum,setBisDatum]=useState("");
  useEffect(()=>{fetch("/api/shops").then(r=>r.json()).then(d=>setShops(Array.isArray(d)?d:[])).catch(()=>{});},[]);
  return<>
    <div style={{display:"flex",gap:10,marginBottom:20,alignItems:"center"}}>
      <select value={shopId} onChange={e=>setShopId(e.target.value)} style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}>
        <option value="">Alle Shops</option>
        {shops.map(s=><option key={s._id} value={s._id}>{s.name}</option>)}
      </select>
      <input type="date" value={vonDatum} onChange={e=>setVonDatum(e.target.value)} title="Von" style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/>
      <input type="date" value={bisDatum} onChange={e=>setBisDatum(e.target.value)} title="Bis" style={{padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"}}/>
    </div>
    <Card style={{textAlign:"center",padding:"48px 32px"}}>
      <div style={{fontSize:40,marginBottom:16,opacity:.3}}>◈</div>
      <div style={{fontSize:16,fontWeight:700,color:"var(--t2)",marginBottom:8}}>Bestelldaten noch nicht verfügbar</div>
      <div style={{fontSize:13,color:"var(--t3)",maxWidth:480,margin:"0 auto",lineHeight:1.6}}>
        Bestelldaten kommen aus JTL via SCX — Anbindung wird in Phase 2 implementiert.
        Die Filter oben sind für die spätere Nutzung bereits vorbereitet.
      </div>
    </Card>
  </>;
};

/* ─── EMAIL CENTER ─── */

const STATUS_COLOR={
  neu:"var(--acc)",
  offen:"var(--ylw)",
  in_bearbeitung:"var(--grn)",
  erledigt:"var(--t3)",
  spam:"var(--red)",
};
const STATUS_LABEL={neu:"Neu",offen:"Offen",in_bearbeitung:"In Bearbeitung",erledigt:"Erledigt",spam:"Spam"};
const PRIO_COLOR={normal:"var(--t3)",hoch:"var(--ylw)",dringend:"var(--red)"};

function emailInitials(name,email){
  const n=name||email||"?";
  const parts=n.trim().split(/\s+/);
  if(parts.length>=2)return(parts[0][0]+parts[1][0]).toUpperCase();
  return n.slice(0,2).toUpperCase();
}

function fmtRelative(d){
  if(!d)return"–";
  const diff=Date.now()-new Date(d).getTime();
  const mins=Math.floor(diff/60000);
  if(mins<1)return"jetzt";
  if(mins<60)return mins+"min";
  const hrs=Math.floor(mins/60);
  if(hrs<24)return hrs+"h";
  const days=Math.floor(hrs/24);
  if(days<7)return days+"d";
  return new Date(d).toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit"});
}

/* VorgangZeile */
const VorgangZeile=({v,selected,onClick})=>{
  const ungelesen=v.status==="neu";
  const ini=emailInitials(v.vonName,v.vonEmail);
  return<div onClick={onClick} style={{
    display:"flex",alignItems:"flex-start",gap:10,padding:"10px 12px",
    cursor:"pointer",borderBottom:"1px solid var(--brd)",
    background:selected?"var(--sact)":"transparent",
    borderLeft:selected?"3px solid var(--acc)":ungelesen?"3px solid var(--acc)":"3px solid transparent",
    position:"relative",minHeight:72,
  }}
  onMouseEnter={e=>{if(!selected)e.currentTarget.style.background="var(--shov)"}}
  onMouseLeave={e=>{if(!selected)e.currentTarget.style.background="transparent"}}>
    <div style={{width:34,height:34,borderRadius:"50%",background:"var(--acc2)",color:"var(--acc)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,flexShrink:0,marginTop:2}}>{ini}</div>
    <div style={{flex:1,minWidth:0}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:2}}>
        <span style={{fontSize:12,fontWeight:ungelesen?700:500,color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:180}}>{v.vonName||v.vonEmail}</span>
        <span style={{fontSize:10,color:"var(--t3)",flexShrink:0,marginLeft:6}}>{fmtRelative(v.letzteNachrichtAm)}</span>
      </div>
      <div style={{fontSize:11,fontWeight:ungelesen?600:400,color:ungelesen?"var(--t1)":"var(--t2)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",marginBottom:3}}>{v.betreff||"(kein Betreff)"}</div>
      <div style={{display:"flex",alignItems:"center",gap:5,flexWrap:"wrap"}}>
        <span style={{fontSize:9,padding:"1px 6px",borderRadius:3,background:STATUS_COLOR[v.status]+"22",color:STATUS_COLOR[v.status],fontWeight:600}}>{STATUS_LABEL[v.status]||v.status}</span>
        {v.label&&<span style={{fontSize:9,padding:"1px 6px",borderRadius:3,background:"var(--acc2)",color:"var(--acc)",fontWeight:600}}>{v.label}</span>}
        {v.prioritaet&&v.prioritaet!=="normal"&&<span style={{fontSize:9,color:PRIO_COLOR[v.prioritaet],fontWeight:700}}>{v.prioritaet==="dringend"?"⚡":"↑"}</span>}
        {v.gesperrtVon&&<span style={{fontSize:9,color:"var(--ylw)"}}>● {v.gesperrtVon}</span>}
        {v.crmFirmaName&&<span style={{fontSize:9,color:"var(--t3)"}}>{v.crmFirmaName}</span>}
      </div>
    </div>
  </div>;
};

/* VorgangListe */
const VorgangListe=({vorgaenge,selectedId,onSelect})=>{
  if(!vorgaenge.length)return<EmptyState icon="✉" title="Keine Vorgänge" sub="Noch keine E-Mails vorhanden"/>;
  return<div style={{overflowY:"auto",height:"100%"}}>
    {vorgaenge.map(v=><VorgangZeile key={v._id} v={v} selected={selectedId===v._id} onClick={()=>onSelect(v._id)}/>)}
  </div>;
};

/* NachrichtBubble */
const NachrichtBubble=({n})=>{
  const out=n.richtung==="ausgehend";
  return<div style={{display:"flex",flexDirection:out?"row-reverse":"row",gap:10,marginBottom:16}}>
    <div style={{width:28,height:28,borderRadius:"50%",background:out?"var(--acc2)":"var(--s3)",color:out?"var(--acc)":"var(--t2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,flexShrink:0,marginTop:2}}>{emailInitials(n.vonName,n.vonEmail)}</div>
    <div style={{maxWidth:"75%"}}>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4,flexDirection:out?"row-reverse":"row"}}>
        <span style={{fontSize:11,fontWeight:600,color:"var(--t1)"}}>{n.vonName||n.vonEmail}</span>
        <span style={{fontSize:10,color:"var(--t3)"}}>{fmtDT(n.datum)}</span>
        {n.anhaenge&&n.anhaenge.length>0&&<span style={{fontSize:10,color:"var(--t3)"}}>📎 {n.anhaenge.length}</span>}
      </div>
      <div style={{padding:"10px 14px",borderRadius:out?"12px 4px 12px 12px":"4px 12px 12px 12px",background:out?"var(--acc)":"var(--s2)",color:out?"#fff":"var(--t1)",fontSize:12,lineHeight:1.6}}>
        {n.textHtml
          ?<div dangerouslySetInnerHTML={{__html:n.textHtml.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"")}} style={{maxHeight:300,overflow:"auto"}}/>
          :<span style={{whiteSpace:"pre-wrap"}}>{n.textPlain||"(leer)"}</span>}
      </div>
      {n.anhaenge&&n.anhaenge.length>0&&<div style={{marginTop:6,display:"flex",flexDirection:"column",gap:4,alignItems:out?"flex-end":"flex-start"}}>
        {n.anhaenge.map((a,i)=>{
          const saved=!!a.minioKey;
          return<span key={i} title={saved?`In MinIO: ${a.minioBucket||"einkauf"}/${a.minioKey}`:"Noch nicht in MinIO"} style={{fontSize:10,padding:"3px 9px",borderRadius:5,background:saved?"var(--grn2)":"var(--s3)",color:saved?"var(--grn)":"var(--t2)",border:`1px solid ${saved?"var(--grn)":"var(--brd)"}`,display:"inline-flex",alignItems:"center",gap:6}}>
            <span>{saved?"✓":"📎"}</span>
            <span style={{fontWeight:500}}>{a.name}</span>
            <span style={{opacity:.75}}>({Math.round((a.size||0)/1024)}KB)</span>
            {saved&&a.brand&&<span style={{padding:"1px 6px",borderRadius:3,background:"var(--grn)",color:"#fff",fontSize:9,fontWeight:700,marginLeft:2}}>{a.brand}</span>}
            {saved&&<span style={{opacity:.7,fontSize:9}}>→ MinIO</span>}
          </span>;
        })}
      </div>}
    </div>
  </div>;
};

/* NotizBubble */
const NotizBubble=({n})=><div style={{margin:"8px 0",padding:"8px 14px",borderRadius:8,background:"var(--ylw2)",border:"1px solid var(--ylw)",borderLeft:"3px solid var(--ylw)"}}>
  <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
    <span style={{fontSize:10,fontWeight:600,color:"var(--ylw)"}}>Interne Notiz · {n.autor||"System"}</span>
    <span style={{fontSize:10,color:"var(--t3)"}}>{fmtDT(n.createdAt)}</span>
  </div>
  <div style={{fontSize:12,color:"var(--t1)",whiteSpace:"pre-wrap"}}>{n.text}</div>
</div>;

/* VorgangDetail */
const VorgangDetail=({vorgangId,onClose,onUpdate})=>{
  const [data,setData]=useState(null);
  const [tab,setTab]=useState("antwort");
  const [antwortText,setAntwortText]=useState("");
  const [notizText,setNotizText]=useState("");
  const [loading,setLoading]=useState(false);
  const [bausteine,setBausteine]=useState([]);
  const [showBausteine,setShowBausteine]=useState(false);

  const load=useCallback(()=>{
    if(!vorgangId)return;
    fetch("/api/email/vorgaenge/"+vorgangId).then(r=>r.json()).then(setData).catch(()=>{});
  },[vorgangId]);

  useEffect(()=>{setData(null);load();},[load]);
  useEffect(()=>{fetch("/api/email/bausteine").then(r=>r.json()).then(setBausteine).catch(()=>{});},[]);

  if(!vorgangId)return<div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center"}}><EmptyState icon="✉" title="Kein Vorgang ausgewählt" sub="Wähle einen Vorgang aus der Liste"/></div>;
  if(!data)return<div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",color:"var(--t3)",fontSize:13}}>Lade…</div>;

  const {vorgang,nachrichten=[],notizen=[]} = data;

  const handleStatusChange=async(status)=>{
    await fetch("/api/email/vorgaenge/"+vorgangId,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({status})});
    load();if(onUpdate)onUpdate();
  };

  const handleSenden=async()=>{
    if(!antwortText.trim())return;
    setLoading(true);
    try{
      await fetch("/api/email/vorgaenge/"+vorgangId+"/senden",{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({anEmail:vorgang.vonEmail,betreff:"Re: "+vorgang.betreff,textPlain:antwortText,textHtml:"<pre>"+antwortText+"</pre>"})
      });
      setAntwortText("");load();if(onUpdate)onUpdate();
    }finally{setLoading(false);}
  };

  const handleNotiz=async()=>{
    if(!notizText.trim())return;
    setLoading(true);
    try{
      await fetch("/api/email/vorgaenge/"+vorgangId+"/notizen",{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({text:notizText,autor:"Stefan M."})
      });
      setNotizText("");load();
    }finally{setLoading(false);}
  };

  // Merge nachrichten + notizen sorted by date
  const timeline=[
    ...nachrichten.map(n=>({...n,_type:"nachricht",_date:new Date(n.datum||n.createdAt)})),
    ...notizen.map(n=>({...n,_type:"notiz",_date:new Date(n.createdAt)})),
  ].sort((a,b)=>a._date-b._date);

  return<div style={{flex:1,display:"flex",flexDirection:"column",minWidth:0,height:"100%"}}>
    {/* Header */}
    <div style={{padding:"14px 18px",borderBottom:"1px solid var(--brd)",background:"var(--s1)",flexShrink:0}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
        <div style={{flex:1,minWidth:0}}>
          <h2 style={{fontSize:15,fontWeight:700,color:"var(--t1)",margin:"0 0 4px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{vorgang.betreff||"(kein Betreff)"}</h2>
          <div style={{fontSize:11,color:"var(--t3)"}}>{vorgang.vonName||vorgang.vonEmail} · {vorgang.kontoEmail} · {nachrichten.length} Nachrichten</div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center",flexShrink:0,marginLeft:12}}>
          {vorgang.crmFirmaName&&<span style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:"var(--acc2)",color:"var(--acc)",fontWeight:600}}>🏢 {vorgang.crmFirmaName}</span>}
          <span style={{fontSize:10,padding:"2px 8px",borderRadius:4,background:PRIO_COLOR[vorgang.prioritaet||"normal"]+"22",color:PRIO_COLOR[vorgang.prioritaet||"normal"],fontWeight:600}}>{(vorgang.prioritaet||"normal").toUpperCase()}</span>
        </div>
      </div>
      <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap"}}>
        <select value={vorgang.status} onChange={e=>handleStatusChange(e.target.value)} style={{padding:"4px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:STATUS_COLOR[vorgang.status]||"var(--t1)",fontSize:11,fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
          {Object.keys(STATUS_LABEL).map(k=><option key={k} value={k}>{STATUS_LABEL[k]}</option>)}
        </select>
        <select value={vorgang.zugewiesen||""} onChange={async e=>{await fetch("/api/email/vorgaenge/"+vorgangId,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({zugewiesen:e.target.value})});load();}} style={{padding:"4px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t2)",fontSize:11,fontFamily:"inherit",cursor:"pointer"}}>
          <option value="">Nicht zugewiesen</option>
          {["Stefan M.","Max B.","Anna K.","Lisa T."].map(u=><option key={u} value={u}>{u}</option>)}
        </select>
        {vorgang.gesperrtVon
          ?<Btn small onClick={async()=>{await fetch("/api/email/vorgaenge/"+vorgangId+"/freigeben",{method:"POST"});load();}} style={{borderColor:"var(--ylw)",color:"var(--ylw)"}}>🔒 {vorgang.gesperrtVon} · Freigeben</Btn>
          :<Btn small onClick={async()=>{await fetch("/api/email/vorgaenge/"+vorgangId+"/sperren",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({user:"Stefan M."})});load();}}>🔓 Sperren</Btn>}
      </div>
    </div>

    {/* Thread */}
    <div style={{flex:1,overflowY:"auto",padding:"16px 18px"}}>
      {timeline.length===0&&<EmptyState icon="📭" title="Keine Nachrichten" sub="Noch keine E-Mails in diesem Vorgang"/>}
      {timeline.map((item,i)=>item._type==="notiz"
        ?<NotizBubble key={"n"+i} n={item}/>
        :<NachrichtBubble key={"m"+i} n={item}/>
      )}
    </div>

    {/* Aktionsleiste */}
    <div style={{borderTop:"1px solid var(--brd)",background:"var(--s1)",padding:"12px 18px",flexShrink:0}}>
      <div style={{display:"flex",gap:6,marginBottom:10}}>
        {[{k:"antwort",l:"Antworten"},{k:"notiz",l:"Interne Notiz"},{k:"weiterleiten",l:"Weiterleiten"}].map(t=>
          <button key={t.k} onClick={()=>setTab(t.k)} style={{padding:"5px 12px",borderRadius:6,border:"none",fontSize:11,fontWeight:500,cursor:"pointer",fontFamily:"inherit",background:tab===t.k?"var(--acc)":"var(--s2)",color:tab===t.k?"#fff":"var(--t2)"}}>{t.l}</button>
        )}
      </div>
      {tab==="antwort"&&<div>
        <div style={{position:"relative"}}>
          <textarea value={antwortText} onChange={e=>setAntwortText(e.target.value)} placeholder={"Antwort an "+vorgang.vonEmail+"…"} rows={4} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",resize:"vertical",outline:"none",lineHeight:1.5}}/>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8}}>
          <button onClick={()=>setShowBausteine(b=>!b)} style={{fontSize:11,padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t2)",cursor:"pointer",fontFamily:"inherit"}}>📋 Vorlagen</button>
          <Btn primary disabled={!antwortText.trim()||loading} onClick={handleSenden}>{loading?"Sende…":"Senden ▶"}</Btn>
        </div>
        {showBausteine&&<div style={{marginTop:8,maxHeight:200,overflowY:"auto",border:"1px solid var(--brd)",borderRadius:8,background:"var(--s1)"}}>
          {bausteine.length===0&&<div style={{padding:"12px",fontSize:11,color:"var(--t3)",textAlign:"center"}}>Keine Bausteine vorhanden</div>}
          {bausteine.map(b=><div key={b._id} onClick={()=>{setAntwortText(t=>t+(t?"\n\n":"")+b.text);setShowBausteine(false);}} style={{padding:"8px 12px",cursor:"pointer",borderBottom:"1px solid var(--brd)",fontSize:12}} onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
            <div style={{fontWeight:600,color:"var(--t1)",marginBottom:2}}>{b.name}</div>
            <div style={{fontSize:10,color:"var(--t3)"}}>{(b.text||"").slice(0,80)}…</div>
          </div>)}
        </div>}
      </div>}
      {tab==="notiz"&&<div>
        <textarea value={notizText} onChange={e=>setNotizText(e.target.value)} placeholder="Interne Notiz (nur für Teammitglieder sichtbar)…" rows={3} style={{width:"100%",padding:"8px 10px",borderRadius:7,border:"1px solid var(--ylw)",background:"var(--ylw2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",resize:"vertical",outline:"none",lineHeight:1.5}}/>
        <div style={{display:"flex",justifyContent:"flex-end",marginTop:8}}>
          <Btn primary disabled={!notizText.trim()||loading} onClick={handleNotiz} style={{background:"var(--ylw)",borderColor:"var(--ylw)"}}>{loading?"Speichere…":"Notiz speichern"}</Btn>
        </div>
      </div>}
      {tab==="weiterleiten"&&<div style={{padding:"20px",textAlign:"center",color:"var(--t3)",fontSize:12}}>Weiterleiten – in Entwicklung</div>}
    </div>
  </div>;
};

/* NeuVorgangModal */
const NeuVorgangModal=({konten,onClose,onCreated})=>{
  const [an,setAn]=useState("");
  const [kontoId,setKontoId]=useState(konten[0]?._id||"");
  const [betreff,setBetreff]=useState("");
  const [text,setText]=useState("");
  const [loading,setLoading]=useState(false);
  const [bausteine,setBausteine]=useState([]);
  const [showBausteine,setShowBausteine]=useState(false);
  useEffect(()=>{fetch("/api/email/bausteine").then(r=>r.json()).then(setBausteine).catch(()=>{});},[]);

  const handleSenden=async()=>{
    if(!an||!betreff||!text)return;
    setLoading(true);
    try{
      const konto=konten.find(k=>k._id===kontoId)||konten[0];
      const vRes=await fetch("/api/email/vorgaenge",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({betreff,vonEmail:konto?.email||"",vonName:konto?.name||"",kontoId:konto?._id,kontoEmail:konto?.email||""})});
      const v=await vRes.json();
      await fetch("/api/email/vorgaenge/"+v._id+"/senden",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({anEmail:an,betreff,textPlain:text,textHtml:"<pre>"+text+"</pre>",kontoId:kontoId})});
      onCreated&&onCreated();onClose();
    }finally{setLoading(false);}
  };

  return<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:999}}>
    <div style={{background:"var(--s1)",borderRadius:12,border:"1px solid var(--brd)",width:560,maxHeight:"90vh",overflow:"auto"}}>
      <div style={{padding:"16px 20px",borderBottom:"1px solid var(--brd)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <h3 style={{fontSize:15,fontWeight:700,color:"var(--t1)",margin:0}}>Neue E-Mail</h3>
        <button onClick={onClose} style={{background:"none",border:"none",fontSize:18,color:"var(--t3)",cursor:"pointer"}}>×</button>
      </div>
      <div style={{padding:"16px 20px",display:"flex",flexDirection:"column",gap:10}}>
        <div><label style={{fontSize:11,color:"var(--t3)",display:"block",marginBottom:3}}>An</label><input value={an} onChange={e=>setAn(e.target.value)} placeholder="empfaenger@domain.de" style={{width:"100%",padding:"7px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",outline:"none"}}/></div>
        <div><label style={{fontSize:11,color:"var(--t3)",display:"block",marginBottom:3}}>Von (Konto)</label><select value={kontoId} onChange={e=>setKontoId(e.target.value)} style={{width:"100%",padding:"7px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",outline:"none",cursor:"pointer"}}>
          {konten.length===0&&<option value="">Kein Konto konfiguriert</option>}
          {konten.map(k=><option key={k._id} value={k._id}>{k.name||k.email} ({k.email})</option>)}
        </select></div>
        <div><label style={{fontSize:11,color:"var(--t3)",display:"block",marginBottom:3}}>Betreff</label><input value={betreff} onChange={e=>setBetreff(e.target.value)} placeholder="Betreff…" style={{width:"100%",padding:"7px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",outline:"none"}}/></div>
        <div><label style={{fontSize:11,color:"var(--t3)",display:"block",marginBottom:3}}>Nachricht</label><textarea value={text} onChange={e=>setText(e.target.value)} rows={7} style={{width:"100%",padding:"7px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",outline:"none",resize:"vertical"}}/></div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <button onClick={()=>setShowBausteine(b=>!b)} style={{fontSize:11,padding:"4px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t2)",cursor:"pointer",fontFamily:"inherit"}}>📋 Vorlagen</button>
          <div style={{display:"flex",gap:8}}>
            <Btn onClick={onClose}>Abbrechen</Btn>
            <Btn primary disabled={!an||!betreff||!text||loading} onClick={handleSenden}>{loading?"Sende…":"Senden ▶"}</Btn>
          </div>
        </div>
        {showBausteine&&<div style={{border:"1px solid var(--brd)",borderRadius:8,maxHeight:160,overflowY:"auto",background:"var(--s2)"}}>
          {bausteine.map(b=><div key={b._id} onClick={()=>{setText(t=>t+(t?"\n\n":"")+b.text);setShowBausteine(false);}} style={{padding:"8px 12px",cursor:"pointer",borderBottom:"1px solid var(--brd)",fontSize:12}} onMouseEnter={e=>e.currentTarget.style.background="var(--shov)"} onMouseLeave={e=>e.currentTarget.style.background="var(--s2)"}>
            <div style={{fontWeight:600,color:"var(--t1)",marginBottom:2}}>{b.name}</div>
            <div style={{fontSize:10,color:"var(--t3)"}}>{b.kategorie}</div>
          </div>)}
        </div>}
      </div>
    </div>
  </div>;
};

/* EmailInbox — Haupt-Wrapper */
const KONTOTYP_BADGE_STYLE={
  kundensupport:{background:"#d1fae5",color:"#065f46"},
  buchhaltung:{background:"#fee2e2",color:"#991b1b"},
  einkauf:{background:"#dbeafe",color:"#1e40af"},
  allgemein:{background:"var(--s2)",color:"var(--t2)"},
};

const EmailInbox=({sub})=>{
  const [vorgaenge,setVorgaenge]=useState([]);
  const [selectedId,setSelectedId]=useState(null);
  const [stats,setStats]=useState({neu:0,offen:0,inBearbeitung:0,erledigt:0,heute:0});
  const [konten,setKonten]=useState([]);
  const [filterKonto,setFilterKonto]=useState("");
  const [filterStatus,setFilterStatus]=useState(sub==="erledigt"?"erledigt":sub==="alle"?"alle":"aktiv");
  const [search,setSearch]=useState("");
  const [syncing,setSyncing]=useState(false);
  const [showNeu,setShowNeu]=useState(false);
  const [userRolle,setUserRolle]=useState("admin"); // hardcoded default, später aus Auth

  const loadVorgaenge=useCallback(()=>{
    const params=new URLSearchParams();
    if(filterKonto)params.set("konto",filterKonto);
    if(filterStatus&&filterStatus!=="alle"&&filterStatus!=="aktiv"){
      params.set("status",filterStatus);
    } else if(filterStatus==="aktiv"){
      // aktiv = neu+offen+in_bearbeitung, handled client-side
    }
    if(search)params.set("search",search);
    params.set("userRolle",userRolle);
    fetch("/api/email/vorgaenge?"+params.toString()).then(r=>r.json()).then(data=>{
      const arr=Array.isArray(data)?data:[];
      if(filterStatus==="aktiv"){
        setVorgaenge(arr.filter(v=>["neu","offen","in_bearbeitung"].includes(v.status)));
      } else {
        setVorgaenge(arr);
      }
    }).catch(()=>{});
  },[filterKonto,filterStatus,search,userRolle]);

  useEffect(()=>{loadVorgaenge();},[loadVorgaenge]);
  useEffect(()=>{fetch("/api/email/stats").then(r=>r.json()).then(setStats).catch(()=>{});},[vorgaenge.length]);
  useEffect(()=>{fetch("/api/email/konten").then(r=>r.json()).then(d=>setKonten(Array.isArray(d)?d:[])).catch(()=>{});},[]);

  const handleSync=async()=>{
    if(konten.length===0){alert("Kein E-Mail-Konto konfiguriert");return;}
    setSyncing(true);
    try{
      for(const k of konten){
        await fetch("/api/email/sync/"+k._id,{method:"POST"});
      }
      loadVorgaenge();
    }finally{setSyncing(false);}
  };

  const STATUS_TABS=[
    {k:"aktiv",l:"Posteingang"},
    {k:"alle",l:"Alle"},
    {k:"in_bearbeitung",l:"In Bearbeitung"},
    {k:"erledigt",l:"Erledigt"},
    {k:"spam",l:"Spam"},
  ];

  return<div style={{display:"flex",flexDirection:"column",height:"calc(100vh - 120px)",overflow:"hidden",margin:"-22px -26px",padding:"0"}}>
    {/* Toolbar */}
    <div style={{display:"flex",alignItems:"center",gap:10,padding:"12px 16px",borderBottom:"1px solid var(--brd)",background:"var(--s1)",flexShrink:0,flexWrap:"wrap"}}>
      {konten.length>0&&<><select value={filterKonto} onChange={e=>setFilterKonto(e.target.value)} style={{padding:"5px 8px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t2)",fontSize:11,fontFamily:"inherit",cursor:"pointer"}}>
        <option value="">Alle Konten</option>
        {konten.map(k=><option key={k._id} value={k._id}>{k.name||k.email}</option>)}
      </select>
      {filterKonto&&(()=>{const k=konten.find(c=>c._id===filterKonto);if(!k)return null;const kt=k.kontotyp||"allgemein";const bs=KONTOTYP_BADGE_STYLE[kt]||KONTOTYP_BADGE_STYLE.allgemein;return<span style={{padding:"3px 8px",borderRadius:10,fontSize:10,fontWeight:600,...bs}}>{kt.charAt(0).toUpperCase()+kt.slice(1)}</span>;})()}</>}
      <div style={{display:"flex",gap:2,background:"var(--s2)",borderRadius:7,padding:2}}>
        {STATUS_TABS.map(t=><button key={t.k} onClick={()=>setFilterStatus(t.k)} style={{padding:"4px 10px",borderRadius:5,border:"none",fontSize:11,fontWeight:500,cursor:"pointer",fontFamily:"inherit",background:filterStatus===t.k?"var(--acc)":"transparent",color:filterStatus===t.k?"#fff":"var(--t2)"}}>
          {t.l}{t.k==="aktiv"&&stats.neu>0&&<span style={{marginLeft:4,background:"var(--red)",color:"#fff",borderRadius:8,padding:"0 5px",fontSize:9,fontWeight:700}}>{stats.neu}</span>}
        </button>)}
      </div>
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Suche…" style={{padding:"5px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:11,fontFamily:"inherit",outline:"none",width:180}}/>
      <div style={{marginLeft:"auto",display:"flex",gap:8}}>
        <Btn small onClick={handleSync} disabled={syncing}>{syncing?"⟳ Sync…":"⟳ Sync"}</Btn>
        <Btn small primary onClick={()=>setShowNeu(true)}>+ Neue E-Mail</Btn>
      </div>
    </div>

    {/* Body */}
    <div style={{display:"flex",flex:1,overflow:"hidden"}}>
      {/* Liste */}
      <div style={{width:350,flexShrink:0,borderRight:"1px solid var(--brd)",overflowY:"auto",background:"var(--sbg)"}}>
        <VorgangListe vorgaenge={vorgaenge} selectedId={selectedId} onSelect={setSelectedId}/>
      </div>

      {/* Detail */}
      <VorgangDetail vorgangId={selectedId} onUpdate={loadVorgaenge}/>
    </div>

    {showNeu&&<NeuVorgangModal konten={konten} onClose={()=>setShowNeu(false)} onCreated={()=>{loadVorgaenge();setShowNeu(false);}}/>}
  </div>;
};

/* EmailBausteine */
const EmailBausteine=()=>{
  const [bausteine,setBausteine]=useState([]);
  const [showModal,setShowModal]=useState(false);
  const [editItem,setEditItem]=useState(null);
  const [form,setForm]=useState({name:"",kategorie:"Allgemein",betreff:"",text:""});
  const VARS=["{{firma}}","{{ansprechpartner}}","{{datum}}","{{benutzer}}"];
  const KATS=["Allgemein","Angebote","Support","Nachfassen"];

  const load=()=>{fetch("/api/email/bausteine").then(r=>r.json()).then(d=>setBausteine(Array.isArray(d)?d:[])).catch(()=>{});};
  useEffect(load,[]);

  const openModal=(item=null)=>{
    setEditItem(item);
    setForm(item?{name:item.name||"",kategorie:item.kategorie||"Allgemein",betreff:item.betreff||"",text:item.text||""}:{name:"",kategorie:"Allgemein",betreff:"",text:""});
    setShowModal(true);
  };

  const handleSave=async()=>{
    if(editItem){
      await fetch("/api/email/bausteine/"+editItem._id,{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    } else {
      await fetch("/api/email/bausteine",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(form)});
    }
    setShowModal(false);load();
  };

  const handleDelete=async(id)=>{
    if(!confirm("Baustein löschen?"))return;
    await fetch("/api/email/bausteine/"+id,{method:"DELETE"});
    load();
  };

  const insertVar=v=>{setForm(f=>({...f,text:f.text+v}));};

  return<div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
      <span style={{fontSize:13,color:"var(--t2)"}}>{bausteine.length} Bausteine</span>
      <Btn primary onClick={()=>openModal()}>+ Baustein</Btn>
    </div>
    {bausteine.length===0&&<EmptyState icon="📋" title="Keine Textbausteine" sub="Erstelle Vorlagen für häufig gesendete E-Mails"/>}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:14}}>
      {bausteine.map(b=><Card key={b._id} style={{position:"relative"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
          <div>
            <div style={{fontSize:13,fontWeight:700,color:"var(--t1)",marginBottom:2}}>{b.name}</div>
            <span style={{fontSize:9,padding:"1px 6px",borderRadius:3,background:"var(--acc2)",color:"var(--acc)",fontWeight:600}}>{b.kategorie}</span>
          </div>
          <div style={{display:"flex",gap:6}}>
            <Btn small onClick={()=>openModal(b)}>✏</Btn>
            <Btn small onClick={()=>handleDelete(b._id)} style={{color:"var(--red)"}}>✕</Btn>
          </div>
        </div>
        {b.betreff&&<div style={{fontSize:11,color:"var(--t2)",marginBottom:6,fontWeight:500}}>Betreff: {b.betreff}</div>}
        <div style={{fontSize:11,color:"var(--t3)",whiteSpace:"pre-wrap",maxHeight:80,overflow:"hidden",position:"relative"}}>
          {(b.text||"").slice(0,200)}{(b.text||"").length>200?"…":""}
        </div>
      </Card>)}
    </div>

    {showModal&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:999}}>
      <div style={{background:"var(--s1)",borderRadius:12,border:"1px solid var(--brd)",width:560,maxHeight:"90vh",overflow:"auto"}}>
        <div style={{padding:"16px 20px",borderBottom:"1px solid var(--brd)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <h3 style={{fontSize:15,fontWeight:700,color:"var(--t1)",margin:0}}>{editItem?"Baustein bearbeiten":"Neuer Baustein"}</h3>
          <button onClick={()=>setShowModal(false)} style={{background:"none",border:"none",fontSize:18,color:"var(--t3)",cursor:"pointer"}}>×</button>
        </div>
        <div style={{padding:"16px 20px",display:"flex",flexDirection:"column",gap:10}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <div><label style={{fontSize:11,color:"var(--t3)",display:"block",marginBottom:3}}>Name</label><input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} style={{width:"100%",padding:"7px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",outline:"none"}}/></div>
            <div><label style={{fontSize:11,color:"var(--t3)",display:"block",marginBottom:3}}>Kategorie</label><select value={form.kategorie} onChange={e=>setForm(f=>({...f,kategorie:e.target.value}))} style={{width:"100%",padding:"7px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",cursor:"pointer"}}>
              {KATS.map(k=><option key={k} value={k}>{k}</option>)}
            </select></div>
          </div>
          <div><label style={{fontSize:11,color:"var(--t3)",display:"block",marginBottom:3}}>Betreff (optional)</label><input value={form.betreff} onChange={e=>setForm(f=>({...f,betreff:e.target.value}))} placeholder="Betreff-Vorlage…" style={{width:"100%",padding:"7px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",outline:"none"}}/></div>
          <div>
            <label style={{fontSize:11,color:"var(--t3)",display:"block",marginBottom:3}}>Text</label>
            <div style={{display:"flex",gap:4,flexWrap:"wrap",marginBottom:6}}>
              {VARS.map(v=><button key={v} onClick={()=>insertVar(v)} style={{fontSize:10,padding:"2px 7px",borderRadius:4,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--acc)",cursor:"pointer",fontFamily:"monospace"}}>{v}</button>)}
            </div>
            <textarea value={form.text} onChange={e=>setForm(f=>({...f,text:e.target.value}))} rows={8} style={{width:"100%",padding:"7px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit",outline:"none",resize:"vertical"}}/>
          </div>
          <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
            <Btn onClick={()=>setShowModal(false)}>Abbrechen</Btn>
            <Btn primary disabled={!form.name||!form.text} onClick={handleSave}>Speichern</Btn>
          </div>
        </div>
      </div>
    </div>}
  </div>;
};

/* ─── NAV STRUCTURE ─── */
const NAV_STRUCTURE=[
  {id:"dashboard",label:"Dashboard",icon:"◎"},
  {id:"potentialanalyse",label:"Potentialanalyse",icon:"◬"},
  {id:"auswertungen",label:"Auswertungen",icon:"◈",children:[
    {id:"auswertungen/reports",label:"Reports"},
    {id:"auswertungen/verkaufszahlen",label:"Verkaufszahlen"},
    {id:"auswertungen/bestseller",label:"Bestseller"},
    {id:"auswertungen/trends",label:"Trends"},
    {id:"auswertungen/performance",label:"Performance"},
    {id:"__divider"},
    {id:"__group",label:"Bestellungen",isGroup:true},
    {id:"bestellungen/auftraege",label:"Aufträge"},
    {id:"bestellungen/retouren",label:"Retouren"},
    {id:"bestellungen/stornos",label:"Stornos"},
    {id:"bestellungen/artikel",label:"Verkaufte Artikel"},
    {id:"bestellungen/kanaele",label:"Kanäle"},
  ]},
  {id:"cashflow",label:"Cashflow",icon:"◇",children:[
  {id:"cashflow/uebersicht",label:"Cashflow Übersicht"},
  {id:"cashflow/kontostände",label:"Kontostände"},
]},
  {id:"buchhaltung",label:"Buchhaltung",icon:"◫",children:[
  {id:"buchhaltung/uebersicht",label:"Übersicht"},
  {id:"buchhaltung/zahlungsverkehr",label:"Zahlungsverkehr"},
  {id:"buchhaltung/buchungssaetze",label:"Buchungssätze"},
  {id:"buchhaltung/kontennachweis",label:"Kontennachweis"},
  {id:"buchhaltung/inventar",label:"Inventar"},
  {id:"buchhaltung/afa",label:"AfA"},
  {id:"buchhaltung/bwa",label:"BWA"},
  {id:"buchhaltung/bilanz",label:"Bilanz"},
  {id:"buchhaltung/banken",label:"Banken"},
  {id:"buchhaltung/mitarbeiter",label:"Mitarbeiter"},
  {id:"buchhaltung/lieferanten",label:"Lieferanten"},
  {id:"buchhaltung/marktplatz",label:"Marktplatz"},
  {id:"buchhaltung/it",label:"IT"},
]},
  {id:"preise",label:"Preise",icon:"◈",children:[
    {id:"preise/kalkulator",label:"Preiskalkulator"},
    {id:"preise/angebote",label:"Angebote"},
  ]},
  {id:"artikel",label:"Artikeldatenverwaltung",icon:"◧",children:[
    {id:"__group",label:"Imports",isGroup:true},
    {id:"artikel/order-files",label:"Order Files"},
    {id:"artikel/imports-ek",label:"Einkaufspreise"},
    {id:"__group",label:"Tradebyte",isGroup:true},
    {id:"artikel/panda-upload",label:"Panda Upload"},
    {id:"artikel/panda-ansicht",label:"Panda Ansicht"},
    {id:"__group",label:"Manuelle Verwaltung",isGroup:true},
    {id:"artikel/ods-upload",label:"Upload Panda ODS"},
    {id:"artikel/artikel-ansicht",label:"Artikelansicht"},
    {id:"__group",label:"JTL",isGroup:true},
    {id:"artikel/jtl-ansicht",label:"Artikelansicht"},
    {id:"artikel/kategoriemapping",label:"Kategoriezuordnung"},
    {id:"__divider"},
    {id:"artikel/pflichtfelder",label:"Pflichtfelder"},
    {id:"artikel/attributfelder",label:"Attributfelder"},
    {id:"artikel/merkmale",label:"Merkmale"},
    {id:"artikel/bilder",label:"Artikelbilder"},
  ]},
  {id:"einkauf",label:"Einkauf",icon:"◉",children:[
    {id:"einkauf/lieferanten",label:"Lieferantenverwaltung"},
    {id:"einkauf/preislisten",label:"Preislisten"},
    {id:"einkauf/artikeleinkaufspreise",label:"Artikeleinkaufspreise"},
    {id:"einkauf/preorder",label:"Preorder"},
    {id:"einkauf/lieferantenauswertung",label:"Lieferantenauswertung"},
  ]},
  {id:"marktplaetze",label:"Marktplatzverwaltung",icon:"◎",children:[
    {id:"marktplaetze/kosten",label:"Marktplatzkosten"},
    {id:"__divider"},
    {id:"__group",label:"Zalando",isGroup:true},
    {id:"zalando/dashboard",label:"Dashboard"},
    {id:"zalando/bestellungen",label:"Bestellungen"},
    {id:"zalando/zfs-lager",label:"ZFS-Lager"},
    {id:"zalando/retouren",label:"Retouren"},
    {id:"zalando/sales-channels",label:"Sales Channels"},
    {id:"__divider"},
    {id:"__group",label:"About You",isGroup:true},
    {id:"aboutyou/dashboard",label:"Dashboard"},
    {id:"aboutyou/bestellungen",label:"Bestellungen"},
    {id:"aboutyou/produkte",label:"Produkte"},
    {id:"aboutyou/webhooks",label:"Webhooks"},
  ]},
  {id:"lager",label:"Lager",icon:"◧",children:[
    {id:"lager/bestand",label:"Bestand"},
    {id:"lager/ehrenfriedersdorf",label:"Ehrenfriedersdorf"},
    {id:"lager/zalando",label:"Zalando ZFS"},
    {id:"lager/aboutyou",label:"About You"},
    {id:"lager/auswertung",label:"Lagerauswertung"},
    {id:"__divider"},
    {id:"lager/konfiguration",label:"Konfiguration"},
  ]},
  {id:"versand",label:"Versanddienstleister",icon:"▶"},
  {id:"crm",label:"CRM",icon:"◉",children:[
    {id:"crm/dashboard",label:"Dashboard"},
    {id:"crm/firmen",label:"Firmen"},
    {id:"crm/kontakte",label:"Kontakte"},
    {id:"crm/leads",label:"Leads"},
    {id:"crm/sammlung",label:"Recherche-Sammlung"},
    {id:"crm/pipelines",label:"Pipelines"},
    {id:"crm/aufgaben",label:"Aufgaben"},
  ]},
  {id:"shops",label:"Shops",icon:"◈",children:[
    {id:"shops/uebersicht",label:"Shop-Übersicht"},
    {id:"shops/kategorien",label:"Kategoriebäume"},
    {id:"shops/coupons",label:"Coupons"},
    {id:"shops/bestellungen",label:"Bestellübersicht"},
  ]},
  {id:"email",label:"E-Mail",icon:"✉",children:[
    {id:"email/inbox",label:"Posteingang"},
    {id:"email/alle",label:"Alle Vorgänge"},
    {id:"email/erledigt",label:"Erledigt"},
    {id:"email/bausteine",label:"Textbausteine"},
    {id:"email/regeln",label:"Regelengine"},
    {id:"email/spam",label:"Spamfilter"},
    {id:"__divider"},
    {id:"chat",label:"Team-Chat",icon:"◉"},
  ]},
  {id:"dokumente",label:"Dokumente",icon:"◧",children:[
    {id:"dokumente/ablage",label:"Dateiablage"},
    {id:"dokumente/geteilt",label:"Geteilte Dateien"},
  ]},
  {id:"verwaltung",label:"Verwaltung",icon:"⚙",adminOnly:true,children:[
    {id:"verwaltung/benutzer",label:"Benutzerverwaltung"},
    {id:"verwaltung/rollen",label:"Rollenverwaltung"},
    {id:"verwaltung/schnittstellen",label:"Schnittstellen"},
    {id:"__divider"},
    {id:"__group",label:"E-Mail",isGroup:true},
    {id:"verwaltung/email-konten",label:"E-Mail-Konten"},
    {id:"verwaltung/email-vorlagen",label:"Vorlagen-Designer"},
  ]},
];

/* ─── Sidebar ─── */
const Sidebar=({nav,setNav,dark,setDark,currentUser,onLogout})=>{
  const [open,setOpen]=useState({auswertungen:false,cashflow:false,artikel:true,preise:false,einkauf:false,crm:false,email:false,shops:false,dokumente:false,verwaltung:false,marktplaetze:false});
  const toggle=id=>setOpen(o=>({...o,[id]:!o[id]}));
  const active=nav;
  const isAdmin=currentUser?.rolleName==="Admin";
  const NAV=NAV_STRUCTURE.filter(it=>!it.adminOnly||isAdmin);

  return<nav style={{width:220,height:"100vh",position:"sticky",top:0,background:"var(--sbg)",borderRight:"1px solid var(--brd)",padding:"0 0 16px",display:"flex",flexDirection:"column",flexShrink:0,overflow:"hidden"}}>
    {/* Logo */}
    <div style={{padding:"18px 14px 16px",borderBottom:"1px solid var(--brd)",display:"flex",alignItems:"center",gap:10}}>
      <div style={{width:32,height:32,borderRadius:8,background:"linear-gradient(135deg,var(--acc),var(--purple))",display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,color:"#fff",fontWeight:700,flexShrink:0}}>S</div>
      <div>
        <div style={{fontSize:15,fontWeight:700,letterSpacing:"-.5px",color:"var(--t1)",lineHeight:1.1}}>StyleOMat</div>
        <div style={{fontSize:9,color:"var(--t3)",letterSpacing:".5px",textTransform:"uppercase"}}>Fashion Intelligence</div>
      </div>
    </div>

    {/* Nav Items */}
    <div style={{flex:1,overflow:"auto",padding:"10px 8px"}}>
      {NAV.map(item=>{
        if(!item.children){
          return<button key={item.id} onClick={()=>setNav(item.id)}
            style={{display:"flex",alignItems:"center",gap:8,padding:"8px 8px",borderRadius:7,border:"none",width:"100%",background:active===item.id?"var(--sact)":"transparent",color:active===item.id?"var(--acc)":"var(--t2)",fontSize:13,fontWeight:active===item.id?600:400,cursor:"pointer",fontFamily:"inherit",textAlign:"left",transition:"all .12s",marginBottom:1}}
            onMouseEnter={e=>{if(active!==item.id)e.currentTarget.style.background="var(--shov)"}} onMouseLeave={e=>{if(active!==item.id)e.currentTarget.style.background="transparent"}}>
            <span style={{fontSize:14,width:16,textAlign:"center",flexShrink:0}}>{item.icon}</span>
            <span>{item.label}</span>
          </button>;
        }

        const isOpen=open[item.id];
        const hasActive=item.children.some(c=>c.id&&active.startsWith(c.id.split("/")[0]+"/"+c.id.split("/")[1])||active===c.id);

        return<div key={item.id} style={{marginBottom:1}}>
          <button onClick={()=>toggle(item.id)}
            style={{display:"flex",alignItems:"center",gap:8,padding:"8px 8px",borderRadius:7,border:"none",width:"100%",background:hasActive&&!isOpen?"var(--sact)":"transparent",color:hasActive?"var(--acc)":"var(--t2)",fontSize:13,fontWeight:hasActive?600:400,cursor:"pointer",fontFamily:"inherit",textAlign:"left",transition:"all .12s"}}
            onMouseEnter={e=>e.currentTarget.style.background=hasActive&&!isOpen?"var(--sact)":"var(--shov)"} onMouseLeave={e=>e.currentTarget.style.background=hasActive&&!isOpen?"var(--sact)":"transparent"}>
            <span style={{fontSize:14,width:16,textAlign:"center",flexShrink:0}}>{item.icon}</span>
            <span style={{flex:1}}>{item.label}</span>
            <span style={{fontSize:9,opacity:.5,transition:"transform .2s",transform:isOpen?"rotate(90deg)":"rotate(0deg)"}}>▶</span>
          </button>

          {isOpen&&<div style={{marginLeft:16,paddingLeft:8,borderLeft:"1px solid var(--brd)",marginTop:2,marginBottom:4}}>
            {item.children.map((child,ci)=>{
              if(child.id==="__divider")return<div key={ci} style={{height:1,background:"var(--brd)",margin:"4px 0"}}/>;
              if(child.isGroup)return<div key={child.label+ci} style={{fontSize:9,fontWeight:600,color:"var(--t3)",textTransform:"uppercase",letterSpacing:"1px",padding:"6px 8px 3px"}}>{child.label}</div>;
              const isAct=active===child.id;
              return<button key={child.id} onClick={()=>setNav(child.id)}
                style={{display:"flex",alignItems:"center",padding:"6px 8px",borderRadius:6,border:"none",width:"100%",background:isAct?"var(--sact)":"transparent",color:isAct?"var(--acc)":"var(--t2)",fontSize:12,fontWeight:isAct?600:400,cursor:"pointer",fontFamily:"inherit",textAlign:"left",transition:"all .12s",marginBottom:1}}
                onMouseEnter={e=>{if(!isAct)e.currentTarget.style.background="var(--shov)"}} onMouseLeave={e=>{if(!isAct)e.currentTarget.style.background="transparent"}}>
                {child.label}
              </button>;
            })}
          </div>}
        </div>;
      })}
    </div>

    {/* Footer */}
    <div style={{padding:"0 8px",borderTop:"1px solid var(--brd)",paddingTop:10,display:"flex",flexDirection:"column",gap:6}}>
      <SystemStatus/>
      <button onClick={()=>{if(window.confirm("Abmelden?")) onLogout&&onLogout();}} title="Klicken zum Abmelden"
        style={{display:"flex",alignItems:"center",gap:8,padding:"6px 8px",background:"transparent",border:"1px solid transparent",borderRadius:7,cursor:"pointer",fontFamily:"inherit",width:"100%",textAlign:"left"}}
        onMouseEnter={e=>{e.currentTarget.style.background="var(--shov)";e.currentTarget.style.borderColor="var(--brd)";}}
        onMouseLeave={e=>{e.currentTarget.style.background="transparent";e.currentTarget.style.borderColor="transparent";}}>
        <div style={{width:28,height:28,borderRadius:6,background:"var(--acc2)",color:"var(--acc)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,flexShrink:0}}>{(currentUser?.name||"?").split(" ").map(p=>p[0]).slice(0,2).join("")}</div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:11,fontWeight:600,color:"var(--t1)",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{currentUser?.name||"?"}</div>
          <div style={{fontSize:10,color:"var(--t3)"}}>{currentUser?.rolleName||"–"}</div>
        </div>
        <span style={{fontSize:12,color:"var(--t3)"}}>⎋</span>
      </button>
      <button onClick={()=>setDark(!dark)} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 8px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s1)",color:"var(--t2)",fontSize:11,cursor:"pointer",fontFamily:"inherit"}}>{dark?"☀":"☾"} {dark?"Light Mode":"Dark Mode"}</button>
    </div>
  </nav>;
};

/* ─── Page Title Map ─── */
const TITLES={
  "dashboard":"Dashboard",
  "cashflow":"Cashflow",
  "auswertungen/reports":"Reports & Analysen",
  "auswertungen/verkaufszahlen":"Verkaufszahlen",
  "auswertungen/bestseller":"Bestseller",
  "auswertungen/trends":"Trends",
  "auswertungen/performance":"Performance",
  "potentialanalyse":"Potentialanalyse",
  "artikel/order-files":"Order Files · Imports",
  "artikel/imports-ek":"Einkaufspreise · Imports",
  "artikel/panda-upload":"Panda Upload · Tradebyte",
  "artikel/panda-ansicht":"Panda Ansicht · Tradebyte",
  "artikel/ods-upload":"ODS Upload · Manuelle Verwaltung",
  "artikel/artikel-ansicht":"Artikelansicht · Manuelle Verwaltung",
  "artikel/jtl-ansicht":"Artikelansicht · JTL",
  "artikel/pflichtfelder":"Pflichtfelder",
  "artikel/attributfelder":"Attributfelder",
  "artikel/merkmale":"Merkmale",
  "artikel/bilder":"Artikelbildverwaltung",
  "verwaltung/benutzer":"Benutzerverwaltung",
  "verwaltung/rollen":"Rollenverwaltung",
  "verwaltung/schnittstellen":"Schnittstellenverwaltung",
  "preise/kalkulator":"Preiskalkulator",
  "preise/angebote":"Angebote",
  "einkauf/lieferanten":"Lieferantenverwaltung",
  "einkauf/preislisten":"Preislisten",
  "einkauf/preorder":"Preorder",
  "marktplaetze":"Marktplatzverwaltung",
  "marktplaetze/kosten":"Marktplatzkosten",
  "aboutyou/dashboard":"About You · Dashboard",
  "aboutyou/bestellungen":"About You · Bestellungen",
  "aboutyou/produkte":"About You · Produkte",
  "aboutyou/webhooks":"About You · Webhooks",
  "zalando/dashboard":"Zalando · Dashboard",
  "zalando/bestellungen":"Zalando · Bestellungen",
  "zalando/zfs-lager":"Zalando · ZFS-Lager",
  "zalando/retouren":"Zalando · Retouren",
  "zalando/sales-channels":"Zalando · Sales Channels",
  "bestellungen":"Bestellungen",
  "bestellungen/auftraege":"Bestellungen · Aufträge",
  "bestellungen/retouren":"Bestellungen · Retouren",
  "bestellungen/stornos":"Bestellungen · Stornos",
  "bestellungen/artikel":"Bestellungen · Verkaufte Artikel",
  "bestellungen/kanaele":"Bestellungen · Kanäle",
  "lager":"Lager",
  "lager/bestand":"Lager · Bestand",
  "lager/ehrenfriedersdorf":"Lager · Ehrenfriedersdorf",
  "lager/zalando":"Lager · Zalando ZFS",
  "lager/aboutyou":"Lager · About You",
  "lager/auswertung":"Lager · Auswertung",
  "lager/konfiguration":"Lager · Konfiguration",
  "lieferanten":"Lieferantenverwaltung",
  "versand":"Versanddienstleister",
  "artikel/kategoriemapping":"Kategoriezuordnung · JTL",
  "cashflow/uebersicht":"Cashflow Übersicht",
  "cashflow/kontostände":"Kontostände",
  "buchhaltung":"Buchhaltung",
  "buchhaltung/uebersicht":"Buchhaltung – GDPdU Importe",
  "buchhaltung/zahlungsverkehr":"Zahlungsverkehr – Monatsverkehrszahlen",
  "buchhaltung/buchungssaetze":"Buchungssatzprotokoll {jahr}",
  "buchhaltung/kontennachweis":"Kontennachweis {jahr}",
  "buchhaltung/inventar":"Inventar & Anlagevermögen",
  "buchhaltung/afa":"AfA – Abschreibungen",
  "buchhaltung/bwa":"BWA – Betriebswirtschaftliche Auswertung {jahr}",
  "buchhaltung/banken":"Banken – Monatliche Kontostände {jahr}",
  "buchhaltung/mitarbeiter":"Mitarbeiter – Personalkosten {jahr}",
  "buchhaltung/lieferanten":"Lieferanten – Monatskosten",
  "buchhaltung/marktplatz":"Marktplatz – Umsätze & Kosten",
  "buchhaltung/it":"IT – Kostenliste",
  "buchhaltung/bilanz":"Bilanz (Kontennachweis Jahresabschluss)",
  "einkauf/artikeleinkaufspreise":"Artikeleinkaufspreise",
  "einkauf/lieferantenauswertung":"Lieferantenauswertung",
  "crm/dashboard":"CRM Dashboard",
  "crm/sammlung":"Recherche-Sammlung",
  "crm/firmen":"Firmen",
  "crm/kontakte":"Kontakte",
  "crm/leads":"Leads",
  "crm/pipelines":"Pipelines",
  "crm/aufgaben":"Aufgaben",
  "shops/uebersicht":"Shop-Übersicht",
  "shops/kategorien":"Kategoriebäume",
  "shops/coupons":"Coupons",
  "shops/bestellungen":"Bestellübersicht",
  "verwaltung/email-konten":"E-Mail-Konten",
  "verwaltung/email-vorlagen":"E-Mail Vorlagen-Designer",
  "email/inbox":"Posteingang",
  "email/alle":"Alle Vorgänge",
  "email/erledigt":"Erledigt",
  "email/bausteine":"Textbausteine",
  "chat":"Team-Chat",
  "email/regeln":"Regelengine",
  "email/spam":"Spamfilter",
  "dokumente/ablage":"Dateiablage",
  "dokumente/geteilt":"Geteilte Dateien",
};

/* ─── Potentialanalyse · Tab "Fashion Cloud" – FC-Artikel vs. Panda ─── */
const PotentialFashionCloud=()=>{
  const [rows,setRows]=useState([]);
  const [brands,setBrands]=useState([]);
  const [marke,setMarke]=useState("");
  const [search,setSearch]=useState("");
  const [inPanda,setInPanda]=useState(""); // ""=alle, "1"=nur Panda, "0"=nur fehlend
  const [skip,setSkip]=useState(0);
  const [limit]=useState(100);
  const [meta,setMeta]=useState({total:0,totalAll:0,inPandaCount:0,inPandaByEan:0,inPandaByHan:0,outsideCount:0,pandaEansLoaded:0,pandaHansLoaded:0});
  const [loading,setLoading]=useState(false);

  const load=async()=>{
    setLoading(true);
    try{
      const qs=new URLSearchParams({skip:String(skip),limit:String(limit)});
      if(marke)qs.set("marke",marke);
      if(search)qs.set("search",search);
      if(inPanda)qs.set("inPanda",inPanda);
      const r=await fetch("/api/recherche/fashioncloud/potential?"+qs);
      const j=await r.json();
      setRows(j.rows||[]);
      setMeta({total:j.total||0,totalAll:j.totalAll||0,inPandaCount:j.inPandaCount||0,inPandaByEan:j.inPandaByEan||0,inPandaByHan:j.inPandaByHan||0,outsideCount:j.outsideCount||0,pandaEansLoaded:j.pandaEansLoaded||0,pandaHansLoaded:j.pandaHansLoaded||0});
    }catch(e){console.error(e);}
    finally{setLoading(false);}
  };
  useEffect(()=>{
    fetch("/api/recherche/fashioncloud/brands").then(r=>r.json())
      .then(j=>setBrands((j.brands||[]).filter(b=>b.productCount>0).map(b=>b.name).sort()))
      .catch(()=>{});
  },[]);
  useEffect(()=>{load();},[marke,search,inPanda,skip]);
  useEffect(()=>{setSkip(0);},[marke,search,inPanda]);

  const pct=meta.totalAll>0?Math.round(meta.inPandaCount/meta.totalAll*1000)/10:0;
  const InSt={padding:"6px 10px",background:"var(--bg)",border:"1px solid var(--brd)",borderRadius:6,color:"var(--t1)",fontSize:12};

  return<>
    <Card>
      <div style={{display:"flex",gap:12,flexWrap:"wrap",alignItems:"center",marginBottom:12}}>
        <div style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>Fashion Cloud · Artikel vs. Panda</div>
        <div style={{fontSize:11,color:"var(--t3)"}}>Panda · EANs: {meta.pandaEansLoaded.toLocaleString("de-DE")} · HANs: {meta.pandaHansLoaded.toLocaleString("de-DE")}</div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(170px,1fr))",gap:8,marginBottom:12}}>
        <StatBox label="FC-Artikel (Filter)" value={meta.totalAll.toLocaleString("de-DE")}/>
        <StatBox label="im Panda" value={meta.inPandaCount.toLocaleString("de-DE")} sub={pct+"% · EAN "+meta.inPandaByEan.toLocaleString("de-DE")+" · HAN "+meta.inPandaByHan.toLocaleString("de-DE")}/>
        <StatBox label="fehlend in Panda" value={meta.outsideCount.toLocaleString("de-DE")} sub={(100-pct).toFixed(1)+"%"}/>
        <StatBox label="Treffer in Ansicht" value={meta.total.toLocaleString("de-DE")}/>
      </div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginBottom:10}}>
        <select value={marke} onChange={e=>setMarke(e.target.value)} style={InSt}>
          <option value="">Alle Marken ({brands.length})</option>
          {brands.map(b=><option key={b} value={b}>{b}</option>)}
        </select>
        <select value={inPanda} onChange={e=>setInPanda(e.target.value)} style={InSt}>
          <option value="">Alle Artikel</option>
          <option value="1">✓ Nur im Panda</option>
          <option value="0">✗ Nur fehlend</option>
        </select>
        <input placeholder="Suche · EAN, Artikelnr., Name" value={search}
          onChange={e=>setSearch(e.target.value)}
          style={{...InSt,minWidth:240,flex:1}}/>
        <Btn onClick={load} disabled={loading}>{loading?"Lade…":"↻"}</Btn>
      </div>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead>
            <tr style={{borderBottom:"1px solid var(--brd)"}}>
              {["Status","Marke","Artikel-Nr.","Bezeichnung","Name (Panda)","Hersteller-Nr.","EAN","Saison"].map(h=>
                <th key={h} style={{padding:"8px 10px",fontSize:10,textTransform:"uppercase",letterSpacing:".5px",color:"var(--t3)",textAlign:"left",fontWeight:600}}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((r,i)=><tr key={r.fc_id||i} style={{borderBottom:"1px solid var(--brd)"}}>
              <td style={{padding:"8px 10px",whiteSpace:"nowrap"}}>
                {r.inPanda
                  ? <span title={r.matchType==="ean"?"Match via EAN":"Match via Hersteller-Artikelnr."} style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:"var(--grn2)",color:"var(--grn)"}}>✓ {r.matchType==="ean"?"EAN":r.matchType==="han"?"HAN":"Panda"}</span>
                  : <span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:"var(--red2)",color:"var(--red)"}}>✗ fehlt</span>}
              </td>
              <td style={{padding:"8px 10px",color:"var(--t1)"}}>{r.marke||"–"}</td>
              <td style={{padding:"8px 10px",color:"var(--t2)",fontFamily:"monospace"}}>{r.artikelnummer||"–"}</td>
              <td style={{padding:"8px 10px",color:"var(--t1)"}}>{r.bezeichnung||r.modellname||"–"}</td>
              <td style={{padding:"8px 10px",color:r.pandaName?"var(--t1)":"var(--t3)"}}>{r.pandaName||"–"}</td>
              <td style={{padding:"8px 10px",color:"var(--t2)",fontFamily:"monospace"}}>{r.hersteller_artikelnr||"–"}</td>
              <td style={{padding:"8px 10px",color:"var(--t2)",fontFamily:"monospace"}}>{r.ean||"–"}</td>
              <td style={{padding:"8px 10px",color:"var(--t2)"}}>{r.saison||"–"}</td>
            </tr>)}
            {!rows.length && !loading && <tr><td colSpan={9} style={{padding:"24px 10px",textAlign:"center",color:"var(--t3)"}}>Keine Treffer</td></tr>}
          </tbody>
        </table>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:12,fontSize:12,color:"var(--t3)"}}>
        <div>Zeile {meta.total?skip+1:0} – {Math.min(skip+limit,meta.total)} von {meta.total.toLocaleString("de-DE")}</div>
        <div style={{display:"flex",gap:8}}>
          <Btn onClick={()=>setSkip(Math.max(0,skip-limit))} disabled={skip===0||loading}>◀ Zurück</Btn>
          <Btn onClick={()=>setSkip(skip+limit)} disabled={skip+limit>=meta.total||loading}>Weiter ▶</Btn>
        </div>
      </div>
    </Card>
  </>;
};
const StatBox=({label,value,sub})=>(
  <div style={{padding:"10px 12px",borderRadius:6,background:"var(--s2)",border:"1px solid var(--brd)"}}>
    <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px"}}>{label}</div>
    <div style={{fontSize:18,fontWeight:700,color:"var(--t1)",marginTop:3}}>{value}</div>
    {sub&&<div style={{fontSize:10,color:"var(--t3)",marginTop:1}}>{sub}</div>}
  </div>
);

/* ─── Potentialanalyse (Konzept-Status – Sprints noch nicht implementiert) ─── */
const Potentialanalyse=()=>{
  const [tab,setTab]=useState("fashioncloud");
  const TabBtn=({id,label})=>(
    <button onClick={()=>setTab(id)}
      style={{padding:"8px 16px",border:"1px solid var(--brd)",borderRadius:6,background:tab===id?"var(--acc)":"var(--bg)",color:tab===id?"#fff":"var(--t1)",fontSize:12,fontWeight:600,cursor:"pointer"}}>{label}</button>
  );
  return<>
    <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
      <TabBtn id="fashioncloud" label="Fashion Cloud"/>
      <TabBtn id="konzept" label="Konzept · Sprints"/>
    </div>
    {tab==="fashioncloud"?<PotentialFashionCloud/>:<PotentialKonzept/>}
  </>;
};
const PotentialKonzept=()=>{
  const sprints=[
    {nr:"0",t:"Konfigurations-Modul",sub:"data_source_configs · AES-256-GCM · Rollen · Test-Connection · UI unter Verwaltung",status:"geplant"},
    {nr:"1",t:"Fashion Cloud Import",sub:"reference_products · ReferenceBrands · Stream-Import · BullMQ-Scheduler",status:"geplant"},
    {nr:"2",t:"UI Referenzkatalog",sub:"Tabelle/Filter · Flag 'im Portfolio' · Beobachtungskandidat · Detail-View",status:"geplant"},
    {nr:"3",t:"Crawler About You",sub:"SitemapDiscovery · UrlQueue · PDP-Parser (JSON-LD) · EAN-Match · ObservationWriter",status:"geplant"},
    {nr:"4",t:"Crawler Zalando",sub:"GraphQL vs. Kategorie-Crawl · ggf. Playwright · Parser + Writer",status:"geplant"},
    {nr:"5",t:"Analyse-Schicht",sub:"demand_score 0–100 · Cross-Marketplace · Preisstabilität · Brand-Priority",status:"geplant"},
    {nr:"6",t:"UI Potentialanalyse",sub:"Top-50 Nachorder-Kandidaten · Verfügbarkeits-Zeitreihe · Aktionen · CSV-Export",status:"geplant"},
  ];
  const offene=[
    {t:"Fashion-Cloud-Exportformate & Zugangsweg",prio:"hoch"},
    {t:"Zalando Partner API als legale Alternative",prio:"mittel"},
    {t:"About You: Partner-API (OpenAPI liegt vor) vs. Frontend-Crawl",prio:"mittel"},
    {t:"Rechtliche Freigabe Scraping-MVP",prio:"hoch vor Produktiv"},
    {t:"Größen-Normalisierung EU/UK/US/NUM",prio:"mittel"},
    {t:"Referenzartikel ↔ JTL-Artikel nach Big-Bang",prio:"mittel"},
    {t:"Proxy-/UA-Strategie (erst bei Blocking)",prio:"niedrig"},
  ];
  return<>
    <Card>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10,flexWrap:"wrap",gap:12}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:20}}>◬</span>
          <div>
            <div style={{fontSize:14,fontWeight:600,color:"var(--t1)"}}>Potentialanalyse · Sold-Out-Detection</div>
            <div style={{fontSize:11,color:"var(--t3)",marginTop:2}}>Nachorder-Entscheidungen aus realer Marktnachfrage (Zalando · About You · Fashion Cloud)</div>
          </div>
        </div>
        <span style={{padding:"4px 10px",borderRadius:4,fontSize:10,fontWeight:600,background:"var(--ylw2)",color:"var(--ylw)",textTransform:"uppercase",letterSpacing:".5px"}}>Konzept</span>
      </div>
      <div style={{fontSize:12,color:"var(--t2)",lineHeight:1.6,padding:"12px 14px",borderRadius:8,background:"var(--s2)",border:"1px solid var(--brd)",marginTop:4}}>
        <strong style={{color:"var(--t1)"}}>Leitsatz:</strong> Wenn ein Artikel bei Zalando / About You in vielen Größen ausverkauft ist → hohe Nachfrage → Nachorder-Kandidat. Zwei Stufen: <strong>Stufe 1</strong> Fashion Cloud als Stamm-Referenzkatalog · <strong>Stufe 2</strong> Sitemap-basierte Crawler beobachten Live-Verfügbarkeit und matchen gegen die Referenz. Daraus entsteht ein <strong>Demand Score (0–100)</strong> als Sortier-Key.
      </div>
    </Card>

    <Card>
      <div style={{fontSize:13,fontWeight:600,color:"var(--t1)",marginBottom:12}}>Umsetzungs-Sprints</div>
      <div style={{display:"grid",gridTemplateColumns:"40px 1fr 90px",gap:8,fontSize:12}}>
        <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:6}}>Sprint</div>
        <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:6}}>Thema</div>
        <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:6}}>Status</div>
        {sprints.map(s=><React.Fragment key={s.nr}>
          <div style={{padding:"10px 0",borderBottom:"1px solid var(--brd)",fontWeight:700,color:"var(--acc)"}}>#{s.nr}</div>
          <div style={{padding:"10px 0",borderBottom:"1px solid var(--brd)"}}>
            <div style={{color:"var(--t1)",fontWeight:600}}>{s.t}</div>
            <div style={{color:"var(--t3)",fontSize:11,marginTop:2}}>{s.sub}</div>
          </div>
          <div style={{padding:"10px 0",borderBottom:"1px solid var(--brd)"}}>
            <span style={{padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:600,background:"var(--s3)",color:"var(--t3)"}}>{s.status}</span>
          </div>
        </React.Fragment>)}
      </div>
    </Card>

    <Card>
      <div style={{fontSize:13,fontWeight:600,color:"var(--t1)",marginBottom:12}}>Offene Punkte</div>
      <div style={{display:"flex",flexDirection:"column",gap:6,fontSize:12}}>
        {offene.map((o,i)=><div key={i} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 10px",borderRadius:6,background:"var(--s2)",border:"1px solid var(--brd)"}}>
          <span style={{color:"var(--t1)"}}>{o.t}</span>
          <span style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px"}}>{o.prio}</span>
        </div>)}
      </div>
    </Card>
  </>;
};

/* ─── Order Files (Imports · Platzhalter) ─── */
const OrderFiles=()=>{
  const [files,setFiles]=useState([]);
  const [loading,setLoading]=useState(false);
  const load=()=>{
    setLoading(true);
    fetch("/api/orderfiles/files").then(r=>r.ok?r.json():Promise.reject())
      .then(d=>setFiles(Array.isArray(d)?d:(d?.files||[])))
      .catch(()=>setFiles([]))
      .finally(()=>setLoading(false));
  };
  useEffect(()=>{load();},[]);
  return<>
    <Card>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <div>
          <div style={{fontSize:14,fontWeight:600,color:"var(--t1)"}}>Order Files</div>
          <div style={{fontSize:11,color:"var(--t3)",marginTop:2}}>MinIO-Ablage: <code>artikeldaten/order-files/</code> — Lieferanten-Orderfiles (Bestelllisten, Masterdata, EAN-Listen)</div>
        </div>
        <Btn onClick={load} disabled={loading}>{loading?"Lade…":"↻ Aktualisieren"}</Btn>
      </div>
      {!loading && !files.length && <EmptyState icon="◧" title="Noch keine Order Files" sub="Lade Lieferanten-Orderfiles nach artikeldaten/order-files/ hoch"/>}
      {!!files.length && <div style={{display:"grid",gridTemplateColumns:"1fr 120px 160px",gap:6,fontSize:12}}>
        <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:6}}>Datei</div>
        <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:6}}>Größe</div>
        <div style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:6}}>Hochgeladen</div>
        {files.map((f,i)=><React.Fragment key={i}>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.name||f.key}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{f.size?Math.round(f.size/1024)+" KB":"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{f.lastModified?fmtDT(f.lastModified):"–"}</div>
        </React.Fragment>)}
      </div>}
    </Card>
  </>;
};

/* ─── Einkaufspreise-Import (Flow 1: Stammdaten → EK) ─── */
const EinkaufspreiseImport=()=>{
  const [logs,setLogs]=useState([]);
  const [detail,setDetail]=useState(null);
  const [running,setRunning]=useState(false);
  const [dryRun,setDryRun]=useState(true);
  const [msg,setMsg]=useState("");
  const [err,setErr]=useState("");

  const loadLogs=async()=>{
    try{
      const r=await fetch("/api/imports/einkaufspreise/logs?limit=30");
      const j=await r.json(); setLogs(j.logs||[]);
    }catch{}
  };
  useEffect(()=>{loadLogs();},[]);

  const start=async()=>{
    setRunning(true); setMsg(""); setErr("");
    try{
      const r=await fetch(`/api/imports/einkaufspreise/stammdaten-run?dryRun=${dryRun}`,{method:"POST"});
      const j=await r.json();
      if(!r.ok) throw new Error(j.message||"Start fehlgeschlagen");
      const runId=j.runId;
      setMsg(`Run ${runId} gestartet${j.dryRun?" (Trockenlauf)":""} – läuft im Hintergrund. Aktualisiere gleich die Liste…`);
      // Poll bis fertig (status !== "running")
      for(let i=0;i<240;i++){ // bis zu 20 Min · 5s · 240
        await new Promise(r=>setTimeout(r,5000));
        await loadLogs();
        const rr=await fetch(`/api/imports/einkaufspreise/logs/${runId}`);
        const jj=await rr.json().catch(()=>({}));
        if(rr.ok && jj.log && jj.log.status && jj.log.status!=="running"){
          const s=jj.log.summary||{};
          setMsg(`Run ${runId} fertig: ${s.filesScanned||0} Files, ${s.rowsParsed||0} Zeilen, ${s.rowsWithEk||0} mit EK, ${s.articlesMatched||0} gematcht, ${s.articlesUpdated||0} aktualisiert`);
          setDetail(jj.log);
          break;
        }
      }
    }catch(ex){setErr(ex.message);}
    setRunning(false);
  };

  const openDetail=async(runId)=>{
    try{
      const r=await fetch(`/api/imports/einkaufspreise/logs/${runId}`);
      const j=await r.json();
      if(r.ok && j.log) setDetail(j.log);
    }catch{}
  };

  const statusColor=(s)=>s?.filesWithError>0?"var(--red)":(s?.articlesUpdated>0?"var(--grn)":"var(--ylw)");

  return<>
    <Card>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14,gap:12,flexWrap:"wrap"}}>
        <div>
          <div style={{fontSize:14,fontWeight:600,color:"var(--t1)"}}>Einkaufspreise · Flow 1 (Stammdaten)</div>
          <div style={{fontSize:11,color:"var(--t3)",marginTop:2,lineHeight:1.5}}>
            Scannt <code>artikeldaten/stammdaten/</code>, extrahiert EK aus den Hersteller-Stammdaten, plausibilisiert (0,50–2000 €),<br/>
            matcht Artikel per EAN → HAN+Größe und schreibt den EK am Artikel weg. Log als JSON im MinIO + MongoDB.
          </div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <label style={{fontSize:11,color:"var(--t2)",display:"flex",alignItems:"center",gap:6,cursor:"pointer"}}>
            <input type="checkbox" checked={dryRun} onChange={e=>setDryRun(e.target.checked)}/>
            Trockenlauf (nichts schreiben)
          </label>
          <Btn primary onClick={start} disabled={running}>{running?"Läuft…":"▶ Durchlauf 1 starten"}</Btn>
        </div>
      </div>
      {msg&&<div style={{padding:"8px 12px",borderRadius:6,background:"var(--grn2)",color:"var(--grn)",fontSize:11,marginBottom:8}}>{msg}</div>}
      {err&&<div style={{padding:"8px 12px",borderRadius:6,background:"var(--red2)",color:"var(--red)",fontSize:11,marginBottom:8}}>{err}</div>}
    </Card>

    <Card>
      <div style={{fontSize:13,fontWeight:600,color:"var(--t1)",marginBottom:10}}>Letzte Durchläufe</div>
      {!logs.length&&<EmptyState icon="◧" title="Noch keine Durchläufe" sub="Starte oben einen ersten Durchlauf (gern erst als Trockenlauf)"/>}
      {!!logs.length&&<div style={{display:"grid",gridTemplateColumns:"140px 80px 70px 80px 80px 80px 80px 80px 80px 90px 60px",gap:6,fontSize:12}}>
        {["Start","Dauer","Files","Zeilen","Mit EK","Matched","Updated","Impl.","No-Match","Mode",""].map((h,i)=>
          <div key={i} style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:6}}>{h}</div>
        )}
        {logs.map(l=><React.Fragment key={l._id||l.runId}>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)",fontSize:11}}>{fmtDT(l.startedAt)}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{l.durationMs?Math.round(l.durationMs/100)/10+"s":"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",fontWeight:600}}>{l.summary?.filesScanned??"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{l.summary?.rowsParsed??"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{l.summary?.rowsWithEk??"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{l.summary?.articlesMatched??"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:statusColor(l.summary),fontWeight:600}}>{l.summary?.articlesUpdated??"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:l.summary?.implausible?"var(--red)":"var(--t3)"}}>{l.summary?.implausible??0}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:l.summary?.noMatch?"var(--ylw)":"var(--t3)"}}>{l.summary?.noMatch??0}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)"}}>
            <span style={{padding:"1px 6px",borderRadius:3,fontSize:9,fontWeight:600,background:l.dryRun?"var(--ylw2)":"var(--grn2)",color:l.dryRun?"var(--ylw)":"var(--grn)"}}>{l.dryRun?"DRY":"LIVE"}</span>
          </div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)"}}>
            <Btn small onClick={()=>openDetail(l._id||l.runId)}>Detail</Btn>
          </div>
        </React.Fragment>)}
      </div>}
    </Card>

    {detail&&<Modal open={true} onClose={()=>setDetail(null)} title={`Run ${detail.runId} · ${detail.dryRun?"Trockenlauf":"Live"}`} width={900}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:14}}>
        <KPI title="Files" value={detail.summary?.filesScanned||0} sub={`${detail.summary?.filesWithError||0} Fehler`} icon="◧" accent="var(--acc)"/>
        <KPI title="Zeilen" value={detail.summary?.rowsParsed||0} sub={`${detail.summary?.rowsWithEk||0} mit EK`} icon="≡" accent="var(--acc)"/>
        <KPI title="Artikel aktualisiert" value={detail.summary?.articlesUpdated||0} sub={`${detail.summary?.articlesMatched||0} gematcht`} icon="✓" accent="var(--grn)"/>
        <KPI title="Probleme" value={(detail.summary?.implausible||0)+(detail.summary?.noMatch||0)} sub={`${detail.summary?.implausible||0} implausibel / ${detail.summary?.noMatch||0} kein Match`} icon="⚠" accent="var(--ylw)"/>
      </div>
      <div style={{fontSize:12,fontWeight:600,color:"var(--t1)",marginBottom:8}}>Pro Datei</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 90px 70px 70px 70px 70px 80px",gap:6,fontSize:11,marginBottom:14}}>
        {["Datei","Marke","Zeilen","EK","Match","Updated","Fehler"].map((h,i)=>
          <div key={i} style={{fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:5}}>{h}</div>
        )}
        {(detail.files||[]).map((f,i)=><React.Fragment key={i}>
          <div style={{padding:"6px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={f.datei}>{f.datei}</div>
          <div style={{padding:"6px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{f.marke||"–"}</div>
          <div style={{padding:"6px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{f.zeilen}</div>
          <div style={{padding:"6px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{f.mitEk}</div>
          <div style={{padding:"6px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{f.articlesMatched}</div>
          <div style={{padding:"6px 0",borderBottom:"1px solid var(--brd)",color:f.articlesUpdated?"var(--grn)":"var(--t3)",fontWeight:600}}>{f.articlesUpdated}</div>
          <div style={{padding:"6px 0",borderBottom:"1px solid var(--brd)",color:f.error?"var(--red)":"var(--t3)",fontSize:10,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={f.error||""}>{f.error||"–"}</div>
        </React.Fragment>)}
      </div>
      {!!detail.issues?.length&&<>
        <div style={{fontSize:12,fontWeight:600,color:"var(--t1)",marginBottom:8}}>Issues ({detail.issues.length})</div>
        <div style={{maxHeight:260,overflowY:"auto",border:"1px solid var(--brd)",borderRadius:6}}>
          <div style={{display:"grid",gridTemplateColumns:"110px 80px 120px 110px 60px 1fr",gap:6,fontSize:11,padding:"0 10px"}}>
            {["Typ","Marke","Datei","HAN/EAN","EK","Details"].map((h,i)=>
              <div key={i} style={{fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",padding:"8px 0",borderBottom:"1px solid var(--brd)",background:"var(--s2)",position:"sticky",top:0}}>{h}</div>
            )}
            {detail.issues.slice(0,200).map((i,k)=><React.Fragment key={k}>
              <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)"}}>
                <span style={{padding:"1px 6px",borderRadius:3,fontSize:9,fontWeight:600,background:"var(--s3)",color:"var(--t2)"}}>{i.typ}</span>
              </div>
              <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{i.marke||"–"}</div>
              <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t3)",fontSize:10,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={i.datei}>{i.datei}</div>
              <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)",fontSize:10}}>{i.han||i.ean||"–"}{i.groesse?` · ${i.groesse}`:""}</div>
              <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{i.ek??"–"}</div>
              <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t3)",fontSize:10}}>{i.details||""}</div>
            </React.Fragment>)}
          </div>
        </div>
      </>}
    </Modal>}
  </>;
};

/* ─── Einkaufspreise-Import (Flow 2: Preislisten) ─── */
const PreislistenImport=()=>{
  const [logs,setLogs]=useState([]);
  const [stats,setStats]=useState([]);
  const [match,setMatch]=useState(null);
  const [detail,setDetail]=useState(null);
  const [running,setRunning]=useState(false);
  const [msg,setMsg]=useState("");
  const [err,setErr]=useState("");

  const loadLogs=async()=>{
    try{
      const r=await fetch("/api/imports/einkaufspreise/preislisten/logs?limit=20");
      const j=await r.json(); setLogs(j.logs||[]);
    }catch{}
  };
  const loadStats=async()=>{
    try{
      const r=await fetch("/api/imports/einkaufspreise/preislisten/stats-by-brand");
      const j=await r.json(); setStats(j.stats||[]);
    }catch{}
  };
  const loadMatch=async()=>{
    try{
      const r=await fetch("/api/imports/einkaufspreise/preislisten/matching-report");
      const j=await r.json(); setMatch(j);
    }catch{}
  };
  useEffect(()=>{loadLogs();loadStats();},[]);

  const start=async()=>{
    setRunning(true); setMsg(""); setErr("");
    try{
      const r=await fetch("/api/imports/einkaufspreise/preislisten-run",{method:"POST"});
      const j=await r.json();
      if(!r.ok) throw new Error(j.message||"Start fehlgeschlagen");
      const runId=j.runId;
      setMsg(`Run ${runId} gestartet – läuft im Hintergrund…`);
      for(let i=0;i<360;i++){
        await new Promise(r=>setTimeout(r,5000));
        await loadLogs();
        const rr=await fetch(`/api/imports/einkaufspreise/preislisten/logs/${runId}`);
        const jj=await rr.json().catch(()=>({}));
        if(rr.ok && jj.log && jj.log.status && jj.log.status!=="running"){
          const s=jj.log.summary||{};
          setMsg(`Run ${runId} fertig: ${s.filesScanned||0} Files, ${s.rowsParsed||0} Zeilen, ${s.rowsWithEk||0} mit EK`);
          setDetail(jj.log);
          loadStats(); loadMatch();
          break;
        }
      }
    }catch(ex){setErr(ex.message);}
    setRunning(false);
  };

  const openDetail=async(runId)=>{
    try{
      const r=await fetch(`/api/imports/einkaufspreise/preislisten/logs/${runId}`);
      const j=await r.json();
      if(r.ok && j.log) setDetail(j.log);
    }catch{}
  };

  return<>
    <Card>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:14,gap:12,flexWrap:"wrap"}}>
        <div>
          <div style={{fontSize:14,fontWeight:600,color:"var(--t1)"}}>Einkaufspreise · Flow 2 (Preislisten)</div>
          <div style={{fontSize:11,color:"var(--t3)",marginTop:2,lineHeight:1.5}}>
            Scannt <code>einkauf/Preislisten/&lt;Marke&gt;/</code> (XLSX, CSV, PDF), extrahiert EK-Netto + EAN/HAN/sonstige Artikelnummer.<br/>
            Daten werden in <code>einkauf.preislisten_extrakt</code> abgelegt und können später gegen Lager/Tradebyte gematcht werden.
          </div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <Btn primary onClick={start} disabled={running}>{running?"Läuft…":"▶ Durchlauf 2 starten"}</Btn>
        </div>
      </div>
      {msg&&<div style={{padding:"8px 12px",borderRadius:6,background:"var(--grn2)",color:"var(--grn)",fontSize:11,marginBottom:8}}>{msg}</div>}
      {err&&<div style={{padding:"8px 12px",borderRadius:6,background:"var(--red2)",color:"var(--red)",fontSize:11,marginBottom:8}}>{err}</div>}
    </Card>

    {!!stats.length&&<Card>
      <div style={{fontSize:13,fontWeight:600,color:"var(--t1)",marginBottom:10}}>Statistik pro Marke</div>
      <div style={{maxHeight:320,overflowY:"auto"}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 70px 80px 80px 80px 80px 80px",gap:6,fontSize:11}}>
          {["Marke","Files","Zeilen","Mit EK","EAN","HAN","Sonstige"].map((h,i)=>
            <div key={i} style={{fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:5,position:"sticky",top:0,background:"var(--s1)"}}>{h}</div>
          )}
          {stats.map((s,i)=><React.Fragment key={i}>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",fontWeight:600}}>{s._id||"(ohne)"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{s.files??s.dateien??"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{s.rows??"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:(s.mitEk??s.withEk)?"var(--grn)":"var(--ylw)",fontWeight:600}}>{s.mitEk??s.withEk??"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{s.mitEan??s.withEan??"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{s.mitHan??s.withHan??"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{s.mitSonstige??s.withSonstige??"–"}</div>
          </React.Fragment>)}
        </div>
      </div>
    </Card>}

    <Card>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
        <div style={{fontSize:13,fontWeight:600,color:"var(--t1)"}}>Matching gegen Artikelstamm</div>
        <Btn small onClick={loadMatch}>{match?"Aktualisieren":"Laden (kann ~2 s dauern)"}</Btn>
      </div>
      <div style={{fontSize:11,color:"var(--t3)",marginBottom:10}}>
        Wie viele der in Flow 2 gefundenen EANs/HANs sind im Artikelstamm (xtradepanda.articles) vorhanden?
      </div>
    {match&&!!match.brands?.length&&<>
      <div style={{display:"grid",gridTemplateColumns:"1fr 70px 70px 80px 70px 80px",gap:6,fontSize:11}}>
        {["Marke","EANs","EAN Hit","EAN Hit%","HANs","HAN Hit"].map((h,i)=>
          <div key={i} style={{fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:5}}>{h}</div>
        )}
        {match.brands.map((b,i)=>{
          const pct=b.eansTotal?Math.round((b.eansMatched/b.eansTotal)*100):0;
          return<React.Fragment key={i}>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",fontWeight:600}}>{b.brand||"(ohne)"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{b.eansTotal??0}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:b.eansMatched?"var(--grn)":"var(--t3)",fontWeight:600}}>{b.eansMatched??0}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:pct>50?"var(--grn)":(pct>0?"var(--ylw)":"var(--red)")}}>{pct}%</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{b.hansTotal??0}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:b.hansMatched?"var(--grn)":"var(--t3)",fontWeight:600}}>{b.hansMatched??0}</div>
          </React.Fragment>;
        })}
      </div>
    </>}
    </Card>

    <Card>
      <div style={{fontSize:13,fontWeight:600,color:"var(--t1)",marginBottom:10}}>Letzte Durchläufe (Flow 2)</div>
      {!logs.length&&<EmptyState icon="◧" title="Noch keine Flow-2-Durchläufe" sub="Oben starten"/>}
      {!!logs.length&&<div style={{display:"grid",gridTemplateColumns:"140px 80px 70px 80px 80px 80px 80px 60px",gap:6,fontSize:12}}>
        {["Start","Dauer","Files","Zeilen","Mit EK","EAN","Errors",""].map((h,i)=>
          <div key={i} style={{fontSize:10,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:6}}>{h}</div>
        )}
        {logs.map(l=><React.Fragment key={l._id||l.runId}>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)",fontSize:11}}>{fmtDT(l.startedAt)}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{l.durationMs?Math.round(l.durationMs/100)/10+"s":(l.status==="running"?"läuft":"–")}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",fontWeight:600}}>{l.summary?.filesScanned??"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{l.summary?.rowsParsed??"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--grn)",fontWeight:600}}>{l.summary?.rowsWithEk??"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{l.summary?.rowsWithEan??"–"}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)",color:l.summary?.filesWithError?"var(--red)":"var(--t3)",fontWeight:600}}>{l.summary?.filesWithError??0}</div>
          <div style={{padding:"8px 0",borderBottom:"1px solid var(--brd)"}}>
            <Btn small onClick={()=>openDetail(l._id||l.runId)}>Detail</Btn>
          </div>
        </React.Fragment>)}
      </div>}
    </Card>

    {detail&&<Modal open={true} onClose={()=>setDetail(null)} title={`Preislisten-Run ${detail.runId}`} width={1000}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10,marginBottom:14}}>
        <KPI title="Files" value={detail.summary?.filesScanned||0} sub={`${detail.summary?.filesWithError||0} Fehler`} icon="◧" accent="var(--acc)"/>
        <KPI title="Zeilen" value={detail.summary?.rowsParsed||0} sub={`${detail.summary?.rowsWithEk||0} mit EK`} icon="≡" accent="var(--grn)"/>
        <KPI title="Mit EAN" value={detail.summary?.rowsWithEan||0} sub={`${detail.summary?.rowsWithHan||0} mit HAN`} icon="#" accent="var(--acc)"/>
        <KPI title="PDFs" value={detail.summary?.pdfFiles||0} sub="parsed" icon="▤" accent="var(--ylw)"/>
      </div>
      <div style={{fontSize:12,fontWeight:600,color:"var(--t1)",marginBottom:8}}>Pro Datei ({(detail.files||[]).length})</div>
      <div style={{maxHeight:320,overflowY:"auto",border:"1px solid var(--brd)",borderRadius:6,padding:"0 8px"}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 100px 60px 60px 60px 60px 1fr",gap:6,fontSize:11}}>
          {["Datei","Marke","Zeilen","EK","EAN","HAN","Fehler / Spalten"].map((h,i)=>
            <div key={i} style={{fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",padding:"8px 0",position:"sticky",top:0,background:"var(--s1)"}}>{h}</div>
          )}
          {(detail.files||[]).map((f,i)=><React.Fragment key={i}>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontSize:10}} title={f.datei}>{f.datei}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{f.marke||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{f.zeilen??0}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:f.mitEk?"var(--grn)":"var(--t3)",fontWeight:600}}>{f.mitEk??0}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{f.mitEan??0}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{f.mitHan??0}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:f.error?"var(--red)":"var(--t3)",fontSize:10,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={f.error||(f.cols?JSON.stringify(f.cols):"")}>{f.error||(f.cols?`EK:${f.cols.ek??"?"} EAN:${f.cols.ean??"?"} HAN:${f.cols.han??"?"}`:"–")}</div>
          </React.Fragment>)}
        </div>
      </div>
    </Modal>}
  </>;
};

/* ─── Einkaufspreise · Ergebnisliste (Flow-2-Daten ↔ Panda) ─── */
const EinkaufspreiseErgebnisliste=()=>{
  const [mode,setMode]=useState("withEk"); // "withEk" | "ohneEk"
  const [brands,setBrands]=useState([]);
  const [brand,setBrand]=useState("");
  const [q,setQ]=useState("");
  const [data,setData]=useState({rows:[],total:0,limit:100,offset:0});
  const [loading,setLoading]=useState(false);
  const [err,setErr]=useState("");
  const [stats,setStats]=useState(null);

  useEffect(()=>{
    fetch("/api/imports/einkaufspreise/preislisten/brands")
      .then(r=>r.json()).then(j=>setBrands(j.brands||[])).catch(()=>{});
    fetch("/api/imports/einkaufspreise/preislisten/summary-stats")
      .then(r=>r.json()).then(j=>setStats(j)).catch(()=>{});
  },[]);

  const load=async(offset=0)=>{
    setLoading(true); setErr("");
    try{
      const path=mode==="ohneEk"?"panda-ohne-ek":"results";
      const params=new URLSearchParams();
      if(brand) params.set("brand",brand);
      if(q) params.set("q",q);
      params.set("limit","100");
      params.set("offset",String(offset));
      const r=await fetch(`/api/imports/einkaufspreise/preislisten/${path}?${params}`);
      const j=await r.json();
      if(!r.ok) throw new Error(j.message||"Fehler");
      setData(j);
    }catch(ex){setErr(ex.message);}
    setLoading(false);
  };
  useEffect(()=>{load(0);},[mode,brand]);

  const fmt=(n)=>n==null?"–":Number(n).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})+" €";
  const fmtN=(n)=>Number(n||0).toLocaleString("de-DE");

  return<>
    {stats&&<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:10,marginBottom:12}}>
      <div style={{background:"var(--b2)",border:"1px solid var(--br)",borderRadius:8,padding:14}}>
        <div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase",letterSpacing:.5}}>Artikel gesamt (Panda)</div>
        <div style={{fontSize:22,fontWeight:700,color:"var(--t1)",marginTop:4}}>{fmtN(stats.artikel?.total)}</div>
      </div>
      <div style={{background:"linear-gradient(135deg,var(--b2),var(--b3))",border:"1px solid var(--br)",borderRadius:8,padding:14}}>
        <div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase",letterSpacing:.5}}>Artikel mit EK</div>
        <div style={{fontSize:22,fontWeight:700,color:"#16a34a",marginTop:4}}>{fmtN(stats.artikel?.mitEk)}</div>
        <div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>aus einkauf.artikelpreise</div>
      </div>
      <div style={{background:"var(--b2)",border:"1px solid var(--br)",borderRadius:8,padding:14}}>
        <div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase",letterSpacing:.5}}>EK-Abdeckung</div>
        <div style={{fontSize:22,fontWeight:700,color:(stats.artikel?.abdeckungPct||0)>=50?"#16a34a":(stats.artikel?.abdeckungPct||0)>=20?"#f59e0b":"#ef4444",marginTop:4}}>
          {stats.artikel?.abdeckungPct!=null?`${stats.artikel.abdeckungPct}%`:"–"}
        </div>
        <div style={{marginTop:6,height:5,background:"var(--s2)",borderRadius:3,overflow:"hidden"}}>
          <div style={{width:`${Math.min(100,stats.artikel?.abdeckungPct||0)}%`,height:"100%",background:(stats.artikel?.abdeckungPct||0)>=50?"#16a34a":(stats.artikel?.abdeckungPct||0)>=20?"#f59e0b":"#ef4444"}}/>
        </div>
      </div>
      <div style={{background:"var(--b2)",border:"1px solid var(--br)",borderRadius:8,padding:14}}>
        <div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase",letterSpacing:.5}}>Artikel ohne EK</div>
        <div style={{fontSize:22,fontWeight:700,color:"#ef4444",marginTop:4}}>{fmtN(stats.artikel?.ohneEk)}</div>
      </div>
      <div style={{background:"var(--b2)",border:"1px solid var(--br)",borderRadius:8,padding:14}}>
        <div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase",letterSpacing:.5}}>Flow-2-EKs extrahiert</div>
        <div style={{fontSize:22,fontWeight:700,color:"var(--t1)",marginTop:4}}>{fmtN(stats.flow2?.extraktRowsMitEk)}</div>
        <div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>{fmtN(stats.flow2?.uniqueEans)} EAN · {fmtN(stats.flow2?.uniqueHans)} HAN</div>
      </div>
      <div style={{background:"var(--b2)",border:"1px solid var(--br)",borderRadius:8,padding:14}}>
        <div style={{fontSize:10,color:"var(--t3)",textTransform:"uppercase",letterSpacing:.5}}>Flow-2 ohne Artikel-Match</div>
        <div style={{fontSize:22,fontWeight:700,color:"#f59e0b",marginTop:4}}>{fmtN(stats.flow2?.keysOhneMatch)}</div>
        <div style={{fontSize:10,color:"var(--t3)",marginTop:2}} title={`${fmtN(stats.flow2?.tuplesGematcht)} von ${fmtN(stats.flow2?.uniqueTuples)} Tuples gematcht · ${fmtN(stats.flow2?.hansBlacklisted)} HANs verworfen (Parser-Noise)`}>
          {fmtN(stats.flow2?.tuplesGematcht)}/{fmtN(stats.flow2?.uniqueTuples)} Tuples gematcht
        </div>
      </div>
    </div>}
    <Card>
      <div style={{display:"flex",gap:12,alignItems:"center",flexWrap:"wrap"}}>
        <div style={{display:"flex",background:"var(--s2)",borderRadius:6,padding:2}}>
          <button onClick={()=>setMode("withEk")} style={{padding:"6px 14px",border:"none",borderRadius:4,cursor:"pointer",fontSize:11,fontWeight:600,background:mode==="withEk"?"var(--acc)":"transparent",color:mode==="withEk"?"#fff":"var(--t2)"}}>Artikel mit EK (Flow 2 ↔ Panda)</button>
          <button onClick={()=>setMode("ohneEk")} style={{padding:"6px 14px",border:"none",borderRadius:4,cursor:"pointer",fontSize:11,fontWeight:600,background:mode==="ohneEk"?"var(--acc)":"transparent",color:mode==="ohneEk"?"#fff":"var(--t2)"}}>Panda-Artikel OHNE EK</button>
        </div>
        <select value={brand} onChange={e=>setBrand(e.target.value)} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s1)",color:"var(--t1)",fontSize:11,minWidth:200}}>
          <option value="">Alle Marken ({brands.length})</option>
          {brands.map(b=><option key={b} value={b}>{b}</option>)}
        </select>
        <input type="text" placeholder="Suche (Name, a_nr, EAN, HAN)…" value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&load(0)} style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s1)",color:"var(--t1)",fontSize:11,minWidth:240}}/>
        <Btn onClick={()=>load(0)} disabled={loading}>{loading?"Lade…":"Suchen"}</Btn>
        <div style={{marginLeft:"auto",fontSize:11,color:"var(--t3)"}}>{data.total.toLocaleString("de-DE")} Treffer</div>
      </div>
      {err&&<div style={{marginTop:8,padding:"8px 12px",borderRadius:6,background:"var(--red2)",color:"var(--red)",fontSize:11}}>{err}</div>}
    </Card>

    <Card>
      {mode==="withEk"?<>
        <div style={{display:"grid",gridTemplateColumns:"110px 90px 1fr 120px 100px 100px 1fr",gap:6,fontSize:11}}>
          {["a_nr","p_nr","Name","Marke","EK (neu)","EK (alt)","Quelle-Datei"].map((h,i)=>
            <div key={i} style={{fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:5}}>{h}</div>
          )}
          {data.rows.map((r,i)=><React.Fragment key={i}>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",fontFamily:"monospace",fontSize:10}}>{r.a_nr||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)",fontFamily:"monospace",fontSize:10}}>{r.p_nr||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={r.name}>{r.name||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{r.marke||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--grn)",fontWeight:600}}>{fmt(r.ek_netto)}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t3)"}}>{r.ek_bestand?fmt(r.ek_bestand):"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t3)",fontSize:10,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={r.datei}>{r.datei||"–"}</div>
          </React.Fragment>)}
        </div>
      </>:<>
        <div style={{display:"grid",gridTemplateColumns:"110px 90px 1fr 120px 110px 110px 100px",gap:6,fontSize:11}}>
          {["a_nr","p_nr","Name","Marke","EAN","HAN","EK aus Flow 2"].map((h,i)=>
            <div key={i} style={{fontSize:9,color:"var(--t3)",fontWeight:600,textTransform:"uppercase",letterSpacing:".5px",borderBottom:"1px solid var(--brd)",paddingBottom:5}}>{h}</div>
          )}
          {data.rows.map((r,i)=><React.Fragment key={i}>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",fontFamily:"monospace",fontSize:10}}>{r.a_nr||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)",fontFamily:"monospace",fontSize:10}}>{r.p_nr||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t1)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={r.name||r.bezeichnung}>{r.name||r.bezeichnung||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t2)"}}>{r.marke||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t3)",fontFamily:"monospace",fontSize:10}}>{r.ean||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:"var(--t3)",fontFamily:"monospace",fontSize:10}}>{r.hersteller_artikelnr||"–"}</div>
            <div style={{padding:"5px 0",borderBottom:"1px solid var(--brd)",color:r.ek_aus_preislisten?"var(--grn)":"var(--red)",fontWeight:600}} title={r.ek_quelle||""}>{r.ek_aus_preislisten?fmt(r.ek_aus_preislisten):"–"}</div>
          </React.Fragment>)}
        </div>
      </>}
      {!data.rows.length&&!loading&&<EmptyState icon="◌" title="Keine Treffer" sub="Filter/Suche anpassen"/>}
      {data.total>data.limit&&<div style={{display:"flex",gap:8,justifyContent:"center",marginTop:12}}>
        <Btn small disabled={data.offset===0||loading} onClick={()=>load(Math.max(0,data.offset-data.limit))}>◀ Zurück</Btn>
        <div style={{fontSize:11,color:"var(--t2)",alignSelf:"center"}}>{data.offset+1}–{Math.min(data.offset+data.limit,data.total)} / {data.total.toLocaleString("de-DE")}</div>
        <Btn small disabled={data.offset+data.limit>=data.total||loading} onClick={()=>load(data.offset+data.limit)}>Weiter ▶</Btn>
      </div>}
    </Card>
  </>;
};

/* ─── Einkaufspreise Hub (Tabs über alle Flows + Ergebnisse) ─── */
const EinkaufspreiseHub=()=>{
  const [tab,setTab]=useState("flow1");
  const tabs=[
    {id:"flow1",label:"Flow 1 · Stammdaten"},
    {id:"flow2",label:"Flow 2 · Preislisten"},
    {id:"ergebnisse",label:"Ergebnisliste"},
  ];
  return<>
    <div style={{display:"flex",gap:2,marginBottom:14,borderBottom:"1px solid var(--brd)"}}>
      {tabs.map(t=>
        <button key={t.id} onClick={()=>setTab(t.id)} style={{padding:"10px 18px",border:"none",background:"transparent",cursor:"pointer",fontSize:12,fontWeight:600,color:tab===t.id?"var(--acc)":"var(--t3)",borderBottom:tab===t.id?"2px solid var(--acc)":"2px solid transparent",marginBottom:"-1px"}}>{t.label}</button>
      )}
    </div>
    {tab==="flow1"&&<EinkaufspreiseImport/>}
    {tab==="flow2"&&<PreislistenImport/>}
    {tab==="ergebnisse"&&<EinkaufspreiseErgebnisliste/>}
  </>;
};

/* ─── Content Router ─── */
const ContentArea=({nav,currentUser})=>{
  const [sub,s]=nav.split("/");
  switch(nav){
    case"dashboard": return<Dashboard/>;
    case"cashflow":case"cashflow/uebersicht": return<Cashflow/>;
    case"cashflow/kontostände": return<Kontostände/>;
    case"buchhaltung": case"buchhaltung/uebersicht": return<BuchhaltungPage/>;
    case"buchhaltung/zahlungsverkehr": return React.createElement(BuchhaltungZahlungsverkehr,null);
    case"buchhaltung/buchungssaetze": return React.createElement(BuchhaltungBuchungssaetze,null);
    case"buchhaltung/kontennachweis": return React.createElement(BuchhaltungKontennachweis,null);
    case"buchhaltung/inventar": return React.createElement(BuchhaltungInventar,null);
    case"buchhaltung/afa": return React.createElement(BuchhaltungAfA,null);
    case"buchhaltung/bwa": return React.createElement(BuchhaltungBWA,null);
    case"buchhaltung/bilanz": return React.createElement(BuchhaltungBilanz,null);
    case"buchhaltung/banken": return React.createElement(BuchhaltungBanken,null);
    case"buchhaltung/mitarbeiter": return React.createElement(BuchhaltungMitarbeiter,null);
    case"buchhaltung/lieferanten": return React.createElement(BuchhaltungLieferanten,null);
    case"buchhaltung/marktplatz": return React.createElement(BuchhaltungMarktplatz,null);
    case"buchhaltung/it": return React.createElement(BuchhaltungIT,null);
    case"einkauf/artikeleinkaufspreise": return<ArtikelEinkaufspreise/>;
    case"einkauf/lieferantenauswertung": return<Lieferantenauswertung/>;
    case"auswertungen/reports":case"auswertungen/verkaufszahlen":case"auswertungen/bestseller":case"auswertungen/trends":case"auswertungen/performance":
      return<Auswertungen sub={s}/>;
    case"potentialanalyse":       return<Potentialanalyse/>;
    case"artikel/order-files":    return<OrderFiles/>;
    case"artikel/imports-ek":     return<EinkaufspreiseHub/>;
    case"artikel/panda-upload":   return<PandaUpload/>;
    case"artikel/panda-ansicht":  return<PandaAnsicht/>;
    case"artikel/ods-upload":     return<ODSUpload/>;
    case"artikel/artikel-ansicht":return<ManuelleArtikelansicht/>;
    case"artikel/jtl-ansicht":    return<JTLArtikelansicht/>;
    case"artikel/pflichtfelder":  return<Pflichtfelder/>;
    case"artikel/attributfelder": return<Attributfelder/>;
    case"artikel/merkmale":       return<Merkmale/>;
    case"artikel/bilder":         return<Artikelbilder/>;
    case"verwaltung/benutzer":    return<Benutzerverwaltung currentUser={currentUser}/>;
    case"verwaltung/rollen":      return<Rollenverwaltung/>;
    case"verwaltung/schnittstellen": return<Schnittstellenverwaltung/>;
    case"preise/kalkulator":        return<Preiskalkulator/>;
    case"preise/angebote":          return<Angebote/>;
    case"einkauf/lieferanten":      return<Lieferantenverwaltung/>;
    case"einkauf/preislisten":      return<Preislisten/>;
    case"einkauf/preorder":         return<Preorder/>;
    case"marktplaetze":case"marktplaetze/kosten": return<Marktplatzverwaltung/>;
    case"zalando/dashboard":        return<ZalandoDashboard/>;
    case"zalando/bestellungen":     return<ZalandoBestellungen/>;
    case"zalando/zfs-lager":        return<ZalandoZFSLager/>;
    case"zalando/retouren":         return<ZalandoRetouren/>;
    case"zalando/sales-channels":   return<ZalandoSalesChannels/>;
    case"aboutyou/dashboard":       return<AYDashboard/>;
    case"aboutyou/bestellungen":    return<AYBestellungen/>;
    case"aboutyou/produkte":        return<AYProdukte/>;
    case"aboutyou/webhooks":        return<AYWebhooks/>;
    case"bestellungen":
    case"bestellungen/auftraege":   return<BestellungenAuftraege/>;
    case"bestellungen/retouren":    return<BestellungenRetouren/>;
    case"bestellungen/stornos":     return<BestellungenStornos/>;
    case"bestellungen/artikel":     return<BestellungenArtikel/>;
    case"bestellungen/kanaele":     return<BestellungenKanaele/>;
    case"lager":                    return<LagerBestand/>;
    case"lager/bestand":            return<LagerBestand/>;
    case"lager/ehrenfriedersdorf":  return<LagerEhrenfriedersdorf/>;
    case"lager/zalando":            return<LagerZalando/>;
    case"lager/aboutyou":           return<LagerAboutYou/>;
    case"lager/auswertung":         return<LagerAuswertung/>;
    case"lager/konfiguration":      return<Lagerverwaltung/>;
    case"lieferanten":              return<Lieferantenverwaltung/>;
    case"versand":                  return<Versanddienstleister/>;
    case"artikel/kategoriemapping": return<Kategoriemapping/>;
    case"crm/dashboard":            return<CrmDashboard/>;
    case"crm/firmen":               return<CrmFirmen/>;
    case"crm/kontakte":             return<CrmKontakte/>;
    case"crm/leads":                return<CrmLeads/>;
    case"crm/pipelines":            return<CrmPipelines/>;
    case"crm/aufgaben":             return<CrmAufgaben/>;
    case"crm/sammlung":             return<CrmSammlung/>;
    case"shops/uebersicht":         return<ShopsUebersicht/>;
    case"shops/kategorien":         return<ShopKategorien/>;
    case"shops/coupons":            return<ShopCoupons/>;
    case"shops/bestellungen":       return<ShopBestellungen/>;
    case"verwaltung/email-konten":  return<EmailKontenVerwaltung/>;
    case"verwaltung/email-vorlagen":return<EmailVorlagenDesigner/>;
    case"email/inbox":              return<EmailInbox sub="inbox"/>;
    case"email/alle":               return<EmailInbox sub="alle"/>;
    case"email/erledigt":           return<EmailInbox sub="erledigt"/>;
    case"email/bausteine":          return<EmailBausteine/>;
    case"email/regeln":             return<EmailRegeln/>;
    case"email/spam":               return<EmailSpam/>;
    case"chat":                     return<TeamChat/>;
    case"dokumente/ablage":         return<DokumenteAblage/>;
    case"dokumente/geteilt":        return<DokumenteGeteilt/>;
    default: return<EmptyState icon="◎" title="Seite nicht gefunden" sub={`Route: ${nav}`}/>;
  }
};

/* ─── BuchhaltungPage ─── */
const MONATE_KURZ=["","Jan","Feb","Mrz","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"];
const fmtEur=v=>(v||0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})+" €";
const fmtNum=v=>{if(v===null||v===undefined||v==="")return"–";const n=parseFloat(v);return isNaN(n)?"–":n.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2});};
const fmtDat=d=>{if(!d)return"–";try{return new Date(d).toLocaleDateString("de-DE");}catch{return"–";};};

/* Gemeinsamer Konto-Lookup-Hook: lädt Sachkonten + Deb/Kred einmalig */
function useKontoLookup(){
  const [lookup,setLookup]=React.useState({});
  React.useEffect(()=>{
    fetch("/api/cashflow/buchhaltung/konto-lookup").then(r=>r.json()).then(d=>setLookup(d||{})).catch(()=>{});
  },[]);
  /* ktoName(nr): gibt "1200 – Forderungen aus L+L" zurück, oder nur "1200" wenn kein Name */
  const ktoName=(nr)=>{if(!nr)return"–";const t=lookup[String(nr)];return t?`${nr} – ${t}`:String(nr);};
  return{lookup,ktoName};
}

/* ─── BuchhaltungZahlungsverkehr ─── */
const BuchhaltungZahlungsverkehr=()=>{
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(true);
  const [search,setSearch]=useState("");
  const iS={padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  const load=useCallback((q="")=>{
    setLoading(true);
    const p=new URLSearchParams();
    if(q)p.set("search",q);
    fetch(`/api/cashflow/buchhaltung/zahlungsverkehr?${p}`).then(r=>r.json()).then(d=>{setData(Array.isArray(d)?d:[]);setLoading(false);}).catch(()=>setLoading(false));
  },[]);

  useEffect(()=>{load();},[]);

  const months=[{k:"MVZ_01",l:"Jan"},{k:"MVZ_02",l:"Feb"},{k:"MVZ_03",l:"Mrz"},{k:"MVZ_04",l:"Apr"},
    {k:"MVZ_05",l:"Mai"},{k:"MVZ_06",l:"Jun"},{k:"MVZ_07",l:"Jul"},{k:"MVZ_08",l:"Aug"},
    {k:"MVZ_09",l:"Sep"},{k:"MVZ_10",l:"Okt"},{k:"MVZ_11",l:"Nov"},{k:"MVZ_12",l:"Dez"}];

  const sumRow={};
  ["EB_S","EB_H","JVZ_S","JVZ_H",...months.flatMap(m=>[m.k+"_S",m.k+"_H"])].forEach(k=>{
    sumRow[k]=data.reduce((a,r)=>(a+(r[k]||0)),0);
  });

  const thS={padding:"5px 8px",fontWeight:600,fontSize:10,color:"var(--t3)",whiteSpace:"nowrap",borderBottom:"2px solid var(--brd)",position:"sticky",top:0,background:"var(--s2)",zIndex:1};
  const tdS={padding:"4px 8px",fontSize:11,whiteSpace:"nowrap",fontFamily:"'JetBrains Mono',monospace",textAlign:"right"};
  const tdL={padding:"4px 8px",fontSize:11,whiteSpace:"nowrap"};

  return<div style={{maxWidth:1600}}>
    <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:14,flexWrap:"wrap"}}>
      <input value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==="Enter"&&load(search)} placeholder="Konto suchen…" style={{...iS,minWidth:220}}/>
      <button onClick={()=>load(search)} style={{...iS,background:"var(--acc)",color:"#fff",cursor:"pointer",border:"none",fontWeight:600}}>Suchen</button>
      <button onClick={()=>{setSearch("");load("");}} style={{...iS,cursor:"pointer"}}>Zurücksetzen</button>
      <span style={{marginLeft:"auto",fontSize:11,color:"var(--t3)"}}>{data.length} Konten</span>
    </div>
    {loading?<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
    <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflowX:"auto"}}>
      <table style={{borderCollapse:"collapse",fontSize:11,minWidth:1400}}>
        <thead>
          <tr>
            <th style={{...thS,textAlign:"left",position:"sticky",left:0,background:"var(--s2)",zIndex:2}}>Ktonr</th>
            <th style={{...thS,textAlign:"left",minWidth:180}}>Bezeichnung</th>
            <th style={{...thS,textAlign:"right"}}>EB S</th>
            <th style={{...thS,textAlign:"right"}}>EB H</th>
            <th style={{...thS,textAlign:"right"}}>JVZ S</th>
            <th style={{...thS,textAlign:"right"}}>JVZ H</th>
            {months.flatMap(m=>[
              <th key={m.k+"_S"} style={{...thS,textAlign:"right"}}>{m.l} S</th>,
              <th key={m.k+"_H"} style={{...thS,textAlign:"right"}}>{m.l} H</th>,
            ])}
          </tr>
        </thead>
        <tbody>
          {data.length===0?<tr><td colSpan={30} style={{padding:24,textAlign:"center",color:"var(--t3)"}}>Keine Daten</td></tr>:
            data.map((r,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
              <td style={{...tdL,position:"sticky",left:0,background:i%2===0?"var(--s2)":"var(--bg)",fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)",fontWeight:600}}>{r.Ktonr||"–"}</td>
              <td style={{...tdL,color:"var(--t1)",maxWidth:220,overflow:"hidden",textOverflow:"ellipsis"}}>{r.Ktobeschr||"–"}</td>
              <td style={{...tdS,color:"var(--t2)"}}>{fmtNum(r.EB_S)}</td>
              <td style={{...tdS,color:"var(--t2)"}}>{fmtNum(r.EB_H)}</td>
              <td style={{...tdS,color:"var(--t1)",fontWeight:500}}>{fmtNum(r.JVZ_S)}</td>
              <td style={{...tdS,color:"var(--t1)",fontWeight:500}}>{fmtNum(r.JVZ_H)}</td>
              {months.flatMap(m=>[
                <td key={m.k+"_S"} style={{...tdS,color:r[m.k+"_S"]?"var(--t1)":"var(--t3)"}}>{fmtNum(r[m.k+"_S"])}</td>,
                <td key={m.k+"_H"} style={{...tdS,color:r[m.k+"_H"]?"var(--t1)":"var(--t3)"}}>{fmtNum(r[m.k+"_H"])}</td>,
              ])}
            </tr>)
          }
          {data.length>0&&<tr style={{borderTop:"2px solid var(--brd)",background:"var(--s3,var(--bg))",fontWeight:700}}>
            <td style={{...tdL,position:"sticky",left:0,background:"var(--s3,var(--bg))",color:"var(--t1)",fontWeight:700}}>Σ</td>
            <td style={{...tdL,color:"var(--t3)",fontSize:10}}>Summe</td>
            <td style={{...tdS,fontWeight:700,color:"var(--t1)"}}>{fmtNum(sumRow.EB_S)}</td>
            <td style={{...tdS,fontWeight:700,color:"var(--t1)"}}>{fmtNum(sumRow.EB_H)}</td>
            <td style={{...tdS,fontWeight:700,color:"var(--t1)"}}>{fmtNum(sumRow.JVZ_S)}</td>
            <td style={{...tdS,fontWeight:700,color:"var(--t1)"}}>{fmtNum(sumRow.JVZ_H)}</td>
            {months.flatMap(m=>[
              <td key={m.k+"_S"} style={{...tdS,fontWeight:700,color:"var(--t1)"}}>{fmtNum(sumRow[m.k+"_S"])}</td>,
              <td key={m.k+"_H"} style={{...tdS,fontWeight:700,color:"var(--t1)"}}>{fmtNum(sumRow[m.k+"_H"])}</td>,
            ])}
          </tr>}
        </tbody>
      </table>
    </div>}
  </div>;
};

/* ─── BuchhaltungBuchungssaetze (Buchungssatzprotokoll) ─── */
const BuchhaltungBuchungssaetze=()=>{
  const {ktoName}=useKontoLookup();
  const [data,setData]=useState([]);
  const [total,setTotal]=useState(0);
  const [page,setPage]=useState(1);
  const [loading,setLoading]=useState(false);
  const [search,setSearch]=useState("");
  const [ktonr,setKtonr]=useState("");
  const [monat,setMonat]=useState("");
  const [von,setVon]=useState("");
  const [bis,setBis]=useState("");
  const iS={padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  const load=useCallback((pg=1)=>{
    setLoading(true);
    const p=new URLSearchParams({page:pg,limit:100});
    if(search)p.set("search",search);
    if(ktonr)p.set("ktonr",ktonr);
    if(monat)p.set("monat",monat);
    if(von)p.set("von",von);
    if(bis)p.set("bis",bis);
    fetch(`/api/cashflow/buchhaltung/buchungssatzprotokoll?${p}`).then(r=>r.json()).then(d=>{
      setData(d.docs||[]);setTotal(d.total||0);setPage(pg);setLoading(false);
    }).catch(()=>setLoading(false));
  },[search,ktonr,monat,von,bis]);

  useEffect(()=>{load(1);},[]);

  const pages=Math.ceil(total/100)||1;

  const statusBadge=(s)=>{
    if(s==="10")return<span style={{padding:"1px 6px",borderRadius:4,fontSize:10,fontWeight:600,background:"#16a34a22",color:"var(--grn)"}}>✓ Festgeschr.</span>;
    if(s==="11")return<span style={{padding:"1px 6px",borderRadius:4,fontSize:10,fontWeight:600,background:"#3b82f622",color:"#3b82f6"}}>Gebucht</span>;
    return<span style={{padding:"1px 6px",borderRadius:4,fontSize:10,background:"var(--bg)",color:"var(--t3)"}}>{s||"–"}</span>;
  };

  return<div style={{maxWidth:1400}}>
    <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginBottom:14}}>
      <input value={search} onChange={e=>setSearch(e.target.value)} onKeyDown={e=>e.key==="Enter"&&load(1)} placeholder="Buchungstext / Belegnr…" style={{...iS,minWidth:200}}/>
      <input value={ktonr} onChange={e=>setKtonr(e.target.value)} onKeyDown={e=>e.key==="Enter"&&load(1)} placeholder="Konto-Nr" style={{...iS,width:100}}/>
      <select value={monat} onChange={e=>setMonat(e.target.value)} style={{...iS,cursor:"pointer"}}>
        <option value="">Alle Monate</option>
        {MONATE_KURZ.slice(1).map((m,i)=><option key={i+1} value={String(i+1).padStart(2,"0")}>{m}</option>)}
      </select>
      <input type="date" value={von} onChange={e=>setVon(e.target.value)} style={iS} title="Datum von"/>
      <input type="date" value={bis} onChange={e=>setBis(e.target.value)} style={iS} title="Datum bis"/>
      <button onClick={()=>load(1)} style={{...iS,background:"var(--acc)",color:"#fff",cursor:"pointer",border:"none",fontWeight:600}}>Suchen</button>
      <button onClick={()=>{setSearch("");setKtonr("");setMonat("");setVon("");setBis("");setTimeout(()=>load(1),50);}} style={{...iS,cursor:"pointer"}}>Zurücksetzen</button>
      <span style={{marginLeft:"auto",fontSize:11,color:"var(--t3)"}}>{total.toLocaleString("de-DE")} Sätze</span>
    </div>
    {loading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:<>
      <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
          <thead><tr style={{borderBottom:"2px solid var(--brd)",color:"var(--t3)"}}>
            {["Stapel/BSNr","Datum","Konto","Gegenkonto","Buchungstext","Belegnummer","Soll","Haben","MwSt%","Status","Herkunft"].map(h=><th key={h} style={{padding:"6px 8px",textAlign:["Soll","Haben","MwSt%"].includes(h)?"right":"left",fontWeight:600,whiteSpace:"nowrap"}}>{h}</th>)}
          </tr></thead>
          <tbody>
            {data.length===0?<tr><td colSpan={11} style={{padding:24,textAlign:"center",color:"var(--t3)"}}>Keine Buchungssätze gefunden</td></tr>:
              data.map((b,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
                <td style={{padding:"5px 8px",fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t3)"}}>{b.Stapelnummer||"–"}/{b.BSNr||"–"}</td>
                <td style={{padding:"5px 8px",whiteSpace:"nowrap",color:"var(--t2)"}}>{fmtDat(b.Belegdatum)}</td>
                <td style={{padding:"5px 8px",color:"var(--acc)",fontWeight:500,fontSize:11}}>{ktoName(b.Ktonr)}</td>
                <td style={{padding:"5px 8px",color:"var(--t2)",fontSize:11}}>{ktoName(b.GKtonr)}</td>
                <td style={{padding:"5px 8px",color:"var(--t1)",maxWidth:260,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{b.Buchungstext||"–"}</td>
                <td style={{padding:"5px 8px",fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t2)"}}>{b.Beleg1||"–"}</td>
                <td style={{padding:"5px 8px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:b.Umsatz_Soll?"var(--t1)":"var(--t3)"}}>{b.Umsatz_Soll?fmtNum(b.Umsatz_Soll):"–"}</td>
                <td style={{padding:"5px 8px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:b.Umsatz_Haben?"var(--t1)":"var(--t3)"}}>{b.Umsatz_Haben?fmtNum(b.Umsatz_Haben):"–"}</td>
                <td style={{padding:"5px 8px",textAlign:"right",color:"var(--t3)"}}>{b.Steuersatz!=null?b.Steuersatz+"%":"–"}</td>
                <td style={{padding:"5px 8px"}}>{statusBadge(b.Bearbeitungsstatus)}</td>
                <td style={{padding:"5px 8px",fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t3)"}}>{b.Herkunftskz||"–"}</td>
              </tr>)
            }
          </tbody>
        </table>
      </div>
      {pages>1&&<div style={{display:"flex",gap:6,alignItems:"center",marginTop:12,justifyContent:"center"}}>
        <button onClick={()=>load(1)} disabled={page<=1} style={{...iS,cursor:page>1?"pointer":"not-allowed",opacity:page>1?1:0.4}}>«</button>
        <button onClick={()=>load(page-1)} disabled={page<=1} style={{...iS,cursor:page>1?"pointer":"not-allowed",opacity:page>1?1:0.4}}>‹</button>
        <span style={{fontSize:12,color:"var(--t2)",padding:"0 8px"}}>Seite {page} / {pages}</span>
        <button onClick={()=>load(page+1)} disabled={page>=pages} style={{...iS,cursor:page<pages?"pointer":"not-allowed",opacity:page<pages?1:0.4}}>›</button>
        <button onClick={()=>load(pages)} disabled={page>=pages} style={{...iS,cursor:page<pages?"pointer":"not-allowed",opacity:page<pages?1:0.4}}>»</button>
      </div>}
    </>}
  </div>;
};

/* ─── BuchhaltungKontennachweis ─── */
const BuchhaltungKontennachweis=()=>{
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(true);
  const [typ,setTyp]=useState("1");

  useEffect(()=>{
    setLoading(true);
    const p=new URLSearchParams();
    if(typ)p.set("typ",typ);
    fetch(`/api/cashflow/buchhaltung/kontennachweis?${p}`).then(r=>r.json()).then(d=>{setData(Array.isArray(d)?d:[]);setLoading(false);}).catch(()=>setLoading(false));
  },[typ]);

  const typLabel={1:"Bilanz",2:"GuV","3":"§4 EStG"};

  // Group by KNW_Unterliste
  const groups={};
  data.forEach(r=>{
    const g=r.KNW_Unterliste||"Sonstige";
    if(!groups[g])groups[g]=[];
    groups[g].push(r);
  });

  const iS={padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  return<div style={{maxWidth:1200}}>
    <div style={{display:"inline-flex",gap:3,background:"var(--s2)",borderRadius:8,padding:3,marginBottom:18}}>
      {[{v:"1",l:"Bilanz"},{v:"2",l:"GuV"},{v:"3",l:"§4 EStG"}].map(t=><button key={t.v} onClick={()=>setTyp(t.v)} style={{padding:"6px 16px",borderRadius:6,border:"none",fontSize:12,fontWeight:500,cursor:"pointer",fontFamily:"inherit",background:typ===t.v?"var(--acc)":"transparent",color:typ===t.v?"#fff":"var(--t2)",transition:"all .2s"}}>{t.l}</button>)}
    </div>
    {loading?<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
    data.length===0?<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Keine Daten</div>:
    <div>
      {Object.entries(groups).map(([grp,rows])=>{
        const grpTotal=rows.reduce((a,r)=>a+(r.KNW_Kontowert||0),0);
        const posTotal=rows.reduce((a,r)=>a+(r.KNW_Postenwert||0),0);
        return<div key={grp} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,marginBottom:16,overflow:"hidden"}}>
          <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontWeight:700,fontSize:13,color:"var(--t1)"}}>{grp}</span>
            <span style={{fontFamily:"'JetBrains Mono',monospace",fontSize:12,color:"var(--t2)",fontWeight:600}}>{fmtEur(grpTotal)}</span>
          </div>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
            <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)"}}>
              <th style={{padding:"5px 12px",textAlign:"left",fontWeight:600}}>Position</th>
              <th style={{padding:"5px 12px",textAlign:"left",fontWeight:600}}>Kontonr</th>
              <th style={{padding:"5px 12px",textAlign:"left",fontWeight:600}}>Kontobezeichnung</th>
              <th style={{padding:"5px 12px",textAlign:"right",fontWeight:600}}>Kontowert</th>
              <th style={{padding:"5px 12px",textAlign:"right",fontWeight:600}}>Postenwert</th>
            </tr></thead>
            <tbody>
              {rows.map((r,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
                <td style={{padding:"5px 12px",color:"var(--t2)",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.KNW_Positionsbez||"–"}</td>
                <td style={{padding:"5px 12px",fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)"}}>{r.KNW_KtoNr||"–"}</td>
                <td style={{padding:"5px 12px",color:"var(--t1)",maxWidth:240,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.KNW_Kontobezeichnung||"–"}</td>
                <td style={{padding:"5px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"var(--t1)"}}>{r.KNW_Kontowert!=null?fmtEur(r.KNW_Kontowert):"–"}</td>
                <td style={{padding:"5px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"var(--t2)"}}>{r.KNW_Postenwert!=null?fmtEur(r.KNW_Postenwert):"–"}</td>
              </tr>)}
              <tr style={{borderTop:"1px solid var(--brd)",background:"var(--bg)",fontWeight:700}}>
                <td colSpan={3} style={{padding:"5px 12px",color:"var(--t3)",fontSize:11}}>Summe {grp}</td>
                <td style={{padding:"5px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"var(--t1)",fontWeight:700}}>{fmtEur(grpTotal)}</td>
                <td style={{padding:"5px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:"var(--t2)",fontWeight:700}}>{fmtEur(posTotal)}</td>
              </tr>
            </tbody>
          </table>
        </div>;
      })}
    </div>}
  </div>;
};

/* ─── BuchhaltungInventar ─── */
const BuchhaltungInventar=()=>{
  const [tab,setTab]=useState("stamm");
  const [stamm,setStamm]=useState([]);
  const [bewegung,setBewegung]=useState([]);
  const [entwicklung,setEntwicklung]=useState([]);
  const [loading,setLoading]=useState(false);

  useEffect(()=>{
    if(tab==="stamm"&&stamm.length===0){
      setLoading(true);
      fetch("/api/cashflow/buchhaltung/inventar/stamm").then(r=>r.json()).then(d=>{setStamm(Array.isArray(d)?d:[]);setLoading(false);}).catch(()=>setLoading(false));
    }
    if(tab==="bewegung"&&bewegung.length===0){
      setLoading(true);
      fetch("/api/cashflow/buchhaltung/inventar/bewegung").then(r=>r.json()).then(d=>{setBewegung(Array.isArray(d)?d:[]);setLoading(false);}).catch(()=>setLoading(false));
    }
    if(tab==="entwicklung"&&entwicklung.length===0){
      setLoading(true);
      fetch("/api/cashflow/buchhaltung/inventar/entwicklung").then(r=>r.json()).then(d=>{setEntwicklung(Array.isArray(d)?d:[]);setLoading(false);}).catch(()=>setLoading(false));
    }
  },[tab]);

  const thS={padding:"6px 10px",fontWeight:600,fontSize:11,color:"var(--t3)",textAlign:"left",borderBottom:"2px solid var(--brd)",whiteSpace:"nowrap"};
  const tdS={padding:"5px 10px",fontSize:11,whiteSpace:"nowrap"};
  const mn={fontFamily:"'JetBrains Mono',monospace",textAlign:"right"};

  const renderStamm=()=>stamm.length===0?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Daten</div>:
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
        <thead><tr>
          <th style={thS}>InventarNr</th><th style={thS}>Bezeichnung</th><th style={thS}>Konto</th>
          <th style={thS}>AfA-Art</th><th style={{...thS,...mn}}>AHK Beginn</th><th style={{...thS,...mn}}>AHK Ende</th>
          <th style={{...thS,...mn}}>NAfA ges.</th><th style={{...thS,...mn}}>Restwert</th><th style={{...thS,...mn}}>BW Ende</th>
          <th style={thS}>Standort</th>
        </tr></thead>
        <tbody>{stamm.map((r,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
          <td style={{...tdS,fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)",fontWeight:600}}>{r.InventarNr||"–"}</td>
          <td style={{...tdS,color:"var(--t1)",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis"}}>{r.InventarBez||"–"}</td>
          <td style={{...tdS,fontFamily:"'JetBrains Mono',monospace",color:"var(--t2)"}}>{r.KontoNr||"–"}</td>
          <td style={{...tdS,color:"var(--t3)"}}>{r.AfaArtText||r.AfaArt||"–"}</td>
          <td style={{...tdS,...mn,color:"var(--t1)"}}>{fmtNum(r.AhkBetragWjBeg)}</td>
          <td style={{...tdS,...mn,color:"var(--t1)",fontWeight:600}}>{fmtNum(r.AhkBetragWjEnd)}</td>
          <td style={{...tdS,...mn,color:"var(--t2)"}}>{fmtNum(r.NAfaWjEnd)}</td>
          <td style={{...tdS,...mn,color:r.Restwert>0?"var(--grn)":"var(--t3)"}}>{fmtNum(r.Restwert)}</td>
          <td style={{...tdS,...mn,color:"var(--t1)",fontWeight:600}}>{fmtNum(r.StWertWjEnd)}</td>
          <td style={{...tdS,color:"var(--t3)",fontSize:10}}>{r.Standort||"–"}</td>
        </tr>)}</tbody>
      </table>
    </div>;

  const renderBewegung=()=>bewegung.length===0?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Daten</div>:
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
        <thead><tr>
          <th style={thS}>Datum</th><th style={thS}>WgId</th><th style={thS}>Bezeichnung</th>
          <th style={thS}>Bewegungsart</th><th style={{...thS,...mn}}>AHK-Betrag</th>
          <th style={{...thS,...mn}}>Normal-AfA</th><th style={{...thS,...mn}}>Sonder-AfA</th>
          <th style={{...thS,...mn}}>Erlös</th><th style={thS}>Buchungstext</th>
        </tr></thead>
        <tbody>{bewegung.map((r,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
          <td style={{...tdS,color:"var(--t2)",whiteSpace:"nowrap"}}>{fmtDat(r.BewegDatum)}</td>
          <td style={{...tdS,fontFamily:"'JetBrains Mono',monospace",color:"var(--t3)"}}>{r.WgId||"–"}</td>
          <td style={{...tdS,color:"var(--t1)",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis"}}>{r.InventarBez||"–"}</td>
          <td style={{...tdS,color:"var(--t2)"}}>{r.BewegArtText||r.BewegArtNr||"–"}</td>
          <td style={{...tdS,...mn,color:"var(--t1)"}}>{fmtNum(r.AhkBetrag)}</td>
          <td style={{...tdS,...mn,color:"var(--t2)"}}>{fmtNum(r.NAfa)}</td>
          <td style={{...tdS,...mn,color:"var(--t2)"}}>{fmtNum(r.SAfa)}</td>
          <td style={{...tdS,...mn,color:r.Erloes?"var(--grn)":"var(--t3)"}}>{fmtNum(r.Erloes)}</td>
          <td style={{...tdS,color:"var(--t3)",maxWidth:200,overflow:"hidden",textOverflow:"ellipsis"}}>{r.BuchTxt||"–"}</td>
        </tr>)}</tbody>
      </table>
    </div>;

  const renderEntwicklung=()=>entwicklung.length===0?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Daten</div>:
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
        <thead><tr>
          <th style={thS}>InventarNr</th><th style={thS}>Bezeichnung</th>
          <th style={{...thS,...mn}}>AHK Beginn</th><th style={{...thS,...mn}}>Zugang</th><th style={{...thS,...mn}}>Abgang</th>
          <th style={{...thS,...mn}}>AHK Ende</th><th style={{...thS,...mn}}>AfA Beginn</th><th style={{...thS,...mn}}>AfA Ende</th>
          <th style={{...thS,...mn}}>BW Beginn</th><th style={{...thS,...mn}}>BW Ende</th><th style={{...thS,...mn}}>AfA %</th>
        </tr></thead>
        <tbody>{entwicklung.map((r,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
          <td style={{...tdS,fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)",fontWeight:600}}>{r.InventarNr||"–"}</td>
          <td style={{...tdS,color:"var(--t1)",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis"}}>{r.InventarBez||"–"}</td>
          <td style={{...tdS,...mn,color:"var(--t2)"}}>{fmtNum(r.Ahk_Beginn)}</td>
          <td style={{...tdS,...mn,color:"var(--grn)"}}>{fmtNum(r.Ahk_Zugang)}</td>
          <td style={{...tdS,...mn,color:r.Ahk_Abgang?"var(--red)":"var(--t3)"}}>{fmtNum(r.Ahk_Abgang)}</td>
          <td style={{...tdS,...mn,color:"var(--t1)",fontWeight:600}}>{fmtNum(r.Ahk_Ende)}</td>
          <td style={{...tdS,...mn,color:"var(--t3)"}}>{fmtNum(r.Afa_Beginn)}</td>
          <td style={{...tdS,...mn,color:"var(--t2)"}}>{fmtNum(r.Afa_Ende)}</td>
          <td style={{...tdS,...mn,color:"var(--t2)"}}>{fmtNum(r.BW_Beginn)}</td>
          <td style={{...tdS,...mn,color:"var(--t1)",fontWeight:600}}>{fmtNum(r.BW_Ende)}</td>
          <td style={{...tdS,...mn,color:"var(--t3)"}}>{r.AfaProz!=null?r.AfaProz+"%":"–"}</td>
        </tr>)}</tbody>
      </table>
    </div>;

  return<div style={{maxWidth:1400}}>
    <div style={{marginBottom:16}}>
      <Tabs tabs={[{k:"stamm",l:"Stammdaten"},{k:"bewegung",l:"Bewegungen"},{k:"entwicklung",l:"Entwicklung"}]} active={tab} onChange={setTab}/>
    </div>
    <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:16}}>
      {loading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
        tab==="stamm"?renderStamm():
        tab==="bewegung"?renderBewegung():
        renderEntwicklung()
      }
    </div>
  </div>;
};

/* ─── BuchhaltungAfA ─── */
const BuchhaltungAfA=()=>{
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);

  useEffect(()=>{
    fetch("/api/cashflow/buchhaltung/afa").then(r=>r.json()).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false));
  },[]);

  if(loading)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade…</div>;
  if(!data)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Keine Daten</div>;

  const gruppen=data.afaGruppen||[];
  const stamm=data.abzugsarten||[];
  const gesamtAhk=gruppen.reduce((a,r)=>a+(r.gesamtAhk||0),0);
  const gesamtNAfa=gruppen.reduce((a,r)=>a+(r.gesamtNAfa||0),0);
  const anzahlWg=gruppen.reduce((a,r)=>a+(r.anzahl||0),0);

  const cards=[
    {label:"Wirtschaftsgüter",val:anzahlWg.toLocaleString("de-DE"),icon:"◧"},
    {label:"Gesamt AHK",val:fmtEur(gesamtAhk),icon:"◈"},
    {label:"AfA dieses WJ",val:fmtEur(gesamtNAfa),icon:"▼"},
  ];

  const thS={padding:"6px 12px",fontWeight:600,fontSize:11,color:"var(--t3)",borderBottom:"2px solid var(--brd)",whiteSpace:"nowrap"};

  return<div style={{maxWidth:900}}>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:14,marginBottom:24}}>
      {cards.map(c=><div key={c.label} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:"14px 16px"}}>
        <div style={{fontSize:11,color:"var(--t3)",marginBottom:4}}>{c.icon} {c.label}</div>
        <div style={{fontSize:15,fontWeight:700,color:"var(--t1)"}}>{c.val}</div>
      </div>)}
    </div>

    <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden",marginBottom:20}}>
      <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",fontWeight:600,fontSize:13,color:"var(--t1)"}}>AfA nach Art</div>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
        <thead><tr>
          <th style={{...thS,textAlign:"left"}}>AfA-Art</th>
          <th style={{...thS,textAlign:"right"}}>Anzahl WG</th>
          <th style={{...thS,textAlign:"right"}}>Gesamt AHK</th>
          <th style={{...thS,textAlign:"right"}}>AfA dieses Jahr</th>
        </tr></thead>
        <tbody>
          {gruppen.length===0?<tr><td colSpan={4} style={{padding:24,textAlign:"center",color:"var(--t3)"}}>Keine Daten</td></tr>:
            gruppen.map((r,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
              <td style={{padding:"6px 12px",color:"var(--t1)",fontWeight:500}}>{r.AfaArtText||"–"}</td>
              <td style={{padding:"6px 12px",textAlign:"right",color:"var(--t2)"}}>{r.anzahl}</td>
              <td style={{padding:"6px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color:"var(--t1)"}}>{fmtEur(r.gesamtAhk)}</td>
              <td style={{padding:"6px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color:"var(--red)"}}>{fmtEur(r.gesamtNAfa)}</td>
            </tr>)
          }
          {gruppen.length>0&&<tr style={{borderTop:"2px solid var(--brd)",background:"var(--bg)",fontWeight:700}}>
            <td style={{padding:"6px 12px",color:"var(--t1)"}}>Gesamt</td>
            <td style={{padding:"6px 12px",textAlign:"right",color:"var(--t1)"}}>{anzahlWg}</td>
            <td style={{padding:"6px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color:"var(--t1)",fontWeight:700}}>{fmtEur(gesamtAhk)}</td>
            <td style={{padding:"6px 12px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color:"var(--red)",fontWeight:700}}>{fmtEur(gesamtNAfa)}</td>
          </tr>}
        </tbody>
      </table>
    </div>

    {stamm.length>0&&<div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:16}}>
      <div style={{fontWeight:600,fontSize:13,color:"var(--t1)",marginBottom:12}}>AHK-Abzugsarten</div>
      {stamm.map((r,i)=><div key={i} style={{display:"flex",gap:12,fontSize:12,color:"var(--t2)"}}>
        <span style={{fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)",minWidth:60}}>{r.AhkAbzId}</span>
        <span>{r.Text||"–"}</span>
      </div>)}
    </div>}
  </div>;
};

/* Letzter Monat mit Bewegung in monatsbasierten Zeilen ({months:{"01":..,"02":..}}).
 * - rows: Array oder Liste von Listen mit `.months`-Objekten.
 * - aktivJahr: gerade gewähltes Buchhaltungsjahr.
 * Heuristik: aktivJahr === currentYear → bis aktuellem Monat, sonst Dez.
 * Wenn Daten ein früheres Ende haben (Teiljahresimport), wird dieses verwendet.
 * Ein Monat zählt als „mit Bewegung", wenn irgendeine Zeile dort einen
 * Betrag !== 0 (Toleranz 0,5 Cent) hat. */
function bhLastMonth(rows, aktivJahr) {
  const aktuellesJahr = new Date().getFullYear();
  const monthIdxNow = new Date().getMonth() + 1;
  const fallback = aktivJahr === aktuellesJahr ? String(monthIdxNow).padStart(2,"0") : "12";
  const flat = [];
  const push=(x)=>{ if(!x) return; if(Array.isArray(x)) x.forEach(push); else if(x.months) flat.push(x); };
  push(rows);
  if (flat.length === 0) return fallback;
  const ms = ["12","11","10","09","08","07","06","05","04","03","02","01"];
  for (const m of ms) {
    if (flat.some(r => Math.abs(r.months[m]||0) > 0.005)) return m;
  }
  return fallback;
}
const BH_MONTH_LABEL={"01":"Jan","02":"Feb","03":"Mrz","04":"Apr","05":"Mai","06":"Jun","07":"Jul","08":"Aug","09":"Sep","10":"Okt","11":"Nov","12":"Dez"};

/* ─── BuchhaltungMitarbeiter ─── */
const BuchhaltungMitarbeiter=()=>{
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const year=String(window.__bhJahr||new Date().getFullYear()); // global Jahr-Selector im Header
  const [drillKey,setDrillKey]=useState(null); // key of category being drilled
  const [drillData,setDrillData]=useState([]);
  const [drillLoading,setDrillLoading]=useState(false);
  const MONTHS=[{k:"01",l:"Jan"},{k:"02",l:"Feb"},{k:"03",l:"Mrz"},{k:"04",l:"Apr"},
    {k:"05",l:"Mai"},{k:"06",l:"Jun"},{k:"07",l:"Jul"},{k:"08",l:"Aug"},
    {k:"09",l:"Sep"},{k:"10",l:"Okt"},{k:"11",l:"Nov"},{k:"12",l:"Dez"}];

  // Payroll account keys per group for drill-down
  const GROUP_KTOS={gehaelter:['6020'],gf:['6027','6149'],aushilfen:['6030','6040'],sozial:['6110','6115'],freiwillig:['6060','6072','6130'],reise:['6650','6660','6663','6664']};

  useEffect(()=>{
    setLoading(true);
    fetch(`/api/cashflow/buchhaltung/mitarbeiter?year=${year}`)
      .then(r=>r.json()).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false));
  },[year]);

  const openDrill=useCallback((key)=>{
    const ktos=(GROUP_KTOS[key]||[]).join(',');
    setDrillKey(key);setDrillLoading(true);
    fetch(`/api/cashflow/buchhaltung/mitarbeiter/detail?kto=${(GROUP_KTOS[key]||['6020'])[0]}`)
      .then(r=>r.json()).then(d=>{
        // Filter to only the accounts in this group
        const ktoList=GROUP_KTOS[key]||[];
        setDrillData(Array.isArray(d)?d.filter(r=>ktoList.includes(r.Ktonr)):[]);
        setDrillLoading(false);
      }).catch(()=>setDrillLoading(false));
  },[]);

  const thS={padding:"5px 8px",fontWeight:600,fontSize:10,color:"var(--t3)",whiteSpace:"nowrap",borderBottom:"2px solid var(--brd)",textAlign:"right"};
  const tdS={padding:"4px 8px",fontSize:11,fontFamily:"'JetBrains Mono',monospace",textAlign:"right",whiteSpace:"nowrap"};
  const iS={padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  const fmtBwa=v=>v===0?"–":(v||0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2});

  if(loading)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade Personaldaten…</div>;
  if(!data)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Keine Daten</div>;

  const {groups=[],freelancers=[],mitarbeiter=[],mitarbeiterEinzel=[],dataNote=""}=data;
  const totalPerMonth=MONTHS.map(m=>groups.reduce((a,g)=>a+(g.months[m.k]||0),0));
  const gesamtJahr=groups.reduce((a,g)=>a+g.total,0);
  const aktivJahr=parseInt(year);
  const lastMonth=bhLastMonth([groups,freelancers,mitarbeiter,mitarbeiterEinzel],aktivJahr);
  const monatLabel=BH_MONTH_LABEL[lastMonth]||"Dez";

  // Summary cards
  const gehalt=groups.find(g=>g.key==="gehaelter");
  const gf=groups.find(g=>g.key==="gf");
  const sozial=groups.find(g=>g.key==="sozial");
  const freiwillig=groups.find(g=>g.key==="freiwillig");
  const aushilfen=groups.find(g=>g.key==="aushilfen");
  const freelancerTotal=freelancers.reduce((a,f)=>a+f.total,0);

  const KARTEN=[
    {label:"Gehälter (AN)",val:gehalt?.total||0,farbe:"var(--acc)"},
    {label:"GF-Vergütungen",val:gf?.total||0,farbe:"#8b5cf6"},
    {label:"Sozialabgaben",val:(sozial?.total||0)+(freiwillig?.total||0),farbe:"#f59e0b"},
    {label:"Aushilfen",val:aushilfen?.total||0,farbe:"#10b981"},
    {label:"Fremdleistungen",val:freelancerTotal,farbe:"#06b6d4"},
    {label:"Gesamtpersonalkosten",val:gesamtJahr+freelancerTotal,farbe:"var(--grn)",bold:true},
  ];

  return<div style={{maxWidth:1600}}>
    {/* Header */}
    <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:20}}>
      <span style={{marginLeft:"auto",fontSize:11,color:"var(--t3)"}}>Daten: GDPdU Export (keine Einzelmitarbeiterdaten verfügbar) · Jahr {year} · Stand bis {monatLabel} {aktivJahr}</span>
    </div>

    {/* Karten */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:12,marginBottom:24}}>
      {KARTEN.map(k=><div key={k.label} style={{background:"var(--s2)",border:`1px solid ${k.farbe}44`,borderRadius:8,padding:"14px 16px",borderLeft:`3px solid ${k.farbe}`}}>
        <div style={{fontSize:10,color:"var(--t3)",marginBottom:4}}>{k.label}</div>
        <div style={{fontSize:k.bold?16:14,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:k.farbe}}>
          {(k.val||0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})} €
        </div>
      </div>)}
    </div>

    {/* Monatstabelle Personalkosten */}
    <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,marginBottom:20,overflow:"hidden"}}>
      <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",fontWeight:600,fontSize:13,color:"var(--t1)"}}>Personalkosten nach Kategorie (monatlich)</div>
      <div style={{overflowX:"auto"}}>
        <table style={{borderCollapse:"collapse",fontSize:11,minWidth:1200,width:"100%"}}>
          <thead>
            <tr style={{background:"var(--bg)"}}>
              <th style={{...thS,textAlign:"left",padding:"6px 12px",minWidth:220,position:"sticky",left:0,background:"var(--bg)",zIndex:2}}>Kategorie</th>
              {MONTHS.map(m=><th key={m.k} style={thS}>{m.l}</th>)}
              <th style={{...thS,color:"var(--t1)"}}>Gesamt</th>
            </tr>
          </thead>
          <tbody>
            {groups.map((grp,gi)=>{
              const isOpen=drillKey===grp.key;
              const rowBg=gi%2===0?"var(--s2)":"var(--bg)";
              return<React.Fragment key={grp.key}>
                <tr onClick={()=>isOpen?setDrillKey(null):openDrill(grp.key)}
                    style={{borderBottom:"1px solid var(--brd)",background:rowBg,cursor:"pointer"}}
                    title="Klicken für Details">
                  <td style={{padding:"5px 12px",fontWeight:600,color:"var(--t1)",fontSize:12,position:"sticky",left:0,background:rowBg,userSelect:"none"}}>
                    <span style={{marginRight:6,fontSize:10,color:"var(--t3)",display:"inline-block",transition:"transform 0.15s",transform:isOpen?"rotate(90deg)":"rotate(0deg)"}}>▶</span>
                    {grp.label}
                  </td>
                  {MONTHS.map(m=>{
                    const v=grp.months[m.k]||0;
                    return<td key={m.k} style={{...tdS,color:v===0?"var(--t3)":v<0?"var(--grn)":"var(--t1)"}}>{fmtBwa(v)}</td>;
                  })}
                  <td style={{...tdS,fontWeight:700,color:grp.total<0?"var(--grn)":"var(--t1)"}}>{fmtBwa(grp.total)}</td>
                </tr>
                {isOpen&&(drillLoading
                  ?<tr><td colSpan={14} style={{padding:"10px 24px",color:"var(--t3)",fontSize:11}}>Lade Details…</td></tr>
                  :drillData.length===0
                    ?<tr><td colSpan={14} style={{padding:"10px 24px",color:"var(--t3)",fontSize:11}}>Keine Buchungsdetails gefunden</td></tr>
                    :drillData.map((d,di)=><tr key={di} style={{background:"var(--bg)",borderBottom:"1px solid var(--brd)33"}}>
                        <td style={{padding:"4px 12px 4px 36px",fontSize:11,color:"var(--t2)",position:"sticky",left:0,background:"var(--bg)"}}>
                          <span style={{color:"var(--t3)",marginRight:6,fontSize:9}}>Kto {d.Ktonr}</span>{d.Buchungstext}
                        </td>
                        {MONTHS.map(m=>{
                          const v=d.months[m.k]||0;
                          return<td key={m.k} style={{...tdS,fontSize:10,color:v===0?"var(--t3)":v<0?"var(--grn)":"var(--t2)"}}>{fmtBwa(v)}</td>;
                        })}
                        <td style={{...tdS,fontSize:10,fontWeight:600,color:d.total<0?"var(--grn)":"var(--t2)"}}>{fmtBwa(d.total)}</td>
                      </tr>)
                )}
              </React.Fragment>;
            })}
            {/* Gesamt */}
            <tr style={{borderTop:"2px solid var(--brd)",background:"var(--bg)",fontWeight:700}}>
              <td style={{padding:"6px 12px",fontWeight:700,fontSize:12,color:"var(--t1)",position:"sticky",left:0,background:"var(--bg)"}}>Σ Personalkosten</td>
              {totalPerMonth.map((v,i)=><td key={i} style={{...tdS,fontWeight:700,fontSize:12,color:"var(--t1)"}}>{fmtBwa(v)}</td>)}
              <td style={{...tdS,fontWeight:700,fontSize:13,color:"var(--grn)"}}>{fmtBwa(gesamtJahr)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    {/* Einzelmitarbeiter aus Bank-Buchungstexten */}
    {mitarbeiterEinzel.length>0&&<div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden",marginBottom:20}}>
      <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",display:"flex",alignItems:"center",gap:12}}>
        <span style={{fontWeight:600,fontSize:13,color:"var(--t1)"}}>👤 Einzelmitarbeiter ({mitarbeiterEinzel.length}) – aus Bank-Buchungstexten extrahiert</span>
        <span style={{marginLeft:"auto",fontSize:10,color:"var(--t3)",fontStyle:"italic"}}>Nur Mitarbeiter mit namentlich zugeordneten Banktransaktionen (Lohndifferenzen, Direktüberweisungen)</span>
      </div>
      <div style={{overflowX:"auto"}}>
        <table style={{borderCollapse:"collapse",fontSize:11,minWidth:1200,width:"100%"}}>
          <thead>
            <tr style={{background:"var(--bg)"}}>
              <th style={{...thS,textAlign:"left",padding:"6px 12px",minWidth:240,position:"sticky",left:0,background:"var(--bg)",zIndex:2}}>Mitarbeiter</th>
              <th style={{...thS,textAlign:"center",minWidth:60}}>Vorgänge</th>
              {MONTHS.map(m=><th key={m.k} style={thS}>{m.l}</th>)}
              <th style={{...thS,color:"var(--t1)"}}>Gesamt</th>
            </tr>
          </thead>
          <tbody>
            {mitarbeiterEinzel.map((e,i)=>{
              const rowBg=i%2===0?"var(--s2)":"var(--bg)";
              return<tr key={i} style={{borderBottom:"1px solid var(--brd)33",background:rowBg}} title={e.variants.join(" · ")}>
                <td style={{padding:"5px 12px",fontSize:11,color:"var(--t1)",position:"sticky",left:0,background:rowBg}}>
                  <span style={{fontWeight:600}}>{e.nachname}</span>, <span style={{color:"var(--t2)"}}>{e.vorname}</span>
                  {e.variants.length>1&&<span style={{marginLeft:8,fontSize:9,color:"var(--t3)",fontStyle:"italic"}}>({e.variants.length} Varianten)</span>}
                </td>
                <td style={{...tdS,textAlign:"center",color:"var(--t3)",fontSize:10}}>{e.count}</td>
                {MONTHS.map(m=>{
                  const v=e.months[m.k]||0;
                  return<td key={m.k} style={{...tdS,fontSize:10,color:v===0?"var(--t3)":v<0?"var(--grn)":"var(--t1)"}}>{fmtBwa(v)}</td>;
                })}
                <td style={{...tdS,fontWeight:700,color:e.total<0?"var(--grn)":"var(--t1)"}}>{fmtBwa(e.total)}</td>
              </tr>;
            })}
            <tr style={{borderTop:"2px solid var(--brd)",background:"var(--bg)"}}>
              <td style={{padding:"6px 12px",fontWeight:700,fontSize:12,color:"var(--t1)",position:"sticky",left:0,background:"var(--bg)"}}>Σ {mitarbeiterEinzel.length} Mitarbeiter</td>
              <td style={{...tdS,fontWeight:700,textAlign:"center"}}>{mitarbeiterEinzel.reduce((a,e)=>a+e.count,0)}</td>
              {MONTHS.map(m=>{
                const v=mitarbeiterEinzel.reduce((a,e)=>a+(e.months[m.k]||0),0);
                return<td key={m.k} style={{...tdS,fontWeight:700}}>{fmtBwa(v)}</td>;
              })}
              <td style={{...tdS,fontWeight:700,color:"var(--t1)"}}>{fmtBwa(mitarbeiterEinzel.reduce((a,e)=>a+e.total,0))}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>}

    {/* Lohnarten-Auflistung (aggregiert aus Buchungstext der Lohnkonten) */}
    {mitarbeiter.length>0&&<div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden",marginBottom:20}}>
      <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",display:"flex",alignItems:"center",gap:12}}>
        <span style={{fontWeight:600,fontSize:13,color:"var(--t1)"}}>Mitarbeiter / Lohnarten ({mitarbeiter.length})</span>
        {dataNote&&<span style={{fontSize:10,color:"var(--t3)",fontStyle:"italic",marginLeft:"auto"}}>⚠ {dataNote}</span>}
      </div>
      <div style={{overflowX:"auto"}}>
        <table style={{borderCollapse:"collapse",fontSize:11,minWidth:1200,width:"100%"}}>
          <thead>
            <tr style={{background:"var(--bg)"}}>
              <th style={{...thS,textAlign:"left",padding:"6px 12px",minWidth:260,position:"sticky",left:0,background:"var(--bg)",zIndex:2}}>Konto · Lohnart</th>
              {MONTHS.map(m=><th key={m.k} style={thS}>{m.l}</th>)}
              <th style={{...thS,color:"var(--t1)"}}>Gesamt</th>
            </tr>
          </thead>
          <tbody>
            {mitarbeiter.map((e,i)=>{
              const rowBg=i%2===0?"var(--s2)":"var(--bg)";
              return<tr key={i} style={{borderBottom:"1px solid var(--brd)33",background:rowBg}}>
                <td style={{padding:"5px 12px",fontSize:11,color:"var(--t1)",position:"sticky",left:0,background:rowBg}}>
                  <span style={{color:"var(--t3)",fontSize:10,marginRight:8}}>Kto {e.kto}</span>
                  <span style={{fontWeight:500}}>{e.text}</span>
                  <span style={{color:"var(--t3)",fontSize:10,marginLeft:8}}>· {e.ktoLabel}</span>
                </td>
                {MONTHS.map(m=>{
                  const v=e.months[m.k]||0;
                  return<td key={m.k} style={{...tdS,color:v===0?"var(--t3)":v<0?"var(--grn)":"var(--t1)"}}>{fmtBwa(v)}</td>;
                })}
                <td style={{...tdS,fontWeight:700,color:e.total<0?"var(--grn)":"var(--t1)"}}>{fmtBwa(e.total)}</td>
              </tr>;
            })}
            <tr style={{borderTop:"2px solid var(--brd)",background:"var(--bg)"}}>
              <td style={{padding:"6px 12px",fontWeight:700,fontSize:12,color:"var(--t1)",position:"sticky",left:0,background:"var(--bg)"}}>Σ alle Lohnarten</td>
              {MONTHS.map(m=>{
                const v=mitarbeiter.reduce((a,e)=>a+(e.months[m.k]||0),0);
                return<td key={m.k} style={{...tdS,fontWeight:700}}>{fmtBwa(v)}</td>;
              })}
              <td style={{...tdS,fontWeight:700,color:"var(--grn)"}}>{fmtBwa(mitarbeiter.reduce((a,e)=>a+e.total,0))}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>}

    {/* Fremdleistungen */}
    {freelancers.length>0&&<div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden"}}>
      <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",fontWeight:600,fontSize:13,color:"var(--t1)"}}>Fremdleistungen / Honorare (Buchungskonto 5900)</div>
      <div style={{overflowX:"auto"}}>
        <table style={{borderCollapse:"collapse",fontSize:11,minWidth:1200,width:"100%"}}>
          <thead>
            <tr style={{background:"var(--bg)"}}>
              <th style={{...thS,textAlign:"left",padding:"6px 12px",minWidth:220,position:"sticky",left:0,background:"var(--bg)",zIndex:2}}>Person</th>
              {MONTHS.map(m=><th key={m.k} style={thS}>{m.l}</th>)}
              <th style={{...thS,color:"var(--t1)"}}>Gesamt</th>
            </tr>
          </thead>
          <tbody>
            {freelancers.map((f,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
              <td style={{padding:"5px 12px",fontWeight:600,color:"#06b6d4",fontSize:12,position:"sticky",left:0,background:i%2===0?"var(--s2)":"var(--bg)"}}>{f.name}</td>
              {MONTHS.map(m=>{
                const v=f.months[m.k]||0;
                return<td key={m.k} style={{...tdS,color:v===0?"var(--t3)":"var(--t1)"}}>{fmtBwa(v)}</td>;
              })}
              <td style={{...tdS,fontWeight:700,color:"#06b6d4"}}>{fmtBwa(f.total)}</td>
            </tr>)}
            <tr style={{borderTop:"2px solid var(--brd)",background:"var(--bg)"}}>
              <td style={{padding:"6px 12px",fontWeight:700,color:"var(--t1)",position:"sticky",left:0,background:"var(--bg)"}}>Σ Fremdleistungen</td>
              {MONTHS.map(m=>{
                const v=freelancers.reduce((a,f)=>a+(f.months[m.k]||0),0);
                return<td key={m.k} style={{...tdS,fontWeight:700}}>{fmtBwa(v)}</td>;
              })}
              <td style={{...tdS,fontWeight:700,color:"#06b6d4"}}>{fmtBwa(freelancerTotal)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>}
  </div>;
};

/* ─── BuchhaltungLieferanten ─── */
const BuchhaltungLieferanten=()=>{
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const year=String(window.__bhJahr||new Date().getFullYear()); // global Jahr-Selector im Header
  const [search,setSearch]=useState("");
  const [filterCat,setFilterCat]=useState("ware");
  const CAT_COLORS={ware:"#10b981",it:"#3b82f6",marktplatz:"#f59e0b",verrechnung:"#8b5cf6",sonstig:"#64748b"};
  const MONTHS=[{k:"01",l:"Jan"},{k:"02",l:"Feb"},{k:"03",l:"Mrz"},{k:"04",l:"Apr"},
    {k:"05",l:"Mai"},{k:"06",l:"Jun"},{k:"07",l:"Jul"},{k:"08",l:"Aug"},
    {k:"09",l:"Sep"},{k:"10",l:"Okt"},{k:"11",l:"Nov"},{k:"12",l:"Dez"}];

  useEffect(()=>{
    setLoading(true);
    fetch(`/api/cashflow/buchhaltung/lieferanten?year=${year}`)
      .then(r=>r.json()).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false));
  },[year]);

  const thS={padding:"5px 8px",fontWeight:600,fontSize:10,color:"var(--t3)",whiteSpace:"nowrap",borderBottom:"2px solid var(--brd)",textAlign:"right"};
  const tdS={padding:"4px 8px",fontSize:11,fontFamily:"'JetBrains Mono',monospace",textAlign:"right",whiteSpace:"nowrap"};
  const iS={padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};
  const fmt=v=>v===0?"–":(v||0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2});

  if(loading)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade Lieferantendaten…</div>;
  if(!data)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Keine Daten</div>;

  const {lieferanten=[],totals={},categoryTotals={},categoryLabels={}}=data;
  const re=search?new RegExp(search.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'),'i'):null;
  const rows=(filterCat?lieferanten.filter(l=>l.category===filterCat):lieferanten)
    .filter(l=>!re||re.test(l.name)||re.test(l.ktonr));
  const aktivJahr=parseInt(year);
  const lastMonth=bhLastMonth(lieferanten,aktivJahr);
  const monatLabel=BH_MONTH_LABEL[lastMonth]||"Dez";

  return<div style={{maxWidth:1800}}>
    <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:20,flexWrap:"wrap"}}>
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Lieferant suchen…"
        style={{...iS,width:220,marginLeft:16}}/>
      <span style={{marginLeft:"auto",fontSize:11,color:"var(--t3)"}}>{rows.length} Lieferanten · Stand bis {monatLabel} {aktivJahr}</span>
    </div>

    {/* Kategorien */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:12,marginBottom:16}}>
      {["ware","it","marktplatz","verrechnung","sonstig"].map(cat=>{
        const col=CAT_COLORS[cat]||"var(--acc)";
        const active=filterCat===cat;
        const v=categoryTotals[cat]||0;
        const count=lieferanten.filter(l=>l.category===cat).length;
        return<div key={cat} onClick={()=>setFilterCat(active?"":cat)} style={{background:active?col+"22":"var(--s2)",border:`1px solid ${active?col:col+"44"}`,borderRadius:8,padding:"12px 14px",borderLeft:`3px solid ${col}`,cursor:"pointer",transition:"all .15s"}}>
          <div style={{fontSize:10,color:"var(--t3)",marginBottom:4,display:"flex",justifyContent:"space-between"}}><span>{categoryLabels[cat]||cat}</span><span style={{color:col}}>{count}</span></div>
          <div style={{fontSize:14,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:col}}>{v.toLocaleString("de-DE",{maximumFractionDigits:0})} €</div>
        </div>;
      })}
      <div onClick={()=>setFilterCat("")} style={{background:filterCat?"var(--s2)":"var(--bg)",border:"1px solid var(--acc)44",borderRadius:8,padding:"12px 14px",borderLeft:"3px solid var(--acc)",cursor:"pointer"}}>
        <div style={{fontSize:10,color:"var(--t3)",marginBottom:4}}>Alle anzeigen</div>
        <div style={{fontSize:14,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)"}}>{Object.values(categoryTotals).reduce((a,v)=>a+v,0).toLocaleString("de-DE",{maximumFractionDigits:0})} €</div>
      </div>
    </div>

    {/* Monatliche Summen */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(110px,1fr))",gap:8,marginBottom:24}}>
      {MONTHS.map(m=>{
        const v=totals[m.k]||0;
        return<div key={m.k} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:6,padding:"8px 10px"}}>
          <div style={{fontSize:9,color:"var(--t3)"}}>{m.l}</div>
          <div style={{fontSize:11,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)"}}>{v===0?"–":v.toLocaleString("de-DE",{maximumFractionDigits:0})}</div>
        </div>;
      })}
    </div>

    <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden"}}>
      <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",fontWeight:600,fontSize:13,color:"var(--t1)"}}>Kosten nach Lieferant (monatlich)</div>
      <div style={{overflowX:"auto"}}>
        <table style={{borderCollapse:"collapse",fontSize:11,minWidth:1300,width:"100%"}}>
          <thead>
            <tr style={{background:"var(--bg)"}}>
              <th style={{...thS,textAlign:"left",minWidth:60,position:"sticky",left:0,background:"var(--bg)",zIndex:2}}>Ktonr</th>
              <th style={{...thS,textAlign:"left",minWidth:240,position:"sticky",left:60,background:"var(--bg)",zIndex:2}}>Name</th>
              <th style={{...thS,textAlign:"left",minWidth:120}}>Kategorie</th>
              {MONTHS.map(m=><th key={m.k} style={thS}>{m.l}</th>)}
              <th style={{...thS,color:"var(--t1)"}}>Gesamt</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((l,i)=>{
              const catCol=CAT_COLORS[l.category]||"#64748b";
              return<tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
              <td style={{padding:"4px 8px",fontSize:11,color:"var(--t3)",fontFamily:"'JetBrains Mono',monospace",position:"sticky",left:0,background:i%2===0?"var(--s2)":"var(--bg)"}}>{l.ktonr}</td>
              <td style={{padding:"4px 8px",fontWeight:500,color:"var(--t1)",position:"sticky",left:60,background:i%2===0?"var(--s2)":"var(--bg)",fontSize:11,maxWidth:240,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={l.topAccounts?.map(a=>`${a.kto}: ${a.sum.toLocaleString("de-DE",{maximumFractionDigits:0})}€`).join(" · ")}>{l.name}</td>
              <td style={{padding:"4px 8px",fontSize:10}}>
                <span style={{display:"inline-block",padding:"2px 8px",borderRadius:3,background:catCol+"22",color:catCol,fontWeight:600,letterSpacing:"0.02em"}}>{l.categoryLabel}</span>
              </td>
              {MONTHS.map(m=>{
                const v=l.months[m.k]||0;
                return<td key={m.k} style={{...tdS,color:v===0?"var(--t3)":"var(--t1)"}}>{fmt(v)}</td>;
              })}
              <td style={{...tdS,fontWeight:700,color:"var(--acc)"}}>
                {fmt(l.total)}
                {filterCat==="ware"&&categoryTotals.ware>0&&<span style={{marginLeft:6,fontSize:10,color:"#fff",fontWeight:600}}>({(l.total/categoryTotals.ware*100).toLocaleString("de-DE",{minimumFractionDigits:1,maximumFractionDigits:1})} %)</span>}
              </td>
            </tr>;})}
            {rows.length===0&&<tr><td colSpan={17} style={{padding:20,textAlign:"center",color:"var(--t3)"}}>Keine Lieferanten gefunden</td></tr>}
            <tr style={{borderTop:"2px solid var(--brd)",background:"var(--bg)"}}>
              <td colSpan={3} style={{padding:"6px 8px",fontWeight:700,color:"var(--t1)",position:"sticky",left:0,background:"var(--bg)"}}>Σ Gesamt</td>
              {MONTHS.map(m=>{
                const v=rows.reduce((a,l)=>a+(l.months[m.k]||0),0);
                return<td key={m.k} style={{...tdS,fontWeight:700}}>{fmt(v)}</td>;
              })}
              <td style={{...tdS,fontWeight:700,color:"var(--acc)"}}>{fmt(rows.reduce((a,l)=>a+l.total,0))}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>;
};

/* ─── BuchhaltungMarktplatz ─── */
const BuchhaltungMarktplatz=()=>{
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const year=String(window.__bhJahr||new Date().getFullYear()); // global Jahr-Selector im Header
  const MONTHS=[{k:"01",l:"Jan"},{k:"02",l:"Feb"},{k:"03",l:"Mrz"},{k:"04",l:"Apr"},
    {k:"05",l:"Mai"},{k:"06",l:"Jun"},{k:"07",l:"Jul"},{k:"08",l:"Aug"},
    {k:"09",l:"Sep"},{k:"10",l:"Okt"},{k:"11",l:"Nov"},{k:"12",l:"Dez"}];

  useEffect(()=>{
    setLoading(true);
    fetch(`/api/cashflow/buchhaltung/marktplatz?year=${year}`)
      .then(r=>r.json()).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false));
  },[year]);

  const thS={padding:"5px 8px",fontWeight:600,fontSize:10,color:"var(--t3)",whiteSpace:"nowrap",borderBottom:"2px solid var(--brd)",textAlign:"right"};
  const tdS={padding:"4px 8px",fontSize:11,fontFamily:"'JetBrains Mono',monospace",textAlign:"right",whiteSpace:"nowrap"};
  const iS={padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};
  const fmt=v=>v===0?"–":(v||0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2});

  if(loading)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade Marktplatzdaten…</div>;
  if(!data)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Keine Daten</div>;

  const {marketplaces=[],costs=[],perMarketplace=[],shared=null}=data;

  const totalUmsatz=MONTHS.map(m=>marketplaces.reduce((a,mp)=>a+(mp.months[m.k]||0),0));
  const totalKosten=MONTHS.map(m=>costs.reduce((a,c)=>a+(c.months[m.k]||0),0));
  const ergebnis=MONTHS.map((_,i)=>totalUmsatz[i]-totalKosten[i]);
  const jahresUmsatz=marketplaces.reduce((a,mp)=>a+mp.total,0);
  const jahresKosten=costs.reduce((a,c)=>a+c.total,0);
  const jahresErgebnis=jahresUmsatz-jahresKosten;
  const aktivJahr=parseInt(year);
  const lastMonth=bhLastMonth([marketplaces,costs],aktivJahr);
  const monatLabel=BH_MONTH_LABEL[lastMonth]||"Dez";

  const SectionHeader=({label,color="#666"})=><tr style={{background:"var(--bg)"}}>
    <td colSpan={14} style={{padding:"8px 12px",fontWeight:700,fontSize:11,color,letterSpacing:"0.05em",textTransform:"uppercase",borderBottom:"1px solid var(--brd)"}}>{label}</td>
  </tr>;

  return<div style={{maxWidth:1800}}>
    <div style={{display:"flex",justifyContent:"flex-end",fontSize:11,color:"var(--t3)",marginBottom:8}}>Stand bis {monatLabel} {aktivJahr}</div>
    {/* KPI Cards */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,marginBottom:24}}>
      <div style={{background:"var(--s2)",border:"1px solid var(--grn)44",borderRadius:8,padding:"16px 20px",borderLeft:"3px solid var(--grn)"}}>
        <div style={{fontSize:11,color:"var(--t3)",marginBottom:6}}>Gesamtumsatz {year}</div>
        <div style={{fontSize:22,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:"var(--grn)"}}>{jahresUmsatz.toLocaleString("de-DE",{maximumFractionDigits:0})} €</div>
      </div>
      <div style={{background:"var(--s2)",border:"1px solid var(--red)44",borderRadius:8,padding:"16px 20px",borderLeft:"3px solid var(--red)"}}>
        <div style={{fontSize:11,color:"var(--t3)",marginBottom:6}}>Marktplatzkosten {year}</div>
        <div style={{fontSize:22,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:"var(--red)"}}>{jahresKosten.toLocaleString("de-DE",{maximumFractionDigits:0})} €</div>
      </div>
      <div style={{background:"var(--s2)",border:`1px solid ${jahresErgebnis>=0?"var(--grn)":"var(--red)"}44`,borderRadius:8,padding:"16px 20px",borderLeft:`3px solid ${jahresErgebnis>=0?"var(--grn)":"var(--red)"}`}}>
        <div style={{fontSize:11,color:"var(--t3)",marginBottom:6}}>Ergebnis {year}</div>
        <div style={{fontSize:22,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:jahresErgebnis>=0?"var(--grn)":"var(--red)"}}>{jahresErgebnis.toLocaleString("de-DE",{maximumFractionDigits:0})} €</div>
      </div>
    </div>

    {/* Per-Marketplace Umsatz · Kosten · Ergebnis */}
    {perMarketplace.length>0&&<div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden",marginBottom:24}}>
      <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",fontWeight:600,fontSize:13,color:"var(--t1)"}}>Je Marktplatz: Umsatz · Kosten · Ergebnis</div>
      <div style={{overflowX:"auto"}}>
        <table style={{borderCollapse:"collapse",fontSize:11,minWidth:1200,width:"100%"}}>
          <thead>
            <tr style={{background:"var(--bg)"}}>
              <th style={{...thS,textAlign:"left",padding:"6px 12px",minWidth:160,position:"sticky",left:0,background:"var(--bg)",zIndex:2}}>Marktplatz</th>
              <th style={{...thS,textAlign:"left",minWidth:160}}>Position</th>
              {MONTHS.map(m=><th key={m.k} style={thS}>{m.l}</th>)}
              <th style={{...thS,color:"var(--t1)"}}>Gesamt</th>
              <th style={{...thS,color:"var(--t3)",minWidth:60}}>Marge</th>
            </tr>
          </thead>
          <tbody>
            {perMarketplace.map((mp,i)=>{
              const bg=i%2===0?"var(--s2)":"var(--bg)";
              const kGrp=mp.kosten?.byGroup||{};
              const groupEntries=Object.entries(kGrp).filter(([,v])=>(v?.total||0)!==0).sort((a,b)=>Math.abs(b[1].total)-Math.abs(a[1].total));
              const rowSpan=2+groupEntries.length+1; // name + umsatz + kosten-summe + groups + ergebnis
              return<React.Fragment key={mp.name}>
                {/* Umsatzerlöse */}
                <tr style={{background:bg,borderTop:i>0?"2px solid var(--brd)":"none"}}>
                  <td rowSpan={rowSpan} style={{padding:"8px 12px",fontWeight:700,color:"var(--t1)",fontSize:14,position:"sticky",left:0,background:bg,borderRight:"1px solid var(--brd)",verticalAlign:"top"}}>
                    {mp.name}
                  </td>
                  <td style={{padding:"4px 10px",color:"var(--grn)",fontSize:11,fontWeight:600,whiteSpace:"nowrap"}}>Umsatzerlöse</td>
                  {MONTHS.map(m=>{
                    const v=mp.umsatz.months[m.k]||0;
                    return<td key={m.k} style={{...tdS,fontSize:10,color:v===0?"var(--t3)":"var(--grn)"}}>{v===0?"–":Math.round(v).toLocaleString("de-DE")}</td>;
                  })}
                  <td style={{...tdS,fontSize:11,fontWeight:700,color:"var(--grn)"}}>{Math.round(mp.umsatz.total).toLocaleString("de-DE")}</td>
                  <td rowSpan={rowSpan} style={{...tdS,fontWeight:700,fontSize:13,color:mp.ergebnis.total>=0?"var(--grn)":"var(--red)",verticalAlign:"middle"}}>{mp.marge.toLocaleString("de-DE",{minimumFractionDigits:1,maximumFractionDigits:1})}%</td>
                </tr>
                {/* Kosten-Summe */}
                <tr style={{background:bg}}>
                  <td style={{padding:"4px 10px",color:"var(--red)",fontSize:11,fontWeight:600,whiteSpace:"nowrap"}}>Kosten gesamt</td>
                  {MONTHS.map(m=>{
                    const v=mp.kosten.months[m.k]||0;
                    return<td key={m.k} style={{...tdS,fontSize:10,color:v===0?"var(--t3)":"var(--red)"}}>{v===0?"–":"-"+Math.round(v).toLocaleString("de-DE")}</td>;
                  })}
                  <td style={{...tdS,fontSize:11,fontWeight:700,color:"var(--red)"}}>-{Math.round(mp.kosten.total).toLocaleString("de-DE")}</td>
                </tr>
                {/* Kosten-Positionen einzeln */}
                {groupEntries.map(([g,gv])=>(
                  <tr key={g} style={{background:bg}}>
                    <td style={{padding:"3px 10px 3px 24px",color:"#fff",fontSize:10,fontWeight:400,whiteSpace:"nowrap",opacity:0.8}}>{g}</td>
                    {MONTHS.map(m=>{
                      const v=gv.months?.[m.k]||0;
                      return<td key={m.k} style={{...tdS,fontSize:9,color:v===0?"var(--t3)":"#fff",opacity:v===0?1:0.75}}>{v===0?"–":"-"+Math.round(v).toLocaleString("de-DE")}</td>;
                    })}
                    <td style={{...tdS,fontSize:10,fontWeight:600,color:"#fff",opacity:0.85}}>-{Math.round(gv.total).toLocaleString("de-DE")}</td>
                  </tr>
                ))}
                {/* Ergebnis */}
                <tr style={{background:"var(--bg)",borderBottom:"1px solid var(--brd)",borderTop:"1px solid var(--brd)"}}>
                  <td style={{padding:"5px 10px",color:mp.ergebnis.total>=0?"var(--grn)":"var(--red)",fontSize:12,fontWeight:700,whiteSpace:"nowrap"}}>Ergebnis</td>
                  {MONTHS.map(m=>{
                    const v=mp.ergebnis.months[m.k]||0;
                    return<td key={m.k} style={{...tdS,fontSize:11,fontWeight:700,color:v===0?"var(--t3)":v>=0?"var(--grn)":"var(--red)"}}>{v===0?"–":Math.round(v).toLocaleString("de-DE")}</td>;
                  })}
                  <td style={{...tdS,fontSize:12,fontWeight:800,color:mp.ergebnis.total>=0?"var(--grn)":"var(--red)"}}>{Math.round(mp.ergebnis.total).toLocaleString("de-DE")}</td>
                </tr>
              </React.Fragment>;
            })}
            {shared&&shared.total!==0&&<tr style={{background:"var(--bg)",borderTop:"2px solid var(--brd)"}}>
              <td style={{padding:"6px 12px",fontWeight:600,color:"var(--t3)",fontSize:11,fontStyle:"italic",position:"sticky",left:0,background:"var(--bg)"}}>Nicht zugeordnet</td>
              <td style={{padding:"6px 12px",fontSize:10,color:"#fff",fontWeight:500,opacity:0.85}}>{Object.entries(shared.byGroup||{}).filter(([,v])=>(v?.total||v||0)!==0).map(([g,v])=>`${g}: ${Math.round(v?.total||v||0).toLocaleString("de-DE")}€`).join(" · ")||"–"}</td>
              {MONTHS.map(m=>{
                const v=shared.months[m.k]||0;
                return<td key={m.k} style={{...tdS,fontSize:10,color:v===0?"var(--t3)":"var(--red)",fontStyle:"italic"}}>{v===0?"–":"-"+Math.round(v).toLocaleString("de-DE")}</td>;
              })}
              <td style={{...tdS,fontWeight:700,color:"var(--red)",fontStyle:"italic"}}>-{Math.round(shared.total).toLocaleString("de-DE")}</td>
              <td></td>
            </tr>}
          </tbody>
        </table>
      </div>
    </div>}

    <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden"}}>
      <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",fontWeight:600,fontSize:13,color:"var(--t1)"}}>Detail: Umsätze & Kosten (Kontenbasis)</div>
      <div style={{overflowX:"auto"}}>
        <table style={{borderCollapse:"collapse",fontSize:11,minWidth:1200,width:"100%"}}>
          <thead>
            <tr style={{background:"var(--bg)"}}>
              <th style={{...thS,textAlign:"left",padding:"6px 12px",minWidth:220,position:"sticky",left:0,background:"var(--bg)",zIndex:2}}>Position</th>
              {MONTHS.map(m=><th key={m.k} style={thS}>{m.l}</th>)}
              <th style={{...thS,color:"var(--t1)"}}>Gesamt</th>
            </tr>
          </thead>
          <tbody>
            {/* Umsätze */}
            <SectionHeader label="Erlöse / Umsätze" color="var(--grn)"/>
            {marketplaces.map((mp,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
              <td style={{padding:"5px 12px",fontWeight:600,color:"var(--grn)",fontSize:12,position:"sticky",left:0,background:i%2===0?"var(--s2)":"var(--bg)"}}>{mp.name}</td>
              {MONTHS.map(m=>{
                const v=mp.months[m.k]||0;
                return<td key={m.k} style={{...tdS,color:v===0?"var(--t3)":"var(--grn)"}}>{fmt(v)}</td>;
              })}
              <td style={{...tdS,fontWeight:700,color:"var(--grn)"}}>{fmt(mp.total)}</td>
            </tr>)}
            <tr style={{borderBottom:"2px solid var(--brd)",background:"var(--bg)"}}>
              <td style={{padding:"5px 12px",fontWeight:700,color:"var(--t1)",fontSize:12,position:"sticky",left:0,background:"var(--bg)"}}>Σ Umsätze</td>
              {totalUmsatz.map((v,i)=><td key={i} style={{...tdS,fontWeight:700,color:"var(--grn)"}}>{fmt(v)}</td>)}
              <td style={{...tdS,fontWeight:700,color:"var(--grn)"}}>{fmt(jahresUmsatz)}</td>
            </tr>

            {/* Kosten */}
            <SectionHeader label="Marktplatzkosten / Provisionen" color="var(--red)"/>
            {costs.map((c,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
              <td style={{padding:"5px 12px",fontWeight:500,color:"var(--t1)",fontSize:12,position:"sticky",left:0,background:i%2===0?"var(--s2)":"var(--bg)"}}>{c.name}</td>
              {MONTHS.map(m=>{
                const v=c.months[m.k]||0;
                return<td key={m.k} style={{...tdS,color:v===0?"var(--t3)":"var(--red)"}}>{fmt(v)}</td>;
              })}
              <td style={{...tdS,fontWeight:700,color:"var(--red)"}}>{fmt(c.total)}</td>
            </tr>)}
            <tr style={{borderBottom:"2px solid var(--brd)",background:"var(--bg)"}}>
              <td style={{padding:"5px 12px",fontWeight:700,color:"var(--t1)",fontSize:12,position:"sticky",left:0,background:"var(--bg)"}}>Σ Kosten</td>
              {totalKosten.map((v,i)=><td key={i} style={{...tdS,fontWeight:700,color:"var(--red)"}}>{fmt(v)}</td>)}
              <td style={{...tdS,fontWeight:700,color:"var(--red)"}}>{fmt(jahresKosten)}</td>
            </tr>

            {/* Ergebnis */}
            <tr style={{background:"var(--bg)",borderTop:"3px solid var(--brd)"}}>
              <td style={{padding:"7px 12px",fontWeight:700,fontSize:13,color:"var(--acc)",position:"sticky",left:0,background:"var(--bg)"}}>Ergebnis</td>
              {ergebnis.map((v,i)=><td key={i} style={{...tdS,fontWeight:700,fontSize:12,color:v>=0?"var(--grn)":"var(--red)"}}>{fmt(v)}</td>)}
              <td style={{...tdS,fontWeight:700,fontSize:13,color:jahresErgebnis>=0?"var(--grn)":"var(--red)"}}>{fmt(jahresErgebnis)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>;
};

/* ─── BuchhaltungIT (IT-Kostenliste) ─── */
const BuchhaltungIT=()=>{
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const year=String(window.__bhJahr||new Date().getFullYear()); // global Jahr-Selector im Header
  const [view,setView]=useState("vendors"); // vendors | konten | liste
  const [filterVendor,setFilterVendor]=useState("");
  const [filterKto,setFilterKto]=useState("");
  const [search,setSearch]=useState("");
  useEffect(()=>{
    setLoading(true);
    fetch(`/api/cashflow/buchhaltung/it?year=${year}`)
      .then(r=>r.json()).then(d=>{setData(d);setLoading(false);})
      .catch(()=>setLoading(false));
  },[year]);
  const fmt=(v)=>v==null||isNaN(v)?"–":Math.round(v).toLocaleString("de-DE")+" €";
  const MONTHS=["01","02","03","04","05","06","07","08","09","10","11","12"];
  if(loading) return <div style={{padding:20,color:"var(--t2)"}}>Lade IT-Kosten…</div>;
  if(!data) return <div style={{padding:20,color:"var(--red)"}}>Fehler beim Laden</div>;

  const aktivJahr=parseInt(year);
  const lastMonth=bhLastMonth([data.vendors||[],data.konten||[]],aktivJahr);
  const monatLabel=BH_MONTH_LABEL[lastMonth]||"Dez";

  const filteredRows=(data.rows||[]).filter(r=>{
    if(filterVendor && r.vendor!==filterVendor) return false;
    if(filterKto && r.kto!==filterKto) return false;
    if(search){
      const s=search.toLowerCase();
      if(!r.text.toLowerCase().includes(s) && !r.vendor.toLowerCase().includes(s) && !r.ktoName.toLowerCase().includes(s)) return false;
    }
    return true;
  });
  const filteredTotal=filteredRows.reduce((a,r)=>a+r.amount,0);

  return <div style={{padding:20}}>
    <div style={{display:"flex",gap:12,alignItems:"center",marginBottom:16,flexWrap:"wrap"}}>
      <div style={{display:"flex",gap:0,border:"1px solid var(--bd)",borderRadius:6,overflow:"hidden"}}>
        {["vendors","konten","liste"].map(v=>
          <button key={v} onClick={()=>setView(v)} style={{padding:"6px 14px",background:view===v?"var(--accent)":"var(--bg2)",color:view===v?"#fff":"var(--t2)",border:"none",cursor:"pointer",fontSize:12,textTransform:"uppercase"}}>{v==="vendors"?"Vendoren":v==="konten"?"Konten":"Alle Buchungen"}</button>
        )}
      </div>
      <div style={{marginLeft:"auto",display:"flex",gap:20,fontSize:13}}>
        <div><span style={{color:"var(--t2)"}}>IT gesamt </span><b style={{color:"#fff"}}>{fmt(data.grandTotal)}</b></div>
        <div><span style={{color:"var(--t2)"}}>Buchungen </span><b style={{color:"#fff"}}>{(data.rows||[]).length.toLocaleString("de-DE")}</b></div>
        <div><span style={{color:"var(--t2)"}}>Vendoren </span><b style={{color:"#fff"}}>{(data.vendors||[]).length}</b></div>
        <div style={{color:"var(--t3)",fontSize:11}}>Stand bis {monatLabel} {aktivJahr}</div>
      </div>
    </div>

    {/* Monats-Balken */}
    <div style={{display:"flex",gap:4,marginBottom:20,alignItems:"flex-end",height:100,padding:"0 2px"}}>
      {MONTHS.map(m=>{
        const v=data.monthsTotal[m]||0;
        const max=Math.max(...Object.values(data.monthsTotal||{}),1);
        const h=Math.round((v/max)*90);
        return <div key={m} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center"}}>
          <div style={{fontSize:10,color:"#fff",marginBottom:2}}>{v?Math.round(v/1000)+"k":""}</div>
          <div style={{width:"100%",height:h,background:"#4f46e5",borderRadius:"3px 3px 0 0"}}/>
          <div style={{fontSize:10,color:"var(--t2)",marginTop:4}}>{m}</div>
        </div>;
      })}
    </div>

    {view==="vendors" && <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
      <thead><tr style={{borderBottom:"1px solid var(--bd)"}}>
        <th style={{textAlign:"left",padding:8,color:"var(--t2)"}}>Vendor</th>
        {MONTHS.map(m=><th key={m} style={{textAlign:"right",padding:"8px 6px",color:"var(--t2)",fontSize:10}}>{m}</th>)}
        <th style={{textAlign:"right",padding:8,color:"var(--t2)"}}>Gesamt</th>
        <th style={{textAlign:"right",padding:8,color:"var(--t2)"}}>Bu.</th>
      </tr></thead>
      <tbody>
        {data.vendors.map(v=><tr key={v.name} onClick={()=>{setFilterVendor(v.name);setView("liste");}} style={{borderBottom:"1px solid var(--bd)",cursor:"pointer"}}>
          <td style={{padding:8,color:"#fff",fontWeight:500}}>{v.name}<span style={{marginLeft:6,fontSize:10,color:"var(--t2)"}}>({v.konten.join(", ")})</span></td>
          {MONTHS.map(m=><td key={m} style={{textAlign:"right",padding:"6px",color:"#fff",fontSize:11}}>{v.months[m]?Math.round(v.months[m]).toLocaleString("de-DE"):""}</td>)}
          <td style={{textAlign:"right",padding:8,color:"#fff",fontWeight:700}}>{fmt(v.total)}</td>
          <td style={{textAlign:"right",padding:8,color:"var(--t2)"}}>{v.count}</td>
        </tr>)}
      </tbody>
    </table>}

    {view==="konten" && <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
      <thead><tr style={{borderBottom:"1px solid var(--bd)"}}>
        <th style={{textAlign:"left",padding:8,color:"var(--t2)"}}>Konto</th>
        <th style={{textAlign:"left",padding:8,color:"var(--t2)"}}>Bezeichnung</th>
        {MONTHS.map(m=><th key={m} style={{textAlign:"right",padding:"8px 6px",color:"var(--t2)",fontSize:10}}>{m}</th>)}
        <th style={{textAlign:"right",padding:8,color:"var(--t2)"}}>Gesamt</th>
        <th style={{textAlign:"right",padding:8,color:"var(--t2)"}}>Bu.</th>
      </tr></thead>
      <tbody>
        {data.konten.map(k=><tr key={k.kto} onClick={()=>{setFilterKto(k.kto);setView("liste");}} style={{borderBottom:"1px solid var(--bd)",cursor:"pointer"}}>
          <td style={{padding:8,color:"#fff",fontWeight:500}}>{k.kto}</td>
          <td style={{padding:8,color:"#fff"}}>{k.name}</td>
          {MONTHS.map(m=><td key={m} style={{textAlign:"right",padding:"6px",color:"#fff",fontSize:11}}>{k.months[m]?Math.round(k.months[m]).toLocaleString("de-DE"):""}</td>)}
          <td style={{textAlign:"right",padding:8,color:"#fff",fontWeight:700}}>{fmt(k.total)}</td>
          <td style={{textAlign:"right",padding:8,color:"var(--t2)"}}>{k.count}</td>
        </tr>)}
      </tbody>
    </table>}

    {view==="liste" && <div>
      <div style={{display:"flex",gap:8,marginBottom:10,alignItems:"center",flexWrap:"wrap"}}>
        <input placeholder="Suche in Text/Vendor/Konto…" value={search} onChange={e=>setSearch(e.target.value)} style={{padding:"6px 10px",background:"var(--bg2)",color:"var(--t1)",border:"1px solid var(--bd)",borderRadius:6,minWidth:260}}/>
        {filterVendor && <span style={{padding:"4px 10px",background:"#4f46e5",color:"#fff",borderRadius:12,fontSize:11}}>Vendor: {filterVendor} <button onClick={()=>setFilterVendor("")} style={{marginLeft:6,background:"none",border:"none",color:"#fff",cursor:"pointer"}}>×</button></span>}
        {filterKto && <span style={{padding:"4px 10px",background:"#4f46e5",color:"#fff",borderRadius:12,fontSize:11}}>Konto: {filterKto} <button onClick={()=>setFilterKto("")} style={{marginLeft:6,background:"none",border:"none",color:"#fff",cursor:"pointer"}}>×</button></span>}
        <div style={{marginLeft:"auto",fontSize:12}}><span style={{color:"var(--t2)"}}>Gefiltert: </span><b style={{color:"#fff"}}>{filteredRows.length}</b> <span style={{color:"var(--t2)"}}>Buchungen, Summe </span><b style={{color:"#fff"}}>{fmt(filteredTotal)}</b></div>
      </div>
      <table style={{width:"100%",fontSize:12,borderCollapse:"collapse"}}>
        <thead><tr style={{borderBottom:"1px solid var(--bd)"}}>
          <th style={{textAlign:"left",padding:8,color:"var(--t2)"}}>Datum</th>
          <th style={{textAlign:"left",padding:8,color:"var(--t2)"}}>Vendor</th>
          <th style={{textAlign:"left",padding:8,color:"var(--t2)"}}>Konto</th>
          <th style={{textAlign:"left",padding:8,color:"var(--t2)"}}>Gegenkonto</th>
          <th style={{textAlign:"left",padding:8,color:"var(--t2)"}}>Buchungstext</th>
          <th style={{textAlign:"left",padding:8,color:"var(--t2)"}}>Beleg</th>
          <th style={{textAlign:"right",padding:8,color:"var(--t2)"}}>Betrag</th>
        </tr></thead>
        <tbody>
          {filteredRows.map((r,i)=><tr key={i} style={{borderBottom:"1px solid var(--bd)"}}>
            <td style={{padding:6,color:"#fff",whiteSpace:"nowrap"}}>{r.datum}</td>
            <td style={{padding:6,color:r.vendor?"#a5b4fc":"var(--t2)"}}>{r.vendor||"–"}</td>
            <td style={{padding:6,color:"#fff"}}>{r.kto}<span style={{marginLeft:4,color:"var(--t2)",fontSize:10}}>{r.ktoName}</span></td>
            <td style={{padding:6,color:"var(--t2)"}}>{r.gkto}</td>
            <td style={{padding:6,color:"#fff",maxWidth:400,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={r.text}>{r.text}</td>
            <td style={{padding:6,color:"var(--t2)",fontSize:11}}>{r.beleg}</td>
            <td style={{padding:6,textAlign:"right",color:r.amount<0?"#ef4444":"#fff",fontWeight:600}}>{fmt(r.amount)}</td>
          </tr>)}
        </tbody>
      </table>
    </div>}
  </div>;
};

/* ─── BuchhaltungBilanz (Kontennachweis Jahresabschluss) ─── */
const BuchhaltungBilanz=()=>{
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const year=String(window.__bhJahr||new Date().getFullYear()); // global Jahr-Selector im Header
  const [expPos,setExpPos]=useState({});     // key: side+posName
  const [expKto,setExpKto]=useState({});     // key: ktonr
  const [ktoData,setKtoData]=useState({});   // key: ktonr -> {items,...}
  const [ktoLoading,setKtoLoading]=useState({});
  const [showVJ,setShowVJ]=useState(true);

  useEffect(()=>{
    setLoading(true);
    fetch(`/api/cashflow/buchhaltung/bilanz?year=${year}`)
      .then(r=>r.json()).then(d=>{setData(d);setLoading(false);})
      .catch(()=>setLoading(false));
  },[year]);

  const fmt=(v)=>v==null||isNaN(v)?"–":Math.round(v).toLocaleString("de-DE")+" €";
  const fmtExact=(v)=>v==null||isNaN(v)?"–":v.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})+" €";
  const togglePos=(side,name)=>{
    const k=side+"|"+name;
    setExpPos(s=>({...s,[k]:!s[k]}));
  };
  const toggleKto=async(kto)=>{
    setExpKto(s=>({...s,[kto]:!s[kto]}));
    if(ktoData[kto]||ktoLoading[kto]) return;
    setKtoLoading(s=>({...s,[kto]:true}));
    try{
      const r=await fetch(`/api/cashflow/buchhaltung/bilanz/konto/${kto}?year=${year}`);
      const d=await r.json();
      setKtoData(s=>({...s,[kto]:d}));
    }catch(e){}
    setKtoLoading(s=>({...s,[kto]:false}));
  };

  if(loading) return <div style={{padding:20,color:"var(--t2)"}}>Lade Bilanz…</div>;
  if(!data) return <div style={{padding:20,color:"var(--red)"}}>Fehler beim Laden</div>;

  const aktivJahr=parseInt(year);
  const aktuellesJahr=new Date().getFullYear();
  const stichtag=aktivJahr===aktuellesJahr
    ? new Date().toLocaleDateString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric"})
    : `31.12.${aktivJahr}`;

  const renderSide=(side,list,total,totalVJ,color)=>(
    <div style={{flex:1,minWidth:480}}>
      <div style={{fontSize:15,fontWeight:700,color:color,padding:"8px 10px",borderBottom:`2px solid ${color}`,marginBottom:4}}>
        {side}
        <span style={{float:"right",fontWeight:600,color:"#fff"}}>{fmt(total)}</span>
        {showVJ && <span style={{float:"right",fontWeight:400,color:"var(--t2)",marginRight:16,fontSize:12}}>VJ {fmt(totalVJ)}</span>}
      </div>
      {list.filter(p=>!p.isSumme).map(pos=>{
        const key=side+"|"+pos.name;
        const open=!!expPos[key];
        const dir=pos.current-pos.vorjahr;
        const isDavon=pos.isDavon;
        return <div key={key} style={{borderBottom:"1px solid var(--bd)",background:isDavon?"#0b0e14":"transparent"}}>
          <div onClick={()=>togglePos(side,pos.name)} style={{display:"flex",padding:"6px 10px",cursor:"pointer",alignItems:"center",gap:8,paddingLeft:isDavon?30:10}}>
            <span style={{color:color,width:12}}>{open?"▾":"▸"}</span>
            <span style={{flex:1,color:isDavon?"var(--t2)":"#fff",fontSize:13,fontStyle:isDavon?"italic":"normal"}}>{pos.name}</span>
            {showVJ && <span style={{fontSize:11,color:dir>=0?"#10b981":"#ef4444",width:70,textAlign:"right"}}>{dir>=0?"+":""}{fmt(dir)}</span>}
            {showVJ && <span style={{fontSize:11,color:"var(--t2)",width:100,textAlign:"right"}}>{fmt(pos.vorjahr)}</span>}
            <span style={{fontSize:13,color:"#fff",fontWeight:600,width:110,textAlign:"right"}}>{fmt(pos.current)}</span>
          </div>
          {open && pos.konten.map(k=>{
            const ko=!!expKto[k.ktonr];
            const kd=ktoData[k.ktonr];
            const kl=ktoLoading[k.ktonr];
            return <div key={k.ktonr} style={{paddingLeft:24}}>
              <div onClick={()=>toggleKto(k.ktonr)} style={{display:"flex",padding:"4px 10px",cursor:"pointer",alignItems:"center",gap:8,fontSize:12,background:"var(--bg2)"}}>
                <span style={{color:"var(--t2)",width:10}}>{ko?"▾":"▸"}</span>
                <span style={{color:"var(--t2)",width:60}}>{k.ktonr}</span>
                <span style={{flex:1,color:"#fff"}}>{k.name}</span>
                {showVJ && <span style={{color:"var(--t2)",width:100,textAlign:"right"}}>{fmt(k.vorjahr)}</span>}
                <span style={{color:"#fff",fontWeight:500,width:110,textAlign:"right"}}>{fmt(k.current)}</span>
              </div>
              {ko && <div style={{background:"#0b0e14",padding:"6px 10px",fontSize:11}}>
                {kl && <div style={{color:"var(--t2)",padding:6}}>Lade Einzelbuchungen…</div>}
                {!kl && kd && <div>
                  <div style={{color:"var(--t2)",marginBottom:4}}>{kd.count} Buchungen | Soll {fmt(kd.sumSoll)} | Haben {fmt(kd.sumHaben)} | Saldo {fmtExact(kd.saldo)}</div>
                  <table style={{width:"100%",fontSize:11,borderCollapse:"collapse"}}>
                    <thead><tr style={{color:"var(--t2)",borderBottom:"1px solid var(--bd)"}}>
                      <th style={{textAlign:"left",padding:"3px 4px"}}>Datum</th>
                      <th style={{textAlign:"left",padding:"3px 4px"}}>Beleg</th>
                      <th style={{textAlign:"left",padding:"3px 4px"}}>Gegenkonto</th>
                      <th style={{textAlign:"left",padding:"3px 4px"}}>Text</th>
                      <th style={{textAlign:"right",padding:"3px 4px"}}>Soll</th>
                      <th style={{textAlign:"right",padding:"3px 4px"}}>Haben</th>
                    </tr></thead>
                    <tbody>
                      {kd.items.map((it,i)=><tr key={i} style={{borderBottom:"1px solid #1a1e28"}}>
                        <td style={{padding:"3px 4px",color:"#fff",whiteSpace:"nowrap"}}>{it.datum}</td>
                        <td style={{padding:"3px 4px",color:"var(--t2)"}}>{it.beleg}</td>
                        <td style={{padding:"3px 4px",color:"var(--t2)"}}>{it.gkto}<span style={{marginLeft:4,fontSize:10}}>{it.gktoName}</span></td>
                        <td style={{padding:"3px 4px",color:"#fff",maxWidth:320,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={it.text}>{it.text}</td>
                        <td style={{padding:"3px 4px",textAlign:"right",color:it.soll?"#fff":"var(--t3)"}}>{it.soll?fmt(it.soll):""}</td>
                        <td style={{padding:"3px 4px",textAlign:"right",color:it.haben?"#fff":"var(--t3)"}}>{it.haben?fmt(it.haben):""}</td>
                      </tr>)}
                    </tbody>
                  </table>
                </div>}
              </div>}
            </div>;
          })}
        </div>;
      })}
    </div>
  );

  return <div style={{padding:20}}>
    <div style={{marginBottom:12,padding:"8px 12px",background:"var(--bg)",border:"1px solid var(--brd)",borderRadius:8,display:"flex",gap:14,alignItems:"center",fontSize:12}}>
      <strong style={{color:"var(--t1)"}}>Bilanz {aktivJahr}</strong>
      <span style={{color:"var(--t3)"}}>· Stichtag {stichtag}</span>
      <span style={{color:"var(--t3)"}}>· Handelsrecht (SKR 04)</span>
    </div>
    <div style={{display:"flex",gap:12,alignItems:"center",marginBottom:16,flexWrap:"wrap"}}>
      <label style={{fontSize:12,color:"var(--t2)",cursor:"pointer"}}>
        <input type="checkbox" checked={showVJ} onChange={e=>setShowVJ(e.target.checked)} style={{marginRight:6}}/>
        Vorjahr anzeigen
      </label>
      <div style={{marginLeft:"auto",display:"flex",gap:20,fontSize:13}}>
        <div><span style={{color:"var(--t2)"}}>Bilanzsumme </span><b style={{color:"#fff"}}>{fmt(data.sumAktiva)}</b></div>
        {Math.abs(data.diff)>0.5 && <div style={{color:"#ef4444"}}>⚠ Diff {fmt(data.diff)}</div>}
      </div>
    </div>
    <div style={{display:"flex",gap:20,flexWrap:"wrap"}}>
      {renderSide("AKTIVA",data.aktiva,data.sumAktiva,data.sumAktivaVJ,"#10b981")}
      {renderSide("PASSIVA",data.passiva,data.sumPassiva,data.sumPassivaVJ,"#f59e0b")}
    </div>
  </div>;
};

/* ─── BuchhaltungBWA (DATEV-BWA Form 1) ─── */
const BuchhaltungBWA=()=>{
  const [data,setData]=useState(null);
  const [loading,setLoading]=useState(true);
  const year=String(window.__bhJahr||new Date().getFullYear()); // global Jahr-Selector im Header
  const [expanded,setExpanded]=useState({});
  const toggle=(k)=>setExpanded(e=>({...e,[k]:!e[k]}));
  const [ktoExp,setKtoExp]=useState({}); // ktonr → true/false
  const [ktoData,setKtoData]=useState({}); // ktonr → {loading, items}
  const toggleKto=(ktonr,type)=>{
    setKtoExp(e=>({...e,[ktonr]:!e[ktonr]}));
    if(!ktoData[ktonr]){
      setKtoData(d=>({...d,[ktonr]:{loading:true,items:[]}}));
      fetch(`/api/cashflow/buchhaltung/konto/${ktonr}/breakdown?type=${type}`)
        .then(r=>r.json()).then(res=>setKtoData(d=>({...d,[ktonr]:{loading:false,items:res.items||[]}})))
        .catch(()=>setKtoData(d=>({...d,[ktonr]:{loading:false,items:[]}})));
    }
  };
  const MONTHS=[{k:"01",l:"Jan"},{k:"02",l:"Feb"},{k:"03",l:"Mrz"},{k:"04",l:"Apr"},
    {k:"05",l:"Mai"},{k:"06",l:"Jun"},{k:"07",l:"Jul"},{k:"08",l:"Aug"},
    {k:"09",l:"Sep"},{k:"10",l:"Okt"},{k:"11",l:"Nov"},{k:"12",l:"Dez"}];

  useEffect(()=>{
    fetch("/api/cashflow/buchhaltung/bwa").then(r=>r.json()).then(d=>{setData(d);setLoading(false);}).catch(()=>setLoading(false));
  },[]);

  const thS={padding:"5px 8px",fontWeight:600,fontSize:10,color:"var(--t3)",whiteSpace:"nowrap",borderBottom:"2px solid var(--brd)",textAlign:"right"};
  const tdS={padding:"4px 8px",fontSize:11,fontFamily:"'JetBrains Mono',monospace",textAlign:"right",whiteSpace:"nowrap"};
  const fmt=v=>v===0?"0,00":(v||0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2});

  if(loading)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade BWA…</div>;
  if(!data)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Keine Daten verfügbar</div>;

  const {rows=[],derived={},rohertragPct={},betriebsergebnis={},ergebnisVorSteuern={},vorlaeufigesErgebnis={}}=data;
  const byKey=Object.fromEntries(rows.map(r=>[r.key,r]));
  const aktivJahr=parseInt(year);
  const lastMonth=bhLastMonth(rows,aktivJahr);
  const monatLabel=BH_MONTH_LABEL[lastMonth]||"Dez";

  // Row-level styles
  const Row=({label,months,total,bold,italic,color,fontSize,bg,indent,borderTop,borderBottom,rowKey})=>{
    const txtColor=color||(total<0?"var(--red)":"var(--t1)");
    const row=rowKey?byKey[rowKey]:null;
    const details=row?.accountDetails||[];
    const canExpand=details.length>0;
    const isExp=canExpand&&expanded[rowKey];
    return<React.Fragment>
      <tr style={{background:bg||"transparent",borderTop,borderBottom,cursor:canExpand?"pointer":"default"}} onClick={canExpand?()=>toggle(rowKey):undefined}>
        <td style={{padding:"4px 10px",paddingLeft:indent?24:10,color:txtColor,fontSize:fontSize||11,fontWeight:bold?700:400,fontStyle:italic?"italic":"normal",position:"sticky",left:0,background:bg||"var(--s2)"}}>
          {canExpand&&<span style={{display:"inline-block",width:12,color:"var(--t3)",fontSize:9,marginRight:4}}>{isExp?"▼":"▶"}</span>}
          {!canExpand&&rowKey&&<span style={{display:"inline-block",width:12,marginRight:4}}/>}
          {label}
          {canExpand&&<span style={{marginLeft:6,color:"var(--t3)",fontSize:9,fontWeight:400}}>({details.length})</span>}
        </td>
        {MONTHS.map(m=>{
          const v=months[m.k]||0;
          return<td key={m.k} style={{...tdS,fontSize:fontSize||11,fontWeight:bold?700:400,color:v===0?"var(--t3)":v<0?"var(--red)":txtColor}}>{fmt(v)}</td>;
        })}
        <td style={{...tdS,fontWeight:bold?700:600,fontSize:fontSize||11,color:total===0?"var(--t3)":total<0?"var(--red)":txtColor}}>{fmt(total)}</td>
      </tr>
      {isExp&&details.map(d=>{
        const kExp=ktoExp[d.ktonr];
        const kInfo=ktoData[d.ktonr];
        return<React.Fragment key={d.ktonr}>
          <tr style={{background:"var(--bg)",cursor:"pointer"}} onClick={()=>toggleKto(d.ktonr,row?.type||"expense")}>
            <td style={{padding:"3px 10px",paddingLeft:42,color:"var(--t2)",fontSize:10,position:"sticky",left:0,background:"var(--bg)"}}>
              <span style={{display:"inline-block",width:10,color:"var(--t3)",fontSize:8,marginRight:4}}>{kExp?"▼":"▶"}</span>
              <span style={{fontFamily:"'JetBrains Mono',monospace",color:"var(--t3)",marginRight:8}}>{d.ktonr}</span>
              {d.ktobeschr}
            </td>
            {MONTHS.map(m=>{
              const v=d.months[m.k]||0;
              return<td key={m.k} style={{...tdS,fontSize:10,color:v===0?"var(--t3)":v<0?"var(--red)":"var(--t2)"}}>{v===0?"–":fmt(v)}</td>;
            })}
            <td style={{...tdS,fontSize:10,fontWeight:600,color:d.total===0?"var(--t3)":d.total<0?"var(--red)":"var(--t2)"}}>{fmt(d.total)}</td>
          </tr>
          {kExp&&kInfo?.loading&&(
            <tr style={{background:"var(--s1)"}}>
              <td colSpan={14} style={{padding:"6px 10px 6px 64px",fontSize:10,color:"var(--t3)",fontStyle:"italic"}}>Lade Buchungen…</td>
            </tr>
          )}
          {kExp&&kInfo&&!kInfo.loading&&kInfo.items.length===0&&(
            <tr style={{background:"var(--s1)"}}>
              <td colSpan={14} style={{padding:"6px 10px 6px 64px",fontSize:10,color:"var(--t3)",fontStyle:"italic"}}>Keine Buchungen gefunden</td>
            </tr>
          )}
          {kExp&&kInfo&&!kInfo.loading&&kInfo.items.map((it,i)=>(
            <tr key={i} style={{background:"var(--s1)"}}>
              <td style={{padding:"2px 10px 2px 64px",color:"#fff",fontSize:10,position:"sticky",left:0,background:"var(--s1)"}}>
                <span style={{fontFamily:"'JetBrains Mono',monospace",marginRight:6,color:"var(--t3)"}}>{it.gkto}</span>
                {it.gktoName&&<span style={{color:"#fff",fontWeight:500,marginRight:6}}>{it.gktoName}</span>}
                <span style={{fontStyle:"italic",color:"#fff"}}>{it.text}</span>
                <span style={{marginLeft:8,color:"var(--t3)",fontSize:9}}>· {it.count}×</span>
              </td>
              {MONTHS.map(m=>{
                const v=it.months[m.k]||0;
                return<td key={m.k} style={{...tdS,fontSize:10,color:v===0?"var(--t3)":v<0?"var(--red)":"#fff"}}>{v===0?"–":fmt(v)}</td>;
              })}
              <td style={{...tdS,fontSize:10,fontWeight:700,color:it.total===0?"var(--t3)":it.total<0?"var(--red)":"#fff"}}>{fmt(it.total)}</td>
            </tr>
          ))}
        </React.Fragment>;
      })}
    </React.Fragment>;
  };

  const SectionHdr=({label,color})=><tr><td colSpan={14} style={{padding:"8px 10px 4px",fontSize:10,fontWeight:700,color:color||"var(--t3)",textTransform:"uppercase",letterSpacing:"0.08em",background:"var(--bg)",borderTop:"1px solid var(--brd)"}}>{label}</td></tr>;

  const emptyMonths=Object.fromEntries(MONTHS.map(m=>[m.k,0]));

  return<div style={{maxWidth:1800}}>
    <div style={{marginBottom:16,padding:"10px 14px",background:"var(--bg)",border:"1px solid var(--brd)",borderRadius:8,display:"flex",gap:16,alignItems:"center"}}>
      <span style={{fontSize:11,color:"var(--t3)"}}>BWA-Form:</span>
      <strong style={{fontSize:13,color:"var(--t1)"}}>DATEV-BWA Nr. 1 (SKR 04)</strong>
      <span style={{fontSize:11,color:"var(--t3)"}}>Wareneinsatz: Wareneinkauf</span>
      <span style={{marginLeft:"auto",fontSize:11,color:"var(--t3)"}}>Geschäftsjahr {aktivJahr} · Stand bis {monatLabel} {aktivJahr} · Handelsrecht</span>
    </div>

    <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden"}}>
      <div style={{overflowX:"auto"}}>
        <table style={{borderCollapse:"collapse",fontSize:11,minWidth:1600,width:"100%"}}>
          <thead>
            <tr style={{background:"var(--bg)"}}>
              <th style={{...thS,textAlign:"left",padding:"6px 10px",minWidth:260,position:"sticky",left:0,background:"var(--bg)",zIndex:2}}>Bezeichnung</th>
              {MONTHS.map(m=><th key={m.k} style={thS}>{m.l}/2025</th>)}
              <th style={{...thS,color:"var(--t1)"}}>Jan - Dez 2025</th>
            </tr>
          </thead>
          <tbody>
            {/* Gesamtleistung */}
            <Row rowKey="umsatz" label="Umsatzerlöse" months={byKey.umsatz?.months||emptyMonths} total={byKey.umsatz?.total||0}/>
            <Row rowKey="bestand" label="Bestandsveränderg. FE/UE" months={byKey.bestand?.months||emptyMonths} total={byKey.bestand?.total||0}/>
            <Row rowKey="aktiv" label="Aktivierte Eigenleistungen" months={byKey.aktiv?.months||emptyMonths} total={byKey.aktiv?.total||0}/>
            <Row label="Gesamtleistung" months={derived.gesamtleistung?.months||emptyMonths} total={derived.gesamtleistung?.total||0} bold bg="var(--bg)" borderTop="1px solid var(--brd)" borderBottom="1px solid var(--brd)"/>

            {/* Wareneinkauf */}
            <Row rowKey="wareneinkauf" label="Material-/Wareneinkauf" months={byKey.wareneinkauf?.months||emptyMonths} total={byKey.wareneinkauf?.total||0}/>

            {/* Rohertrag */}
            <Row label="Rohertrag" months={derived.rohertrag?.months||emptyMonths} total={derived.rohertrag?.total||0} bold bg="var(--bg)" borderTop="1px solid var(--brd)" borderBottom="1px solid var(--brd)" color="var(--acc)"/>
            <tr style={{background:"var(--bg)"}}>
              <td style={{padding:"2px 10px",paddingLeft:24,color:"var(--t3)",fontSize:10,fontStyle:"italic",position:"sticky",left:0,background:"var(--bg)"}}>Rohertrag in % vom Umsatz</td>
              {MONTHS.map(m=>{
                const p=rohertragPct?.months?.[m.k]||0;
                return<td key={m.k} style={{...tdS,fontSize:10,fontStyle:"italic",color:p<=0?"var(--t3)":"var(--acc)"}}>{p===0?"–":p.toLocaleString("de-DE",{minimumFractionDigits:1,maximumFractionDigits:1})+" %"}</td>;
              })}
              <td style={{...tdS,fontSize:10,fontStyle:"italic",fontWeight:600,color:(rohertragPct?.total||0)<=0?"var(--t3)":"var(--acc)"}}>{(rohertragPct?.total||0).toLocaleString("de-DE",{minimumFractionDigits:1,maximumFractionDigits:1})+" %"}</td>
            </tr>

            {/* So. betr. Erlöse */}
            <Row rowKey="sonstErloes" label="So. betr. Erlöse" months={byKey.sonstErloes?.months||emptyMonths} total={byKey.sonstErloes?.total||0}/>
            <Row label="Betrieblicher Rohertrag" months={derived.betrieblicherRohertrag?.months||emptyMonths} total={derived.betrieblicherRohertrag?.total||0} bold bg="var(--bg)" borderTop="1px solid var(--brd)" borderBottom="2px solid var(--brd)" color="var(--acc)"/>

            {/* Kostenarten */}
            <SectionHdr label="Kostenarten:"/>
            <Row rowKey="personal" label="Personalkosten" months={byKey.personal?.months||emptyMonths} total={byKey.personal?.total||0}/>
            <Row rowKey="raum" label="Raumkosten" months={byKey.raum?.months||emptyMonths} total={byKey.raum?.total||0}/>
            <Row rowKey="steuer" label="Betriebliche Steuern" months={byKey.steuer?.months||emptyMonths} total={byKey.steuer?.total||0}/>
            <Row rowKey="versich" label="Versicherungen/Beiträge" months={byKey.versich?.months||emptyMonths} total={byKey.versich?.total||0}/>
            <Row rowKey="besonder" label="Besondere Kosten" months={byKey.besonder?.months||emptyMonths} total={byKey.besonder?.total||0}/>
            <Row rowKey="fahrzeug" label="Fahrzeugkosten (ohne Steuer)" months={byKey.fahrzeug?.months||emptyMonths} total={byKey.fahrzeug?.total||0}/>
            <Row rowKey="werbe" label="Werbe-/Reisekosten" months={byKey.werbe?.months||emptyMonths} total={byKey.werbe?.total||0}/>
            <Row rowKey="warenabgabe" label="Kosten Warenabgabe" months={byKey.warenabgabe?.months||emptyMonths} total={byKey.warenabgabe?.total||0}/>
            <Row rowKey="afa" label="Abschreibungen" months={byKey.afa?.months||emptyMonths} total={byKey.afa?.total||0}/>
            <Row rowKey="reparatur" label="Reparatur/Instandhaltung" months={byKey.reparatur?.months||emptyMonths} total={byKey.reparatur?.total||0}/>
            <Row rowKey="sonst" label="Sonstige Kosten" months={byKey.sonst?.months||emptyMonths} total={byKey.sonst?.total||0}/>
            <Row label="Gesamtkosten" months={derived.gesamtkosten?.months||emptyMonths} total={derived.gesamtkosten?.total||0} bold bg="var(--bg)" borderTop="1px solid var(--brd)" borderBottom="1px solid var(--brd)"/>

            {/* Betriebsergebnis */}
            <Row label="Betriebsergebnis" months={betriebsergebnis?.months||emptyMonths} total={betriebsergebnis?.total||0} bold fontSize={12} bg="var(--s1)" borderTop="2px solid var(--brd)" borderBottom="2px solid var(--brd)" color={(betriebsergebnis?.total||0)>=0?"var(--grn)":"var(--red)"}/>

            {/* Neutrale Posten */}
            <Row rowKey="zinsAuf" label="Zinsaufwand" months={byKey.zinsAuf?.months||emptyMonths} total={byKey.zinsAuf?.total||0}/>
            <Row rowKey="neutralAuf" label="Sonstiger neutraler Aufwand" months={byKey.neutralAuf?.months||emptyMonths} total={byKey.neutralAuf?.total||0}/>
            <Row label="Neutraler Aufwand" months={derived.neutralAufwand?.months||emptyMonths} total={derived.neutralAufwand?.total||0} bold bg="var(--bg)" borderTop="1px solid var(--brd)" borderBottom="1px solid var(--brd)"/>

            <Row rowKey="zinsErt" label="Zinserträge" months={byKey.zinsErt?.months||emptyMonths} total={byKey.zinsErt?.total||0}/>
            <Row rowKey="neutralErt" label="Sonstiger neutraler Ertrag" months={byKey.neutralErt?.months||emptyMonths} total={byKey.neutralErt?.total||0}/>
            <Row rowKey="kalk" label="Verrechnete kalk. Kosten" months={byKey.kalk?.months||emptyMonths} total={byKey.kalk?.total||0}/>
            <Row label="Neutraler Ertrag" months={derived.neutralErtrag?.months||emptyMonths} total={derived.neutralErtrag?.total||0} bold bg="var(--bg)" borderTop="1px solid var(--brd)" borderBottom="1px solid var(--brd)"/>

            <Row rowKey="unbesetzt" label="Kontenklasse unbesetzt" months={byKey.unbesetzt?.months||emptyMonths} total={byKey.unbesetzt?.total||0}/>

            {/* Ergebnis vor Steuern */}
            <Row label="Ergebnis vor Steuern" months={ergebnisVorSteuern?.months||emptyMonths} total={ergebnisVorSteuern?.total||0} bold fontSize={12} bg="var(--s1)" borderTop="2px solid var(--brd)" borderBottom="1px solid var(--brd)" color={(ergebnisVorSteuern?.total||0)>=0?"var(--grn)":"var(--red)"}/>

            {/* Steuern */}
            <Row rowKey="steuerEink" label="Steuern Einkommen u. Ertrag" months={byKey.steuerEink?.months||emptyMonths} total={byKey.steuerEink?.total||0}/>

            {/* Vorläufiges Ergebnis */}
            <Row label="Vorläufiges Ergebnis" months={vorlaeufigesErgebnis?.months||emptyMonths} total={vorlaeufigesErgebnis?.total||0} bold fontSize={13} bg="var(--bg)" borderTop="3px solid var(--brd)" borderBottom="3px solid var(--brd)" color={(vorlaeufigesErgebnis?.total||0)>=0?"var(--grn)":"var(--red)"}/>
          </tbody>
        </table>
      </div>
    </div>
    <div style={{marginTop:10,fontSize:10,color:"var(--t3)",textAlign:"right"}}>
      Das vorläufige Ergebnis entspricht dem derzeitigen Stand der Buchführung. Abschluss-/Abgrenzungsbuchungen können es noch verändern.
    </div>
  </div>;
};

/* ─── BuchhaltungBanken ─── */
const BuchhaltungBanken=()=>{
  const {ktoName}=useKontoLookup();
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(true);
  const [drillKto,setDrillKto]=useState(null); // null = overview, string = drill-down ktonr
  const [drill,setDrill]=useState(null);
  const [drillLoading,setDrillLoading]=useState(false);
  const [drillPage,setDrillPage]=useState(1);
  const [tab,setTab]=useState("uebersicht"); // "uebersicht" | "umbuchungen"
  const [umb,setUmb]=useState(null);
  const [umbLoading,setUmbLoading]=useState(false);
  const [umbFilter,setUmbFilter]=useState({from:"",to:""});

  useEffect(()=>{
    if(tab==="umbuchungen"&&!umb){
      setUmbLoading(true);
      fetch("/api/cashflow/buchhaltung/umbuchungen")
        .then(r=>r.json()).then(d=>{setUmb(d);setUmbLoading(false);}).catch(()=>setUmbLoading(false));
    }
  },[tab,umb]);

  const MONTHS=[{k:"01",l:"Jan"},{k:"02",l:"Feb"},{k:"03",l:"Mrz"},{k:"04",l:"Apr"},
    {k:"05",l:"Mai"},{k:"06",l:"Jun"},{k:"07",l:"Jul"},{k:"08",l:"Aug"},
    {k:"09",l:"Sep"},{k:"10",l:"Okt"},{k:"11",l:"Nov"},{k:"12",l:"Dez"}];
  const FARBEN={"1800":"#f97316","1810":"#f59e0b","1820":"#8b5cf6","1830":"#10b981","1840":"#06b6d4","1850":"#3b82f6","1890":"#64748b"};
  const aktivJahr=parseInt(window.__bhJahr||new Date().getFullYear());
  const aktuellesJahr=new Date().getFullYear();
  // Wenn aktuelles Jahr: bis aktuellem Monat. Sonst: bis Dez (volles Jahr).
  // Für Teiljahre (z.B. 2026 nur bis April) wird der zuletzt befüllte Monat
  // dynamisch aus den geladenen Daten ermittelt – siehe lastMonthFromData.
  const monthIdxNow=new Date().getMonth()+1;
  const defaultLastMonth=aktivJahr===aktuellesJahr?String(monthIdxNow).padStart(2,"0"):"12";
  // Letzter Monat mit Bewegung in den geladenen Daten (über alle Konten):
  const lastMonthFromData=(rows)=>{
    if(!Array.isArray(rows)||rows.length===0)return defaultLastMonth;
    const ms=["12","11","10","09","08","07","06","05","04","03","02","01"];
    for(const m of ms){
      const any=rows.some(r=>{
        const v=r.months&&r.months[m];
        // Nur wenn dieser Monat sich vom Vormonat unterscheidet (= echte Bewegung)
        const mi=parseInt(m);const prev=mi===1?null:String(mi-1).padStart(2,"0");
        const pv=prev?(r.months&&r.months[prev]):r.EB;
        return v!==undefined&&pv!==undefined&&Math.abs((v||0)-(pv||0))>0.005;
      });
      if(any)return m;
    }
    return defaultLastMonth;
  };
  const lastMonth=lastMonthFromData(data);
  const monatLabel=(MONTHS.find(m=>m.k===lastMonth)?.l)||"Dez";

  useEffect(()=>{
    fetch("/api/cashflow/buchhaltung/banken").then(r=>r.json()).then(d=>{setData(Array.isArray(d)?d:[]);setLoading(false);}).catch(()=>setLoading(false));
  },[]);

  const loadDrill=useCallback((kto,pg=1)=>{
    setDrillLoading(true);
    fetch(`/api/cashflow/buchhaltung/banken/${kto}/buchungen?page=${pg}&limit=200`)
      .then(r=>r.json()).then(d=>{setDrill(d);setDrillPage(pg);setDrillLoading(false);}).catch(()=>setDrillLoading(false));
  },[]);

  const openDrill=(kto)=>{setDrillKto(kto);loadDrill(kto,1);};
  const closeDrill=()=>{setDrillKto(null);setDrill(null);};

  const thS={padding:"5px 10px",fontWeight:600,fontSize:10,color:"var(--t3)",whiteSpace:"nowrap",borderBottom:"2px solid var(--brd)",textAlign:"right"};
  const tdS={padding:"5px 10px",fontSize:11,fontFamily:"'JetBrains Mono',monospace",textAlign:"right",whiteSpace:"nowrap"};
  const iS={padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  if(loading)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade Banken…</div>;

  /* ── Drill-Down View ── */
  if(drillKto){
    const bankInfo=data.find(b=>b.Ktonr===drillKto)||{};
    const farbe=FARBEN[drillKto]||"var(--acc)";
    const docs=drill?.docs||[];
    const pages=drill?.pages||1;
    return<div style={{maxWidth:1400}}>
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
        <button onClick={closeDrill} style={{...iS,cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>← Übersicht</button>
        <div style={{borderLeft:`3px solid ${farbe}`,paddingLeft:12}}>
          <div style={{fontSize:10,color:"var(--t3)"}}>{drillKto}{bankInfo.isKontokorrent&&<span style={{marginLeft:6,padding:"1px 6px",borderRadius:3,background:"#f59e0b22",color:"#f59e0b",fontWeight:700,fontSize:9,letterSpacing:"0.05em"}}>KONTOKORRENT</span>}</div>
          <div style={{fontSize:16,fontWeight:700,color:"var(--t1)"}}>{bankInfo.Name||drillKto}</div>
        </div>
        <span style={{marginLeft:"auto",fontSize:11,color:"var(--t3)"}}>{drill?.total||0} Buchungen · EB: {(bankInfo.EB||0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})} €</span>
      </div>
      {drillLoading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade Buchungen…</div>:
      <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden"}}>
        <div style={{overflowX:"auto"}}>
          <table style={{borderCollapse:"collapse",fontSize:11,minWidth:900,width:"100%"}}>
            <thead>
              <tr style={{background:"var(--bg)"}}>
                <th style={{...thS,textAlign:"left",padding:"6px 10px"}}>Datum</th>
                <th style={{...thS,textAlign:"left"}}>Beleg</th>
                <th style={{...thS,textAlign:"left",minWidth:260}}>Buchungstext</th>
                <th style={{...thS,textAlign:"left"}}>Gegenkonto</th>
                <th style={thS}>Soll</th>
                <th style={thS}>Haben</th>
                <th style={{...thS,color:"var(--t1)"}}>Kontostand</th>
              </tr>
            </thead>
            <tbody>
              {docs.length===0?<tr><td colSpan={7} style={{padding:24,textAlign:"center",color:"var(--t3)"}}>Keine Buchungen</td></tr>:
                docs.map((d,i)=>{
                  const saldo=d._saldo||0;
                  return<tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
                    <td style={{padding:"4px 10px",color:"var(--t2)",whiteSpace:"nowrap"}}>{fmtDat(d.Belegdatum)}</td>
                    <td style={{padding:"4px 10px",fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t3)",whiteSpace:"nowrap"}}>{d.Beleg1||d.Beleg2||"–"}</td>
                    <td style={{padding:"4px 10px",color:"var(--t1)",maxWidth:280,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.Buchungstext||"–"}</td>
                    <td style={{padding:"4px 10px",color:"var(--acc)",fontSize:11}}>{ktoName(d.GKtonr)}</td>
                    <td style={{...tdS,color:d.Umsatz_Soll?"var(--grn)":"var(--t3)"}}>{d.Umsatz_Soll?d.Umsatz_Soll.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2}):"–"}</td>
                    <td style={{...tdS,color:d.Umsatz_Haben?"var(--red)":"var(--t3)"}}>{d.Umsatz_Haben?d.Umsatz_Haben.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2}):"–"}</td>
                    <td style={{...tdS,fontWeight:600,fontSize:12,color:saldo>=0?"var(--grn)":"var(--red)"}}>{saldo.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
                  </tr>;
                })
              }
            </tbody>
          </table>
        </div>
        {pages>1&&<div style={{display:"flex",gap:6,alignItems:"center",padding:"10px 16px",borderTop:"1px solid var(--brd)"}}>
          <button onClick={()=>loadDrill(drillKto,1)} disabled={drillPage<=1} style={{...iS,cursor:drillPage>1?"pointer":"not-allowed",opacity:drillPage>1?1:0.4}}>«</button>
          <button onClick={()=>loadDrill(drillKto,drillPage-1)} disabled={drillPage<=1} style={{...iS,cursor:drillPage>1?"pointer":"not-allowed",opacity:drillPage>1?1:0.4}}>‹</button>
          <span style={{fontSize:12,color:"var(--t2)",padding:"0 8px"}}>Seite {drillPage} / {pages}</span>
          <button onClick={()=>loadDrill(drillKto,drillPage+1)} disabled={drillPage>=pages} style={{...iS,cursor:drillPage<pages?"pointer":"not-allowed",opacity:drillPage<pages?1:0.4}}>›</button>
          <button onClick={()=>loadDrill(drillKto,pages)} disabled={drillPage>=pages} style={{...iS,cursor:drillPage<pages?"pointer":"not-allowed",opacity:drillPage<pages?1:0.4}}>»</button>
        </div>}
      </div>}
    </div>;
  }

  /* ── Umbuchungen View ── */
  if(tab==="umbuchungen"){
    const banks=umb?.banks||[];
    const matrix=umb?.matrix||{};
    const transfers=umb?.transfers||[];
    const monthlyTotal=umb?.monthlyTotal||{};
    const filtered=transfers.filter(t=>(!umbFilter.from||t.from===umbFilter.from)&&(!umbFilter.to||t.to===umbFilter.to));
    return<div style={{maxWidth:1600}}>
      {/* Tab-Navigation */}
      <div style={{display:"flex",gap:4,marginBottom:16,borderBottom:"1px solid var(--brd)"}}>
        <button onClick={()=>setTab("uebersicht")} style={{padding:"8px 16px",background:"transparent",border:"none",borderBottom:"2px solid transparent",color:"var(--t3)",cursor:"pointer",fontSize:12,fontWeight:500}}>Übersicht</button>
        <button onClick={()=>setTab("umbuchungen")} style={{padding:"8px 16px",background:"transparent",border:"none",borderBottom:"2px solid var(--acc)",color:"var(--acc)",cursor:"pointer",fontSize:12,fontWeight:600}}>Umbuchungen</button>
      </div>
      {umbLoading?<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade Umbuchungen…</div>:<>
      {/* KPI-Header */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:12,marginBottom:20}}>
        <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:"12px 14px",borderLeft:"3px solid var(--acc)"}}>
          <div style={{fontSize:10,color:"var(--t3)"}}>Umbuchungen 2025</div>
          <div style={{fontSize:18,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:"var(--t1)"}}>{(umb?.totalCount||0).toLocaleString("de-DE")}</div>
          <div style={{fontSize:10,color:"var(--t3)",marginTop:2}}>{(umb?.totalSum||0).toLocaleString("de-DE",{maximumFractionDigits:0})} € Volumen</div>
        </div>
        {banks.map(b=>{
          const farbe=FARBEN[b.ktonr]||"var(--acc)";
          const net=(b.totals.in||0)-(b.totals.out||0);
          return<div key={b.ktonr} style={{background:"var(--s2)",border:`1px solid ${farbe}44`,borderRadius:8,padding:"12px 14px",borderLeft:`3px solid ${farbe}`}}>
            <div style={{fontSize:10,color:"var(--t3)",display:"flex",alignItems:"center",gap:6}}>{b.ktonr}{b.isKK&&<span style={{padding:"1px 5px",borderRadius:3,background:"#f59e0b22",color:"#f59e0b",fontWeight:700,fontSize:8}}>KK</span>}</div>
            <div style={{fontSize:11,fontWeight:600,color:"var(--t1)"}}>{b.name}</div>
            <div style={{display:"flex",justifyContent:"space-between",marginTop:6,fontSize:10,fontFamily:"'JetBrains Mono',monospace"}}>
              <span style={{color:"var(--grn)"}}>↓ {(b.totals.in||0).toLocaleString("de-DE",{maximumFractionDigits:0})}</span>
              <span style={{color:"var(--red)"}}>↑ {(b.totals.out||0).toLocaleString("de-DE",{maximumFractionDigits:0})}</span>
            </div>
            <div style={{fontSize:11,fontWeight:700,color:net>=0?"var(--grn)":"var(--red)",fontFamily:"'JetBrains Mono',monospace",marginTop:2}}>Netto {net>=0?"+":""}{net.toLocaleString("de-DE",{maximumFractionDigits:0})}</div>
          </div>;
        })}
      </div>

      {/* Matrix Von/Zu */}
      <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden",marginBottom:20}}>
        <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",fontWeight:600,fontSize:13,color:"var(--t1)"}}>Umbuchungs-Matrix (Von → Zu) · Zelle anklicken zum Filtern</div>
        <div style={{overflowX:"auto"}}>
          <table style={{borderCollapse:"collapse",fontSize:11,width:"100%"}}>
            <thead>
              <tr style={{background:"var(--bg)"}}>
                <th style={{...thS,textAlign:"left",padding:"6px 10px"}}>Von \ Zu</th>
                {banks.map(b=>{
                  const farbe=FARBEN[b.ktonr]||"var(--acc)";
                  return<th key={b.ktonr} style={{...thS,color:farbe,minWidth:130,textAlign:"right"}}>
                    <div style={{fontSize:11,fontWeight:700}}>{b.name}</div>
                    <div style={{fontSize:9,color:"var(--t3)",fontWeight:400,fontFamily:"'JetBrains Mono',monospace"}}>{b.ktonr}{b.isKK?" · KK":""}</div>
                  </th>;
                })}
                <th style={{...thS,color:"var(--t1)"}}>Summe Out</th>
              </tr>
            </thead>
            <tbody>
              {banks.map(from=>{
                const farbeF=FARBEN[from.ktonr]||"var(--acc)";
                const rowSum=banks.reduce((a,t)=>a+(matrix[from.ktonr]?.[t.ktonr]?.sum||0),0);
                return<tr key={from.ktonr} style={{borderBottom:"1px solid var(--brd)"}}>
                  <td style={{padding:"6px 10px",fontWeight:600,color:farbeF,fontSize:11,whiteSpace:"nowrap"}}>
                    <span style={{fontFamily:"'JetBrains Mono',monospace",marginRight:6}}>{from.ktonr}</span>
                    {from.name}{from.isKK&&<span style={{marginLeft:6,padding:"1px 5px",borderRadius:3,background:"#f59e0b22",color:"#f59e0b",fontWeight:700,fontSize:8}}>KK</span>}
                  </td>
                  {banks.map(to=>{
                    const cell=matrix[from.ktonr]?.[to.ktonr];
                    const isDiag=from.ktonr===to.ktonr;
                    const v=cell?.sum||0;
                    return<td key={to.ktonr} onClick={v>0?()=>setUmbFilter({from:from.ktonr,to:to.ktonr}):undefined} style={{...tdS,background:isDiag?"var(--bg)":(v>0?"transparent":"transparent"),cursor:v>0?"pointer":"default",color:v===0?"var(--t3)":"var(--t1)"}}>
                      {isDiag?"–":(v===0?"–":<><div style={{fontWeight:600}}>{v.toLocaleString("de-DE",{maximumFractionDigits:0})}</div><div style={{fontSize:9,color:"var(--t3)"}}>{cell.count}× </div></>)}
                    </td>;
                  })}
                  <td style={{...tdS,fontWeight:700,color:"var(--red)"}}>{rowSum===0?"–":rowSum.toLocaleString("de-DE",{maximumFractionDigits:0})}</td>
                </tr>;
              })}
              <tr style={{background:"var(--bg)",borderTop:"2px solid var(--brd)"}}>
                <td style={{padding:"6px 10px",fontWeight:700,color:"var(--t1)"}}>Summe In</td>
                {banks.map(to=>{
                  const colSum=banks.reduce((a,f)=>a+(matrix[f.ktonr]?.[to.ktonr]?.sum||0),0);
                  return<td key={to.ktonr} style={{...tdS,fontWeight:700,color:"var(--grn)"}}>{colSum===0?"–":colSum.toLocaleString("de-DE",{maximumFractionDigits:0})}</td>;
                })}
                <td style={{...tdS,fontWeight:700,color:"var(--acc)"}}>{(umb?.totalSum||0).toLocaleString("de-DE",{maximumFractionDigits:0})}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Monatsverlauf */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(12,1fr)",gap:6,marginBottom:20}}>
        {MONTHS.map(m=>{
          const v=monthlyTotal[m.k]||0;
          return<div key={m.k} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:6,padding:"6px 8px"}}>
            <div style={{fontSize:9,color:"var(--t3)"}}>{m.l}</div>
            <div style={{fontSize:10,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:"var(--acc)"}}>{v===0?"–":v.toLocaleString("de-DE",{maximumFractionDigits:0})}</div>
          </div>;
        })}
      </div>

      {/* Filter + Liste */}
      <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflow:"hidden"}}>
        <div style={{padding:"10px 16px",background:"var(--bg)",borderBottom:"1px solid var(--brd)",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
          <span style={{fontWeight:600,fontSize:13,color:"var(--t1)"}}>Einzelbuchungen</span>
          <span style={{marginLeft:"auto",fontSize:10,color:"var(--t3)"}}>Von:</span>
          <select value={umbFilter.from} onChange={e=>setUmbFilter(f=>({...f,from:e.target.value}))} style={iS}>
            <option value="">Alle</option>
            {banks.map(b=><option key={b.ktonr} value={b.ktonr}>{b.ktonr} {b.name}{b.isKK?" (KK)":""}</option>)}
          </select>
          <span style={{fontSize:10,color:"var(--t3)"}}>Zu:</span>
          <select value={umbFilter.to} onChange={e=>setUmbFilter(f=>({...f,to:e.target.value}))} style={iS}>
            <option value="">Alle</option>
            {banks.map(b=><option key={b.ktonr} value={b.ktonr}>{b.ktonr} {b.name}{b.isKK?" (KK)":""}</option>)}
          </select>
          {(umbFilter.from||umbFilter.to)&&<button onClick={()=>setUmbFilter({from:"",to:""})} style={{...iS,cursor:"pointer",padding:"4px 10px",fontSize:10}}>× Reset</button>}
          <span style={{fontSize:10,color:"var(--t3)"}}>{filtered.length} / {transfers.length}</span>
        </div>
        <div style={{overflowX:"auto",maxHeight:600,overflowY:"auto"}}>
          <table style={{borderCollapse:"collapse",fontSize:11,width:"100%"}}>
            <thead style={{position:"sticky",top:0,background:"var(--bg)",zIndex:1}}>
              <tr>
                <th style={{...thS,textAlign:"left",padding:"6px 10px"}}>Datum</th>
                <th style={{...thS,textAlign:"left"}}>Von</th>
                <th style={{...thS,textAlign:"center",width:30}}>→</th>
                <th style={{...thS,textAlign:"left"}}>Zu</th>
                <th style={thS}>Betrag</th>
                <th style={{...thS,textAlign:"left",minWidth:260}}>Buchungstext</th>
                <th style={{...thS,textAlign:"left"}}>Beleg</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length===0?<tr><td colSpan={7} style={{padding:24,textAlign:"center",color:"var(--t3)"}}>Keine Umbuchungen</td></tr>:
                filtered.map((t,i)=>{
                  const farbeF=FARBEN[t.from]||"var(--acc)";
                  const farbeT=FARBEN[t.to]||"var(--acc)";
                  const kkInvolved=t.from==="1810"||t.to==="1810";
                  return<tr key={i} style={{borderBottom:"1px solid var(--brd)",background:kkInvolved?"#f59e0b0a":(i%2===0?"transparent":"var(--bg)")}}>
                    <td style={{padding:"4px 10px",color:"var(--t2)",whiteSpace:"nowrap"}}>{t.datum}</td>
                    <td style={{padding:"4px 10px",color:farbeF,fontSize:10,whiteSpace:"nowrap"}}>
                      <span style={{fontFamily:"'JetBrains Mono',monospace",marginRight:4}}>{t.from}</span>{t.fromName}
                      {t.from==="1810"&&<span style={{marginLeft:4,padding:"1px 4px",borderRadius:3,background:"#f59e0b22",color:"#f59e0b",fontWeight:700,fontSize:8}}>KK</span>}
                    </td>
                    <td style={{textAlign:"center",color:"var(--t3)"}}>→</td>
                    <td style={{padding:"4px 10px",color:farbeT,fontSize:10,whiteSpace:"nowrap"}}>
                      <span style={{fontFamily:"'JetBrains Mono',monospace",marginRight:4}}>{t.to}</span>{t.toName}
                      {t.to==="1810"&&<span style={{marginLeft:4,padding:"1px 4px",borderRadius:3,background:"#f59e0b22",color:"#f59e0b",fontWeight:700,fontSize:8}}>KK</span>}
                    </td>
                    <td style={{...tdS,fontWeight:700,color:"var(--t1)"}}>{t.amount.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
                    <td style={{padding:"4px 10px",color:"var(--t2)",maxWidth:320,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} title={t.text}>{t.text||"–"}</td>
                    <td style={{padding:"4px 10px",fontFamily:"'JetBrains Mono',monospace",fontSize:9,color:"var(--t3)",whiteSpace:"nowrap"}}>{t.beleg||"–"}</td>
                  </tr>;
                })
              }
            </tbody>
          </table>
        </div>
      </div>
      </>}
    </div>;
  }

  /* ── Overview ── */
  return<div style={{maxWidth:1400}}>
    {/* Tab-Navigation */}
    <div style={{display:"flex",gap:4,marginBottom:16,borderBottom:"1px solid var(--brd)"}}>
      <button onClick={()=>setTab("uebersicht")} style={{padding:"8px 16px",background:"transparent",border:"none",borderBottom:"2px solid var(--acc)",color:"var(--acc)",cursor:"pointer",fontSize:12,fontWeight:600}}>Übersicht</button>
      <button onClick={()=>setTab("umbuchungen")} style={{padding:"8px 16px",background:"transparent",border:"none",borderBottom:"2px solid transparent",color:"var(--t3)",cursor:"pointer",fontSize:12,fontWeight:500}}>Umbuchungen</button>
    </div>
    {/* Karten – klickbar */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:12,marginBottom:24}}>
      {data.map(b=>{
        const bal=b.months[lastMonth]||0;
        const farbe=FARBEN[b.Ktonr]||"var(--acc)";
        return<div key={b.Ktonr} onClick={()=>openDrill(b.Ktonr)} style={{background:"var(--s2)",border:`1px solid ${farbe}44`,borderRadius:8,padding:"14px 16px",borderLeft:`3px solid ${farbe}`,cursor:"pointer",transition:"transform .15s,box-shadow .15s"}}
          onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow=`0 4px 16px ${farbe}33`;}}
          onMouseLeave={e=>{e.currentTarget.style.transform="";e.currentTarget.style.boxShadow="";}}>
          <div style={{fontSize:10,color:"var(--t3)",marginBottom:3,display:"flex",alignItems:"center",gap:6}}>
            <span>{b.Ktonr}</span>
            {b.isKontokorrent&&<span style={{padding:"1px 5px",borderRadius:3,background:"#f59e0b22",color:"#f59e0b",fontWeight:700,fontSize:8,letterSpacing:"0.05em"}}>KK</span>}
          </div>
          <div style={{fontSize:12,fontWeight:600,color:"var(--t1)",marginBottom:6,lineHeight:1.3}}>{b.Name}</div>
          <div style={{fontSize:14,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:bal>=0?"var(--grn)":"var(--red)"}}>
            {bal.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})} €
          </div>
          <div style={{fontSize:10,color:"var(--t3)",marginTop:3}}>Stand {monatLabel} {aktivJahr} · <span style={{color:farbe}}>Buchungen ansehen →</span></div>
        </div>;
      })}
      <div style={{background:"var(--bg)",border:"1px solid var(--brd)",borderRadius:8,padding:"14px 16px",borderLeft:"3px solid var(--acc)"}}>
        <div style={{fontSize:10,color:"var(--t3)",marginBottom:3}}>Alle Konten</div>
        <div style={{fontSize:12,fontWeight:600,color:"var(--t1)",marginBottom:6}}>Gesamt</div>
        <div style={{fontSize:14,fontWeight:700,fontFamily:"'JetBrains Mono',monospace",color:"var(--t1)"}}>
          {data.reduce((a,b)=>a+(b.months[lastMonth]||0),0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})} €
        </div>
        <div style={{fontSize:10,color:"var(--t3)",marginTop:3}}>Stand {monatLabel} {aktivJahr}</div>
      </div>
    </div>

    {/* Monatstabelle */}
    <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,overflowX:"auto"}}>
      <div style={{padding:"12px 16px",borderBottom:"1px solid var(--brd)",fontWeight:600,fontSize:13,color:"var(--t1)"}}>Monatliche Kontostände (kumulativer Endbestand) – Konto anklicken für Details</div>
      <table style={{borderCollapse:"collapse",fontSize:11,minWidth:900,width:"100%"}}>
        <thead>
          <tr>
            <th style={{...thS,textAlign:"left",padding:"6px 12px",position:"sticky",left:0,background:"var(--bg)",zIndex:2}}>Konto</th>
            <th style={{...thS,textAlign:"right"}}>EB</th>
            {MONTHS.map(m=><th key={m.k} style={thS}>{m.l}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.map((b,i)=>{
            const farbe=FARBEN[b.Ktonr]||"var(--acc)";
            return<tr key={b.Ktonr} onClick={()=>openDrill(b.Ktonr)} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)",cursor:"pointer"}}
              onMouseEnter={e=>e.currentTarget.style.background="var(--bg)"}
              onMouseLeave={e=>e.currentTarget.style.background=i%2===0?"transparent":"var(--bg)"}>
              <td style={{padding:"5px 12px",position:"sticky",left:0,background:i%2===0?"var(--s2)":"var(--bg)"}}>
                <div style={{fontSize:10,color:farbe,fontFamily:"'JetBrains Mono',monospace"}}>{b.Ktonr}</div>
                <div style={{fontSize:11,fontWeight:600,color:"var(--t1)",maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{b.Name}</div>
              </td>
              <td style={{...tdS,color:"var(--t2)"}}>{(b.EB||0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
              {MONTHS.map(m=>{
                const beyond=parseInt(m.k)>parseInt(lastMonth);
                if(beyond)return<td key={m.k} style={{...tdS,color:"var(--t3)"}}>–</td>;
                const v=b.months[m.k]||0;
                return<td key={m.k} style={{...tdS,color:v>0?"var(--grn)":v<0?"var(--red)":"var(--t3)",fontWeight:m.k===lastMonth?700:400}}>{v.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})}</td>;
              })}
            </tr>;
          })}
          <tr style={{borderTop:"2px solid var(--brd)",background:"var(--bg)",fontWeight:700}}>
            <td style={{padding:"5px 12px",position:"sticky",left:0,background:"var(--bg)",color:"var(--t1)",fontWeight:700}}>Σ Gesamt</td>
            <td style={{...tdS,fontWeight:700,color:"var(--t1)"}}>{data.reduce((a,b)=>a+(b.EB||0),0).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
            {MONTHS.map(m=>{
              const beyond=parseInt(m.k)>parseInt(lastMonth);
              if(beyond)return<td key={m.k} style={{...tdS,color:"var(--t3)"}}>–</td>;
              const v=data.reduce((a,b)=>a+(b.months[m.k]||0),0);
              return<td key={m.k} style={{...tdS,fontWeight:700,fontSize:12,color:v>=0?"var(--grn)":"var(--red)"}}>{v.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})}</td>;
            })}
          </tr>
        </tbody>
      </table>
    </div>
  </div>;
};

/* ─── DATEV-Import-Panel ─── Pipeline-Übersicht: MinIO-Bucket → gdpdu-import.js → Mongo
 * Zeigt Last-Run-Status, Lock, Historie der letzten Importläufe und erlaubt
 * einen manuellen Scan-Trigger. Auto-Scan läuft serverseitig alle 15 min. */
const DatevImportPanel=()=>{
  const [status,setStatus]=useState(null);
  const [imports,setImports]=useState([]);
  const [scanning,setScanning]=useState(false);
  const [lastMsg,setLastMsg]=useState("");

  const reload=useCallback(()=>{
    Promise.all([
      fetch("/api/datev/status").then(r=>r.ok?r.json():null).catch(()=>null),
      fetch("/api/datev/imports?limit=20").then(r=>r.ok?r.json():null).catch(()=>null),
    ]).then(([s,h])=>{
      if(s)setStatus(s);
      if(h)setImports(h.rows||[]);
    });
  },[]);

  useEffect(()=>{
    reload();
    const t=setInterval(reload,30000); // alle 30s frisch ziehen
    return()=>clearInterval(t);
  },[reload]);

  const triggerScan=async()=>{
    setScanning(true);setLastMsg("");
    try{
      const r=await fetch("/api/datev/scan",{method:"POST"}).then(r=>r.json());
      if(r.skipped){setLastMsg("Scan übersprungen — anderer Lauf aktiv.");}
      else{
        const ok=(r.results||[]).filter(x=>x.status==="ok").length;
        const failed=(r.results||[]).filter(x=>x.status==="failed").length;
        setLastMsg(`Scan abgeschlossen: ${r.found||0} ZIP(s) gefunden, ${ok} erfolgreich, ${failed} Fehler.`);
      }
      reload();
    }catch(e){setLastMsg("Fehler: "+(e?.message||e));}
    finally{setScanning(false);}
  };

  const fmtDateTime=d=>{if(!d)return"–";try{return new Date(d).toLocaleString("de-DE",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"});}catch{return"–";}};
  const dur=(a,b)=>{if(!a||!b)return"–";const ms=new Date(b)-new Date(a);if(ms<1000)return ms+"ms";if(ms<60000)return Math.round(ms/1000)+"s";return Math.round(ms/60000)+"min";};

  const last=status?.lastRun;
  const running=!!status?.running;
  const pwOk=!!status?.passwordConfigured;

  return<div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:16,marginBottom:20}}>
    <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12,flexWrap:"wrap"}}>
      <div style={{fontWeight:600,fontSize:13,color:"var(--t1)"}}>◫ DATEV-Import-Pipeline</div>
      <div style={{fontSize:11,color:"var(--t3)"}}>Bucket: <code style={{fontFamily:"'JetBrains Mono',monospace"}}>{status?.bucket||"–"}</code></div>
      <div style={{fontSize:11,color:pwOk?"var(--grn)":"var(--red)"}}>{pwOk?"✓ ZIP-Passwort gesetzt":"✗ DATEV_ZIP_PASSWORD fehlt"}</div>
      <div style={{fontSize:11,color:running?"var(--ylw)":"var(--t3)"}}>{running?"⟳ Läuft gerade…":"○ idle"}</div>
      <div style={{marginLeft:"auto",display:"flex",gap:8,alignItems:"center"}}>
        <span style={{fontSize:11,color:"var(--t3)"}}>Auto-Scan: alle 15 min</span>
        <button onClick={triggerScan} disabled={scanning||running}
          style={{padding:"6px 14px",borderRadius:6,border:"1px solid var(--acc)",background:scanning?"var(--s3)":"var(--acc)",color:scanning?"var(--t3)":"#fff",fontSize:12,fontWeight:600,cursor:scanning||running?"not-allowed":"pointer",fontFamily:"inherit"}}>
          {scanning?"Scanne…":"Jetzt scannen"}
        </button>
      </div>
    </div>
    {last&&<div style={{fontSize:11,color:"var(--t3)",marginBottom:10}}>
      Letzter Lauf ({last.trigger}): {fmtDateTime(last.startedAt)} · OK: <span style={{color:"var(--grn)"}}>{last.processed}</span> · Fehler: <span style={{color:"var(--red)"}}>{last.failed}</span> · Dauer: {dur(last.startedAt,last.finishedAt)}
    </div>}
    {lastMsg&&<div style={{fontSize:11,color:"var(--t1)",padding:"6px 10px",background:"var(--s3)",borderRadius:5,marginBottom:10}}>{lastMsg}</div>}

    {imports.length===0?<div style={{fontSize:11,color:"var(--t3)",padding:"8px 0"}}>Noch keine Imports protokolliert.</div>:
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
        <thead>
          <tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)"}}>
            {["Status","Gestartet","Datei","Dauer","Ziel"].map(h=><th key={h} style={{padding:"6px 10px",textAlign:"left",fontWeight:600}}>{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {imports.map((r,i)=>{
            const ok=r.status==="ok";const f=r.status==="failed";
            return<tr key={i} style={{borderBottom:"1px solid var(--brd)"}}>
              <td style={{padding:"6px 10px"}}><span style={{padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600,background:ok?"var(--grn2)":f?"var(--red2)":"var(--ylw2)",color:ok?"var(--grn)":f?"var(--red)":"var(--ylw)"}}>{ok?"OK":f?"FEHLER":r.status||"?"}</span></td>
              <td style={{padding:"6px 10px",color:"var(--t2)"}}>{fmtDateTime(r.startedAt)}</td>
              <td style={{padding:"6px 10px",color:"var(--t1)",fontFamily:"'JetBrains Mono',monospace",fontSize:10}}>{r.key||r.baseName||"–"}</td>
              <td style={{padding:"6px 10px",color:"var(--t3)"}}>{dur(r.startedAt,r.finishedAt)}</td>
              <td style={{padding:"6px 10px",color:"var(--t3)",fontFamily:"'JetBrains Mono',monospace",fontSize:10}}>{r.movedTo||"–"}{r.error?<div style={{color:"var(--red)",marginTop:3,fontFamily:"inherit"}}>{r.error.slice(0,200)}</div>:null}</td>
            </tr>;
          })}
        </tbody>
      </table>
    </div>}
  </div>;
};

const BuchhaltungPage=()=>{
  const {ktoName}=useKontoLookup();
  const [tab,setTab]=useState("uebersicht");
  const [stats,setStats]=useState(null);
  const [monatsumsaetze,setMonatsumsaetze]=useState([]);
  const [loadingStats,setLoadingStats]=useState(true);

  // Buchungssätze state
  const [bs,setBs]=useState([]);
  const [bsTotal,setBsTotal]=useState(0);
  const [bsPage,setBsPage]=useState(1);
  const [bsLoading,setBsLoading]=useState(false);
  const [bsSearch,setBsSearch]=useState("");
  const [bsKtonr,setBsKtonr]=useState("");
  const [bsGktonr,setBsGktonr]=useState("");
  const [bsMonat,setBsMonat]=useState("");
  const [bsVon,setBsVon]=useState("");
  const [bsBis,setBsBis]=useState("");

  // Sachkonten state
  const [sk,setSk]=useState([]);
  const [skSearch,setSkSearch]=useState("");
  const [skLoading,setSkLoading]=useState(false);

  // Debitoren/Kreditoren state
  const [dk,setDk]=useState([]);
  const [dkTyp,setDkTyp]=useState("");
  const [dkSearch,setDkSearch]=useState("");
  const [dkLoading,setDkLoading]=useState(false);

  const iS={padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,fontFamily:"inherit"};

  // load stats & monatsumsaetze on mount
  useEffect(()=>{
    Promise.all([
      fetch("/api/cashflow/buchhaltung/stats").then(r=>r.json()),
      fetch("/api/cashflow/buchhaltung/monatsumsaetze").then(r=>r.json()),
    ]).then(([s,m])=>{setStats(s);setMonatsumsaetze(Array.isArray(m)?m:[]);setLoadingStats(false);})
      .catch(()=>setLoadingStats(false));
  },[]);

  // load buchungssätze when tab or filters change
  const loadBs=useCallback((page=1)=>{
    setBsLoading(true);
    const p=new URLSearchParams({page,limit:100});
    if(bsSearch)p.set("search",bsSearch);
    if(bsKtonr)p.set("ktonr",bsKtonr);
    if(bsGktonr)p.set("gktonr",bsGktonr);
    if(bsMonat)p.set("monat",bsMonat);
    if(bsVon)p.set("von",bsVon);
    if(bsBis)p.set("bis",bsBis);
    fetch(`/api/cashflow/buchhaltung/buchungssaetze?${p}`).then(r=>r.json()).then(d=>{
      setBs(d.docs||[]);setBsTotal(d.total||0);setBsPage(page);setBsLoading(false);
    }).catch(()=>setBsLoading(false));
  },[bsSearch,bsKtonr,bsGktonr,bsMonat,bsVon,bsBis]);

  useEffect(()=>{if(tab==="buchungssaetze")loadBs(1);},[tab]);

  // load sachkonten
  useEffect(()=>{
    if(tab==="sachkonten"&&sk.length===0){
      setSkLoading(true);
      fetch("/api/cashflow/buchhaltung/sachkonten").then(r=>r.json()).then(d=>{setSk(Array.isArray(d)?d:[]);setSkLoading(false);}).catch(()=>setSkLoading(false));
    }
  },[tab]);

  // load debkred
  const loadDk=useCallback(()=>{
    setDkLoading(true);
    const p=new URLSearchParams();
    if(dkTyp)p.set("typ",dkTyp);
    if(dkSearch)p.set("search",dkSearch);
    fetch(`/api/cashflow/buchhaltung/debkred?${p}`).then(r=>r.json()).then(d=>{setDk(Array.isArray(d)?d:[]);setDkLoading(false);}).catch(()=>setDkLoading(false));
  },[dkTyp,dkSearch]);

  useEffect(()=>{if(tab==="debkred")loadDk();},[tab,dkTyp]);

  const bsPages=Math.ceil(bsTotal/100)||1;

  // ─── Übersicht Tab ───
  const renderUebersicht=()=>{
    if(loadingStats)return<div style={{padding:40,textAlign:"center",color:"var(--t3)"}}>Lade…</div>;
    return<div>
      {/* Stats-Karten */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(190px,1fr))",gap:14,marginBottom:24}}>
        {[
          {label:"Buchungssätze",val:(stats?.totalBuchungen||0).toLocaleString("de-DE"),icon:"◈"},
          {label:"Sachkonten",val:(stats?.totalSachkonten||0).toLocaleString("de-DE"),icon:"◧"},
          {label:"Debitoren/Kreditoren",val:(stats?.totalDebkred||0).toLocaleString("de-DE"),icon:"◉"},
          {label:"Zeitraum",val:stats?.minDatum?`${fmtDat(stats.minDatum)} – ${fmtDat(stats.maxDatum)}`:"–",icon:"◎"},
          {label:"Gesamtumsatz Soll",val:fmtEur(stats?.gesamtSoll),icon:"▲"},
          {label:"Gesamtumsatz Haben",val:fmtEur(stats?.gesamtHaben),icon:"▼"},
        ].map(c=><div key={c.label} style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:"14px 16px"}}>
          <div style={{fontSize:11,color:"var(--t3)",marginBottom:4}}>{c.icon} {c.label}</div>
          <div style={{fontSize:15,fontWeight:700,color:"var(--t1)"}}>{c.val}</div>
        </div>)}
      </div>

      {/* DATEV-Import-Panel (MinIO → Mongo) */}
      <DatevImportPanel/>

      {/* Monatsübersicht */}
      <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:16,marginBottom:20}}>
        <div style={{fontWeight:600,fontSize:13,color:"var(--t1)",marginBottom:12}}>Monatsumsätze {String(window.__bhJahr||new Date().getFullYear())}</div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
            <thead>
              <tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)"}}>
                {["Monat","Buchungen","Soll","Haben","Saldo"].map(h=><th key={h} style={{padding:"6px 10px",textAlign:h==="Monat"||h==="Buchungen"?"left":"right",fontWeight:600}}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {monatsumsaetze.length===0?<tr><td colSpan={5} style={{padding:16,textAlign:"center",color:"var(--t3)"}}>Keine Daten</td></tr>:
                monatsumsaetze.map((m,i)=>{
                  const saldo=(m.sumSoll||0)-(m.sumHaben||0);
                  return<tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
                    <td style={{padding:"6px 10px",color:"var(--t1)",fontWeight:500}}>{MONATE_KURZ[m.monat]||m.monat}</td>
                    <td style={{padding:"6px 10px",color:"var(--t2)"}}>{(m.count||0).toLocaleString("de-DE")}</td>
                    <td style={{padding:"6px 10px",textAlign:"right",color:"var(--t1)",fontFamily:"'JetBrains Mono',monospace",fontSize:11}}>{fmtEur(m.sumSoll)}</td>
                    <td style={{padding:"6px 10px",textAlign:"right",color:"var(--t1)",fontFamily:"'JetBrains Mono',monospace",fontSize:11}}>{fmtEur(m.sumHaben)}</td>
                    <td style={{padding:"6px 10px",textAlign:"right",fontWeight:600,fontFamily:"'JetBrains Mono',monospace",fontSize:11,color:saldo>=0?"var(--grn)":"var(--red)"}}>{fmtEur(saldo)}</td>
                  </tr>;
                })
              }
            </tbody>
          </table>
        </div>
      </div>

      {/* Top 5 Konten */}
      {stats?.top5Konten?.length>0&&<div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:16}}>
        <div style={{fontWeight:600,fontSize:13,color:"var(--t1)",marginBottom:12}}>Top 5 Konten nach Umsatzvolumen (Soll)</div>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr style={{borderBottom:"1px solid var(--brd)",color:"var(--t3)"}}>
            <th style={{padding:"5px 10px",textAlign:"left",fontWeight:600}}>Konto</th>
            <th style={{padding:"5px 10px",textAlign:"left",fontWeight:600}}>Bezeichnung</th>
            <th style={{padding:"5px 10px",textAlign:"right",fontWeight:600}}>Volumen (Soll)</th>
            <th style={{padding:"5px 10px",textAlign:"right",fontWeight:600}}>Buchungen</th>
          </tr></thead>
          <tbody>{stats.top5Konten.map((k,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
            <td style={{padding:"6px 10px",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color:"var(--acc)"}}>{k.Ktonr}</td>
            <td style={{padding:"6px 10px",color:"var(--t2)"}}>{k.Text||"–"}</td>
            <td style={{padding:"6px 10px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color:"var(--t1)",fontWeight:600}}>{fmtEur(k.vol)}</td>
            <td style={{padding:"6px 10px",textAlign:"right",color:"var(--t3)"}}>{(k.count||0).toLocaleString("de-DE")}</td>
          </tr>)}</tbody>
        </table>
      </div>}
    </div>;
  };

  // ─── Buchungssätze Tab ───
  const renderBuchungssaetze=()=><div>
    <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center",marginBottom:14}}>
      <input value={bsSearch} onChange={e=>setBsSearch(e.target.value)} onKeyDown={e=>e.key==="Enter"&&loadBs(1)} placeholder="Buchungstext / Belegnr…" style={{...iS,minWidth:200}}/>
      <input value={bsKtonr} onChange={e=>setBsKtonr(e.target.value)} onKeyDown={e=>e.key==="Enter"&&loadBs(1)} placeholder="Konto-Nr" style={{...iS,width:100}}/>
      <input value={bsGktonr} onChange={e=>setBsGktonr(e.target.value)} onKeyDown={e=>e.key==="Enter"&&loadBs(1)} placeholder="Gegenkonto" style={{...iS,width:100}}/>
      <select value={bsMonat} onChange={e=>{setBsMonat(e.target.value);}} style={{...iS,cursor:"pointer"}}>
        <option value="">Alle Monate</option>
        {MONATE_KURZ.slice(1).map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
      </select>
      <input type="date" value={bsVon} onChange={e=>setBsVon(e.target.value)} style={iS} title="Datum von"/>
      <input type="date" value={bsBis} onChange={e=>setBsBis(e.target.value)} style={iS} title="Datum bis"/>
      <button onClick={()=>loadBs(1)} style={{...iS,background:"var(--acc)",color:"#fff",cursor:"pointer",border:"none",fontWeight:600}}>Suchen</button>
      <button onClick={()=>{setBsSearch("");setBsKtonr("");setBsGktonr("");setBsMonat("");setBsVon("");setBsBis(""); setTimeout(()=>loadBs(1),50);}} style={{...iS,cursor:"pointer"}}>Zurücksetzen</button>
      <span style={{marginLeft:"auto",fontSize:11,color:"var(--t3)"}}>{bsTotal.toLocaleString("de-DE")} Buchungssätze</span>
    </div>
    {bsLoading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:<>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
          <thead><tr style={{borderBottom:"2px solid var(--brd)",color:"var(--t3)"}}>
            <th style={{padding:"6px 8px",textAlign:"left",fontWeight:600}}>Belegnr.</th>
            <th style={{padding:"6px 8px",textAlign:"left",fontWeight:600}}>Datum</th>
            <th style={{padding:"6px 8px",textAlign:"left",fontWeight:600}}>Monat</th>
            <th style={{padding:"6px 8px",textAlign:"left",fontWeight:600}}>Konto</th>
            <th style={{padding:"6px 8px",textAlign:"left",fontWeight:600}}>Gegenkonto</th>
            <th style={{padding:"6px 8px",textAlign:"left",fontWeight:600}}>Buchungstext</th>
            <th style={{padding:"6px 8px",textAlign:"right",fontWeight:600}}>Soll</th>
            <th style={{padding:"6px 8px",textAlign:"right",fontWeight:600}}>Haben</th>
            <th style={{padding:"6px 8px",textAlign:"left",fontWeight:600}}>SH</th>
          </tr></thead>
          <tbody>
            {bs.length===0?<tr><td colSpan={9} style={{padding:24,textAlign:"center",color:"var(--t3)"}}>Keine Buchungssätze gefunden</td></tr>:
              bs.map((b,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
                <td style={{padding:"5px 8px",fontFamily:"'JetBrains Mono',monospace",color:"var(--t2)"}}>{b.Belegnummer||b.BelegNr||"–"}</td>
                <td style={{padding:"5px 8px",whiteSpace:"nowrap",color:"var(--t2)"}}>{fmtDat(b.Belegdatum)}</td>
                <td style={{padding:"5px 8px"}}>
                  <span style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:4,padding:"1px 6px",fontSize:10,color:"var(--t3)"}}>{MONATE_KURZ[b.WjMonat]||b.WjMonat||"–"}</span>
                </td>
                <td style={{padding:"5px 8px",color:"var(--acc)",fontWeight:500,fontSize:11}}>{ktoName(b.Ktonr)}</td>
                <td style={{padding:"5px 8px",color:"var(--t2)",fontSize:11}}>{ktoName(b.GKtonr)}</td>
                <td style={{padding:"5px 8px",color:"var(--t1)",maxWidth:280,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{b.Buchungstext||"–"}</td>
                <td style={{padding:"5px 8px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:b.Umsatz_Soll?"var(--t1)":"var(--t3)"}}>{b.Umsatz_Soll?fmtEur(b.Umsatz_Soll):"–"}</td>
                <td style={{padding:"5px 8px",textAlign:"right",fontFamily:"'JetBrains Mono',monospace",color:b.Umsatz_Haben?"var(--t1)":"var(--t3)"}}>{b.Umsatz_Haben?fmtEur(b.Umsatz_Haben):"–"}</td>
                <td style={{padding:"5px 8px",fontSize:10,color:"var(--t3)"}}>{b.SHKz||"–"}</td>
              </tr>)
            }
          </tbody>
        </table>
      </div>
      {bsPages>1&&<div style={{display:"flex",gap:6,alignItems:"center",marginTop:12,justifyContent:"center"}}>
        <button onClick={()=>loadBs(1)} disabled={bsPage<=1} style={{...iS,cursor:bsPage>1?"pointer":"not-allowed",opacity:bsPage>1?1:0.4}}>«</button>
        <button onClick={()=>loadBs(bsPage-1)} disabled={bsPage<=1} style={{...iS,cursor:bsPage>1?"pointer":"not-allowed",opacity:bsPage>1?1:0.4}}>‹</button>
        <span style={{fontSize:12,color:"var(--t2)",padding:"0 8px"}}>Seite {bsPage} / {bsPages}</span>
        <button onClick={()=>loadBs(bsPage+1)} disabled={bsPage>=bsPages} style={{...iS,cursor:bsPage<bsPages?"pointer":"not-allowed",opacity:bsPage<bsPages?1:0.4}}>›</button>
        <button onClick={()=>loadBs(bsPages)} disabled={bsPage>=bsPages} style={{...iS,cursor:bsPage<bsPages?"pointer":"not-allowed",opacity:bsPage<bsPages?1:0.4}}>»</button>
      </div>}
    </>}
  </div>;

  // ─── Sachkonten Tab ───
  const skFiltered=sk.filter(s=>{
    if(!skSearch)return true;
    const q=skSearch.toLowerCase();
    return (String(s.Ktonr||"")).includes(q)||(s.Text||s.IFktBeschr||"").toLowerCase().includes(q);
  });

  const renderSachkonten=()=><div>
    <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:14}}>
      <input value={skSearch} onChange={e=>setSkSearch(e.target.value)} placeholder="Konto suchen…" style={{...iS,maxWidth:300}}/>
      <span style={{marginLeft:"auto",fontSize:11,color:"var(--t3)"}}>{skFiltered.length} von {sk.length} Konten</span>
    </div>
    {skLoading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
      sk.length===0?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Sachkonten gefunden</div>:
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr style={{borderBottom:"2px solid var(--brd)",color:"var(--t3)"}}>
            <th style={{padding:"6px 10px",textAlign:"left",fontWeight:600}}>Ktonr</th>
            <th style={{padding:"6px 10px",textAlign:"left",fontWeight:600}}>Bezeichnung</th>
            <th style={{padding:"6px 10px",textAlign:"left",fontWeight:600}}>Typ</th>
            <th style={{padding:"6px 10px",textAlign:"left",fontWeight:600}}>Funktion</th>
          </tr></thead>
          <tbody>{skFiltered.map((s,i)=><tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
            <td style={{padding:"6px 10px",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color:"var(--acc)",fontWeight:600}}>{s.Ktonr}</td>
            <td style={{padding:"6px 10px",color:"var(--t1)"}}>{s.Text||s.IFktBeschr||"–"}</td>
            <td style={{padding:"6px 10px",color:"var(--t3)",fontSize:11}}>{s.HkTyp||"–"}</td>
            <td style={{padding:"6px 10px",color:"var(--t2)",fontSize:11,maxWidth:300,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{s.IFktBeschr||"–"}</td>
          </tr>)}</tbody>
        </table>
      </div>
    }
  </div>;

  // ─── Debitoren/Kreditoren Tab ───
  const renderDebkred=()=><div>
    <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:14,flexWrap:"wrap"}}>
      <div style={{display:"flex",gap:3,background:"var(--s2)",borderRadius:8,padding:3}}>
        {[{v:"",l:"Alle"},{v:"D",l:"Debitoren"},{v:"K",l:"Kreditoren"}].map(t=><button key={t.v} onClick={()=>setDkTyp(t.v)} style={{padding:"6px 14px",borderRadius:6,border:"none",fontSize:12,fontWeight:500,cursor:"pointer",fontFamily:"inherit",background:dkTyp===t.v?"var(--acc)":"transparent",color:dkTyp===t.v?"#fff":"var(--t2)",transition:"all .2s"}}>{t.l}</button>)}
      </div>
      <input value={dkSearch} onChange={e=>setDkSearch(e.target.value)} onKeyDown={e=>e.key==="Enter"&&loadDk()} placeholder="Name / Ktonr…" style={{...iS,maxWidth:280}}/>
      <button onClick={()=>loadDk()} style={{...iS,background:"var(--acc)",color:"#fff",cursor:"pointer",border:"none",fontWeight:600}}>Suchen</button>
      <span style={{marginLeft:"auto",fontSize:11,color:"var(--t3)"}}>{dk.length.toLocaleString("de-DE")} Einträge</span>
    </div>
    {dkLoading?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Lade…</div>:
      dk.length===0?<div style={{padding:32,textAlign:"center",color:"var(--t3)"}}>Keine Einträge gefunden</div>:
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
          <thead><tr style={{borderBottom:"2px solid var(--brd)",color:"var(--t3)"}}>
            {["Ktonr","Typ","Name","Staat","Telefon","IBAN","PLZ","Ort"].map(h=><th key={h} style={{padding:"6px 10px",textAlign:"left",fontWeight:600}}>{h}</th>)}
          </tr></thead>
          <tbody>{dk.map((d,i)=>{const isD=d.Typ==="D";return<tr key={i} style={{borderBottom:"1px solid var(--brd)",background:i%2===0?"transparent":"var(--bg)"}}>
            <td style={{padding:"6px 10px",fontFamily:"'JetBrains Mono',monospace",fontSize:11,color:"var(--acc)"}}>{d.PKKtonr||"–"}</td>
            <td style={{padding:"6px 10px"}}>
              <span style={{padding:"1px 7px",borderRadius:4,fontSize:10,fontWeight:600,background:isD?"#16a34a22":"#3b82f622",color:isD?"var(--grn)":"#3b82f6"}}>{d.Typ||"–"}</span>
            </td>
            <td style={{padding:"6px 10px",color:"var(--t1)",fontWeight:500}}>{d.Name_Unternehmen||"–"}</td>
            <td style={{padding:"6px 10px",color:"var(--t3)",fontSize:11}}>{d.Staat||d.EU_Mitgliedstaat_UStID||"–"}</td>
            <td style={{padding:"6px 10px",fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t3)"}}>{d.Telefon_1||"–"}</td>
            <td style={{padding:"6px 10px",fontFamily:"'JetBrains Mono',monospace",fontSize:10,color:"var(--t2)"}}>{d.IBAN_1||"–"}</td>
            <td style={{padding:"6px 10px",color:"var(--t3)",fontSize:11}}>{d.PLZ||"–"}</td>
            <td style={{padding:"6px 10px",color:"var(--t2)"}}>{d.Ort||"–"}</td>
          </tr>;})}
</tbody>
        </table>
      </div>
    }
  </div>;

  return<div style={{maxWidth:1400}}>
    <div style={{marginBottom:16}}>
      <Tabs tabs={[
        {k:"uebersicht",l:"Übersicht"},
        {k:"buchungssaetze",l:"Buchungssätze"},
        {k:"sachkonten",l:"Sachkontenplan"},
        {k:"debkred",l:"Debitoren / Kreditoren"},
      ]} active={tab} onChange={setTab}/>
    </div>
    <div style={{background:"var(--s2)",border:"1px solid var(--brd)",borderRadius:8,padding:20}}>
      {tab==="uebersicht"&&renderUebersicht()}
      {tab==="buchungssaetze"&&renderBuchungssaetze()}
      {tab==="sachkonten"&&renderSachkonten()}
      {tab==="debkred"&&renderDebkred()}
    </div>
  </div>;
};

/* ─── App ─── */
/* ─── Login-Screen (mehrstufig: Passwort → 2FA-Setup oder 2FA-Challenge) ─── */
const LoginScreen=({dark,onLogin})=>{
  // step: "password" | "challenge" | "setup" | "backup-codes"
  const [step,setStep]=useState("password");
  const [email,setEmail]=useState("");
  const [password,setPassword]=useState("");
  const [code,setCode]=useState("");
  const [useBackup,setUseBackup]=useState(false);
  const [setupData,setSetupData]=useState(null); // {secret, qrDataUrl, email}
  const [backupCodes,setBackupCodes]=useState(null);
  const [finalUser,setFinalUser]=useState(null);
  const [err,setErr]=useState("");
  const [loading,setLoading]=useState(false);

  const wrap=(inner)=><div style={{...TH[dark?"dark":"light"],background:"var(--bg)",minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",color:"var(--t1)"}}>{inner}</div>;

  const resetAll=()=>{
    localStorage.removeItem("authToken");
    setStep("password"); setPassword(""); setCode(""); setUseBackup(false);
    setSetupData(null); setBackupCodes(null); setFinalUser(null); setErr("");
  };

  // ── Schritt 1: Passwort ──
  const submitPassword=async(e)=>{
    e&&e.preventDefault(); setErr(""); setLoading(true);
    try{
      const r=await fetch("/api/auth/login",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email,password})});
      const j=await r.json().catch(()=>({}));
      if(!r.ok) throw new Error(j.message||"Login fehlgeschlagen");
      if(j.needs2fa && j.challengeToken){
        localStorage.setItem("authToken",j.challengeToken);
        setStep("challenge"); setCode(""); setUseBackup(false);
      }else if(j.needsSetup && j.setupToken){
        localStorage.setItem("authToken",j.setupToken);
        // Setup-Daten holen
        const r2=await fetch("/api/auth/2fa/setup",{method:"POST"});
        const j2=await r2.json().catch(()=>({}));
        if(!r2.ok) throw new Error(j2.message||"Setup konnte nicht gestartet werden");
        setSetupData(j2); setStep("setup"); setCode("");
      }else if(j.token && j.user){
        // Volle Session (Gnadenfrist vor Pflichttermin oder Legacy)
        localStorage.setItem("authToken",j.token);
        if(j.twofaGracePeriod && j.twofaDeadline){
          try{ localStorage.setItem("twofaDeadline", j.twofaDeadline); }catch{}
        }else{
          try{ localStorage.removeItem("twofaDeadline"); }catch{}
        }
        onLogin(j.user);
      }else{
        throw new Error("Unerwartete Server-Antwort");
      }
    }catch(ex){setErr(ex.message);}
    setLoading(false);
  };

  // ── Schritt 2a: Challenge (TOTP oder Backup-Code) ──
  const submitChallenge=async(e)=>{
    e&&e.preventDefault(); setErr(""); setLoading(true);
    try{
      const r=await fetch("/api/auth/2fa/challenge",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({code})});
      const j=await r.json().catch(()=>({}));
      if(!r.ok) throw new Error(j.message||"Code ungültig");
      localStorage.setItem("authToken",j.token);
      onLogin(j.user);
    }catch(ex){setErr(ex.message); setCode("");}
    setLoading(false);
  };

  // ── Schritt 2b: Setup abschließen ──
  const submitSetup=async(e)=>{
    e&&e.preventDefault(); setErr(""); setLoading(true);
    try{
      const r=await fetch("/api/auth/2fa/verify-setup",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({code})});
      const j=await r.json().catch(()=>({}));
      if(!r.ok) throw new Error(j.message||"Code ungültig");
      localStorage.setItem("authToken",j.token);
      setBackupCodes(j.backupCodes||[]); setFinalUser(j.user); setStep("backup-codes");
    }catch(ex){setErr(ex.message); setCode("");}
    setLoading(false);
  };

  // Auto-Submit bei 6 Ziffern (nur Challenge ohne Backup + Setup)
  useEffect(()=>{
    if(loading) return;
    if(step==="challenge" && !useBackup && /^\d{6}$/.test(code)) submitChallenge();
    if(step==="setup" && /^\d{6}$/.test(code)) submitSetup();
  },[code,step,useBackup]);

  const cardStyle={background:"var(--s1)",borderRadius:12,border:"1px solid var(--brd)",padding:"30px 32px",width:420,boxShadow:"0 4px 20px rgba(0,0,0,.3)"};
  const inputStyle={width:"100%",padding:"9px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontFamily:"inherit"};
  const btnPrimary=(disabled)=>({width:"100%",padding:"10px 14px",borderRadius:7,border:"none",background:"var(--acc)",color:"#fff",fontSize:13,fontWeight:600,cursor:disabled?"wait":"pointer",fontFamily:"inherit",opacity:disabled?0.7:1});

  if(step==="password"){
    return wrap(<form onSubmit={submitPassword} style={cardStyle}>
      <div style={{fontSize:22,fontWeight:700,marginBottom:4,letterSpacing:"-.5px"}}>StyleOMat Login</div>
      <div style={{fontSize:11,color:"var(--t3)",marginBottom:22}}>Bitte anmelden</div>
      <div style={{marginBottom:14}}>
        <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>E-Mail</label>
        <input autoFocus type="email" value={email} onChange={e=>setEmail(e.target.value)} style={inputStyle}/>
      </div>
      <div style={{marginBottom:14}}>
        <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>Passwort</label>
        <input type="password" value={password} onChange={e=>setPassword(e.target.value)} style={inputStyle}/>
      </div>
      {err&&<div style={{padding:"8px 12px",borderRadius:6,background:"var(--red2)",color:"var(--red)",fontSize:11,marginBottom:12}}>{err}</div>}
      <button type="submit" disabled={loading||!email||!password} style={btnPrimary(loading)}>{loading?"Anmelden…":"Weiter"}</button>
      <div style={{fontSize:10,color:"var(--t3)",marginTop:16,textAlign:"center"}}>🔒 2-Faktor-Authentifizierung ist Pflicht</div>
    </form>);
  }

  if(step==="challenge"){
    return wrap(<form onSubmit={submitChallenge} style={cardStyle}>
      <div style={{fontSize:22,fontWeight:700,marginBottom:4,letterSpacing:"-.5px"}}>🔒 2FA-Code</div>
      <div style={{fontSize:11,color:"var(--t3)",marginBottom:22}}>
        {useBackup?"Backup-Code aus deiner Liste eingeben":"6-stelligen Code aus Google Authenticator eingeben"}
      </div>
      <div style={{marginBottom:14}}>
        <input autoFocus inputMode={useBackup?"text":"numeric"} autoComplete="one-time-code"
          maxLength={useBackup?24:6} pattern={useBackup?undefined:"\\d{6}"}
          value={code} onChange={e=>setCode(useBackup?e.target.value:e.target.value.replace(/\D/g,"").slice(0,6))}
          placeholder={useBackup?"z.B. a1b2-c3d4e5":"123 456"}
          style={{...inputStyle,fontSize:useBackup?14:22,textAlign:"center",letterSpacing:useBackup?1:6,fontFamily:"'SF Mono',Menlo,monospace"}}/>
      </div>
      {err&&<div style={{padding:"8px 12px",borderRadius:6,background:"var(--red2)",color:"var(--red)",fontSize:11,marginBottom:12}}>{err}</div>}
      <button type="submit" disabled={loading||!code} style={btnPrimary(loading)}>{loading?"Prüfe…":"Anmelden"}</button>
      <div style={{display:"flex",justifyContent:"space-between",marginTop:14,fontSize:11}}>
        <a onClick={(e)=>{e.preventDefault();setUseBackup(!useBackup);setCode("");setErr("");}} href="#" style={{color:"var(--acc)",textDecoration:"none"}}>
          {useBackup?"← Authenticator-Code":"2FA verloren? Backup-Code verwenden"}
        </a>
        <a onClick={(e)=>{e.preventDefault();resetAll();}} href="#" style={{color:"var(--t3)",textDecoration:"none"}}>Abbrechen</a>
      </div>
    </form>);
  }

  if(step==="setup"){
    return wrap(<form onSubmit={submitSetup} style={{...cardStyle,width:460}}>
      <div style={{fontSize:20,fontWeight:700,marginBottom:4,letterSpacing:"-.5px"}}>🔒 2FA einrichten</div>
      <div style={{fontSize:11,color:"var(--t3)",marginBottom:18}}>Pflicht für alle Benutzer. Google Authenticator (oder kompatibel) auf dem Handy installieren, dann QR-Code scannen.</div>
      {setupData?.qrDataUrl&&<div style={{background:"#fff",padding:14,borderRadius:8,display:"flex",justifyContent:"center",marginBottom:14}}>
        <img src={setupData.qrDataUrl} alt="QR" style={{width:180,height:180,imageRendering:"pixelated"}}/>
      </div>}
      {setupData?.secret&&<div style={{marginBottom:14}}>
        <label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:4}}>Kann nicht scannen? Schlüssel manuell eingeben:</label>
        <div style={{padding:"8px 10px",borderRadius:6,background:"var(--s2)",border:"1px solid var(--brd)",fontSize:11,fontFamily:"'SF Mono',Menlo,monospace",color:"var(--t2)",wordBreak:"break-all",textAlign:"center"}}>{setupData.secret}</div>
      </div>}
      <div style={{marginBottom:14}}>
        <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>6-stelliger Code aus der App</label>
        <input autoFocus inputMode="numeric" autoComplete="one-time-code" maxLength={6} pattern="\d{6}"
          value={code} onChange={e=>setCode(e.target.value.replace(/\D/g,"").slice(0,6))}
          placeholder="123 456"
          style={{...inputStyle,fontSize:22,textAlign:"center",letterSpacing:6,fontFamily:"'SF Mono',Menlo,monospace"}}/>
      </div>
      {err&&<div style={{padding:"8px 12px",borderRadius:6,background:"var(--red2)",color:"var(--red)",fontSize:11,marginBottom:12}}>{err}</div>}
      <button type="submit" disabled={loading||code.length!==6} style={btnPrimary(loading)}>{loading?"Prüfe…":"2FA aktivieren"}</button>
      <div style={{marginTop:14,textAlign:"right",fontSize:11}}>
        <a onClick={(e)=>{e.preventDefault();resetAll();}} href="#" style={{color:"var(--t3)",textDecoration:"none"}}>Abbrechen</a>
      </div>
    </form>);
  }

  if(step==="backup-codes"){
    const codesText=(backupCodes||[]).join("\n");
    const download=()=>{
      const blob=new Blob([`StyleOMat · 2FA Backup-Codes für ${finalUser?.email}\nErstellt: ${new Date().toLocaleString("de-DE")}\n\nJeder Code ist nur einmal gültig. Sicher aufbewahren!\n\n${codesText}\n`],{type:"text/plain"});
      const a=document.createElement("a"); a.href=URL.createObjectURL(blob);
      a.download=`stylomat-backup-codes-${(finalUser?.email||"user").split("@")[0]}.txt`;
      a.click(); URL.revokeObjectURL(a.href);
    };
    return wrap(<div style={{...cardStyle,width:480}}>
      <div style={{fontSize:20,fontWeight:700,marginBottom:4,letterSpacing:"-.5px",color:"var(--grn)"}}>✓ 2FA aktiviert</div>
      <div style={{fontSize:12,color:"var(--t2)",marginBottom:16,lineHeight:1.5}}>
        <strong style={{color:"var(--ylw)"}}>Wichtig:</strong> Diese 10 Backup-Codes werden <strong>nur jetzt</strong> angezeigt. Speichere sie an einem sicheren Ort — wenn du dein Handy verlierst, sind sie der einzige Weg zurück in deinen Account.
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,padding:14,borderRadius:8,background:"var(--s2)",border:"1px dashed var(--brd)",marginBottom:14,fontFamily:"'SF Mono',Menlo,monospace",fontSize:13}}>
        {(backupCodes||[]).map((c,i)=><div key={i} style={{color:"var(--t1)",letterSpacing:1}}>{String(i+1).padStart(2,"0")}. {c}</div>)}
      </div>
      <div style={{display:"flex",gap:8,marginBottom:12}}>
        <button type="button" onClick={()=>{navigator.clipboard.writeText(codesText); setErr("✓ In Zwischenablage kopiert");}}
          style={{flex:1,padding:"9px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>📋 Kopieren</button>
        <button type="button" onClick={download}
          style={{flex:1,padding:"9px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>⬇ Download</button>
        <button type="button" onClick={()=>window.print()}
          style={{flex:1,padding:"9px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>🖨 Drucken</button>
      </div>
      {err&&<div style={{padding:"8px 12px",borderRadius:6,background:"var(--grn2)",color:"var(--grn)",fontSize:11,marginBottom:12}}>{err}</div>}
      <button type="button" onClick={()=>onLogin(finalUser)} style={btnPrimary(false)}>Ich habe die Codes gesichert → Weiter</button>
    </div>);
  }

  return wrap(<div style={cardStyle}>Lade…</div>);
};

function App(){
  const [dark,setDark]=useState(true);
  useEffect(()=>{document.body.setAttribute("data-theme",dark?"dark":"light");},[dark]);
  // Buchhaltung: aktives Jahr (global, persistiert in localStorage)
  const [bhJahr,setBhJahr]=useState(()=>{
    const stored=parseInt(localStorage.getItem("bhJahr"));
    return (stored>=2000&&stored<=2099)?stored:new Date().getFullYear();
  });
  const [bhJahre,setBhJahre]=useState([]);
  // SYNC: window.__bhJahr muss vor jedem child-fetch passen, sonst greift der
  // Fetch-Interceptor mit dem Stand vor dem Wechsel (children-effects laufen
  // vor parent-effects). Daher inline im Render setzen, nicht via useEffect.
  window.__bhJahr=bhJahr;
  useEffect(()=>{try{localStorage.setItem("bhJahr",String(bhJahr));}catch(e){}},[bhJahr]);
  useEffect(()=>{
    fetch("/api/cashflow/buchhaltung/jahre").then(r=>r.ok?r.json():null).then(j=>{
      if(!j)return;
      const arr=Array.isArray(j.jahre)?j.jahre:[];
      setBhJahre(arr);
      if(arr.length){
        const stored=parseInt(localStorage.getItem("bhJahr"));
        if(!arr.includes(stored)) setBhJahr(j.current||arr[0]);
      }
    }).catch(()=>{});
  },[]);
  const [nav,setNav]=useState(()=>{
    const h=(window.location.hash||"").replace(/^#\/?/,"");
    return h||"dashboard";
  });
  useEffect(()=>{
    const target="#/"+nav;
    if(window.location.hash!==target) window.history.replaceState(null,"",target);
  },[nav]);
  useEffect(()=>{
    const onHash=()=>{
      const h=(window.location.hash||"").replace(/^#\/?/,"")||"dashboard";
      setNav(prev=>prev===h?prev:h);
    };
    window.addEventListener("hashchange",onHash);
    return()=>window.removeEventListener("hashchange",onHash);
  },[]);
  const [now,setNow]=useState(new Date());
  const [currentUser,setCurrentUser]=useState(null);
  const [authChecked,setAuthChecked]=useState(false);
  useEffect(()=>{const t=setInterval(()=>setNow(new Date()),60000);return()=>clearInterval(t);},[]);
  // Beim Start: Token prüfen
  useEffect(()=>{
    const tok=localStorage.getItem("authToken");
    if(!tok){setAuthChecked(true);return;}
    fetch("/api/auth/me").then(r=>r.ok?r.json():Promise.reject()).then(j=>setCurrentUser(j.user)).catch(()=>{localStorage.removeItem("authToken");}).finally(()=>setAuthChecked(true));
  },[]);
  const handleLogout=async()=>{
    try{await fetch("/api/auth/logout",{method:"POST"});}catch{}
    localStorage.removeItem("authToken");
    setCurrentUser(null);
  };
  if(!authChecked) return<div style={{...TH[dark?"dark":"light"],background:"var(--bg)",minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",color:"var(--t2)",fontSize:13}}>Lade…</div>;
  if(!currentUser) return<LoginScreen dark={dark} onLogin={setCurrentUser}/>;

  const deadlineISO=localStorage.getItem("twofaDeadline");
  const showGraceBanner=!currentUser.twofaEnabledAt && deadlineISO;
  const daysLeft=deadlineISO?Math.max(0,Math.ceil((new Date(deadlineISO)-Date.now())/86400000)):0;

  return<div style={{...TH[dark?"dark":"light"],background:"var(--bg)",minHeight:"100vh",display:"flex",color:"var(--t1)",transition:"background .3s,color .3s"}}>
    <Sidebar nav={nav} setNav={setNav} dark={dark} setDark={setDark} currentUser={currentUser} onLogout={handleLogout}/>
    <main style={{flex:1,padding:"22px 26px",overflow:"auto",maxHeight:"100vh"}}>
      {showGraceBanner&&<TwofaGraceBanner daysLeft={daysLeft} deadline={deadlineISO} user={currentUser} onDone={u=>setCurrentUser(u)}/>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <div>
          <h1 style={{fontSize:20,fontWeight:700,margin:0,letterSpacing:"-.5px",color:"var(--t1)"}}>{(TITLES[nav]||nav).replace(/\{jahr\}/g,String(bhJahr))}</h1>
          <p style={{margin:"3px 0 0",fontSize:11,color:"var(--t3)"}}>{now.toLocaleDateString("de-DE",{weekday:"long",day:"numeric",month:"long",year:"numeric"})} · {now.toLocaleTimeString("de-DE",{hour:"2-digit",minute:"2-digit"})} Uhr</p>
        </div>
        {nav.startsWith("buchhaltung")&&<div style={{display:"flex",alignItems:"center",gap:8}}>
          <span style={{fontSize:11,color:"var(--t3)",textTransform:"uppercase",letterSpacing:".5px"}}>Geschäftsjahr</span>
          <select value={bhJahr} onChange={e=>setBhJahr(parseInt(e.target.value))}
            style={{padding:"6px 10px",borderRadius:6,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:13,fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>
            {(bhJahre.length?bhJahre:[bhJahr]).map(j=><option key={j} value={j}>{j}</option>)}
          </select>
        </div>}
      </div>
      <ContentArea key={nav.startsWith("buchhaltung")?("bh-"+bhJahr+"-"+nav):nav} nav={nav} currentUser={currentUser}/>
    </main>
  </div>;
}

/* ─── 2FA-Gnadenfrist-Banner + Selbst-Setup ─── */
const TwofaGraceBanner=({daysLeft,deadline,user,onDone})=>{
  const [open,setOpen]=useState(false);
  const [loading,setLoading]=useState(false);
  const [err,setErr]=useState("");
  const [setupData,setSetupData]=useState(null);
  const [code,setCode]=useState("");
  const [backupCodes,setBackupCodes]=useState(null);

  const start=async()=>{
    setOpen(true); setErr(""); setLoading(true);
    try{
      const r=await fetch("/api/auth/2fa/setup",{method:"POST"});
      const j=await r.json();
      if(!r.ok) throw new Error(j.message||"Setup konnte nicht gestartet werden");
      setSetupData(j);
    }catch(ex){setErr(ex.message);}
    setLoading(false);
  };
  const verify=async(e)=>{
    e&&e.preventDefault(); setErr(""); setLoading(true);
    try{
      const r=await fetch("/api/auth/2fa/verify-setup",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({code})});
      const j=await r.json();
      if(!r.ok) throw new Error(j.message||"Code ungültig");
      localStorage.setItem("authToken",j.token);
      localStorage.removeItem("twofaDeadline");
      setBackupCodes(j.backupCodes||[]);
      onDone&&onDone(j.user);
    }catch(ex){setErr(ex.message); setCode("");}
    setLoading(false);
  };
  const finish=()=>{setOpen(false); setSetupData(null); setBackupCodes(null); setCode(""); setErr("");};

  const urgent=daysLeft<=2;
  return<>
    <div style={{padding:"10px 14px",borderRadius:8,border:`1px solid ${urgent?"var(--red)":"var(--ylw)"}`,background:urgent?"var(--red2)":"var(--ylw2)",marginBottom:16,display:"flex",alignItems:"center",gap:12,fontSize:12}}>
      <span style={{fontSize:18}}>🔒</span>
      <div style={{flex:1,color:urgent?"var(--red)":"var(--ylw)"}}>
        <strong>2-Faktor-Authentifizierung wird {daysLeft===0?"heute":daysLeft===1?"morgen":`in ${daysLeft} Tagen`} Pflicht</strong>
        <span style={{color:"var(--t2)",marginLeft:8}}>(ab {new Date(deadline).toLocaleDateString("de-DE")}). Bitte jetzt einrichten, sonst kein Login mehr möglich.</span>
      </div>
      <button onClick={start} style={{padding:"7px 14px",borderRadius:6,border:"none",background:urgent?"var(--red)":"var(--ylw)",color:"#fff",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>Jetzt einrichten</button>
    </div>
    {open&&<Modal open={true} onClose={finish} title={backupCodes?"✓ 2FA aktiviert":"🔒 2FA einrichten"} width={480}>
      {!backupCodes?<div>
        <div style={{fontSize:12,color:"var(--t2)",marginBottom:14,lineHeight:1.5}}>
          Google Authenticator (oder kompatible App) auf dem Handy installieren, dann QR-Code scannen.
        </div>
        {setupData?.qrDataUrl&&<div style={{background:"#fff",padding:14,borderRadius:8,display:"flex",justifyContent:"center",marginBottom:14}}>
          <img src={setupData.qrDataUrl} alt="QR" style={{width:180,height:180,imageRendering:"pixelated"}}/>
        </div>}
        {setupData?.secret&&<div style={{marginBottom:14}}>
          <label style={{fontSize:10,color:"var(--t3)",display:"block",marginBottom:4}}>Kann nicht scannen? Schlüssel manuell eingeben:</label>
          <div style={{padding:"8px 10px",borderRadius:6,background:"var(--s2)",border:"1px solid var(--brd)",fontSize:11,fontFamily:"'SF Mono',Menlo,monospace",color:"var(--t2)",wordBreak:"break-all",textAlign:"center"}}>{setupData.secret}</div>
        </div>}
        <form onSubmit={verify}>
          <label style={{fontSize:11,color:"var(--t2)",display:"block",marginBottom:4}}>6-stelliger Code aus der App</label>
          <input autoFocus inputMode="numeric" autoComplete="one-time-code" maxLength={6} pattern="\d{6}"
            value={code} onChange={e=>setCode(e.target.value.replace(/\D/g,"").slice(0,6))}
            placeholder="123 456"
            style={{width:"100%",padding:"9px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:22,fontFamily:"'SF Mono',Menlo,monospace",textAlign:"center",letterSpacing:6,marginBottom:12}}/>
          {err&&<div style={{padding:"8px 12px",borderRadius:6,background:"var(--red2)",color:"var(--red)",fontSize:11,marginBottom:12}}>{err}</div>}
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <Btn onClick={finish}>Später</Btn>
            <Btn primary onClick={verify} disabled={loading||code.length!==6}>{loading?"Prüfe…":"2FA aktivieren"}</Btn>
          </div>
        </form>
      </div>:<div>
        <div style={{fontSize:12,color:"var(--t2)",marginBottom:14,lineHeight:1.5}}>
          <strong style={{color:"var(--ylw)"}}>Wichtig:</strong> Diese 10 Backup-Codes werden <strong>nur jetzt</strong> angezeigt. Speichere sie sicher — sie sind der einzige Weg zurück, wenn du dein Handy verlierst.
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,padding:14,borderRadius:8,background:"var(--s2)",border:"1px dashed var(--brd)",marginBottom:14,fontFamily:"'SF Mono',Menlo,monospace",fontSize:13}}>
          {backupCodes.map((c,i)=><div key={i} style={{color:"var(--t1)",letterSpacing:1}}>{String(i+1).padStart(2,"0")}. {c}</div>)}
        </div>
        <div style={{display:"flex",gap:8,marginBottom:12}}>
          <button type="button" onClick={()=>{navigator.clipboard.writeText(backupCodes.join("\n"));}} style={{flex:1,padding:"9px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>📋 Kopieren</button>
          <button type="button" onClick={()=>{
            const blob=new Blob([`StyleOMat · 2FA Backup-Codes für ${user?.email}\n${new Date().toLocaleString("de-DE")}\n\n${backupCodes.join("\n")}\n`],{type:"text/plain"});
            const a=document.createElement("a"); a.href=URL.createObjectURL(blob);
            a.download=`stylomat-backup-codes-${(user?.email||"user").split("@")[0]}.txt`; a.click(); URL.revokeObjectURL(a.href);
          }} style={{flex:1,padding:"9px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>⬇ Download</button>
          <button type="button" onClick={()=>window.print()} style={{flex:1,padding:"9px 12px",borderRadius:7,border:"1px solid var(--brd)",background:"var(--s2)",color:"var(--t1)",fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>🖨 Drucken</button>
        </div>
        <div style={{display:"flex",justifyContent:"flex-end"}}>
          <Btn primary onClick={finish}>Codes gesichert → Fertig</Btn>
        </div>
      </div>}
    </Modal>}
  </>;
};

export default App;
